export const courses = {
  courses: {
    'BIOL 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 205',
      description:
        'An introduction to Mendelian and molecular genetics covering the basic mechanisms of genetic transmission, gene\nstructure and function, as well as the application of molecular genetics in medicine and biotechnology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mendelian and Molecular Genetics',
      units: '3.0',
      PREREQUISITE: ['A GPA of 1.90 in BIOL 102/3.0 and BIOL 103/3.0.'],
      'LEARNING HOURS': ['120 (36L;18Lb;18T;12O;36P)\n']
    },
    'HIST 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 421',
      description:
        'Beginning with the development of revolutionary movements in the late 19th century, this course will examine major\nproblems in the history of the Russian Revolution and the former Soviet Union. Special emphasis will be placed on the first\ntwo decades of Soviet rule and the Stalin period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Russian Revolution',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ENGL 291': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 291',
      description:
        'A study of the relationships between literary texts written in English, from classics to contemporary popular fiction, and\ntheir adaptations in a range of media, comprising close analysis, historical and cultural investigation into national and\ntransnational formulations of adaptation, and discussion of the processes and theories of adaptation.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature on Screen and Stage',
      units: '3.0',
      PREREQUISITE: [' A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LING 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 100',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'RELS 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 201',
      description:
        'A topic of current interest in Religious Studies not covered in other available courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Themes in Religious Studies',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100-level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ITLN 111': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ITLN 111',
      description:
        'Offers a basic level of Italian understanding, speaking, reading and writing for students with no knowledge of Italian\nwhatsoever.\n',
      NOTE: [
        'Also offered through the Venice Term Abroad Program. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Italian I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\nONE WAY ']
    },
    'HIST 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 335',
      description:
        'he Age of Jackson\nAn examination of Americans\u2019 struggles with the conflicting ideals of republicanism and liberalism in the first half of the\n19th century. Topics include the presidency of Andrew Jackson, political party formation, Native Americans, African-\nAmericans, women, labour, the expansion of slavery, and the rise of sectional conflict.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'MUSC 280': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 280',
      description:
        'Continuation of MUSC 180/3.0. Study of more advanced topics of vocal instruction with emphasis on classroom teaching\ntechniques and choral conducting. Topics include vocal technique, diction, ensemble blend and balance, rehearsal\ntechniques, building age- and grade-appropriate repertoire, and long and short-term lesson planning.\n',
      NOTE: [
        'Enrolment is limited to students in a MUSC Plan; B.M.T. Plan or the B.Mus. Program.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Vocal Techniques and Methods II',
      units: '3.0',
      PREREQUISITE: ['MUSC 180/3.0 or permission of the instructor.'],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'HIST 349': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 349',
      description:
        'arly Modern European Intellectual History\nAn examination of early modern European intellectual history from the early 16th century through the mid-18th century,\nwith a particular focus on political thought. Topics will include the Scientific Revolution, the impact of the Wars of Religion\nand of overseas expansion on European intellectual life, constitutionalism, Cartesianism, gender, and the political\nphilosophies of Hobbes and Rousseau.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'ARTH 369': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 369',
      description:
        'Theory and practice of architecture and town planning from the 15th to the late 16th centuries in Italy and elsewhere in\nEurope.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Architecture of the Renaissance Period',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'LLCU 295': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 295',
      description:
        'Special Topics: For detailed information, consult the Department of Languages, Literatures, and Cultures website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 327': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 327',
      description:
        'Critical approaches to the role of the geographic, cultural and historical imagination in shaping landscapes, environments\nand society.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Geographical Imagination',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 229/3.0, or 3.0 units in DEVS at the 200 level or above, or permission of the Department.'
      ],
      'LEARNING HOURS': ['127 (36L;4G;12O;3Oc;72P)\n']
    },
    'ECON 455': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 455',
      description:
        'Applications of mathematics in economic analysis. Topics covered will generally include a review of optimization techniques\nas applied to consumer and producer theory, comparative statics, the envelope theorem, duality theory, welfare economics\nand general equilibrium theory. Optimization techniques to be covered will include nonlinear and dynamic programming.\nOffered concurrently with ECON 855/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematical Economics',
      units: '3.0',
      PREREQUISITE: [
        'ECON 255/3.0 and ECON 310/3.0 and permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;12G;72P)\n']
    },
    'FILM 351': {
      EXCLUSION: ['No more than one course from FILM 351/3.0; FILM 355/6.0.'],
      RECOMMENDATION: [],
      code: 'FILM 351',
      description:
        'Advanced motion picture production course. Each student produces a short documentary using video and/or 16mm film.\nEmphasis will be placed on unconventional approaches and techniques.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Documentary Production',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and FILM 250/6.0 and 6.0 units in\nFILM.\n'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;30G;30P)\n']
    },
    'BIOL 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 331',
      description:
        'This course will explore the structure of genomes and the nature and origin of gene families as well as large scale functional\ngenomics methods for analysis of novel gene function.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Analytical Genomics',
      units: '3.0',
      PREREQUISITE: ['BIOL 205/3.0 or BCHM 218/3.0.'],
      'LEARNING HOURS': ['124 (36L;12T;40O;36P)\n']
    },
    'ENGL 271': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 271',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues and Themes: Special Topics I',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 239': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 237/3.0; DRAM 238/3.0; DRAM 239/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 239',
      description:
        'Practical work in selected areas of performance. Not offered every year.\n',
      NOTE: ['Priority enrollment given to students in a DRAM Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Performance I',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above and DRAM 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36Pc;84P)\n']
    },
    'HIST 316': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 316',
      description:
        'A basic survey of Europe since 1789. Topics include the origins and consequences of the French Revolution; the Industrial\nRevolution; the development of parliamentary democracy; nationalism; the origins and consequences of the Russian\nRevolution; imperialism; the two World Wars; fascism; communism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'uropean Politics and Society Since 1789',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'HIST 281': {
      EXCLUSION: ['No more than 1 course from HIST 280/6.0; HIST 281/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 281',
      description:
        'This course highlights the experiences of women in European history. Topics include: changing ideas about male and female\nidentities, family formations, and sexual politics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ender in History: A European Perspective',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 491': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 491',
      description:
        'This is an independent project in an area of specialization in health enhancement, disease prevention and human\nperformance. Students must arrange for a faculty advisor approved by the School of Kinesiology and Health Studies to\noversee their project.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Project in Kinesiology and Physical Education',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan and permission of the supervisor and the\nUndergraduate Coordinator.'
      ],
      'LEARNING HOURS': ['126 (6I;120P)\n']
    },
    'POLS 405': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 405',
      description:
        'Issues in global politics, international relations, international diplomacy, or foreign policy will be examined in this course.\nThe focus of this course will vary from year to year; consult the departmental homepage for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Relations: Questions & Challenges',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'STAT 351': {
      EXCLUSION: ['No more than 3.0 units from STAT 351/3.0; STAT 268/3.0.'],
      RECOMMENDATION: [],
      code: 'STAT 351',
      description:
        'Probability theory; probability models; random variables; jointly distributed random variables; transformations and\ngenerating functions. Inequalities and limit laws. Distributions: binomial, Poisson, exponential, gamma, normal.\nApplications: elementary stochastic processes, time-to-failure models, binary communication channels with Gaussian noise.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Probability I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '120 (36L;12T;72P)\nCOREQUISITE    MATH 221/3.0 or MATH 280/3.0.\n'
      ]
    },
    'HIST 125': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 125',
      description:
        'A survey of Western and Central Europe and Great Britain from about 1750 to 1950. The focus is on the revolutions which\nproduced modern Europe, notably the political revolutions (1789 and 1848), industrialization, urbanization, population growth,\nsecularization, the rise of new classes, and changes in ideologies and popular attitudes.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.'],
      'ONE-WAY EXCLUSION': [],
      title: 'he Evolution of Modern Europe',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CHEM 223': {
      EXCLUSION: [
        'No more than 3.0 units from CHEM 223/3.0; CHEM 282/3.0; CHEM 285/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 223',
      description:
        'Mechanistically oriented study of organic reactions with emphasis on applications to synthesis. The laboratory affords\nexperience in organic synthesis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Organic Reactions',
      units: '3.0',
      PREREQUISITE: ['CHEM 211/3.0 and CHEM 212/3.0.\n'],
      'LEARNING HOURS': ['144 (36L;36Lb;72P)\n']
    },
    'MUSC 114': {
      EXCLUSION: [],
      RECOMMENDATION: ['MUSC 104/3.0 or MUSC P52/3.0 is recommended.'],
      code: 'MUSC 114',
      description:
        'Hands-on, blended approach to the theory and practice of teaching and engaging with children through music. Students will\nbe introduced to concepts through educational activities and will learn to identify and describe musical characteristics\nheard in a variety of repertoire as well as perform short pieces appropriate for novice performers.\n',
      NOTE: ['May not be taken for credit by students in the B.Mus. Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Teaching Music to Children',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (18L;18Lb;24O;60P)\n']
    },
    'SOCY 429': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 429',
      description:
        'Consult the Department for possible offerings in any given year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Sociology V',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'PHYS 460': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 460',
      description:
        'Topics and applications in modern physical optics, culminating with the development of the laser and its current\napplications. Topics include: Gaussian beam propagation, optical resonators, Fourier optics, fiber optics, holography, light\nmatter interaction using classical and semi classical models, and the basic theory and types of lasers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Laser Optics',
      units: '3.0',
      PREREQUISITE: [
        'PHYS 239/3.0 and (PHYS 344/3.0 or CHEM 313/3.0).\nCOREQUISITE    PHYS 432/3.0.'
      ],
      'LEARNING HOURS': []
    },
    'FREN 250': {
      EXCLUSION: ['No more than 3.0 units from FREN 250/3.0; FREN 344/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 250',
      description:
        'A detailed analysis of French grammar based on the description of language structures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Grammaire avanc\u00e9e',
      units: '3.0',
      PREREQUISITE: [
        'FREN 150/6.0 or FREN 100/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 110/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LLCU 110': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 110',
      description:
        'This course explores the diversity of human languages, and the nature of linguistic identity across and within speech\ncommunities from a linguistics perspective. Topics that will be covered include: language families; linguistic typology;\nwriting systems; language endangerment and revitalization; and situations of language contact, bilingualism, and\nsociolinguistic variation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Linguistic Diversity and Identity',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'CISC 471': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 471',
      description:
        'Computational Biology\nAdvanced computational approaches to the problems in molecular biology. Techniques and algorithms for sequence\nanalysis and alignment; molecular databases; protein structure prediction and molecular data mining.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'C- in [CISC 271/3.0 and CISC 352/3.0 and (BCHM 218/3.0 or MBIO 218/3.0) and (BIOL 334/3.0 or BCHM\n315/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 443': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 443',
      description:
        'Selected topics in microeconomic policy. Topics may include: climate change, health economics, national security (defense\neconomics), globalization and/or regional development, and demographic change. Students are directed to the\nundergraduate website for a detailed description.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues in Microeconomic Policy',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0.'],
      'LEARNING HOURS': ['120 (36L;18G;66P)\n']
    },
    'CHEM 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 422',
      description:
        'Modern synthetic methods in organic chemistry. Principles of strategy in planning organic syntheses based on simple\nclassifications of reagents and reactions, and on the control of stereochemistry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Synthetic Organic Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 311/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'GREK 322': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 322',
      description:
        'Selected passages of Greek verse, usually drawn from works of epic, lyric, elegy, and drama, read in the original Greek and\ncommented upon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with GREK 422/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Greek Verse',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GREK 208/6.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'LING 475': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 475',
      description:
        'This course provides instruction in method and procedure in linguistic fieldwork. The course investigates the syntax,\nmorphology and phonology of a language unfamiliar to the participants. The instruction is structured around weekly\nfieldwork sessions dedicated to data collection working with a native speaker of the language, and weekly workshops\ndevoted to analysis. The course contains an intensive independent study component.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Methods in Linguistics',
      units: '6.0',
      PREREQUISITE: [
        'LING 310/3.0 and LING 320/3.0 and LING 330/3.0 and LING 340/3.0.'
      ],
      'LEARNING HOURS': ['210 (18S;18Lb;6T;168P)\n']
    },
    'KNPE 352': {
      EXCLUSION: ['No more than 3.0 units from HLTH 352/3.0 or KNPE 352/3.0.'],
      RECOMMENDATION: [],
      code: 'KNPE 352',
      description:
        'An internship for students in Kinesiology and Physical Education working in the research labs and on research projects of SKHS\nfaculty members. Includes a seminar series covering research topics and methodologies in: Applied Exercise Science,\nEpidemiology, Health Promotion, Psychology of Sport and Physical Activity, and Sociology of Sport and Health.\n',
      NOTE: [
        'Students will apply for a research-based internship at the end of their second year. Recommended for students who\nintend to complete KNPE 595/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Research-Based Internship',
      units: '3.0',
      PREREQUISITE: [
        'KNPE 251/3.0 or NURS 323/3.0; Level 3 in a PHED Specialization or KINE Specialization Plan; and permission of the\ncourse coordinator or the Undergraduate Coordinator.\nCOREQUISITE    HLTH 252/3.0.\n'
      ],
      'LEARNING HOURS': ['140 (12S;80Pc;48P)\n']
    },
    'EMPR 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 240',
      description:
        'This course provides an overview of the elements and functioning of contemporary labour policy in Canada that govern\nemployment relations and work.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Labour Policy',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 334': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 334',
      description:
        'A survey of selected topics including: general principles of enzymology; bioenergetics; metabolism and its control; the\nimportance of proteomic and enzyme research in functional genomics and biotechnology; mechanisms whereby animals\nand plants acclimate at the biochemical level to environmental stress.\n',
      NOTE: [
        'Preference will be given to students registered in a Biology degree program or who require this course for their\nprogram.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Biochemistry',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 103/3.0 and CHEM 112/6.0 and (BIOL 205/3.0 or BCHM 218/3.0).'
      ],
      'LEARNING HOURS': ['110.4 (36L;24O;50.4)\n']
    },
    'HIST 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 440',
      description:
        'This course will offer a political, social, and intellectual history of the Enlightenment in Britain. The chronological scope of\nthe course will run from the Restoration to the French Revolution. The purpose of the course will be to set Enlightenment\nideas within their political, social, and economic context, and introduce students to the methods of contextualism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ritain in the Enlightenment Era',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'LLCU 244': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 244/3.0; LLCU 495/3.0 (2015-2016).'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 244',
      description:
        'This survey course explores key aspects of Hispanic history and culture in the 20th century through the study of its musical\nproduction. We will study notions of race, class, gender, and national identity by focusing on specific musical genres.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Hips Don\u2019t Lie?: Music and Culture in Latin America',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 353': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 353',
      description:
        'An analysis of the origin and development of certain major ideas in the western political tradition.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History of Political Thought',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 485': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 485',
      description:
        'The course will explore the diverse materials used for sculpture (marble, bronze, wood, clay, wax, etc.) and their social\nfunctions - - how sculptures were a part of cult practices, dressing sculptures, speaking statues, miraculous sculptures,\niconoclasm, reliquaries, and domestic objects.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'A Social and Material History of Italian Renaissance Sculpture',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;12O;72P)\n']
    },
    'MUSC 424': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 420/6.0; MUSC 421/6.0; MUSC 424/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 424',
      description: 'Continuation of MUSC 324/6.0.\n',
      NOTE: ['Open to non-B.Mus. students only.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Music',
      units: '6.0',
      PREREQUISITE: ['MUSC 324/6.0 and permission of the School.\n'],
      'LEARNING HOURS': []
    },
    'ECON 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 320',
      description:
        'Macroeconomic Theory II\nAn advanced study of the determinants of aggregate demand and the structure of Keynesian and new classical models.\nPolicy issues covered include crowding out, choice of monetary policy instruments, and monetary policy and the exchange\nrate.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(A grade of C in ECON 222/3.0) and ECON 255/3.0 and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0\nor [MATH 123/3.0 and MATH 124/3.0] or MATH 126/6.0).'
      ],
      'LEARNING HOURS': ['120 (30L;6G;6O;78P)\n']
    },
    'RELS 224': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 224',
      description:
        'The philosophy, worldview, spirituality and ethics of Taoism, China\u2019s organized indigenous religion, in Chinese history and in\nthe contemporary world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Taoism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 279': {
      EXCLUSION: [
        'No more than 6.0 units from HIST 124/6.0; HIST 278/3.0, HIST 279/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'HIST 279',
      description:
        '0th-Century Canada\nA study of the major economic, social and political themes. The emphasis is upon the interaction between political events\nand change in the economy and society.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 455': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 455',
      description:
        'This seminar will explore psychological development from the transition out of childhood to the transition into adulthood.\nThe content of the course will cover typical and atypical adolescent development within several domains: cognitive, social,\nemotional, neurological and physical. Readings will focus on both basic developmental theory and applied research.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Adolescence',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 251/3.0.'],
      'LEARNING HOURS': []
    },
    'PHAR 340': {
      EXCLUSION: [
        'No more than 3.0 units from PHAR 230/3.0; PHAR 270/3.0; PHAR 340/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHAR 340',
      description:
        'Topics include: fundamental principles of drug action, autonomic nervous system pharmacology, and toxicology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of General Pharmacology I',
      units: '3.0',
      PREREQUISITE: [
        '(PHGY 210/6.0 or PHGY 214/6.0 or PHGY 212/6.0).\nCOREQUISITE    BCHM 310/9.0 or BCHM 315/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (27L;24T;69P)\n']
    },
    'GNDS 427': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 427',
      description:
        'This interdisciplinary seminar will explore the ways in which modernity shapes cultural \u2018difference\u2019 and \u2018the\nhuman\u2019. Readings will focus on the racial and geographic contours of colonialism, transatlantic slavery and The\nEnlightenment in order to bring into focus communities that challenge racial-sexual categorization through creative\nexpression (music, fiction, poetry, and visual art as well as theory). This course contains an intensive and independent study\ncomponent.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Towards the Human: Race and the Politics of Expression',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['204(36S;168P)\n']
    },
    'RELS 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 310',
      description:
        'Exemplary work in recent and contemporary Christian theology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern and Contemporary Christian Thought',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'DEVS 305': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 305',
      description:
        'This course is designed to introduce students to Cuban society and culture. The course will focus especially on the period\nfrom the Cuban revolution (1959) to the present. Students will examine some of the main events and highlights of Cuban\nhistory, politics and culture in this era. Two weeks of this four-week intensive course will take place at Queen\u2019s and two\nweeks at the University of Havana.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cuban Culture and Society',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above and registration in any Arts and Science Plan.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 422',
      description:
        'This course provides an extensive survey of the principal theoretical perspectives and empirical debates in the study of\npublic opinion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Public Opinion',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 305': {
      EXCLUSION: ['No more than 6.0 units from HIST 267/3.0; HIST 305/6.0.\n'],
      RECOMMENDATION: [],
      code: 'HIST 305',
      description:
        'A study of historical societies in which Muslims have played a predominating role, particularly in the Middle East and North\nAfrica. Selected issues in religious, political, social, economic and cultural history will be examined with an emphasis on the\ninterpretation of primary sources in translation and debated scholarly issues.\n',
      NOTE: [
        'In Fall Term, HIST 305/6.0 meets in the same classroom with HIST 267/3.0 or HIST 296/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'uslim Societies',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (34.5L;36S;1.5T;168P)\n']
    },
    'GEOL 337': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 337',
      description:
        'Review of the major groups of invertebrate fossils, emphasizing functional morphology, paleoecology, evolution, and\ngeological significance.\n',
      NOTE: [
        'Course includes a required one-day paleontological field trip. Please contact the Department for more information.\nEstimated $25.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Paleontology',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 238/3.0 or BIOL 202/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['129 (36L;24Lb;6Pc;9Oc;54P)\n']
    },
    'MUSC 185': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 185',
      description:
        'An introduction to the orchestral strings through class instruction. Fundamental playing techniques will be emphasized.\nIncludes the study of ranges, fingerings, bowings, transpositions, tunings, basic instrument maintenance, method books and\nteaching techniques. Rental instruments available.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'String Techniques and Methods I',
      units: '3.0',
      PREREQUISITE: ['(Registration in a BMUS or BMT Plan) or MUSC 104/3.0.'],
      'LEARNING HOURS': []
    },
    'ENGL 412': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 412',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Medieval Literature II',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 285': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 285',
      description:
        'A study of one particular issue or theme in Canadian literature. For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues and Themes in Canadian Literature II',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PACT 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT 100',
      description:
        'This course will expose students to a wide variety of physical activities with the intent of learning fundamental pedagogical\nconcepts relevant to structured (e.g. Physical Education) and unstructured (e.g. recreational) physical activity environments.\nStudents will develop an activity lesson plan and effectively teach its content.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamental Practicum in Physical Activity',
      units: '3.0',
      PREREQUISITE: ['Registration in a PHED Specialization Plan.'],
      'LEARNING HOURS': ['108 (16L;32Pc;60P)\n']
    },
    'LLCU 330': {
      EXCLUSION: ['No more than 3.0 units from LLCU 330/3.0; SPAN 330/3.0.'],
      RECOMMENDATION: [],
      code: 'LLCU 330',
      description:
        "A study of Don Quijote I and a selection of his short theatrical Interludes. The course will consider the socio-economic and\nhistorical context and the literary implications of these works to provide a better understanding of 17th century Spain and\nthe significance Cervantes' works still hold today.\n",
      NOTE: ['Readings are in translation.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Cervantes I: Earlier Works',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHYS 260': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 260',
      description:
        'Students will develop an appreciation for the physical and chemical processes that control light and colours. Students will\nlearn the basic principles of light emission and propagation, image formation, the workings of optical devices and detectors,\ncolour theory and colour perception, colour in art, colour in nature, and colours in astronomy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Physics of Light and Colour',
      units: '3.0',
      PREREQUISITE: [
        'PHYS 104/6.0 or PHYS 106/6.0 or PHYS 117/6.0 or PHYS 118/6.0 or BIOL 102/3.0 or BIOL 103/3.0 or CHEM\n112/6.0 or GEOL 102/3.0 or GEOL 104/3.0 or GEOL 106/3.0 or GEOL 107/3.0 or PSYC 100/6.0.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'CANC 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CANC 440',
      description:
        'Cancer Biology and Therapeutics\nA consideration of current knowledge and theories about the biology and treatment of cancer. The course will be presented\nin a small group format, with active student participation required.\n',
      NOTE: [
        'Priority to students in the LISC Specialization Plan, CANC Sub-Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 in a LISC or BCHM Major or Specialization Plan and (a GPA of 2.5 and permission of the course\ncoordinator).'
      ],
      'LEARNING HOURS': []
    },
    'MATH 123': {
      EXCLUSION: [
        'No more than 6.0 units from MATH 120/6.0; MATH 121/6.0; MATH 122/6.0; MATH 123/3.0; MATH 124/3.0;\nMATH 126/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 123',
      description:
        'Differentiation and integration of elementary functions, with applications to physical and social sciences. Topics include\nlimits, related rates, Taylor polynomials, and introductory techniques and applications of integration.\n',
      NOTE: ['Not intended for students pursuing a MATH or STAT plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential and Integral Calculus I',
      units: '3.0',
      PREREQUISITE: ['Permission of the Department.\n'],
      'LEARNING HOURS': []
    },
    'BIOL 321': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'BIOL 202/3.0.\nCOREQUISITE    6.0 units from BIOL 201/3.0; BIOL 202/3.0; BIOL 205/3.0; BIOL 206/3.0.'
      ],
      code: 'BIOL 321',
      description:
        'An evolutionary approach to the study of animal behaviour. This course explores processes and patterns in behaviour, with\nemphasis on perception, communication, foraging, spacing, reproduction and social behaviour in a variety of animals.\nMethods of studying and analyzing behaviour are explored through laboratory exercises.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Animal Behaviour',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['132 (36L;12T;12I;12O;24Oc;36P)\n']
    },
    'ARTH 482': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 482',
      description:
        'A study of the evolution of Gothic sculpture from the mid-12th century to the 15th century. Topics will range from the\nelaborate sculptural programs of great cathedrals to the work of Claus Sluter and other major sculptors of the late Middle\nAges.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gothic Sculpture',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 538': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 538',
      description:
        'Research Mentorship in Biology I\nResearch practicum under the supervision of a Biology faculty member. The course will involve a combination of research in\nthe host laboratory, attendance of BIOL 537/12.0 or other seminars in the Department, and literature research to present\nas a major paper and seminar.\n',
      NOTE: [
        'Students will normally be enrolled in the fourth year of their Program, having completed the third year core\nrequirements of their Plan.\n'
      ],
      'ONE-WAY EXCLUSION': ['Not to be taken concurrently with BIOL 537/12.0.'],
      title: '',
      PREREQUISITE: [
        'Registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH, EBIO-P-BSH)\nand a minimum GPA of 2.0 in the Biological Foundations List and permission of the Department.\n'
      ],
      'LEARNING HOURS': ['128 (8S;12T;60Pc;48P)\n']
    },
    'CLST 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 306',
      description:
        'A survey of Roman material culture (art, architecture and artifacts) from the reign of Augustus to that of Constantine. An\nemphasis will be placed on analyzing Roman architecture, sculpture, urban patterns, and objects of daily life in order to\nbetter understand the political messages and social experiences of Romans during the Imperial period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology of the Roman Empire',
      units: '3.0',
      PREREQUISITE: [
        '(CLST 102/3.0 and CLST 103/3.0) or CLST 129/6.0 or CLST 201/3.0 or CLST 101/6.0 or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'ARTH 253': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 120/6.0.\n'],
      code: 'ARTH 253',
      description:
        'A survey of the visual culture of Europe and its colonies in the Baroque age (ca. 1580-1750). Attention is given to\ndevelopments in all aspects of the visual arts, with emphasis on painting, sculpture, architecture, and the graphic arts, and\non the achievements of artists such as Rembrandt, Rubens, Poussin, Velasquez, and Bernini.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Baroque Art',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 458': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 458',
      description:
        'Relationship between law and ideology with particular reference to current controversies; legal reasoning in substantive\nareas of law, and the place of law with reference to social control, power, social conflict, and dispute resolution; law\u2019s\ninterconnections to state ordering and economic relations emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Law and Ideology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'FREN 351': {
      EXCLUSION: ['No more than 3.0 units from FREN 351/3.0; FREN 451/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 351',
      description:
        'A study of representative works by African and the Caribbean writers. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '\u00c9crits de la Francophonie',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 351': {
      EXCLUSION: ['No more than 3.0 units from ECON 351/3.0; STAT 361/3.0.'],
      RECOMMENDATION: [],
      code: 'ECON 351',
      description:
        'Estimation and inference in multivariate econometric models. Emphasizes understanding of methods and their properties as\ndistinct from formal theoretical development. Practical tools for preparing and analyzing data with appropriate models are\ntaught using econometric software.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Econometrics',
      units: '3.0',
      PREREQUISITE: [
        '(A grade of C in ECON 250/3.0 or STAT 263/3.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or\n[MATH 123/3.0 and MATH 124/3.0] or MATH 126/6.0).\nCOREQUISITE    ECON 255/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'ANAT 101': {
      EXCLUSION: [
        'No more than one course from ANAT 100/3.0; ANAT 101/3.0; IDIS 150/6.0.\n'
      ],
      RECOMMENDATION: ['4U Biology.\n'],
      code: 'ANAT 101',
      description:
        'A basic anatomy course with an emphasis on clinical relevance of structure and function of human body systems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after ANAT 215/3.0; ANAT 216/3.0; ANAT 312/3.0; ANAT 315/3.0; ANAT\n316/3.0.'
      ],
      title: 'Introductory Human Anatomy',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ECON 490': {
      EXCLUSION: ['No more than 3.0 units from ECON 480-499/3.0.'],
      RECOMMENDATION: [],
      code: 'ECON 490',
      description:
        'Series of seminar courses on macroeconomic topics. Evaluation based on presentations, formal/informal participation and\nwritten papers. Offerings vary from year to year with staff availability. Topics announced in advance of course selection and\navailable on the Undergraduate webpage.\n',
      NOTE: [
        'Fourth year ECON Medial students with fewer than 30.0 ECON units and fourth year APEC students without ECON\n320 should contact the department before May 1 to obtain permission to register in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminars in Macroeconomics',
      units: '3.0, 491',
      PREREQUISITE: [
        'Level 4 and (a minimum cumulative GPA of 1.90) and (a minimum GPA of 2.60 in 30.0 units of ECON) and\n(ECON 310/3.0; ECON 320/3.0; ECON 351/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (18S;18G;12I;72P)\n']
    },
    'PSYC 301': {
      EXCLUSION: [
        'No more than 6.0 units from PSYC 300/6.0; PSYC 301/3.0; PSYC 302/3.0.\nEQUIVALENCY    PSYC 300/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 301',
      description:
        'Statistical inference (continuation of PSYC 202/PSYC 203) and laboratory projects. The course covers critical thinking about\nresearch and statistics and three types of statistical analyses: tests of categorization, comparisons of means, and\nassociation.\n',
      NOTE: [
        'Enrollment is limited. Restricted to students in a PSYC Major Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Statistical Inference',
      units: '3.0',
      PREREQUISITE: [
        '[A minimum GPA of 1.90 in (PSYC 202/3.0 or STAT_Options) and PSYC 203/3.0] and (a minimum GPA of\n2.60 in PSYC  at the 100 and 200 level) and (registration in a PSYC Major Plan).\n'
      ],
      'LEARNING HOURS': ['120 (36L;36Lb;12G;12O;24P)\n']
    },
    'CHEM 285': {
      EXCLUSION: [
        'No more than 3.0 units from CHEM 223/3.0; CHEM 282/3.0; CHEM 285/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 285',
      description:
        'A continuation from CHEM 281/3.0 intended for students in biological sciences, and other plans taking no further courses in\norganic chemistry. Students in chemistry or biochemistry plans should not enrol in this course. Organic molecules and their\nreactions; relevance to biological systems. Illustrations using biomolecules such as carbohydrates, amino acids and proteins,\nlipids, and nucleic acids. The virtual laboratory provides knowledge of elementary organic syntheses.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'General Organic Chemistry II (with Virtual Laboratory)',
      units: '3.0',
      PREREQUISITE: ['CHEM 281/3.0.\n'],
      'LEARNING HOURS': ['99 (60O;39P)\n']
    },
    'ARTH 472': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 472',
      description:
        'An assessment of hybrid art focusing on the period of European evangelization of non-European civilizations, 15th-19th c., a\nglobal encounter involving the widest spectrum of peoples, races, cultures, and religions. Will consider the transformation\nof the arts of Early Modern Europe in contact situations in Asia, Africa, Latin America, and Quebec.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Art and Global Encounter in Asia, the Americas and Africa, 1492-1850',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 352',
      description:
        'Gender in relationship to the spatial organization of contemporary Western cities. Emphasis on the diversity of gendered\nexperiences of the city, gender and urban form, housing, social movements, the geography of work, and gender symbols in\nthe urban landscape.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and the City',
      units: '3.0',
      PREREQUISITE: [
        '(6.0 units from GPHY 227/3.0; GPHY 228/3.0; GPHY 229/3.0) or (3.0 units at the 200 level or above in\nGNDS), or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 360': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 360',
      description:
        'An examination of the impact of warfare on 20th-century western culture. Utilizing a variety of approaches, the seminar will\nfocus on such questions as the role of the state, war and gender, religion and pacifism, nuclear weapons and Cold War\nculture, and the impact of war on literature and popular culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ar and Peace in 20th-Century Western Culture I',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MATH 384': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 384',
      description:
        'Interest accumulation factors, annuities, amortization, sinking funds, bonds, yield rates, capital budgeting, contingent\npayments. Students will work mostly on their own; there will be a total of six survey lectures and six tests throughout the\nterm, plus opportunity for individual help.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematical Theory of Interest',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0 or MATH 126/6.0).'
      ],
      'LEARNING HOURS': ['102 (12L;84P)\n']
    },
    'GRMN 427': {
      EXCLUSION: ['No more than 3.0 units from LLCU 327/3.0; GRMN 427/3.0.'],
      RECOMMENDATION: [],
      code: 'GRMN 427',
      description:
        'Investigates cultural images and metaphors of disease, with an emphasis on the evolution of normalcy. We will study\nrepresentations of disease (photography, museum exhibit, literary text), their historic development, and theoretic\nreflections on media with respect to both historical and contemporary notions of sickness and health.\n',
      NOTE: [
        'Taught in English together with LLCU 327/3.0. Students concentrating in German will submit written assignments,\ntests and examinations in German. Normally students will read German texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title:
        'Sickness and Health \u2013 Cultural Representations in Medical Discourse',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures\n'
      ],
      'LEARNING HOURS': ['114 (36L;6O;72P)\n']
    },
    'SOCY 475': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 475',
      description:
        'Advanced Studies in Deviance and Social Control\nCritical study of theories and practices of social control in Canada and comparable societies insofar as they are\nimplemented by law or regulation and rely on coercion; main agencies of social control and assumptions of their operation\nemphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and ([SOCY 275/3.0 and SOCY 276/3.0] or SOCY\n274/6.0) and (a minimum grade of C in SOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a\nminimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of\n2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 425': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 425',
      description:
        'This course considers the house as a central typology in the history of architecture and will explore it in its fullest\ntheoretical and literary contexts. We consider the house as an idea and a material whole, including the art that it housed,\nthe functions and performances that it staged, and the patrons, architects and designers that created it.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'House: Topics in the History of an Idea',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 446': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'ARTH 214/3.0 and 215/3.0 (or ARTH 213/6.0) or ARTH 353/3.0 or ARTH 354/3.0 or ARTH 375/3.0.\n'
      ],
      code: 'ARTH 446',
      description:
        'A detailed study of one artist or theme in the visual culture of northern Europe, primarily The Netherlands and/or\nGermany. Topics may focus on the Renaissance and/or Baroque era (ca. 1400-1750).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Northern Renaissance and Baroque Art',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 440',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Romanticism',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'SPAN 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 304',
      description:
        'Intensive practice in advanced grammar with a focus on Spanish for business, technical, administrative and related cultural\npurposes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Espa\u00f1ol para contextos profesionales II',
      units: '3.0',
      PREREQUISITE: ['SPAN 303/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 430',
      description:
        'Working with the Coordinator of Athletic Therapy (AT), and building on the practical skills and knowledge acquired in KNPE\n330/4.5, students will complete an Athletic Therapy internship. AT interns will be responsible for serving as a mentor to\nstudent trainers and onsite trainers in the Athletic Therapy clinic and at varsity events. They will also serve as teaching\nassistants in the laboratory component of KNPE 331/3.0.\n',
      NOTE: ['Valid First Aid/CPR Certification required.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Athletic Therapy Internship',
      units: '4.5',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan and KNPE 330/4.5 and (a GPA of 2.70) and\npermission of the course coordinator and the Undergraduate Coordinator in the School of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['189 (165Pc;24P)\n']
    },
    'ENGL 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 330',
      description:
        'A study of poetry, drama, and prose of the major writers of the period 1660-1800. Readings will be drawn from the works\nof writers such as Dryden, Pope, Swift, Johnson, Fielding, and Richardson.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Restoration and 18th-Century Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 329': {
      EXCLUSION: ['No more than 6.0 units from HIST 289/3.0; HIST 329/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 329',
      description:
        'Topics include political, social, and cultural transformations in the 19th and 20th centuries, the world wars, imperialism and\nempire, decolonization, the Cold War, and the 1960s. Emphasis on critical interpretation of primary source material and\nhistorical debates.\n',
      NOTE: [
        'In some years, HIST 329/6.0 will meet in the same classroom as HIST 289/3.0 in the Fall.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'odern Britain',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['228 (72S;72O;84P)\n']
    },
    'BCHM 317': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 317',
      description:
        'Application of separation and assay techniques to the study of proteins, metabolism and molecular biology. Attendance\nrequired in both terms. Enrolment will be limited because of laboratory constraints, and selection will be based on\nacademic standing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Biochemistry Laboratory',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '360 (96Lb;264P)\nCOREQUISITE    BCHM 315/3.0 and BCHM 316/3.0.\n'
      ]
    },
    'LLCU 233': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 233/3.0; ITLN 233/3.0; ITLN 331/3.0.\nEQUIVALENCY    ITLN 233/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 233',
      description:
        'A survey of Italian literature, through selected texts of representative authors, from the Middle Ages to the eighteenth\ncentury.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Survey of Italian Literature I',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 422',
      description:
        'Addresses topics in attentional control including limits in attentional control, cortical mechanisms of attention, spatial and\ntemporal attention, interaction of attention and memory, and influence of videogame playing on attentional control.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Attention',
      units: '3.0',
      PREREQUISITE: ['PSYC 221/3.0 or PSYC 220/6.0 or COGS 200/6.0.'],
      'LEARNING HOURS': []
    },
    'ENGL 472': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 472',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Modern/Contemporary American Literature II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'POLS 387': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 387',
      description:
        'The course explores contemporary approaches to understanding the politics of culture. In the everyday behaviours,\nattitudes and practices that form our culture, politics play a role. The course considers a range of diverse theoretical\nperspectives on the interrelationship of culture with social, political, and economic power.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Politics and Culture',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 452',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Victorian Literature II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'FILM 322': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 322',
      description:
        'Intermediate study in history and critical analysis, from early cinema to the tax-shelter boom and the institution of Telefilm\nCanada.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Film and Television to 1980',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'CANC 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'CANC 499',
      description:
        'A research project involving the study of cancer biology or genetics. The project will be supervised by a faculty member\nassociated with the Cancer Research Institute, and will provide opportunities for experimental design, data analysis and\nboth written and oral presentation of results. Students must contact a potential faculty supervisor in the Spring preceding\nregistration in fourth year. Enrolment is limited; acceptance by a supervisor required prior to registration.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Cancer Biology and Genetics',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Specialization Plan, CANC Sub-Plan and a GPA of 2.50.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'STAT 465': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 465',
      description:
        'An overview of the statistical and lean manufacturing tools and techniques used in the measurement and improvement of\nquality in business, government and industry today. Topics include management and planning tools, Six Sigma approach,\nstatistical process charting, process capability analysis, measurement system analysis and factorial and fractional factorial\ndesign of experiments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Quality Management',
      units: '3.0',
      PREREQUISITE: [
        'STAT 263/3.0 or STAT 267/3.0 or STAT 269/3.0 or STAT 367/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 381': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 381',
      description:
        'Examination of the work of selected playwrights, to include world drama currently or recently produced in the British\ntheatre.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary British Theatre and Drama',
      units: '3.0',
      PREREQUISITE: ['Level 3 standing and permission of the Department.'],
      'LEARNING HOURS': []
    },
    'GEOL 319': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 319',
      description:
        'Geophysical methods (gravity, magnetic, electrical, and seismic) applied to engineering problems, including resource\nexploration and site investigation. Design of field programs considering physical principles, instrumentation, limitations,\nfield procedures and data interpretation. Laboratory projects with geophysical equipment are undertaken.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Geophysics',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 249/3.0 and (MATH 225/3.0 or MATH 232/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['121 (21L;18Lb;22T;12Oc;48P)\n']
    },
    'CHEM 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 312',
      description:
        'Introduction to the chemistry, bonding and structures of coordination compounds of the transition metals; transition\nmetals in the solid state and in biological systems; industrial and environmental aspects of transition metal chemistry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Transition Metal Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 211/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'DEVS 498': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 498',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 808/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies VII',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 267': {
      EXCLUSION: ['No more than 6.0 units from HIST 267/3.0; HIST 305/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 267',
      description:
        'An introduction to the multi-faceted history and cultural diversity of North Africa and Southwest Asia, a region stretching\nfrom Morocco to Afghanistan. Using a variety of sources including historical documents, films, music and literature, the\ncourse explores the social coordinates, political dynamics, culture and chronology which are necessary to understand\nmodern events (from WWI) and contemporary conflicts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'odern Middle East',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 256': {
      EXCLUSION: [
        'No more than 6.0 units from ENGL 256/6.0; ENGL 257/3.0; ENGL 258/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 256',
      description:
        'A study of Shakespeare\u2019s plays in relation to the social, intellectual, and political climate of the Elizabethan and Jacobean\nperiods and with reference to theatrical production.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Shakespeare',
      units: '6.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'GNDS 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 352',
      description:
        'This course will examine the gendered history of the production and consumption of cloth, the impact of changing\ntechnologies on the textile industry since the 18th century, and the ensuing tensions between the industrial and the hand-\ncrafted.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Cloth and Globalization',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 417': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 417',
      description:
        'Changes in land use and land cover represent significant changes to the dynamics of the earth system. This course will\nexplore the methods used to quantify rates of land-use and land-cover change, and also the biophysical consequences of\nthese changes. The goal of the course is to develop a framework for evaluating the biophysical and societal trade-offs\nassociated with land-use decisions.\n',
      NOTE: [
        'Field trip fees may apply in certain years. See departmental webpage for more information. Cost will vary\ndepending on location, but not likely to exceed $175 per year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Land-Use Change in the Earth System',
      units: '3.0',
      PREREQUISITE: [
        ' Level 4 and (6.0 units from MATH at the 100 level or above) and (6.0 units from BIOL or CHEM or PHYS at\nthe 100-level or above) and (a GPA of 1.90 in 30.0 units from GPHY) and (registration in a GPHY Major [Science] or EGPY\nSpecialization Plan).'
      ],
      'LEARNING HOURS': ['131 (30L;41Oc;60P)\n']
    },
    'PSYC 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 435',
      description:
        'Recent developments in the experimental investigation of such abnormal behaviours as anxiety, depression, thought and\nmemory disorders, etc.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topics in Abnormal Psychology',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ENGL 223': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 223',
      description:
        'A survey of women writers from after 1900. The historical and geographical focus of the course may vary from year to year;\nfor details, consult the Department.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Women Writers Post-1900',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a GNDS Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 401',
      description:
        'This course offers the theory and context of Interprofessional education and collaborative practice from a global policy\nviewpoint as well as the opportunity to develop and apply the required Interprofessional education core competencies.\n',
      NOTE: [
        'This course falls under a selection of courses with a focus on Interdisciplinary Studies in Global Health and Disability that\nwill be offered only at the Bader International Study Centre.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Interprofessional Collaborative Education',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and a minimum GPA of 1.9.'],
      'LEARNING HOURS': ['129 (39L;5S;21G;24Oc;40P)\n']
    },
    'HIST 361': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 361',
      description:
        'ar and Peace in 20th-Century Western Culture II\nAn examination of the impact of warfare on 20th-century western culture. Utilizing a variety of approaches, the seminar will\nfocus on such questions as the role of the state, war and gender, religion and pacifism, nuclear weapons and Cold War\nculture, and the impact of war on literature and popular culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MUTH 111': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 111',
      description:
        'An introduction to the study of Western music, theatre, fine art, and literature in historical and global perspective. Using\ndrama and music as a focal point, this interdisciplinary course will place artistic creation in a social, philosophical, and\npolitical chronological framework. Key periods include European Romanticism, Modernism, and Popular Culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Listening to Revolutions: History, Arts, and Performance II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36L;36O;42P)']
    },
    'PHYS 453': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 453',
      description:
        'Advanced physics laboratory course providing students with experience in a range of experimental techniques and analysis.\nA selection of experiments are performed from fields including nuclear physics, applied physics, fluid mechanics, solid state\nphysics, low-temperature physics and optics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Physics Laboratory',
      units: '3.0',
      PREREQUISITE: ['PHYS 350/3.0 and (PHYS 344/3.0 or CHEM 313/3.0).'],
      'LEARNING HOURS': ['132 (76Lb;60P)\n']
    },
    'GPHY 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 351',
      description:
        'An overview of selected elements of the geographies of Aboriginal peoples in Canada with a focus on the relationship\nbetween Aboriginal peoples and their environments, urbanization and culture change, and colonialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Aboriginal Geographies of Canada',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (6.0 units from GPHY 227/3.0; GPHY 228/3.0; GPHY 229/3.0) or (3.0 units at the 200 level or\nabove in DEVS or GNDS), or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 213': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 213',
      description:
        'Introduction to analytical chemical methods and science. Topics include statistical analysis of data, titrations and\nequilibrium theory, spectrophotometry and instrumental elemental analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Chemical Analysis',
      units: '3.0',
      PREREQUISITE: ['CHEM 112/6.0'],
      'LEARNING HOURS': ['144 (36L;36Lb;72P)\n']
    },
    'CISC 452': {
      EXCLUSION: ['No more than 3.0 units from COGS 400/3.0; CISC 452/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 452',
      description:
        'Neural and Genetic Computing\nIntroduction to neural and genetic computing. Topics include associative memory systems, neural optimization strategies,\nsupervised and unsupervised classification networks, genetic algorithms, genetic and evolutionary programming.\nApplications are examined, and the relation to biologic systems is discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['C- in CISC 235/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 323',
      description:
        'Introduction to the chemical basis of biological systems and biomolecules, protein structure and synthesis, enzyme\ncatalysis, nucleic acids (DNA, RNA), carbohydrates, membranes, cell signalling, biosynthetic and metabolic pathways.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biological Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 311/3.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'ARTF 100': {
      EXCLUSION: ['No more than 6.0 units from ARTF 100/6.0; ARTF 127/6.0.\n'],
      RECOMMENDATION: [],
      code: 'ARTF 100',
      description:
        'Introductory Drawing\nA basic introduction to the principles of line and form, intended as a foundation for further studies in the visual arts.\n',
      NOTE: [
        'Offered during Summer Term only. Not available for credit towards a B.F.A. program.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GRMN 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 102',
      description:
        'This course is for students with a limited background in German. The course concentrates on the basic language skills\n(listening, reading, writing and speaking) and introduces elements of German culture as recorded in its customs, history and\nliterature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after GRMN 201/3.0; GRMN 202/3.0.'
      ],
      title: 'Beginner\u2019s German II',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 101/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'ARTH 486': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 486',
      description:
        'An examination of selected topics in the painting of Venice and the Veneto.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '16th-Century Painting in Venice',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'HLTH 495': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 495',
      description:
        'Honours level courses exploring advanced topics that are current and/or of special interest in the area of health studies.\nStudents should check with the School of Kinesiology and Health Studies regarding availability of these courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topics in Health Studies II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization, KINE Specialization or (HLTH Major or Medial) Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'BCHM 102': {
      EXCLUSION: [
        'No more than 3.0 units from BCHM 102/3.0; BCHM 270/3.0.\n',
        'No more than 3.0 units from BCHM 102/3.0; BCHM 315/3.0.\n'
      ],
      RECOMMENDATION: ['4U Chemistry.\n'],
      code: 'BCHM 102',
      description:
        'Chemical principles as applied to biochemistry, human and clinical biochemistry. Winter Term.\n',
      NOTE: [
        'Primarily intended for students in Nursing. Arts & Science students require permission of the Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Biochemistry',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['118 (24L;16T;6G;36O;36P)\n']
    },
    'ENIN 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 205',
      description:
        'The course welcomes students from any background to collaborate and explore the overlapping practices, paradigms, and\npoints of divergence between the arts and STEM disciplines (Science, Technology, Engineering, and Mathematics). A\n\u201cSTEAM\u201d approach combines what may at first appear to be opposite methods and processes, by emphasizing the\nimportance of creativity, collaboration, and critical analysis to art and science.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Innovation for STEAM',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (84O;36P)\n']
    },
    'GNDS 375': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 375',
      description:
        'This course explores current theory in queer studies by centrally examining the interdependence of race, sexuality, and\ngender. The course foregrounds the critical insights that follow sustained study of race in queer studies, and of queer\nmatters in critical race, Indigenous, global, and diaspora studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Queer/Race Studies',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 464': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 464',
      description:
        'An examination of major issues in contemporary philosophy of mind. Possible topics to be considered include:\nconsciousness; definitional questions (what is the mind?); mental causation; mental events; mental properties; and various\ntheories about the nature of the mind.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Philosophy of Mind',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 324': {
      EXCLUSION: ['No more than 3.0 units from ARTH 322/3.0; ARTH 324/3.0.'],
      RECOMMENDATION: [],
      code: 'ARTH 324',
      description:
        'A study of late nineteenth- and early twentieth-century French art in its changing institutional, social and art historical\ncontexts. Topics may include the institutions of exhibiting and artistic training, the art market, modernity, the new Paris,\nimpressionism and sensation, the decorative, the cult of the self, primitivism and colonialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'French Art and Its Reception, 1855-1912',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.\n'],
      'LEARNING HOURS': ['126 (24L;12G;90P)\n']
    },
    'GNDS 360': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 360',
      description:
        'Considers the main themes in the history of masculinity and male sexuality, especially \u2018dissident\u2019 or subaltern masculinities\ninternationally, and women\u2019s roles in shaping ideologies of masculinity. Topics include the theorization of masculinity,\ninitiation rituals, family and parenting, violence, sports, homophobia, sexual practices, colonialism, science/epistemology\nand men and feminism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Masculinities: Cross Cultural Perspectives',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ANAT 316': {
      EXCLUSION: ['No more than 3.0 units from ANAT 216/3.0; ANAT 316/3.0.'],
      RECOMMENDATION: [],
      code: 'ANAT 316',
      description:
        'Gross and functional anatomy of the thorax, abdomen and pelvis, head and neck.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Human Visceral Systems',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 102/3.0 and BIOL 103/3.0) or (BIOL 201/3.0 and BIOL 202/3.0) or PHED 153/3.0 or KNPE 153/3.0 or\npermission of the Department of Biomedical and Molecular Sciences.\n'
      ],
      'LEARNING HOURS': []
    },
    'CISC 465': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 465',
      description:
        'Syntax and semantics. Classification of programming languages. The language of while programs. The typed lambda\ncalculus. Recursive definitions and domain theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Foundations of Programming Languages',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 204/3.0 and CISC 223/3.0 and CISC 260/3.0).'],
      'LEARNING HOURS': ['120 (18G;12I;90P)\n']
    },
    'CHEM 497': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 497/6.0; CHEM 498/3.0; CHEM 499/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 497',
      description:
        'A full-year research project on a topic in chemistry, supervised by a member of staff. Normally limited to students in the\nfinal year of a major or subject of specialization in Chemistry. May be taken in the Summer Term with permission.\nAdditional restrictions may apply.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project',
      units: '6.0',
      PREREQUISITE: ['CHEM 397/6.0.\n'],
      'LEARNING HOURS': ['240 (216Lb;24P)\n']
    },
    'KNPE 425': {
      EXCLUSION: [
        'No more than 3.0 units from KNPE 425/3.0; KNPE 493-001 (2015-16).'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 425',
      description:
        'An in-depth exploration of physiological responses to primarily psychological sources of stress. An emphasis is placed on\nunderstanding the interaction between stress responses and function/health and the action of selected stress management\ntechniques.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Physiology of Stress',
      units: '3.0',
      PREREQUISITE: [
        '(Level 4 in a PHED Specialization or KINE Specialization Plan) and KNPE 225/3.0 and KNPE 227/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L/S;84P)\n']
    },
    'ENGL 215': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 215',
      description:
        'A survey of Canadian literature in English from its beginnings to the contemporary period. Readings will include poetry,\nshort fiction and nonfiction, as well as novels from various eras; authors to be studied may include Moodie, Atwood, Klein,\nRichler, Callaghan, Ondaatje, Laurence, Munro, Brand, and King.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Literature',
      units: '6.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'GPHY 103': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 103',
      description:
        'Water is becoming a major global issue due to increased demand and pollution pressures. This course examines dimensions\nof the world\u2019s need for this critical resource. Topics include water distribution and availability, different users, water\ntreatment, pollution issues, freshwater ecosystem conservation, and water management and allocation.\n',
      NOTE: ['Field trips: estimated cost $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Water Resources',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'POLS 419': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 419',
      description:
        'A critical examination of the rhetoric of political persuasion, the framing and construction of political messages and the way\nin which meaning is interpreted and created in the political system. The mass media are an important, though not exclusive,\nfocus of this course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Communication',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'GEOL 302': {
      EXCLUSION: [
        'No more than one course from GEOL 301/1.5; GEOL 302/1.5; GEOL 368/3.0 (prior to 2013); GEOL 478/3.0\n(prior to 2013); GEOL 488/3.0 (prior to 2013).'
      ],
      RECOMMENDATION: [],
      code: 'GEOL 302',
      description:
        'An independent study of the general links between tectonics and the nature of the sedimentary record in a variety of\ncarbonate and siliciclastic depositional environments.\n',
      NOTE: [
        'This course is intended to provide an option for students in lieu of GEOL 301/1.5.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Problems in Sedimentary Geology',
      units: '1.5',
      PREREQUISITE: [
        'GEOL 238/3.0\nCOREQUISITE    GEOL 321/3.0 or GEOL 337/3.0 or GEOL 368/3.0 and permission of the Department.\n'
      ],
      'LEARNING HOURS': ['60 (10I;50P)\n']
    },
    'MUSC 220': {
      EXCLUSION: ['No more than 6.0 units from MUSC 220/6.0; MUSC 221/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 220',
      description: 'Continuation of MUSC 120/6.0.\n',
      NOTE: [
        'Students who do not hold the prerequisite may audition for admission to this course.  They must obtain a grade of\nA- in the jury examination component of MUSC 121/6.0 or MUSC 124/6.0 and receive recommendation of the jury.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study II (Performance)',
      units: '6.0',
      PREREQUISITE: [
        'A grade of B in both MUSC 120/6.0 and MUSC 125/6.0.\nCOREQUISITE    MUSC 225/6.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'CLST 103': {
      EXCLUSION: [
        'No more than 6.0 units from CLST 101/6.0; CLST 102/3.0; CLST 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CLST 103',
      description:
        'An introduction to major themes in the development of Roman civilization using the evidence of literature, history and\narchaeology. Some attention will be given to those aspects of ancient cultural and intellectual growth that are of\nsignificance in the western tradition.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Roman Civilization',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'ITLN 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ITLN 501',
      description:
        'Seminar course on topics in Italian literature. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Letteratura italiana: Temi scelti',
      PREREQUISITE: [
        'Permission of the Department of Languagues, Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 390': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 390',
      description:
        'An examination of the history of the discipline and the epistemological assumptions underpinning art historical research\nand writing in the past and present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing Art History Today',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'COMP 391': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COMP 391',
      description:
        'A Computing Internship involves spending twelve to sixteen months in a paid internship position in the private or public\nsectors. Students in a 12-month internship register in COMP 390/6.0 and either COMP 391/3.0 or COMP 392/3.0, or all of\nCOMP 393/3.0, COMP 391/3.0 and COMP 392/3.0. Students in a 16-month internship register in COMP 390/6.0, COMP\n391/3.0 and COMP 392/3.0. The Internship Coordinator must be satisfied that the work carried out has educational merit.\nSuccessful completion of the course requires submission of a satisfactory report on the experience within thirty days of\ncompletion of the work period. The Internship Coordinator is responsible for evaluating the report. The QUIP program\nincludes prior workshops on interviewing, resum\u00e9 preparation and work performance. Career Services manages the non-\nacademic aspects of the program.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computing Internship II',
      units: '3.0',
      PREREQUISITE: [
        'GPA of 1.90 and Level 2 or 3 and registration in a Bachelor of Computing internship plan (BMCO-I-BCH or\nCOGS-I-BCH or COMP-I-BCH or CSCI-I-BCH or SODE-I-BCH).'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 348': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 248/3.0.\n'],
      code: 'ARTH 348',
      description:
        'Arts of the Arctic\nA study of the arts and visual culture of the Indigenous peoples of the northern circumpolar region encompassing Alaska,\nCanada, and Greenland, with a main focus on Dorset, Thule, and post-1950 Inuit arts. Students will examine the\ndevelopment of modern Inuit art markets, including reception, promotion, and circulation in the south.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (24L;12S;84P)\n']
    },
    'FILM 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 451',
      description:
        'Production: Special Topic\nAdvanced seminar/workshop in an area of film or video production, generally involving intensive analysis of existing work\nand practical assignments.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and FILM 250/6.0 and 24.0 units in\nFILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'MUSC 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 227',
      description: 'A continuation of MUSC 127/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ear Training and Sight Singing II',
      units: '3.0',
      PREREQUISITE: ['MUSC 127/3.0.'],
      'LEARNING HOURS': []
    },
    'MUSC 171': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 171',
      description:
        'A survey of important trends in 20th century Western popular music. Topics include genres, individual artists and groups,\nrecord labels and stylistic trends, and sociological issues.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Social History of Popular Music',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'MATH 281': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 281',
      description:
        'Taylor\u2019s theorem, optimization, implicit and inverse function theorems. Elementary topology of Euclidean spaces.\nSequences and series of numbers and functions. Pointwise and uniform convergence. Power series.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Real Analysis',
      units: '3.0',
      PREREQUISITE: [
        'MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0.'
      ],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'HIST 288': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 288',
      description:
        'he Rise of the British Empire\nThis course surveys the emergence and development of the first British Empire, from the age of exploration through the\nloss of the American colonies. Topics will include: the conceptual impact of the new world; patterns of migration; slavery;\nthe economic and political impact colonization; and ideologies of empire.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['123 (39L;84P)\n']
    },
    'ECON 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 440',
      description:
        'The study of public goods, redistribution of income, and taxation, with emphasis on efficiency and equality as criteria for\ndecision-making in the public sector.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Public Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0.'],
      'LEARNING HOURS': ['120 (36L;6O;78P)\n']
    },
    'GEOL 475': {
      EXCLUSION: ['No more than 3.0 units from GEOL 475/3.0 and GEOL 485/3.0.'],
      RECOMMENDATION: [],
      code: 'GEOL 475',
      description:
        'Rock-water interaction and element migration in near surface environments applied to environmental and exploration\nproblems. Students learn field and analytical techniques, evaluate and interpret geochemical data, and design solutions\nrelated to geochemical hazards to human health, environmental impact of mining, and detection of mineral deposits.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Exploration and Environmental Geochemistry',
      units: '3.0',
      PREREQUISITE: ['GEOL 365/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': ['129 (30L;6S;33Lb;60P)\n']
    },
    'PHIL 275': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 275',
      description:
        'What is at stake in how we think about gender, sex, and love? How do these concepts inform each other? What else defines\nthem? Using classic and contemporary philosophical texts we examine presuppositions and alternative possibilities. Old and\nnew insights are explored. Emphasis is on careful reading and critical thinking skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Thinking Gender, Sex, and Love',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 244': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 244',
      description:
        'Lecture course on a selected historical issue. Subject changes from year to year; course is either being offered for the first\ntime or is being taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'elected Topics in History',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'GPHY 319': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 319',
      description:
        'Bioenergy and Biorefining in Canada\nDeveloping new renewable energy options using biomass requires an understanding of feedstocks and technologies, as well\nas the social and economic factors that drive the industry. Value-added options for biorefining, including the combination of\nmaterial, chemical, and energy products with environmental services such as phytoremediation and carbon sequestration,\nare explored in the Canadian context.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 in a GPHY Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['126 (36L;18G;36O;36P)\n']
    },
    'POLS 354': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 354',
      description:
        'An exploration of the normative underpinnings of democracy, based on a survey of selected historical texts, contemporary\ntheories, and current problems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Democratic Theory',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 345': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 214/3.0 and 215/3.0 (or ARTH 213/6.0).\n'],
      code: 'ARTH 345',
      description:
        'The sources of High Renaissance art will be examined and special attention will be given to the works of Leonardo, Raphael\nand Michelangelo, up to about 1520.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Italian Art of the High Renaissance',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'DEVS 293': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 293',
      description:
        'Lectures and courses offered by regular and visiting faculty on development topics related to their research interests.\nConsult the departmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies II',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 243': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 243',
      description:
        'A comparative examination of the ways in which selected polities respond to national, ethnic, linguistic, religious, and racial\ndiversity.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'States, Ethnic Diversity, and Conflict',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'DRAM 439': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 439',
      description:
        'Practical work in selected areas of performance. Not offered every year.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Performance III',
      units: '3.0',
      PREREQUISITE: ['Level 4.'],
      'LEARNING HOURS': []
    },
    'ARTH 214': {
      EXCLUSION: [
        'No more than 6.0 units from  ARTH 214/3.0; ARTH 215/3.0; ARTH 213/6.0'
      ],
      RECOMMENDATION: [],
      code: 'ARTH 214',
      description:
        'A study of Renaissance art and architecture before 1500 within the context of the social, political and economic history of\nWestern Europe. Key monuments, themes and concepts will be stressed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Renaissance Art and Architecture b 1500',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 413': {
      EXCLUSION: [
        'No more than 4.5 units from HIST 400/4.5-001 (Winter 2016-17); HIST 400/4.5-001 (Winter 2015-16); HIST\n413/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 413',
      description:
        'The Enlightenment used reason to make boundaries between Christian Europe and Jews and Muslims, establishing the\nfoundation for racism, orientalism, and colonialism, which led intellectuals to formulate The Jewish Question and The Eastern\nQuestion, and societies continue to seek solutions as they struggle with antisemitism and Islamophobia.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ews/Muslims in Enlightenment',
      units: '4.5',
      PREREQUISITE: [
        'A grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'RELS 268': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 268',
      description:
        'Moral and religious norms of ethical judgment in bio-medicine; specific issues will be chosen such as population control,\nabortion, genetic control, experimentation, consent behaviour control, death and euthanasia.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Biomedical Ethics',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 437': {
      EXCLUSION: ['No more than 3.0 units from CISC 437/3.0; SOFT 437/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 437',
      description:
        'Analytic and empirical evaluation of the performance of software systems. Performance modeling. Experimental design and\nstatistical techniques for empirical performance analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Performance Analysis',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 324/3.0 and CISC 327/3.0).\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 498': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 498',
      description:
        'An important topic in mathematics not covered in any other courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Mathematics V',
      units: '3.0',
      PREREQUISITE: [
        'Prerequisites vary depending on specific course content; consult instructor or departmental webpage.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 410': {
      EXCLUSION: ['No more than 1 course from HIST 411/4.5; HIST 410/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 410',
      description:
        'A history of the rise of global trade, competition, cultural exchange, warfare, imperialism, and development. An\nexamination of the benefits and pitfalls of globalization, the winners and losers, in both the developing world and the rich\nWestern world. Other issues include the possible link between globalization and income inequality and the welfare state.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'lobalization',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'GNDS 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 335',
      description:
        'This course examines ways in which science fiction and fantasy writers use technology and the fantastic as tools for the\ndeconstruction and reconstruction of gendered categories. The emphasis is on contemporary novels as offering deliberate\nand sophisticated interventions in major discourses in gender studies, with attention to issues of race, class, and\nnationhood.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Science Fiction and Fantasy',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LATN 209': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 209',
      description:
        'Review of grammar followed by a study of representative works of Ovid and other authors. In addition to developing facility\nin translation, study of literary content and background of authors.\n',
      NOTE: [
        'A student with 4U Latin may alternatively use this as a prerequisite and should contact the Department for\npermission to register in the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Latin',
      units: '6.0',
      PREREQUISITE: [' LATN 110/6.0.'],
      'LEARNING HOURS': ['282 (72L;210P)\n']
    },
    'BCHM 270': {
      EXCLUSION: ['No more than 3.0 units from BCHM 102/3.0; BCHM 270/3.0.\n'],
      RECOMMENDATION: [],
      code: 'BCHM 270',
      description:
        'This course will introduce general biochemical concepts that will allow for an understanding of the biological and chemical\nprinciples underlying human physiology, health and disease. The course will provide self-paced learning and utilize\nevidence-based teaching principles, small group learning, peer-learning and guided-independent learning methodologies to\nprovide an inclusive learning environment. Students will gain an enhanced appreciation of general applications of\nbiochemistry as applied in day to day healthy life and during the disease states, diagnosis and clinical management of\nmetabolic disorders.\n',
      NOTE: [
        'Only offered online. Consult Arts and Science Online.\n',
        'May not be taken for credit towards the Plan requirements of the BCHM or LISC Specialization or Major Plans.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after BCHM 310/9.0; BCHM 315/3.0.'
      ],
      title: 'Biochemical Basis of Health and Disease',
      PREREQUISITE: [
        ' Level 2 or above and [(4U Biology and PHGY 170/3.0) or (BIOL 102/3.0 and BIOL 103/3.0)] or permission of\nthe Department.\n'
      ],
      'LEARNING HOURS': ['126 (66O;60P)\n']
    },
    'COCA 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COCA 201',
      description:
        'A multidisciplinary studio-oriented overview of computer-based applications in Art, Music, Drama and Film. History of\nhuman-computer interaction. Critical and philosophical issues. Animation. Virtual reality. Computer-aided design. Computer\ngames. Enrolment is limited.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Computing and the Creative Arts',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and (C- in 6.0 units in ARTF or ARTH or DRAM or FILM or MUSC at the 100-level.\nCOREQUISITE    CISC 101/3.0 or CISC 110/3.0 or CISC 121/3.0, or permission of the School of Computing.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 499': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 499',
      description:
        'Explores teaching French as a second language in relation to didactic methods, active learning, cultural content, and\npedagogic approaches through both seminars and a teaching practicum in FREN 150/6.0 (formerly FREN 100/6.0).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Apprentissage et enseignement du fran\u00e7ais langue seconde',
      units: '6.0',
      PREREQUISITE: [
        'PROF 110/1.5 and [({PROF 210/1.5 or CURR 395/3.0} and PRAC 210/1.5) or PROF 211/1.5 and PRAC 211/1.5)];\nand (FREN 230/3.0 and FREN 241/3.0 and {FREN 342/3.0 or FREN 343/3.0}) or FREN 220/6.0 and FREN 212/6.0; FREN 221/6.0.'
      ],
      'LEARNING HOURS': ['240 (48L;24S;48T;120P)\n']
    },
    'PHIL 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 250',
      description:
        'An examination of the development of central debates in epistemology and metaphysics from the early modern period to\nthe present. Focusing on the work of thinkers like Descartes, Kant, Wittgenstein and Quine, such questions as the nature\nand justification of knowledge, mind and body, personhood and community, truth and meaning will be discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Epistemology and Metaphysics',
      units: '6.0',
      PREREQUISITE: [
        '(A GPA of 2.0 in 6.0 units in PHIL) or (a grade of B- in 3.0 units in PHIL and registration in a COGS Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'ANAT 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'ANAT 499',
      description:
        'An examination of the development and present state of knowledge in selected research areas of Anatomy and Cell\nBiology. Research project involves experimental design, data collection and analysis, written report, poster presentation\nand oral presentation. Students will be required to attend seminars and tutorials on topics related to research. Limited\nenrolment; restricted to fourth year honours, permission of the department required.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Anatomy and Cell Biology',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Specialization Plan and a GPA of 2.50 and [(ANAT 215/3.0 and ANAT\n216/3.0) or ANAT 309/3.0 or (ANAT 315/3.0 and ANAT 316/3.0)].\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'DRAM 238': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 237/3.0; DRAM 238/3.0; DRAM 239/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 238',
      description:
        'A practical introduction to various theories and styles of acting, involving the exploration of various approaches to the\ncultural and period context of performance.\n',
      NOTE: ['Priority enrollment given to students in a DRAM or STSC Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Elementary Acting II - Theories and Styles of Acting',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above and DRAM 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36Pc;84P)\n']
    },
    'STAT 361': {
      EXCLUSION: ['No more than 3.0 units from ECON 351/3.0; STAT 361/3.0.'],
      RECOMMENDATION: [],
      code: 'STAT 361',
      description:
        'A detailed study of simple and multiple linear regression, residuals and model adequacy. The least squares solution for the\ngeneral linear regression model. Analysis of variance for regression and simple designed experiments; analysis of\ncategorical data.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Methods in Statistics I',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and (STAT 268/3.0 or STAT 351/3.0) and (STAT 263/3.0\nor STAT 267/3.0 or STAT 269/3.0 or STAT 367/3.0), or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'STAT 471': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 471',
      description:
        'Simple random sampling; Unequal probability sampling; Stratified sampling; Cluster sampling; Multi-stage sampling;\nAnalysis of variance and covariance; Block designs; Fractional factorial designs; Split-plot designs; Response surface\nmethodology; Robust parameter designs for products and process improvement. Offered jointly with STAT 871/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sampling and Experimental Design',
      units: '3.0',
      PREREQUISITE: [
        '(STAT 361/3.0 or ECON 351/3.0) and STAT 463/3.0  or permission of the Department.\nEQUIVALENCY    STAT 362/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 240',
      description:
        'A theoretical and practical introduction to technical production including various elements of theatre space, design and\nconstruction, groundplans, and stage management.\n',
      NOTE: [
        'Preference will be given to students registered in a DRAM Plan who require this course for their plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Theatre Space',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan.\nCOREQUISITE    DRAM 246/1.5.'
      ],
      'LEARNING HOURS': ['120 (18S;18Pc;84P)\n']
    },
    'MUSC 120': {
      EXCLUSION: ['No more than 6.0 units from MUSC 120/6.0; MUSC 121/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 120',
      description:
        'A first year study of the student\u2019s applied subject (instrument or voice) in the performance concentration.\n',
      NOTE: [
        'Open only to students who have demonstrated a considerably higher level of performance ability than the\nminimum required for B.Mus. admission.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study I (Performance)',
      units: '6.0',
      PREREQUISITE: [
        'Permission of the School.\nCOREQUISITE    MUSC 125/6.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'ANAT 309': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ANAT 309',
      description: 'An outline of basic mammalian tissues.\n',
      NOTE: [
        'Priority will be given to students registered in a LISC Specialization Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Functional Histology',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 102/3.0 and BIOL 103/3.0) or (BIOL 201/3.0 and BIOL 202/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;60P)\n']
    },
    'FREN 330': {
      EXCLUSION: [
        'No more than 3.0 units from FREN 330/3.0; FREN 201/3.0; FREN 202/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 330',
      description:
        'A presentation of the principles of textual production in French as applied in the production of various types of texts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'R\u00e9daction et style I',
      units: '3.0',
      PREREQUISITE: [
        'FREN 250/3.0 or (FREN 212/6.0 and FREN 220/6.0). or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 341',
      description:
        'The Roman Empire\nIntensive study of the Empire to the reign of Marcus Aurelius. Politics of the imperial courts: administration and\nRomanization of the provinces.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['CLST 201/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'STAT 463': {
      EXCLUSION: [],
      RECOMMENDATION: ['STAT 353/3.0.\n'],
      code: 'STAT 463',
      description:
        'Decision theory and Bayesian inference; principles of optimal statistical procedures; maximum likelihood principle; large\nsample theory for maximum likelihood estimates; principles of hypotheses testing and the Neyman-Pearson theory;\ngeneralized likelihood ratio tests; the chi-square, t, F and other distributions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Statistical Inference',
      units: '3.0',
      PREREQUISITE: ['STAT 269/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'ASTR 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ASTR 102',
      description:
        'This course, intended for non-specialist students, will provide an overview of astronomy beyond the Solar System. Topics\nwill include: the formation, nature, and evolution of the stars; stellar deaths, including novae, supernovae, white dwarfs,\nneutron stars, pulsars, and black holes; the interstellar medium; the Milky Way Galaxy; normal and active galaxies and large\nscale structure in the universe; and modern ideas in cosmology and the early universe.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Astronomy II: Stars, Galaxies, and the Universe',
      units: '3.0',
      PREREQUISITE: [
        'ASTR 101/3.0 or PHYS P15/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24O;60P)\nEQUIVALENCY    PHYS P16/3.0.\n']
    },
    'PHIL 329': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 329',
      description: 'A study of selected topics in early modern philosophy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Early Modern Philosophy',
      units: '3.0',
      PREREQUISITE: [
        'PHIL 250/6.0 or PHIL 257/6.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SPAN 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 402',
      description:
        'This course aims to perfect the students\u2019 ability to write and speak in Spanish, with intensive practice of advanced Spanish\ngrammatical structures through translation exercises, as well as compositions and oral work.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Grammar Through Translation II',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 401/3.0 (or permission of the Department of Languages, Literatures and Cultures).'
      ],
      'LEARNING HOURS': []
    },
    'FREN 324': {
      EXCLUSION: ['No more than 3.0 units from FREN 324/3.0; FREN 424/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 324',
      description:
        'A detailed study of selected novels from 20th-century French authors until 1945. Beauvoir, Camus, C\u00e9line, Cocteau, Colette,\nGide, Proust, Sartre. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le roman fran\u00e7ais du 20e si\u00e8cle',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 458': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 458',
      description:
        'An examination of the debates about when it is (morally) justified to go to war - and when it isn\u2019t. Topics will include war as\nself-defense, humanitarian intervention, preventive war, and different conceptions of the morally proper way to wage war.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ethics of War and Intervention',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 181': {
      EXCLUSION: ['No more than 6.0 units from DRAM 100/6.0; DRAM 181/6.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 181',
      description:
        'An examination of the elements of theatrical production through the use of text, live and videotaped performances.\nOpportunity given for practical projects. While content varies from year to year, the course draws upon students\u2019 access to\ntheatre in the United Kingdom and Europe.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Current Theatre',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ENGL 457': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 457',
      description:
        'Studies in literary topics focused on \u201cthe long nineteenth century\u201d that do not fit within the established Group II rubrics\n(Romantic Literature, Victorian Literature, Literature of the Americas). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group II: Special Topics II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'KNPE 300': {
      EXCLUSION: [
        'No more than one course from HLTH 300/3.0; KNPE 300/3.0; KNPE 330/4.5; KNPE 336/3.0; KNPE 346/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 300',
      description:
        'A community-based internship for Kinesiology and Physical Education students to apply knowledge gained in theory-based\ncourses and develop a range of professional skills. Internship opportunities vary year to year, subject to availability of an\nappropriate placement in a relevant workplace setting.\n',
      NOTE: [
        'Students are expected to participate in professional development workshops offered by the SKHS Internship\nCoordinator and Career Services.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Community-Based Internship',
      units: '3.0',
      PREREQUISITE: [
        '(Level 3 or above in a PHED Specialization or KINE Specialization Plan) and a minimum cumulative GPA of\n1.90 and permission of the Internship Coordinator and Undergraduate Coordinator in the School of Kinesiology and Health\nStudies.\n'
      ],
      'LEARNING HOURS': ['120 (12G;84Oc;24P)\n']
    },
    'GRMN 532': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 532',
      description:
        'Reading courses enabling individual study of a particular author or problem in greater depth, the specific topic to be\nselected in consultation with the Head of Department. An essay of appropriate length may, after consultation, be submitted\nin either course in lieu of a final examination.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies II',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (120P)\n']
    },
    'POLS 462': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 462',
      description:
        'Contemporary aspects of Canadian international security policy. Topics include: the evolution of policy towards NATO;\nbilateral defence arrangements with the US; collective security and cooperative security; peacekeeping; defence\neconomics; the role of domestic factors in the shaping of strategy; and aid of the civil power.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in National Security',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'LLCU 207': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 207',
      description:
        'How are businesses and business people represented in film? This course draws from a range of international films to\nanalyze how business at different levels of development in different places in the world is represented on screen. It asks\nwhy Hollywood and other film industries seem to heroize and demonize their usually male, White entrepreneurs. And it\nasks how such depictions matter.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Representations of Business in the Movies',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;24G;60P)\n']
    },
    'ARTH 436': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 436',
      description:
        'This course will examine a range of anthropological theories and will assess their potential methodological roles in art\nhistorical analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Anthropological Theory and Art History',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 318': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 318',
      description:
        'The formation of modern China, Vietnam, Korea, and Japan in historical and regional contexts. The development of\nresearch skills is emphasized, along with structured discussion of readings and research.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'odern East Asia',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'HLTH 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 404',
      description:
        'While people with disabilities continue to experience challenges to their full and equal community participation, in the\ncontext of mental illness they are subject to particularly profound levels of social exclusion at a global level. We will\nexamine current disability discourse as it relates to mental illnesses and exclusion of this population.\n',
      NOTE: [
        'This course falls under a selection of courses with a focus on Interdisciplinary Studies in Global Health and Disability\nthat will be offered only at the Bader International Study Centre.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title:
        'Global Studies of Social Inclusion, Community Participation and Mental Illness',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and a minimum GPA of 1.9.'],
      'LEARNING HOURS': ['120 (30S;20G;4I;10Oc;56P)\n']
    },
    'LLCU 232': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 232/3.0; ITLN 232/3.0; ITLN 432/3.0.\nEQUIVALENCY    ITLN 232/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 232',
      description:
        'The course will focus on the study of Italian Romanticism and its relation to English, German, Spanish and French\nRomanticism. The rise of Realism and Decadentism will also be discussed and examined.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: "From the Romantics to D'Annunzio",
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 111': {
      EXCLUSION: [
        'No more than 1 course from PHIL 111/6.0; PHIL 127/6.0; PHIL 151/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHIL 111',
      description:
        'An introduction to philosophy through the examination of a number of classic philosophical works, with an evaluation of\nthe positions and arguments offered in each.\n',
      NOTE: [
        'Students considering a Major or Medial Plan in PHIL are strongly urged to take PHIL 111/6.0 or PHIL 115/6.0 in their\nfirst year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'What is Philosophy?',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'ENIN 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 301',
      description:
        'This course offers a primer on personal and organizational creativity, and is designed to support learners to develop\nentrepreneurial mindsets. Learners will study emerging theories of creative thinking, and develop a deep understanding of,\nand engagement with, discourses and methods of innovation in the creative industries.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Creative Entrepreneurship',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (72O;48P)\n']
    },
    'POLS 470': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 470',
      description:
        'The theoretical problems of analyzing foreign policy and the practical issues of diplomatic action.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in International Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (36S;12G;72P)\n']
    },
    'PSYC 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 456',
      description:
        'Explores children\u2019s emerging understanding that others\u2019 observable behaviours are motivated by internal mental states\nsuch as intentions, desires and beliefs. The first section of the course will cover the development of this understanding from\ninfancy through the preschool years. The second section of the course will cover how this emerging understanding affects\nchildren\u2019s social and communicative development.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory of Mind',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 251/3.0.'],
      'LEARNING HOURS': []
    },
    'KNPE 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 335',
      description:
        'This course looks at what happens to the body as we age, including an examination of the physiological, psychological and\nemotional changes that occur during the aging process.  The role of a healthy lifestyle in achieving quality of life as we age is\na key perspective.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Healthy Aging',
      units: '3.0',
      PREREQUISITE: [
        '(Level 3 or above and registration in a PHED, KINE or HLTH Plan) or registration at the BISC.\nCOREQUISITE    HLTH 332/3.0.'
      ],
      'LEARNING HOURS': ['112 (36L;4Oc;72P)\n']
    },
    'MUTH 329': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 329',
      description:
        'An intensive study of a particular topic within the area of Music Theatre.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Music Theatre',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and registration in a DRAM; MUSC; or B.M.T. Plan, or permission of the School.'
      ],
      'LEARNING HOURS': ['120 (36S;24O;60P)\n']
    },
    'PHYS 590': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 590',
      description:
        'Investigation of a contemporary research topic in physics or astronomy under the supervision of a faculty member, and\nleading to a written thesis and an oral presentation of results.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Thesis',
      units: '6.0',
      PREREQUISITE: ['Level 4 in a PHYS, ASPH or MAPH Plan.'],
      'LEARNING HOURS': []
    },
    'BIOL 418': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 418',
      description:
        'This course will introduce students to many \u201chands-on\u201d techniques currently used in fisheries. This will include fish\nidentification, different capture techniques for fisheries assessment, bioacoustics, environmental monitoring, techniques\nfor ageing fish, diet analysis, fish tracking (biotelemetry approaches), and data management.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fisheries Techniques',
      units: '3.0',
      PREREQUISITE: ['BIOL 316/3.0.'],
      'LEARNING HOURS': ['120 (30Lb;10T;40G;40P)\n']
    },
    'BIOL 403': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 403',
      description:
        'Self-directed and self-selected hands-on experimental techniques used in fundamental biology research, biotechnologies,\nand medical sciences.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Experimental Techniques in Biology',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 205/3.0 and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['120 (36Lb;12T;72Oc)\n']
    },
    'BIOL 410': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 335/3.0.\n'],
      code: 'BIOL 410',
      description:
        'An in-depth look at the ecology and evolution of freshwater aquatic ecosystems, considering the role of populations,\ninterspecific interactions, and the flow of energy and matter. There will be an emphasis on linking ecological theory with\nempirical evidence from aquatic systems. Topics will include dispersal and colonization, ecological genetics, resource\ncompetition, predator-prey interaction, evolution of life-history strategies, habitat coupling, and biogeochemical cycling.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ecology of Lakes and Streams',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 302/3.0 or BIOL 303/3.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['120 (24L;12S;84P)\n']
    },
    'ARTH 372': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 372',
      description:
        'Considers art, architecture, and ephemera in Colonial Latin America (1492-1820) with particular attention to the aboriginal\ncontribution to visual culture and built environment and the impact of multiculturalism (Africans, Asians, mestizos,\nEuropeans of various nationalities).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Art of Colonial Latin America',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 352': {
      EXCLUSION: ['No more than 3.0 units from HLTH 352/3.0 or KNPE 352/3.0.'],
      RECOMMENDATION: [],
      code: 'HLTH 352',
      description:
        'An internship for students in Health Studies working in the research labs and on research projects of SKHS faculty members.\nIncludes a seminar series covering research topics and methodologies in: Applied Exercise Science; Epidemiology; Health\nPromotion; Psychology of Sport; Physical Activity and Health; and Sociology of Sport and Health.\n',
      NOTE: [
        'Students will apply for a research-based internship at the end of their second year. Recommended for students who\nintend to complete HLTH 595/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Research-Based Internship',
      units: '3.0',
      PREREQUISITE: [
        'KNPE 251/3.0 or NURS 323/3.0; Level 3 in a HLTH Plan; and permission of the course coordinator or the\nUndergraduate Coordinator in the School of Kinesiology and Health Studies.\nCOREQUISITE    HLTH 252/3.0.\n'
      ],
      'LEARNING HOURS': ['140 (12S;84Pc;48P)\n']
    },
    'ECON 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 212',
      description:
        'Theory of markets and prices: decision-making by individuals and firms, equilibrium conditions under various market\nstructures, and issues of individual and social welfare. This course presumes a knowledge of calculus at the first-year\nuniversity level.\n',
      NOTE: [
        'A grade of C in this course is required as a prerequisite for ECON 310/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Microeconomic Theory I',
      units: '3.0',
      PREREQUISITE: [
        'ECON 110/6.0 or (ECON 111/3.0 and ECON 112/3.0).\nCOREQUISITE    MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or (MATH 123/3.0 and MATH 124/3.0) or MATH 126/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'BIOL 243': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0 (formerly\nPHED 251/3.0); NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM\n162/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'BIOL 243',
      description:
        'Introduction to Statistics\nAn introduction to the analysis of data from real life situations. Covers study design, descriptive and inferential statistics.\nTopics include probability, t-tests, regression, Chi-square tests, analysis of variance. Emphasis is in the foundation of\nstatistical inference and practical application of statistical methods using statistical software.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': ['May not be taken with or after STAT 269/3.0.'],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'ECON 437': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 437',
      description:
        'Cost-Benefit Analysis\nA course covering the techniques and applications of cost-benefit analysis and project evaluation. Topics include the\nfoundations of cost-benefit analysis; investment decision rules; the social discount rate; risk and uncertainty; and the\nshadow pricing of inputs. Objectives such as income distribution and macro-economic goals are also considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'ECON 255/3.0 and ECON 310/3.0 and permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'DRAM 476': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 476',
      description:
        'A study of the relationship between the evolving cultural milieu and the theatre. Topics may include funding policies,\npractitioners\u2019 associations, equity, performance spaces, development of traditions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cultures of Theatre',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a DRAM Major or Medial Plan, or COCA-CODR Sub-Plan, or STSC Specialization\nPlan) and (a grade of B- in DRAM 300/6.0) and (a GPA of 2.60 in DRAM) or permission of the Department.)'
      ],
      'LEARNING HOURS': []
    },
    'MATH 387': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 387',
      description:
        'In-depth follow-up to high school geometry: striking new results/connections; analysis/proof of new/familiar results from\nvarious perspectives; extensions (projective geometry, e.g.); relation of classical unsolvable constructions to modern\nalgebra; models/technology for geometric exploration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Elementary Geometry \u2013 an Advanced Perspective',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (MATH 221/3.0 or MATH 280/3.0 or MATH 281/3.0), or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PATH 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PATH 310',
      description:
        'An introduction to pathology and molecular medicine. The course will be organized around a specific set of diseases,\ndesigned to illustrate basic concepts in the molecular biology, biochemistry, and pathology of human disease.\nRECOMENDATION    ANAT 215/3.0 and ANAT 216/3.0 and BCHM 310/9.0 or (BCHM 315/3.0 and BCHM 316/3.0) and PHGY\n212/6.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Pathology and Molecular Medicine',
      units: '3.0',
      PREREQUISITE: ['BCHM 218/3.0 or MBIO 218/3.0.'],
      'LEARNING HOURS': []
    },
    'ENSC 482': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 482',
      description:
        'This course will provide intensive coverage of a topic that is current and/or of special interest in Environmental Studies. The\ncourse will cover mainly social science-based material, but will be multidisciplinary. Offered periodically by visiting\nprofessors or members of faculty. The topic for each year will be announced in advance of course selection and will be\nmade available on the ENSC web page. Students are advised to consult with their academic counsellor and/or the course\ninstructor prior to registration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Environmental Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and registration in an ENSC Major, ENVS Medial, EBIO, ECHM, EGEO, EGPY, ELSC or ETOX Plan or\npermission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'FREN 215': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 215',
      description:
        'An introduction to the general principles of linguistics, in the areas of phonetics, phonology, morphology, lexicology, syntax\nand semantics. Examples are drawn primarily from Canadian and European French.\n',
      NOTE: [
        'FREN 215 is a Problem-Based Learning (PBL) course. The instructor will meet with students once a week for 1.5\nhours in the lecture format to present concepts and problems. The second block of 1.5 hours will be occupied by students\nworking collaboratively in small groups on specific sets of preset problems using online and other materials.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction \u00e0 la linguistique fran\u00e7aise',
      units: '6.0',
      PREREQUISITE: [
        'A grade of B- in [FREN 150/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 100/6.0] or a grade of C in\nFREN 110/6.0.'
      ],
      'LEARNING HOURS': [' 264 (48L;24G;192P)\n']
    },
    'MATH 474': {
      EXCLUSION: [],
      RECOMMENDATION: ['STAT 353/3.0.\n'],
      code: 'MATH 474',
      description:
        'Topics include: information measures, entropy, mutual information, modeling of information sources, lossless data\ncompression, block encoding, variable-length encoding, Kraft inequality, fundamentals of channel coding, channel capacity,\nrate-distortion theory, lossy data compression, rate-distortion theorem. Given jointly with MATH 874/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Information Theory',
      units: '3.0',
      PREREQUISITE: ['STAT 268/3.0 or STAT 351/3.0.'],
      'LEARNING HOURS': ['140 (36L;104P)\n']
    },
    'POLS 342': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 342',
      description:
        'Comparative study of Latin American politics. Topics include the political legacies of colonialism and independence, the\nevolution of class structures, populism, the role of the military, and the transition to democracy and free market policies.\nEmphasis is on the countries of continental South America.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Latin American Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 322': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 322',
      description:
        'Surveys the history and philosophy of yoga in India and the West.\n',
      NOTE: ['Yoga practicum: estimated cost $85.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Yoga in India and the West',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': []
    },
    'HIST 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 452',
      description:
        'This course examines contemporary African political and economic history from the euphoric days of independence\nthrough the tumultuous decades of famines and pandemics to \u2018Africa rising\u2019 and the \u2018war on terror\u2019. Topics include\nEuropean late colonial rule, ascent to independence, structural readjustment programs.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'frican Decolonization and In-Dependence',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'POLS 263': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 263',
      description:
        'This course introduces students to current theoretical and policy debates about the nature of \u2018international security.\u2019 In\naddition to addressing the meaning of this contested concept, we will examine three principal ways in which security has\nbeen organized by states, specifically: collective security, collective defence, and security communities.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to International Security',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'ENGL 216': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 216',
      description:
        'A survey of American prose and poetry from the Puritans to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Literature',
      units: '6.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'MUSC 485': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 485',
      description:
        'A study of the theory and practice of musical notations from circa 1000 to circa 1600. Representative compositions from\nthe mediaeval and Renaissance periods will be transcribed and considered in conjunction with contemporary theoretical\nwritings. Discussions will focus on current scholarly views concerning the rhythmic interpretations of ambiguous notations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Palaeography',
      units: '3.0',
      PREREQUISITE: [
        '(MUSC 103/3.0 and MUSC 205/3.0) or permission of the School.'
      ],
      'LEARNING HOURS': ['120 (24S;12G;24O;60P)\n']
    },
    'MATH 402': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'Experience with abstract mathematics and mathematical proof, and a good foundation in linear\nalgebra.\n'
      ],
      code: 'MATH 402',
      description:
        'Enumerative combinatorics is concerned with counting the number of elements of a finite set. The techniques covered include\ninclusion-exclusion, bijective proofs, double-counting arguments, recurrence relations, and generating functions. Given jointly\nwith MATH 802/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Enumerative Combinatorics',
      units: '3.0',
      PREREQUISITE: [' MATH 210/3.0 or MATH 211/6.0 or MATH 217/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 112': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 112',
      description:
        'Mid-size ensemble experience for qualified performers. Topics vary. Course includes weekly rehearsals of a wider variety of\nrepertoire, and a minimum of one concert per term for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medium Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'FREN 306': {
      EXCLUSION: ['No more than 3.0 units from FREN 306/3.0; FREN 418/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 306',
      description:
        'A detailed study of plays by Corneille, Racine, Moli\u00e8re. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le th\u00e9\u00e2tre classique',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 498': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 497/6.0; CHEM 498/3.0; CHEM 499/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 498',
      description:
        'A Fall Term research project on a topic in chemistry, supervised by a member of staff. Normally limited to students in the\nfinal year of a major or subject of specialization in Chemistry. Additional restrictions may apply.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (108Lb;12P)\n']
    },
    'ENGL 237': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 237',
      description:
        'A critical study of literature written for children or appropriated by adults for the nursery. The emphasis will be on\ndistinguishing the characteristics and cultural significance of a variety of works from the medieval to the modern period.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Children\u2019s Literature',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DEVS 396': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 396',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies V',
      PREREQUISITE: [
        'Level 3 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'SPAN 330': {
      EXCLUSION: ['No more than 3.0 units from LLCU 330/3.0; SPAN 330/3.0.'],
      RECOMMENDATION: [],
      code: 'SPAN 330',
      description:
        "A study of Don Quijote I and a selection of his short theatrical Interludes.  The course will consider the socio-economic and\nhistorical context and the literary implications of these works to provide a better understanding of 17th century Spain and\nthe significance Cervantes' works still hold today.\n",
      NOTE: [
        'Taught in English together with LLCU 330/3.0. Students concentrating in Spanish submit written assignments, tests\nand examinations in Spanish.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Cervantes I: Earlier Works',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 380/3.0.\nCOREQUISITE    (SPAN 301/3.0 and SPAN 302/3.0) or (SPAN 303/3.0 and SPAN 304/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHYS 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 321',
      description:
        'An introduction to the equations of mechanics using the Lagrange formalism and to the calculus of variations leading to\nHamilton\u2019s principle. The concepts developed in this course are applied to problems ranging from purely theoretical\nconstructs to practical applications. Links to quantum mechanics and extensions to continuous systems are developed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Mechanics',
      PREREQUISITE: [
        'PHYS 212/3.0 and (MATH 221/3.0 or MATH 227/3.0 or MATH 280/3.0) and (MATH 225/3.0 or MATH\n231/3.0 or MATH 232/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 354': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 354',
      description:
        'Acoustic Composition\nGuidance in the development of the student as a composer for instruments and voice.\n',
      NOTE: [
        'Students must submit a portfolio of compositions to the Music Office by the last day of classes in the Winter Term.\nAdmission is determined through evaluation of portfolios by a Faculty jury. Submission of a portfolio does not guarantee\nadmission.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'FRST 125': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FRST 125',
      description:
        'An introduction to the language of business in French. Students will learn how to understand texts in the areas of\nadministrative correspondence, personnel issues (CV, covering letter, hiring process), basic financial reporting, and\nadvertising. Explanations are given in English, all materials to be analyzed are in French.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after any FREN or FRST courses except FRST 105/3.0, FREN 106/3.0\n(formerly FREN P16/3.0) or FREN 107/3.0 (formerly FREN P17/3.0).'
      ],
      title: 'Basic Business French',
      units: '3.0',
      PREREQUISITE: [
        'FRST 105/3.0 or FREN 107/3.0 or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['120 (96O;24P)\n']
    },
    'GNDS 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 410',
      description:
        'Offered when faculty resources permit, these courses are intensive analyses of particular areas of gender studies\ninterdisciplinary research. Details regarding specific topics will be available from the Head of the Department on an annual\nbasis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Gender Studies',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['204(36S;168P)\n']
    },
    'CISC 472': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 472',
      description:
        'Current topics in the application of information technology to medical image computing and its use in image-guided\nmedical interventions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medical Informatics',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 330/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 250',
      description:
        'Their place in religious consciousness with a variety of examples.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mythology of Heroes, Heroines and Saints',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 101': {
      EXCLUSION: [
        'No more than 1 course from PSYC 100/6.0; PSYC 1UNS/3.0; PSYC 101/3.0; PSYC 102/3.0; PSYC 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 101',
      description:
        'An introductory survey of basic areas of psychology including perception, cognition, learning and motivation and their\nbiological substrata. Also reviewed are child development, individual differences, social psychology, health and clinical\npsychology.\n',
      NOTE: [
        'Not offered at Queen\u2019s; only available as a transfer credit.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Psychology I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'BIOL 510': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 302/3.0 and BIOL 303/3.0.\n'],
      code: 'BIOL 510',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biogeochemistry and Global Change',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'LATN 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 321',
      description:
        'Selected passages of Latin prose, usually drawn from oratory, history, and philosophy, read in the original Latin and\ncommented upon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with LATN 421/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Latin Prose',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in LATN 209/6.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'RELS 222': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 222',
      description:
        'Developments through 3,000 years of Indian history; the Upanishads, the Bhagavad Gita, Yoga and Vedanta, mythology of\nVishnu and Shiva, and recent Hindu thinkers (e.g., Tagore, Aurobindo).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Hindu World',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 302': {
      EXCLUSION: ['No more than 6.0 units from HIST 285/3.0; HIST 302/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 302',
      description:
        'This course will focus on learning to interpret primary and secondary sources, conduct historical analysis, discern a thesis and\nmethodology, and write analytical short essays. Course examines the impacts of invasion and colonialism on the lives of\ncolonial Latin American subjects.\n',
      NOTE: [
        'In Fall term, HIST 302/6.0 meets in the same classroom with HIST 285/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'olonial Invasions, Colonial Lives',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (34.5L;36S;1.5T;168P)\n']
    },
    'ARTH 370': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 370',
      description:
        'Baroque and Rococo architecture and urbanism of Europe and beyond including Italy, France, Iberia, Central and Eastern\nEurope, Scandinavia, New Spain (Mexico), Peru, Brazil, India, Macau, Philippines. Includes Italian bel composto, impact of\ntheater, salon culture in Paris, indigenous contributions outside Europe, ephemera, gardens.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Architecture of the Baroque Period',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 303',
      description:
        'A survey of the work of First Nations playwrights, exploring the stories, concerns and aesthetics of these contemporary,\nmostly Canadian, theatrical practitioners. Course work involves reading, discussion, and writing descriptively, critically or\ncreatively about selected pieces in artistic, social and/or political contexts.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'First Nations Playwrights',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'HIST 367': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 367',
      description:
        'An examination of the recurring dream in European society of a glorious future and of attempts to describe and realize it.\nThe course begins with images of the past and future in Antiquity but focuses extensively on Medieval and Early Modern\nEurope.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'topian Visions and Movements for a New Society',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'CISC 330': {
      EXCLUSION: [
        'No more than 3.0 units from CISC 330/3.0; COMP 329/3.0; COMP 230/3.0.\nEQUIVALENCY    COMP 230/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CISC 330',
      description:
        'Concepts of computer-integrated surgery systems and underlying techniques such as medical-image computing, robotics,\nand virtual reality, learned through real-life applications and problems. Techniques learned in class will be applied in a\nhands-on surgery session where students perform minimally invasive surgery with virtual-reality navigation tools.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computer-Integrated Surgery',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 121/3.0 and CISC 271/3.0).\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 396': {
      EXCLUSION: [
        'No more than 3.0 units from FREN 295/3.0; FREN 396/3.0; FREN 496/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 396',
      description:
        'A study of Qu\u00e9bec society through the analysis of cinema focusing on the impacts of recent cultural institutions on the formation\nof cultural identity during and since the Quiet Revolution. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cin\u00e9ma et culture qu\u00e9b\u00e9coise',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['136 (36L;6O;84P)\n']
    },
    'FILM 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 450',
      description:
        'A 12-week course that serves as a general primer on the current business of media in Canada as it pertains to narrative\nstorytelling. Students explore business considerations throughout the production cycle, from development to production to\ndistribution and marketing, as well as examine various different career paths in media.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Business of Media',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and FILM 250/6.0 and 24.0 units in FILM or\npermission of the Department.'
      ],
      'LEARNING HOURS': ['108 (36L;24Oc;48P)\n']
    },
    'FILM 206': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 206',
      description:
        'A series of interactive presentations and lectures instructing students in research methods, argumentative writing, and the\ndesign of effective audio-visual presentations.\n',
      NOTE: ['Priority will be given to FILM, STSC, and COCA students.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research, Writing, and Presentation Methods',
      units: '3.0',
      PREREQUISITE: [
        '(A grade of B- in FILM 110/6.0) or (a GPA of 2.60 in FILM 104/3.0 and FILM 106/3.0) or (a GPA of 2.60 in\nBISC 100/3.0 and FILM 104/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'POLS 383': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 383',
      description:
        'An examination of the role of law in politics, the differences between legal and political reasoning, the law and politics of\nconstitution-making, and the political character of criminal and civil law. Topics include the victim\u2019s rights movement,\npornography and censorship, and the role of litigation in political life.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Law and the Governmental Process',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 367': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 367',
      description:
        'An examination of American foreign policy, with particular emphasis on the analysis of concepts and issues and the study of\ndecision-making processes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Foreign Policy',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LATN 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 422',
      description:
        'Selected works of Latin verse, usually drawn from epic, lyric, elegy, and drama, read in the original Latin and commented\nupon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with LATN 322/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Latin Verse',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in LATN 322/3.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['141 (36L;105P)\n']
    },
    'ENGL 441': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 441',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Romanticism I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 258': {
      EXCLUSION: [
        'No more than 6.0 units from ENGL 256/6.0; ENGL 257/3.0; ENGL 258/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 258',
      description:
        'A study of eight of Shakespeare\u2019s plays in relation to the social, intellectual, and political climate of the Jacobean period and\nwith reference to theatrical production.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Jacobean Shakespeare',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUTH 160': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 160',
      description:
        'Performance experience for qualified musicians in a staged vocal ensemble. Topics include musical theatre, opera, or other\nensemble formats combining voice and drama.\n',
      NOTE: [
        'Placement is made at the discretion of the School based on an audition or other criteria.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Theatre Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School.'],
      'LEARNING HOURS': ['168 (72Pc;24G;72P)\n']
    },
    'EPID 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EPID 401',
      description:
        'An applied statistics course covering practical topics in tests and confidence intervals for single and multiple samples,\nANOVA, linear regression, correlations, methods for categorical data, and nonparametric methods. SPSS package is used in\nthe lab. The course emphasizes analyzing data arising in life sciences using practical statistical methods.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biostatistical Data Analysis for Life Science Students',
      units: '3.0',
      PREREQUISITE: [
        'COMM 162/3.0; ECON 250/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0\nand (Level 4 and registration in a LISC Major or Specialization Plan) and (a GPA of 2.5).'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 121': {
      EXCLUSION: ['No more than 6.0 units from MUSC 120/6.0; MUSC 121/6.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 121',
      description:
        'The first year of study of the student\u2019s chief practical subject (instrument or voice).\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study I',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'INTN 301': {
      EXCLUSION: [
        'No more than 1 course from INTN 303/3.0 and INTN 304/1.5.\nINTN 304/1.5\nProfessional Internship III\nPart 3 of a 16 month, professional supervised, career-related position designed to offer students the opportunity to learn\nabout current advances, practices and technologies in workplace including business, industry, government and community\nsettings. Students will develop a range of workplace skills, learn about organizational culture, expand their knowledge of\ncareer options and reflect on linkages between classroom knowledge and professional practice.\n',
        'No more than 1 course from INTN 303/3.0 and INTN 304/1.5.\nINTN 305/1.5\nProfessional Internship IV\nPart 4 of a 16 month, professional supervised, career-related position designed to offer students the opportunity to learn\nabout current advances, practices and technologies in workplace including business, industry, government and community\nsettings. Students will develop a range of workplace skills, learn about organizational culture, expand their knowledge of\ncareer options and reflect on linkages between classroom knowledge and professional practice.\n',
        'No more than 1 course from INTN 303/3.0 and INTN 305/1.5.'
      ],
      RECOMMENDATION: [],
      code: 'INTN 301',
      description:
        'Part 1 of a 12-16 month, professionally supervised, career-related position designed to offer students the opportunity to\nlearn about current advances, practices, and technologies in workplaces including business, industry, government, and\ncommunity settings. Students will develop a range of workplace skills, learn about organizational culture, and expand their\nknowledge of career options.\n',
      NOTE: [
        'Prior to undertaking the internship, workshops on resum\u00e9 preparation and interview skills are required,\ncoordinated by Career Services.\n',
        'Students enroll in INTN 301/1.5 in the first term of the internship, INTN 302/1.5 in the second term of the\ninternship, and INTN 303/3.0 in the final term(s) of the internship, for a total of 6.0 units.\n',
        'Students enroll in INTN 301/1.5 in the first term of the internship, INTN 302/1.5 in the second term of the\ninternship, and INTN 303/3.0 in the final term(s) of the internship, for a total of 6.0 units.\n',
        'This course is intended for students participating in a 16 month internship. This is part 3 of 4.\n',
        'This course is intended for students participating in a 16 month internship. This is part 4 of 4.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Professional Internship I',
      units: '1.5',
      PREREQUISITE: [
        'Level 2 or 3 and a minimum GPA of 1.90.\nINTN 302/1.5\nProfessional Internship II\nPart 2 of a 12-16 month, professionally supervised, career-related position designed to offer students the opportunity to\nlearn about current advances, practices, and technologies in workplaces including business, industry, government, and\ncommunity settings. Students will develop a range of workplace skills, learn about organizational culture, and expand their\nknowledge of career options.\n',
        'INTN 301/1.5 and a minimum GPA of 1.90.\nINTN 303/3.0\nProfessional Internship III\nPart 3 of a 12 month, professionally supervised, career-related position designed to offer students the opportunity to learn\nabout current advances, practices, and technologies in workplaces including business, industry, government, and\ncommunity settings. Students will develop a range of workplace skills, learn about organizational culture, expand their\nknowledge of career options, and reflect on linkages between classroom knowledge and professional practice.\n',
        'INTN 302/1.5 and a minimum GPA of 1.90.\n',
        'INTN 302/1.5 and a minimum GPA of 1.90.\n',
        'INTN 304/1.5 and a minimum GPA of 1.90.\n'
      ],
      'LEARNING HOURS': []
    },
    'FILM 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 340',
      description:
        'Course reviews print, online, and television advertising strategies to understand the construction of consumer culture and\ncitizenship. Critically examines the historical evolution of integrated marketing and communications and public relations in\nNorth America.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advertising and Consumer Culture',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (FILM 236/3.0; FILM\n240/3.0; FILM 260/3.0) or (COMM 131/3.0 or COMM 231/3.0 or PSYC 342/3.0).\nFILM 345/3.0\nTelevision: Structure and Function\nIntermediate examination of television and the development of the medium as a distinctive cultural form, through a range\nof programs and programming formats, issues of audience, and television broadcasting in Canada.\n',
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;36O;36P)\n', '108 (36L;24Lb;48P)\n']
    },
    'HIST 295': {
      EXCLUSION: ['No more than one course from HIST 295/3.0; HIST 306/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 295',
      description:
        'The background to and processes of the destruction of the Jews of Europe between 1933 and 1945. Themes to be covered\ninclude: modern anti-semitism, Jewish communities in the inter-war era, Nazi racial policies, the Judenrat, the organization of\nthe death camps, the attitudes of the Christian churches, the role of collaborators, the ideology of mass murder, and the\nquestions of \u2018compliance\u2019, \u2018resistance\u2019, and \u2018silence\u2019.\n',
      NOTE: [
        'Offered also as a Cognate course in the Program in Jewish Studies.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'he Holocaust',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['129 (77L;52P)\n']
    },
    'FREN 353': {
      EXCLUSION: [
        'No more than 6.0 units from FREN 215/6.0; FREN 353/3.0; FREN 393/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 353',
      description:
        'Introduction to basic notions in phonetics and phonology. Physiology of speech and phonation, description and\nclassification of French sounds, distinction between phonetics and phonology, description of the French phonological\nsystem (phonemes and feature system, phonological rules and syllable structure).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Phon\u00e9tique et phonologie du fran\u00e7ais',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or FREN 212/6.0 or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 392': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 392',
      description:
        'An examination of selected aspects of Canadian politics and government, including institutions and behavioural\napproaches. The focus of this course will vary from year to year; consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Canadian Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 473': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 473',
      description:
        'Advanced supervised study in a specific area of musicology/ethnomusicology, music theory/analysis or music education.\nRegulations pertaining to the courses are available in the Music Office.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Study I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and a GPA of 3.50 in MUSC at the 300-level and permission of the instructor and of the Chair of\nUndergraduate Studies.'
      ],
      'LEARNING HOURS': ['123 (6I;117P)\n']
    },
    'POLS 385': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; COMM 162/3.0; ECON 250/3.0; GPHY 247/3.0;\nKNPE 251/3.0 (formerly PHED 251/3.0); NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT\n267/3.0; STAT 367/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'POLS 385',
      description:
        'Introduction to Statistics\nAn introduction to the analysis of data from real life situations. Covers study design, descriptive and inferential statistics.\nTopics include probability, t-tests, regression, Chi-square tests, analysis of variance. Emphasis is in the foundation of\nstatistical inference and practical application of statistical methods using statistical software.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['118 (24L;10T;84P)\n']
    },
    'GNDS 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 480',
      description:
        'Offered when faculty resources permit, these courses are analyses of particular areas of gender studies interdisciplinary research.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Gender Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a GNDS Major or Medial or SXGD Plan, or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'LING 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 320',
      description:
        'Principles and methods of modern generative phonology. Examination of the formal properties of the sound systems of\nlanguages. Current theoretical controversies as well as particular synchronic and diachronic problems in a variety of\nlanguages.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Phonology',
      units: '3.0',
      PREREQUISITE: [
        'LING 100/6.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (18L;18G;84P)\n']
    },
    'PHGY 494': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHGY 494',
      description:
        'Neuroendocrinology\nStudents are exposed to an in depth study of selected topics in neuroendocrinology and neuroendocrine techniques.\nNeuroendocrinology refers to the neural control of endocrine and autonomic function. Areas of focus will include central\nnervous system control of cardiovascular function, reproduction, and appetite. In addition, students will learn to critically\nevaluate scientific literature. Instructional format is primarily student led seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(A minimum grade of B in PHGY 210/6.0 or PHGY 214/6.0 or PHGY 212/6.0) and Level 4 and (registration in\na LISC Major or Specialization Plan) and (a GPA of 2.5) or permission of the course coordinator.'
      ],
      'LEARNING HOURS': ['114 (36S;12O;96P)\n']
    },
    'MUSC 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 480',
      description:
        'An intensive study of the development of a particular musical genre. Emphasis will be placed on the analysis of significant\ncontributions to the genre and the place of the genre in the total cultural milieu of a given period. Content varies from year\nto year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Genre Studies',
      units: '3.0',
      PREREQUISITE: [
        '([MUSC 293/3.0 or MUSC 291/6.0] and MUSC 103/3.0 and [MUSC 203/3.0 or MUSC 204/3.0 or MUSC\n205/3.0]) or permission of the School.'
      ],
      'LEARNING HOURS': ['127 (36L;91P)\n']
    },
    'DRAM 342': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 342',
      description:
        'An examination of specific topics in contemporary design practice with special attention to the areas of lighting, costume,\nand sound design: includes theoretical and practical design projects.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Elements of Design Practice',
      units: '3.0',
      PREREQUISITE: ['A grade of B- in DRAM 241/3.0.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DEVS 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 480',
      description:
        '600 years of colonialism have greatly harmed this planet\u2019s people and environments. Complementary lifeways can balance\ncognitive, emotional, and physical realities and inform intellectual, scientific, and artistic enquiry. This course attempts to\nstrike that balance, through academic inquiry and visceral experience, in the classroom and on the land.\n',
      NOTE: [
        'Students are required to make application. Contact Department for application information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Reindigenizing People and Environment',
      units: '6.0',
      PREREQUISITE: ['DEVS 220/3.0 or GPHY 351/3.0.'],
      'LEARNING HOURS': ['232 (8L;8S;36O;100Oc;80P)\n']
    },
    'ARTF 448': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTF 448',
      description:
        'In fourth year, each student must submit a proposal for an individual program of creative exploration and research. This can\nbe based on one or more of the following areas: painting, printmedia, 3-D media. Instruction at this level is through\nindividual tutorials and critiques, although all students will meet once a week for a common seminar.\n',
      NOTE: ['Open only to students in a BFA Program.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Individual Programs II',
      units: '9.0',
      PREREQUISITE: ['A minimum grade of C- in ARTF 447/9.0.'],
      'LEARNING HOURS': ['309 (9S;12I;288P)\n']
    },
    'LISC 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'LISC 499',
      description:
        'An examination of the development and present state of knowledge in selected areas in life sciences and related areas.\nResearch projects involve experimental design, data collection and analysis, written report, and oral presentation. Students\nwill be required to attend seminars and tutorials on topics related to research. Limited enrolment.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Life Sciences',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Specialization Plan and a GPA of 2.50.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'DRAM 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 300',
      description:
        'A study of production and performance methods, and dramatic literature of the 20th and 21st centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theatre History and Literature II',
      units: '6.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['252 (24L;24S;24G;60O;120P)\n']
    },
    'HIST 206': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 206',
      description:
        'An introduction to the history of the United States during the turbulent period from 1868 until 1920.  Topics may include\nindustrialization, reform movements, mass consumption, corporations, imperialism,  immigration, urbanization, the rise of\nsegregation, agricultural transformation, art, and literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'he United States in the Gilded Age and Progressive Era, 1868-1920',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 300',
      description:
        'This course examines Classical Hollywood Cinema from the early 1940s until its demise at the end of the 1950s.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Hollywood: The Dream Factory',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization) or (FILM 236/3.0; FILM 240/3.0; FILM 260/3.0).\nFILM 301/3.0\nAmerican Film in Historical Perspective\nThis course studies the production and reception of film in the United States from the turn of the 20th century to the\npresent day. It traces the aesthetic, technological and organizational changes in various film practices, and places those\nchanges in the context of American social history. Example films are chosen from feature filmmaking as well as from\ndocumentary and experimental traditions.\n',
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\nFILM 302/3.0\nGenre\nIntermediate examination of generic convention, iconography, relations to modes of production and to audience, and\nhistorical dimensions, using as examples films or video productions in one or more genre.\n',
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': [
        '108 (36L;24Lb;48P)\n',
        '108 (36L;24Lb;48P)\n',
        '108 (36L;24Lb;48P)\n'
      ]
    },
    'SOCY 225': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 225',
      description:
        'An introduction to recent sociological debates on the emergence of a global economy and society, and its impact on\ndifferent parts of the world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Globalization',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 404',
      description:
        'Sociology of Corporate Crime\nCourse examines the causes and effects of corporate crime, and the challenges of controlling, policing, and sanctioning it.\nThe role of the regulatory agency, the impact of globalization, the rise of transnational corporations, and associated issues\nof development and power are considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and ([SOCY 275/3.0 and SOCY 276/3.0] or SOCY\n274/6.0) and (a minimum grade of C in SOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a\nminimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of\n2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'PHYS 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 350',
      description:
        'General Laboratory\nExperiments in heat, optics, electron physics, quantum physics, and radioactivity are performed. A substantial part of the\ncourse is an experimental project during the Winter Term. A topic for the experimental physics, or observational astronomy\nproject will be assigned after discussion with the student.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['PHYS 239/3.0 and PHYS 242/3.0 and PHYS 250/3.0.'],
      'LEARNING HOURS': []
    },
    'PHYS 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 435',
      description:
        'This course provides a detailed account of the formation, structure, evolution and endpoints of stars. Topics include the HR\ndiagram, nuclear energy generation, radiative transport and stellar model building, supernovae, white dwarfs, neutron\nstars, pulsars and black holes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Stellar Structure and Evolution',
      units: '3.0',
      PREREQUISITE: ['PHYS 315/3.0.'],
      'LEARNING HOURS': []
    },
    'GEOL 232': {
      EXCLUSION: ['No more than 3.0 units from GEOL 212/3.0; GEOL 232/3.0.'],
      RECOMMENDATION: ['4U Chemistry is required.\n'],
      code: 'GEOL 232',
      description:
        'Mineralogy\nCharacterization of rock- and soil-forming silicate and non-silicate minerals (their crystallography, optical and physical\nbehaviour, and crystal chemistry). The structural, chemical and genetic aspects of the crystalline state as displayed by\nminerals are considered. Implications of mineral properties for the engineering behaviour of soils and rocks, and for human\nneeds, are discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;36Lb;48P)\n']
    },
    'GPHY 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 338',
      description:
        'The forces involved in shaping the political environment and spatial structure of urban areas. Emphasis on the significance\nof decisions concerning public goods in the distribution of income and equity within the city.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Urban Political Geography',
      units: '3.0',
      PREREQUISITE: [
        '6.0 units from GPHY 227/3.0; GPHY 228/3.0; GPHY 229/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ITLN 331': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 233/3.0; ITLN 331/3.0; LLCU 233/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 331',
      description:
        'A survey of Italian literature, through selected texts of representative authors, from the Middle Ages to the eighteenth\ncentury.\n',
      NOTE: [
        'Taught in English together with LLCU 233/3.0. Students submit written assignments, tests, and examinations in\nItalian.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Survey of Italian Literature I',
      units: '3.0',
      PREREQUISITE: ['ITLN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 262': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 262',
      description:
        'A Canadian perspective on labour market theories, trends, policies and the analysis of differences by gender in labour\ndemand, labour supply, and wages.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Labour Markets and Gender Differences',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'GPHY 348': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 348',
      description:
        'Application Design and Customization in GIS\nAn introduction to customization of GIS and database software with an emphasis on spatial analysis tool development for\ndesktop and Web-based GIS. Students will learn concepts of user requirements analysis, software requirements\npreparation, interface and software design, and computer programming while they develop customized GIS applications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'GPHY 243/3.0 or (3.0 units from GPHY 247/3.0; ECON 250/3.0; KNPE 251/3.0; PHED 251/3.0; POLS 385/3.0;\nPSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0), or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (24L;24Pc;24G;24O;24P)\n']
    },
    'MATH 211': {
      EXCLUSION: ['No more than 1 course from MATH 210/3.0; MATH 211/6.0.'],
      RECOMMENDATION: [],
      code: 'MATH 211',
      description:
        'Algebraic techniques used in applied mathematics, statistics, computer science and other areas. Polynomials, complex\nnumbers; least squares approximations; discrete linear systems; eigenvalue estimation; non-negative matrices - Markov\nchains; permutation groups; linear Diophantine equations; introduction to algebraic structures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Algebraic Methods',
      units: '6.0',
      PREREQUISITE: [
        '(MATH 120/6.0 or MATH 121/6.0 or MATH 124/3.0 or MATH 126/6.0 or MATH 122/6.0) and (MATH\n110/6.0 or MATH 111/6.0 or MATH 112/3.0).\n'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'GEOL 462': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 462',
      description:
        'Igneous petrology, geochemistry and fluid-rock interaction applied to metallogeny and ore genesis. Case studies in mineral\nchemistry and geochemstry. Lectures, critical reading, laboratory work and seminars will provide an advanced\nunderstanding of the major ore-forming processes in a geodynamic setting and applications to mineral exploration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Petrogenesis and Metallogenesis',
      units: '3.0',
      PREREQUISITE: [
        '(GEOL 362/3.0, GEOL 365/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (24L;12S;36Lb;48P)\n']
    },
    'MUSC 205': {
      EXCLUSION: ['No more than 3.0 units from MUSC 101/3.0; MUSC 205/3.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 205',
      description:
        'An examination of musical styles, structures and historical movements of the Western art tradition from the Age of\nAntiquity, to the Middle Ages, through to the Renaissance from circa 500 B.C.E. to circa 1600 A.D.\n',
      NOTE: [
        'Non-Music students holding Royal Conservatory Grade III Harmony may enroll in this course with permission of the\nSchool.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Mediaeval and Renaissance Music',
      units: '3.0',
      PREREQUISITE: ['MUSC 103/3.0.\nCOREQUISITE    MUSC 191/6.0.\n'],
      'LEARNING HOURS': ['118 (36L;12O;70P)\n']
    },
    'ARTH 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 340',
      description:
        'An examination of a range of historical conditions that have encouraged and challenged the growth of a visual and media\narts practice in Canada since the mid-1950s.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Aspects of Contemporary Art in Canada',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['126 (24L;12G;90P)\n']
    },
    'GEOL 481': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 481',
      description:
        'Applications of the principles of brittle and ductile deformation to the fabric analysis of rocks in the optimization of\nstrategies for open-ended resource exploration, resource engineering, continental tectonics studies, and geotechnical\nengineering problems. Emphasis is on fracture, fault, and vein analysis; structures in fold and thrust belts and continental\ncollision zones; and studies of superposed deformation and their impact on effective and economical mineral resource\ndevelopment.\n',
      NOTE: [
        'This course may not be offered every year. Consult: http://www.queensu.ca/geol/courses for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Structural Analysis',
      units: '3.0',
      PREREQUISITE: ['GEOL 321/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;24Lb;12T;60P)\n']
    },
    'CWRI 294': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CWRI 294',
      description:
        'A workshop course focusing on the writing and editing of poetry. Students attempt several different forms within the poetic\ngenre and complete the course with a formal submission for publication in a magazine. There are lectures on editing,\npublishing, and public performance.\n',
      NOTE: [
        'Admission only at the discretion of the instructor following a submission of creative work.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Creative Writing in Poetry',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'POLS 110': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 110',
      description:
        'An introduction to political science that provides both a framework for thinking about politics and the institutions of\ngovernance, and some of the vocabulary necessary for political analysis.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Politics and Government',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CLST 334': {
      EXCLUSION: ['No more than 3.0 units from CLST 331/3.0; CLST 334/3.0.'],
      RECOMMENDATION: [],
      code: 'CLST 334',
      description:
        'Study of Greek history in the century following the end of the Peloponnesian War in 404 BCE. Topics may include the crisis\nand renewal of the Greek polis; the Spartan hegemony, the rise of Thebes, the Second Athenian League, and the failure of\nhegemonic policies; the end of the Achaemenid Empire; the rise of Macedon; and the campaigns of Alexander.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fourth Century Greece to the Death of Alexander',
      units: '3.0',
      PREREQUISITE: ['CLST 200/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PSYC 473': {
      EXCLUSION: [],
      RECOMMENDATION: ['PSYC 205/3.0.\n'],
      code: 'PSYC 473',
      description:
        'An examination of current theories on the neurobiology of mental disorders (e.g. autism, schizophrenia, mood and anxiety\ndisorders). Seminars will focus on the evaluation of animal models for investigating neurodevelopmental and\npharmacological aspects of various psychopathologies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Neurobiology of Psychiatric Disorders',
      units: '3.0',
      PREREQUISITE: ['PSYC 271/3.0 and (PSYC 370/3.0).'],
      'LEARNING HOURS': []
    },
    'HIST 124': {
      EXCLUSION: [
        'No more than 6.0 units from HIST 124/6.0; HIST 278/3.0, HIST 279/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 124',
      description:
        'An introduction to major themes and events in the history of Canada placed in a North American and world context. Topics\ninclude relations between natives and newcomers, comparative colonialism, the emergence of nation-states and new social\nand cultural identities. Assignments emphasize analysis of historical texts and development of research and writing skills.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Canada in the World',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (36L;36S;24O;144P)\n']
    },
    'ARTH 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 304',
      description:
        'Issues in the History of Canadian Art\nA selective examination of issues in Canadian art history and historical practice, especially as they inform the production\nand critique of the history of Canadian art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'GNDS 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 320',
      description:
        'Centers historical movements in communities affected by AIDS as sources of unique critical theories of disease, health,\npower, and social change. Highlights how testimonies, cultural and creative work, and social research in community-based\nAIDS activism inspire current critical theory in feminist, queer, disability, and critical race studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'HIV/AIDS Movements:Histories of Community Health Activism',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 326': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 326',
      description:
        'The first part examines chemical contaminants in the atmosphere, water, soils and sediments, including sources, behaviour,\ntransport, and distribution among these environments. The second part introduces Green Chemistry, examining industrial\nsources of contaminants and the modification of industrial processes in order to minimize environmental impact.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental and Green Chemistry',
      units: '3.0',
      PREREQUISITE: [
        '(CHEM 223/3.0 or CHEM 281/3.0) and 6.0 units in CHEM at the 200 level.'
      ],
      'LEARNING HOURS': ['108 (33L;3G;72P)\n']
    },
    'ARTH 339': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 339',
      description:
        'Selected problems in the development of Canadian painting and sculpture in the modern period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Art in the Twentieth Century',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['126 (24L;12G;90P)\n']
    },
    'HIST 260': {
      EXCLUSION: [
        'No more than 6.0 units from HIST 260/6.0; HIST 278/3.0, HIST 279/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 260',
      description:
        'An introduction to some of the major themes in the social, cultural, economic and political history of Canada.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'anada from the Conquest to the Present',
      units: '6.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['260 (144O;120P)\n']
    },
    'SPAN 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 501',
      description:
        'Literatura de Espa\u00f1a: Temas espec\u00edficos\nSeminar courses on topics in Spanish literature. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Permission of the Department of Languages Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'HIST 299': {
      EXCLUSION: ['No more than 3.0 units from HIST 270/3.0; HIST 299/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 299',
      description:
        'hina since 1800\nAn introduction to China\u2019s recent history, offering interpretive frameworks for issues such as the competence of the Qing\ngovernment, population growth, revolutionary movements, Mao Zedong\u2019s leadership, and economic expansion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': []
    },
    'DEVS 395': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 395',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies IV',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ARTF 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTF 227',
      description:
        'This course offers two of the sections from the four media areas available at this level: painting, drawing, print media and\nsculpture. Course content builds on concepts developed in ARTF127/6.0 and ARTF128/6.0. New techniques, skills and\nconcepts are introduced.\n',
      NOTE: [
        'Open only to students in a BFA Program.\n',
        'Materials: estimated cost $250.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Fine Art I',
      units: '6.0',
      PREREQUISITE: [
        'A minimum grade of C- in ARTF 128/6.0 and a GPA of 1.60.'
      ],
      'LEARNING HOURS': ['288 (144Lb;144P)\n']
    },
    'BIOL 103': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 102/3.0.'],
      code: 'BIOL 103',
      description:
        'An introduction to the basic themes and concepts of modern biology spanning organizational levels from organisms to\necosystems in an evolutionary context.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Biology of Organisms',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['123 (36L;24Lb;24O;39P)\n']
    },
    'POLS 398': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 398',
      description:
        'This course provides foundational knowledge about the relationship between international politics and international law. It\nthen explores more specific aspects of international law, including international criminal law and the Law of Armed Conflict,\nand situates the central statutes, customs, and institutions of international law within the broader context of global\ngovernance.\n',
      NOTE: [
        'Only offered at the Bader International Study Centre as part of the Field School in International Law and Politics.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to International Law and Politics',
      units: '9.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['348 (72L;36S;24G;24Oc;192P)\n']
    },
    'HIST 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 365',
      description:
        'Examination of historical research methods using primarily non-printed sources, with emphasis on material culture and its\napplication to community history. Students will examine the use of photographs, ephemera, artefacts, oral history, popular\nmusic, movies, magazines and posters to consider how these sources can augment written documentation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History Outside the Book',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'ENGL 487': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 487',
      description:
        'Studies focused on Modern and Contemporary literature that do not fit within the established Group III rubrics (British,\nCanadian, American, Postcolonial, Indigenous). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group III: Special Topics II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DEVS 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 240',
      description:
        'Provides students with a broad overview of debates relating to development and culture, including issues of religion, music,\nsport, art and literature, and how these interact with economic policy and political change.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Culture and Development',
      units: '3.0',
      PREREQUISITE: [
        'DEVS 100/6.0 and DEVS 230/3.0. (DEVS 100/6.0 can be taken concurrently in exceptional circumstances).'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 305': {
      EXCLUSION: [
        'No more than 3.0 units from SOCY 305/3.0; SOCY 303/3.0 (2016-17).'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 305',
      description:
        'Sociology of Professions and Occupations\nThis course examines theories and empirical studies on professions and occupations. This course examines historical\nchange, social structure, market competition, career advancement, workplace interaction and culture, job satisfaction,\ndemographic diversity and social service, from the late nineteenth century to the age of globalization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 405': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 405',
      description:
        'An examination of major issues in contemporary social and political philosophy. Possible topics to be studied include\ncommunitarianism, liberalism, multi-culturalism, the nation-state, and utopias.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Social and Political Philosophy I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'CISC 481': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 481',
      description:
        'Chomsky grammars, including context-free languages; algorithms for natural language processing. Content will vary from\nyear to year, but may include lexical-functional grammars, ambiguity resolution, parsing algorithms, grammatical inference,\nLindenmeyer grammars and grammars for multi-dimensional objects. Students will present seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Syntax Systems for Natural Language',
      units: '3.0',
      PREREQUISITE: ['Permission of the School.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DEVS 220': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 220',
      description:
        'An introduction to Aboriginal world view and culture organized on an historical basis, from Creation to 1969, emphasizing\nAboriginal culture and experience in Canada. Aboriginal perspectives will be introduced through traditional teaching\nmethods and contributions from elders and other community members.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Aboriginal Studies',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ENGL 284': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 284',
      description:
        'A study of one particular issue or theme in Canadian literature. For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues and Themes in Canadian Literature I',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BCHM 441': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 441',
      description:
        'Tutorials, assignments and demonstrations in important subjects in biochemistry emphasizing topics of broad interest.\nParticular emphasis will be paid to the applications of biochemical knowledge and new technologies.\n',
      NOTE: [
        'Students in the BCHM Specialization Plan registered in BCHM 421/6.0 and BCHM 422/6.0 will not be allowed to\nregister in BCHM 441/3.0; Students in the LISC Specialization Plan registered in one of ANAT 499/12.0, CANC 499/12.0, EPID\n499/12.0, LISC 499/12.0, MICR 455/6.0, MICR 499/12.0, NSCI 499/12.0, PATH 499/12.0, PHAR 499/12.0 or PHGY 499/12.0\nwill not be allowed to register in BCHM 441/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Topics in Biochemistry',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Major Plan) and [a GPA of 2.7 in BCHM 313/3.0, BCHM 315/3.0, BCHM\n316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['120 (21L;9S;3G;3Oc;84P)\n']
    },
    'SPAN 331': {
      EXCLUSION: ['No more than 3.0 units from LLCU 331/3.0; SPAN 331/3.0.'],
      RECOMMENDATION: [],
      code: 'SPAN 331',
      description:
        "A study of Don Quijote II and a selection of novellas from Cervantes' Exemplary Novels.  The course will consider the socio-\neconomic and historical context and the literary implications of the continuation of Don Quijote I to provide a better\nunderstanding of 17th century Spain and the significance Cervantes' works hold today.\n",
      NOTE: [
        'Taught in English with LLCU 331/3.0. Written work and examinations are in Spanish. Readings are in translation.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Cervantes II: Later Works',
      units: '3.0',
      PREREQUISITE: ['SPAN 330/3.0.\n'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ECON 590': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 590',
      description:
        'Optional for those in the B.A.(Honours) program with a major concentration in Economics or Applied Economics. The thesis\nis a major research paper to be undertaken with supervision of a faculty adviser. The thesis proposal should be presented to\nthe Department by 31 October in the graduating year and a completed thesis must be submitted to the Department by the\nend of the Winter Session in the graduating year.\n',
      NOTE: ['Enrolment is limited.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Thesis',
      units: '6.0',
      PREREQUISITE: [
        'Permission of the Department. Level 4 and registration in an ECON or APEC plan.'
      ],
      'LEARNING HOURS': ['240 (48I;192P)\n']
    },
    'ARTH 460': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 460',
      description:
        'Curatorial Studies\nThis seminar, held at the Agnes Etherington Art Centre, integrates historical, theoretical, and practical approaches to\ncontemporary curatorial issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['126 (18S;18Pc;90P)\n']
    },
    'FREN 111': {
      EXCLUSION: [
        'No more than 6.0 units from FREN P10/6.0; FREN P11/3.0; FREN P12/3.0; FREN 111/3.0; FREN 112/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'FREN 111',
      description:
        'Review of the French language in the North American context: written and oral exercises, compositions, short readings.\nEmphasis on grammar and vocabulary.\n',
      NOTE: ['Not available for credit towards any plan in FREN\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after FREN 112/3.0; FREN 118/3.0; FREN 150/6.0; FREN 219/3.0; FREN\n320/3.0; FREN P12/3.0; FREN 100/6.0; FREN 101/3.0; FREN 102/3.0; FREN 110/6.0.\nEQUIVALENCY    FREN P11/3.0.'
      ],
      title: 'R\u00e9vision de la grammaire I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 252': {
      EXCLUSION: ['No more than 3.0 units from BMED 270/3.0; HLTH 252/3.0.\n'],
      RECOMMENDATION: [],
      code: 'HLTH 252',
      description:
        'Introduction to Research Methods\nThis course provides an introduction to methods, techniques and approaches to research. The course will explore the\nformulation of research questions, experimental design, interpretation of results, and the use of statistical analysis in\nexperimental research. Ethical issues in research will also be discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after: GPHY 240/3.0; PSYC 203/3.0; SOCY 210/3.0.\n'
      ],
      title: '',
      PREREQUISITE: [
        'Level 2 or above and registered in a KINE, PHED or a (HLTH Major or Medial) Plan.\nCOREQUISITE    3.0 units from STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM 162/3.0; ECON 250/3.0; PSYC 202/3.0;\nSOCY 211/3.0; BIOL 243/3.0; CHEE 209/3.0; GPHY 247/3.0; KNPE 251/3.0 or PHED 251/3.0; POLS 385/3.0; NURS 323/3.0.\n'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'PSYC 470': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 470',
      description:
        'Intensive coverage of selected topics in behavioural neuroscience to include, in different years, such topics as neurobiology\nof learning and memory, neuroendocrinology, biological bases of motivation, biological bases of brain disorders, etc.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topics in Behavioural Neuroscience',
      units: '3.0',
      PREREQUISITE: ['PSYC 205/3.0 and PSYC 271/3.0 and PSYC 370/3.0.'],
      'LEARNING HOURS': []
    },
    'GEOL 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 341',
      description:
        'A problem-oriented course involving a substantial amount of self-directed learning about a topic of the student\u2019s choosing,\nculminating in the submission of a written report. This course is open to students only if a suitable faculty member is\navailable.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Problems in Geology',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a GEOL Major or Specialization Plan or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (6I;114P)\n']
    },
    'HIST 332': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 332',
      description:
        'Combining history and archaeology, this course explores the key developments of Medieval England from the formation of\nthe Anglo-Saxon kingdoms to the late 15th century Wars of the Roses. A significant proportion of this course will be devoted\nto the study of material culture, the practice of archaeology and the excavation of medieval sites.\n',
      NOTE: [
        'Offered only at the Bader International Studies Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'edieval Britain',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['119 (22.5L;7.5S;8Lb;16T;35G;30P)']
    },
    'HIST 488': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 488',
      description:
        'By studying the careers of Nobel laureates as individuals and as groups, students will become familiar with landmarks (and\ndisasters) in twentieth-century science. They will also learn to write and criticize histories of science and commemoration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'obel Prize in Medicine: Who won it; Who didn\u2019t; and Why?',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'PHIL 403': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 403',
      description:
        'Current Issues in Moral Philosophy II\nAn examination of major issues in contemporary moral philosophy. Topics to be studied may include contractualism, objectivity,\npractical reason, relativism and value realism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 497',
      description:
        'This course examines issues in Ethics and Animals. Potential topics include animal rights, human consumption and other\nuses of non-human animals, the domestication of non-human animals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ethics and Animals',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level) or registration in a ENVS Medial Plan or ENSC Major plan or ENSC, EGPY, EBIO, ECHM, EGEO, ELSC\nor ETOX Specialization Plan)].'
      ],
      'LEARNING HOURS': []
    },
    'MATH 337': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 337',
      description:
        'Some probability distributions, simulation, Markov chains, queuing theory, dynamic programming, inventory theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Operations Research Models',
      units: '3.0',
      PREREQUISITE: [
        '(STAT 268/3.0 or STAT 351/3.0) and (MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and (MATH\n120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 397': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 397/6.0; CHEM 398/3.0; CHEM 399/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 397',
      description:
        'Experimental Chemistry\nLaboratory course introducing modern experimental methods in chemistry, including synthesis, analytical instrumentation\nand computational methods. The integration of several methods will be emphasized in the synthesis and characterisation of\nmolecules.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '12.0 units at the 200 level in CHEM, including CHEM 222/3.0 and CHEM 223/3.0.\nCOREQUISITE    6.0 units at the 300 level in CHEM.\n'
      ],
      'LEARNING HOURS': ['300 (144Lb;12T:144P)\n']
    },
    'DEVS 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 393',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies II',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['132 (24L;12T;96P)\n']
    },
    'SPAN 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 401',
      description:
        'Advanced Grammar Through Translation I\nThis course aims to perfect the students\u2019 ability to write and speak in Spanish, with intensive practice of advanced Spanish\ngrammatical structures through translation exercises, as well as compositions and oral work.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'SPAN 302/3.0 or SPAN 304/3.0 (or permission of the Department of Languages, Literatures and Cultures).\nONE WAY '
      ],
      'LEARNING HOURS': []
    },
    'HLTH 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 101',
      description:
        'This course introduces students to basic concepts in public, population and global health, and introduces social\ndeterminants of health, such as poverty, income inequality, and racism, in Canadian and global contexts.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Social Determinants of Health',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['117 (12L;9T;24O;72P)']
    },
    'BIOL 533': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 533',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Biology II',
      units: '3.0',
      PREREQUISITE: ['To be announced.\n'],
      'LEARNING HOURS': ['120 (9L;9S;18G;84P)\n']
    },
    'ENGL 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 311',
      description:
        'A study of the poetry, drama, and prose of late medieval Britain. Texts are read in Middle English; language training is\nprovided. Readings may include the dramatic cycles, Arthurian romance, Chaucer and his successors, women\u2019s writing,\nspiritual writing, historiography, and the culture of political and religious dissent.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Middle English Literature',
      units: '6.0',
      PREREQUISITE: [
        '[(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units)] or [(a GPA of 2.6) and (registration\nin a MDVL Plan)].'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'POLS 251': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 251',
      description:
        'This course introduces students to a range of contemporary ideologies, such as liberalism, socialism, conservatism, fascism,\nfeminism, anarchism, ecologism, fundamentalism, and nationalism. It includes primary and secondary readings, and will\nfocus on the critical interpretation of these competing belief systems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Ideologies',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'GEOL 269': {
      EXCLUSION: ['No more than 3.0 units from GEOL 249/3.0; GEOL 269/3.0.'],
      RECOMMENDATION: ['4U Physics is required.\n'],
      code: 'GEOL 269',
      description:
        'An examination of the physical principles and properties exhibited by the Earth which can be used to understand its origin,\nstructure, dynamic processes, and evolution through time. Topics such as gravity, seismology, magnetism, geochronology,\nand heat flow are discussed in conjunction with the unifying theory of plate tectonics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Physics of the Earth',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 104/3.0 or permission of the Department.\nCOREQUISITE    MATH 120/6.0 or MATH 121/6.0 or (MATH 123/3.0 and MATH 124/3.0) or MATH 122/6.0 or permission of\nthe Department.\n'
      ],
      'LEARNING HOURS': ['117 (36L;8T;42Pc;7G;24P)\n']
    },
    'PSYC 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 420',
      description:
        'An examination of selected topics in cognitive psychology which may include: computational modelling; problem-solving;\nface recognition; gestalt influences on cognitive science; motor control processes; cognitive neuropsychology. Exact topics\nto vary by year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topics in Cognitive Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 221/3.0 or PSYC 220/6.0 or COGS 200/6.0.'],
      'LEARNING HOURS': []
    },
    'MUSC 289': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 289',
      description:
        'An introduction to the study of music in culture, based on world music traditions. The course focuses on a selection of\nNative North American, African, European, Eastern and Middle Eastern, as well as other musical contexts.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'World Musics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['112 (36L;24O;52P)']
    },
    'MATH 401': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'Experience with abstract mathematics and mathematical proof, and a good foundation in linear\nalgebra.\n'
      ],
      code: 'MATH 401',
      description:
        'An introduction to graph theory, one of the central disciplines of discrete mathematics. Topics include graphs, subgraphs,\ntrees, connectivity, Euler tours, Hamiltonian cycles, matchings, independent sets, cliques, colourings, and planarity. Given\njointly with MATH 801/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Graph Theory',
      units: '3.0',
      PREREQUISITE: [' MATH 210/3.0 or MATH 211/6.0 or MATH 217/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 332': {
      EXCLUSION: ['No more than 3.0 units from CISC 332/3.0; COMM 392/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 332',
      description:
        'Data models: relational, entity-relationship. Relational query languages: relational algebra and SQL. Relational database\ndesign. Application interfaces and embedded SQL. Storage and indexing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Database Management Systems',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 124/3.0 and CISC 204/3.0).\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 121': {
      EXCLUSION: [
        'No more than 6.0 units from MATH 120/6.0; MATH 121/6.0; MATH 122/6.0; MATH 123/3.0; MATH 124/3.0;\nMATH 126/6.0.'
      ],
      RECOMMENDATION: [
        'MHF4U and MCV4U or equivalent, or 4U AFIC, or MATH P06/3.0, or permission of the Department.\nEQUIVALENCY    MATH 122/6.0.\n'
      ],
      code: 'MATH 121',
      description:
        'Differentiation and integration with applications to biology, physics, chemistry, economics, and social sciences; differential\nequations; multivariable differential calculus.\n',
      NOTE: [
        'For students intending to pursue a medial or major plan in a subject other than Mathematics or Statistics.\n',
        'Also offered at the Bader International Study Centre. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential and Integral Calculus',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['262 (48L;11G;72O)\n']
    },
    'BIOL 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 350',
      description:
        'An exploration of how evolutionary thinking can affect our understanding of our lives, our species, and our ability to share\nthe planet with other species.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Evolution and Human Affairs',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'JWST 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'JWST 301',
      description:
        'Topics in Jewish Studies I\nA topic of current interest in Jewish Studies not covered in other available courses. Seminars offered by regular and visiting\nfaculty on topics related to their own research or interest. Consult the Jewish Studies website.',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'DRAM 273': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 273',
      description:
        "A practical performance course where students will actively explore historical performance styles and conventions. The\nfocus of this course will be the rehearsal of one or more plays to be presented in period acting style and costume as part of\nEngland's Medieval Fair at the culmination of the course.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medieval Performance',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\nCOREQUISITE    DRAM271/3.0.'],
      'LEARNING HOURS': ['104 (36S;32Oc;36P)\n']
    },
    'POLS 280': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 280',
      description:
        'This course analyzes the status of women and men in domestic and global politics. It presents primary concepts used in\npolitical science to address: What is gender? How is it political? How have the women\u2019s movement and other collectivities\naddressed inequality and oppression? What does gender equality look like, and how can it be obtained?\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Women, Gender and Politics',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'KNPE 454': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 454',
      description:
        'This advanced course will present the general biomechanical techniques used in clinical evaluation.  This will be followed by\nassessment techniques, how assessment is done, and how the results of assessment can be used to evaluate performance\nand the effectiveness of treatment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Clinical Biomechanics',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or 4 in a PHED Specialization or KINE Specialization Plan and (KNPE 254/3.0 or KNPE 353/3.0).'
      ],
      'LEARNING HOURS': ['132 (18L;18S;12Lb;84P)\n']
    },
    'LLCU 326': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 326/3.0; INTS 326/3.0; GRMN 426/3.0.\nEQUIVALENCY    INTS 326/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 326',
      description:
        'European film is our starting point for investigating the connections between work and art. Topics include: urban space;\n(post- and para-); socialist societies; border crossings, especially gendered labour and cultural flows. This course will\ninvestigate how the new Europe and film shape each other.\n',
      NOTE: [
        'A screening will be made available each week for viewing films.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Film in the New Europe',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L; 84P)\n']
    },
    'POLS 433': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 433',
      description:
        'Focuses on recent debates about the sources of malaise in the American system, with a special emphasis on understanding\nthe dynamics of mass public opinion and the factors influencing public disaffection from political institutions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Problems of American Democracy',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ECON 290': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 290',
      description:
        'An examination of the economic principles and practices for using environmental resources such as air, water, and natural\nenvironments. The economically optimal use of these resources is contrasted with actual uses in modern economies.\nGovernment policies are examined in theory and in practice. Cost benefit analysis is presented as a technique for evaluating\npublic sector projects using environmental resources.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Economics and Assessment',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;18G;66P)\n']
    },
    'MUSC 490': {
      EXCLUSION: [
        'No more than 3.0 units from MUSC 475/3.0 (2013-14 to 2016-17); MUSC 490/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 490',
      description:
        'In this course we explore gender, sexuality and performativity in Western popular music with an emphasis on musical\ntechnologies, musical consumption practices, and sonic and visual texts. A range of musical genres will be covered with a\nparticular emphasis on rock, pop, country, rap, and R and B.\n',
      NOTE: [
        'Not open to students who previously have taken Gender and Popular Music as a special topics course (MUSC\n475/3.0, Special Topics in Music I).\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Popular Music',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.\n'],
      'LEARNING HOURS': ['120 (36S;12O;72P)\n']
    },
    'FILM 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 250',
      description:
        'A foundation in media production techniques relevant to graphic, sound, and moving-image formats. Topics include project\ndesign, technical workflow, and the aesthetic and social aspects of screen-based media. Students undertake several group\nprojects in the first term and a major video production in the second term.\n',
      NOTE: [
        'Production supplies $250. Priority will be given to students with the highest overall GPA on FILM courses, including\nthose at the 100-level.\n',
        'Only offered online. Consult Arts and Science Online.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Media Production',
      units: '6.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization.\nFILM 260/3.0\nDigital Media Theory and Practice\nSurvey of digital media theories and online mass communication practices, with emphasis on social and mobile\ntechnologies. Course considers the impact of digitalization on the creative and culture industries.\n'
      ],
      'LEARNING HOURS': ['216 (48L;24Lb;60G;24O;60P)\n', '120 (72O;48P)']
    },
    'LLCU 308': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 308/3.0; ITLN 308/3.0; ITLN 408/3.0.\nEQUIVALENCY    ITLN 308/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 308',
      description:
        'This course will examine social, historic and political realities of the twentieth century through the lens of the unique Italian\nhumorist tradition of film making. The course will focus on films by F.Fellini, L.Comencini, E.Scola, G.Tornatore,\nG.Salvatores, N.Moretti, R.Benigni and other film makers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'From Fellini to Benigni',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;36T;48P)\n']
    },
    'CISC 322': {
      EXCLUSION: ['No more than 3.0 units from CISC 322/3.0 and CISC 326/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 322',
      description:
        'Abstractions and patterns of interactions and relationships among modules. Design recovery; relationship of architecture to\nrequirements and testing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Software Architecture',
      units: '3.0',
      PREREQUISITE: [
        'C- in (CISC 203/3.0 and CISC 204/3.0 and CISC 223/3.0 and CISC 235/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;16G;68P)\n']
    },
    'MUTH 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 320',
      description:
        'Preparation and examination of selected Lieder, music theatre, and/or opera aria repertoire in duo form for singers and\npianists. Aspects of interpretation and execution of each performance will be discussed by instructors, with additional input\nfrom class participants.\n',
      NOTE: [
        'A previous course in keyboard accompaniment or fluency in sight-reading is highly recommended for pianists taking\nthis course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Song Interpretation',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and (MUSC 121/6.0 or MUSC 124/6.0 or MUTH 210/3.0).'
      ],
      'LEARNING HOURS': ['108 (36G;72P)\n']
    },
    'PSYC 423': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 423',
      description:
        'A discussion of some areas in natural scene perception. Topics that will be discussed include: speeded processing of scene\ngist, the neural basis of scene perception, attention and eye movements, visual search and memory in real-world contexts,\nas well as some discussion of other more applied research related to the processing of real-world scenes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Real-World Scene Perception',
      units: '3.0',
      PREREQUISITE: ['PSYC 221/3.0 or PSYC 220/6.0 or COGS 200/6.0.'],
      'LEARNING HOURS': []
    },
    'HIST 243': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 243',
      description:
        'A general introduction to the history of the Crusades and holy war in the medieval period. Western, Muslim and Byzantine\nperspectives will be considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': ['May not be taken with or after HIST 430/6.0.'],
      title: 'he Crusades',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'CISC 466': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 466',
      description:
        'A continuation of CISC 365/3.0. Lower bound theory. Average-case analysis of algorithms. Approximation algorithms.\nProbabilistic algorithms. Parallel algorithms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Algorithms II',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 365/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 427': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 427',
      description:
        'An intensive examination of the major themes and controversies in European social, cultural, and political history since the\nlate 18th century. Emphasis on France, England, Germany and Russia. Topics include the social impact of the Industrial\nRevolution and urbanization; the rise of the middle class; Marxism; separate sphere ideology and feminism; nationalism;\nfascism; communism; and consumerism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'odern European Society',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'DEVS 499': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 499',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies VIII',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 325': {
      EXCLUSION: ['No more than 3.0 units from CISC 325/3.0; SOFT 325/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 325',
      description:
        'Developing usable software requires that human factors be considered throughout the design and development process.\nThis course introduces a series of techniques for development and evaluating usable software, and shows how these\ntechniques can be integrated into a process for software development.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Human-Computer Interaction',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 124/3.0 and CISC 235/3.0).\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 354': {
      EXCLUSION: [
        'HIST 400/4.5-003 (Fall Term 2016-17 and Winter Term 2015-16); HIST 400/4.5-001 (Fall Term 2014-15 and\nWinter Term 2013-14); HIST 400/4.5-002 (Winter Term 2012-13).'
      ],
      RECOMMENDATION: [],
      code: 'HIST 354',
      description:
        'This course explores the Jewish presence in the American media and how historical events affected the way in which Jews\nand Jewish issues have been represented on screen, from the beginning of Hollywood\u2019s founding to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ews on Film',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['180 (36S;36O;108P)\n']
    },
    'RELS 334': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 334',
      description:
        'A study of the tensions that come into play as Jews formulated views of the Other to balance co-existence with them.\nSource materials include authoritative writings of Jewish commentary and law and social scientific views of them.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Jewish Views of the Other',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'PHIL 256': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 256',
      description:
        'Representative figures from Kierkegaard to de Beauvoir will be the focus of attention in this overview of the main ideas of\nexistentialism, a vital movement in contemporary philosophy. The foundations of existential thought, its distinctive style of\nargumentation and its relationship to the perennial concerns of philosophy will be explored.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Existentialism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SPAN 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 502',
      description:
        'Reading courses in selected fields of Peninsular literature to meet the needs of advanced students for whom a seminar\ncourse is not available. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literatura de Espa\u00f1a: Estudios independientes',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department of Languages Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (120P)\n']
    },
    'SOCY 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 321',
      description:
        'Evaluation and use of quantitative/qualitative research methodologies as a means of exploring the validity of sociological\ntheories.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Methodology',
      units: '3.0',
      PREREQUISITE: [
        'A minimum grade of C in each of SOCY 210/3.0 and SOCY 211/3.0 and (SOCY 226/3.0 and SOCY 227/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 500': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 500',
      description:
        'An independent advanced project or thesis in any area of the basic curriculum, supervised and evaluated by faculty.\nCompleted applications must be submitted by 15 March of students\u2019 third year for Department approval. Consult faculty\nadvisers or supervisor for detailed information well in advance of the deadline.\n',
      NOTE: [
        'In addition to the prerequisites indicated below, the department may require a grade of A- in any DRAM course\nrelevant to the subject of study.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Senior Project',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and (registration in a DRAM Major or Media Plan) and (a GPA of 2.90 in DRAM) and permission of\nthe School.'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 387': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 387',
      description:
        'A study of the creative interactions between print literature and modern audio and visual media such as mass circulation\nnewspaper, radio, film, television, and digital devices.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and Modern Media',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'DRAM 371': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 371',
      description:
        'Modern Drama at the Shaw Festival\nIntensive study in the mandate and practice of the Shaw Festival in Niagara-on-the-Lake, Ontario. Students attend several\nproductions at the Shaw Festival, discussing these in seminars and with guest speakers drawn from the Shaw company\nwhere available.\n',
      NOTE: [
        'Taught in Niagara-on-the-Lake during summer Term. May be taken in conjunction with DRAM 373/3.0. Students are\nresponsible for the costs of transportation, accommodation and Shaw Festival theatre tickets.   Costs vary annually and\ndetails may be found on the Department website.   Estimated $495.00.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36S;24Oc;60P)\n']
    },
    'HIST 411': {
      EXCLUSION: ['No more than 1 course from HIST 411/4.5; HIST 410/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 411',
      description:
        "Examines the major contours of Western capitalism and the emergence of a more integrated global marketplace since 1945.\nTopics include: the rise in prosperity followed by the rise in income inequality since the 1970s; technological change; the\n'downsizing' phenomenon; related trends in social policy. A balance of pro and con literature on 'globalization' will be\nexamined.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'lobalization, Wealth and Inequality in the West since 1945',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'HIST 461': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 461',
      description:
        'Examines the history of race relations in Latin America from European contact to the present. Topics include indigenous\nresistance and adaptation to conquest, African slavery and emancipation, debates about assimilation versus cultural\nsurvival, and whether Latin America provides a unique model of race relations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ace and Ethnicity in Latin America 1492 to the Present',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MATH 418': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 418',
      description:
        'Time estimates for arithmetic and elementary number theory algorithms (division algorithm, Euclidean algorithm, congruences),\nmodular arithmetic, finite fields, quadratic residues. Simple cryptographic systems; public key, RSA. Primality and factoring:\npseudoprimes, Pollard\u2019s rho-method, index calculus. Elliptic curve cryptography.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Number Theory and Cryptography',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 210/3.0 or MATH 217/3.0) or (MATH 211/6.0 with permission of the Department).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 512': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 512',
      description:
        'Students will arrange their reading in consultation with members of the Department. They will be expected to write reports\non their readings and to discuss them throughout the term in seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'GNDS 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 312',
      description:
        'Studies in black women\u2019s and black gender politics in Canada, the U.S.A., and the Caribbean.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Black Feminisms',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'STAT 506': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 506',
      description:
        'Topics in Statistics II\nAn important topic in probability or statistics not covered in any other course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Permission of the Department.'],
      'LEARNING HOURS': ['132 (24I;108P)\n']
    },
    'ENGL 290': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 290',
      description:
        'An intensive study of one text or a cluster of related texts, cultivating close reading skills through discussion. The course\ndevelops students\u2019 writing abilities and also introduces the basic research tools of literary studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Literary Interpretation',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 and (registration in an ENGL Major or Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 259': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 259',
      description:
        'A study of the dissemination of Shakespeare\u2019s plays across a range of cultures and sites from the early seventeenth century\nto the present, with a focus on the development of Shakespeare as a \u201cglobal\u201d author. Selected plays will be studied in\nhistorical context and in geographically diverse adaptations in theatrical, print, and electronic media.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Global Shakespeare',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 409': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 409',
      description:
        'An intensive six-week introduction to archaeological methods and interpretation at a fieldwork project in Italy under the\nsupervision of a member of the Classics Department.\n',
      NOTE: ['Offered in Summer Term (May-June or July-August Session).\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology Fieldwork Practicum II',
      units: '6.0',
      PREREQUISITE: [
        '(CLST 303/3.0 or CLST 304/3.0 or CLST 305/3.0 or CLST 306/3.0) and permission of the Department.'
      ],
      'LEARNING HOURS': ['276 (160Lb;12T;48Pc;32G;24I)\n']
    },
    'ECON 241': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 241',
      description:
        'An application of economic analysis to a selection of public policy issues. The topics covered will vary from year to year but\nexamples include regulation of agricultural and industrial markets, health economics, trade policy, natural resource policy,\nproperty rights and the \u2018external\u2019 effects of private activities. This course should be of special interest to students of law,\npolitical studies and sociology as well as economics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economic Aspects of Selected Social Issues',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'PHIL 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 410',
      description:
        'This course examines issues and theorists in the History of Philosophy. Possible topics include the nature of substance,\nexplanation, causality, rights and obligations, primary and secondary qualities. Possible theorists include, Descartes,\nSpinoza, Hegel, Frege.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in the History of Philosophy',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 248': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 248',
      description:
        'An introduction to the arts and visual culture of the indigenous peoples of North America from north of the Rio Grande to\nthe Arctic, encompassing pre-history, colonialism, and the modern period. Key works from six regional zones are studied in\ntheir historical and cultural contexts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to the Indigenous Arts of North America',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 398': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 398',
      description:
        'The development of modern Jewish thought and practice, including the Reform, Orthodox, Conservative and\nReconstructionist movements. The consequences of the Holocaust and the establishment of the modern State of Israel.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Judaism in the Modern Age',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'FREN 503': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 503',
      description:
        'Research in a particular area of French Linguistics under the supervision of a professor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Recherches en linguistique',
      units: '3.0',
      PREREQUISITE: [
        'FREN 215/6.0 or (FREN 353/3.0 and FREN 373/3.0) and permission of the Chair of Undergraduate Studies\nand approval of the supervisor.'
      ],
      'LEARNING HOURS': ['120 (24I;96P)\n']
    },
    'PHIL 271': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 271',
      description:
        'A broad introduction to philosophical method and the nature of philosophical issues through a consideration of philosophic\nassumptions and theses present in important literary works.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy and Literature',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 405': {
      EXCLUSION: [
        'No more than 9.0 units from HIST 390/9.0-003 (2015-16) and HIST 405/9.0.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 405',
      description:
        'Key trends and issues in U.S. economy, society and politics such as rising inequality and falling social mobility levels;\nchanges in family structures; racial diversions; globalization, de-industrialization, and the plight of the middle class. Health,\neducation, housing, social security, welfare and tax policy examined.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '.S. Public Policy and Society since 1945',
      units: '9.0',
      PREREQUISITE: [
        'A grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ENGL 494': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 494',
      description:
        'Studies in literary topics that cross over the historical boundaries between Groups I, II, and III. For detailed information,\nconsult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Interpretation IV',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units)'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'RELS 214': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 214',
      description:
        'As religious literature expressing the witness to Jesus; and as source for the history, trends and problems of early\nChristianity.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The New Testament',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'INTS 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 312',
      description:
        'This course will offer a unique opportunity to study a special topic in Modern European Studies. Topics will vary each term,\nand the course may not be offered every year. For a detailed course description, see www.queensu.ca/bisc\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Modern European Studies I',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'DEVS 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 100',
      description:
        'Canada and the \u2018Third World\u2019\nIntroduces basic theoretical concepts of development studies, the history of global inequality, and short histories of\nalternative development strategies. Case studies of Canada\u2019s ties to the so-called third world will include missionaries,\nmilitary, business, and aid. Canadian colonialism over First Nations peoples will introduce basic issues in Aboriginal Studies.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (48L;24T;24O;144P)']
    },
    'HIST 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 415',
      description:
        'ulture and Postcolonialism in French Canada\nLooks at how questions of colonialism, hegemony and decolonization have affected major trends shaping Quebec society\nand culture in the 19th and 20th centuries. Centers on the French-speaking population and focusses on family formation,\ngender roles, the Catholic Church, popular entertainment and mentalities.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'LLCU 257': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 257/3.0; ITLN 257/3.0; ITLN 357/3.0.\nEQUIVALENCY    ITLN 257/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 257',
      description:
        'An in-depth study of Pirandello\u2019s most important dramatic works, together with analysis of his theoretical essays on\ntheatre. Particular attention will be paid to the following plays: Six Characters in Search of an Author; Each in his Own Way,\nHenry IV, The Feast of Our Lord of the Ships, The New Colony; Tonight We Improvise and The Mountain Giants.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: "Pirandello's Theatre",
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 510': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 510',
      description:
        'A critical essay of at least 7500 words on a topic of the student\u2019s choice, written under the supervision of a faculty member.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Essay',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the RELS Major Plan and permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'PSYC 332': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 332',
      description:
        'Health Psychology\nKey issues in health and health care require approaches embodying psychological, biological, and sociological factors. For\nevery CT scan, injection, or doctor visit, there is a person to be considered. This course explores a variety of health-related\ntopics where psychology has a significant role (e.g., health promotion, stress, psychoneuroimmunology, medical contacts,\npain, illness, sport). Canadian statistics used in discussions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(PSYC 235/6.0 or PSYC 236/3.0) and (PSYC 202/3.0 or 3.0 units from STAT_Options).'
      ],
      'LEARNING HOURS': []
    },
    'GNDS 345': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 345',
      description:
        'This course provides a critical interdisciplinary introduction to methods and methodological issues in gender studies\nresearch.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Methods in Gender Studies',
      units: '3.0',
      PREREQUISITE: ['Level 3 and GNDS 120/3.0 or GNDS 125/3.0'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 301',
      description:
        'Explores a range of issues in contemporary sociology. Topics may vary from year to year. See the departmental website for\nfurther details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Sociology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'EMPR 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 330',
      description:
        'Strategic HR Management: Building High Performance Workplaces\nHigh performance work systems (HPWS) refer to a series of interrelated practices in the management of human resources.\nIn this course, students will learn how to design, implement, and manage a variety of high performance work practices in\naccordance with organizational strategy and culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['EMPR 230/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 399': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 399',
      description:
        'Selected studies of the English Country house, its architecture, landscape gardens, interior design, and contents.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The English Country House',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'ARTH 352': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 253/3.0.\n'],
      code: 'ARTH 352',
      description:
        'A chronological survey of the history of printmaking in Western Europe from its beginnings in the 15th century to the\nIndustrial Revolution. Topics include the cultural impact of the reproducible image, the development of woodcut,\nengraving, etching and lithography, and the achievements of printmakers such as D\u00fcrer, Goltzius, Callot, Rembrandt,\nHogarth and Goya.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Printmaking in Early Modern Europe',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'KNPE 125': {
      EXCLUSION: [
        'No more than 1 course from IDIS 150/6.0; KNPE 125/3.0; KNPE 225/3.0; PHGY 210/6.0; PHGY 214/6.0; PHGY\n212/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 125',
      description:
        'Introduction to Human Physiology\nThis course provides an introduction to human physiology from the cellular to the systemic level with special emphasis on\nthe systems that adapt to exercise stress. The following areas will be covered: the cell, nervous system, skeletal muscle\nsystem, respiratory system, cardiovascular system, neuroendocrine system, and renal system.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 1 or above in a PHED, KINE or HLTH Plan.\n'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'RELS 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 401',
      description:
        'Advanced seminar providing detailed reading of one contemporary theme or thinker in religious studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Seminar',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a RELS Major or Medial Plan and a GPA of 2.6 in 24.0 units in RELS.\nCOREQUISITE    [RELS 354/3.0 and (RELS 255/3.0 or RELS 355/3.0)] or RELS 353/6.0.'
      ],
      'LEARNING HOURS': []
    },
    'FILM 511': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 511',
      description:
        'Open to students completing an honours concentration in Film and Media, or Stage and Screen Studies. Enables a student\nto pursue an area of study not covered in regularly offered courses. Applicants must obtain approval of the Undergraduate\nCoordinator and supervising instructor.\n',
      NOTE: [
        'To use Film and Media video equipment the student must have completed FILM 250/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Studies',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and 30.0 units in FILM or\npermission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 100': {
      EXCLUSION: ['No more than 6.0 units from DRAM 100/6.0; DRAM 181/6.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 100',
      description:
        'Introduction to the Theatre\nAn exploration of stage production, acting, directing, playwriting, theatre history, dramatic analysis and criticism through\nuse of plays chosen from various periods and representing different styles and genres. Opportunities given for practical\nprojects.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['228 (36L;36Lb;36O;120P)\n']
    },
    'FILM 430': {
      EXCLUSION: [
        'No more than one course from FILM 400/3.0-001 (2014 onward); FILM 430/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FILM 430',
      description:
        'Advanced seminar on authorship and analysis, usually concerning the work of one or two filmmakers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Authorship: Special Topic',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'ARTH 215': {
      EXCLUSION: [
        'No more than 6.0 units from  ARTH 214/3.0; ARTH 215/3.0; ARTH 213/6.0'
      ],
      RECOMMENDATION: [],
      code: 'ARTH 215',
      description:
        'A study of Renaissance art and architecture after 1500 within the context of the social, political and economic history of\nWestern Europe. Key monuments, themes and concepts will be stressed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Renaissance Art and Architecture after 1500',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHAR 230': {
      EXCLUSION: [
        'No more than 3.0 units from PHAR 230/3.0; PHAR 270/3.0; PHAR 340/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHAR 230',
      description:
        'Lecture series on the following topics: principles of drug action, autonomic pharmacology, cardiovascular-renal\npharmacology, neuropsychopharmacology, chemotherapy, drugs acting on the endocrine system, over-the-counter drugs,\nand therapeutic applications.\n',
      NOTE: [
        'Given in Winter Term and concurrently with students in the School of Nursing.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Pharmacology for the Health Sciences',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '122 (36L;8G;78P)\nCOREQUISITE    PHGY 210/6.0 or PHGY 214/6.0 or KNPE 225/3.0 or KINE 225/3.0.\n'
      ]
    },
    'CISC 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 365',
      description:
        'Principles of design, analysis and implementation of efficient algorithms. Case studies from a variety of areas illustrate\ndivide and conquer methods, the greedy approach, branch and bound algorithms and dynamic programming.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Algorithms I',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 203/3.0 and CISC 204/3.0 and CISC 235/3.0).'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 418': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 418',
      description:
        'The origin, migration and accumulation of petroleum resources, emphasizing typical reservoir styles, potential reservoir\nlithologies, methods of exploration and basic concepts of formation evaluation. Concepts and applications equip students\nwith the basic principles necessary to undertake petroleum industry exploration and production. Laboratory exercises\ninclude a major exploration problem and presentation.\n',
      NOTE: [
        'This course may not be offered every year. Consult: http://www.queensu.ca/geol/courses for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Petroleum Geology',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 238/3.0 or permission of the Department.\nCOREQUISITE    GEOL 321/3.0.'
      ],
      'LEARNING HOURS': ['129 (36L;33Lb;60P)\n']
    },
    'ITLN 204': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ITLN 204',
      description:
        'A review of the fundamentals of the Italian language, designed to reinforce and develop the student\u2019s comprehension,\nspeaking and writing ability.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Italiano intermedio',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ITLN 112/3.0.\nONE WAY '],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 349': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 349',
      description:
        'A study of nineteenth-century literature from both sides of the Atlantic. This course will explore cultural transactions\nbetween Europe and the Americas from the late eighteenth to the early twentieth century, with special attention to the\ntransatlantic dimension of literary movements such as Romanticism, Realism, and Modernism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '19th-Century Transatlantic Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'MUTH 340': {
      EXCLUSION: [
        'No more than 3.0 units from DRAM 319/3.0 (Fall 2016); MUTH 340/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUTH 340',
      description:
        'An introduction to the principles and skills necessary for a successful career in the arts centered around business aspects as\nwell as important facets of professionalism required in today\u2019s arts fields. Topics may include business practices, concert\nplanning, grant writing, promotion and publicity, and the role of supporting professionals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Arts Professionalism',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in an ARTF, ARTH, BMT, DRAM, FILM, MUSC, or STSC Plan.\n'
      ],
      'LEARNING HOURS': ['120 (36L;24O;60P)\nEQUIVALENCY    MUSC 340/3.0.\n']
    },
    'SOCY 273': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 273',
      description:
        'The social matrix of personality, socialization as a social process, the influence of social structure and culture upon\nsocialization practices, and the patterning of personality through the life cycle.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social Psychology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'BCHM 411': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 411',
      description:
        'This course concentrates on the molecular biology of mammalian models particularly mechanisms involved in human\ndiseases. The human genome project, forensic analysis, DNA diagnostics of human diseases, models of transcriptional and\ngrowth regulation and cancer, DNA repair, RNA processing and translation are all discussed. Emphasis on recent findings\nand course materials will be drawn from current reviews.\n',
      NOTE: [
        'Offered jointly with BMED 811/3.0.  Students in a LISC or BMCO Plan should contact the Department regarding\nprerequisites and permission to register.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Molecular Biology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Specialization or Major Plan) and [a GPA of 2.7 in BCHM 313/3.0, BCHM\n315/3.0, BCHM 316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 493': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 493',
      description:
        'This course examines issues in Ethics and the Environment. Possible topics include sustainable development, humans and\nnature, moral obligations to future generations.\n',
      NOTE: ['Bus fare: estimate cost $10.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Ethics and the Environment',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level) or registration in a ENVS Medial Plan or ENSC Major plan or ENSC, EGPY, EBIO, ECHM, EGEO, ELSC\nor ETOX Specialization Plan)].'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 423': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 330/3.0 or BCHM 218/3.0 or MBIO 218/3.0.\n'],
      code: 'BIOL 423',
      description:
        'An exploration into the world of insects, one of the most abundantly successful group of organisms on the earth.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': ['May not be taken with or after BIOL 507/3.0.\n'],
      title: 'Modern Insect Science',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 205/3.0 and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['120 (12L;36T;72P)\n']
    },
    'CHEM 411': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 411',
      description:
        'A discussion of recent advances in analytical chemistry and its applications to the environmental, materials and biomedical\nfields. At least four topics will be covered from sample preparation, separation methods, multidimensional\nchromatography, elemental spectroscopy, mass spectroscopy, and surface analysis methods. Additional topics will be\nselected from the current literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Analytical Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 321/3.0 or ENSC 471/3.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'MATH 335': {
      EXCLUSION: [
        'No more than 1 course from MATH 236/3.0; MATH 335/3.0; PHYS 312/6.0.\nEQUIVALENCY    MATH 236/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 335',
      description:
        'Linear input/output systems and their stability. Frequency-domain and time-domain analysis. Continuous and discrete time-\nmodeling. Fourier, Laplace, and Z-transforms. Sampling and the discrete-time Fourier transform. Application to modulation\nof communications signals, filter design, and digital sampling.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematics of Engineering Systems',
      units: '3.0',
      PREREQUISITE: ['MATH 334/3.0 and (MATH 326/3.0 or MATH 228/3.0).\n'],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'MUSC 474': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 474',
      description:
        'Advanced supervised study in a specific area of musicology/ethnomusicology, music theory/analysis or music education.\nRegulations pertaining to the courses are available in the Music Office.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Study II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and a GPA of 3.50 in MUSC at the 300-level and permission of the instructor and of the Chair of\nUndergraduate Studies.'
      ],
      'LEARNING HOURS': ['123 (6I;117P)\n']
    },
    'BIOL 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 201',
      description:
        'A survey of bacteria, algae, fungi and plants, their internal organization and their relationships to their environment.\nOrganismal biology is discussed in a phylogenetic context and the evolution of organizational complexity and the relations\nbetween structure and function are stressed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Diversity of Life I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['117 (36L;33Lb;48P)']
    },
    'MUSC 396': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 396',
      description:
        'The examination of individual instruments in the string, woodwind, brass and percussion sections. Course includes score\nanalysis, transcription, arranging and orchestration. A recommended course for B.Mus. composition students.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Orchestration',
      units: '3.0',
      PREREQUISITE: ['MUSC 191 or permission of the School.'],
      'LEARNING HOURS': []
    },
    'LLCU 328': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 328/3.0; SPAN 328/3.0; SPAN 428/3.0.\nEQUIVALENCY    SPAN 328/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 328',
      description:
        'This course will explore major themes of development in relation to gender in Latin America through its manifestation in\nfilm. Films will be chosen from all regions of Latin America, including Brazil.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Development and Film in Latin America',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 337': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 337',
      description:
        'The elements of the regional development process and regional policies. Principal theories and methods of regional\nanalysis. Assessment of strategies of regional development and the use of policy instruments in regional development\nprograms in North America and western Europe.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Regional Development Theory and Policy',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 228/3.0 and (GPHY 227/3.0 or GPHY 247/3.0 or 3.0 units in DEVS at the 200 level or above), or\npermission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 231': {
      EXCLUSION: [
        'No more than 1 course from MATH 225/3.0; MATH 226/3.0; MATH 231/3.0; MATH 235/3.0; MATH 237/3.0;\nMATH 232/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 231',
      description:
        'An introduction to ordinary differential equations and their applications. Intended for students concentrating in\nMathematics or Statistics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential Equations',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH\n124/3.0).\n'
      ],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'FILM 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 306',
      description:
        'Intermediate study of thematic and stylistic trends in recent European cinema, with reference to social and political\nchanges.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Contemporary Film in Europe',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'SOCY 354': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 354',
      description:
        'Comparative study of Canadian education system and processes in light of current sociological theory and research.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Education',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'KNPE 595': {
      EXCLUSION: [],
      RECOMMENDATION: ['HLTH 252/3.0.\n'],
      code: 'KNPE 595',
      description:
        'An independent study involving a research proposal and project on an approved topic in the area of health enhancement,\ndisease prevention, and human performance. The research proposal will be completed in the Fall Term and research\nproject in the Winter Term. Students must arrange for a full-time faculty advisor in the School of Kinesiology and\nHealth Studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis in Kinesiology and Physical Education',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan with a GPA of 3.50; permission of the supervisor\nand Undergraduate Coordinator in the School of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['252 (12I;240P)\n']
    },
    'ECON 250': {
      EXCLUSION: [
        'No more than 3.0 units from STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM 162/3.0; ECON 250/3.0; PSYC\n202/3.0; SOCY 211/3.0; BIOL 243/3.0; CHEE 209/3.0; GPHY 247/3.0; KNPE 251/3.0 or PHED 251/3.0; POLS 385/3.0; NURS\n323/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ECON 250',
      description:
        'Introduction to Statistics\nStatistical methods as used in economics. This course introduces statistical hypothesis testing and covers basic methods as\nfar as linear regression analysis.\n',
      NOTE: [
        'A grade of C in this course is required as a prerequisite for ECON 351/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'ECON 110/6.0 or (ECON 111/3.0 and ECON 112/3.0).\nCOREQUISITE    MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or (MATH 123/3.0 and MATH 124/3.0) or MATH 126/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;12I;72P)\n']
    },
    'LLCU 111': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 111',
      description:
        'This course offers an overview of the theoretical framework behind the study of intercultural communication and proposes\npractical applications of these theories, including in-class guest speakers and a 4-session workshop on Intercultural\nCompetence by the Queen\u2019s University International Centre (QUIC). Students will obtain a Certificate by QUIC.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Cultures',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12O;72P)']
    },
    'PSYC 453': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 453',
      description:
        'This seminar examines social and cognitive development during the first two years of life. Topics include the early\ndifferentiation between animate and inanimate entities, goal attribution, imitation, and prosocial behaviour.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Infancy',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 251/3.0.'],
      'LEARNING HOURS': []
    },
    'POLS 403': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 403',
      description:
        'An investigation of selected issues in gender analysis, considering a variety of perspectives and case studies. The focus of\nthis course will vary from year to year. Consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender Politics: Questions & Challenges',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 333',
      description:
        'The course explores biological contributions to society in the fields of environmental assessment and management,\nmaterials and food production, and biotechnology. Emphasis is placed on understanding of applied processes in relevant\nservice and production industries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Biology',
      units: '3.0',
      PREREQUISITE: ['BIOL 201/3.0 and BIOL 205/3.0.'],
      'LEARNING HOURS': ['108 (36L;12T;60P)\n']
    },
    'GEOL 104': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 104',
      description:
        'Introduction to the internal structure of the Earth and the processes that have shaped its surface. Global tectonics and\ncontinental movement, rock genesis, mountain building, glaciations and geological time. Laboratories include rock and\nmineral identification, and problem solving in historical geology, earthquakes, groundwater flow and coastal erosion.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Dynamic Earth',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['108 (36L;12Lb;60P)']
    },
    'HIST 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 201',
      description:
        'A survey of the social, cultural, economic, political and intellectual life of Europe from the French Wars of Religion to the\nAge of Napoleon. Topics will include religious warfare, the Scientific Revolution, state building, economic transformation,\nfamily life, popular culture, the French Revolution, and the Napoleonic Wars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'urope, 1572-1815',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'POLS 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 445',
      description:
        'A critical examination of selected \u2018new\u2019 theories of development (neo-Marxism, postmodernism, new social movements,\nrational choice, flexible specialization, etc.), followed by a study of selected Asian countries\u2019 development strategies to\nevaluate the relevance of the theories.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Dialectics of Development',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 261': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 261',
      description:
        'A discussion of some ontological and epistemological problems associated with mathematics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Mathematics',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 311': {
      EXCLUSION: ['No more than 3.0 units from DRAM 211/3.0; DRAM 311/3.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 311',
      description:
        'The history and theory of theatre conceived for audiences of young people. Students will read a variety of plays intended\nfor young audiences and consider the social and artistic issues associated with various dramatic and theatrical techniques.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theatre for Young Audiences',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan.\n'
      ],
      'LEARNING HOURS': ['120 (24L;12Pc;84P)\n']
    },
    'HLTH 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 456',
      description:
        'Independent study involving a critical review of the literature on an approved topic of specialization in Health Studies.\nStudents must arrange for a faculty advisor approved by the School of Kinesiology and Health Studies. Limited spaces are\navailable.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Survey of Research and Literature in Health Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization, KINE Specialization or (HLTH Major or Medial) Plan and permission of the\nsupervisor and Undergraduate Coordinator in the School of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['126 (6I;120P)\n']
    },
    'FREN 394': {
      EXCLUSION: ['No more than 3.0 units from FREN 394/3.0; FRST 294/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 394',
      description:
        'Montr\u00e9al Interculturel: une metropole en repr\u00e9sentation\nMontreal is a converging point for immigrants. We will explore significant texts that represent this diversity, from a migrant\nperspective or one of majority, and the political implications that arise in a pluralistic context, seeking to identify the model\nof interculturalism, and its links with notions such as hybridity adopted by migrant writers.\n',
      NOTE: [
        'This course is offered in French. Students registered in FREN 394/3.0 will read texts in their French original version\nand write their quizzes, essay and exam in French. Those registered in FRST 294/3.0 may read texts in translation, and write\ntheir quizzes, essay and exam in English. English version of PowerPoint presentations will be available on onQ. Students\nregistered should understand oral French at an intermediate level.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ITLN 357': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 257/3.0; ITLN 357/3.0; LLCU 257/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 357',
      description:
        'An in-depth study of Pirandello\u2019s most important plays, and an analysis of his theoretical essays on theatre. Particular\nattention will be paid to the following plays: Six Characters in Search of an Author; Each in his Own Way, Henry IV, The Feast\nof Our Lord of the Ships, Tonight We Improvise, The Mountain Giants.\n',
      NOTE: [
        'Taught in English together with LLCU 257/3.0. Written work and exams are in Italian. Readings in translation.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Pirandello\u2019s Theatre',
      units: '3.0',
      PREREQUISITE: ['ITLN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 210': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 210',
      description:
        'Introduction in the light of the political, cultural, and religious history of ancient Israel and Judah.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Hebrew Bible',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 226': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 226',
      description:
        'Textual analysis of narrative and other films, including examination of formal, aesthetic, and narrative techniques and\nconventions, and their production of meaning in social and political contexts.\n',
      NOTE: ['Priority will be given to FILM, STSC, and COCA students.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Inquiry',
      units: '3.0',
      PREREQUISITE: [
        '(A grade of B- in FILM 110/6.0) or (a GPA of 2.60 in FILM 104/3.0 and FILM 106/3.0) or (a GPA of 2.60 in\nBISC 100/3.0 and FILM 104/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'HIST 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 404',
      description:
        'hemes in Diaspora History\nTheoretical and methodological approaches to the study of diaspora, and the social and cultural history of diasporic\ncommunities in the early modern and modern world. Labour, trade and migration; race, religion and identity; tensions\nbetween national, imperial and diasporic formations are explored with a focus on a specific historical example.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['186 (36S;6Pc;24O;120P)\n']
    },
    'HEBR 191': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 191',
      description:
        'Provides a basic understanding of the Hebrew language as vehicle of meaning for the message of the Hebrew Bible.',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Biblical Hebrew',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'FILM 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 240',
      description:
        'Course surveys a variety of popular media forms and genres (film, TV, radio, music, novels, magazines, advertising, news,\nInternet). Introduces contemporary cultural studies analysis concerning the impact of everyday media use on the formation\nof identities, perceptions, lifestyles and communities.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Media and Popular Culture',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['108(36L;36PS;36O)']
    },
    'CLST 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 321',
      description:
        'Study of the rise of Christianity and the Christian reception of classical culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'World of Late Antiquity',
      units: '3.0',
      PREREQUISITE: ['CLST 201/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'HLTH 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 350',
      description:
        'This course examines global health from a variety of perspectives, including anthropological, epidemiological, and\nsociological, to help understand the cultural and historical patterns shaping global health inequalities. With an emphasis on\nresource-poor countries, specific topics may include infectious and non-communicable diseases, nutrition and maternal\nhealth.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Global Health',
      units: '3.0',
      PREREQUISITE: [
        '[(Level 3 or above and registration in a HLTH, KINE, or PHED Plan) or registration at the BISC] and HLTH\n101/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 336': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 336',
      description:
        'Examines the relationship between human health and built, physical, and social environments. Focus is influence of local\nenvironmental conditions on population health outcomes within the North American urban context. Policy and\nprogramming options for improving local conditions are explored.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Geography, the Environment and Human Health',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (3.0 units from BIOL 243/3.0; CHEE 209/3.0; COMM 162/3.0; ECON 250/3.0; GPHY 240/3.0;\nGPHY 247/3.0; KNPE 251/3.0; NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT\n367/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24I;24O;36P)\n']
    },
    'GPHY 309': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 309',
      description:
        'Land-use history provides insights into societal interactions with the environment and can alter contemporary ecosystem\nproperties. This integrated science, social science and humanities field course will explore the cultural and biophysical\nimportance of land-use history. Students will do cartographic, archival, and literature research at Queen\u2019s, then carry out\nfield research for two weeks.\n',
      NOTE: ['Field trips: estimated cost $350.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Integrated Field Course in Human and Physical Geography',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and registration in a GPHY Plan.'],
      'LEARNING HOURS': ['136 (20L;8S;12T;60G;12I;24P)\n']
    },
    'MUSC 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 451',
      description: 'A continuation of MUSC 351/3.0, MUSC 354/6.0.\n',
      NOTE: [
        'In addition to the prerequisites, students must submit a portfolio of compositions to the Music Office by the last\nday of classes in the Winter Term. Admission is determined through evaluation of portfolios by a Faculty jury. Submission of\na portfolio does not guarantee admission.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Acoustic Composition',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'SOCY 309': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 309',
      description:
        'Provides a critical introduction to surveillance and the emerging interdisciplinary field of Surveillance Studies. Offers an\nhistorically-grounded, theoretically-informed, and empirically-illustrated survey of the practices, technologies and social\nrelations of surveillance from different perspectives, with an emphasis on the socio-political dimensions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Surveillance and Society',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 459': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 459',
      description:
        'An examination of major issues in contemporary philosophy of language. Possible topics to be studied include: the nature\nof meaning; the relationship between language and the mind, as well as language and the world; and the syntax, semantics\nand pragmatics of natural language.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Philosophy of Language I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level) or (registration in a LING Major Plan)].'
      ],
      'LEARNING HOURS': []
    },
    'CLST 413': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 413',
      description:
        'An intensive two-week introduction to archaeological and architectural recording using photography, surveying, and 3D\nmeasurement on a site of historical importance for the Classical and Byzantine period in the Balkans under the supervision\nof a member of the Classics Department.\n',
      NOTE: ['Offered in Summer Term\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology Fieldwork Practicum IIIb',
      units: '3.0',
      PREREQUISITE: ['Level 2 and permission of the Department.'],
      'LEARNING HOURS': ['128 (12L;44Pc;44G;4I;8Oc;16P)\n']
    },
    'PHAR 416': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHAR 416',
      description:
        'An advanced study of chemical disposition and toxicity. Topics include toxicokinetics, biotransformation, metabolite-\nmediated toxicity, free radicals, the mechanism of action of toxicants, effects of toxicants on organ systems and a detailed\nexamination of selected toxic agents.\n',
      NOTE: [
        'BCHM, BIOL and BMCO students should contact the department for permission to register in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Xenobiotic Disposition and Toxicity',
      units: '3.0',
      PREREQUISITE: [
        '(PHAR 340/3.0 or BCHM 310/9.0 or BCHM 316/3.0) and (Level 4 and (registration in a LISC Specialization or\nMajor Plan or ELSC Specialization Plan) and (a GPA of 2.5).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 425': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 425',
      description:
        'lack Experience in Canada\nExamines the Black experience in Canada from the 16th to 20th centuries. Topics include slavery, the arrival of the Black\nLoyalists, the migration of fugitive slaves, abolitionism, creation of Black communities and institutions. Twentieth century\nthemes include military and labour participation, social activism, Caribbean migration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'RELS 226': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 226',
      description:
        'Historical and topical survey of Islam, its development through the study of its rise, institutionalization of its beliefs and\npractices, formation of its theology, law, mysticism; as well as its modern interpretations and practices.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Islam',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FRST 294': {
      EXCLUSION: ['No more than 3.0 units from FREN 394/3.0; FRST 294/3.0.'],
      RECOMMENDATION: [],
      code: 'FRST 294',
      description:
        'Montreal is a converging point for immigrants. We will explore significant texts that represent this diversity, from a migrant\nperspective or one of majority, and the political implications that arise in a pluralistic context, seeking to identify the model\nof interculturalism, and its links with notions such as hybridity adopted by migrant writers.\n',
      NOTE: [
        'This course is offered in French. Students registered in FREN 394/3.0 will read texts in their French original version\nand write their quizzes, essay and exam in French. Those registered in FRST 294/3.0 may read texts in translation, and write\ntheir quizzes, essay and exam in English. English version of PowerPoint presentations will be available on onQ. Students\nregistered should understand oral French at an intermediate level. The Department recommends students take a\nplacement test.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Montreal: Interculturalism in Representation',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 259': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 259',
      description:
        'A discussion of the general principles of reasonable discourse, with a focus on persuasive and cogent writing.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Thinking',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'DRAM 373': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 373',
      description:
        'Intermediate acting course in which a variety of techniques and exercises will be used to explore selected dramatic texts\ndrawn from the mandate of the Shaw Festival - mainly plays written during the lifetime of George Bernard Shaw (1856 to\n1950).\n',
      NOTE: [
        'Taught in Niagara-on-the-Lake during Summer Term.  Students are responsible for the costs of transportation,\naccommodation and theatre tickets.   Costs vary annually and details may be found on the Department website.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Scene Study at the Shaw Festival',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and (3.0 units from DRAM\n331/3.0; DRAM 332/3.0; DRAM 339/3.0).\nCOREQUISITE    DRAM 371/3.0.'
      ],
      'LEARNING HOURS': ['104 (36S;32Oc;36P)\n']
    },
    'PHIL 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 201',
      description:
        'The relationship between philosophical traditions and medical theory will be explored, as will the impact on philosophy of\nmedical discoveries (such as anaesthesia and antibiotics) and diseases (such as the Black Death and AIDS). Emphasis is on\nconcepts of disease from antiquity to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy and Medicine',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 370': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 370',
      description:
        'A study of poetry, prose, and drama from the mid-twentieth century to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'RELS 394': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 394',
      description:
        'Examines Chinese and foreign religions in mainland China from 1949 to the present day. Topics include the status of\nestablished religions, the political control of new religious movements and the resurgence of traditional Chinese religions\nand ideologies including Daoism and Confucianism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Politics in Contemporary China',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'ENGL 234': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 234',
      description:
        'A study of this relatively modern genre with emphasis on methods of close textual analysis of European, British, and North\nAmerican texts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Short Story in English',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 413': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 413',
      description:
        'An introduction to the study of systems of polynomial equations in one or many variables. Topics covered include the\nHilbert basis theorem, the Nullstellenstaz, the dictionary between ideals and affine varieties, and projective geometry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Algebraic Geometry',
      units: '3.0',
      PREREQUISITE: ['MATH 210/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'KNPE 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 331',
      description:
        'The care and prevention of common athletic injuries with emphasis placed on the practical portion of taping and wrapping\nof athletic trauma.\n',
      NOTE: ['Lab materials: estimated cost $15.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Care and Prevention of Athletic Injuries',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED or KINE Plan and ANAT 315/3.0 and ANAT 316/3.0.'
      ],
      'LEARNING HOURS': ['120 (24L;24Lb;72P)\n']
    },
    'DRAM 351': {
      EXCLUSION: ['No more than 1 course from DRAM 350/6.0; DRAM 351/3.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 351',
      description:
        'Continuation of DRAM 251/3.0. An intermediate study of playwriting and dramaturgy, including exercises in dramatic\ntechniques and composition of original works.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Playwriting and Dramaturgy III',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a DRAM Major or Medial Plan, or COCA-CODR Sub-Plan, or STSC Specialization\nPlan) and (a grade of B- in DRAM 251/3.0) and (a GPA of 2.60 in DRAM) or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHAR 270': {
      EXCLUSION: [
        'No more than 3.0 units from PHAR 230/3.0; PHAR 270/3.0; PHAR 340/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHAR 270',
      description:
        'This course introduces the basic principles in clinical applications of pharmacology. Topics covered include the general\nprinciples of drug therapy, the use of therapeutics in the nervous, cardiovascular, respiratory, endocrine and\ngastrointestinal systems and drugs used in infection, inflammation and cancer.\n',
      NOTE: [
        'Only offered online. Consult Arts and Science Online.\n',
        'May not be taken for credit towards the Plan requirements of the LISC Specialization or Major Plans.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Pharmacology and Therapeutics',
      PREREQUISITE: ['One of PHGY 210/6.0 or PHGY 214/6.0 or KNPE 225/3.0.\n'],
      'LEARNING HOURS': ['114 (36O;78P)\n']
    },
    'MUTH 387': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 387',
      description:
        'The course examines research and research methodologies that underpin the discipline.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research in Performing Arts Education',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a BMT or DRAM or MUSC Plan.'
      ],
      'LEARNING HOURS': ['120 (36G;12O;72P)\n']
    },
    'IDIS 210': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 210',
      description:
        'A broad-ranging introduction to the role arts play in human society with a focus on contemporary production and research.\nThrough a series of guest speakers, students will engage with the arts\u2019 living practices embedded in social interaction\naddressing topics as wide-ranging as aesthetics, politics, race, representation, critical theory, and identities.\n',
      NOTE: [
        'Students will be required to attend a variety of arts events outside class time which may include concerts, gallery\nexhibitions, performances, film screenings.\n',
        'Field trips: estimated cost $75.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Arts in Society',
      units: '3.0',
      PREREQUISITE: ['Level 2.'],
      'LEARNING HOURS': ['108 (36L;24O;48P)\n']
    },
    'HLTH 493': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 493',
      description:
        'Advanced Topics in Health Studies I\nHonours level courses exploring advanced topics that are current and/or of special interest in the area of health studies.\nStudents should check with the School of Kinesiology and Health Studies regarding availability of these courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization, KINE Specialization or (HLTH Major or Medial) Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DRAM 375': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 375',
      description:
        'A survey of selected topics concerning women\u2019s participation in international theatre. Emphasis will be on historical,\npractical and theoretical inquiry and application of feminist methodologies in such work.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Women and Theatre I',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a DRAM or GNDS Major or Medial Plan, or COCA-CODR Sub-Plan, or STSC\nSpecialization Plan) and (a GPA of 2.60 in DRAM) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'HLTH 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 323',
      description:
        'Basic methods involved in researching the distribution and determinants of health and disease in populations. Core\nmeasurement (rates, standardization, impact, association) and interpretation (bias, confounding, interaction, chance) issues\nare covered. The course also examines epidemiological approaches to study design including descriptive (cross-sectional and\necological), observational (case-control and cohort), and experimental (randomized controlled trials) approaches. Restricted to\nstudents in a concentration in health studies, kinesiology or physical and health education.\n',
      NOTE: [
        'Restricted to students in a HLTH, KINE, or PHED Plan. Limited spaces are available to students in the LISC(H) and\nBCHM(H) Plans.\n'
      ],
      'ONE-WAY EXCLUSION': ['May not be taken with or after: EPID 301/3.0.'],
      title: 'Epidemiology',
      units: '3.0',
      PREREQUISITE: [
        '[(KNPE 251/3.0 or STAT_Options) and HLTH 252/3.0] or [STAT_Options and registration in a LISC(H) or\nBCHM(H) Plan].\n'
      ],
      'LEARNING HOURS': ['120 (24L;6T;6G;84P)\n']
    },
    'ENSC 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 420',
      description:
        'This course considers feminist approaches to environmental issues in western and non-western contexts, with attention to\nboth theories and activism.\n',
      NOTE: [
        'This course is recommended for students in Environmental Studies, Gender Studies, Development Studies or Health\nStudies.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Environments',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'GPHY 325': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 325',
      description:
        'A critical study of cartographic representation from the pre-modern era up to and including the political, social, military,\nand economics roles of maps and geospatial data in the contemporary world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Maps and Society',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 111': {
      EXCLUSION: [
        'No more than 1 course from MATH 110/6.0; MATH 111/6.0; MATH 112/3.0.'
      ],
      RECOMMENDATION: ['At least one 4U mathematics course.\n'],
      code: 'MATH 111',
      description:
        'An introduction to matrices and linear algebra. Emphasis on applications to biological and economic systems and to\ncomputer applications. Topics covered will include systems of equations, eigenvalues, recursions, orthogonality, regression\nanalysis, and geometric transformations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Linear Algebra',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'POLS 412': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 412',
      description:
        'Content varies from year to year; consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Provincial Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 244': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 244',
      description:
        'A comparative exploration of the apparent disjuncture between the normative assumptions of liberal democratic theory\nand the realities of democracy-building.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Politics: Democracy and Democratization',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'POLS 327': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 327',
      description:
        'An examination of key issues in comparative politics. Topics will vary from year to year; consult department homepage.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Comparative Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 160': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 160',
      description:
        'This course is designed to promote interest in and understanding of modern prose fiction by introducing students to a\nselection of the best novels and short stories of the 20th century. British, American, and Canadian authors are represented.\n',
      NOTE: [
        'Enrolment is limited to students not registered in an ENGL Plan. This course cannot be counted toward an ENGL\nPlan nor used as a prerequisite for upper-year ENGL courses.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern Prose Fiction',
      units: '6.0',
      PREREQUISITE: ['Level 2 or above, or permission of the Department.'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'MICR 121': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 121',
      description:
        'This course provides the student with a foundation in the subdisciplines of bacteriology, virology, parasitology, and\nimmunology. The course is designed to examine common infectious diseases through a body-systems approach. Laboratory\nand tutorial sessions emphasize diagnostic microbiology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after MICR at the 200-level or above.'
      ],
      title: 'Microbiology for Nursing Students',
      units: '3.0',
      PREREQUISITE: ['BCHM 102/3.0.\n'],
      'LEARNING HOURS': []
    },
    'MATH 112': {
      EXCLUSION: [
        'No more than 1 course from MATH 110/6.0; MATH 111/6.0; MATH 112/3.0.'
      ],
      RECOMMENDATION: ['At least one 4U mathematics course.\n'],
      code: 'MATH 112',
      description:
        'A brief introduction to matrix algebra, linear algebra, and applications. Topics include systems of linear equations, matrix\nalgebra, determinants, the vector spaces Rn and their subspaces, bases, co-ordinates, orthogonalization, linear\ntransformations, eigenvectors, diagonalization of symmetric matrices, quadratic forms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Linear Algebra',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GNDS 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 445',
      description:
        'Examines feminist ethnography and queer ethnography as distinct subfields, areas of inquiry, writing genres and ethical\nmethods in research and social life. Topics: historical uses of ethnography and feminist/queer/trans critiques of them;\nadaptations of ethnography to trans, queer, and feminist work; ethnography\u2019s importance to gender studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Feminist and Queer Ethnography',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a GNDS Major or Medial or SXGD Plan, or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['240 (12L;24S;36G;168P)\n']
    },
    'HIST 481': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 481',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'PSYC 202': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0 (formerly\nPHED 251/3.0); NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM\n162/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 202',
      description:
        'An introduction to descriptive and inferential statistics in psychology. Topics will include descriptive statistics, probability,\ncorrelation and regression, experimental design and one-way ANOVA.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Statistics in Psychology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of B- in PSYC 100/6.0 and (registration in a PSYC Major or Medial or Specialization Plan).\n'
      ],
      'LEARNING HOURS': []
    },
    'ARTF 265': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 120/6.0.\n'],
      code: 'ARTF 265',
      description:
        'An intermediate studio practice course exploring the practical and pedagogical aspects of print-based artwork, processes\nand strategies, as well as the resulting theoretical implications that have accompanied recent technological changes in\nproduction and distribution.\n',
      NOTE: ['Only available to students in the Faculty of Education.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Studies in Studio Practice',
      units: '3.0',
      PREREQUISITE: [
        'ARTF 101/3.0 or ARTF 102/3.0 or permission of the instructor.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 482': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 482',
      description:
        'An examination of key issues in the political economy of public policy. Topics will vary from year to year; consult the\ndepartmental homepage.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Public Policy',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 326': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 326',
      description:
        'Introduction to phonetics, the International Phonetic Alphabet and voice physiology together with a study of the rules of\npronunciation in English, Italian, French and German. Emphasis on active skills, singing and discussion. Highly recommended\nfor all voice students and students planning graduate study in voice, choral conducting or collaborative piano.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Lyric Diction',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and permission of the School.\nEQUIVALENCY    MUSC 226/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 425': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 425',
      description:
        'Consult the Department for possible offerings in any given year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Sociology I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'A course which combines study of the history and theory of documentary film with the production of documentary': {
      EXCLUSION: [
        'No more than one course from FILM 355/6.0; FILM 360/3.0.\nFILM 356/3.0\nAnimation Production\nA combined study of the history and theory of film animation with the production of animated films. Requirements will\ninclude both research essays as well as the conceptualization and production of an animated film.\n'
      ],
      RECOMMENDATION: [],
      code:
        'A course which combines study of the history and theory of documentary film with the production of documentary',
      description:
        'videos. Requirements will include both research essays as well as the conceptualization and production of a documentary video or\nfilm.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n',
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Documentary Theory and Practice',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and FILM 250/6.0 and 6.0 units in\nFILM.\n'
      ],
      'LEARNING HOURS': ['240 (36L;36S;48Lb;48G;72P)\n']
    },
    'IDIS 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 304',
      description:
        'An interdisciplinary introduction to the broad development of British life and culture, focusing on British national identity.\nThe course usually combines British art history, history, literature and geography.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'British Studies I',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'PSYC 399': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 399',
      description:
        'Lecture courses on selected topics in psychology offered periodically.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Psychology II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'PSYC 570': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 570',
      description:
        'Laboratory courses to be arranged in consultation with individual members of the Department. Courses must involve data\ncollection; approximately 5-7 hours of lab work per week required.\n',
      NOTE: [
        'Students whose research involves the care and/or handling of animals must also complete the Introductory Animal\nCare Course and if required the appropriate Animal Use workshops through the Office of the University Veterinarian.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Laboratory I',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the instructor and of the Chair of Undergraduate Studies and Level 3 or above and\nregistration in a PSYC Major, Medial or Specialization Plan.'
      ],
      'LEARNING HOURS': ['117 (78Lb;39P)\n']
    },
    'MUSC 324': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 320/6.0; MUSC 321/6.0; MUSC 324/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 324',
      description: 'Continuation of MUSC 224/6.0.\n',
      NOTE: ['Open to non-B.Mus. students only.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Music',
      units: '6.0',
      PREREQUISITE: ['A grade of B- in MUSC 224/6.0.\n'],
      'LEARNING HOURS': []
    },
    'ENGL 231': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 231',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Genre I',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 477': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 477',
      description:
        'An intensive analysis of a particular topic within a specific area of music. Topics vary by year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Music III',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and permission of the School.'],
      'LEARNING HOURS': ['120 (24S;12G;24O;60P)\n']
    },
    'ENSC 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 310',
      description:
        'This course introduces political science and public policy within the context of environmental politics, policy, and\nadministration. The purposes of policy, the makers of policy, and the tools at their disposal will be analyzed within the\ninstitutional context of environmental policy-making.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Policy',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above, or permission of the School.'],
      'LEARNING HOURS': ['132 (24L;12T;36O;60P)\n']
    },
    'HIST 482': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 482',
      description:
        'An examination of historiography aspects of medical history including History and Philosophy, old and new subjects, old and\nnew methods, old and new text styles. Students may orient readings to focus either on specific periods and places or on\nbroad trends in History.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Historiography of Medicine',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'GPHY 332': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 332',
      description:
        'Contemporary community planning and urban development from the perspectives of social sciences, planning and real\nestate development. Emphasis on understanding actors in the process and creating projects that are socially,\nenvironmentally and economically sustainable. Informed by international perspectives, but focused on Canadian cities.\n',
      NOTE: ['Case Materials: Approximate $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Cities and Planning for Sustainable Development',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 227/3.0 and (GPHY 228/3.0 or GPHY 229/3.0 or DEVS 230/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 245': {
      EXCLUSION: [
        'No more than 6.0 units from ENGL 244/3.0; ENGL 245/3.0; ENGL 360/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 245',
      description:
        'A study of the form and technique in modern poetry and plays by such writers as Yeats, Eliot, Auden, Shaw, Beckett.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern British Poetry and Drama',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 106': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 106',
      description:
        'The relationship between human-kind and our ever-changing planet, with a focus on natural geologic hazards (volcanic\neruptions, earthquakes, landslides, tsunamis, mass movement, floods, extraterrestrial impacts, etc.), and environmental\nimpacts which result from population and land-use expansion and our increased use of water, energy and mineral\nresources. A study of the sources and impact of pollution and global climate change. Public perception of and response to\ngeological risk.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Geology and Natural Hazards',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12O;72P)']
    },
    'ENGL 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 100',
      description:
        'Introduction to Literary Study\nAn introduction to literary study, with an emphasis on the formal analysis of a diverse range of poetry and prose. Specific content\nand approach vary from section to section, but all sections share the goals of developing sensitivity to genre, cultivating writing\nskills, and providing students with a set of literary terms and critical techniques as a foundation for further literary study.\n',
      NOTE: [
        'Enrolment preference is given to first-year students.\n',
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (48L;24T;168P)']
    },
    'ENGL 499': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 499',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Criticism and Theory IV',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHIL 454': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 454',
      description:
        'Topics in Feminist Philosophy\nThis course examines issues in Feminist Philosophy. Possible topics may include gender and sex; feminist ethics,\nepistemologies and metaphysics; disputes about essentialism; the intersections of gender, sexuality, racialization,\nimperialism, and class.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level) or (registration in a GNDS Major Plan)].'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 387': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 387',
      description:
        'Critical study of conceptual, empirical, and theoretical bases to sociological approaches to crime and delinquency; Canadian\nresearch emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Crime and Delinquency',
      units: '3.0',
      PREREQUISITE: ['SOCY 275/3.0 or SOCY 274/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENSC 407': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 407',
      description:
        'Increasing demands on water resources and widespread pollution of surface and groundwater has led many experts to\npredict a looming water crisis. This course will develop a global perspective on issues that include water distribution,\nmanagement, pollution, conservation, conflict and policy. This course will be of interest to students in science, applied\nscience or the humanities.\n',
      NOTE: ['Field trip: estimated cost $50.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Global Water Issues',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'PSYC 350': {
      EXCLUSION: [
        'No more than 3.0 units from PSYC 350/3.0; PSYC 353/3.0; PSYC 457/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 350',
      description:
        'Lecture courses on selected topics in the area of developmental psychology offered periodically.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Developmental Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 251/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LLCU 327': {
      EXCLUSION: ['No more than 3.0 units from LLCU 327/3.0; GRMN 427/3.0.'],
      RECOMMENDATION: [],
      code: 'LLCU 327',
      description:
        'The course investigates German cultural images and metaphors of disease, with an emphasis on the evolution of normalcy.\nWe will study representations of disease (photography, museum exhibit, literary text), their historic development, and\ntheories of media with respect to both historical and contemporary notions of sickness and health.\n',
      NOTE: ['Readings are in translation.\n'],
      'ONE-WAY EXCLUSION': [],
      title:
        'Sickness and Health \u2013 Cultural Representations in Medical Discourse',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['114 (36L;6O;72P)\n']
    },
    'HLTH 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 315',
      description:
        'This course provides an overview of models and theories of health behaviour change at varying levels of practice and\nanalysis, including individual, intrapersonal, group, and community influences on health behaviour. Students will learn how\ntheories are applied in health promotion interventions in a variety of settings, with a variety of populations, and for a\nvariety of health behaviours.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory and Practice of Health Behaviour Change',
      units: '3.0',
      PREREQUISITE: [
        'PSYC 100/6.0 and (3.0 units from HLTH 205/3.0; KNPE 265/3.0; PHED 165/3.0) and registered in a HLTH,\nKINE or PHED Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 102',
      description:
        '330/3.0; BIOL 334/3.0; BIOL 339/3.0; BIOL 341/3.0\nBIOL 401/3.0\nExperimental Approaches to Animal Physiology\nLaboratory-based course emphasizing experimental approaches to understanding the principles of animal physiology\ncovered in BIOL 339/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'BIOL_FNDS',
      PREREQUISITE: [
        'A minimum GPA of 2.0 in the Biological Foundations List.\nCOREQUISITE    BIOL 339/3.0.'
      ],
      'LEARNING HOURS': ['108 (36Lb;12T;60P)\n']
    },
    'GNDS 510': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 510',
      description:
        'In consultation with the Head of the Department, students arrange their reading with individual Gender Studies faculty, and\nare expected to write reports on their readings and to discuss them throughout the term with that faculty supervisor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above and registered in a GNDS Major or Medial or SXGD Plan or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['240(15I;225P)\n']
    },
    'MATH 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 497',
      description:
        'An important topic in mathematics not covered in any other courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Mathematics IV',
      units: '3.0',
      PREREQUISITE: [
        'Prerequisites vary depending on specific course content; consult instructor or departmental webpage.'
      ],
      'LEARNING HOURS': []
    },
    'ENIN 207': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 207',
      description:
        'This course illustrates the concept of disruptive technology \u2013 where the pace of technological progress easily exceeds the\nrate of performance improvement that customers in a market demand. The cases we will cover highlight the implications of\nsuch innovation on the research, design, promotional, and business strategies involved.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Envisioning Disruptive Technologies',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (72O;48P)\n']
    },
    'MUSC 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 445',
      description:
        'Intensive study of a particular style or method of analysis, usually of a specific musical genre.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Advanced Analysis',
      units: '3.0',
      PREREQUISITE: ['MUSC 392/3.0 or permission of the School.'],
      'LEARNING HOURS': ['126 (36S;12O;78P)\n']
    },
    'BIOL 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 445',
      description:
        'The current status of research in the study of the neural control of the natural behaviour of animals. Topics include the\ndetection and coding of information in the environment, the integration of this information in the process of decision-\nmaking, the generation of the motor patterns that underlie behaviour, and general constraints on form and function of\nneural circuits.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Neuroethology',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 339/3.0 or PHGY 214/6.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['126 (36L;18T;24O;48P)\n']
    },
    'RELS 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 501',
      description:
        'Reading courses on topics not covered in other available courses, arranged with individual members of the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the RELS Major Plan and permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 294': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 294',
      description:
        'The history of violence and attempts at peacemaking in the Arab-Israel conflict, from its beginnings in the twilight years of the\nOttoman Empire to the \u2018Oslo (1993) peace process\u2019 and the outbreaks of autumn 2000. The impact of this conflict on regional\nsecurity.\n',
      NOTE: [
        'Offered also as a Cognate course in the Program in Jewish Studies.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'rab-Israeli Conflict and Regional Security',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 435',
      description:
        'lobal, World, and Transnational History\nAn exploration of the theory, historiography and methodologies of the sub-discipline of World History, with particular\nemphasis on the defining debates of the field. Topics include: World Systems Theory, the environment and biological\nprocesses as organizing principles, rise of the West, periodization in World History, and Big History.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'ARTH 395': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 395',
      description:
        'Students in Art History and Fine Art can apply to take a practical internship in a museum or gallery, where they would\nundertake research or curatorial activities. All internships must be approved in advance by written application to the\nUndergraduate Chair. Approval will depend on the quality of the proposal and the academic record of the applicant.\nStudents are required to write a report about their experience and are evaluated jointly by the employer and a faculty\nmember from the Department of Art. It is the responsibility of students to arrange internships.\n',
      NOTE: [
        'Depending on location, substantial travel and subsistence costs may be involved.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Internship',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in an ARTH or ARTF Major or Medial Plan and permission of the\nDepartment.'
      ],
      'LEARNING HOURS': []
    },
    'MICR 436': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 436',
      description:
        'A detailed description of the processes of heredity in bacteria including a discussion of gene structure and evolution, gene\nexpression and its control, the exchange of genetic material in the microbial world and genetic engineering and its\napplications. The laboratory component will emphasize modern approaches to genetic engineering.\n',
      NOTE: ['Offered in alternate years to MICR 435/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Microbial Genetics',
      units: '3.0',
      PREREQUISITE: [
        ' BIOL 205/3.0 and (MICR 221/3.0 or MICR 229/3.0 with a minimum grade of B) and (Registration in the LISC\nMajor or Specialization Plan) and (a GPA of 2.5).\nCOREQUISITE    BCHM 310/9.0 or BCHM 315/3.0 or BIOL 334/3.0.'
      ],
      'LEARNING HOURS': ['132 (12L;12S;36Lb;12T;60P)\n']
    },
    'HIST 212': {
      EXCLUSION: [
        'No more than 1 course from HIST 212/3.0, HIST 501/6.0, HIST 502/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 212',
      description:
        'Offers credit for non-academic work in historical practice. Examples include but are not limited to work in museums,\narchives, historic sites, NGOs, etc. Several internships are negotiated and advertised by the Department. Student-initiated\nproposals will also be considered. After the work has been completed, a ten-page report is required.\n',
      NOTE: [
        "This course may be taken only once during a student's degree program.\n"
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'xperiential Learning in Historical Practice',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above and permission of the Department.\n'],
      'LEARNING HOURS': ['130 (130Oc)\n']
    },
    'ENGL 356': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 356',
      description:
        'A study of British nineteenth-century fiction featuring selected writers from Jane Austen to Thomas Hardy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'British Fiction of the 19th Century',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 253': {
      EXCLUSION: [
        'No more than 1 course from HIST 213/6.0; HIST 253/3.0; HIST 240/6.0 (2013-14).'
      ],
      RECOMMENDATION: [],
      code: 'HIST 253',
      description:
        'An introduction to the history of social welfare and public policy in Western Europe and North America. Topics include\nhealth care and public assistance; employment, pension and education policy; economic and urban planning. A major\ntheme of the course is the emergence and development of civil, political, economic and social \u2018rights\u2019.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History of Public Policy',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 237': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 237/3.0; DRAM 238/3.0; DRAM 239/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 237',
      description:
        'A practical introduction to the fundamental skills and techniques of acting, involving an appreciation of the\ninterdependence of the actor\u2019s body, voice, intellect, feeling, and cultural context.\n',
      NOTE: ['Priority enrollment given to students in a DRAM or STSC Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Elementary Acting I - The Actor\u2019s Instrument',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan.\n'
      ],
      'LEARNING HOURS': ['120 (18Lb;18Pc;84P)\n']
    },
    'CISC 423': {
      EXCLUSION: ['No more than 3.0 units from CISC 423/3.0; SOFT 423/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 423',
      description:
        'Software Requirements\nAn integrated approach to discovering and documenting software requirements. Identification of stakeholders; customer,\noperator, analyst, and developer perspectives. Requirements elicitation. Transition from initial (informal) requirements to\nsemi-formal and formal representations. Requirements analysis process; analysis patterns. Requirements specification\ntechniques. Relation to architecture and user interface design; traceability of requirements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'C- in (CISC 322/3.0 or CISC 326/3.0).\nCOREQUISITE    CISC 325/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 491': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 491',
      description: 'Content varies. Not offered every year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Computing Science II',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'DRAM 242': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 242',
      description:
        'Introduction to Theatre Production\nA theoretical and practical introduction to theatre production including various elements of design construction, costume,\nproperties, lighting and sound systems and equipment.\n',
      NOTE: [
        'Preference will be given to students registered in a DRAM Plan or who require this course for their plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['A grade of B- in (DRAM 240/3.0 or FILM 250/6.0).'],
      'LEARNING HOURS': ['120 (18S;18Pc;84P)\n']
    },
    'LATN 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 421',
      description:
        'Selected works of Latin prose, usually drawn from oratory, history, and philosophy, read in the original Latin and\ncommented upon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with LATN 321/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Latin Prose',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in LATN 321/3.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['141 (36L;105P)\n']
    },
    'ENGL 467': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 467',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Modern/Contemporary Canadian Literature II',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in an ENGL Major or Medial Plan and a GPA of 2.4 on all ENGL units and ENGL 200/6.0 and\nENGL 290/3.0) or permission of the department.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CISC 282': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 282',
      description:
        'This course surveys current best practices for implementing attractive, usable, secure and maintainable web applications.\nOther issues considered include: accessibility, platform and browser independence, licensing of intellectual property,\nscalability, user privacy, and using web technologies in mobile development.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Web Development',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 and [(C- in CISC 101/3.0 or CISC 110/3.0 or CISC  121/3.0)] or permission of the Instructor.\nEQUIVALENCY    CISC P82/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;48O;36P)\n']
    },
    'MATH 439': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 439',
      description:
        'Geometric modeling, including configuration space, tangent bundle, kinetic energy, inertia, and force. Euler-Lagrange\nequations using affine connections. The last part of the course develops one of the following three applications: mechanical\nsystems with nonholonomic constraints; control theory for mechanical systems; equilibria and stability.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Lagrangian Mechanics, Dynamics, and Control',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 231/3.0 or MATH 237/3.0) and (MATH 280/3.0 or MATH 281/3.0), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'MUSC 229': {
      EXCLUSION: ['No more than 3.0 units from MUSC 229/3.0; MUSC 228/3.0.'],
      RECOMMENDATION: ['MUSC 292/3.0 and MUSC 293/3.0.\n'],
      code: 'MUSC 229',
      description:
        'A comprehensive keyboard musicianship course in a laboratory format specifically designed for keyboard majors and others\nreceiving advanced placement. Course content will include practical instrument-specific activities for pianists.\n',
      NOTE: [
        'Course content will support and coordinate with the traditional diatonic harmonic material covered in MUSC 191\nbut will also include other styles. Successful completion of the course will require a working fluency at the keyboard in\nsight-reading, melodic and harmonic analysis as well as transcription. Activities will include harmonization, transposition\nand improvisation.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Keyboard Lab',
      units: '3.0',
      PREREQUISITE: ['MUSC 129/3.0 or Permission of the School.\n'],
      'LEARNING HOURS': ['120 (24Lb;96P)\n']
    },
    'COMP 390': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COMP 390',
      description:
        'A Computing Internship involves spending twelve to sixteen months in a paid internship position in the private or public\nsectors. Students in a 12-month internship register in COMP 390/6.0 and either COMP 391/3.0 or COMP 392/3.0, or all of\nCOMP 393/3.0, COMP 391/3.0 and COMP 392/3.0. Students in a 16-month internship register in COMP 390/6.0, COMP\n391/3.0 and COMP 392/3.0. The Internship Coordinator must be satisfied that the work carried out has educational merit.\nSuccessful completion of the course requires submission of a satisfactory report on the experience within thirty days of\ncompletion of the work period. The Internship Coordinator is responsible for evaluating the report. The QUIP program\nincludes prior workshops on interviewing, resum\u00e9 preparation and work performance. Career Services manages the non-\nacademic aspects of the program.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computing Internship I',
      units: '6.0',
      PREREQUISITE: [
        'GPA of 1.90 and Level 2 or 3 and registration in a Bachelor of Computing internship plan (BMCO-I-BCH or\nCOGS-I-BCH or COMA-I-BCH or COMP-I-BCH or CSCI-I-BCH or SODE-I-BCH).'
      ],
      'LEARNING HOURS': []
    },
    'CLST 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 304',
      description:
        'Intensive study of the achievements in architecture, painting and sculpture, and town planning from 480 B.C. to 31 B.C.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology of the Classical World and Hellenistic Period',
      units: '3.0',
      PREREQUISITE: [
        '(CLST 102/3.0 and CLST 103/3.0) or CLST 129/6.0 or CLST 200/3.0 or CLST 101/6.0 or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PHIL 470': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 470',
      description:
        'An examination of major issues in the philosophy of science. Possible topics to be considered include explanation, realism\nversus instrumentalism scientific progress, the social dimensions of science and the unity of the sciences.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Philosophy in Science',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'KNPE 367': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 367',
      description:
        'This course looks at the ways that notions of fitness are tied to historically specific ideas about the body. The course focuses\non ideas about race, class, gender, ability and sexuality while addressing the politics of fitness and exercise and their\nrelationship to social, economic, and cultural institutions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fitness, the Body and Culture',
      units: '3.0',
      PREREQUISITE: [
        'KNPE 167/3.0, or (SOCY 226/3.0 and SOCY 227/3.0) or SOCY 221/6.0.'
      ],
      'LEARNING HOURS': ['129 (36L;9Lb;84P)\n']
    },
    'POLS 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 101',
      description:
        'An examination of current political issues. By examining an issue or problem students will be exposed to political\ninstitutions, processes and concepts in political science. The subject matter will change depending on the instructor and\ncurrent political events.\n',
      NOTE: [
        'This course does not lead to further courses in Political Studies. Not available for credit towards any POLS Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Issues in Politics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;12Oc;72P)']
    },
    'LLCU 206': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 206',
      description:
        'This course examines cities from a cultural perspective, focusing through film to see how different urban spaces have, at\ndifferent moments in time, been incubators of great social changes. It seeks to understand why, when, and with what result\nsuch upheavals occur.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Rebel Cities',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 113': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 112/6.0 or (CHEM 113/3.0 and CHEM 114/3.0).'
      ],
      RECOMMENDATION: ['4U Chemistry.\n'],
      code: 'CHEM 113',
      description:
        'A quantitative treatment of chemical phenomena and materials. Critical thinking and problem solving are emphasized.\nTopics include atomic structure and molecular bonding, organic chemistry, polymers, proteins, and condensed phases.\n',
      NOTE: [
        'Only offered online. Consult Arts and Science Online.\n',
        'Not appropriate for pre and upper level courses that have a laboratory component.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'General Chemistry I: From Atoms to Matter',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['126 (54O;72P)\n']
    },
    'ENGL 446': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 446',
      description:
        'Studies of 19th-century literature produced in the Americas (Canada, United States, and elsewhere in the western\nhemisphere). Geographical focus will vary from year to year. For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literature of the Americas I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DRAM 395': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 395',
      description:
        'Students can apply to undertake a practical internship in theatre production or administration.\n',
      NOTE: ['Students will be given a grade of Pass/Fail for work done.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Internship',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a DRAM Major or Medial Plan) and (a GPA of 2.9 in DRAM) and permission of\nthe Department.'
      ],
      'LEARNING HOURS': ['120 (96Oc;24P)\n']
    },
    'ENIN 204': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 204',
      description:
        'This course develops an understanding of the basic principles, processes and applications of public relations and marketing\ncommunications in the arts and entertainment sectors, and across the creative industries. From arts marketing, fundraising,\nand publicity, to talent and music management, and event planning, the course covers how public relations can be applied\nto many fields.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Publicity and Media Relations',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (72O;48P)\n']
    },
    'ENGL 294': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 294',
      description:
        'In-depth exploration of the cultural significance of one particular genre, issue, or theme (for instance, spy fiction, literary\nprizes, youth subcultures). Topics may vary from year to year; for detailed information, consult the departmental website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cultural Studies: Theory into Practice',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 212': {
      EXCLUSION: ['No more than 3.0 units from GEOL 212/3.0; GEOL 232/3.0.'],
      RECOMMENDATION: ['4U Chemistry is required.\n'],
      code: 'GEOL 212',
      description:
        'An introduction to the crystallography and crystal chemistry of rock-forming minerals for students not in the Geological\nSciences. The structural, chemical and genetic aspects of the crystalline state as displayed by minerals are considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Mineralogy',
      units: '3.0',
      PREREQUISITE: ['GEOL 104/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': []
    },
    'HIST 419': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 419',
      description:
        'This course explores the society and culture of the Italian Renaissance (ca 1100-1520). Students will read and discuss great\nworks of literature (Dante, Petrarch, Boccaccio), philosophy (Ficino, Erasmus), political thought (Machiavelli, More), and\nlesser known sources, such as letters, diaries, and trial records. Topics will include; humanism (reception of classical\nliterature), art, religion, ethics, and violence; ideals and realities about family life, marriage, and gender.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Italian Renaissance',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'STAT 269': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 269',
      description:
        'Basic techniques of statistical estimation such as best unbiased estimates, moment estimates, maximum likelihood.\nBayesian methods. Hypotheses testing. Classical distributions such as the t-distribution, F-distribution, beta distribution.\nThese methods will be illustrated by simple linear regression. Statistical computing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Statistics and Probability II',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 221/3.0 or MATH 280/3.0) and (STAT 268/3.0 or STAT 351/3.0), or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 204': {
      EXCLUSION: ['No more than 3.0 units from MUSC 101/3.0; MUSC 204/3.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 204',
      description:
        'Examination of musical styles and movements in the Western tradition between about 1580 and 1820 in their sociocultural\ncontexts.\n',
      NOTE: [
        'Non-Music students holding Royal Conservatory Grade III Harmony may enroll in this course with permission of the\nSchool.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Baroque and Classical Music',
      units: '3.0',
      PREREQUISITE: ['MUSC 103/3.0.\nCOREQUISITE    MUSC 191/6.0.\n'],
      'LEARNING HOURS': ['118 (36L;12O;70P)\n']
    },
    'CHEM 281': {
      EXCLUSION: ['No more than 3.0 units from CHEM 211/3.0; CHEM 281/3.0.\n'],
      RECOMMENDATION: [],
      code: 'CHEM 281',
      description:
        'An introduction to the basic principles of organic chemistry with emphasis on bonding, stereochemistry, reaction\nintermediates and reaction mechanisms, and structure-reactivity correlations. Intended for students in biological and life\nsciences. Students in chemistry or biochemistry programs should not enrol in this course.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'General Organic Chemistry I',
      units: '3.0',
      PREREQUISITE: ['CHEM 112/6.0 or CHEM 114/3.0.\n'],
      'LEARNING HOURS': ['108 (36L;24O;48P)\n']
    },
    'CISC 458': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 458',
      description:
        'Introduction to the systematic construction of a compiler: grammars and languages, scanners, top-down and bottom-up\nparsing, runtime organization, symbol tables, internal representations; Polish notation, syntax trees, semantic routines,\nstorage allocation, code generation, interpreters.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Programming Language Processors',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 121/3.0 and CISC 221/3.0 and CISC 223/3.0).'],
      'LEARNING HOURS': ['120 (36L;36Lb;48G)\n']
    },
    'ARTH 292': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 292',
      description:
        'An examination of architecture in the western world, from 1900 to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Architecture from 1900 to the Present',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 413': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 413',
      description:
        'The study of the interaction of the atmosphere with the surface in terms of radiative, heat, water, and trace gas fluxes.\n',
      NOTE: [
        'Field trip fees may apply in certain years. See departmental webpage for more information. Cost will vary\ndepending on location, but not likely to exceed $175 per year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Water, Energy and Carbon Cycling in the Biosphere',
      units: '3.0',
      PREREQUISITE: [
        ' Level 4 and (6.0 units from MATH at the 100 level or above) and (6.0 units from BIOL or CHEM or PHYS at\nthe 100-level or above) and (a GPA of 1.90 in 30.0 units from GPHY) and (registration in a GPHY Major [Science] or EGPY\nSpecialization Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;12Lb;72P)\n']
    },
    'PACT P01': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT P01',
      description:
        'This is a prerequisite course for Fall Camp School. Students must exhibit a technical proficiency in front crawl, elementary\nback stroke, side stroke, breast stroke, shallow dive, front dive from one-metre board, survival swimming, rescue, and\nresuscitation. Students may meet this requirement by producing current swimming qualifications at the RLSS Bronze\nMedallion level, or by passing the swim test.\n',
      NOTE: [
        'Students are strongly encouraged to complete this requirement by the end of Year 2.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Aquatics',
      units: '0.0',
      PREREQUISITE: ['Registration in a PHED Specialization Plan.'],
      'LEARNING HOURS': []
    },
    'BCHM 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 421',
      description:
        'Advanced Biochemistry Laboratory I\nBiochemical research techniques with emphasis on nucleic acids, protein structure and function, regulation of gene\nexpression and metabolic control processes.\n',
      NOTE: ['6.0-unit course offered in the Fall Term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Specialization Plan) and [a GPA of 2.9 in BCHM 313/3.0, BCHM 315/3.0,\nBCHM 316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['222 (6S;144Lb;24I;6O;42P)\n']
    },
    'COGS 201': {
      EXCLUSION: [
        'No more than 6.0 units from COGS 200/6.0; COGS 201/3.0; PSYC 220/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'COGS 201',
      description:
        'Introduction to the computational aspects of the mind. Implementation of computer programs for reasoning, decision\nmaking, and problem solving to understand these mental processes. Information theory and behaviourism; computational\nmodels of cognition, perception and memory processes demonstrating modeling approaches, and cognitive architectures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cognition and Computation',
      units: '3.0',
      PREREQUISITE: ['C- in (COGS 100/3.0 or PSYC 100/6.0).\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 431',
      description:
        'European Politics\nMulti-level politics in Europe: the European Union and its member states. Development of the EU, institutions and policy\nprocesses at the EU level, how the domestic politics of European states affects the EU and vice-versa. Economic union,\nsupranationalism, political impulsion for economic integration, accession of new member states.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'LLCU 331': {
      EXCLUSION: ['No more than 3.0 units from LLCU 331/3.0; SPAN 331/3.0.'],
      RECOMMENDATION: [],
      code: 'LLCU 331',
      description:
        "In this course students will study Don Quijote II and a selection of novellas from Cervantes' Exemplary Novels. The course\nwill consider the socio-economic and historical context and the literary implications of the continuation of Don Quijote I to\nprovide a better understanding of 17th century Spain and the significance Cervantes' works hold today.\n",
      NOTE: ['Readings are in translation.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Cervantes II: Later Works',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHIL 473': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 473',
      description:
        'An examination of major issues in the philosophy of logic. Possible topics to be considered include deviant logics, the nature\nof identity, modal logics and the paradoxes of material implication and strict conditionals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophical Logic',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)] and PHIL 361/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 534': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 534',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Biology III',
      units: '3.0',
      PREREQUISITE: ['To be announced.\n'],
      'LEARNING HOURS': ['120 (9L;9S;18G;84P)\n']
    },
    'POLS 467': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 467',
      description:
        'Theoretical approaches and issues within the field, while paying particular attention to hegemony and leadership, the\neconomic dimension of post war and post cold war security, trade, money, debt, underdevelopment, regionalism, and\ninternational organization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Political Economy',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'GNDS 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 365',
      description:
        'This course takes an intersectional approach to contemporary interfaith dialogues, with the aim of exploring and\ndeveloping religious, ethical, and cultural literacies. The course considers the construction of gender norms, stereotypes,\ncultural expectations, religious expectations and practices, and state policies post 9/11.\n',
      NOTE: ['Also offered at the Bader International Study Centre.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender Dialogues: Jewish, Muslim and Christian',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 201',
      description:
        'Survey of the basic social and political developments in Rome from kingdom to republic to empire.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Roman History',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PHYS 206': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'A minimum grade of C in PHYS 104/6.0 or PHYS 106/6.0.\n'
      ],
      code: 'PHYS 206',
      description:
        'An introductory course in classical dynamics of particles, of rigid bodies and of fluids that sets the foundation for more\nadvanced work. Topics include kinematics of particles and of rigid bodies, central forces, kinetics of systems of particles,\nplanar and three dimensional dynamics of rigid bodies and an introduction to fluid mechanics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Dynamics',
      units: '3.0',
      PREREQUISITE: [
        '(PHYS 104/6.0 or PHYS 106/6.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0).'
      ],
      'LEARNING HOURS': []
    },
    'WRIT 290': {
      EXCLUSION: ['No more than 3.0 units from WRIT 290/3.0; WRIT 295/3.0.'],
      RECOMMENDATION: [],
      code: 'WRIT 290',
      description:
        'A study of the essay as a literary form, including analysis of readings as well as a series of writing assignments.\nComplementing the assignments is a mandatory Grammar and Style component.\n',
      NOTE: [
        'A student with a 100-level course with a writing component, such as DRAM, ENGL, FILM, HIST, PHIL, POLS, SOCY\nmay alternatively use this as a prerequisite and should contact the instructor for permission to register in the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing Literary Non-fiction',
      units: '3.0',
      PREREQUISITE: ['WRIT 125/3.0 or permission of the instructor.\n'],
      'LEARNING HOURS': ['114 (36O;78P)\nEQUIVALENCY    WRIT 295/3.0.\n']
    },
    'LLCU 322': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 322/3.0; INTS 322/3.0; GRMN 433/3.0.\nEQUIVALENCY    INTS 322/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 322',
      description:
        'An examination of international discourses on conflict and resolution, including theories of reconciliation, human rights,\nand international law, as portrayed in various media (fiction, theatre and film) and diverse cultural contexts (e.g. ancient\nGreece, Germany, South Africa and Canada [indigenous settler relations]).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Conflict and Culture: Literature, Law, and Human Rights',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 327': {
      EXCLUSION: ['No more than 3.0 units from FREN 327/3.0; FREN 427/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 327',
      description:
        'A study of cultural representations in contemporary film. Special topics may include women in cinema, culture and identity\nin French and/or Francophone cinema, history through cinema, avant-garde cinema and the \u2018nouvelle vague\u2019. Travaux\npratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le Cin\u00e9ma aujourd\u2019hui: \u00c9tudes th\u00e9matiques',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MICR 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MICR 499',
      description:
        'A research project supervised by and closely related to the research program of a faculty member. The research project\ninvolves experimental design, data collection and analysis, written report and oral presentation. Students will be required\nto attend seminars and tutorials on topics related to research. Limited enrolment.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Microbiology and Immunology',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC or ELSC Specialization Plan and a GPA of 2.50 and MICR 221/3.0.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'HIST 241': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 241',
      description:
        'Lecture course on a selected historical issue. Subject changes from year to year; course is either being offered for the first\ntime or is being taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ssues in History',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 331',
      description:
        'Intermediate study in feminist approaches to the cinema and to films produced by women. Critical examination of critical\nand theoretical literature, and examples of narrative, documentary, and experimental cinemas.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Women and Film',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (Level 3 and registration\nin a GNDS Plan and GNDS 120/3.0, GNDS 125/3.0).\nFILM 335/3.0\nCulture and Technology\nResearch and studies in relations of media, technology, and culture. Critical examination of cultural and communication\ntechnologies and the employment of technology within selected examples from film, television, and digital media.\n',
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (FILM 236/3.0; FILM\n240/3.0; FILM 260/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n', '108 (36L;24O;48P)\n']
    },
    'NSCI 433': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'NSCI 433',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'LLCU 319': {
      EXCLUSION: ['No more than 3.0 units from GRMN 419/3.0; LLCU 319/3.0.'],
      RECOMMENDATION: [],
      code: 'LLCU 319',
      description:
        'A survey of various currents of thought from 19th-century Europe that illustrate conservative discomfort with industrial\nsociety and help to make the outbreak of fascism understandable after 1918. The course will distinguish between\nconservative, nationalist, aesthetic, and religious trends, illustrated by relevant readings from different countries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Roots of Fascism: Resistance to Liberalism in the 19th Century',
      units: '3.0',
      PREREQUISITE: [
        'Third year standing of permission of the Department of Languages, Literatures, and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 440',
      description:
        'An exploration of higher-level processes in evolution spanning considerations of mechanisms of speciation, extinction,\nadaptive radiation, and phylogenetics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Speciation and Macroevolution',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 302/3.0 or BIOL 303/3.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['120 (24L;24T;60G;12O)\n']
    },
    'HLTH 332': {
      EXCLUSION: [
        'No more than 3.0 units from HLTH 332/3.0; HLTH 397/3.0-001 (2015-16); HLTH 402/3.0 (2014-15 or earlier);\nKNPE 333/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HLTH 332',
      description:
        'This course is designed to provide students with a solid understanding of disability and disability-related issues as they\npertain to health, well-being, and quality of life. It will include an examination of the historical treatment of persons with\ndisabilities through present day.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Foundations for Understanding Disability: A Health Perspective',
      units: '3.0',
      PREREQUISITE: [
        '(Level 2 or above and registration in a HLTH, KINE, or PHED Plan) or registration at the BISC.\n'
      ],
      'LEARNING HOURS': ['112 (36L;4O;72P)\n']
    },
    'ARTH 245': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 245',
      description:
        'Instruction in Venice based on daily study tours to the city\u2019s monuments and galleries. Each week a visit will be organized to\nan important centre in the Venice region.\n',
      NOTE: [
        'Costs of travel and accommodation abroad must be paid by the student. Consult the Department of Art for the\ncosts involved. Estimated cost: Room and board $4,500, Travel $1500.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Art and Architecture in Venice',
      units: '6.0',
      PREREQUISITE: ['6.0 units in ARTH.'],
      'LEARNING HOURS': []
    },
    'PATH 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PATH 430',
      description:
        'An in-depth perspective of the pathogenesis of human disease. An integration of the genetic, biochemical, physiologic,\nanatomic, and general etiologic factors which play a role in the progression of several specific diseases from inception to\ndeath or recovery. The course will comprise short introductory presentations by teaching faculty followed by the\npresentation and discussion of relevant scientific papers by students. Given jointly with PATH 826/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Molecular Basis of Disease',
      units: '3.0',
      PREREQUISITE: [
        'PATH 310/3.0 or and Level 4 and (registration in a LISC Major or Specialization Plan) and (a GPA of 2.5) or\npermission of the course coordinator.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 415',
      description:
        'An examination of the evolution and operation of the Canadian federal system. Topics include the concept and meaning of\nfederalism, the implications of provincial/federal interdependence, and the politics of constitutional reform.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Federalism',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'DEVS 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 320',
      description:
        'HIV/AIDS is one of the most pressing development issues in the world today. This course examines the cultural, political,\neconomic, and other social factors that contribute to its transmission and intractability, and which help to explain the\ndifferential impact of the disease upon societies worldwide. Particular attention is paid to the ways that specific\nsocial/sexual identities and practices arising from inequitable class, gender, race, and ethnic relations, affect the prevalence\nof HIV, the ability to contain its spread, and the human costs that it entails.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'AIDS, Power, and Poverty',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and (DEVS 100/6.0 or DEVS 220/3.0 or DEVS 221/3.0 or DEVS 230/3.0 or HLTH 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 404',
      description:
        'An examination of key issues in Canadian Politics. Topics will vary from year to year; consult the departmental website for\nfurther details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Politics: Questions & Challenges',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PHAR 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHAR 499',
      description:
        'Research Project in Pharmacology and Toxicology\nAn examination of the development and present state of knowledge in selected research areas of pharmacology and\ntoxicology. Research project involves experimental design, data collection and analysis, written report and oral\npresentation. Students will be required to attend seminars and tutorials on topics related to research.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in a LISC or ELSC Specialization Plan and a GPA of 2.50.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'PSYC 371': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 371',
      description:
        'A critical analysis of important topics in behavioural neuroscience, with emphasis on current, controversial areas including:\nbrain plasticity, learning and memory, neurobiology of sleep and consciousness. Laboratories emphasize behavioural\nneuroscience methods with hands-on experience in projects related to the lecture material.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Problems in Behavioural Neuroscience',
      units: '3.0',
      PREREQUISITE: ['PSYC 271/3.0 and PSYC 370/3.0.'],
      'LEARNING HOURS': ['120 (36L;36Lb;48P)\n']
    },
    'MICR 360': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 360',
      description:
        'The general principles and mechanism of immune reaction. Immunochemical and immunobiological aspects of antibody\nformation and cell-mediated immunity in health and disease will be considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Immunology',
      units: '3.0',
      PREREQUISITE: ['MICR 221/3.0 and (BCHM 218/3.0 or BIOL 334/3.0).'],
      'LEARNING HOURS': ['144 (36L;36O;72P)\n']
    },
    'ECON 370': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 370',
      description:
        'Topics vary from year to year, reflecting the interests of students and the instructor. One-third of the course is devoted to\nspatial theory and two-thirds to the application of economic theory to such problems as optimal city size, urban public\nfinance, pollution and aesthetics, and housing, transportation and poverty problems in the urban setting.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Urban and Regional Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 496': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 496',
      description: 'A detailed study in the history of prints and drawings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in the History of Prints and Drawings',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 321',
      description:
        'A study of the development and organization of non-civic religious associations in the Greek and Roman empires using\ninscriptions, papyri, and literary texts. Insight into religious practices of the Greco-Roman period comes through exploration\nof groups organized by deity, cult, occupation, or ethnic identity, and the so-called mystery religions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Greek and Roman Religions',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'HLTH 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 102',
      description:
        'This course provides an introduction to the variety of factors which could affect a person\u2019s health and wellness.\n',
      NOTE: ['Not available to students in a PHED or KINE Plan.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after 12.0 units in KNPE (formerly PPHE; PHED; KINE).'
      ],
      title: 'Personal Health and Wellness',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'RELS 239': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 239',
      description:
        'Religion and Sport\nThis course will provide an overview of the relatively new and expanding body of research that examines the relationship\nbetween sport, spirituality and religion. Topics including play, games, flow, ritual, prayer, sports stars as role models,\ndoping, fandom and miracles in sport will be explored.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['129 (36L;93P)\n']
    },
    'ARTH 120': {
      EXCLUSION: [
        'No more than 9.0 units from ARTH 116/3.0; ARTH 117/3.0; ARTH 120/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'ARTH 120',
      description:
        'A survey of famous and lesser-known works of painting, sculpture, architecture, and other art forms from Antiquity, the\nMiddle Ages, the Renaissance, the Baroque, and the Modern Age. Themes include politics, religion, mythology, gender\nroles, techniques, conservation and intersections with non-western cultures.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Art in the West from Antiquity to Modernity',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'SOCY 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 352',
      description:
        'This course introduces students to the sociology of family diversity. Topics normally considered include diversity of family\nforms; social constructions of motherhood and fatherhood; contested understandings of families; and how contemporary\ndebates about gender differences, sexualities, and racialization may inform the understanding of intimate and familial\nrelations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Family Diversity',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'INTS 363': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'It is recommended but not required, that applicants have some academic background in\ninternational law and/or political or legal theory.\n'
      ],
      code: 'INTS 363',
      description:
        'The course explores international and transnational law and institutions and the ways familiar principles might apply to\nthem. We will ask questions such as: What is the source of the authority and legitimacy of international norms? How should\nwe think of the rule of law or procedural justice in an international context? Can international institutions be democratic? Is\nthere a moral basis to state sovereignty?\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Philosophy of International Law',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['116 (36L;80P)\n']
    },
    'WRIT 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 240',
      description:
        'Writing for Social Media and the Web introduces students to professional writing in the context of online media. Short\nassignments, including blog entries, a critical review, a process analysis, and a web page, focus on strengthening writing and\nediting skills, writing according to purpose, and recognizing various styles in social media writing.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing for Social Media and the Web',
      units: '3.0',
      PREREQUISITE: ['WRIT 120/3.0 or WRIT 125/3.0.'],
      'LEARNING HOURS': ['120 (36O;84P)\n']
    },
    'ECON 223': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 223',
      description:
        'Current topics in macroeconomic policy which may include: unemployment and policies to reduce it, government budget deficits,\nsupply-side controversies, financial deregulation, policy coordination, and management of exchange rates. Comparison of policies\nin Canada, the United States, and other OECD countries.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Macroeconomic Policy',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 112/3.0.'],
      'LEARNING HOURS': ['120 (24L;12G;48O;36P)\n']
    },
    'STAT 486': {
      EXCLUSION: [],
      RECOMMENDATION: ['STAT 462/3.0.\n'],
      code: 'STAT 486',
      description:
        'Introduces the theory and application of survival analysis: survival distributions and their applications, parametric and\nnonparametric methods, proportional hazards models, counting process and proportional hazards regression, planning and\ndesigning clinical trials. Given jointly with STAT 886/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Survival Analysis',
      units: '3.0',
      PREREQUISITE: [
        '(STAT 361/3.0 or ECON 351/3.0) and STAT 463/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 296': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 296',
      description:
        'This course introduces students to historical and contemporary debates regarding the treatment of nonhuman animals\nwithin Western societies, and explores our ethical responsibilities toward them. The course examines a range of human-\nanimal relations, involving domesticated, working, research subjects and wild animals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Animals and Society',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 383': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 383',
      description:
        'This course examines the phenomenon of the city, a settlement of high density that has, throughout history, offered many\ndistinctive social and cultural experiences. The focus of this course will be urban art, architecture, planning, and material\nculture, and their relationship to those experiences. Specific urban case studies, Western and non-Western, will provide the\nfoundation for our study.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The City',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 480': {
      EXCLUSION: ['No more than 3.0 units from ECON 480-499/3.0.'],
      RECOMMENDATION: [],
      code: 'ECON 480',
      description:
        'Seminars in Microeconomics\nSeries of seminar courses on microeconomic topics. Evaluation based on presentations, formal/informal participation and\nwritten papers. Offerings vary from year to year with staff availability. Topics announced in advance of course selection and\navailable on the Undergraduate webpage.\n',
      NOTE: [
        'Fourth year ECON Medial students with fewer than 30.0 ECON units and fourth year APEC students without ECON\n320 should contact the department before May 1 to obtain permission to register in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (a minimum cumulative GPA of 1.90) and (a minimum GPA of 2.60 in 30.0 units   of ECON) and\n(ECON 310/3.0; ECON 320/3.0; ECON 351/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (18S;18G;12I;72P)\n']
    },
    'PHYS P10': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS P10',
      description:
        'A course relevant to those interested in teaching. Activity based learning of fundamental physics topics typically taught in\nelementary and secondary schools. Topics include: motion, forces, energy, heat, electricity and magnetism, and light.\nStudents will be required to teach a one hour enrichment class, once a week for 10 weeks, to Grade 7 or 8 students in a\nlocal school.\n',
      NOTE: [
        'This course may not be included in any Plan in Physics other than a Minor.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamental Concepts in Physics for Teachers',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['113 (12L;24Lb;10Pc;5I;18O;20Oc;24P)']
    },
    'HIST 436': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 436',
      description:
        'This seminar explores central issues in and approaches to legal history based on Canadian examples. Topics may include the\nhistory of crime and punishment; the legal regulation of gender, sexuality, \u2018race\u2019, and Native-newcomer relations; the law\nand the evolution of modern capitalism; and the history of the legal profession, and civil rights.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Canadian Legal History',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'BIOL 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 430',
      description:
        'Molecular Genetics of Development\nThe use of genetic analysis to understand developmental processes such as cell fate determination, pattern formation and\nmorphogenesis. Emphasis will be on the molecular pathways used during embryonic development, highlighting applications\nand techniques using model organisms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(BCHM 218/3.0 or BIOL 330/3.0 or MBIO 218/3.0) and a minimum GPA of 2.0 in the Biological Foundations\nList.'
      ],
      'LEARNING HOURS': ['126 (36L;18S;24G;12I;12O;24P)\n']
    },
    'FILM 110': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 110',
      description:
        'Introduction to analysis of film, television, new media and other related forms of contemporary culture. Includes classical\nand contemporary Hollywood cinema, Canadian film and television, alternatives in international cinema, as well as recent\ndevelopments on the internet, in gaming, and in social media.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Film, Culture and Communication',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['216 (24L;24Lb;36T;36Pc;96P)']
    },
    'POLS 464': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 464',
      description:
        'An examination of the determinants of Russian Foreign Policy, and the extent to which they have changed over the last\nhalf-century. The course will cover both historical and contemporary issues in Russian foreign relations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Russian Foreign Policy',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 503': {
      EXCLUSION: [
        'No more than 1 course from GPHY 501/3.0; GPHY 502/3.0; GPHY 503/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 503',
      description:
        'Research project in Geography supervised by a member of the faculty. Research involving the amount of work associated\nwith larger research projects with work comparable to a 6.0 unit course (including work completed during summer) may be\ndone as GPHY 503/6.0.\n',
      NOTE: ['Admission is subject to the availability of supervisors.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research and Thesis in Geography II',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and a (GPA of 3.50 in 24.0 units in GPHY) and (registration in a GPHY Major or Medial Plan or EGPY\nSpecialization Plan) and (consent of a supervising member of the Department) or by permission of the Departmental\nUndergraduate Committee.\n'
      ],
      'LEARNING HOURS': ['240 (48I;192P)\n']
    },
    'PSYC 221': {
      EXCLUSION: [
        'No more than 6.0 units from COGS 200/6.0; COGS 201/3.0; PSYC 220/6.0; PSYC 221/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 221',
      description:
        'An introduction to the empirical study of mental processes. Topics include perception and attention, working memory,\nlong-term memory, visual imagery, problem-solving, language, and decision-making.\n',
      NOTE: [
        'Also offered online. Consult Art and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Cognitive Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'IDIS 220': {
      EXCLUSION: [
        'No more than 3.0 units from IDIS 220/3.0 and IDIS 221/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'IDIS 220',
      description:
        'The course will work towards crafting a definition of the term \u2018digital humanities\u2019 through examining the way in which we\ncreate, use, and think about digital resources in humanities disciplines. Students will: learn the basic skills needed to create\ndigital objects, use digital artifacts and tools specific to their own research interests, and engage in theoretical discussions.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title:
        'Hacking the Humanities: An Introduction to the Digital Humanities',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (18L;9S;9Lb;30O;24Oc;30P)\n']
    },
    'SPAN 111': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 111',
      description:
        'Offers a basic level of Spanish understanding, speaking, reading and writing for students who have no knowledge of Spanish\nwhatsoever.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after SPAN 112/3.0; SPAN 204/3.0; SPAN 205/3.0; SPAN 301/3.0; SPAN\n302/3.0; SPAN 303/3.0; SPAN 304/3.0; SPAN 401/3.0; SPAN 402/3.0; SPAN 201/6.0.'
      ],
      title: 'Beginning Spanish I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12O;72P)\nEQUIVALENCY    SPAN P10/3.0.\n']
    },
    'CISC 327': {
      EXCLUSION: ['No more than 3.0 units from CISC 327/3.0; SOFT 327/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 327',
      description:
        'Software Quality Assurance\nValidation of software throughout the life cycle. Comparative effectiveness in defect removal of formal methods (proofs of\ncorrectness), inspection (walkthroughs and reviews), and testing (unit, integration, and system testing; white box versus black\nbox).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['C- in (CISC 220/3.0 and CISC 124/3.0).\n'],
      'LEARNING HOURS': ['120 (36L;84G)\n']
    },
    'CLST 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 200',
      description:
        'Survey of the Greek World from the Late Bronze Age to the death of Cleopatra. Social, religious and political developments\namong the major powers, Athens, Sparta and Hellenistic kingdoms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Greek History',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PSYC 398': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 398',
      description:
        'Lecture courses on selected topics in psychology offered periodically.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Psychology I',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CHEM 222': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 222',
      description:
        'A survey of practical spectroscopic and spectrometric methods for the determinations of the structures of organic and\ninorganic compounds. Methods will include nuclear magnetic resonance, electronic, infrared/Raman spectroscopy, and\nmass spectrometry. Tutorials will involve solving compound structures using spectroscopic data, and include an\nintroduction to computational methods in spectroscopy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Methods of Structure Determination',
      units: '3.0',
      PREREQUISITE: ['CHEM 211/3.0 or CHEM 212/3.0 or CHEM 281/3.0.'],
      'LEARNING HOURS': ['126 (36L;18T;72P)\n']
    },
    'PATH 425': {
      EXCLUSION: ['No more than 3.0 units from BIOL 441/3.0; PATH 425/3.0.'],
      RECOMMENDATION: [
        'BCHM 218/3.0 or MBIO 218/3.0 or permission of the course coordinator.\n'
      ],
      code: 'PATH 425',
      description:
        'An advanced level course introducing current topics in human genetics. The course will focus on the significance and\nimplications of genetic variation and its role in disease, development and normal human diversity. In particular, the course\nwill explore the future directions and implications of human genetic research in the post genomic era. Participation in\nseminars and group discussions is required. Enrolment is limited. Offered in Winter Term.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Topics in Human Genetics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ARTH 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 307',
      description:
        'This course considers the retrospective tendencies in art of the so-called \u2018Romanesque period\u2019 leading up to the \u2018Gothic\u2019.\nConsidering monuments across all media, we discuss concepts of artistic development in cathedral, monastic and secular\nsettings. We will also consider modes of \u2018reading\u2019 and interpretation of medieval art in terms of contemporary modes of\nperception.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Romanesque: Art and Historicism in Europe c.800-1150',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'SPAN 408': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 309/3.0; SPAN 308/3.0; SPAN 408/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'SPAN 408',
      description:
        'Students will view and analyze a selection of Almod\u00f3var\u2019s films within the context of Spain and other countries. The study\nof gender, sexual, cultural and societal identity and other fundamentals of contemporary theory will be central to this\ncourse.\n',
      NOTE: [
        'Taught in English together with LLCU 309/3.0. Students concentrating in Spanish submit written assignments, tests,\nand examination in Spanish.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Films of Pedro Almod\u00f3var',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 381/3.0 (or permission of the Department of Languages, Literatures and Cultures).\n'
      ],
      'LEARNING HOURS': ['120 (36L;36T;48P)\n']
    },
    'SPAN 204': {
      EXCLUSION: [],
      RECOMMENDATION: ['4U Spanish.\n'],
      code: 'SPAN 204',
      description:
        'A review of the fundamentals of Spanish, in cultural contexts, designed to develop aural, oral, reading and writing skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after SPAN 201/6.0; SPAN 205/3.0; SPAN 301/3.0; SPAN 302/3.0; SPAN\n303/3.0; SPAN 304/3.0; SPAN 401/3.0; SPAN 402/3.0.'
      ],
      title: 'Espa\u00f1ol intermedio',
      units: '3.0',
      PREREQUISITE: ['A grade of C in SPAN 112/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 345': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 345',
      description:
        'This course focuses on the development of sport conditioning programs from periodization concepts to specific training\ncomponents and how the components can be integrated to create a comprehensive and balanced athlete training plan.\nLaboratory sessions will work on skill development applicable to conducting training and conditioning programs.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'The Science and Methodology of Sport Training Conditioning Programs',
      PREREQUISITE: [
        'Level 3 or above in a PHED or KINE Plan and KNPE 227/3.0; Reserved for BPHEH, BSCH KINE students only.\nCOREQUISITE    KNPE 254/3.0.'
      ],
      'LEARNING HOURS': ['126 (36L;18Pc;12G;60P)\n']
    },
    'CHEM 321': {
      EXCLUSION: ['No more than 3.0 units from CHEM 321/3.0; ENSC 471/3.0.'],
      RECOMMENDATION: [],
      code: 'CHEM 321',
      description:
        'Overview of instrumental methods of chemical analysis. Topics include gas and liquid chromatography, mass spectrometric\ndetection, new separation methods, electrochemical analysis, inductively coupled plasma-based elemental analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Instrumental Chemical Analysis',
      units: '3.0',
      PREREQUISITE: ['CHEM 213/3.0.\n'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'LANG 202': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LANG 202',
      description:
        'For students studying abroad or at a Canadian University who wish to learn a modern language other than English and who\nhave acquired a basic knowledge of that language. An increased emphasis on the study of the grammatical structures of the\nlanguage and on the acquisition of vocabulary. Practice in speaking, reading, and writing.\n',
      NOTE: [
        'A language placement test will be administered by the host university.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Language Acquisition - Advanced Level II',
      PREREQUISITE: [
        '(LANG 101/3.0 and LANG 102/3.0) or (LANG P10/3.0 and LANG P11/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    LANG 121/3.0.\n']
    },
    'GREK 208': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 208',
      description:
        'Review of grammar, and developing facility in translation, study of literary content and background of authors.\n',
      NOTE: [
        'A student with 4U Greek may alternatively use this as a prerequisite and should contact the Department for\npermission to register in the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Greek',
      units: '6.0',
      PREREQUISITE: [' GREK 112/6.0.'],
      'LEARNING HOURS': ['282 (72L;210P)\n']
    },
    'HIST 315': {
      EXCLUSION: ['No more than one course from HIST 286/3.0; HIST 315/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 315',
      description:
        'In first semester, students join with the lecture course \u2018Latin America 1850-Today\u2019. In second semester, students deepen\ntheir exploration of Latin America\u2019s modern history in a seminar format, with emphasis on major controversies, critical\nreading of historical sources and texts, speaking, research, and writing skills.\n',
      NOTE: [
        'In Fall Term, HIST 315/6.0 meets in the same classroom with HIST 286/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'odern Latin American History: Sources and Debates',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (34.5L;36S;1.5T;168P)\n']
    },
    'HIST 437': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 437',
      description:
        'A study of religion in Canada and the United States, concentrating on the period 1800-1930, and examining a wide range of\ntopics such as revivalism, gender, social reform, higher education, missions, the rise of fundamentalism, and the causes of\nsecularization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'eligion and North American Society',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'FREN 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 501',
      description:
        'Research in a particular area of French literature or language under the supervision of a professor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Recherches dirig\u00e9es I',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department and approval of the supervisor.\n'
      ],
      'LEARNING HOURS': ['120 (24I;96P)']
    },
    'DEVS 495': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 495',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 805/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies IV',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['132 (36S;96P)\n']
    },
    'DEVS 410': {
      EXCLUSION: ['No more than 1 course from DEVS 410/6.0; DEVS 421/3.0.\n'],
      RECOMMENDATION: [],
      code: 'DEVS 410',
      description:
        "Work Placement in Development Studies\nProvides students with first-hand experience working with an agency involved in international development, either in\nCanada or abroad. The placement will normally be for 10-20 weeks, to be negotiated with the sponsoring agency. Students\nare required to attend preparatory meetings, prepare a work-study proposal, a research paper on the placement and\nmaintain a journal on a continuing basis while on their placement. In addition to academic requirements, students are\nrequired to enroll in the Queen's Emergency Support Program, attend pre-departure orientation and complete Queen's Off-\nCampus Activity Safety Policy (OCASP) requirements.\n",
      NOTE: [
        'Students are normally responsible for all costs associated with participation in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        "Level 3 or above and registration in the DEVS Major Plan and departmental approval in advance from the\nHead of Global Development Studies.\nCOREQUISITE    DEVS 411/3.0  (Under special circumstances a student can substitute DEVS 502/3.0 (Directed Readings in\nDevelopment Studies) for DEVS 411/3.0. Permission for the latter may be granted to students who have completed all other\ndegree requirements, and who do not need to return to Queen's University campus following completion of their\nplacement. Students must seek prior approval from the Placement Coordinator, Global Development Studies for this\noption).\n"
      ],
      'LEARNING HOURS': ['260 (60G;200P)\n']
    },
    'MUTH 460': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 460',
      description:
        'Performance experience for qualified musicians in a staged vocal ensemble. Topics include musical theatre, opera, or other\nensemble formats combining voice and drama.\n',
      NOTE: [
        'Placement is made at the discretion of the School based on an audition or other criteria.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Theatre Ensemble',
      units: '1.5',
      PREREQUISITE: ['MUTH 360/1.5 and permission of the School.'],
      'LEARNING HOURS': ['168 (72Pc;24G;72P)\n']
    },
    'PHIL 382': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 382',
      description:
        'Contemporary physics has revolutionized our understanding of space, time, and matter. This has raised many fascinating\nphilosophical issues, such as: Is time real? Is time travel possible? Is reality determinate, or does it depend on human\nobservation? We will examine these and other questions in the context of physical theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Space-Time, Matter, and Reality',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MICR 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 320',
      description:
        'Knowledge of interactions between bacterial or viral pathogens and their human hosts is crucial for understanding the\nnature of infectious diseases, as well as their control and treatment. This course examines key microbial pathogens, with\nthe goal of introducing students to the biology, diversity and complexity of host-pathogen relationships.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Microbial Pathogenesis',
      units: '3.0',
      PREREQUISITE: ['(MICR 221/3.0 or MICR 229/3.0) and MICR 360/3.0.'],
      'LEARNING HOURS': ['120 (34L;2S;4T;8G;72P)\n']
    },
    'SOCY 363': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 363',
      description:
        'Critical examination of science in modern society; particular reference to historical development, transmission of scientific\nknowledge, conduct of enquiry, and interdependence with other institutions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Science, Technology and Society',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 288': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 288',
      description:
        'This course introduces students to key institutions of art by studying their histories, current practices, and future\nchallenges. Using a case study approach to institutions including museums, artist-run centres, auction houses, and private\ngalleries, the course develops students\u2019 understanding of art worlds both in Canada and globally.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Art Worlds',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['114 (24L;12G;18O;60P)\n']
    },
    'ARTF 128': {
      EXCLUSION: [
        'No more than 1 course from ARTF 101/3.0; ARTF 105/6.0; ARTF 106/3.0; ARTF 128/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'ARTF 128',
      description:
        'A continuation of ARTF 127/6.0, this course offers two of the sections from the media available at this level: painting,\ndrawing, two-dimensional fundamentals, and three-dimensional fundamentals.\n',
      NOTE: [
        'Open only to students in a BFA Program.\n',
        '$250 deposit required for voluntary 2nd year field trip to New York.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Fine Art II',
      units: '6.0',
      PREREQUISITE: [
        'A minimum grade of C- in ARTF 127/6.0 and a GPA of 1.60.\n'
      ],
      'LEARNING HOURS': ['288 (144Lb;144P)\n']
    },
    'DEVS 492': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 492',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 809/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'LEARNING HOURS    120 (36L;84P)': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LEARNING HOURS    120 (36L;84P)',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Introduction to the study of Indigenous traditions in North America.',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': []
    },
    'HIST 314': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 314',
      description:
        'An analysis of significant social and cultural trends in the United States since 1877. Topics include constructions of race and\ngender; consumer culture; industrialization; the myth of the frontier; popular culture; the civil rights movement.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'merican Society and Culture Since 1877',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'MATH 477': {
      EXCLUSION: [],
      RECOMMENDATION: ['STAT 353/3.0.\n'],
      code: 'MATH 477',
      description:
        'Topics include: arithmetic coding, universal lossless coding, Lempel-Ziv and related dictionary based methods, rate\ndistortion theory, scalar and vector quantization, predictive and transform coding, applications to speech and image coding.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Data Compression and Source Coding',
      units: '3.0',
      PREREQUISITE: ['MATH 474/3.0.'],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'ARTH 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 415',
      description:
        'A detailed study of one area or topic in the history of medieval European art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Medieval Art History',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 467': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 467',
      description:
        'An examination of First Nations history from ancient times to the present in North America with a particular focus on the Canadian\nexperience. Topics include culture theory, disease, trade, missionaries, the writing of native history, and contemporary events.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'irst Nations of North America',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'PORT 103': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 101/3.0 (if taken between 2012-13 and 2014-15); PORT 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PORT 103',
      description:
        'Introduction to the language and culture of Portugal and Brazil, acquiring basic communicative skills, vocabulary, and\nstructures of the Portuguese language. This course promotes knowledge and understanding of the social, cultural, and\nhistorical contexts of both countries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Portuguese and Culture I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GNDS 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 321',
      description:
        'This course offers an interdisciplinary framework of feminist thought on women, work and employment opportunities. It\ntakes a comparative look at socio-political feminist theories on work and employment in different social and cultural\ncontexts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gendering Opportunities \u2013 Women\u2019s Work',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ITLN 432': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 232/3.0; ITLN 432/3.0; LLCU 232/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 432',
      description:
        'The course will focus on the study of Italian Romanticism and its relation to English, German, Spanish and French\nRomanticism. The rise of Realism and Decadentism will also be discussed and examined.\n',
      NOTE: [
        'Taught in English together with LLCU 232/3.0. Students concentrating in Italian submit written assignments, tests\nand examinations in Italian. Normally students will read Italian texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'From the Romantics to D\u2019Annunzio',
      units: '3.0',
      PREREQUISITE: ['ITLN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 433': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 433',
      description:
        'Art, Tourism and Modernity\nAn examination of the relationship of art and tourism. Topics include the role of tourism in the creation of tourist, Folk and\nPrimitive art, souvenir and craft; the relationship of museums and cultural tourism to the rise of global capitalism; the ways\nin which art in a tourism economy participates in the politics of identity and representation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;12G;12I;60P)\n']
    },
    'MATH 427': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 427',
      description:
        'Topics include: global properties of flows and diffeomorphisms, Invariant sets and dynamics, Bifurcations of fixed and\nperiodic points; stability and chaos. Examples will be selected by the instructor. Given jointly with MATH 827/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Deterministic Dynamical Systems',
      units: '3.0',
      PREREQUISITE: [
        'MATH 328/3.0 and MATH 231/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 347': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 347',
      description:
        'This course offers an introduction to the theory and application of multivariate statistics to geographical data. Topics\ninclude regression and correlation analysis, ANOVA, spatial autocorrelation and other spatial statistics as well as\ngeostatistical operations in GIS software.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Multivariate and Spatial Statistics',
      units: '3.0',
      PREREQUISITE: [
        '(3.0 units from GPHY 247/3.0; ECON 250/3.0; KNPE 251/3.0; PHED 251/3.0; POLS 385/3.0; PSYC 202/3.0;\nSOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0).'
      ],
      'LEARNING HOURS': ['120 (24L;24Pc;24O;24P)\n']
    },
    'HLTH 491': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 491',
      description:
        'This is an independent project in an area of specialization in Health Studies. Students must arrange for a faculty advisor\napproved by the School of Kinesiology and Health Studies to oversee their project.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Project in Health Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization, KINE Specialization or (HLTH Major or Medial) Plan; permission of the\nsupervisor and the Undergraduate Coordinator of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['126 (6I;120P)\n']
    },
    'MUSC 283': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 283',
      description:
        'Brass Techniques and Methods II\nContinuation of MUSC 183/3.0. A more advanced study of the complete brass family of instruments. Emphasis includes\nplaying techniques, ranges, fingerings, transpositions, instrument maintenance, method books, ensemble repertoire and\nteaching techniques. Rental instruments available.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['MUSC 183/3.0 or permission of the instructor.'],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'CLST 405': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 405',
      description:
        'The growth of Rome from the foundation to Late Antiquity based on archaeological evidence. Emphasis on developments\nduring its classical period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Topography of Rome',
      units: '3.0',
      PREREQUISITE: [
        'CLST 305/3.0 or CLST 306/3.0 or CLST 321/3.0 or CLST 340/3.0 or CLST 341/3.0 or CLST 343/3.0 or\npermission of the Department.'
      ],
      'LEARNING HOURS': ['126 (36S;90P)\n']
    },
    'PSYC 397': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 397',
      description:
        'A survey of the history of modern psychology, from the early 19th century to the close of the 20th. The more important\nempirical findings of psychology and related disciplines will be examined together with their theoretical explanations. The\ncourse will lead to an examination of the causes of differential scientific progress in the various subfields of psychology.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'History of Modern Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': []
    },
    'CISC 352': {
      EXCLUSION: [],
      RECOMMENDATION: ['CISC 260/3.0.\n'],
      code: 'CISC 352',
      description:
        'An introduction to the basic principles and tools of artificial intelligence. Problem solving methods and knowledge\nrepresentation techniques.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Artificial Intelligence',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 235/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PACT 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT 333',
      description:
        'This activity-based course will afford students the opportunity to work with community physical activity programs for\npersons with disabilities and relate class theory from HLTH 332/3.0 Foundations for Understanding Disability to practical\nimplementation. Students will also have a weekly laboratory component.\n',
      NOTE: [
        'Transportation and other costs (e.g. required Criminal Checks) are the responsibility of the student.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Practicum in Physical Activity for Persons with Disabilities',
      units: '3.0',
      PREREQUISITE: ['PACT 237/3.0.\nCOREQUISITE    HLTH 332/3.0.'],
      'LEARNING HOURS': ['126 (18Lb;6Pc;36Oc;12O;54P)\n']
    },
    'HLTH 237': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 237',
      description:
        'An overview of theoretical and practical issues. Topics include drug action, theories of drug abuse, treatment strategies,\nand community resources. Students prepare group presentations on trends, needs of selected populations, and issues of\ncontroversy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to the Study of Alcohol and Drug Problems',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'GNDS 125': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 125',
      description:
        'Explores popular culture from feminist and anti-racist perspectives, with attention to sexuality, gender, race and nation in a\nvariety of media.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Race and Popular Culture',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;84P)']
    },
    'PSYC 370': {
      EXCLUSION: [],
      RECOMMENDATION: ['PSYC 100/6.0.\n'],
      code: 'PSYC 370',
      description:
        'The relationship between brain and behaviour. The first part of the course examines topics relevant to brain plasticity,\nincluding neurodevelopment, brain damage and learning and memory; followed by a section on the biopsychology of\nmotivation that covers the neural mechanisms of eating, sexual behaviour and sleep. The final section deals with disorders\nof cognition and emotion, including drug addiction, stress and psychiatric disorders.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Brain and Behaviour II',
      units: '3.0',
      PREREQUISITE: [
        'PSYC 271/3.0 or (Level 3 and registration in a BIOL or LISC Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 432',
      description:
        'Topics include the presentation and storage of data, implementation concerns, and the integration of databases with other\nareas of computer science.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Database Systems',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 235/3.0 and CISC 332/3.0).'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HEBR 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 301',
      description:
        'Specialized study, as circumstances permit, of a particular author, genre, theme, movement, literary form or some\ncombination of these elements. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Hebrew',
      units: '3.0',
      PREREQUISITE: ['HEBR 294/3.0 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'CWRI 295': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CWRI 295',
      description:
        'A practical examination of creative writing skills, focused on the writing workshop. The student may concentrate on short\nfiction or poetry, or a combination of the two, throughout the term.\n',
      NOTE: ['Admission is based on writing samples.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Creative Writing I',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUSC 181': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 181',
      description:
        'An introduction to the study of woodwind instruments through class instruction on selected instruments. Fundamental\nplaying techniques and diagnostics will be emphasized. Includes the study of ranges, fingerings, transpositions, basic\ninstrument maintenance, method books and teaching techniques. Rental instruments available.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Woodwind Techniques and Methods I',
      units: '3.0',
      PREREQUISITE: ['(Registration in a BMUS or BMT Plan) or MUSC 104/3.0.'],
      'LEARNING HOURS': []
    },
    'FREN 150': {
      EXCLUSION: [
        'No more than 6.0 units from FREN 150/6.0; FREN 100/6.0; FREN 101/3.0; FREN 102/3.0; FREN 110/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 150',
      description:
        'Practice in reading, writing, grammar review, and literary analysis. For students wishing to complete a major, medial, or minor\nPlan in French.\n',
      NOTE: [
        'Placement test recommended prior to registration.  For information go  to:\nHttp://www.queensu.ca/french/undergraduatestudents/placementtest.html.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Fran\u00e7ais interm\u00e9diaire',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '216 (48L;24T;36O;108P)\nEQUIVALENCY    FREN 100/6.0.\n'
      ]
    },
    'ECON 232': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 232',
      description:
        'The spread of industrialization and economic development in Europe and areas beyond in the late 19th and early 20th\ncenturies. The geographic focus may differ from year to year but Germany, Russia and Japan are usually included.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Diffusion of Modern Economic Growth',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'POLS 364': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 364',
      description:
        'An examination of the concept of international security and the causes of war and conditions of peace. Topics include: the\nrole of nuclear weapons after the Cold War; the economics of security; new security themes (environmental and ethnic\nfactors); regional security and peacekeeping; alliance dynamics; and European security and the future of NATO.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Peace and Security',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENIN 140': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 140',
      description:
        'This course teaches design thinking techniques and their application to real-life case studies. Design Thinking takes a cross-\ndisciplinary approach wherein students from various academic and professional backgrounds engage in co-creation, peer\nreview, online discussions, brainstorming, and prototyping activities.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Media and Design Thinking',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (72O;48P)\nEQUIVALENCY    FILM 140/3.0.']
    },
    'INUK 101': {
      EXCLUSION: ['LLCU 101/3.0 (Topic: Inuktitut).'],
      RECOMMENDATION: [],
      code: 'INUK 101',
      description:
        'Beginning Inuktitut Language and Culture\nAn introduction to the history and culture of the Inuit of Canada with particular emphasis on their language, Inuktitut, in\nboth writing and speaking. This course is designed for those who have little or no exposure to the Inuit language nor the\nhistory of Canada\u2019s Inuit peoples.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 330': {
      EXCLUSION: [
        'No more than one course from HLTH 300/3.0; KNPE 300/3.0; KNPE 330/4.5; KNPE 336/3.0; KNPE 346/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 330',
      description:
        'Under the tutelage of the Coordinator of Athletic Therapy Services, students will complete a field placement that involves\nassignment to a varsity team as a student trainer. Student trainers are responsible for onsite coverage of the team during\ncompetition and possibly during practices. The student trainers are also responsible for the taping needs of athletes on the\nteam, and assisting with assessment and rehabilitation.\n',
      NOTE: [
        'Students must hold valid First Aid/CPR certification and proof of completion of Athletic Therapy experience (36 hours)\nin second year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Athletic Therapy Field Placement',
      units: '4.5',
      PREREQUISITE: [
        'Level 3 or above in a PHED Specialization or KINE Specialization Plan and (ANAT 315/3.0 and KNPE 331/3.0)\nand (a GPA of 2.70) and permission of the course coordinator and the Undergraduate Coordinator in the School of Kinesiology\nand Health Studies.\n'
      ],
      'LEARNING HOURS': ['177 (165Pc; 12P)\n']
    },
    'PHGY 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHGY 499',
      description:
        'An investigation in a selected area of physiology. The project involves experimental design, data collection and analysis,\nsubmission of written reports, and oral presentations. Students attend seminars/tutorials on related topics.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Physiology',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Specialization Plan and a GPA of 2.50.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'POLS 241': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 241',
      description:
        'An examination of how and why societies change and the context in which transformation occurs. Offered annually.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Politics: Transformations',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'HIST 270': {
      EXCLUSION: ['No more than 3.0 units from HIST 270/3.0; HIST 299/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 270',
      description:
        'Contemporary China aims to place the dynamics of recent social and economic change in historical perspective. Rather than\nproceeding both thematically and chronologically, it familiarizes students with the deep continuities with the phenomena\nsuch as urbanization, environmental challenges, cultural expectations, and gender norms.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'ontemporary China',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (48O;72P)\n']
    },
    'DEVS 221': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 221',
      description:
        'Re-evaluation of conventional knowledge based on aboriginal world view and culture and the introduction of a decolonized\nperspective on contemporary issues. Guest speakers will provide detailed examinations of specific topics such as current\nissues in Aboriginal spirituality, art, education and politics.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Aboriginal Studies',
      units: '3.0',
      PREREQUISITE: [
        'DEVS 220/3.0 or permission of the Department of Global Development Studies.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 441': {
      EXCLUSION: ['No more than 3.0 credits from BIOL 441/3.0; PATH 425/3.0.'],
      RECOMMENDATION: [],
      code: 'BIOL 441',
      description:
        'Research in eukaryotic molecular genetics with an emphasis on epigenetics. Epigenetic phenomena will be examined in a\nrange of models from single-celled organisms to metazoans, with student discussions on topics as diverse as bioethics,\ndisease controls, and eugenics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Molecular Genetics',
      units: '3.0',
      PREREQUISITE: [
        '(BCHM 218/3.0 or BIOL 330/3.0 or MBIO 218/3.0) and a minimum GPA of 2.0 in the Biological Foundations\nList.\n'
      ],
      'LEARNING HOURS': ['125 (30L;8S;12Lb;10G;65P)\n']
    },
    'ECON 110': {
      EXCLUSION: [
        'No more than 6.0 units from ECON 110/6.0; ECON 111/3.0; ECON 112/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ECON 110',
      description:
        'Principles of Economics\nAn introduction to economic analysis of a modern mixed economy, including the roles of government. The microeconomics\npart of the course analyzes the behaviour of individual consumers and producers and the functioning of the market price\nsystem. The macroeconomics part examines the functioning of the economy as a whole, including the determination of\nnational income, the price level, interest rates, the money supply, and the balance of payments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;24O;144P)\n']
    },
    'SPAN 344': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 344',
      description:
        'A study of changes in Spanish society as reflected in film and/or literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'La sociedad espa\u00f1ola a trav\u00e9s del cine',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 381/3.0.\nCOREQUISITE    (SPAN 301/3.0 and SPAN 302/3.0) or (SPAN 303/3.0 and SPAN 304/3.0).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PSYC 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 321',
      description:
        'An introduction to psycholinguistic research and theory. Topics include the development of language, language perception,\nlanguage production, and linguistic representation. Particular attention will be paid to applied issues in language research\n(e.g., speech pathology, language aids, and automatic recognition of speech).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Psycholinguistics',
      units: '3.0',
      PREREQUISITE: [
        'PSYC 221/3.0 and [PSYC 203/3.0 or (Level 3 or above and registration in a LING Plan and a grade of B- in\nPSYC 100/6.0)].'
      ],
      'LEARNING HOURS': []
    },
    'ARTF 447': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTF 447',
      description:
        'In fourth year, each student must submit a proposal for an individual program of creative exploration and research. This can\nbe based on one or more of the following areas: painting, print media, 3-D media. Instruction at this level is through\nindividual tutorials and critiques, although all students will meet once a week for a common seminar.\n',
      NOTE: ['Open only to students in a BFA Program.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Individual Programs I',
      units: '9.0',
      PREREQUISITE: [
        'Level 4 and (a GPA of 2.60 in ARTF 337/9.0 and ARTF 338/9.0) and (a grade of C- in ARTH 120/6.0) and (a\nminimum of 6.0 units in ARTH at the 200-level) and a GPA of 1.90.'
      ],
      'LEARNING HOURS': ['309 (9S;12I;288P)\n']
    },
    'PHGY 444': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHGY 444',
      description:
        'The mechanisms and regulation of motor, secretory, digestive, and absorptive functions of the gastrointestinal tract are\nconsidered in lectures and seminars. Students are required to prepare and present reviews of original literature.\n',
      NOTE: [
        'The normal classroom time of 36 hours is spread over two terms.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Gastrointestinal Physiology',
      units: '3.0',
      PREREQUISITE: [
        '(A minimum grade of C in PHGY 210/6.0 or PHGY 214/6.0 or PHGY 212/6.0) and Level 4 and (registration in\na LISC Major or Specialization Plan) and (a GPA of 2.5) or permission of the course coordinator.'
      ],
      'LEARNING HOURS': []
    },
    'ENSC 425': {
      EXCLUSION: [],
      RECOMMENDATION: ['ENSC 201/3.0.\n'],
      code: 'ENSC 425',
      description:
        'An exploration of the interactions among chemical exposure, toxicity to individual organisms, and effects on ecosystem\nstructure and function. Mechanisms of toxicity will be linked to effects at different levels of organization up to the level of\nthe ecosystem, using case studies to explore the complexities of exposure and response.\n',
      NOTE: ['Field trip: estimated cost $20.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Ecotoxicology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 standing and (BIOL 102/3.0 and 103/3.0) and (CHEM 112/6.0).'
      ],
      'LEARNING HOURS': ['126 (24L;12T;6Oc;84P)\n']
    },
    'ENGL 200': {
      EXCLUSION: ['No more than 6.0 units from ENGL 110/6.0; ENGL 200/6.0.'],
      RECOMMENDATION: [],
      code: 'ENGL 200',
      description:
        'An historical survey of literature from the British Isles and beyond. Through the study of representative works, the course\naims to familiarize students with the characteristics of literary periods from the Middle Ages to the present.\n',
      NOTE: [
        'Enrolment preference is given to students registered in ENGL Plans.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'History of Literature in English',
      units: '6.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'ARTH 316': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 316',
      description:
        'A study of Renaissance art and architecture through examples found in Britain and British collections.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Renaissance Art and Architecture in Britain',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'HIST 465': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 465',
      description:
        'Comparative studies in the history of women and their experiences. Topics will vary from year to year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Women\u2019s History',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'GEOL 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 235',
      description:
        'Introduction to the genesis and characterization of igneous and metamorphic rocks. Students will acquire skills to classify\nrocks and the theoretical background to place these rocks in the context of where, why, and how they form with\nimplications for resource exploration and utilization. Macroscopic and microscopic properties will be studied.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Igneous and Metamorphic Petrology',
      units: '3.0',
      PREREQUISITE: ['GEOL 232/3.0.'],
      'LEARNING HOURS': []
    },
    'BIOL 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 315',
      description:
        'Human civilization depends on plants. We have changed them and they have changed us. This course investigates the\nbiology and evolution of valuable economic plants, the science of plant domestication and genetic manipulation, and how\nour interactions with plants have altered the economy, politics, and sociology of human civilization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Plants and Human Culture',
      units: '3.0',
      PREREQUISITE: ['BIOL 102/3.0 and BIOL 103/3.0 and BIOL 201/3.0.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'POLS 443': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 443',
      description:
        'General issues and selected specific topics reflecting an interdisciplinary approach combining international political\neconomy, feminist theory and comparative politics. Case studies from both industrialized and developing nations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Globalization',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PSYC 355': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 355',
      description:
        'Advanced study in comparative cognition with a focus on the evolution and function of cognitive processes across animal\nspecies. Through lectures, laboratory activities, and readings, theory and research methodology in the areas of number,\ntiming, casual reasoning, social learning, tool use, social cognition, and communication will be discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Cognition: Cognitive Origins Laboratory',
      units: '3.0',
      PREREQUISITE: [
        '[PSYC  203/3.0 and (PSYC 205/3.0 taken in Fall 2015 or onward) or (Level and registration in a BCHM, BIOL,\nor LISC Plan).'
      ],
      'LEARNING HOURS': ['120 (18L;18Lb;12O;72P)\n']
    },
    'MUSC 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 100',
      description:
        'Small Ensemble\nChamber music or small ensemble experience for qualified instrumentalists and singers. Topics vary. Course includes\nweekly or bi-weekly coachings and a minimum of one evaluation and/or concert per term for all students. Credit attained\nonly with regular attendance, active participation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': []
    },
    'RELS 266': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 266',
      description:
        'Moral problems and religious responses: e.g., sexual morality; violence; civil disobedience.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Social Ethics',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 219': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 219',
      description: 'For students with immersion background.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': ['May not be taken with or after FREN 320/3.0.'],
      title: 'Communication et culture IV',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36L;18Lb;60P)\n']
    },
    'LANG 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LANG 101',
      description:
        'For students studying abroad or at a Canadian University who wish to learn a modern language other than English and who\nhave no previous knowledge of that language. A basic level of understanding, speaking, reading, and writing in the\nlanguage. An introduction to elements of culture of the countries in which the language is spoken.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Language Acquisition - Beginning Level I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    LANG P10/3.0.']
    },
    'SOCY 210': {
      EXCLUSION: [
        'No more than 3.0 units from BMED 270/3.0; GPHY 240/3.0; SOCY 210/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 210',
      description:
        'Examination of relationship between sociological theory and methods of social research; topics include logic of research,\nhypothesis formulation, and variables and their operationalization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social Research Methods',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'Topics in Modern': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'Topics in Modern',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ENGL 466/3.0',
      units: 'Contemporary Canadian Literature I',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'Students explore the prevalence of pseudohistory in Canadian popular media and apply critical tools to identify these': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code:
        'Students explore the prevalence of pseudohistory in Canadian popular media and apply critical tools to identify these',
      description:
        'modern myths. From ancient aliens to destroyed civilizations, why does history inspire theories about lost civilizations, dark\nconspiracies, apocalyptic predictions or mysterious technologies? How do we tell the truth from the bunk?\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History vs Pseudohistory',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['168 (36S;36O;96P)\n']
    },
    'MUSC 255': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'Experience in music composition is encouraged but not a prerequisite.'
      ],
      code: 'MUSC 255',
      description:
        'Basic techniques of electroacoustic music composition, including recording, sound editing, synthesis, MIDI, sequencers and\nsynthesizer voicing. Emphasis is also placed on the history and aesthetics of electroacoustic music through listening,\ndiscussion and analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Electroacoustic Music Composition',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ECON 322': {
      EXCLUSION: ['No more than 3.0 units from ECON 322/3.0; COMM 324/3.0.'],
      RECOMMENDATION: [],
      code: 'ECON 322',
      description:
        'An in-depth coverage of portfolio selection theory, performance evaluation and derivative pricing theory. Portfolio risk\nmanagement and hedging are introduced. Discussions on widely used derivative products including futures and options.\nStudents will be exposed to the most recent developments in financial markets.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Financial Markets and Risk Management',
      units: '3.0',
      PREREQUISITE: [
        'ECON 212/3.0 and (ECON 250/3.0 or STAT 263/3.0); MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or\n[MATH 123/3.0 and MATH 124/3.0] or MATH 126/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;12G;72P)\n']
    },
    'SOCY 344': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 344',
      description:
        'Critical study of Canada\u2019s socio-economic structures and processes: topics include dynamics of capitalist development,\nglobal restructuring, labour force transformations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Power and Change in Canada',
      units: '3.0',
      PREREQUISITE: [
        ' A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 321',
      description:
        'This course explores the society and culture of Early Modern Europe (ca 1500-1800). Students will read and discuss recent\nworks of social and cultural history concerning peasants, impostors, heretics, missionaries, Asians, Persians, kings, and popes in\nEurope. Topics will include: Religion, Popular Culture, Carnival, Witchcraft, Marriage and Family Life, Imperialism, Courts, Social\nCriticism, Enlightenment, and Revolution.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ocial and Cultural Change in Europe, 1500-1800',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'ENGL 273': {
      EXCLUSION: [
        'No more than 3.0 units from ENGL 273/3.0; GRMN 429/3.0; LLCU 329/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 273',
      description:
        'A study of literature dealing with the fantastic or containing supernatural or uncanny elements.  This course may include\nsamples of myth, romance, Gothic literature, and fantasy from a variety of periods.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and the Fantastic',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 476': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 476',
      description:
        'Advanced study of surveillance engaging with sociological, political, cultural and geographic perspectives. The focus is on\ncore topics in Surveillance Studies including: the relationship between surveillance, power and social control; the concept of\nprivacy, its history, utility and future; surveillance, pleasure and consumption; and surveillance in popular culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topics in Surveillance Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and SOCY 309/3.0 and  (a minimum grade of C in\nSOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 200': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 200/6.0; DRAM 201/3.0; DRAM 202/3.0; DRAM 210/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 200',
      description:
        'A chronological survey of production methods, architecture, performance, and dramatic literature in western and eastern\ntheatre traditions from early classical eras to the end of the 19th century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theatre History and Literature I',
      units: '6.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['240 (72L;60O;108P)\n']
    },
    'LLCU 332': {
      EXCLUSION: ['No more than 3.0 units from LLCU 332/3.0; SPAN 332/3.0.'],
      RECOMMENDATION: [],
      code: 'LLCU 332',
      description:
        'Short theatre played an important role in the theatre of Spanish Golden Age. In this course students will study the literary\nparticularities of the genre and the social ramifications of the themes present in short theatre (gender, battle of the sexes,\ndiversity, authority amongst others) and their historical and contemporary relevance.\n',
      NOTE: ['Readings are in translation.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Spanish Baroque Short Theatre',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DEVS 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 501',
      description:
        'The course will involve a critical review of the literature on a clearly-defined topic relevant to development, a synthesis of\nideas, and a final thesis under the supervision of a faculty member.\n',
      NOTE: [
        'The student must identify a willing supervisor from DEVS or a cognate department and receive permission of the\nDepartment of Global Development Studies.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis in Development Studies',
      units: '6.0',
      PREREQUISITE: [
        'Minimum Cumulative GPA of 3.50 and Level 4 and registration in the DEVS Major or Medial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'EMPR 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 250',
      description:
        'This course introduces students to employment relations practices and legislative frameworks related to workplace health\nand wellness. The course examines roles and responsibilities of employers, employees, and unions in occupational health\nand safety. Students will explore efforts to address stress and promote wellness, including mental health.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Managing Workplace Health, Safety, and Wellness',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHYS 313': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 313',
      description:
        'Introduction to Linux and a programming language. Foundations and limitations of numerical calculations. Code\ndevelopment, debugging, optimization and profiling. Algorithms and techniques used in physics problems. Possible topics to\nbe covered include numerical differentiation and integration, root finding and optimization problems, solution of linear\nsystems of equations, Monte Carlo simulations, symbolic computation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computational Methods in Physics',
      units: '3.0',
      PREREQUISITE: [
        '(PHYS 212/3.0 and PHYS 239/3.0) and (MATH 221/3.0 or MATH 280/3.0) and (MATH 225/3.0 or MATH\n231/3.0 or MATH 232/3.0).\n'
      ],
      'LEARNING HOURS': []
    },
    'GEOL 282': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 282',
      description:
        'Managing Earth Systems: Resources and Environment\nAn earth-system engineering perspective on the nature, acquisition and utilization of energy, mineral and water resources,\nwith particular emphasis on the environmental considerations in their extraction, processing, and use. Criteria for designing\nresource exploration programs are examined. Practical exercises, projects and seminars (team and individual) deal with\nthese issues, and include the design of risk-management plans, environmental life-cycle assessments, sustainable systems\nand ore-reserve estimations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'GEOL 221/3.0 or GEOL 232/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 490': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 490',
      description: 'Content varies. Not offered every year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Computing Science I',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'PSYC 495': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 495',
      description:
        'Seminar and lab course on an advanced topic in psychology offered periodically by visiting professors.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topic in Psychology',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (12L;24S;84P)']
    },
    'RELS 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 331',
      description:
        'Links between violence and religious beliefs, practices and institutions; for example, sacrifice, holy wars, scapegoating, and\nsuicide.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Violence',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'POLS 511': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 511',
      description:
        'Students arrange their course of reading in consultation with members of the Department. They are expected to write\nreports on their readings and to discuss them in seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (9I;111P)\n']
    },
    'PSYC 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 351',
      description:
        'An overview of the development of emotions and their regulation. Topics range from basic emotions in infancy and\ninteractions with caregivers that lay the foundations of socialized behaviour to the emotional upheaval and radical social\nchanges of adolescence. Individual differences in social and emotional behaviour will be considered in light of both typical\nand atypical development.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social and Emotional Development',
      units: '3.0',
      PREREQUISITE: ['PSYC 251/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHGY 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHGY 350',
      description:
        'An introductory course in Pathophysiology in which the underlying functional changes of cell and cell systems will be\ndiscussed in association with a variety of disease processes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Pathophysiology',
      units: '3.0',
      PREREQUISITE: [
        'PHGY 210/6.0 or PHGY 214/6.0 or (KNPE 125/3.0 and KNPE 225/3.0) or PHGY 212/6.0.'
      ],
      'LEARNING HOURS': ['114 (36L;6O;72P)\n']
    },
    'GEOL 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 200',
      description:
        'Introduction to marine science. Topics include: ocean basins and their sediments; seawater chemistry/biochemistry; ocean\nwaves, tides and currents; ocean-atmosphere interaction; polar to tropical organism communities; marine resources;\nenvironmental concerns; global change.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Oceanography',
      PREREQUISITE: [
        'PHYS 104/6.0 or PHYS 106/6.0 or PHYS 107/6.0 or PHYS 117/6.0 or CHEM 112/6.0 or BIOL 102/3.0 or BIOL\n103/3.0 or GEOL 104/3.0 or GEOL 106/3.0 or GEOL 107/3.0.'
      ],
      'LEARNING HOURS': ['114 (36L;12Pc;12O;48P)\n']
    },
    'LLCU 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 501',
      description:
        'This course enables a student or a group of students to explore a body of literature on a selected topic in Languages,\nLiteratures, and Cultures. The focus may be by theme, by region, or academic approach and can span the humanities, social\nsciences, and environmental sciences.\n',
      NOTE: [
        'The student(s) is responsible for approaching a professor with whom they wish to work and who is willing to\nundertake this project.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Readings in Languages, Literatures and Cultures',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 342': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 342',
      description:
        'Through lectures, readings, and research, this course explores the nature, practice, and impact of photography in Canada\nbetween 1839 and 1939. By examining how the new medium was used to confirm, complement, and contest older forms of\naesthetic expression, written documentation, or visual evidence, it traces the role of photography in Canadian society\nduring this critical period of Canadian nation building.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Photography in Canada 1839-1939',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'HIST 313': {
      EXCLUSION: ['No more than 1 course from HIST 278/3.0; HIST 313/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 313',
      description:
        'This course will survey the political, social, economic, and cultural development of the British colonies that became Canada\nfrom the conquest of Quebec to Confederation. Native-newcomer relations, the maturation of settler societies, and new\ninstitutional structures will receive special attention. Different historical approaches and the use of primary sources will be\nemphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ritish North America, 1759-1867',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'GPHY 207': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 207',
      description:
        'An examination of ecological and earth system processes that affect the dynamics of organisms, their spatial patterns and\ntheir variability in time.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Biogeography',
      units: '3.0',
      PREREQUISITE: [
        '3.0 units from GPHY 102/3.0; BIOL; GEOL or permission of the Department.'
      ],
      'LEARNING HOURS': ['114 (36L;18Pc;12I;48P)\n']
    },
    'GRMN 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 201',
      description:
        'A continuation of GRMN 102/3.0 aimed at expanding basic language skills (listening, reading, writing and speaking). Students will\nreview and deepen their knowledge of grammatical structures through exposure to a variety of German-language media and\nculture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate German I',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 102/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'ECON 411': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 411',
      description:
        'Content varies from year to year. Game theory, risk, and externalities are among the topics covered in recent years.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Microeconomic Theory',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 285': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 285',
      description:
        'A course focusing on the socio-cultural and political aspects of African and Caribbean cinemas.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Cin\u00e9ma et soci\u00e9t\u00e9: aspects culturels de la francophonie',
      units: '3.0',
      PREREQUISITE: [
        'FREN 150/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 100/6.0 or FREN 110/6.0.'
      ],
      'LEARNING HOURS': []
    },
    'GNDS 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 340',
      description:
        'Examines scholarship, creative works, and activism by Indigenous women as a basis for introducing Indigenous feminist\nthought. Cases examine the many ways that Indigenous women and LGBTQ/Two-Spirit people participate in Indigenous\nnations, experience and resist settler colonialism, and work for Indigenous decolonization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Indigenous Women, Feminism and Resistance',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 209': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 209',
      description:
        'The principles of energy and water exchange between the atmosphere, surface and subsurface. The hydrological cycle,\nradiation, and energy balances are used as conceptual frameworks.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Hydroclimatology',
      units: '3.0',
      PREREQUISITE: ['GPHY 102/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['114 (36L;18Pc;60P)\n']
    },
    'POLS 461': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 461',
      description:
        'An exploration of problems of order and change in the international system with particular attention to the theory and\npractice of co-operation, ranging from classic concepts of international organization to current debates about international\nregimes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Regimes',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 421',
      description:
        'A detailed study of one area or topic in the history of early 20th-century art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Early 20th-century Visual and Material Culture',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'INTS 324': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 324',
      description:
        'A study of thematic and stylistic approaches to the representation of selected cultures and to the presentation and\nevocation of global issues in one or more of the fine, performing or media arts. Topics will vary each year. For detailed\ncourse description, see www.queensu.ca/bisc\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'International Perspectives in the Creative Arts II',
      units: '3.0',
      PREREQUISITE: ['Level 2 in the relevant arts discipline.'],
      'LEARNING HOURS': []
    },
    'ENGL 482': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 482',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Indigenous Literatures II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ECON 423': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 423',
      description:
        'Selected topics in financial economics. Topics may include: the microeconomics of banking; pricing of financial instruments;\nrisk management and financial markets infrastructure; financial choices under uncertainty and general equilibrium.\nStudents are directed to the undergraduate website for a detailed description yearly.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Financial Economics',
      units: '3.0',
      PREREQUISITE: [
        'ECON 310/3.0 and ECON 322/3.0.\nCOREQUISITE    ECON 351/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENSC 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 301',
      description:
        'The course explores components of environmental assessment including public consultation, scoping, alternatives,\nprotocols, significance, trade-offs, mitigation and monitoring. Biophysical, cumulative, social, strategic and sustainability\nassessment through case studies highlight strengths and weaknesses of the environmental assessment process.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Assessment',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['114 (12L;24G;78P)\n']
    },
    'PSYC 342': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 342',
      description:
        'This course reviews theory and research on the processes by which people exert influence on one another\u2019s behaviours,\nbeliefs, emotions, and attitudes. Topics of study include conformity, compliance, obedience, and persuasion. The course\nwill focus on both the theoretical and applied implications of social influence research.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Psychology of Social Influence',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 110': {
      EXCLUSION: [
        'No more than 3.0 units from APSC 142/3.0; CISC 101/3.0; CISC 110/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'CISC 110',
      description:
        'Introduction to fundamental programming concepts in the context of visual, interactive media. Students may develop\napplications in any domain (e.g., fine art, education, commerce, physical or social sciences) while learning about algorithms,\nprogram design, logic, program control flow, functions, testing, etc.\n',
      NOTE: ['No computing or art background required.\n'],
      'ONE-WAY EXCLUSION': ['May not be taken with or after CISC 121/3.0.'],
      title: 'Creative Computing',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 333': {
      EXCLUSION: ['No more than 3.0 units from CLST 330/3.0; CLST 333/3.0.'],
      RECOMMENDATION: [],
      code: 'CLST 333',
      description:
        'Study of the rise of Athenian power from the end of the Persian Wars in 479 BCE, and the conflict between Athens and\nSparta along with their allies during the Peloponnesian War (431-404 BCE). Topics may include the Delian League and\nAthenian imperialism, development of radical democracy in Athens, and causes and effects of the Peloponnesian War.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'The Rise of the Athenian Empire to the End of the Peloponnesian War',
      units: '3.0',
      PREREQUISITE: ['CLST 200/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'ARTF 106': {
      EXCLUSION: [
        'No more than 1 course from ARTF 101/3.0; ARTF 105/6.0; ARTF 106/3.0; ARTF 127/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'ARTF 106',
      description:
        'An exploration, through the processes of drawing and painting, of a wide variety of visual problems encountered by the\ncontemporary artist.\n',
      NOTE: [
        'Not available for credit towards a B.F.A. program.\n',
        'Materials: estimated cost $200.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Fine Art (Drawing and Painting)',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'LLCU 316': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 316/3.0; SPAN 316/3.0; SPAN 406/3.0.\nEQUIVALENCY    SPAN 316/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 316',
      description:
        'An introduction to contemporary literary theories and the analysis of Hispanic texts from reader-, structural-, and author-\noriented perspectives.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Contemporary Literary Theory and Analysis',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 464': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 464',
      description:
        'A study of the theory and practice of modernist writers in Britain and North America. Texts will include theoretical\nmanifestoes as well as creative writing. Some attention will be given to the modernist movement in other arts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literary Modernism',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'HEBR 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 393',
      description:
        'Selections from current Israeli media including music, newspapers and television, as well as from modern Hebrew prose and\npoetry (e.g., Ahad Haam, Bialik, Tchernichowski, Agnon, Amichai, Oz, Yehoshua). The selections are studied in Hebrew; written\nassignments may be submitted in English.',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Reading Modern Hebrew Literature',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'HIST 391': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 391',
      description:
        'Seminar on a selected topic in Canadian history. Topics change from year to year; course is either being offered for the first\ntime or is being taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Canadian History',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'SPAN 496': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 496',
      description:
        'Seminar courses on topics in Spanish American literature. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literatura de Hispanoam\u00e9rica: Estudios independientes II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SPAN Major or SLAS Specialization Plan or permission of the Department of\nLanguages Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 450',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Victorian Literature',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'POLS 485': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 485',
      description:
        'An examination of key issues in gender and politics. Topics will vary from year to year; consult the departmental homepage.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Gender and Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (36S;12G;72P)\n']
    },
    'CHEM 212': {
      EXCLUSION: ['No more than 3.0 units from CHEM 212/3.0; CHEM 281/3.0.'],
      RECOMMENDATION: [],
      code: 'CHEM 212',
      description:
        'An introduction to the kinetics and mechanisms of reactions in gaseous and condensed phases, including acid-base and\nnucleophilic substitution reactions at carbon and other main group centers. Other topics will include molecular dynamics\nand reactions in solution. The laboratory illustrates measurement techniques and develops laboratory skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Chemical Reactivity',
      units: '3.0',
      PREREQUISITE: [
        'CHEM 112/6.0 and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or [MATH 123/3.0 and MATH\n124/3.0]).\n'
      ],
      'LEARNING HOURS': ['126 (36L;18Lb;72P)\n']
    },
    'HIST 517': {
      EXCLUSION: ['No more than 1 course from HIST 515/6.0; HIST 517/3.0.\n'],
      RECOMMENDATION: [],
      code: 'HIST 517',
      description:
        'The paper may be either a research project involving the use of primary and secondary sources, or a more broadly\nconceived independent reading program.\n',
      NOTE: [
        'Students must obtain the approval of the supervising instructor and of the Undergraduate Committee for any\nproject submitted.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'ndependent Study Project',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registered in a HIST Major or Medial Plan) and (a GPA of 3.30) and (30.0 units in HIST).\n'
      ],
      'LEARNING HOURS': ['120 (120P)\n']
    },
    'GPHY 402': {
      EXCLUSION: [
        'No more than 3.0 units from GPHY 401/3.0; GPHY 402/3.0; GPHY 403/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 402',
      description:
        'Seminars offered by regular and visiting faculty on Geography topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each academic year.\n',
      NOTE: [
        'Field trip fees may apply in certain years. See departmental webpage for more information. Cost will vary\ndepending on location, but not likely to exceed $300 per year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Seminar in Human Geography II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (a GPA of 2.60 in 24.0 units in GPHY and registration in a GPHY Major or Medial [Arts] Plan).\n'
      ],
      'LEARNING HOURS': ['132 (36S;24Oc;72P)\n']
    },
    'HIST 446': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 446',
      description:
        'This course explores sex, gender, man, woman, as products of particular cultural and scientific contexts, drawing on South\nAsian material. Themes include sexuality in Hindu mythology, colonial masculinity, sex and the body in Gandhi\u2019s thought,\nthe gendered underpinnings of imperial ideologies, transnational feminism and its postcolonial critics, and the expression of\nqueer identities in South Asia.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ender, Sexuality and Race in South Asia',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'POLS 261': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 261',
      description:
        'International Politics\nAn introduction to the major issues in the study of international relations: questions of war and peace, national security,\nthe role of the \u2018state\u2019, foreign and defence policy, gender and international relations, and international institutions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'LING 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 350',
      description:
        'This course introduces the linguistic study of historical language change. The focus is on principles and method in the study\nof phonological, morphological and syntactic change. Case studies will be drawn from a cross-section of languages,\nincluding but not limited to members of the Indo-European language family.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Historical Linguistics',
      units: '3.0',
      PREREQUISITE: [
        'LING 320/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (18L;18G;84P)\n']
    },
    'POLS 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 320',
      description:
        'An examination of First Nations politics in a Canadian context, including aboriginal self-government.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'First Nations Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 406': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 406',
      description:
        'Construction and properties of finite fields. Polynomials, vector spaces, block codes over finite fields. Hamming distance\nand other code parameters. Bounds relating code parameters. Cyclic codes and their structure as ideals. Weight\ndistribution. Special codes and their relation to designs and projective planes. Decoding algorithms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Coding Theory',
      units: '3.0',
      PREREQUISITE: ['MATH 210/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHGY 214': {
      EXCLUSION: [
        'No more than 6.0 units from IDIS 150/6.0; KNPE 125/3.0; KNPE 225/3.0; PHGY 210/6.0; PHGY 214/6.0; PHGY\n212/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHGY 214',
      description:
        'The function of organs, body systems, and the integration of functions in the whole body.\n',
      NOTE: [
        'Students in a KINE, HLTH; PHED or NURS Plan should not register in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Mammalian Physiology',
      units: '6.0',
      PREREQUISITE: [
        'A minimum GPA of 2.0 in BIOL 102/3.0 and BIOL 103/3.0.\n'
      ],
      'LEARNING HOURS': ['288 (72L;216P)\n']
    },
    'POLS 388': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 388',
      description:
        'Focusing on issues of citizenship and non-citizenship in the modern world. How issues of nationality and nationalism,\nminority rights, gender, class, race and ethnicity, and immigration status impact on the rights and obligations of citizenship\nand central to the politics of these debates. The relevance of these issues to the current Canadian context will be an\nongoing theme of the course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Citizenship and Non-Citizenship',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 100',
      description:
        'Ancient Greek and Roman literature in translation: Homer\u2019s Iliad and Odyssey and Greek drama; Vergil\u2019s Aeneid and\nselections from other Latin authors. Reference to ancient customs, history, mythology, thought.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Classical Literature',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['252 (72L;180P)']
    },
    'PHIL 348': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 348',
      description:
        'An examination of the concept of freedom of the will, with emphasis on the problems generated by causation and the\nnotion of responsibility.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Freedom of the Will',
      units: '3.0',
      PREREQUISITE: [
        'PHIL 250/6.0 or PHIL 257/6.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 340',
      description:
        'Deals with the role of religion in the public sphere and its relation to liberal democracy. It examines the (in)compatibility of\nsome tenets of certain religions with modern democratic principles.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Democracy',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'STAT 455': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 455',
      description:
        'Markov chains, birth and death processes, random walk problems, elementary renewal theory, Markov processes,\nBrownian motion and Poisson processes, queuing theory, branching processes. Given jointly with STAT 855/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Stochastic Processes and Applications',
      units: '3.0',
      PREREQUISITE: [
        'STAT 353/3.0 or (STAT 269/3.0 or STAT 351/3.0 with permission of the Department).'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'HIST 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 451',
      description:
        'he Experience of War in 20th Century Europe\nAn examination of transformations in the conception, practice and experience of war in 20th century Europe with a focus\non the two World Wars. Topics include international law, gender and the home-front, trench warfare, popular violence and\ngenocide, collaboration and resistance, and memory. Students will read primary sources such as diaries, letters and novels\nas well as scholarly literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ENGL 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 335',
      description:
        'A study of English drama from the medieval to the Restoration period. Emphasis falls on tracing the development of\ndramatic forms, traditions, and performance practices in relation to socio-cultural history.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'English Drama to 1700',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'FILM 370': {
      EXCLUSION: ['No more than one course from FILM 370/3.0; FILM 375/6.0.'],
      RECOMMENDATION: [],
      code: 'FILM 370',
      description:
        'Intermediate critical and historical study in the avant-garde of the international cinema, based on selected examples principally\nfrom Europe, the United States and Canada.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Experimental Tradition',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\n'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'GRMN 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 101',
      description:
        'This course is for students with no previous knowledge of German. The course concentrates on the basic language skills\n(listening, reading, writing and speaking) and introduces elements of German culture as recorded in its customs, history and\nliterature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after GRMN 102/3.0; GRMN 201/3.0; GRMN 202/3.0.'
      ],
      title: 'Beginner\u2019s German I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;120;72P)\n']
    },
    'BIOL 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 502',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Plant Cellular Responses to Environmental Stress',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List  and (BIOL 330/3.0 or BIOL 334/3.0\nor BIOL 341/3.0 or BIOL 430/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CISC 101': {
      EXCLUSION: [
        'No more than 3.0 units from APSC 142/3.0; CISC 101/3.0; CISC 110/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'CISC 101',
      description:
        'Introduction to algorithms: their definition, design, coding, and execution on computers. Intended for students who have\nno programming experience. All or most assignment work will be completed during lab time.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after: CISC 121/3.0; CISC; SOFT at the 200-level and above.'
      ],
      title: 'Elements of Computing Science',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;36Lb;48P)\n']
    },
    'ARTH 228': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 228',
      description:
        'This course will examine the histories, meanings, and sites of contemporary art in the metropolitan West from the 1960\u2019s to\nthe present. Students will become familiar not only with the works themselves, but with shifts in critical conceptions and\npopular media that affect both the production and reception of contemporary art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Histories of Contemporary Art',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;12G;12O;72P)\n']
    },
    'INTS 313': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 313',
      description:
        'This course will offer a unique opportunity to study a special topic in Modern European Studies. Topics will vary each term,\nand the course may not be offered every year. For a detailed course description, see www.queensu.ca/bisc\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Modern European Studies II',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'CLST 214': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 214',
      description:
        'Ancient concepts of nature and of natural phenomena: what did the ancients (e.g. Babylonians and Greeks) know about the\nnatural world and how did they come to know it?\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ancient Science',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'FILM 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 422',
      description:
        'Advanced seminar on specific area of research and study selected by the instructor. Subjects have included Qu\u00e9b\u00e9cois\ncinema, film and mass culture in Canada.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Cinema: Special Topic',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'PHYS 118': {
      EXCLUSION: [
        'No more than 6.0 units from PHYS 104/6.0, PHYS 106/6.0; PHYS 117/6.0; PHYS 118/6.0.'
      ],
      RECOMMENDATION: ['4U Physics is recommended.\n'],
      code: 'PHYS 118',
      description:
        'An algebra-based course dealing with basic Physics concepts, including dynamics, fluids, waves, electromagnetism, and\nbasic optics. Emphasis is placed on the development of problem-solving skills through the use of Mastery based course\ndelivery.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Basic Physics',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['228 (132O;96P)\n']
    },
    'PHYS 454': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 454',
      description:
        'Groups of students in physics and engineering physics undertake a large design project of their choice that reflects and\nfurther develops their knowledge of physics. The students then build a prototype of their design to demonstrate the\nfeasibility of the project within the design constraints.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Physics Design Project',
      units: '3.0',
      PREREQUISITE: ['PHYS 350/3.0.'],
      'LEARNING HOURS': ['132 (72L;60P)\n']
    },
    'CRSS 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CRSS 456',
      description:
        'An intensive course surveying the molecular and cellular mechanisms underlying the pathophysiology of the major\ncardiovascular diseases, and the current and emerging tolls used in their diagnosis and treatment. Alterations in signalling,\nmetabolism, and structure and function will be discussed to present an integrative view of how cardiovascular diseases\ndevelop and progress.\n',
      NOTE: ['Priority given to students in the CRSS Sub-Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Molecular and Cellular Basis of Cardiovascular Disease',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Major or Specialization Plan and a GPA of 2.5 and (PHGY 210/6.0 or PHGY\n214/6.0 or PHGY 212/6.0).'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 424': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 424',
      description:
        'This course provides a comprehensive and critical assessment of contemporary issues on social aging. This course focuses\non how society and its major institutions have reacted to the aging of society as well as how they have shaped it. The social-\npsychological, social structural (gender, race and social class) and cultural factors that influence a person\u2019s experience of\naging are examined.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Aging',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'CHEM 114': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 112/6.0 or (CHEM 113/3.0 and CHEM 114/3.0).'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 114',
      description:
        'A quantitative treatment of chemical phenomena and materials. Critical thinking and problem solving are emphasized.\nTopics include atomic thermodynamics, chemical equilibria, acids and bases, kinetics, electrochemistry.\n',
      NOTE: [
        'Only offered online. Consult Arts and Science Online.\n',
        'Not appropriate for pre and upper level courses that have a laboratory component.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'General Chemistry II: Thermodynamic and Kinetics',
      units: '3.0',
      PREREQUISITE: ['CHEM 113/3.0.\n'],
      'LEARNING HOURS': ['126 (54O;72P)\n']
    },
    'FILM 368': {
      EXCLUSION: ['No more than one course from FILM 368/3.0; FILM 385/6.0.'],
      RECOMMENDATION: [],
      code: 'FILM 368',
      description:
        'A course on the history, theory, and practice of animated films. Requirements include a series of screenings, writings, and a\npractice based critical project.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Animation Theory and Criticism',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\n'
      ],
      'LEARNING HOURS': ['108 (36L;12Oc;60P)\n']
    },
    'GRMN 317': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 317',
      description:
        "This course's aim is threefold: to improve students' comprehension and production of oral and written German through practice\nin reading, writing, listening and speaking; to increase their knowledge of contemporary issues in Germany, with a special focus on\ntransnational perspectives; and to better their analytic skills and media literacy.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Germany through Media and News',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120.5 (36S;12.5G;72P)\n']
    },
    'PHIL 347': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 347',
      description:
        'A critical survey of some recent trends in moral philosophy. Study will begin with the emotive theory of ethics, and end with\nvery recent works of importance in the field.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Moral Philosophy',
      units: '3.0',
      PREREQUISITE: ['PHIL 257/6.0 or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'WRIT 225': {
      EXCLUSION: ['No more than 3.0 units from WRIT 225/3.0; WRIT 195/3.0.\n'],
      RECOMMENDATION: [],
      code: 'WRIT 225',
      description:
        'Offering modules on ten types of writing often encountered in various academic fields in university, this course allows\nstudents to develop assignments based on the five most relevant to their program. Options range from reviews and lab\nreports to position papers and annotated bibliographies, complemented by a Grammar and Mechanics Assessment.\n',
      NOTE: ['Offered only online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing in Academic Contexts',
      units: '3.0',
      PREREQUISITE: [' WRIT 125/3.0'],
      'LEARNING HOURS': ['114 (36O;78P)\nEQUIVALENCY    WRIT 195/3.0.\n']
    },
    'ENSC 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 501',
      description:
        'Independent Environmental Study\nIndependent study of an environmental topic by individuals or inter-disciplinary groups.\n',
      NOTE: [
        'This course is intended for a self-motivated student with an established record of undergraduate performance, i.e.\ncumulative GPA of approximately 3.0. It is the responsibility of the student to secure a supervisor prior to registering in the\ncourse.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        "Open to students in the final year of an honours program in any discipline, and with permission of the\ninstructor of the course and of the Department of the student's Plan."
      ],
      'LEARNING HOURS': ['228 (48I;180P)\n']
    },
    'CISC 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 435',
      description:
        'Fundamental concepts in the design and implementation of computer communication networks, protocols, and\napplications. Overview of network architectures; applications; network programming interfaces (e.g., sockets); transport;\ncongestion; routing and data link protocols; addressing; local area networks; wireless networks, mobility\nmanagement; security.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computer Communications and Networks',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 324/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 118': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 118',
      description:
        'This course is designed for students who have completed beginner level French. In this course students will further develop\ntheir written and oral communication skills as well as acquire the means to competently engage in a range of everyday\ncommon social and professional situations.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken after FREN 150/6.0 or FREN 100/6.0.'
      ],
      title: 'Communication et culture III',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (72O;48P)\n']
    },
    'ITLN 332': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 234/3.0; ITLN 332/3.0; LLCU 234/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 332',
      description:
        'A survey of Italian literature, through selected texts of representative authors, from the eighteenth century to the present.\n',
      NOTE: [
        'Taught in English together with LLCU 234/3.0. Students submit written assignments, tests, and examinations in\nItalian.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Survey of Italian Literature II',
      units: '3.0',
      PREREQUISITE: ['ITLN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 421',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Renaissance Literature I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'BIOL 539': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 539',
      description:
        'Research practicum under the supervision of a Biology faculty member. The course will involve a combination of research in\nthe host laboratory, attendance of BIOL 537/12.0 or other seminars in the Department, and literature research to present\nas a major paper and seminar.\n',
      NOTE: [
        'Students will normally be enrolled in the fourth year of their Program, having completed the third year core\nrequirements of their Plan.\n'
      ],
      'ONE-WAY EXCLUSION': ['Not to be taken concurrently with BIOL 537/12.0.'],
      title: 'Research Mentorship in Biology II',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH, EBIO-P-BSH)\nand a minimum GPA of 2.0 in the Biological Foundations List and permission of the Department.\nCOREQUISITE    BIOL 538/3.0.\n'
      ],
      'LEARNING HOURS': ['128 (8S;12T;60Pc;48P)\n']
    },
    'JAPN 302': {
      EXCLUSION: [
        ' No more than 6.0 units from JAPN 300/6.0; JAPN 301/3.0; JAPN 302/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'JAPN 302',
      description:
        'Intermediate study of the structural patterns of the language, with intensive training in listening, speaking, reading, and\nwriting. Extensive use of audio-visual materials.\n',
      NOTE: [
        'Students with previous study background must take a placement test during orientation week.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Japanese II',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in JAPN 301/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': []
    },
    'HIST 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 431',
      description:
        'The political, social, cultural and economic development of the Maritimes and Newfoundland from the early 17th century\nto the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'tlantic Canada',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'PHIL 203': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 203',
      description:
        'Philosophical issues - both epistemological and ethical - involved in specific debates about the relationship between science\nand social issues. The course may focus, for instance, on recent \u2018popular\u2019 sociobiology efforts by biologists and others to\nestablish scientific theories of human nature and human potential.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Science and Society',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 456',
      description:
        'Independent study involving a critical review of the literature on an approved topic of specialization in health\nenhancement, disease prevention and human performance. Students must arrange for a faculty adviser approved by the\nSchool of Kinesiology and Health Studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Survey of Research and Literature in Kinesiology and Physical Education',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan; permission of the supervisor and the\nUndergraduate Coordinator.'
      ],
      'LEARNING HOURS': ['126 (6I;120P)\n']
    },
    'ENGL 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 422',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Renaissance Literature II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PSYC 471': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 471',
      description:
        'The neuropharmacological basis of psychological processes. Topics to be covered include drug actions on neurochemical\nsystems, psychoactive effects of drugs and the neuropharmacological basis of psychiatric disorders.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Behavioural Pharmacology',
      PREREQUISITE: [
        'Level 3 and (PSYC 205/3.0 or [PSYC 271/3.0 and PSYC 370/3.0).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHGY 424': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHGY 424',
      description:
        'The electrophysiology and biophysics of neuronal and cardiac membranes; molecular biology, structure, and function of ion\nchannels. Students will learn to critically evaluate scientific literature. Instructional format is primarily student-led seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ion Channels of Excitable Cells',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Major or Specialization Plan and a GPA of 2.5 and (a minimum grade of C\nin PHGY 210/6.0 or PHGY 214/6.0 or PHGY 212/6.0).'
      ],
      'LEARNING HOURS': []
    },
    'ITLN 310': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 210/3.0; ITLN 310/3.0; LLCU 210/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 310',
      description:
        'The ancient Greek and Roman tradition in literature, art and the politics of Italy from the Middle Ages to the 18th century.\nTexts and works of art will be studied in the context of the historical, cultural and political settings of Italy.\n',
      NOTE: [
        'Taught in English with LLCU 210/3.0. Students concentrating in Italian submit written assignments, tests and exams\nin Italian. Normally students will read Italian texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Italy and the Classical Tradition',
      units: '3.0',
      PREREQUISITE: ['ITLN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 466': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 466',
      description:
        'This course is designed to expose advanced students in the fields of biology, chemistry, geography or geology to the\nprinciples of stable isotope and radiogenic isotope systematics in natural processes. Emphasis will be placed on the use of\nisotopes in tracing elemental cycles, biological cycles and hydrologic cycles and how some isotopes can be used to place\nconstraints on the timing of specific events in these cycles.\n',
      NOTE: [
        'This course may not be offered every year. Consult : http://www.queensu.ca/geol/courses for more information\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Isotopes and the Environment',
      units: '3.0',
      PREREQUISITE: ['CHEM 112 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;12S;12Lb;60P)\n']
    },
    'HIST 269': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 269',
      description:
        'How political power was conceived, exercised, and contested in the aboriginal, French and British colonial, and early-\nnational formations in what is now Canada. The origins and nature of liberal democracy and changing forms of popular\npolitical participation, schooling, and the criminal law receive particular attention.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'olitics and the State in Canada to 1896',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['116 (36L;24O;56P)\n']
    },
    'FREN 342': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 342',
      description:
        'An intro. to French 19th Century and contemporary literature. More specifically focused on literature the course will also\nexplore predominant trends in different media such as painting and cinema. Drawing on critical, historical, and literary\ntheory, students will acquire the skills to assess how specific works reflect or relate to the aesthetic, literary, and\nphilosophical trends of their time.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Histoire culturelle et litt\u00e9raire de la France moderne et contemporaine',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CWRI 293': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CWRI 293',
      description:
        'Creative Writing in Prose\nA workshop course focusing on the writing and editing of short fiction, novels, and memoir. Students attempt several\ndifferent approaches to the writing of creative prose, as well as the process of publication in both magazine and book\nformats.\n',
      NOTE: ['Admission is based on writing samples.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'POLS 313': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 313',
      description:
        'A critical examination of the relationship between the mass media and politics, focusing on the functions of the media in\nmodern liberal democracies and the ways in which news stories are created and packaged.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mass Media and Politics in Canada',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 104': {
      EXCLUSION: [
        'No more than one course from MUSC 104/3.0; MUSC P06/0.0; MUSC P52/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 104',
      description:
        'An introduction to musical notation, ear training, theory and analysis.\n',
      NOTE: [
        'Students who hold Royal Conservatory Advanced Rudiments or higher should consult with the School for\nappropriate course placement. May not be taken for credit by students in the B.Mus. Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Music Fundamentals',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['123 (36L;3G;36O;48P)\n']
    },
    'HIST 208': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 208',
      description:
        'An interdisciplinary course in which the Canadian nation state will be examined from a geographic, historical, political,\ncultural and economic perspective, with particular attention being paid to the First Nations and linguistic minorities.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ntroduction to Themes in Canadian History I',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GREK 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 321',
      description:
        'Selected passages of Greek prose, usually drawn from oratory, history, and philosophy, read in the original Greek and\ncommented upon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with GREK 421/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Greek Prose',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GREK 208/6.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PATH 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PATH 499',
      description:
        'A research project involving the study of human disease processes. The project will be supervised by a Faculty member in\nthe Department and will provide opportunities for experimental design, data analysis and both written and oral\npresentation of results. Students must contact a potential faculty supervisor in the Spring preceding registration in fourth\nyear.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Pathology',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Specialization Plan and a GPA of 2.50.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'PHIL 301': {
      EXCLUSION: ['May not be taken with or after PHIL 247/3.0.'],
      RECOMMENDATION: [],
      code: 'PHIL 301',
      description:
        'Bioethics\nAn investigation of some moral issues arising in connection with health care, including: the relationship between patient\nand health care provider; reproductive decision-making; euthanasia and the nature of death; and the development of\nhealth care policy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 255': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 255',
      description:
        'A survey of the social, cultural, political and intellectual life of Europe in the Renaissance and Reformation. Topics to be\ndiscussed include: humanism, secularism, printing, and exploration; war and the early modern state; prophecy, heresy, and\ndissent; popular culture; sex, marriage, and family life; witch hunts, panics, and magic; and the impact of the Reformation\nand the Counter Reformation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'enaissance and Reformation Europe',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'PHYS 345': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 345',
      description:
        'Spin. Addition of angular momentum. Many electron atoms and the periodic table. Introduction to perturbation theory and\nFermi\u2019s golden rule. Time dependent perturbations, including stimulated emission. Introduction to nuclear and particle\nphysics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Quantum Physics of Atoms, Nuclei and Particles',
      units: '3.0',
      PREREQUISITE: ['PHYS 344/3.0.'],
      'LEARNING HOURS': []
    },
    'ARTF 101': {
      EXCLUSION: [
        'No more than 1 course from ARTF 101/3.0; ARTF 105/6.0; ARTF 106/3.0; ARTF 127/6.0.\n'
      ],
      RECOMMENDATION: [
        'ARTH 120/6.0. A survey course in Art History provides increased visual literacy at the studio level.\nPrevious experience in painting and drawing is highly recommended.\n'
      ],
      code: 'ARTF 101',
      description:
        'A foundation course aimed at developing basic skills in drawing and painting, embracing a variety of subjects, materials and\ntechniques.\n',
      NOTE: ['Materials: estimated cost $300.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Drawing and Painting',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor.\n'],
      'LEARNING HOURS': ['144 (48Lb;96P)\n']
    },
    'ARTH 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 435',
      description:
        'This course examines a range of theoretical approaches used currently in art historical scholarship, including Marxism,\ngender theory, psychoanalysis, structuralism, poststructuralism, and postcolonialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Art History Theory and Methods',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 292': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 292',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Literary Criticism and Theory',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'MUSC 398': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 398',
      description:
        'Modal Counterpoint\nStudy, through rule-based writing, of 16th century modal counterpoint, from two-part species exercises to free\ncounterpoint in Renaissance style.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'MUSC 293/3.0 or MUSC 291/6.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'LLCU 329': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 329/3.0; GRMN 429/3.0; ENGL 273/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 329',
      description:
        'This course offers an overview of the related genres of the Fantastic, the Fairy Tale, Dystopia, Science Fiction, and Horror.\nExamples will include popular works such as the Twilight Saga, Harry Potter, and/or The Hunger Games, but also traditional\ntexts by Hoffman and Kafka. Parallel to the fictional works, the course offers theoretical analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Uncanny Encounters: Narrative Analysis of the Fantastic Genre',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (12L;24S;12G;24O;48P)\n']
    },
    'ARTH 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 410',
      description:
        'Studies in the textiles and dress of selected periods with a focus upon visual culture and/or material culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in the History of Textiles and Dress',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'KNPE 251': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0; NURS\n323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM 162/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 251',
      description:
        'An introduction to the analysis of data from real life situations. Covers study design, descriptive and inferential statistics.\nTopics include probability, t-tests, regression, Chi-square tests, analysis of variance. Emphasis is in the foundation of\nstatistical inference and practical application of statistical methods using statistical software.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Statistics',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above in a PHED, KINE or HLTH plan.\n'],
      'LEARNING HOURS': ['126 (12L;18Lb;48O;48P)\n']
    },
    'ENGL 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 235',
      description:
        'Life writing includes autobiography, biography, diaries, letters, and memoirs. The aim of this course will be to explore its\ngeneric conventions and innovations, to consider the interplay between lived experience and its textual representation, and\nto examine the social and cultural dimensions of life stories.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Life Writing',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 328': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 328',
      description:
        'The primary focus of the course will be the theological perspectives and social functions of apocalyptic in select religious\ntraditions. The course will also survey the appropriation of apocalyptic themes throughout history in artistic forms such as\nart, fiction, and film, with particular attention to our modern times and cultures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Interpretation of Apocalyptic Literature',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'RELS 237': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 237',
      description:
        'How religion is portrayed in film; particularly the depiction of religious belief, practices, practitioners, and institutions, and the\nuse of religious symbols and metaphors.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Film',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 231': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 231',
      description:
        'An examination of the origins of modern economic growth concentrating on the industrial revolution in Britain and the\nprior developments leading up to it. Some attention is directed to the early followers of the changes initiated in Britain.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Emergence of the Modern Industrial Economy',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'BIOL 439': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 439',
      description:
        'The mechanisms of evolutionary change - from genes to societies. How natural selection interacts with genetic and\npopulation processes to make organisms adapted to their environment and to create biological diversity.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Natural Selection and Microevolution',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 302/3.0 or BIOL 303/3.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['120 (36L;6S;18Lb;60P)\n']
    },
    'HIST 286': {
      EXCLUSION: ['No more than one course from HIST 286/3.0; HIST 315/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 286',
      description:
        'A survey of Latin American history from 1850 to the recent past. Major events of the 20th century will be examined in\nhistorical context, with special attention to issues of development, nation building, and political and social conflict.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'atin America from 1850 to Today: The Modern Era',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': []
    },
    'GREK 591': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 591',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'General Examination',
      units: '0.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'KNPE 237': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 237',
      description:
        'This course is an exploration of behavioural and biological research on physical activity and how it relates to the\npsychosocial, structural, and physiological development of children between birth and approximately age 13.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Child and Adolescent Motor Development',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above in a PHED or KINE Plan.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'ENGL 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 306',
      description:
        'A survey of major literary works written in Old English and Old Norse from the ninth to the thirteenth centuries. Readings\nwill include sagas, epics, elegies, riddles, mythology, as well as historical and religious writing. Texts will be read in\ntranslation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Northern World: Vikings and Saxons',
      units: '6.0',
      PREREQUISITE: [
        '[(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units)] or [(a GPA of 2.6) and (registration\nin a MDVL Plan)].'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'MUTH 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 240',
      description:
        'With so many digital disruptions and new intermediaries affecting the way creative works are conceived, created,\ndistributed, and consumed, this course explores a range of impacts on the entertainment sector, inspired by the Internet,\ndigital convergence, and mass adoption of mobile and social consumer technologies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Digital Disruption in the Creative and Performing Arts',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (12L;48O;60P)']
    },
    'PHIL 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 307',
      description:
        'Specific topics in or traditions within Latin American and Caribbean Philosophy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Latin American and Caribbean Philosophy',
      units: '3.0',
      PREREQUISITE: ['Level 3 and 12.0 units in PHIL, ENGL, HIST, or POLS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ITLN 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ITLN 502',
      description:
        'Reading courses in specialized themes of Italian literature to meet the needs of advanced students for whom a seminar course\nis not available. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Letteratura italiana: Studi indipendenti',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department of Languagues, Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'LLCU 210': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 210/3.0; ITLN 210/3.0; ITLN 310/3.0.\nEQUIVALENCY    ITLN 210/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 210',
      description:
        'The ancient Greek and Roman tradition in literature, art and the politics of Italy from the Middle Ages to the 18th century.\nTexts and works of art will be studied in the context of the historical, cultural and political settings of Italy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Italy and the Classical Tradition',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOFT 437': {
      EXCLUSION: ['No more than 3.0 units from CISC 437/3.0; SOFT 437/3.0.'],
      RECOMMENDATION: [],
      code: 'SOFT 437',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Performance Analysis',
      units: '3.0',
      PREREQUISITE: ['CISC 324/3.0 and CISC 327/3.0.\n'],
      'LEARNING HOURS': []
    },
    'STAT 473': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 473',
      description:
        'An introduction to advanced regression methods for binary, categorical, and count data. Major topics include maximum-\nlikelihood method, binomial and Poisson regression, contingency tables, log linear models, and random effect models. The\ngeneralized linear models will be discussed both in theory and in applications to real data from a variety of sources. Given\njointly with STAT 873/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Generalized Linear Models',
      units: '3.0',
      PREREQUISITE: [
        '(STAT 361/3.0 or ECON 351/3.0) and STAT 463/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 257': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 257',
      description:
        'The lands and peoples of Mexico, Central America, and the West Indies, emphasizing the historical factors that shape\ncontemporary life in the region.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Geography of Middle America',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'HLTH 595': {
      EXCLUSION: [],
      RECOMMENDATION: ['HLTH 252/3.0.\n'],
      code: 'HLTH 595',
      description:
        'An independent study involving a research proposal and project on an approved topic in the area of health enhancement or\ndisease prevention. The research proposal will be completed in the fall term and the research project in the winter term.\nStudents must arrange for a full-time faculty advisor in the School of Kinesiology and Health Studies.\n',
      NOTE: [
        'Limited spaces available; priority to Health Studies students.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis in Health Studies',
      units: '6.0',
      PREREQUISITE: [
        'A GPA of 3.50 and level 4 in a PHED Specialization, KINE Specialization or (HLTH Major or Medial) Plan;\npermission of the supervisor and Undergraduate Coordinator in the School of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['252 (12I;240P)\n']
    },
    'ENGL 389': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 389',
      description:
        'A study of modern and/or contemporary North American literatures (which may include some works in translation).\nContent will vary, but the aim will be to discern how cultural similarities and differences are reflected in individual works by\nwriters from (e.g.) Canada, the United States, and the Caribbean.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Context North America',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'FREN 315': {
      EXCLUSION: ['No more than 3.0 units from FREN 315/3.0; FREN 405/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 315',
      description:
        'A study of representative literary works of the 15th and 16th centuries, including Villon, Montaigne, Rabelais. Travaux pratiques\ninclude essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Litt\u00e9rature fran\u00e7aise de la Renaissance',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 401',
      description:
        'The study of a selected theme within the subject matter of Western art, concentrating on its changing modes of\nrepresentation in response to historical and artistic circumstances.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Iconography',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 301',
      description:
        'A study of selected objects with a focus on materials and meanings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Artwork as Material Object',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 263': {
      EXCLUSION: ['No more than 1 course from HIST 263/3.0; HIST 322/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 263',
      description:
        'A blended online/classroom course that will introduce students to armed forces in modern history, and how they relate to\nthe societies they function within and against.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'ar in the Twentieth Century: Myths and Reality',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (12L;24G;12O;72P)\n']
    },
    'SOFT 426': {
      EXCLUSION: ['No more than 3.0 units from CISC 426/3.0; SOFT 426/3.0.'],
      RECOMMENDATION: [],
      code: 'SOFT 426',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Real-Time Systems',
      units: '3.0',
      PREREQUISITE: ['CISC 324/3.0 and CISC 327/3.0.\n'],
      'LEARNING HOURS': []
    },
    'PHIL 510': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 510',
      description:
        'This course involves a directed study of a philosophical topic. Topics chosen may be from any area of philosophy, and\nshould be determined in consultation with a proposed supervising instructor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a PHIL Major or Medial Plan and (a minimum GPA of 2.60 in PHIL 250/6.0 and\nPHIL 257/6.0) and permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'CLST 411': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 411',
      description:
        'Topics in Greek Scholarship II\nIntensive study of a special topic, period, or author(s) in the Greek world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 in a CLST or CLAS or GREK or LATN Plan, and permission of Department.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 590': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 590',
      description:
        'Thesis\nThe thesis is optional and counts as one course toward an honours concentration in Political Studies. The thesis subject\nmust be selected at the end of the penultimate year after consultation with members of the Department, and the thesis\nmust be submitted by 31 March of the final year. The student can choose to pay for binding of the departmental copy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.9 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['348 (24S;24Pc;24G;12I;48Oc;216P)\n']
    },
    'INTS 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 323',
      description:
        'A study of thematic and stylistic approaches to the representation of selected cultures and to the presentation and\nevocation of global issues in one or more of the fine, performing or media arts. Topics will vary each year. For detailed\ncourse description, see www.queensu.ca/bisc\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'International Perspectives in the Creative Arts I',
      units: '3.0',
      PREREQUISITE: ['Level 2 in the relevant arts discipline.'],
      'LEARNING HOURS': []
    },
    'MATH 414': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 414',
      description:
        'An introduction to Galois Theory and some of its applications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Galois Theory',
      units: '3.0',
      PREREQUISITE: ['MATH 310/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'ENGL 437': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 437',
      description:
        'Studies in literary topics focused on the period before 1800 that do not fit within the established Group I rubrics (Medieval,\nRenaissance, Restoration/18th Century). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group I: Special Topics II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CLST 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 312',
      description:
        'Greek and Roman Drama\nIntensive study (in translation) of representative works from the ancient theatre, both tragic (Aeschylus, Sophocles,\nEuripides, Seneca) and comic (Aristophanes, Menander, Plautus, Terence). Comparative study of English drama of the\nclassical tradition encouraged.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'CLST 100/6.0 or (CLST 102/3.0 and CLST 103/3.0) or DRAM 200/6.0 or DRAM 219/3.0 or CLST 101/6.0 or\nDRAM 210/6.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['121.5 (12L;72G;37.5P)\n']
    },
    'ARTF 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTF 338',
      description:
        'In this second advanced-level course students choose two media sections from these areas: paint, media, sculpture/new\nmedia, or print media. The media area chosen must be different from that studied in ARTF 337/9.0. The course will include\nseminars introducing elements of professional practice.\n',
      NOTE: ['Open only to students in a BFA Program.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Programs II',
      units: '9.0',
      PREREQUISITE: [
        'A minimum grade of C- in ARTF 337/9.0 and a GPA of 1.60.'
      ],
      'LEARNING HOURS': ['324 (144Lb;180P)\n']
    },
    'ENGL 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 432',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Restoration and 18th-Century Literature II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'RELS 255': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 255',
      description:
        'An investigation into the techniques of critical reading and writing for research in Religious Studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Methods in Religious Studies',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36S;84P)\nEQUIVALENCY    RELS 355/3.0.\n']
    },
    'FREN 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 320',
      description: 'For advanced students.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Communication et culture V',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36L;18Lb;60P)']
    },
    'BIOL 530': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 530',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Origins of Biodiversity',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'DEVS 420': {
      EXCLUSION: [
        'No more than 1 course from DEVS 410/6.0; DEVS 420/3.0; DEVS 432/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'DEVS 420',
      description:
        'Participation in an organized educational or cultural exchange, either i) one term of studies at a developing-country\nuniversity, or ii) an exchange program in a developing-country setting with an organization such as Canada World Youth or\nShastri Indo-Canadian Institute for at least 6 weeks. Students are required to prepare a work-study proposal, a risk\nassessment of their placement and attend a pre-departure orientation. Assessment will also be based on a journal and final\nreport.\n',
      NOTE: [
        'Students are normally responsible for all costs associated with this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Study Placement in Development Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in the DEVS Major or Medial Plan and departmental approval in advance\nfrom the Placement Coordinator, Global Development Studies.\n'
      ],
      'LEARNING HOURS': ['124 (40G;84P)\n']
    },
    'KNPE 254': {
      EXCLUSION: ['KNPE 353/3.0.'],
      RECOMMENDATION: ['ANAT 315/3.0.\n'],
      code: 'KNPE 254',
      description:
        'Students will learn to apply the knowledge and skills acquired in KNPE 153 to conduct detailed analyses of human\nmovement including how to analyze human movement using information obtained from different measurement tools.\nExamples will be used to demonstrate how biomechanics can be used to enhance and maintain human health, fitness and\nperformance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biomechanical Analysis of Human Movement',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above in a PHED or KINE Plan and KNPE 153/3.0.\n'
      ],
      'LEARNING HOURS': ['108 (24L;12T;72P)\n']
    },
    'PHIL 361': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 361',
      description:
        'From propositional calculus to first-order monadic predicate calculus. Symbolization, rules of inference, derivation and\nrefutation of arguments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': ['May not be taken with or after: CISC 204/3.0.'],
      title: 'Introduction to Logic',
      units: '3.0',
      PREREQUISITE: ['A GPA of 2.0 in 6.0 units in PHIL.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 257': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 257',
      description:
        'A study of problems in moral and/or political philosophy from the ancient or early modern period to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ethics',
      units: '6.0',
      PREREQUISITE: ['A GPA of 2.0 in 6.0 units in PHIL.'],
      'LEARNING HOURS': ['240 (76L;168P)\n']
    },
    'BIOL 319': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 201/3.0.\n'],
      code: 'BIOL 319',
      description:
        'Ethnobotany is the study of the relationships that exist between indigenous cultures and local flora. Case studies will be\npresented to examine the various categories of plant use, the importance of traditional knowledge to Western culture, and\nthe role of plant conservation and cultural sustainability.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Ethnobotany',
      units: '3.0',
      PREREQUISITE: ['BIOL 102/3.0 and BIOL 103/3.0.'],
      'LEARNING HOURS': []
    },
    'WRIT 120': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 120',
      description:
        'Fundamentals of Effective Writing\nA focus on the principles and practical applications of effective writing. Students apply effective writing strategies to\naddress a variety of professional and academic audiences. Students plan, outline, write, and revise reader-centred\ndocuments that relate to forms and contexts they will encounter in the workplace and in educational environments.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36O;78P)']
    },
    'COMP 392': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COMP 392',
      description:
        'A Computing Internship involves spending twelve to sixteen months in a paid internship position in the private or public\nsectors. Students in a 12-month internship register in COMP 390/6.0 and either COMP 391/3.0 or COMP 392/3.0, or all of\nCOMP 393/3.0, COMP 391/3.0 and COMP 392/3.0. Students in a 16-month internship register in COMP 390/6.0, COMP\n391/3.0 and COMP 392/3.0. The Internship Coordinator must be satisfied that the work carried out has educational merit.\nSuccessful completion of the course requires submission of a satisfactory report on the experience within thirty days of\ncompletion of the work period. The Internship Coordinator is responsible for evaluating the report. The QUIP program\nincludes prior workshops on interviewing, resum\u00e9 preparation and work performance. Career Services manages the non-\nacademic aspects of the program.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computing Internship III',
      PREREQUISITE: [
        'GPA of 1.90 and Level 2 or 3 and registration in a Bachelor of Computing internship plan (BMCO-I-BCH or\nCOGS-I-BCH or COMP-I-BCH or CSCI-I-BCH or SODE-I-BCH).'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 420',
      description:
        'Studies in Renaissance Literature\nFor detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'SPAN 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 306',
      description:
        'A study of selected works by Spanish American writers such as Horacio Quiroga, Gabriel Garc\u00eda M\u00e1rquez, Jorge Luis Borges,\nJuan Rulfo, Julio Cort\u00e1zar and Reinaldo Arenas.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'La narrativa hispanoamericana del siglo 20',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 352/3.0.\nCOREQUISITE    (SPAN 301/3.0 and SPAN 302/3.0) or (SPAN 303/3.0 and SPAN 304/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 399': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 399',
      description:
        'Study, through composition, of the contrapuntal procedures of the 18th century, with an emphasis on J.S. Bach\u2019s two-part\ninventions and fugues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Tonal Counterpoint',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 293/3.0 or MUSC 291/6.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'HIST 289': {
      EXCLUSION: ['No more than 6.0 units from HIST 289/3.0; HIST 329/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 289',
      description:
        'A survey of British history in the 19th and 20th centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ritain since 1851',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 341',
      description:
        'The course examines various aspects of plant cell biology, physiology, and biochemistry including carbon and nitrogen\nmetabolism (photosynthesis, respiration, etc.), water relations, mineral nutrition, response to environmental stress, roles of\nplant hormones, plant biotechnology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Plant Physiology',
      units: '3.0',
      PREREQUISITE: ['BIOL 205/3.0 or BCHM 218/3.0.'],
      'LEARNING HOURS': ['115 (36L;10G;15O;54P)\n']
    },
    'DRAM 289': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 289',
      description:
        'An examination of the theatrical nature of British and European dramatic literature, current and past productions, and\narchitectural structures, using various elements of site and performance as text for discussion and projects.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Studies in British and European Theatre',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'PHGY 210': {
      EXCLUSION: [
        'No more than 6.0 units from IDIS 150/6.0; KNPE 125/3.0; KNPE 225/3.0; PHGY 210/6.0; PHGY 214/6.0; PHGY\n212/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHGY 210',
      description:
        'The function of organs, body systems and the integration of functions in the whole body.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Physiology for Health Sciences',
      units: '6.0',
      PREREQUISITE: [
        'Level 2 and [a GPA of 2.0 in (BIOL 102/3.0 and BIOL 103/3.0) or PHGY 170/3.0] or permission of the\ninstructor.\n'
      ],
      'LEARNING HOURS': ['300 (300O)\n']
    },
    'BIOL 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 422',
      description:
        'The application of biological research to the conservation of biodiversity and natural resources, as well as the interaction of\nbiology with philosophy, politics and economics in influencing conservation policy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Conservation Biology',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 302/3.0 or BIOL 303/3.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['108 (36L;36T;36P)\n']
    },
    'SPAN 332': {
      EXCLUSION: ['No more than 3.0 units from LLCU 332/3.0; SPAN 332/3.0.'],
      RECOMMENDATION: [],
      code: 'SPAN 332',
      description:
        'Spanish Baroque Short Theatre\nShort theatre played an important role in the theatre of Spanish Golden Age. In this course students will study the literary\nparticularities of the genre and the social ramifications of the themes present in short theatre (gender, battle of the sexes,\ndiversity, authority amongst others) and their historical and contemporary relevance.\n',
      NOTE: [
        'Taught in English with LLCU 332/3.0. Written work and examinations are in Spanish. Readings are in translation.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['SPAN 380/3.0 or SPAN 381/3.0.\n'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUSC 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 415',
      description:
        'Large ensemble for qualified instrumentalists and singers. Topics vary. Course includes weekly rehearsals of a wide variety\nof repertoire, and a minimum of one concert per term, for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Large Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'As insight regarding the human brain expands, so do related issues such as what constitutes personhood, what drives the': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code:
        'As insight regarding the human brain expands, so do related issues such as what constitutes personhood, what drives the',
      description:
        'criminal mind, intelligence-enhancing drugs and end-of-life issues. Lead by experts who deal daily with such concerns, we\nwill focus weekly on a particular topic in neuroscience which impacts on society.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Controversies in Neuroscience',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Major or Specialization Plan and a GPA of 2.5 and (ANAT 312/3.0 or NSCI\n323/3.0 or NSCI 324/3.0 or PSYC 271/3.0).'
      ],
      'LEARNING HOURS': ['108 (12L;24S;72P)\n']
    },
    'SPAN 406': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 316/3.0; SPAN 316/3.0; SPAN 406/3.0'
      ],
      RECOMMENDATION: [],
      code: 'SPAN 406',
      description:
        'An introduction to contemporary literary theories and the analysis of Hispanic texts from reader-, structural- and author-\noriented perspectives.\n',
      NOTE: [
        'Taught in English together with LLCU 316/3.0. Students concentrating in Spanish submit written assignments, tests,\nand examination in Spanish. Normally they will read Hispanic texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introducci\u00f3n a la teor\u00eda y el an\u00e1lisis literario',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 352/3.0 (or permission of the Department of Languages, Literatures and Cultures).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 365',
      description:
        'A study of poetry from the twentieth and twenty-first centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern and Contemporary Poetry',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'PHYS 316': {
      EXCLUSION: [
        'No more than 1 course from MATH 334/3.0; MATH 338/3.0; PHYS 316/3.0; PHYS 312/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PHYS 316',
      description:
        'Methods of mathematics important for physicists. Complex arithmetic, series expansions and approximations of functions,\nFourier series and transforms, vector spaces and eigenvalue problems, ordinary differential equations and Green\u2019s\nfunctions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Methods in Mathematical Physics I',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 221/3.0 or MATH 280/3.0 or MATH 227/3.0) and (MATH 225/3.0 or MATH 231/3.0 or MATH\n232/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'PSYC 437': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 437',
      description:
        'An intensive study of the state of research and controversies in the area of mood disorders. Specific topics covered will\ninclude bio-genetic, cognitive, interpersonal, and stress theories of etiology, as well as state-of-the-art advances in\ntreatment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mood Disorders',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and (PSYC 235/6.0 or PSYC 236/3.0).'],
      'LEARNING HOURS': ['120 (18L;18S;84P)\n']
    },
    'KNPE 203': {
      EXCLUSION: [],
      RECOMMENDATION: ['KNPE 237/3.0.\n'],
      code: 'KNPE 203',
      description:
        'This course provides an introduction to theoretical and methodological research on coaching, with a special emphasis on\nthe influence of coaches\u2019 interpersonal knowledge/behaviours on athlete development. Concepts related to leadership,\ncoach behaviours, and coach education will be explored.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Art and Science of Coaching',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above in a PHED or KINE Plan and KNPE 265/3.0.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'SOCY 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 304',
      description:
        'Explores a range of contemporary issues in communications and information technology. Topics may vary from year to\nyear. See the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Communications and Information Technology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'KNPE 363': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 363',
      description:
        'An integration of theory, research and applied work in the area of applied sport psychology. Analysis, discussion of\ntheoretical issues related to performance and practical application of mental skills such as arousal management, attention\ncontrol, decision making, goal setting, positive self-talk, and time management.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Psychology of Sport and Performance',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED or KINE Plan and KNPE 265/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 218': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 218',
      description:
        'Introduction to Christianity as a religious tradition through its texts, its history and its contemporary forms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Christianity',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LING 202': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 202',
      description:
        'This course investigates the distinctive characteristics of Canadian English as it is spoken and written today. Topics include\nhistorical development, regional dialects, and current changes. Students will have access to the extensive bibliographic and\ncomputer corpus resources of the Strathy Language Unit.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian English',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'HLTH 305': {
      EXCLUSION: ['HLTH 405/3.0.'],
      RECOMMENDATION: [],
      code: 'HLTH 305',
      description:
        'An overview of the fundamentals of health policy with an emphasis on the Canadian context. Topics to be discussed include\nhistory of the Canadian public health care system; the Canada Health Act; the political and economic environment of the\nCanadian health care system; issue and challenges in Canadian health policy; and comparative perspectives.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Health Policy',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and HLTH 101/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 277': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 277',
      description:
        'This course will explore how different literary works represent desire, romance, queerness, and other gender-related\nissues. Particular focus may vary from year to year; for detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and Gender',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a GNDS Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHIN 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHIN 200',
      description:
        'For students with some knowledge of Cantonese who wish to acquire a command of Mandarin or for students with some\nknowledge of Mandarin who want to improve their Chinese language skills. Continued study of basic structural patterns of\nthe language with the emphasis on oral communication, reading and writing using the simplified forms of Chinese\ncharacters.\n',
      NOTE: [
        'Students will have their level of competence assessed by the instructor during orientation week in September.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Mandarin Chinese II',
      units: '6.0',
      PREREQUISITE: [
        'CHIN 100/6.0 and permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['240 (72L;24T;144P)\n']
    },
    'MUTH 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 201',
      description:
        'This course is structured around a series of case studies of particular moments in the history of the representation of sex\nand violence in dramatic and musical performances.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Sex and Violence in Performance',
      units: '3.0',
      PREREQUISITE: ['Level 2.'],
      'LEARNING HOURS': ['120 (60O;60P)\n']
    },
    'WRIT 275': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 275',
      description:
        'An interdisciplinary course on analytical writing, applying selected principles of rhetoric and linguistics. Collaborative\nexercises and peer-edited essays are supplemented by critical reading of diverse articles and narratives. Enrolment is\nlimited.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Analytical Writing',
      units: '3.0',
      PREREQUISITE: ['WRIT 175/3.0 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'FILM 500': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 500',
      description:
        'Open to students completing an honours concentration in Film and Media, or Stage and Screen Studies. May be an essay or\na film or video project. Apply for FILM 500/6.0 or FILM 501/3.0, but not both, to the Undergraduate Coordinator by end of\nLevel 3.\n',
      NOTE: [
        'To use Film and Media video equipment the student must have completed FILM 250/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis',
      units: '6.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and 30.0 units in FILM or\npermission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 211': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 211',
      description:
        'This course will explore the origins of the struggle between the postwar superpowers, the United States and the Soviet\nUnion; the changing nature of their rivalry, and the way other nations were drawn into the conflict. It considers the Cold\nWar from Western, Soviet, and various global perspectives.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'he Cold War',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'PACT 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT 338',
      description:
        'Theory and practice of warm weather camping and canoe tripping. Students spend one pre-term week learning a variety of\ncamping and canoeing skills and application on an extended canoe trip.\n',
      NOTE: [
        'The Camp School Aquatic Test is also required to register in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Outdoor Education',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or 4 in a PHED Specialization Plan and PACT P01/0.0.'
      ],
      'LEARNING HOURS': []
    },
    'ECON 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 445',
      description:
        'An analysis of industry structure, conduct and performance in the Canadian economy, including the major features and\ncurrent issues of competition policy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Industrial Organization and Public Policy',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'MUSC 388': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 388',
      description:
        'A study of art music in Canada since 1930 with an emphasis on specific composers and their works.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Music Since 1930',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 103/3.0 and (MUSC 203/3.0 or MUSC 204/3.0 or MUSC 205/3.0).\nCOREQUISITE    MUSC 293/3.0 or MUSC 291/3.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'DEVS 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 250',
      description:
        'Examines the relationship between development and environmental change by introducing social science perspectives on\nthemes including energy, agriculture, climate, urbanization, and water. With a focus on combining macro- and micro-\nanalysis, the course reflects on the meaning of development in an era of global environmental transformation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Global Environmental Transformations',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['117 (26L;13T;78P)\n']
    },
    'DRAM 545': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 545',
      description:
        'Directed Special Studies in Technical Production\nAdvanced examination of various roles in technical production, especially production and stage management, over the full\nyear. Practical stage management projects are a component of the course.\n',
      NOTE: [
        'The normal classroom time of 36 hours is spread over two terms.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of A- in DRAM 345/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'KNPE 167': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 167',
      description:
        'An introduction to sociological thinking about sport and physical activity. Among the topics to be discussed are: an\nexploration of what constitutes sport and under what conditions; how social relations of class, race, gender, and sexuality\nshape sport experiences; the business of sport; and the relationship between the media and sport.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Socio-Cultural Dimensions of Sport and Physical Activity',
      units: '3.0',
      PREREQUISITE: ['Level 1 or above in a PHED or KINE Plan.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'DRAM 211': {
      EXCLUSION: ['No more than 3.0 units from DRAM 211/3.0; DRAM 311/3.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 211',
      description:
        'An introduction to the history and theory of theatre conceived for audiences of young people. Students will read a variety\nof plays intended for young audiences and consider the social and artistic issues associated with various dramatic and\ntheatrical techniques.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Theatre for Young Audiences',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (84O;36P)\n']
    },
    'MUSC 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 452',
      description: 'A continuation of MUSC 352/3.0, MUSC 355/6.0.\n',
      NOTE: [
        ' Students must submit in writing to the Music Office their request to apply for this course by the last day of classes\nin the Winter Term.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Electroacoustic Composition',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'COGS 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COGS 100',
      description:
        'Introduction to Cognitive Science\nA multidisciplinary approach to the study of the mind combining approached from philosophy, psychology, linguistics,\nneuroscience, anthropology, and artificial intelligence. Logic, rules, concepts, and other mental representations used to\ngenerate thought and behaviour. Implementation of computational and cognitive models of mental processes.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after CISC 352/3.0; PSYC 200/6.0.'
      ],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 301': {
      EXCLUSION: ['No more than one course from HIST 218/3.0; HIST 301/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 301',
      description:
        'Selected issues in the political, social and cultural history of Medieval Europe and the Mediterranean. Emphasis on scholarly\ndebates and the interpretation of primary sources in translation.\n',
      NOTE: [
        'In Fall Term, HIST 301/6.0 meets in the same classroom with HIST 218/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'edieval Societies',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (34.5L;36S;1.5T;168P)\n']
    },
    'EMPR 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 320',
      description:
        'This course introduces students to the various models of mediation used in the modern workplace to resolve conflicts as\nwell as a variety of other emerging alternative dispute resolution (ADR) processes. Students are introduced to the theory,\nprocess, and practice of workplace mediation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Workplace Mediation and Alternative Dispute Resolution',
      units: '3.0',
      PREREQUISITE: ['EMPR 200/3.0 or EMPR 220/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 318': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 318',
      description:
        'A survey of the central issues in the philosophy of law including a consideration of current jurisprudential controversies\nabout the nature of law and philosophical treatments of problems arising from within the law such as paternalism, privacy,\nresponsibility, and civil liberties.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Law',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'KNPE 463': {
      EXCLUSION: [],
      RECOMMENDATION: ['HLTH 315/3.0.\n'],
      code: 'KNPE 463',
      description:
        'Program planning and evaluation for the promotion of physical activity in the community, workplace, school, and health\ncare settings. Using a combination of lecture, group discussions, and a community-based placement, students will acquire\nthe skills and understand the philosophies used in promoting physical activity involvement in the community.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Community-Based Physical Activity Promotion',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan and KNPE 265/3.0 and a GPA of 2.90 in all KNPE\ncourses.'
      ],
      'LEARNING HOURS': ['244 (72S;72Pc;100P)\n']
    },
    'PHYS 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 250',
      description:
        'Laboratory and lecture course that presents techniques and skills that are the foundations of experimental physics. Topics\ninclude statistical analysis of data, uncertainties in measurement, propagation of errors, software for data analysis,\ngraphing and reporting. Students will be exposed to techniques in the measurement of electric, magnetic, thermal and\nmechanical properties. Laboratories also illustrate some principles of quantum physics, mechanics, electromagnetism and\nthermodynamics learned in other physics courses. Some exposure to computerized data acquisition is included.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Foundations of Experimental Physics',
      units: '3.0',
      PREREQUISITE: ['PHYS 104/6.0 or PHYS 106/6.0.'],
      'LEARNING HOURS': ['132 (24L;36Lb;72P)\n']
    },
    'PHIL 362': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 362',
      description:
        'From first-order monadic predicate calculus to polyadic predicate calculus with identity. Symbolization, rules of inference,\nderivation and refutation of arguments. Introduction to modal logics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Further Studies in Logic',
      units: '3.0',
      PREREQUISITE: ['PHIL 361/3.0 or ELEC 270/3.0.'],
      'LEARNING HOURS': []
    },
    'FILM 336': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 336',
      description:
        'Intermediate examination of the historical and critical relation between film and politics or political ideologies. Examples\nwill be drawn from both narrative and non-narrative traditions.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Film and Politics',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\nFILM 337/3.0\nCinema and the City\nAn intermediate study of representations of the city in cinema and visual culture, the social histories from which these\nrepresentations emerge, and the changing environments in which cinema is viewed.\n',
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (Level 3 and registration\nin a GPHY Plan and GPHY 101/3.0, GPHY 227/3.0, GPHY 229/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n', '108 (36L;24Lb;48P)\n']
    },
    'PHYS 104': {
      EXCLUSION: [
        'No more than 6.0 units from PHYS 104/6.0; PHYS 106/6.0; PHYS 117/6.0; PHYS 118/6.0.'
      ],
      RECOMMENDATION: [
        '4U Physics is required.\nCOREQUISITE    MATH 120/6.0 or MATH 121/6.0 or (MATH 123/3.0 and MATH 124/3.0).\n'
      ],
      code: 'PHYS 104',
      description:
        'Mechanics, including systems of particles and rigid body motion; gravitation; fluids; electricity and magnetism; oscillatory\nmotion and waves; topics in modern physics. The material is presented at a more fundamental level appropriate for\nstudents who are seeking a deeper appreciation of physics, and who may be considering a concentration in Physics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamental Physics',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;36Lb;36T;96P)\n']
    },
    'LLCU 339': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 339',
      description:
        'Investigate the life and works of 20 internationally renowned Italian playwrights (including two Nobel Prize winners Luigi\nPirandello and Dario Fo) in a philosophical, political, social, and historical context. Particular emphasis will be given on the\naesthetic solutions proposed by the playwrights to deal with the new realities of the 21st-Century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'XX-Century Italian Playwrights: In Search of the Theatre',
      units: '3.0',
      PREREQUISITE: [
        'Third year standing or permission of the Department of Languages, Literatures, and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 421': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 420/6.0; MUSC 421/6.0.\n',
        'No more than 6.0 units from MUSC 421/6.0; MUSC 425/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 421',
      description: 'Continuation of MUSC 321/6.0.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study IV',
      units: '6.0',
      PREREQUISITE: ['A grade of B- in (MUSC 320/6.0 or MUSC 321/6.0).\n'],
      'LEARNING HOURS': []
    },
    'CANC 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CANC 497',
      description:
        'A seminar-based discussion of topics relevant to cancer research. This course will be run as a companion to CANC 499/12.0,\nand will incorporate the practical experience students will gain in that course as one foundation of learning. Students will\nalso be introduced to other relevant practical aspects of cancer research, including critical analysis of current literature, and\nthe presentation scientific results. The course will also involve attending and discussing a number of research seminars\noffered throughout the year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Topics in Cancer Biology and Genetics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GEOL 221': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 221',
      description:
        'The field study of surficial deposits, rock types, and geological processes, based on the geology of the Kingston area.\nDescriptions, samples and measurements acquired on several field trips will be analyzed, and the results recorded in maps,\nsections, and reports throughout the course.\n',
      NOTE: [
        'Field trips and laboratories are 5 hours per week. Please contact the Department for more information. Estimated\n$90.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Geological Field Methods',
      units: '3.0',
      PREREQUISITE: ['GEOL 104/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;60Lb;8G;4Oc;24P)\n']
    },
    'ENGL 257': {
      EXCLUSION: [
        'No more than 6.0 units from ENGL 256/6.0; ENGL 257/3.0; ENGL 258/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 257',
      description:
        'A study of eight of Shakespeare\u2019s plays in relation to the social, intellectual, and political climate of the Elizabethan period\nand with reference to theatrical production.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Elizabethan Shakespeare',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 246': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 246',
      description:
        'A credit/non-credit practicum for 48 hours of extra-curricular work in drama-related fields, including departmental\nproductions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Technical Practicum',
      units: '1.5',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '48 (6I;42P)\nCOREQUISITE    DRAM 240/3.0 or DRAM 242/3.0.'
      ]
    },
    'GPHY 258': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 258',
      description:
        'The lands and peoples of South America, emphasizing how the colonial experience continues to affect contemporary life in\nthe region.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Geography of South America',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'ANAT 417': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ANAT 417',
      description:
        'Mammalian Embryonic Development\nComprehensive overview of cellular and molecular mechanisms that direct embryogenesis including gastrulation,\nneurulation, establishment of body axes, differentiation, sex determination, limb development, organogenesis, and\nteratology. Participation in seminar presentations and group discussions is required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and a GPA of 2.5 and (registration in a LISC Major or Specialization Plan) and [ANAT 309/3.0 or\n(ANAT 215/3.0 and ANAT 216/3.0) or (ANAT 315/3.0 and ANAT 316/3.0)].'
      ],
      'LEARNING HOURS': ['114 (24L;12S;1I;77P)\n']
    },
    'LATN 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 431',
      description:
        'Detailed study of certain aspects of Latin Literature and Roman history through directed readings and essay assignments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Course',
      units: '6.0',
      PREREQUISITE: [
        'A minimum GPA of 1.90 in 6.0 units from LATN at the 300  level.'
      ],
      'LEARNING HOURS': ['240 (24I;216P)\n']
    },
    'STAT 464': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 464',
      description:
        'Autocorrelation and autocovariance, stationarity; ARIMA models; model identification and forecasting; spectral analysis.\nApplications to biological, physical and economic data.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Discrete Time Series Analysis',
      units: '3.0',
      PREREQUISITE: [
        'STAT 361/3.0 or ECON 351/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'JWST 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'JWST 501',
      description:
        'Directed reading on topics in Jewish Studies not covered in other courses available to the student.',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Reading in Jewish Studies I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'HIST 287': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 287',
      description:
        'A survey of English history during the early modern period (16th- and 17th-centuries), with a thematic focus on the\nformative political, religious, and intellectual upheavals of the age.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'arly Modern England',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['123 (39L;84P)\n']
    },
    'ENGL 436': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 436',
      description:
        'Studies in literary topics focused on the period before 1800 that do not fit within the established Group I rubrics (Medieval,\nRenaissance, Restoration/18th Century). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group I: Special Topics I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUSC 102': {
      EXCLUSION: ['No more than 3.0 units from MUSC 102/3.0; MUSC 203/3.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 102',
      description:
        'The history of Western art music from 1750 to the present. The course focuses on musical styles, genres, and composers, as\nwell as historical and social contextual considerations.\n',
      NOTE: [
        'Students registered in a MUSC Plan should not register in this course.\n',
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Western Music: Napoleon to 9/11',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'HLTH 300': {
      EXCLUSION: [
        'No more than one course from HLTH 300/3.0; KNPE 300/3.0; KNPE 330/4.5; KNPE 336/3.0; KNPE 346/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'HLTH 300',
      description:
        'A community-based internship for Health Studies students to apply knowledge gained in theory-based courses and develop\na range of professional skills. Internship opportunities vary year to year, subject to availability of an appropriate placement\nin a relevant workplace setting.\n',
      NOTE: [
        'Students are expected to participate in professional development workshops offered by the SKHS Internship\nCoordinator and Career Services.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Community-Based Internship',
      units: '3.0',
      PREREQUISITE: [
        '(Level 3 or above and registration in a HLTH Major or Medial Plan) and minimum cumulative GPA of 1.90\nand permission of the Internship Coordinator and Undergraduate Coordinator in the School of Kinesiology and Health\nStudies.\n'
      ],
      'LEARNING HOURS': ['120 (12G;84Oc;24P)\n']
    },
    'MUSC 425': {
      EXCLUSION: ['No more than 6.0 units from MUSC 421/6.0; MUSC 425/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 425',
      description:
        'Applied Study IV (Performance Recital)\nStudents will perform in a public recital in accordance with guidelines established by the Dan School of Music.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\nCOREQUISITE    MUSC 420/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'INTS 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 303',
      description:
        'This course will examine ways in which southeastern England has been and is connected to the world. Students will develop\nan appropriate research methodology drawing on local archival and oral resources to investigate selected topics. Topics will\nvary yearly and may be examined from a variety of perspectives: historical, sociological, cultural or within a multidisciplinary\nframework.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Global Village: Case Studies of South Eastern England',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'PHYS 372': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 372',
      description:
        'Temperature, equations of state, internal energy, first and second laws, entropy and response functions. Application to\nheat engines and refrigerators. Free energies, Legendre transformations, changes of phase. Introduction to the Boltzmann\nfactor and statistical mechanics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Thermodynamics',
      units: '3.0',
      PREREQUISITE: ['PHYS 242/3.0.'],
      'LEARNING HOURS': []
    },
    'STAT 499': {
      EXCLUSION: ['STAT 505/3.0.'],
      RECOMMENDATION: [],
      code: 'STAT 499',
      description:
        'An important topic in statistics not covered in any other courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Statistics',
      units: '3.0',
      PREREQUISITE: ['Permission of the Department.\n'],
      'LEARNING HOURS': []
    },
    'SOCY 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 306',
      description:
        'A comprehensive introduction to the major theories and empirical studies of consumer culture with emphasis upon the\nhistorical, socioeconomic, and cultural aspects of consumption in sociological context; substantive focus upon diverse topics\nsuch as food, tourism, the home, children, and marketing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Consumer Culture',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 411': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 411',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Medieval Literature I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'POLS 384': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 384',
      description:
        'An exploration of major issues and schools of thought in the philosophy of social science and an examination of\ncontemporary approaches to the study of politics.\n',
      NOTE: [
        'This course is open to POLS majors and medials who have completed 1.0 100-level credit in Political Studies.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Strategies of Political Research',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DEVS 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 300',
      description:
        'Cross-Cultural Research Methods\nA study of practical issues related to development research and program evaluation in development settings, using a case-\nstudy approach. Topics include information retrieval, cross-cultural research methods, basic data analysis, and results-based\nproject evaluation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'DEVS 100/6.0 and DEVS 230/3.0 and DEVS 240/3.0 (DEVS 100/6.0 can be taken concurrently with DEVS\n230/3.0 or DEVS 240/3.0 in exceptional circumstances).'
      ],
      'LEARNING HOURS': ['132 (24L;12G;96P)\n']
    },
    'SOCY 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 431',
      description:
        'Advanced study of gender relations from postcolonial and anti-racist theoretical perspectives. Historical and sociological\nanalysis of femininity, masculinity, race and sexuality, particularly in the context of nation-building and colonialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Studies in Gender Relations',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and SOCY 331/6.0 and (a minimum grade of C in\nSOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'MUTH 210': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 210',
      description:
        'A study of vocal techniques from Legitimate in the Golden Age of Musical Theatre to Belt/Mixed Belt in contemporary\nmusicals and popular music culture. The course incorporates current research in the functional utility of breath and sound\nproduction. Emphasis is on the application of practical singing/listening skills and critical analysis skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Theatre Vocal Techniques',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a B.M.T. Plan, or permission of the School upon successful audition.'
      ],
      'LEARNING HOURS': ['120 (24S;12G;84P)\n']
    },
    'MUSC 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 312',
      description:
        'Medium Ensemble\nMid-size ensemble experience for qualified performers. Topics vary. Course includes weekly rehearsals of a wider variety of\nrepertoire, and a minimum of one concert per term for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'DRAM 331': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 331/3.0; DRAM 332/3.0; DRAM 339/3.0; STSC 300/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 331',
      description:
        'An introduction to playing Shakespeare. Ways of breathing life into the text thereby communicating a character\u2019s thoughts,\nwants and emotional state to an audience will be explored.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Playing Shakespeare',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and a grade of B- in DRAM 237/3.0\nand (3.0 units from DRAM 238/3.0; DRAM 239/3.0; DRAM 273/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36Pc;18G;66P)\n']
    },
    'MUSC 258': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 258',
      description:
        'Practical aspects of the physics of musical instruments, architectural acoustics, physiology of the ear and of the voice,\ntuning and temperament, psychoacoustics, and audio electronics including analog and digital technologies for recording,\nsynthesis and broadcasting. Attention will also be given to the history and literature of electroacoustic music.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Science and Technology of Music',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36L;12O;66P)']
    },
    'INTS 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 300',
      description:
        'This course will offer a unique opportunity to study a special topic in Britain and Europe in a global context. Topics will vary\neach term, and the course may not be offered every year. For detailed course description, see www.queensu.ca/bisc\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Studies in Britain and Europe in a Global Context I',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'IDIS 221': {
      EXCLUSION: ['No more than 3.0 units from IDIS 220/3.0 and IDIS 221/3.0.'],
      RECOMMENDATION: [],
      code: 'IDIS 221',
      description:
        'How does a \u2018user\u2019 compare with a \u2018reader\u2019 or a \u2018viewer\u2019? This course will equip students with perspectives and skills\nrequired to engage in a critical assessment of the use of technology in their current research practice. Students will be\nasked to evaluate digital resources using the skills of critical analysis native to humanities disciplines.\n',
      NOTE: ['This course will only be offered at the BISC.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Digital Humanities I: Theorising the Digital User',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;9Lb;12Oc;60P)\n']
    },
    'HEBR 190': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 190',
      description:
        'For students with no (or a minimal) background in Hebrew. Introduces elements of grammar and vocabulary of modern\nHebrew.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Modern Hebrew',
      units: '6.0',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'ARTF 228': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTF 228',
      description:
        'This course offers two of the sections from the four media areas available at this level: painting, drawing, print media and\nsculpture. Course content builds on concepts developed in ARTF127/6.0 and ARTF128/6.0. New techniques, skills and\nconcepts are introduced.\n',
      NOTE: ['Open only to students in a BFA Program.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Fine Art II',
      units: '6.0',
      PREREQUISITE: [
        'A minimum grade of C- in ARTF 227/6.0 and a GPA of 1.60.'
      ],
      'LEARNING HOURS': ['288 (144Lb;144P)\n']
    },
    'PHYS 344': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 344',
      description:
        'Matter waves. Postulates of wave mechanics. Stationary states and one-dimensional potentials. Particle tunneling and\nscattering states. Introduction to matrix mechanics and Dirac notation. Quantized angular momentum, and the H atom.\n',
      NOTE: ['Manual: estimated cost $15 to $25 per manual.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Quantum Mechanics',
      units: '3.0',
      PREREQUISITE: [
        'PHYS 212/3.0 and PHYS 242/3.0 and (MATH 221/3.0 or MATH 280/3.0) and (MATH 225/3.0 or MATH\n231/3.0 or MATH 232/3.0).\nEQUIVALENCY    PHYS 343/3.0.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 351',
      description:
        'An examination of the major theories and critiques of liberalism, focusing on the rival conceptions of freedom and equality\nthat animate classical \u2018laissez-faire\u2019 liberalism, egalitarian liberalism, left-libertarianism, and perfectionist liberalism, and the\ncritical responses these various kinds of liberalism have provoked from communitarians, feminists, Marxists, and others.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Liberal Theory',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 343': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 343',
      description:
        'Development of the equations governing flow and transport; sensitivity to sub-surface complexities. Field instrumentation,\ninstallation and sampling protocols, elements of groundwater investigation. Assessment of measurement techniques and\ninterpretation of fundamental hydrogeological properties. Groundwater occurrence, flow system analysis, with a focus on\ndesigning extraction scheme.\n',
      NOTE: [
        'Course includes a field trip. Please contact the Department for more information.  Estimated $30.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Hydrogeology',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 238/3.0 and CHEM 112/6.0 or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'GNDS 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 401',
      description:
        'Debates on Feminism and Islam\nThis course focuses on the theories, political activities, and organizing of Islamic feminists. It situates itself in relation to\ncontemporary debates around the status of women in Islam and problematizes the nature of feminism and its assumed\nrelationship to Islam. The course will focus on questions of religion, race, class, and nationalism in relation to Islam and\nMuslim women. This course contains an intensive and independent study component.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['204 (36S;168P)\n']
    },
    'MUSC 320': {
      EXCLUSION: ['No more than 6.0 units from MUSC 320/6.0; MUSC 321/6.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 320',
      description: 'Continuation of MUSC 220/6.0.\n',
      NOTE: [
        'Students who do not hold the prerequisite may audition for admission to this course.  They must obtain a grade of\nA- in the jury examination component of MUSC 221/6.0 or MUSC 224/6.0 and receive recommendation of the jury.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study III (Performance)',
      units: '6.0',
      PREREQUISITE: [
        'A grade of B in both MUSC 220/6.0 and MUSC 225/6.0.\nCOREQUISITE    MUSC 325/6.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 470': {
      EXCLUSION: ['No more than 6.0 units from ENGL 375/6.0; ENGL 470/6.0.'],
      RECOMMENDATION: [],
      code: 'ENGL 470',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Modern/Contemporary American Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).\n'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'MATH 221': {
      EXCLUSION: [
        'No more than 3.0 units from MATH 221/3.0; MATH 227/3.0; MATH 280/3.0.'
      ],
      RECOMMENDATION: ['Some linear algebra.\n'],
      code: 'MATH 221',
      description:
        'Double and triple integrals, including polar and spherical coordinates. Parameterized curves and line integrals. Gradient,\ndivergence, and curl. Green\u2019s theorem. Parameterized surfaces and surface integrals. Stokes\u2019 and Gauss\u2019 Theorems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Vector Calculus',
      units: '3.0',
      PREREQUISITE: [
        'MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0 or MATH 126/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 453': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 453',
      description:
        'An examination of a particular problem or theme in Western political thought post-1500; issues covered might include\nproperty, revolution, sovereignty, republicanism, or gender.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern Political Philosophy',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'SPAN 428': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 328/3.0; SPAN 328/3.0; SPAN 428/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'SPAN 428',
      description:
        'This course will explore major themes of development in relation to gender in Latin America through its manifestation in\nfilm. Films will be chosen from all regions of Latin America, including Brazil.\n',
      NOTE: [
        'Taught in English together with LLCU 328/3.0. Students concentrating in Spanish submit written assignments, tests\nand examinations in Spanish.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Development and Film in Latin America',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 351/3.0 or SPAN 352/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LING 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 501',
      description:
        'Upon agreement with a qualified instructor, this course may be taken by an upper-year student in Linguistics to explore a\nspecific area or methodology. Regular meetings, directed readings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Readings in Linguistics',
      units: '3.0',
      PREREQUISITE: [
        '(6.0 units at the 300 level or above in LING) and (a GPA of 3.50) and permission of the Department of\nLanguages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (12I;108P)\n']
    },
    'DEVS 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 350',
      description:
        'Explores gender and development as related social formations in global North and South. Traces historical processes\nincluding colonial capitalism as it restructured gender inequalities, shaped anti-colonial projects of \u2018freedom\u2019, framed\ninstitutional projects of rights and \u2018empowerment\u2019, and recast resistance against gender inequality.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Development',
      units: '3.0',
      PREREQUISITE: [
        'DEVS 100/6.0 and DEVS 230/3.0 and DEVS 240/3.0. (DEVS 100/6.0 can be taken concurrently with DEVS\n230/3.0 or DEVS 240/3.0 in exceptional circumstances).'
      ],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'POLS 264': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 264',
      description:
        'This course examines the evolution of global politics in the modern era, from the institutionalization of sovereignty in the\nPeace of Westphalia to the contemporary period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'World Politics in Historical Perspective',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'PSYC 102': {
      EXCLUSION: [
        'No more than 1 course from PSYC 100/6.0; PSYC 1UNS/3.0; PSYC 101/3.0; PSYC 102/3.0; PSYC 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 102',
      description:
        'An introductory survey of basic areas of psychology including history, methods, perception, cognition, learning and\nmotivation and their biological substrata.\n',
      NOTE: [
        'Not offered at Queen\u2019s; only available as a transfer credit.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Psychology II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'BIOL 433': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 433',
      description:
        'An examination of the foundations of evolution, classification and other selected topics from historical, philosophical and\nscientific perspectives.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History and Philosophy of Biology',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 302/3.0 or BIOL 303/3.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['120 (36L;24T;60P)\n']
    },
    'GEOL 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 102',
      description:
        'Gemstones: Their Art, History and Science\nGemstones have played an important role in society throughout history. The role of gemstones and other precious\nmaterials will be illustrated through the study of works of art and popular literature. The physical properties that make\ngems attractive are explained. Gemstone marketing and ethical considerations of mining methods will be explored.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;36O;48P)']
    },
    'GNDS 380': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 380',
      description:
        'Offered when faculty resources permit, these courses are analyses of particular areas of gender studies interdisciplinary\nresearch. Details regarding specific topics will be available from the Head of the Department on an annual basis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Gender Studies',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENSC 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 480',
      description:
        'This course will provide intensive coverage of a topic that is current and/or of special interest in Environmental Science. The\ncourse will be multidisciplinary, but with a science focus. Offered periodically by visiting professors or members of faculty.\nThe topic for each year will be announced in advance of course selection and will be made available on the ENSC web\npage. Students are advised to consult with their academic counsellor and/or the course instructor prior to registration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Environmental Science',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and registration in an ENSC Major, ENVS Medial, EBIO, ECHM, EGEO, EGPY, ELSC or ETOX Plan or\npermission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 362': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 362',
      description:
        'The movement of people across the surface of the earth from early times to the present, focussing on contemporary issues\nof immigration, refugees, human rights, social integration and barriers to integration including discussions of racism,\ncitizenship, multiculturalism, and community infrastructure.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Human Migration',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 227/3.0 or GPHY 228/3.0 or GPHY 229/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 211': {
      EXCLUSION: ['No more than 3.0 units from CHEM 211/3.0; CHEM 281/3.0.'],
      RECOMMENDATION: [],
      code: 'CHEM 211',
      description:
        'An introduction to chemistry of main group inorganic and organic compounds with the use of fundamental quantum\nmechanics, molecular orbital diagrams and Lewis structures to describe the structure and bonding. The stereochemistry\nand chirality of organic compounds, solid state inorganic chemistry, and descriptive chemistry of compounds of the main\ngroup elements will be covered. The laboratory will introduce skills in inorganic and organic synthesis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Main Group Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 112/6.0\n'],
      'LEARNING HOURS': ['144 (36L;36Lb;72P)\n']
    },
    'CLST 335': {
      EXCLUSION: ['No more than 3.0 units from CLST 331/3.0; CLST 335/3.0.'],
      RECOMMENDATION: [],
      code: 'CLST 335',
      description:
        'Study of the Successor Kingdoms (Antigonids, Ptolomies, and Seleucids) during the period from the death of Alexander the\nGreat in 323 BCE until the end of the Ptolemaic Dynasty in Egypt with the Death of Cleopatra in 30 BCE. Topics may include\nthe role of Greece in the new Mediterranean order, structures of Hellenistic kingdoms, Romans in the East.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Hellenistic Successor Kingdoms to the Death of Cleopatra',
      units: '3.0',
      PREREQUISITE: ['CLST 200/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'CHEM 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 421',
      description:
        'Modern spectroscopic methods for the structural and electronic characterisation of molecules will be discussed, including:\nNMR, X-ray and synchrontron-based spectroscopies, laser spectroscopy, surface spectroscopic methods and scanning probe\nmethods.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Methods in Physical Chemistry',
      units: '3.0',
      PREREQUISITE: [
        'CHEM 313/3.0 or PHYS 345/3.0.\nCOREQUISITE    CHEM 322/3.0.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'LLCU 302': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 302/3.0; LLCU 495/3.0 (2015-2016).'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 302',
      description:
        'An intersectional/interdisciplinary approach to the analysis of, and possible alternatives to, Canadian settler colonialism.\nPrimacy given to Indigenous voices/theories/methods related to the history of Indigenous lands and associated\ntraditions/identities, the course focuses on the theory/practice of \u2018unsettling\u2019 the settler colonial societies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Unsettling: Indigenous Peoples & Canadian Settler Colonialism',
      units: '3.0',
      PREREQUISITE: ['DEVS 220/3.0 or DEVS 221/3.0.\n'],
      'LEARNING HOURS': ['119 (36L;9G;6O;8Oc;60P)\n']
    },
    'FREN 305': {
      EXCLUSION: ['No more than 3.0 units from FREN 305/3.0; FREN 417/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 305',
      description:
        'A detailed study of selected plays from French theatre since 1945. Visual presentations. Semiotic approach. Cocteau, Duras,\nBeckett, Ionesco, Sarraute, Sartre, Kolt\u00e8s. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le th\u00e9\u00e2tre depuis 1945',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 281': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 281',
      description:
        'This course investigates the enduring popularity of the legend of Arthur, with an emphasis on its adaptability to the\nchanging values and viewpoints of different cultural moments (Celtic, Medieval, Victorian, Modern). Themes to be\ninvestigated may include chivalry, courtly love, the grail quest, national identity, politics and gender relationships.\n',
      NOTE: ['Medieval texts will be read in modern translation.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Legends of King Arthur: Medieval to Modern',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a MDVL Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 366': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 366',
      description:
        'An examination of the principles, institutions and politics of the United Nations, assessing its effectiveness in maintaining\ninternational peace and promoting cooperation among states.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The United Nations',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 151': {
      EXCLUSION: ['No more than 1 course from MUSC 151/3.0; MUSC 153/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 151',
      description:
        'This course teaches students the basics of instrumental music composition in the Western Art Music tradition with a strong\nemphasis on creativity and class participation.\n',
      NOTE: [
        'No prior experience with composition is required, but students must demonstrate a thorough understanding of the\nrudiments of music prior to enrollment.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Instrumental Composition',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 104/3.0 or MUSC P52/3.0 or permission of the School.\n'
      ],
      'LEARNING HOURS': ['136 (12L;24S;4G;96P)\n']
    },
    'ENGL 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 315',
      description:
        'This course surveys early romance, and particularly chivalric romance, from its first flowering during the twelfth century to\nthe allegorical romance of the early modern period. Writers and works to be read may include Chr\u00e9tien de Troyes, Marie de\nFrance, Sir Gawain and the Green Knight, Sir Thomas Malory, Sir Philip Sidney, and Edmund Spenser.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Romance: Medieval to Early Modern',
      units: '6.0',
      PREREQUISITE: [
        '[(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units)] or [(a GPA of 2.6) and (registration\nin a MDVL Plan)].'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'SPAN 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 205',
      description:
        'An advanced treatment of the written and spoken language, involving a study of syntax and style, written composition,\ntranslation into Spanish and oral discussions of cultural topics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after SPAN 201/6.0; SPAN 301/3.0; SPAN 302/3.0; SPAN 303/3.0; SPAN\n304/3.0; SPAN 401/3.0; SPAN 402/3.0.'
      ],
      title: 'Espa\u00f1ol avanzado',
      units: '3.0',
      PREREQUISITE: ['A grade of C in SPAN 204/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 103': {
      EXCLUSION: [
        'No more than 1 course from PSYC 100/6.0; PSYC 1UNS/3.0; PSYC 101/3.0; PSYC 102/3.0; PSYC 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 103',
      description:
        'An introductory survey of basic areas of psychology including child development, individual differences, social psychology,\nhealth and clinical psychology.\n',
      NOTE: [
        'Not offered at Queen\u2019s; only available as a transfer credit.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Psychology III',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'HIST 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 420',
      description:
        'This course explores the impact of the Cold War on the American home front between 1945 and 1991. Topics include\nreactions to the atomic bomb, the role of civil defense, McCarthyism, the culture of consumption, and the impact of the\nCold War on the family, politics, religion, science, the arts, and social movements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ulture and Society in Cold War America',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'GPHY 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 312',
      description:
        'The course examines the processes that govern the flow and dissolved load in surface waters. Assignments focus on\nhydrological and hydrochemical data analysis and problem solving. Field projects emphasize hydrological monitoring\ntechniques and methods used to collect and analyze the chemical composition of water samples.\n',
      NOTE: ['Field trips: estimated cost $50.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Watershed Hydrology',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 208/3.0 or GPHY 209/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['108 (36L;36Lb;36P)\n']
    },
    'LLCU 309': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 309/3.0; SPAN 308/3.0; SPAN 408/3.0.\nEQUIVALENCY    SPAN 308/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 309',
      description:
        'Students will view and analyze a selection of Almod\u00f3var\u2019s films within the context of Spain and other countries. The study\nof gender, sexual, cultural and societal identity and other fundamentals of contemporary theory will be central to this\ncourse.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Films of Pedro Almod\u00f3var',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 344': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 344',
      description:
        'A study of the integration of the elements of design which together contribute to a three-dimensional environment for\nperformance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Scenography',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'STAT 268': {
      EXCLUSION: ['No more than 3.0 units from STAT 351/3.0; STAT 268/3.0.'],
      RECOMMENDATION: [],
      code: 'STAT 268',
      description:
        'Basic ideas of probability theory such as random experiments, probabilities, random variables, expected values,\nindependent events, joint distributions, conditional expectations, moment generating functions. Main results of probability\ntheory including Chebyshev\u2019s inequality, law of large numbers, central limit theorem. Introduction to statistical computing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Statistics and Probability I',
      units: '3.0',
      PREREQUISITE: [
        'MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0.\nCOREQUISITE    MATH 221/3.0 or MATH 280/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOM 300': {
      EXCLUSION: [],
      RECOMMENDATION: ['MATH 110/6.0 or MATH 111/6.0.\n'],
      code: 'BIOM 300',
      description:
        'Modeling will be presented in the context of biological examples drawn from ecology and evolution, including life history\nevolution, sexual selection, evolutionary epidemiology and medicine, and ecological interactions. Techniques will be drawn\nfrom dynamical systems, probability, optimization, and game theory with emphasis put on how to formulate and analyze\nmodels.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modeling Techniques in Biology',
      units: '3.0',
      PREREQUISITE: [
        'MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MICR 450': {
      EXCLUSION: [],
      RECOMMENDATION: ['BCHM 218/3.0 or MBIO 218/3.0.\n'],
      code: 'MICR 450',
      description:
        'Further study of contemporary virology, using the textbook as a guide to particles, genomes, replication, expression,\ninfection and pathogenesis. Emphasizing reading and writing to develop skills in observation and critical thinking, important\nattributes in understanding the scientific method.\n',
      NOTE: ['Offered in alternate years to MICR 451/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Molecular Virology',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 205/3.0 and (MICR 221/3.0 with a minimum grade of B-) and (Level 4 and registration in the LISC\nMajor or Specialization Plan) and (a GPA of 2.5).\nCOREQUISITE    BCHM 310/9.0 or BCHM 315/3.0.'
      ],
      'LEARNING HOURS': ['140 (36L;12S;8T;24G;24I;36P)\n']
    },
    'HIST 468': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 468',
      description:
        'An in-depth examination of intellectual and cultural changes in continental Europe, 1750 to the present, organized around\nsuch themes as changing views of selfhood, rationality, emotions, irrationality, and technology. Movements that might be\nexamined include the late Enlightenment, Romanticism, realism, and modernism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Modern European Intellectual and Cultural History',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ENGL 461': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 461',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Modern/Contemporary British Literature I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'HIST 463': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 463',
      description:
        'Key debates in the political history of Latin America from Independence (1820s) to the recent past. Themes include the\ntension between liberalism and authoritarianism; struggles for civil, political, and human rights; populism and charismatic\nleaders; revolutionary and reactionary ideologies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'iberalism, Authoritarianism and Citizenship in Latin America',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'COMP 329': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COMP 329',
      description:
        'Introduction to Computer-Integrated Surgery\nAn introduction to concepts and novel technologies used in computer-integrated surgery, including image based navigation,\nmedical robotics and virtual reality. Concepts and techniques learned in class will be applied in a hands-on surgery session\nwhere students perform minimally invasive surgery with virtual-reality navigation tools.\n',
      NOTE: ['MATH P06/3.0 or one Mathematics 4U level course is required.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 2 or above.\nEXLUSION    No more than 3.0 units from CISC 330/3.0; COMP 329/3.0; COMP 230/3.0'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 427': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 427',
      description:
        'Consult the Department for possible offerings in any given year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Sociology III',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 157': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 157',
      description:
        'An introduction to ethics via an examination of controversial moral issues. Special topics: abortion; animal rights;\neuthanasia.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Moral Issues',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'MUSC 454': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 454',
      description: 'A continuation of MUSC 351/3.0, MUSC 354/6.0.\n',
      NOTE: [
        'In addition to the prerequisites, students must submit a portfolio of compositions to the Music Office by the last\nday of classes in the Winter Term. Admission is determined through evaluation of portfolios by a Faculty jury. Submission of\na portfolio does not guarantee admission.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Acoustic Composition',
      units: '6.0',
      PREREQUISITE: ['MUSC 351/3.0 or MUSC 354/6.0.'],
      'LEARNING HOURS': ['264 (24I;240P)\n']
    },
    'LLCU 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 101',
      description:
        'Offers a basic level of understanding, speaking, reading and writing for students with no knowledge of the language. The\nspecific language will be announced on the Department of Languages, Literatures and Cultures web page.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Language and Culture I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36S;84P)']
    },
    'CLST 332': {
      EXCLUSION: ['No more than 3.0 units from CLST 330/3.0; CLST 332/3.0.'],
      RECOMMENDATION: [],
      code: 'CLST 332',
      description:
        'Study of the period from the formation of Greek civilization following the collapse of the Bronze Age Palace Culture until\nthe end of Persian Wars (479 BCE). Topics may include the development of the polis and its institutions, Greek colonization,\nthe tyrants and the beginning of Athenian democracy, and conflict with the Persian Empire.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Iron Age to the End of the Persian Wars',
      units: '3.0',
      PREREQUISITE: ['CLST 200/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'BIOL 317': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 317',
      description:
        'Field Biology II\nTwo weeks of field work plus written assignments in one or two areas of study to be done when specialized modules are\navailable in May, July, August or February. Studies may include ecology of birds, fish, insects, small mammals, plants, tundra\nand taiga, lakes and caves.\n',
      NOTE: [
        'Field trip: estimated cost of each module and the schedule of offerings for each year are available in January.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'BIOL 307/3.0. Prior to registering in the course students must complete the application process, be placed\nin a module and complete the field work.'
      ],
      'LEARNING HOURS': []
    },
    'RELS 252': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 252',
      description:
        'The academic study of mysticism; mystical movements; and mystics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mysticism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 473': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 473',
      description:
        'This course draws on critical theories to look at sport in Western cultures. It examines sport\u2019s contribution to systems of\ngender, race, class, sexuality and ability. Topics include sport\u2019s relationship to nationalism, media, commodification,\nglobalization, and the environment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sport and Culture',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DRAM 319': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 319',
      description:
        'A seminar or workshop in selected areas of the curriculum. Not offered every year. See Department for details.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Studies II',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'FILM 510': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 510',
      description:
        'Open to students completing an honours concentration in Film and Media, or Stage and Screen Studies. Enables a student\nto pursue an area of study not covered in regularly offered courses. Applicants must obtain approval of the Undergraduate\nCoordinator and supervising instructor.\n',
      NOTE: [
        'To use Film and Media video equipment the student must have completed FILM 250/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Studies',
      units: '6.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and 30.0 units in FILM or\npermission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 393',
      description:
        'The study of music, technology, and digital media/multimedia and their interactions in contemporary contexts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Music and Digital Media',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or permission of the School.'],
      'LEARNING HOURS': []
    },
    'DDHT 459': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DDHT 459',
      description:
        'Principles of Drug Discovery\nAdvanced study of the early stage components involved in the complex process of drug development including target\nidentification, design and synthesis, structure activity relationships, in vitro and in vivo efficacy determination, biochemical\nand biological optimization.\n',
      NOTE: [
        'Priority given to students in the LISC Specialization Plan, DDHT Sub-Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'PHAR 340/3.0 or and Level 4 and registration in a LISC Major or Specialization Plan) and (a GPA of 2.5).\nCOREQUISITE    PHAR 416/3.0 or permission of the instructor.'
      ],
      'LEARNING HOURS': ['120 (12L;24G;84P)\n']
    },
    'HIST 464': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 464',
      description:
        'This course examines the history of sexuality in a comparative context, using Canada, Britain and the United States in the\n19th and 20th centuries as a focus.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he History of Sexuality',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'CLST 343': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 343',
      description:
        'Intensive study of the Later Roman Empire from the reign of Septimius Severus to the death of Theodosius I (395 CE). Topics\ninclude the Severan dynasty, the crisis of the Third Century, the Tetrarchy, and the christianization of the Roman empire.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Later Roman Empire',
      units: '3.0',
      PREREQUISITE: ['CLST 201/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'GPHY 502': {
      EXCLUSION: [
        'No more than 1 course from GPHY 501/3.0; GPHY 502/3.0; GPHY 503/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 502',
      description:
        'Research project in Geography supervised by a member of the faculty. Research involving the amount of work associated\nwith other senior 3.0 unit courses will be done as GPHY 502/3.0.\n',
      NOTE: ['Admission is subject to the availability of supervisors.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research and Thesis in Geography I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and a (GPA of 3.50 in 24.0 units in GPHY) and (registration in a GPHY Major or Medial Plan or EGPY\nSpecialization Plan) and (consent of a supervising member of the Department) or by permission of the Departmental\nUndergraduate Committee.\n'
      ],
      'LEARNING HOURS': ['120 (24I;96P)\n']
    },
    'GRMN 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 312',
      description:
        'An introduction to reading, discussing and writing about German literary texts in German. Major periods, authors, and texts\nof the 20th century will be examined in their cultural and historical contexts. Students will be exposed to different genres:\nexcerpts from novels and dramas as well as short stories, poems and film adaptations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'German Language and Culture through 20th-Century Literature',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12T;84P)\n']
    },
    'POLS 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 212',
      description:
        'An analysis of the processes, groups, parties, voters, and culture of Canadian politics. Offered annually.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Politics',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'GNDS 428': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 428',
      description:
        'This advanced seminar addresses some of the many meanings and manifestations of \u2018gender performance\u2019 in literature and\npopular culture. Primary sources include a wide variety of media - novels, plays, poems, films, magazines and cartoons.\nPrimary material will be balanced with careful consideration of work in areas such as feminist theory, identity politics,\nqueer and performance theory. This course contains an intensive and independent study component.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender Performance',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['204(36S;168P)\n']
    },
    'ANAT 215': {
      EXCLUSION: ['No more than 3.0 units from ANAT 215/3.0; ANAT 315/3.0.'],
      RECOMMENDATION: [],
      code: 'ANAT 215',
      description:
        'The general principles of human structure and function as appreciated through a survey of the morphological sciences,\nincluding: history of anatomy; embryology; neuroanatomy; developmental, microscopic and gross anatomy of the\nlocomotor system.\n',
      NOTE: [
        'Priority will be given to students registered in a LISC Specialization Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Human Morphology I',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 102/3.0 and BIOL 103/3.0) or (BIOL 201/3.0 and BIOL 202/3.0) or permission of the Department of\nBiomedical and Molecular Sciences.\n'
      ],
      'LEARNING HOURS': []
    },
    'HIST 344': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 344',
      description:
        'An examination of the path that led from the state-sanctioned racial profiling of immigrants in the late nineteenth century\nto current multicultural ideas and policies in Canada and the United States, with an emphasis on the role Jewish\nintellectuals, politicians, and community leaders played in developing and, sometimes, resisting such changes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Plural Visions: New World Jews and the Invention of Multiculturalism',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MUSC 475': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 475',
      description:
        'An intensive analysis of a particular topic within a specific area of music: ethnomusicology, musicology or theory/analysis.\nDetails regarding specific topics will be available from Dan School of Drama and Music on an annual basis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Music I',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and permission of the School.'],
      'LEARNING HOURS': []
    },
    'GEOL 301': {
      EXCLUSION: [
        'No more than 1 course from GEOL 301/1.5; GEOL 302/1.5; GEOL 368/3.0 (prior to 2013); GEOL 478/3.0 (prior\nto 2013); GEOL 488/3.0 (prior to 2013).'
      ],
      RECOMMENDATION: [],
      code: 'GEOL 301',
      description:
        'A multi-day field trip that uses stratigraphic, sedimentological, and paleontological data to interpret rock successions in a\npaleoenvironmental and tectonic context. Enrolment is limited.\n',
      NOTE: [
        'The course runs during the week of Canadian Thanksgiving. Please contact the Department for more information.\nPlease see the departmental webpage for information on costs.  Estimated $450.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Studies in Geology I',
      units: '1.5',
      PREREQUISITE: [
        'GEOL 238/3.0.\nCOREQUISITE    GEOL 321/3.0 or GEOL 337/3.0 or GEOL 368/3.0.\n'
      ],
      'LEARNING HOURS': ['61 (1L;30Pc;15G;15P)\n']
    },
    'SOCY 511': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 511',
      description:
        'Students will arrange their reading in consultation with members of the Department. They will be expected to write reports\non their readings and to discuss them throughout the term in seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 227',
      description:
        'Cities: Geography, Planning and Urban Life\nThe city from a geographical and planning perspective. Topics include origins of urbanism; mega; migrant, and global cities;\nurban competitiveness; land use planning and design; suburbanization and sprawl; new urban identities and culture;\nretailing transport; public space; private and temporary cities; urban poverty; politics and governance; sustainable urban\nfutures.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (12L;18T;30O;60P)\n']
    },
    'PHAR 100': {
      EXCLUSION: [],
      RECOMMENDATION: ['4U Biology.\n'],
      code: 'PHAR 100',
      description:
        'Topics covered include central nervous system stimulants and depressants, narcotics, alcohol, cardiovascular agents,\ncontraceptives, environmental toxicants, mechanism of drug action and disposition, antibiotics, drugs used in sports, over-\nthe-counter drugs, food additives, and vitamins.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after: PHAR 230/3.0; PHAR 270/3.0; PHAR 340/3.0; PHAR 450/3.0.'
      ],
      title: 'Introductory Pharmacology',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ARTH 226': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 226',
      description:
        'This course will examine the histories, meanings, and sites of modern art in the metropolitan West from about the mid\nnineteenth century to the mid twentieth century. Students will become familiar not only with the works themselves, but\nwith shifts in critical conceptions and key art historical problems surrounding modern art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Histories of Modern Art',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;12G;12O;72P)\n']
    },
    'POLS 395': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 395',
      description:
        'An examination of different topics and issues in global political economy, such as the role of international financial\ninstitutions, the politics of global trade, or the global distribution of wealth. The focus of this course will vary from year to\nyear; consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in International Political Economy',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 422',
      description:
        'Topics in monetary theory and policy, depending upon the interests of the instructor and students. Examples include the\nfoundations of monetary theory; money supply and demand; portfolio choice; monetary aspects of the balance of payments;\nmoney and economic growth; financial markets; the term structure of interest rates.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Monetary Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0 and ECON 320/3.0.'],
      'LEARNING HOURS': ['120 (36L;6O;78P)\n']
    },
    'PSYC 555': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 555',
      description:
        'Reading courses to be arranged in consultation with individual members of the Department.\n',
      NOTE: [
        'Students are limited to a maximum of two of PSYC 550/3.0, PSYC 555/3.0, PSYC 560/3.0, PSYC 570/3.0, or PSYC\n575/3.0. Students are also limited to a maximum of two 500-level courses supervised by the same faculty member.\n(Students registered in PSYC 501/9.0 concurrently will not normally take one of these courses with their thesis supervisor.)\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading II',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the instructor and of the Chair of Undergraduate Studies and Level 3 or above and\nregistration in a PSYC Major, Medial or Specialization Plan.'
      ],
      'LEARNING HOURS': ['117 (20G;13I;84P)\n']
    },
    'PSYC 575': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 575',
      description:
        'Directed Special Laboratory II\nLaboratory courses to be arranged in consultation with individual members of the Department. Courses must involve data\ncollection; approximately 5-7 hours of lab work per week required.\n',
      NOTE: [
        'Students whose research involves the care and/or handling of animals must also complete the Introductory Animal\nCare Course and if required the appropriate Animal Use workshops through the Office of the University Veterinarian.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Permission of the instructor and of the Chair of Undergraduate Studies and Level 3 or above and\nregistration in a PSYC Major, Medial or Specialization Plan.'
      ],
      'LEARNING HOURS': ['117 (78Lb;39P)\n']
    },
    'CHEM 112': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 112/6.0 or (CHEM 113/3.0 and CHEM 114/3.0).'
      ],
      RECOMMENDATION: ['4U Chemistry or equivalent.\n'],
      code: 'CHEM 112',
      description:
        'General Chemistry\nA survey of modern chemistry: molecular structure, bonding, phases of matter, thermodynamics, electrochemistry,\nequilibrium, kinetics, polymers, organic and biochemistry.  Using information technology, laboratories and formulation of\nproblem-solving strategies, students will develop an appreciation for the relevance of chemistry to the solution of modern-\nday societal challenges.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['288 (48L;36Lb;36G;72O;96P)\n']
    },
    'LING 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 310',
      description:
        'This course provides a foundation in the study of speech sounds. The focus is on articulatory phonetics, how to classify and\ntranscribe different sounds of speech according to their articulatory features. The course also offers an introduction to\nacoustic phonetics and feature geometry theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Phonetics',
      units: '3.0',
      PREREQUISITE: [
        'LING 100/6.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'INTS 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 306',
      description:
        'An introduction to the theory and formation of cultural identity with some reference to cross-cultural issues.\n',
      NOTE: ['Administered by the Department of Philosophy.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Culture, Identity and Self',
      units: '3.0',
      PREREQUISITE: [' Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'PHIL 343': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 343',
      description:
        'An examination of some of the principles and theories to which appeal is commonly made when social institutions and\npractices (and the policies associated with their establishment and maintenance) are subjected to critical scrutiny.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social and Political Philosophy',
      units: '3.0',
      PREREQUISITE: ['PHIL 257/6.0 or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'ITLN 326': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 226/3.0; ITLN 326/3.0; LLCU 226/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 326',
      description:
        'Addresses the various issues relating to the film adaptation of a literary text. The reading of narrative texts, the viewing of\nfilms and critical readings are required.\n',
      NOTE: [
        'Taught in English together with LLCU 226/3.0. Students concentrating in Italian submit written assignments, tests\nand examinations in Italian. Normally students will read Italian texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and Cinema',
      units: '3.0',
      PREREQUISITE: ['ITLN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 412': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 412',
      description:
        'An examination of major issues in the philosophy of culture. Possible topics to be studied include: the history of the philosophy\nof culture; the relationship between culture and identity or the self; the relationship between culture and progress; and\nvarious forms of cultural relativism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Philosophy of Culture',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'PSYC 315': {
      EXCLUSION: [
        'No more than 3.0 units from PSYC 315/3.0; PSYC 495/3.0 (2012-2016).'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 315',
      description:
        'The objective of this course is to (1) introduce the student to basic techniques for the quantitative analysis of time-varying\nsignals and (2) teach the student how to apply these techniques using MATLAB. Emphasis will be placed on methods\nappropriate to the psychological research environment.\n',
      NOTE: ['Expertise in MATLAB or signal processing is not required.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to the Analysis of Psychological Signals',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0.\n'],
      'LEARNING HOURS': ['120 (18L;36Lb;66P)\n']
    },
    'FILM 353': {
      EXCLUSION: ['No more than one course from FILM 353/3.0; FILM 365/6.0.'],
      RECOMMENDATION: [],
      code: 'FILM 353',
      description:
        'An advanced course on the conception, planning, shooting, and editing of narrative film and television. Working in groups\nof four, students will produce short, professional quality videos (maximum length eight minutes) for a public screening.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Narrative Production',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and FILM 250/6.0 and 6.0 units in\nFILM.\n'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;30G;30P)\n']
    },
    'GREK 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 422',
      description:
        'Selected works of Greek verse, usually drawn from works of epic, lyric, elegy, and drama, read in the original Greek and\ncommented upon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with GREK 322/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Greek Verse',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GREK 322/3.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['141 (36L;105P)\n']
    },
    'GREK 112': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 112',
      description:
        'Fundamentals of grammar, syntax and etymology, for students with no or little knowledge of Ancient Greek; provides\nsufficient background to read Plato, Euripides as well as the New Testament.\n',
      NOTE: ['Normally not open to students with 4U Greek.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Greek',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['276 (72L;24T;180P)']
    },
    'GEOL 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 321',
      description:
        'The nature, origin, and interpretation of deformation and fracture of rocks, and the application of structural methods to\nsite-investigation and resource exploitation. Topics include geometric, kinematic and dynamic analysis of brittle and ductile\ndeformation features; and examination of deformation styles in selected tectonic environments.\n',
      NOTE: [
        'Required full-day field trip. Please contact the Department for more information.  Estimated $25.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Analysis of Rock Structures',
      units: '3.0',
      PREREQUISITE: ['GEOL 300/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['122 (36L;18Lb;8Oc;60P)\n']
    },
    'POLS 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 401',
      description:
        'This course will consider various theoretical writings and topics in political science. The focus of this course will vary from\nyear to year. Consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Theory: Questions & Challenges',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 497',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Criticism and Theory II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'IDIS 302': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 302',
      description:
        'Historical and contemporary racism and anti-racism; critical \u2018race\u2019 theories; experiences of people of colour; case studies of\n\u2018sites of struggle\u2019 around which racism is constructed and resisted, including communities, institutions, the nation state;\nCanadian focus and international examples.\n',
      NOTE: ['Administered by the Department of Geography.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '\u2018Race\u2019 and Racism',
      units: '3.0',
      PREREQUISITE: ['Level 2.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'FREN 373': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 373',
      description:
        'Syntaxe du fran\u00e7ais canadien\nAn examination of the syntax of standard French and of Canadian French from a generative grammar perspective. The\nstudy of syntax will be explained, as well as the various properties of language that form the object of syntactic analysis.\nDiscovery of what a grammatical theory can show us about the grammar of French and consider some specific questions\nraised by the syntax of Canadian French.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'FREN 215/6.0 or (FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 420': {
      EXCLUSION: ['No more than 6.0 units from MUSC 420/6.0; MUSC 421/6.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 420',
      description: 'Continuation of MUSC 320/6.0.\n',
      NOTE: [
        'Students who do not hold the prerequisite may audition for admission to this course. They must obtain a grade of\nA- in the jury examination component of MUSC 321/6.0 or MUSC 324/6.0 and receive recommendation of the jury.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study IV (Performance)',
      units: '6.0',
      PREREQUISITE: [
        'A grade of B in both MUSC 320/6.0 and MUSC 325/6.0.\nCOREQUISITE    MUSC 425/6.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'INTS 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 307',
      description:
        'An examination of individual and group relations within and between culturally diverse societies. Topics include: relations\namong indigenous, immigrant and ethnocultural communities; acculturation and identity strategies; the role of prejudice,\ndiscrimination, dominance, emotions and values; intercultural communications and training; and modes of mutual\naccommodation (pluralism, internationalism and globalism).\n',
      NOTE: ['Administered by the Department of Sociology.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Intercultural Relations',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'MUTH 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 310',
      description:
        'An applied course focused on the integration of advanced-level singing and dancing techniques in the rehearsal and\nperformance of musical theatre scenes. Through written assignments and performance, students prepare and perform\nscenes that integrate the work of the composer, lyricist, and book writer.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Dancer-Singer in Music Theatre',
      units: '3.0',
      PREREQUISITE: [
        'A grade of B- in MUTH 210/3.0 and MUTH 211/3.0, or permission of the School upon successful audition.'
      ],
      'LEARNING HOURS': ['120 (24S;12G;84P)\n']
    },
    'GRMN 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 315',
      description:
        'Students who have participated in the Werkstudentenprogramm (or an equivalent program or internship) may obtain academic\ncredit on their return by presenting, by the end of the fall term of the same year, a 2,500 word essay about their experiences and\nsubmitting to a 90 minute written and a 20 minute oral exam, all in the German language.\n',
      NOTE: ['Participation in the Werkstudentenprogramm is required.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Work and Study in Germany',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (120P)\n']
    },
    'FILM 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 310',
      description:
        'A course in developing expertise in writing reviews of contemporary world cinema and media arts. The class will meet every\nother week throughout the Fall and Winter terms. Students\u2019 reviews will be posted on a web site.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Reviewing World Cinema and Media Arts',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\nFILM 312/3.0\nScreenwriting\nApproaches to dramatic storytelling for the screen. Students analyze examples from existing works and, through practical\nexercises, prepare a short, original screenplay.\n',
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\nFILM 315/3.0\nCommunication Technologies and Creative Practice\nIntermediate study in the evolution of digital visual communications theory and practice. Covers readings about social and\ntechnological developments in computer mediated communication, and involves creative investigation of interactive digital\nmedia through design projects.\n',
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': [
        '108 (36S;72P)\n',
        '108 (36S;72P)\n',
        '108 (36L;24Lb;48P)\n'
      ]
    },
    'ARAB 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARAB 100',
      description:
        'Introduction to the basic structures of Modern Standard Arabic. This course gives intensive training equally in listening,\nspeaking, reading, and writing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Arabic (Modern Standard)',
      units: '6.0',
      PREREQUISITE: ['Permission of the Instructor.'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'KNPE 346': {
      EXCLUSION: [
        'No more than one course from HLTH 300/3.0; KNPE 300/3.0; KNPE 330/4.5; KNPE 336/3.0; KNPE 346/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 346',
      description:
        'Under the tutelage of the Strength and Conditioning Coordinator, students will complete a field placement that involves a\nrange of practical experiences in the area of strength and conditioning programs for elite athletes. Practical sessions will be\nrotated weekly in order to provide students with a variety of experiences in program delivery, training sessions, and testing.\n',
      NOTE: [
        'Students must hold valid First Aid/CPR certification and proof of completion of Athletic Therapy experience (36 hours)\nin second year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Strength and Conditioning Field Placement',
      units: '4.5',
      PREREQUISITE: [
        'Level 3 or above in a PHED Specialization or KINE Specialization Plan and (ANAT 315/3.0 and KNPE 345/3.0)\nand (a GPA of 2.70) and permission of the course coordinator and the Undergraduate Coordinator in the School of Kinesiology\nand Health Studies.\n'
      ],
      'LEARNING HOURS': ['168 (120Pc;24G;24P)\n']
    },
    'POLS 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 442',
      description:
        'Latin American Politics\nAdvanced research course focusing on problems relating to the consolidation of democracy in contemporary Latin America.\nTopics may include political parties and elections, economic policy, mass media, social movements, and political violence.\nCase studies are drawn largely from continental South America.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'CISC 425': {
      EXCLUSION: ['No more than 3.0 units from CISC 425/3.0; SOFT 425/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 425',
      description:
        'Advanced user-interface styles such as eye-tracking input, digital desks, wearable computing, ubiquitous and context-aware\ncomputing, and tangible interfaces.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced User Interface Design',
      units: '3.0',
      PREREQUISITE: ['(C- in CISC 325/3.0) or permission of the School.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GNDS 215': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 215',
      description:
        'This course is an introduction to studies in sexuality and gender diversity. It will survey the field and include topics such as\nclassical inquiries into sexuality, contemporary theories on Lesbian, Gay, Bisexual, Transgender and Queer identities, sexual\nmovements, human rights, sexual morality, pornography, global sex trade, and queer cultural production. This course is\nopen to all students but required for students enrolled in the Certificate in Sexual and Gender Diversity. It is designed to\nintroduce SXGD students to the field and prepare them for selecting future courses.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Sexual and Gender Diversity',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'SOCY 457': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 457',
      description:
        'Sociological perspectives of the relationship of law to social structure, the role of law in social action, law\u2019s role in social\nchange, and discrimination and social inequality through law; emphasis is on contemporary systems in comparative and\nhistorical perspective.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Law and Social Structure',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 515': {
      EXCLUSION: ['No more than 1 course from HIST 515/6.0; HIST 517/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 515',
      description:
        'The project may be either a research paper involving the use of primary and secondary sources, or a more broadly\nconceived independent reading program.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ndependent Study Project',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and (registered in a HIST Major or Medial Plan) and (a GPA of 3.30) and (30.0 units in HIST).\n'
      ],
      'LEARNING HOURS': ['240 (24I;24O;192P)\n']
    },
    'NSCI 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'NSCI 499',
      description:
        'An investigation into a selected area of neuroscience. The research project involves experimental design, data collection,\nand analysis, written report and oral presentation. Students will be required to attend seminars and tutorials on topics\nrelated to research. Limited enrolment.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Neuroscience',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Specialization Plan and a GPA of 2.50.\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'MUSC 245': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 245',
      description:
        'Topics in Musics and Cultures\nA survey of a specific topic in (ethno)musicology, music and society, and/or music and its interactions within a particular\ncultural context.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'HIST 458': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 458',
      description:
        'Studies in Canadian society in its pre-industrial, industrial and post-industrial aspects, 1900-1975. Topics in labour,\nimmigration, childhood, family, urban and rural history, with emphasis upon both the cultural and technological contexts of\nsocial change. Readings from the traditional and \u2018new\u2019 social history literatures. The discussion is national in scope with\nfocus upon distinctive regional developments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Social History of Modern Canada',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'RELS 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 301',
      description:
        'A topic of current interest in Religious Studies not covered in other available courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Themes in Religious Studies',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'ECON 425': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 425',
      description:
        'A rigorous treatment of the major issues in international trade theory, using mainly geometrical tools. There is also\nemphasis on empirical testing of various hypotheses. The major topics covered are the determinants of international trade\npatterns, commercial policy issues, trade and economic growth and regional integration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Trade Theory and Policy',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;6O;72P)\n']
    },
    'LATN 110': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 110',
      description:
        'Introductory Latin\nFundamentals of grammar, syntax and etymology for students with no or little knowledge of Latin; provides sufficient\nbackground to read Latin prose and poetry.\n',
      NOTE: ['Normally not open to students with 4U Latin.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ENGL 465': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 465',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Modern/Contemporary Canadian Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'FILM 236': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 236',
      description:
        'Introduction to cultural and social theory of film and other media as it relates to the tension between citizenship and\nconsumerism. Examines roles, functions, and impact of mass media technologies, institutions, and practices in both scholarly and\npractical forms.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Media and Cultural Studies',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;24Lb;24O;36P)']
    },
    'MATH 225': {
      EXCLUSION: [
        'No more than 3 units from MATH 225/3.0; MATH 226/3.0; MATH 231/3.0; MATH 235/3.0; MATH 237/3.0;\nMATH 232/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 225',
      description:
        'An introduction to solving ordinary differential equations. Topics include first order differential equations, linear differential\nequations with constant coefficients, and applications, Laplace transforms, systems of linear equations.\n',
      NOTE: ['Some knowledge of linear algebra is assumed.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Ordinary Differential Equations',
      units: '3.0',
      PREREQUISITE: [
        'MATH 120/6.0 or MATH 121/6.0 or MATH 124/3.0 or MATH 126/6.0 or MATH 122/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\nEQUIVALENCY   MATH 232/3.0.\n']
    },
    'CLST 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 410',
      description:
        'Intensive study of a special topic, period, or author(s) in the Greek world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Greek Scholarship',
      units: '3.0',
      PREREQUISITE: ['Level 4 in a CLST or CLAS or GREK or LATN Plan.'],
      'LEARNING HOURS': ['120 (24L;12S;84P)\n']
    },
    'RELS 229': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 229',
      description:
        'The philosophy, worldview, spirituality and ethics of Confucianism in its classical, modern and contemporary forms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Confucianism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 340',
      description:
        'Combinational circuits; sequential circuits; digital systems design; micro-programming; bus structures; data\ncommunications; interface design; microprocessor systems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Digital Systems',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 221/3.0.'],
      'LEARNING HOURS': ['120 (12L;24G;84P)\n']
    },
    'WRIT 175': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 175',
      description:
        'An intensive study of the essay-writing process, from techniques of prewriting and outlining through revising for\ngrammatical correctness and argumentative clarity, with particular emphasis on critical reading skills. Enrolment is limited.\n',
      NOTE: [
        'A student with a 100-level course with a writing component, such as DRAM, ENGL, FILM, HIST, PHIL, POLS, SOCY\nmay alternatively use this as a prerequisite and should contact the instructor for permission to register in the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Effective Writing II',
      units: '3.0',
      PREREQUISITE: [
        '(3.0 units from WRIT 125/3.0 or WRIT P75/3.0) or permission of the instructor.'
      ],
      'LEARNING HOURS': []
    },
    'RELS 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 235',
      description:
        'Examines how religious traditions shape human values and behaviours towards the environment and how environmental\nproblems are shaping the evolution of religious and spiritual traditions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Environment',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 262': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 262',
      description:
        'An introduction to the major issues in the study of international political economy, including transnationalism, integration,\nglobalization, and underdevelopment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Political Economy',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': ['118 (24L;10T;84P)\n']
    },
    'ENGL 590': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 590',
      description:
        'A critical essay of at least 7500 words on a topic of the student\u2019s choice, written under the supervision of a faculty member.\nFor additional information, students should consult the Department, preferably in the spring of their third year. Open only\nto students in the final year of a Major or Medial Plan in English.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Senior Essay Option',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department and (a minimum GPA of 3.50 in 24.0 previous English units). The 3.50 GPA\nrequirement may be waived in exceptional cases by request of the essay\u2019s faculty supervisor.'
      ],
      'LEARNING HOURS': ['120 (12I;108P)\n']
    },
    'GPHY 259': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 259',
      description:
        'The ecological, cultural, and historical factors that contribute to the shaping of modern Europe.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Geography of Europe',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 101/3.0 or GPHY 102/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'GPHY 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 330',
      description:
        'The course provides a systematic examination of urban transportation in the context of general economic, social and spatial\ntrends. Particular focus is placed on the role of the built environment in explaining travel behaviour. The aim is to provide a\nfair understanding of transportation planning and policy issues and explore potential solutions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Transportation Geography',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 436': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 436',
      description:
        'This course provides an overview of the main theoretical perspectives on gender differences and similarities in sexuality,\nand examines how differences and similarities manifest in multiple domains, including sexual attitudes and behaviours,\nsexual motivation, mating strategies, sexual orientation, sexual psychophysiology, atypical sexuality, and sexual functioning.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sexuality and Gender',
      units: '3.0',
      PREREQUISITE: [
        'PSYC 203/3.0 and (PSYC 235/6.0 or PSYC 236/3.0 or PSYC 333/3.0 or BIOL 369/3.0 or BIOL 210/3.0).'
      ],
      'LEARNING HOURS': ['126 (12L;24S;90P)\n']
    },
    'MUTH 211': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 211',
      description:
        'A continuation of dance and performance techniques developed in previous instruction. This course will include the study\nof the creation of choreography for ensemble members. Students will learn to choreograph a musical theatre piece with a\nproper historical context, technique, and relationship to appropriate text.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Dance for Music Theatre',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a B.M.T. Plan, or permission of the School upon successful audition.'
      ],
      'LEARNING HOURS': ['120 (24S;12G;84P)\n']
    },
    'MATH 328': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 328',
      description:
        'Metric spaces, topological spaces, compactness, completeness, contraction mappings, sequences and series of functions,\nuniform convergence, normed linear spaces, Hibert space.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Real Analysis',
      units: '3.0',
      PREREQUISITE: ['MATH 281/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'ARTH 223': {
      EXCLUSION: ['No more than 3.0 units from ARTH 223/3.0; ARTH 250/3.0.'],
      RECOMMENDATION: [],
      code: 'ARTH 223',
      description:
        'A comparative study of English and Continental European art in the first half of the 19th century. Topics will include\nlandscape as an expression of class and power, art and politics in French Romanticism, gender roles in Pre-Raphaelite\npainting and the rhetoric of Realism.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Art in Europe c.1800-1850',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BCHM 315': {
      EXCLUSION: ['No more than 3.0 units from BCHM 102/3.0; BCHM 315/3.0.\n'],
      RECOMMENDATION: [],
      code: 'BCHM 315',
      description:
        'Proteins and Enzymes\nPrinciples of protein biochemistry, enzymology, and protein engineering.\n',
      NOTE: [
        'Students lacking the prerequisites CHEM 222/3.0 or CHEM 282/3.0 may take these courses as a corequisite with\npermission of the Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 or above and (BCHM 218/3.0 or MBIO 218/3.0) and [(CHEM 222/3.0 and CHEM 223/3.0) or CHEM\n282/3.0].\n'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'PHIL 373': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 373',
      description:
        'This lecture course provides an analysis of key figures and texts in continental European philosophy between 1900 and\n1960.  Possible figures include Edmund Husserl, Martin Heidegger, Karl Jaspers, Gabriel Marcel, Hannah Arendt, and Hans-\nGeorg Gadamer. Possible topics include phenomenology, existentialism, and hermeneutics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Continental Philosophy, 1900-1960',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 226': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 226',
      description:
        'A discussion of the central concepts in sociological theory, for example, agency and structure; rationality, reason, and\nabstraction; social continuity and social change; subjectivity and selfhood; language and interpretation are normally\nconsidered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Central Concepts in Sociological Theory',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'ENSC 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 430',
      description:
        'Interdisciplinary study of the scientific, socio-political, and economic aspects of selected local, national, or global issues\nrelated to environmental sustainability. Teamwork is emphasized.\n',
      NOTE: ['One full-day weekend field trip: estimated cost $15.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Projects in Environmental Sustainability',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and registration in an ENSC Major, ENVS Medial, EBIO, ECHM, EGEO, EGPY, ELSC or ETOX Plan or\npermission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 352',
      description:
        'Guidance in the development of the student as a composer of electroacoustic music.\n',
      NOTE: [
        'Students must submit in writing to the Music Office their request to apply for this course by the last day of classes\nin the Winter Term.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Electroacoustic Composition',
      units: '3.0',
      PREREQUISITE: ['MUSC 255/6.0 and permission of the School.'],
      'LEARNING HOURS': []
    },
    'ANAT 270': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ANAT 270',
      description:
        'This course is designed to introduce the foundations of human structure and function to students at all levels of post-\nsecondary education. Through a series of learning modules, students will develop an understanding of the architecture of\nthe human body through interactive study using a virtual cadaver. This course will survey the gross and microscopic\nanatomy of the body organ systems including the skeletal, muscular, nervous, endocrine, cardiovascular,\nlymphatic/immune, respiratory, digestive, urinary and reproductive systems.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after ANAT 215/3.0; ANAT 216/3.0; ANAT 315/3.0; ANAT 316/3.0.'
      ],
      title: 'Human Anatomy and Morphology',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 102/3.0 and BIOL 103/3.0) or permission of the Department of Biomedical and Molecular Sciences.\n'
      ],
      'LEARNING HOURS': ['120 (60O;60P)\n']
    },
    'FREN 304': {
      EXCLUSION: ['No more than 3.0 units from FREN 304/3.0; FREN 404/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 304',
      description:
        'A study of representative literary works in the Middle Ages, including La Chanson de Roland, Tristan et Iseult, Le Roman de\nRenart, Le Roman de la Rose, Chr\u00e9tien de Troyes, Rutebeuf and Villon. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Introduction \u00e0 la litt\u00e9rature fran\u00e7aise du Moyen Age',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SPAN 495': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 495',
      description:
        'Seminar courses on topics in Spanish literature. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literatura de Espa\u00f1a: Estudios independientes II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SPAN Major or SLAS Specialization Plan or permission of the Department of\nLanguages Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'GPHY 228': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 228',
      description:
        'This course examines how geographers understand the global economic system. Topics include globalization, regional\neconomic integration, transnational production and marketing strategies of firms, new patterns of consumption, the rise of\nthe service economy, and work and employment in the new economy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Geographies of the Global Political Economy',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['129 (36L;9G;24O;60P)\n']
    },
    'GPHY 344': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 344',
      description:
        'Provides analysis of map design, construction, interpretation, and geographical data visualization techniques. Topics\nexplore different mapping concepts and techniques for designing and producing quantitative and qualitative thematic\nmaps. Emphasis on the representation of spatial data using 2- and 3-dimensional visualization methods. Lectures\ncomplement hands-on computer laboratory exercises.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cartographic Design and Visualization',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'HIST 121': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 121',
      description:
        'The Intellectual Origins of the Contemporary West\nAn introduction to European intellectual history from the ancient world to the present. Concentration is on the analysis of\nprimary sources and ideas in their historical contexts. The course offers weekly introductory lectures followed by discussion\nof source material in small tutorial groups where the objective is maximum student participation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (36L;36S;168P)']
    },
    'LLCU 215': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 215/3.0; ITLN 215/3.0; ITLN 415/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 215',
      description:
        'A study of Dante Alighieri\u2019s life and poetry, especially the Vita Nuova and the Divine Comedy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Dante',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    ITLN 215/3.0.\n']
    },
    'BIOL 111': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 111',
      description:
        'Introduces the basic concepts of ecology and shows how they relate to environmental issues such as population growth,\nresource management, biodiversity, agriculture, air and water pollution, energy, and climate change, and to solutions\nleading to a sustainable environment.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after BIOL 302/3.0; BIOL 303/3.0.'
      ],
      title: 'Ecology and the Environment',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'ARTH 492': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 492',
      description:
        'The detailed, analytic study of a selected body of texts within the literature of art, directed towards gaining an\nunderstanding of the dominant theories, critical attitudes, or historical perspectives on art during a particular period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in the Literature of Art',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'PHAR 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHAR 450',
      description:
        'Topics include: neuropsychopharmacology, cardiovascular pharmacology, agents acting on the endocrine system, and\nchemotherapy.\n',
      NOTE: [
        'This course involves team based learning sessions and a drug literature evaluation assignment.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of General Pharmacology II',
      units: '3.0',
      PREREQUISITE: [
        '(PHAR 230/3.0 or PHAR 270/3.0 with a minimum grade of B+) or PHAR 340/3.0 or permission of the course\ncoordinator.'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 254': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 254',
      description:
        'The past, present and future role of the Caribbean in the world economy, with  an emphasis on the colonial legacy, debt\nand dependency, the effects of neoliberal reform and the changing geographies, and patterns of uneven development\ncreated by increasingly transnational flows of capital, people and culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Caribbean in a Globalizing World',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'PHIL 374': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 374',
      description:
        'This lecture course provides an analysis of key figures and texts in continental European philosophy from 1960 to the\npresent.  Possible figures include Michel Foucault, Jacques Derrida, Jurgen Habermas, Emmanuel Levinas, Jean-Francois\nLyotard, and Julia Kristeva. Possible topics include hermeneutics, postmodernism, critical theory and feminism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Continental Philosophy 1960-present',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'This introductory course provides first-year students with a selection of key skills and theories from across a number of': {
      EXCLUSION: ['No more than 3.0 units from BISC 100/3.0; FILM 106/3.0.\n'],
      RECOMMENDATION: [],
      code:
        'This introductory course provides first-year students with a selection of key skills and theories from across a number of',
      description:
        'disciplines (Film and Media, Geography, History, Sociology) that will allow them to engage with their further studies and\ntheir role in a globalised environment with confidence, intelligence and ambition.\n',
      NOTE: [
        'This is a mandatory course for students in the First-Year Program at the Bader International Study Centre, and is\nonly available to First-Year Program students.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Thinking Locally',
      PREREQUISITE: [],
      'LEARNING HOURS': ['152.4 (14.4L;12S;6Pc;6G;42Oc;72P)\n']
    },
    'ECON 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 450',
      description:
        'Estimation methods, including least squares and maximum likelihood; specification testing, including t, F, likelihood ratio\nand Lagrange multiplier tests; serial correlation and heteroskedasticity; dynamic models and simultaneous equation\nmodels. Extensive use of calculus and linear algebra. Offered concurrently with ECON 852/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Econometrics',
      units: '3.0',
      PREREQUISITE: [
        'ECON 351/3.0 and ECON 452/3.0 and permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'GPHY 104': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 104',
      description:
        'Forests are a critical global resource, containing significant biodiversity, regulating CO2 in the atmosphere, and providing\ncultural and economic benefits to society. Yet forests are threatened by over-harvesting, fire, development and\nenvironmental change. This course examines the ecology, distribution, and sustainability of the world\u2019s forests.\n',
      NOTE: ['Field trips: estimated cost $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Forests as a Global Resource',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;36O;48P)']
    },
    'BIOL 540': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 540',
      description:
        'Research practicum under the supervision of a Biology faculty member. The course will involve a combination of research in\nthe host laboratory, attendance of BIOL 537 or other seminars in the Department, and literature research to present as a\nmajor paper and seminar.\n',
      NOTE: [
        'Students will normally be enrolled in the fourth year of their Program, having completed the third year core\nrequirements of their Plan.\n'
      ],
      'ONE-WAY EXCLUSION': ['Not to be taken concurrently with BIOL 537/12.0.'],
      title: 'Research Mentorship in Biology',
      units: '6.0',
      PREREQUISITE: [
        'Registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH, EBIO-P-BSH)\nand a minimum GPA of 2.0 in the Biological Foundations List and permission of the Department.\n'
      ],
      'LEARNING HOURS': ['248 (8S;24T;120Pc;96P)\n']
    },
    'MUSC 125': {
      EXCLUSION: ['No more than 6.0 units from MUSC 121/6.0; MUSC 125/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 125',
      description:
        'Students will perform in a public recital in accordance with the guidelines established by the Dan School of Music.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\nCOREQUISITE    MUSC 120/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study I (Performance Recital)',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ECON 332': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 332',
      description:
        'The development of the economies of Canada from Confederation and the U.S. since the Civil War. A comparative approach\nto the development of the two economies is taken.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economic History of North America since 1865',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'RELS 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 341',
      description:
        'Spirituality, Secularity, and Nonreligion\nA study of concepts intended to summarize positions which are necessarily defined in reference to religion but considered\nto be other than religious. We explore the origins and presents of perspectives and experiences including the secular,\nspiritual-but-not-religious, atheistic, and other forms of imitation, indifference, and hostility to religion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['126 (24L;6G;12O;84P)\n']
    },
    'BCHM 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 432',
      description:
        'Principles of regulatory mechanisms; regulation of cellular function and growth by oncogenes, growth factors, isoprenoids\nand steroid hormones. Receptors, second messengers and protein phosphorylation. Correlation of cell ultrastructure with\nbiochemical function. Description of the components, assembly, metabolism and evolution of cellular structures are\ndescribed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Molecular Basis of Cellular Function',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Specialization or Major Plan) and [a GPA of 2.7 in BCHM 313/3.0, BCHM\n315/3.0, BCHM 316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['120 (30L;6G;84P)\n']
    },
    'IDIS 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 303',
      description:
        'An exploration of the way in which the patterns that we observe in the world about us can be described by language and\nunderstood with the tools of analysis and synthesis. A carefully selected sequence of poems and mathematical problems\nwill be examined in a discussion format, and students will be expected to examine similar examples on their own.\n',
      NOTE: [
        'Administered by the Departments of English Language and Literature and Mathematics and Statistics.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematics and Poetry',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'GPHY 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 415',
      description:
        'A fourth year Honours capstone project course exploring a contemporary geographic issue by integrating advanced\nknowledge and skills in physical geography and geographic information science. Focus will be on integration of field and\nlaboratory methods, and how they are used to explore contemporary geographic or environmental issues.\n',
      NOTE: [
        'Field trips within the Province of Ontario during the year. Costs will vary depending on location, but not likely to\nexceed $175 per year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Analysis of Earth Surface Processes',
      units: '6.0',
      PREREQUISITE: [
        ' Level 4 and (6.0 units from MATH or STAT at the 100-level or above) and (6.0 units from CHEM or PHYS at\nthe 100-level or above) and (a GPA of 1.90 in 30.0 units from GPHY) and (registration in a GPHY Major [Science] or EGPY\nSpecialization Plan).'
      ],
      'LEARNING HOURS': ['240 (12L;12S;36Lb;12G;24Oc;144P)\n']
    },
    'COMP 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COMP 393',
      description:
        'A Computing Internship involves spending twelve to sixteen months in a paid internship position in the private or public\nsectors. Students in a 12-month internship register in COMP 390/6.0 and either COMP 391/3.0 or COMP 392/3.0, or all of\nCOMP 393/3.0, COMP 391/3.0 and COMP 392/3.0. Students in a 16-month internship register in COMP 390/6.0, COMP\n391/3.0 and COMP 392/3.0. The Internship Coordinator must be satisfied that the work carried out has educational merit.\nSuccessful completion of the course requires submission of a satisfactory report on the experience within thirty days of\ncompletion of the work period. The Internship Coordinator is responsible for evaluating the report. The QUIP program\nincludes prior workshops on interviewing, resum\u00e9 preparation and work performance. Career Services manages the non-\nacademic aspects of the program.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computing Internship IV',
      units: '3.0',
      PREREQUISITE: [
        'GPA of 1.90 and Level 2 or 3 and registration in a Bachelor of Computing internship plan (BMCO-I-BCH or\nCOGS-I-BCH or COMA-I-BCH or COMP-I-BCH or CSCI-I-BCH or SODE-I-BCH).'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 438': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 438',
      description:
        'Advanced study and synthesis of educational theories and practices in music introduced in music education courses.\nStudents are expected to engage in independent and cooperative study of agreed upon topics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Education Seminar',
      units: '3.0',
      PREREQUISITE: ['MUTH 387/3.0 or permission of the School.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 492': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 492',
      description: 'Content varies. Not offered every year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Computing Science III',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'MATH 381': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 381',
      description:
        'A historical perspective on mathematical ideas focussing on a selection of important and accessible theorems. A project is\nrequired.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematics with a Historical Perspective',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 212/3.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH\n126/6.0 or MATH 122/6.0).'
      ],
      'LEARNING HOURS': ['120 (36L;12G;72P)\n']
    },
    'ECON 426': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 426',
      description:
        'The study of international capital flows, sovereign debt, and international risk-sharing; real exchange rates and international\ngoods pricing; topics in international finance such as exchange-rate modeling and speculative attacks; and policy topics such as\nfiscal and monetary policy effects and exchange-rate regime choice.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Macroeconomics',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0 and ECON 320/3.0.'],
      'LEARNING HOURS': ['120 (36L;12I;72P)\n']
    },
    'FILM 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 415',
      description:
        'Advanced seminar on one or more approaches to cinema and culture, based on a selection of writings and related\nscreenings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Theory: Special Topic',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'ECON 354': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 354',
      description:
        'Computational Methods in Economics and Finance\nAn introduction to numerical methods as used in economics, finance, and related fields. Topics include optimization, non-\nlinear systems, numerical approximation, and simulation. Includes a major project where students implement economic\nmodels or replicate work found in the literature.\n',
      NOTE: [
        'Programming experience is recommended but not required. Students with a strong math or computing background\ncan contact the department for permission.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'ECON 255/3.0.\nCOREQUISITE    ECON 250/3.0 or STAT 263/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;18G;66P)\n']
    },
    'ARTH 210': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 210',
      description:
        'A course surveying the study of artists\u2019 materials and techniques through methods of examination such as X-radiography,\ninfrared reflectography, dendrochronology, and high-resolution digital imaging.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'An Introduction to Technical Art History',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'BIOL 308': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 308',
      description:
        'One week of field work plus written assignments in one or two areas of study to be done when specialized modules are\navailable in May, July, August or February. Studies may include ecology of birds, fish, insects, small mammals, plants, tundra\nand taiga, lakes and caves.\n',
      NOTE: [
        'Field trip: estimated cost of each module and the schedule of offerings for each year are available in January.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Studies in Biology I',
      units: '1.5',
      PREREQUISITE: [
        'BIOL 201/3.0 and BIOL 202/3.0. Prior to registering in the course students must complete the application\nprocess, be placed in a module and complete the field work.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 358': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 358',
      description:
        'Notation, symbols and format of popular music, jazz and music theatre. Scoring and arranging for small jazz groups, studio\nbands, rock bands, and commercial orchestra.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Jazz and Popular Music Arranging',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 293/3.0 or MUSC 291/6.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'BCHM 319': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 319',
      description:
        'Application of separation and essay techniques to the study of proteins, metabolism and molecular biology.\n',
      NOTE: [
        'This course is for outgoing Biochemistry Honours exchange students who are not able to obtain the equivalent of\nBCHM 317/6.0 when on exchange.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intro Biochemistry Laboratory',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '180 (48Lb;132P)\nCOREQUISITE    BCHM 315/3.0 or BCHM 316/3.0.\n'
      ]
    },
    'FREN 283': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 283',
      description:
        'An introduction to business French, including discussions of related cultural and economic issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le fran\u00e7ais des affaires',
      units: '3.0',
      PREREQUISITE: [
        'FREN 150/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 100/6.0 or FREN 110/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'COGS 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'COGS 300',
      description:
        'Importance and challenges of building cognitive models; steps of model building, programming simple models using\ncomputational and statistical techniques and tools such as Matlab. Recent models from research publications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Programming Cognitive Models',
      units: '3.0',
      PREREQUISITE: [
        'C- in [(COGS 201/3.0 or PSYC 221/3.0) and (PSYC 202/3.0 or STAT_Options)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 261': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 261',
      description:
        'An introduction to the history of the Acadian population in the Maritime Provinces, from the beginnings of French\ncolonization to the present day. This course will familiarize students with the major themes and events in the social,\npolitical, economic, and cultural history of the Acadians. Particular attention will be put on the lives of both genders and all\nsocial classes of this French-speaking people.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History of Acadia 1604 to Today',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['132 (36L;36O;60P)\n']
    },
    'PHIL 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 402',
      description:
        'An examination of major issues in contemporary moral philosophy. Topics to be studied may include contractualism, objectivity,\npractical reason, relativism and value realism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Moral Philosophy I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DDHT 460': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DDHT 460',
      description:
        'Advanced study of the component parts of the complex process of drug discovery and development and the assessment of\nhuman toxicology including drug delivery and formulation, directed toxicology studies, drug disposition, clinical trials, legal\nissues and regulatory approval.\n',
      NOTE: [
        'Priority given to students in the LISC Specialization Plan, DDHT Sub-Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Drug Development',
      units: '3.0',
      PREREQUISITE: [
        'DDHT 459/3.0 and PHAR 416/3.0 and registration in a LISC Major or Specialization Plan and (a GPA of 2.5)\nor permission of the instructor.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MICR 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 452',
      description:
        'Course material will focus on the molecular basis for virus pathogenesis including host immune responses to virus infection,\nand viral countermeasures. Emphasis will be on viral infections that result in gastrointestinal, haematological, neurological,\nand respiratory diseases. Tutorials will focus on discussion of current and seminal literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Viral Infection and Immunity',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the LISC Major or Specialization Plan and a GPA of 2.5 and MICR 221/3.0 and\nMICR 360/3.0.'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 401': {
      EXCLUSION: [
        'No more than 3.0 units from GPHY 401/3.0; GPHY 402/3.0; GPHY 403/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 401',
      description:
        'Seminars offered by regular and visiting faculty on Geography topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each academic year.\n',
      NOTE: [
        'Field trip fees may apply in certain years. See departmental webpage for more information. Cost will vary\ndepending on location, but not likely to exceed $300 per year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Seminar in Human Geography I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (a GPA of 2.60 in 24.0 units in GPHY and registration in a GPHY Major or Medial [Arts] Plan).\n'
      ],
      'LEARNING HOURS': ['132 (36S;24Oc;72P)\n']
    },
    'FILM 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 402',
      description:
        'This research and workshop based course will focus on a wide variety of research practices.  Queen\u2019s faculty members and\nvisiting speakers will give guest talks on their creative works, research practices and methodologies, accessing archival\nmaterial, and on making creative and practical research available beyond the academic environment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Seminar and Workshop',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;48O;36Oc)\n']
    },
    'ARTH 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 402',
      description:
        'An in-depth study of Renaissance painting techniques in Italy and/or Northern Europe. Selected issues of technique and\nconservation will be examined within a broader art-historical framework.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Renaissance Painting Technique',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 204': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 204',
      description:
        'Elements of mathematical logic with computing applications. Formal proof systems for propositional and predicate logic.\nInterpretations, validity, and satisfiability. Introduction to soundness, completeness and decidability.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Logic for Computing Science',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and C- in [CISC 121/3.0 and (CISC 102/3.0 or MATH 110/6.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 206': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 206',
      description:
        'An exploration of the history and archaeology of Roman Britain from the expeditions of Julius Caesar in 55 B.C. to the\nRoman withdrawal in 411 A.D. On-site instruction in excavation and archaeological practice, and visits to major Roman sites\nabout the United Kingdom.\n',
      NOTE: ['This course includes a five-day field trip component.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Roman Britain',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['105 (18L;15S;12Lb;35G;25P)\n']
    },
    'ARTF 127': {
      EXCLUSION: [
        'No more than 6.0 units from ARTF 100/6.0; ARTF 127/6.0.\n',
        'No more than 6.0 units from ARTF 102/3.0; ARTF 110/6.0; ARTF 127/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'ARTF 127',
      description:
        'Introductory Fine Art I\nA foundation course that offers two of the sections from the four media areas available at this level: painting, drawing, two-\ndimensional fundamentals, and three-dimensional fundamentals. One class per week will be devoted to learning safe\nprocedures and technical skills in the wood-shop. There will be a half-day WHMIS safety training workshop.\n',
      NOTE: ['Open only to students in a BFA Program.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after: ARTF 125/6.0; ARTF 260/3.0; ARTF 265/3.0.'
      ],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['288 (144Lb;144P)\n']
    },
    'POLS 457': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 457',
      description:
        'Issues in Global Justice\nAn exploration of issues in international politics from a theoretical and normative perspective, including global\nredistributive justice, just war theory, theories of secession, and normative theories of humanitarian intervention. Among\nthe questions posed are whether we have an obligation to redistribute wealth to strangers, what can justify secession,\nintervention and war; and the terms on which people can migrate to other countries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'EPID 301': {
      EXCLUSION: [
        'No more than 3.0 units from BMED 270/3.0; EPID 301/3.0; HLTH 323/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'EPID 301',
      description:
        'Principles of Epidemiology\nBasic methods involved in researching the distribution and determinants of health/disease in populations. Core principles\nof epidemiology are examined, as are the various epidemiological approaches to study design. The latter include descriptive\n(cross-sectional and ecological), observational (case-control and cohort), and experimental (randomized controlled trials)\napproaches.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'BIOL 243/3.0; CHEE 209/3.0; COMM 162/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0; NURS 323/3.0;\nPHED 251/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0 or permission of the\nDepartment of Biomedical and Molecular Sciences.\n'
      ],
      'LEARNING HOURS': ['117(13.5L;13.5T;6G;12O;72P)\n']
    },
    'INTS 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 301',
      description:
        'This course will offer a unique opportunity to study a special topic in Britain and Europe in a global context. Topics will vary\neach term, and the course may not be offered every year. For detailed course description, see www.queensu.ca/bisc\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Studies in Britain and Europe in a Global Context II',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'SOCY 472': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 472',
      description:
        'Examination of the relevance of sociological theories for a cross-cultural understanding of development.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in the Sociology of Development',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'LLCU 495': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 244/3.0; LLCU 495/3.0 (2015-2016).\n'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 495',
      description:
        'Special topics. For detailed information, consult the Department of Languages, Literatures and Cultures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics I',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CLST 129': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 129',
      description:
        'Development of the discipline, methods of discovering and recovering materials through excavation, evaluation of such\nmaterials and reconstruction of original environments. Historic and prehistoric sites; contribution of archaeology to the\nknowledge of the past.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Archaeology',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['252 (72L;180P)']
    },
    'MUSC 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 200',
      description:
        'Chamber music or small ensemble experience for qualified instrumentalists and singers. Topics vary. Course includes\nweekly or bi-weekly coachings and a minimum of one evaluation and/or concert per term for all students. Credit attained\nonly with regular attendance, active participation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Small Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': []
    },
    'PHIL 463': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 463',
      description:
        'An examination of major issues in contemporary metaphysics. Possible topics include causation, properties, time, modal\ntheory, and induction.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Metaphysics II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 272': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 272',
      description:
        'Surveys the art and architecture of Latin America from the pre-Hispanic period to the present, from Patagonia to California.\nParticular attention is paid to the contribution of aboriginal artists and traditions to colonial visual culture and the built\nenvironment. Considers the rise of the academies, Nationalism, Indigenism, Romanticism, Modernism (Kahlo, Rivera,\nTarsila), Mad\u00ed and Chicano muralism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Latin American Art',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 375': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 214/3.0 and 215/3.0 (or ARTH 213/6.0).\n'],
      code: 'ARTH 375',
      description:
        'A study of Netherlandish painters (c.1410-1560) from the Master of Fl\u00e9malle and Jan van Eyck to Geertgen tot Sint Jans and\nHieronymus Bosch.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Early Netherlandish Painting',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'SOCY 300': {
      EXCLUSION: [
        'No more than 3.0 units from SOCY 300; SOCY 301/3.0-001 (2009-2015).'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 300',
      description:
        'More than 50% of the world\u2019s population now lives in cities and most of the biggest sociological issues are urban in location\nand character. Understanding cities is therefore crucial to understanding contemporary societies. This course is an intensive\nintroduction to Urban Sociology with particular emphasis on world cities.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Cities',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'WRIT 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 235',
      description:
        'An interdisciplinary course that employs a community service-learning model in order to develop specialized writing skills.\nStudents will be actively involved in the completion of a writing project in the local community. Written and oral work will\nfacilitate individual reflection on the writing process. Class time consisting of lectures, discussions, workshops, and\npresentations will encourage critical thinking, editing, and research skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing in the Community',
      units: '6.0',
      PREREQUISITE: [
        '(3.0 units from WRIT 125/3.0 or WRIT 175/3.0 or WRIT 195/3.0 or WRIT P75/3.0) or permission of the\ninstructor.'
      ],
      'LEARNING HOURS': []
    },
    'SOFT 425': {
      EXCLUSION: ['No more than 3.0 units from CISC 425/3.0; SOFT 425/3.0.'],
      RECOMMENDATION: [],
      code: 'SOFT 425',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced User Interface Design',
      units: '3.0',
      PREREQUISITE: ['CISC 325/3.0 or permission of the School.\n'],
      'LEARNING HOURS': []
    },
    'GNDS 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 212',
      description:
        'Decades after the formal decolonization of former colonies, the power relations of the colonial world - and the racism it\nengendered - remain deeply embedded in the West, and are intrinsic to contemporary relations of globalization. This\ncourse explores European colonialism; historical and social constructions of \u2018race\u2019; the ongoing occupation of Indigenous\npeoples\u2019 territories; and contemporary racism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Racism, Colonialism and Resistance',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'BIOL 110': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 110',
      description:
        'Introductory genetics and evolutionary processes as they relate to the human condition - genetic diseases, medical\ntechniques, inheritance and ethical issues such as cloning and genetically modified foods.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after BIOL 102/3.0; BIOL 103/3.0.'
      ],
      title: 'Human Genetics and Evolution',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['118 (26L;10T;10G;36O;36P)\n']
    },
    'GNDS 350': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 350',
      description:
        'Feminism, the Body and Visual Culture\nThis course will explore how the visual constructs and/or subverts \u2018woman\u2019 as a cultural category. An emphasis will be\nplaced upon the female body as it intersects with class and race. Readings from art history, history, cultural theory and\nfeminist theory will be considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 215': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 215',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GPHY 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 307',
      description:
        'Field work plus written assignments in an aspect of physical geography, to be undertaken when a formal field course is\noffered.\n',
      NOTE: ['Field trips: estimated cost $400, depending on the location.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Studies in Physical Geography',
      units: '3.0',
      PREREQUISITE: [
        '(GPHY 208/3.0 and GPHY 209/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 200',
      description:
        'This course explores the sociological dimensions affecting the meaning and experience of health and illness in\ncontemporary society. Topics include policy, professionalization, medicalization, mental health, inequalities, bioethics, and\nglobalization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Health and Illness',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0) or HLTH 101/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 311',
      description:
        'Congruences; Euler\u2019s theorem; continued fractions; prime numbers and their distribution; quadratic forms; Pell\u2019s equation;\nquadratic reciprocity; introduction to elliptic curves.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Elementary Number Theory',
      units: '3.0',
      PREREQUISITE: ['MATH 210/3.0 or MATH 211/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 335': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 201/3.0 and BIOL 202/3.0 are recommended.\n'],
      code: 'BIOL 335',
      description:
        'Physics, chemistry and biology of freshwater lakes. Emphasis on: morphometry; light and temperature; water chemistry in\nrelation to nutrients; physiological requirements; composition and interaction of algal and invertebrate populations;\neutrophication; pollution; environmental change.\n',
      NOTE: ['Field trip: estimated cost $35.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Limnology and Aquatic Ecology',
      units: '3.0',
      PREREQUISITE: ['CHEM 112/6.0'],
      'LEARNING HOURS': ['113 (36L;18Lb;8Oc;51P)\n']
    },
    'WRIT 125': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 125',
      description:
        'A study of the basic principles of academic writing, including a series of assignments that emphasize logical organization,\nstylistic clarity, and grammatical precision.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Academic Essay Writing',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['126 (66O;60P)\nEQUIVALENCY    WRIT P75/3.0.']
    },
    'SOCY 275': {
      EXCLUSION: [
        'No more than 6.0 units from SOCY 275/3.0; SOCY 276/3.0; SOCY 274/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 275',
      description:
        'This course focuses on the theoretical foundation examining the process by which activities are defined as deviant: such\nactivities as \u2018sexual deviance\u2019, \u2018mental illness\u2019, and \u2018political deviance\u2019. The major etiological approaches to the study of\ndeviants are also considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theories of Deviance and Social Control',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 401',
      description:
        'Seminar on a selected topic in Canadian history. Topics change from year to year; course is either being offered for the first\ntime or is being taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Canadian History',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'ANAT 409': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ANAT 409',
      description:
        'A focused histological and cell biological study of three selected mammalian tissues, organs and/or systems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Histology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and a GPA of 2.5 and (registration in a LISC Major or Specialization Plan) and [ANAT 309/3.0 or\n(ANAT 215/3.0 and ANAT 216/3.0) or (ANAT 315/3.0 and ANAT 316/3.0)].'
      ],
      'LEARNING HOURS': []
    },
    'POLS 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 335',
      description:
        'Topics in British Politics\nAn examination of key issues in British politics. Topics will vary from year to year; consult the department homepage.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 395': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 395',
      description:
        'A study of relations between social, cultural and artistic developments and their literary expression from the Middle Ages to\nthe French Revolution. Various media will be used to support that analysis: texts, movies, paintings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Textes et contextes de l\u2019ancienne France',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.'
      ],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'HIST 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 303',
      description:
        'An introduction to Caribbean History from the early 15th century to the present. Topics will include early Spanish contact,\nplantation systems, slavery and resistance, U.S. intervention and globalization. Organizing themes include gender, race and\nethnicity, cultural memory systems, identity, rediasporization, popular culture, and postcolonialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History of the Caribbean in a Global Perspective',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'MUSC 328': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 328',
      description:
        'Applied Pedagogy I\nThe practical study of teaching techniques of standard musical repertoire (solo, chamber, orchestral, operatic, etc.) of a\nparticular instrument. The course requires student performances of representative musical works. The instruments studied\nwill rotate from year to year as resources permit.\n',
      NOTE: [
        'Students must have previous experience on the instrument/vocal area listed in the topic ID. Contact the School for\nmore information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above and permission of the School.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 476': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 476',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Postcolonial Literatures I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CHEM 425': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 425',
      description:
        'Four topics covering a range of self-assembled molecular systems will be discussed: monolayers and bilayers, block co-\npolymers, nanoparticles, and liquid crystals. Material properties, synthetic methods and application of these systems in\ncurrent and emerging technologies, including nanotechnologies, will be covered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Self-Assembly and Materials',
      units: '3.0',
      PREREQUISITE: ['CHEM 221/3.0 and CHEM 223/3.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'ENGL 486': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 486',
      description:
        'Studies focused on Modern and Contemporary literature that do not fit within the established Group III rubrics (British,\nCanadian, American, Postcolonial, Indigenous). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group III: Special Topics I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHIL 407': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 407',
      description:
        'An examination of major issues in contemporary social and political philosophy. Possible topics to be studied include\ncommunitarianism, liberalism, multi-culturalism, the nation-state, and utopias.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Social and Political Philosophy III',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 338',
      description:
        'An introduction to European schools of ethnohistory which examine First World minority cultures, groups, and social\nclasses within the Occidental hegemony, by focussing on the intersections of oral history, folklore, anthropology and\nsociology at the convergence of ethnicity, race, nationality, gender, class, sexuality and imperialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'estern World Ethnohistory',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;24O;120P)\n']
    },
    'SOFT 325': {
      EXCLUSION: ['No more than 3.0 units from CISC 325/3.0; SOFT 325/3.0.'],
      RECOMMENDATION: [],
      code: 'SOFT 325',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Human-Computer Interaction',
      units: '3.0',
      PREREQUISITE: ['CISC 124/3.0 and CISC 235/3.0.\n'],
      'LEARNING HOURS': []
    },
    'HIST 356': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 356',
      description:
        'A study of medical theory and practice from Hippocratic-Galenic traditions to the so-called \u2018medicalization\u2019 of the early 19th\ncentury. Topics will focus on the social impact of diseases.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Health and Disease in Western Society',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'CISC 223': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 223',
      description:
        'Introduction to techniques for specifying the behaviour of software, with applications of these techniques to design,\nverification and construction of software. Logic-based techniques such as loop invariants and class invariants. Automata and\ngrammar-based techniques, with applications to scanners, parsers, user-interface dialogs and embedded systems.\nComputability issues in software specifications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Software Specifications',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and C- in CISC 124/3.0 and C- in (CISC 102/3.0 or MATH 110/6.0).\nCOREQUISITE    CISC 204/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 244': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 244',
      description:
        'An economic critique of policies past and present with regard to First Nations, Inuit, and M\u00e9tis peoples living in Canada,\nwith reference to relevant cultural, historic, geographic, and governance contexts. In some years material may be more\ncomparative and international in scope.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economics of Indigenous Communities',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (24L;12G;48O;36P)\n']
    },
    'BIOL 302': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 302',
      description:
        'Introductory ecology dealing with population growth and regulation, species interactions and reproductive and life history\nstrategies. Laboratory work includes field studies as well as individual and group projects.\n',
      NOTE: ['Field trip: estimated cost $85.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Population and Evolutionary Ecology',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 201/3.0 and BIOL 202/3.0 and BIOL 206/3.0.\nCOREQUISITE    BIOL 243/3.0 or PSYC 202/3.0 or STAT 269/3.0.'
      ],
      'LEARNING HOURS': ['118 (36L;27Lb;12O;19Oc;24P)\n']
    },
    'ANAT 100': {
      EXCLUSION: [
        'No more than one course from ANAT 100/3.0; ANAT 101/3.0; IDIS 150/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'ANAT 100',
      description:
        'This web-based anatomy course is designed to introduce students to the basic structure and functional relationship of the\nhuman body. Through a series of 5 study modules, students will learn about the basic language of Gross Anatomy and\nHistology in order to understand the working of various body systems. This course is also suitable for individuals who have a\ngeneral interest in human anatomy.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after ANAT 215/3.0; ANAT 216/3.0; ANAT 312/3.0; ANAT 315/3.0; ANAT\n316/3.0.'
      ],
      title: 'Anatomy of the Human Body',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (48O;72P)\n']
    },
    'LING 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 340',
      description:
        'This course provides a foundation in syntactic analysis and explanation. The course focuses on the relation between\nstructure and meaning, and assumes the framework of Universal Grammar Theory. Topics covered include thematic roles,\ncase, anaphora, NP movement and WH movement.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Syntax',
      units: '3.0',
      PREREQUISITE: [
        'LING 100/6.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 228': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 228',
      description:
        'The religious institutions produced by the Jews from the second to the seventh centuries. This course will explore in critical\nfashion the principal areas of rabbinic activity including: topics on jurisprudence, philosophy, social and political thinking,\nthe role of tradition and scriptures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sages, Scholars and Rabbis',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 191': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 191',
      description:
        'Diatonic voice-leading and harmony, principles of form and small structures (binary, ternary) through part-writing and\nanalysis.\n',
      NOTE: [
        'Students having received 80% or higher on a conservatory advanced rudiments exam may enroll in the course with\npermission of the School.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory and Analysis I',
      units: '6.0',
      PREREQUISITE: [
        '(Registration in a BMUS or BMT Plan) or a grade of A- in MUSC 104/3.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['240 (72L;24T;144P)\n']
    },
    'FILM 104': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 104',
      description:
        'Film Form and Modern Culture to 1970\nIntroduction to tools and methods of visual and aural analysis and to historical and social methods, with examples primarily\nfrom the history of cinema and other moving-image media to 1970.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'PHIL 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 311',
      description:
        'A philosophical understanding of the background to psychology. Topics may include the nature of mental representation,\nthe place of \u2018folk psychology,\u2019 individualism in psychology, the nature of mental causation and explanation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Psychology',
      PREREQUISITE: [
        'PHIL 250/6.0 or 12.0 units in PSYC or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 312',
      description:
        'An introduction to the themes and approaches pursued by Canadian social historians, including histories of race, gender,\nclass, colonialism, and sexuality. While specific course frameworks may vary, this course seminar will emphasize the writing,\nresearch, communication, and analytical skills necessary for more advanced historical study.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'anadian Social History',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'PSYC 203': {
      EXCLUSION: ['No more than 3.0 units from BMED 270/3.0; PSYC 203/3.0.'],
      RECOMMENDATION: [],
      code: 'PSYC 203',
      description:
        'Lectures will focus on basic research methodologies. Labs will include the collection and statistical analysis of data, and the\nreporting of experimental findings. To introduce students to the breadth of psychological research, there will be a series of\nguest lectures in which professors present their own research.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Methods in Psychology',
      units: '3.0',
      PREREQUISITE: [
        'PSYC 202/3.0; BIOL 243/3.0; CHEE 209/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0 (formerly PHED\n251/3.0); NURS 323/3.0; POLS 385/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM 162/3.0 and\n(registration in a PSYC Major or Medial or Specialization Plan).\n'
      ],
      'LEARNING HOURS': []
    },
    'KNPE 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 400',
      description:
        'Through problem-based learning, students will gain an understanding of what it means to be an applied health care\nprofessional. Students will work collaboratively on case studies and develop critical thinking skills to prepare them as they\ntransition to their careers as health care practitioners.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Professional Issues in Allied Health',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a KINE Specialization Plan, PHED Specialization Plan, or HLTH Major Plan.'
      ],
      'LEARNING HOURS': ['120 (24L;12G;84P)\n']
    },
    'RELS 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 227',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Indigenous Traditions in North America',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CHEM 398': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 397/6.0; CHEM 398/3.0; CHEM 399/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 398',
      description:
        'Laboratory course. In consultation with the course co-ordinator, and subject to availability, students may select\nexperiments as are relevant to their degree program including synthesis, analytical instrumentation and computational\nmethods. The integration of several methods will be emphasized in the design and characterisation of molecules.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Experimental Chemistry I',
      units: '3.0',
      PREREQUISITE: [
        '6.0 units at the 200 level in CHEM.\nCOREQUISITE    3.0 units at the 300 level in CHEM or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['156 (72Lb;12T:72P)\n']
    },
    'GRMN 309': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 309',
      description:
        'Survey of German Cultural History II\nIntensive development of language skills (reading, writing, speaking, listening) in the course of a general introduction to the\ncultural history of the German-speaking countries in the twentieth and twenty-first centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12T;84P)\n']
    },
    'ARTH 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 212',
      description:
        'An introduction to the arts of the Middle Ages (c.300-1400) from the origins of Christian art under the Emperor\nConstantine, through the Early Christian, Byzantine, Romanesque and Gothic Periods. The focus will be on major\nmonuments and personalities and will also involve a trip to Toronto to study medieval art in the Royal Ontario Museum.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medieval Art',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 222': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 222',
      description:
        'A survey of women writers from before 1900. The historical and geographical focus of the course may vary from year to\nyear; for details, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Women Writers Pre-1900',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a GNDS Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 211': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; COMM 162/3.0; ECON 250/3.0; GPHY 247/3.0;\nKNPE 251/3.0 (formerly PHED 251/3.0); NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT\n267/3.0; STAT 367/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 211',
      description:
        'Introduces descriptive and inferential statistics and data analysis strategies. Topics include probability,\ncorrelation/regression, experimental design and analysis of variance. Online learning and weekly laboratories provide\npractice in computation, interpretation and communication of statistical findings, and large class review sessions and\nindividual drop in assistance ensure mastery.  Applications appropriate to different fields of study will be explored.\n',
      NOTE: [
        'Students can also fulfill the statistics requirements of a SOCY plan by taking any one of the courses listed as\nexclusions below in place of SOCY 211/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Statistics',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 420',
      description:
        'An examination of both modern and postmodern contemporary art as activism sampled from Western and non-Western\npractices. The chronological period of study is from the end of the 1960s to the present. Theoretical frameworks to be used\ninclude social movement theory, postcolonial theory, and critical museum studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Art and Activism',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 316': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 316',
      description:
        'An introduction to the basic principles of fisheries biology and examination of the biological foundations of current\nproblems affecting the world\u2019s fisheries, with an emphasis on developing sound science-based strategies to resolve these\nproblems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fisheries Biology',
      units: '3.0',
      PREREQUISITE: ['BIOL 103/3.0 and BIOL 202/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 422',
      description:
        'Mathematical methods for describing software behaviour and structure. Topics include (but are not limited to) the following:\nRequirements specification. Module specification: axiomatic, algebraic, and trace specifications. Abstract models. Verification.\nSpecification-based validation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Formal Methods in Software Engineering',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 223/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUTH 332': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 332',
      description:
        'Exploration and discussion of historical and contemporary performances as well as theories of acting, character\ndevelopment, staging and other topics related to Opera performance. Knowledge will be applied and expanded through live\nperformance of scenes from the repertoire. Course may focus on a specific work, composer, or theme.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Opera Performance',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and permission of the School upon successful audition.'
      ],
      'LEARNING HOURS': ['120 (12L;24Lb;84P)\n']
    },
    'CLST 412': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 412',
      description:
        'An intensive two-week introduction to archaeological and architectural recording using photography, surveying, and 3D\nmeasurement on a site of historical importance for the Classical and Byzantine period in the Balkans under the supervision\nof a member of the Classics Department.\n',
      NOTE: ['Offered in Summer Term\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology Fieldwork Practicum IIIa',
      units: '3.0',
      PREREQUISITE: ['Level 2 and permission of the Department.'],
      'LEARNING HOURS': ['128 (12L;44Pc;44G;4I;8Oc;16P)\n']
    },
    'SOCY 384': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 384',
      description:
        'Critical study of historical development of scientific and medical establishments with specific focus upon women; legal,\nethical, and economic issues related to new reproductive technologies examined.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Women and Reproductive Technology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0) or 6.0 units in GNDS.'
      ],
      'LEARNING HOURS': []
    },
    'MICR 270': {
      EXCLUSION: [],
      RECOMMENDATION: ['4U Biology.\n'],
      code: 'MICR 270',
      description:
        "This course focuses on the biology of the immune system in combating infections caused by common pathogens as well as\nmajor global infectious disease threats. The unique features of this course lie in its approach to understanding the body's\ndefense mechanisms in combating microbial, autoimmune, immune mediated diseases, and cancer. By the end of the\ncourse the student will be able to apply the knowledge gained through this course in various areas of life sciences.\n",
      NOTE: [
        'This online course in infection and immunity is designed for students from various biological sciences and allied\nhealth backgrounds at all levels of post-secondary education and is recommended as a foundation course for students\npursuing a life sciences career.\n',
        'May not be taken for credit towards the Plan requirements of the LISC Specialization or Major Plans.\n'
      ],
      'ONE-WAY EXCLUSION': ['May not be taken with or after MICR 360/3.0.'],
      title: 'Infection, Immunity and Inflammation',
      units: '3.0',
      PREREQUISITE: [
        'Level  2 and (BIOL 102/3.0 or MICR 121/3.0 or PHGY 170/3.0)\n'
      ],
      'LEARNING HOURS': ['114 (36O;78P)\n']
    },
    'MUSC 270': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 270',
      description:
        'An introduction to basic principles of conducting, baton and rehearsal techniques.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Conducting Techniques',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 191/6.0 and (MUSC 121/6.0 or MUSC 124/6.0) and (3.0 units from MUSC 181/3.0; MUSC 183/3.0;\nMUSC 185/3.0; MUSC 187/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 224': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 224',
      description:
        'This course aims to introduce students to the socio-cultural and religious realities of French-language communities in\nCanada, from the 19th century to today. Ce cours introduit les \u00e9tudiants aux r\u00e9alit\u00e9s socio-culturelles et religieuses des\ncommunaut\u00e9s de langue fran\u00e7aise au Canada, du 19e si\u00e8cle \u00e0 nos jours.\n',
      NOTE: ['This course can be taken in either French or English.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'eligion in Canadian Francophone Communities',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'KNPE 339': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 339',
      description:
        'This course focuses on aspects of skeletal muscle energy metabolism related to exercise, with a particular emphasis on the\nregulation of carbohydrate and fat metabolism and the mechanisms regulating their use as substrates for muscle during\nrest and exercise.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Exercise Metabolism',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a KINE Specialization Plan or PHED Specialization Plan and KNPE 225/3.0 and KNPE\n227/3.0'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    KNPE 427/3.0.\n']
    },
    'PSYC 231': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 231',
      description:
        'An examination of the major theoretical approaches to the study of personality with attention to the utility of these\ntheories as measured by empirical investigations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Study of Personality',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': []
    },
    'ENGL 471': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 471',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Modern/Contemporary American Literature I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ARTH 117': {
      EXCLUSION: [
        'No more than 9.0 units from ARTH 116/3.0; ARTH 117/3.0; ARTH 120/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'ARTH 117',
      description:
        'A chronological survey of painting, sculpture and architecture in western culture from c.1700 to the present day. The art\nworks will be studied at British galleries, museums and architectural monuments.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Art and Architecture in Britain from c.1700 to the Present',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'KNPE 225': {
      EXCLUSION: [
        'No more than 6.0 units from IDIS 150/6.0; KNPE 125/3.0; KNPE 225/3.0; PHGY 210/6.0; PHGY 214/6.0; PHGY\n212/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 225',
      description:
        'The emphasis will be placed on understanding the concept of homeostasis and the integrated control of cellular and organ\nresponses involved in regulation to maintain homeostasis. Special emphasis will be placed on the systems that respond to\nexercise stress.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Human Physiology',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and registration in a PHED, KINE or HLTH Plan and KNPE 125/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'ANAT 315': {
      EXCLUSION: ['No more than 3.0 units from ANAT 215/3.0; ANAT 315/3.0.'],
      RECOMMENDATION: [],
      code: 'ANAT 315',
      description:
        'The Human Musculoskeletal System\nGross and functional anatomy of the back, body wall, upper and lower limbs, including blood supply and neural controls.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(BIOL 102/3.0 and BIOL 103/3.0) or (BIOL 201/3.0 and BIOL 202/3.0) or PHED 153/3.0 or KNPE 153/3.0 or\npermission of the Department of Biomedical and Molecular Sciences.\n'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 352',
      description:
        'The nature and varieties of metaphysics, including rationalistic \u2018Platonist\u2019 and empirical/descriptive \u2018Aristotelian\u2019\napproaches. Positivistic and pragmatic anti-metaphysical \u2018critiques\u2019 and verificationism. Contemporary analytical\nmetaphysics after Quine and Strawson.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Metaphysics',
      units: '3.0',
      PREREQUISITE: ['PHIL 250/6.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 434': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 434',
      description:
        'A consideration of the history of collecting and public collections; of museum policy and practice; and of Western notions of\nart and culture as they are applied in the museum to non-Western art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Non-Western Art in Western Collections',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 242': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 242',
      description:
        'The physical principles and practices of collecting, analyzing and interpreting various remote sensing data from the visible,\ninfrared, and microwave regions of the electromagnetic spectrum are examined. In addition, the display, enhancement and\ninterpretation of various digital remote sensing data, from airborne to satellite scales, is emphasized. Enrolment is limited.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Remote Sensing I: Remote Sensing of the Environment',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 101/3.0 or GPHY 102/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;60P)\n']
    },
    'PHIL 376': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 376',
      description:
        'An introduction to topics and issues in feminist philosophy. The influence of feminist perspectives on the framing and study\nof philosophical problems, and the contribution of philosophy to the development of feminist theory and practice will be\ncentral concerns. This course can be counted towards a minor, major or medial concentration in Gender Studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy and Feminism',
      units: '3.0',
      PREREQUISITE: [
        '(6.0 units in PHIL or GNDS at the 200-level or above) and (6.0 units in PHIL or GNDS) or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 326': {
      EXCLUSION: ['No more than 3.0 units from CISC 322/3.0 and CISC 326/3.0.'],
      RECOMMENDATION: ['CISC 226/3.0\n'],
      code: 'CISC 326',
      description:
        'An introduction to software architectural design through the application domain of game development. Topics will include\nnotations for expressing static and dynamic aspects of software architecture, design patterns, interface design, and\napplication of these techniques to 3D games, mobile games and web-based games.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Game Architecture',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 220/3.0 and CISC 235/3.0).\n'],
      'LEARNING HOURS': ['120 (36L;24T;60P)\n']
    },
    'MATH 212': {
      EXCLUSION: [
        'No more than 1 course from MATH 110/6.0 and MATH 212/3.0.\nEQUIVALENCY    MATH 312/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 212',
      description:
        'Vector spaces, direct sums, linear transformations, eigenvalues, eigenvectors, inner product spaces, self-adjoint operators,\npositive operators, singular-value decomposition, minimal polynomials, Jordan canonical form, the projection theorem,\napplications to approximation and optimization problems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Linear Algebra II',
      units: '3.0',
      PREREQUISITE: ['MATH 111/6.0 or MATH 112/3.0 or MTHE 217/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'ENGL 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 480',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Indigenous Literatures',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'GPHY 339': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 339',
      description:
        'Current issues in disease ecology and health care delivery systems. Emphasis on patterns of incidence, cultural and\nenvironmental associations, spread and control of infectious diseases, comparisons of health care delivery systems, and\naccessibility to health services.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medical Geography',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (3.0 units from BIOL 243/3.0; CHEE 209/3.0; COMM 162/3.0; ECON 250/3.0; GPHY 240/3.0;\nGPHY 247/3.0; KNPE 251/3.0; NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT\n367/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24I;24O;36P)\n']
    },
    'ANAT 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ANAT 312',
      description:
        'Study of the structure and function of the nervous system by lectures, hands-on laboratories, brain dissection, and\nreadings. Topics include, but are not limited to, sensory and motor systems, brain imaging, and clinical examples.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Functional Neuroanatomy',
      units: '3.0',
      PREREQUISITE: [
        '(ANAT 215/3.0 and ANAT 216/3.0) or (ANAT 315/3.0 and ANAT 316/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 290': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 290',
      description:
        'A survey of Irish history from the early Christian era to the Great Famine. Cultural, religious and constitutional\ndevelopments will be analyzed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'reland to 1848',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GRMN 308': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 308',
      description:
        'Intensive development of language skills (reading, writing, speaking, listening) in the course of a general introduction to the\ncultural history of the German-speaking countries up to and including the nineteenth century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Survey of German Cultural History I',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12T;84P)\n']
    },
    'POLS 397': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 397',
      description:
        'An investigation of selected problems in feminist and gender analysis, examining the different authors and issues. The focus\nof this course will vary from year to year; consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Gender and Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENSC 305': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 305',
      description:
        'This course critically examines the complex interaction of material and social processes that define our relationship with the\nenvironment.  Topics focus on how environmental issues emerge as concerns, are defined by different stakeholders, and\ntheir solutions framed through political, economic, cultural, and techno-scientific discourses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social Environments',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above, or permission of the School.'],
      'LEARNING HOURS': ['96 (24L;12G;60P)\n']
    },
    'ENSC 483': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 483',
      description:
        'This course will provide intensive coverage of a topic that is current and/or of special interest in Environmental Studies. The\ncourse will cover mainly social science-based material, but will be multidisciplinary. Offered periodically by visiting\nprofessors or members of faculty. Topic for each year will be announced in advance of course selection and will be made\navailable on the ENSC webpage. Students are advised to consult with their academic counsellor and/or the course\ninstructor prior to registration.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Environmental Studies II',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and registration in ENSC Major, ENVS Medial, EBIO, ECHM, EGEO, EGPY, ELSC, or ETOX plan, or\npermission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 333',
      description:
        'An historical overview and introduction to the philosophical and pedagogical views of Emile Jaques-Dalcroze, Zoltan Kod\u00e1ly\nand Carl Orff to teaching music.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Dalcroze, Kodaly and Orff',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and MUSC 274/3.0.'],
      'LEARNING HOURS': ['120 (12L;12Pc;12G;24O;60P)\n']
    },
    'BCHM 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 422',
      description:
        'An independent research project by each student in one of the departmental research labs. Evaluation is based on oral\npresentation, lab performance and a thesis.\n',
      NOTE: ['6.0-unit course offered in the Winter Term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Biochemistry Laboratory II',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Specialization Plan) and [a GPA of 2.9 in BCHM 313/3.0, BCHM 315/3.0,\nBCHM 316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['222 (6S;144Lb;24I;6O;42P)\n']
    },
    'HLTH 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 402',
      description:
        'An introduction to the field of disability studies \u2013 definitions, conceptualizing disability, language for talking about disability,\ndisability issues, policy and systems affecting people with disabilities. The course takes a global perspective on disability,\naddressing geo-political and cultural factors, as well as personal and social factors.\n',
      NOTE: [
        'This course falls under a selection of courses with a focus on Interdisciplinary Studies in Global Health and Disability that\nwill be offered only at the Bader International Study Centre.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Disability Studies: Issues, Research and Policy',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and a minimum GPA of 1.9 and HLTH 332/3.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['127 (30L;18G;39Oc;40P)\n']
    },
    'BIOL 501': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 430/3.0.\n'],
      code: 'BIOL 501',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Recent Research in Molecular Biology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ECON 112': {
      EXCLUSION: [
        'No more than 6.0 units from ECON 110/6.0; ECON 111/3.0; ECON 112/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ECON 112',
      description:
        'An introduction to macroeconomic analysis of the economy as a whole, including the determination of national income, the\nprice level, interest rates, the money supply, and the balance of payments. The principles of monetary and fiscal policy are\nalso examined. ECON 111/3.0 and ECON 112/3.0 are together equivalent to ECON 110/6.0.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Macroeconomics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'GRMN 203': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 203',
      description:
        'An intermediate conversation course designed to advance skills in oral communication and cultural competence, supported\nby grammar instruction and written assignments. Students will engage with different media sources, including German-\nlanguage television, film, internet, print media and music.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'German Conversation and Culture',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 102/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12T;84P)\n']
    },
    'DEVS 394': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 394',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies III',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 218': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 218',
      description:
        'This course examines Indigenous novels, traditional stories, poetry, short stories, and plays from various time periods,\nwritten by M\u00e9tis, Inuit, and First Nations authors. We will study the themes, aesthetics, and politics of the texts, using a\ncombination of culturally specific and pan-Indigenous approaches.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Indigenous Literatures in Canada',
      units: '3.0',
      PREREQUISITE: ['ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GRMN 202': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 202',
      description:
        'A systematic review of grammatical structures with the aim of enhancing students\u2019 linguistic competence with particular\nemphasis on written communication.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate German II',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 201/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'PSYC 443': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 443',
      description:
        'Classic and contemporary research pertaining to adult romantic relationships. Topics include attachment styles, relationship\ndevelopment, communication, and conflict in relationships.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intimate Relationships',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 241/3.0.'],
      'LEARNING HOURS': ['126 (18L;18S;90P)\n']
    },
    'HIST 252': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 252',
      description:
        'frica in the Modern World\nAn examination of Africa\u2019s involvement in modern world history. Course covers material from the slave trade to the\ncrumbling of European empires. Major topics include: Pre-colonial African states, slavery, imperialism, the colonial state,\nAfrican protest and resistance, and women\u2019s issues, among other topics.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 321',
      description:
        'A study of Renaissance poetry and prose but excluding drama, with emphasis on the works of Sidney, Spenser,\nShakespeare, Donne, and Milton. Such writers as More, Marlowe, Nashe, Jonson, and Bacon may be included.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Renaissance Poetry and Prose',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'PSYC 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 480',
      description:
        'Seminar courses on advanced topics in psychology offered periodically by visiting professors.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Psychology I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (6L;30S;84P)']
    },
    'POLS 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 432',
      description:
        'An exploration of the emergence and functioning of the modern welfare state in comparative perspective.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Modern Welfare State',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PHYS P20': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS P20',
      description:
        'For those interested in the impact of science on our century. Modern physics, especially nuclear physics, will be introduced\nby emphasizing the personalities, thoughts and writings of key scientists such as Bohr, Einstein and Rutherford and the\nways in which they related to and shaped their political, scientific and social environments. Enrolment is limited.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.'],
      'ONE-WAY EXCLUSION': [],
      title: 'Physicists in the Nuclear Age',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CISC 486': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 486',
      description:
        "An introduction to 'engines' used in networked 3-dimensional games. Topics include game-engine architecture and\ncomponents providing 3-dimensional rendering, physics simulation, sound, artificial intelligence and networking services.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Game Engine Development',
      units: '3.0',
      PREREQUISITE: [
        'C- in [CISC 226/3.0 and CISC 326/3.0 and CISC 324/3.0 and (MATH 110/6.0 or MATH 111/6.0 or MATH\n112/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;15G;69P)\n']
    },
    'POLS 358': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 358',
      description:
        'Selected topics in the critique of capitalism, e.g. Marxism, democracy, the environment, globalization, employment and\npopular culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Perspectives on Contemporary Capitalism',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC P81': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC P81',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CISC 462': {
      EXCLUSION: [],
      RECOMMENDATION: ['CISC 365/3.0.\n'],
      code: 'CISC 462',
      description:
        'Turing machines and other models of computability such as \u00b5-recursive functions and random-access machines.\nUndecidability. Recursive and recursively enumerable sets. Church-Turing thesis. Resource-bounded complexity. Complexity\ncomparisons among computational models. Reductions. Complete problems for complexity classes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computability and Complexity',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 223/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 312',
      description:
        'This course provides an introduction to the principal theoretical perspectives and empirical debates in the study of\nelections, voting, public opinion, political participation and political culture in established democracies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Behaviour',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 333',
      description:
        'An examination of southern African social history up to the onset of colonial rule. Topics include the \u2018bushmen\u2019, early state\nformation, gender relations, spirituality, early Portuguese feudalism, and the Dutch at the Cape. Fall Term.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'outhern Africa to c.1890',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MATH 326': {
      EXCLUSION: [
        'No more than 1 course from MATH 228/3.0; MATH 326/3.0; PHYS 317/3.0; PHYS 312/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 326',
      description:
        'Complex numbers, analytic functions, harmonic functions, Cauchy\u2019s Theorem, Taylor and Laurent series, calculus of\nresidues, Rouche\u2019s Theorem.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Functions of a Complex Variable',
      units: '3.0',
      PREREQUISITE: ['MATH 281/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'ENGL 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 340',
      description:
        'Romantic Literature\nAn intensive study of the Romantics with emphasis on the works of Blake, Wordsworth, Coleridge, Byron, Shelley, and\nKeats.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'CLST 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 420',
      description:
        'Intensive study of a special topic, period, or author(s) in the world of Rome. For information contact the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Latin/Roman Scholarship I',
      units: '3.0',
      PREREQUISITE: ['Level 4 in a CLST or CLAS or GREK or LATN Plan.'],
      'LEARNING HOURS': ['120 (24L;12S;84P)\n']
    },
    'PHYS 483': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 483',
      description:
        'An examination of the key ideas, techniques and technologies in the fields of nanoscience and nanotechnology. Emphasis\nwill be placed on the physics involved, measurement techniques, and technological applications. Topics covered are selected\nfrom the following: electrical and optical properties of quantum dots, quantum wires and nanotubes; quantum information\ntechnology; mesoscopic electronics; nanostructures on surfaces; and scanning probe and optical microscopy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Nanoscience and Nanotechnology',
      units: '3.0',
      PREREQUISITE: [
        '(PHYS 345/3.0 or CHEM 313/3.0) and (PHYS 480/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 592': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 592',
      description:
        'A critical essay of at least 7500 words on a topic of the student\u2019s choice in the field of musicology, ethnomusicology, or music\ntheory and analysis, written under the supervision of a faculty member.\n',
      NOTE: [
        'Students should consult the Chair of Undergraduate Studies for Music in the spring of their third year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and registration in a MUSC Major Plan.\nCOREQUISITE    MUTH 380/3.0 or MUSC 385/3.0 or MUSC 386/3.0.'
      ],
      'LEARNING HOURS': ['218 (36I;182P)\n']
    },
    'JWST 302': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'JWST 302',
      description:
        'A topic of current interest in Jewish Studies not covered in other available courses. Seminars offered by regular and visiting\nfaculty on topics related to their own research or interest. Consult the Jewish Studies website.',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Jewish Studies II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CRSS 498': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CRSS 498',
      description:
        'An advanced course in which students attend cardiology and respirology rounds in the Department of Medicine and\nprepare written and oral reports based on the material presented. The course will provide students with an in-depth\nexposure to topics in clinical cardiorespiratory science. The course will be offered in alternate years.\n',
      NOTE: ['Priority given to students in the CRSS Sub-Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Cardiorespiratory Rounds',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a LISC Major or Specialization Plan and a GPA of 2.5 and (PHGY 210/6.0 or PHGY\n214/6.0 or PHGY 212/6.0).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 429': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 429',
      description:
        'Primary emphasis is placed on social and intellectual developments in the 19th century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'merican Thought and Culture',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'KNPE 255': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 255',
      description:
        'An introduction to the interrelationships between physical activity, fitness and health. Current techniques for the\nmeasurement of health related fitness components, evaluation of diet, weight loss principles, psychological aspects of\nfitness and suitable activities for fitness development. Concepts related to prescription of physical activity and exercise\ncounselling are introduced.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Physical Activity, Fitness and Health',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above in a PHED or KINE Plan and KNPE 125/3.0.\nCOREQUISITE    KNPE 225/3.0 and KNPE 227/3.0.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'KNPE 465': {
      EXCLUSION: [],
      RECOMMENDATION: ['KNPE 237/3.0\n'],
      code: 'KNPE 465',
      description:
        'An exploration of the theoretical and empirical work in the development of sport participation and performance. Specific\ndiscussion of the developmental aspects and learning conditions that allow individuals to maintain participation and reach\nhigh levels of excellence in sport will be included.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sport Participation and Performance',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan and a grade of B in KNPE 265/3.0.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MICR 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 451',
      description:
        'The nature of selected animal virus groups and their interactions with the host in disease production. Special emphasis on\nthe pathogenesis of tumour and human immunodeficiency viruses.\n',
      NOTE: ['Offered in alternate years to MICR 450/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Viral Pathogenesis',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'MUSC 381': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 381',
      description:
        'An intensive survey of a topic within historical musicology, ethnomusicology, or popular music(s).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Music History and Culture II',
      units: '3.0',
      PREREQUISITE: [
        '(MUSC 191/6.0 and MUSC 103/3.0 and [MUSC 203/3.0 or MUSC 204/3.0 or MUSC 205/3.0]) or permission\nof the School.'
      ],
      'LEARNING HOURS': ['112 (36L;24O;52P)\n']
    },
    'KNPE 459': {
      EXCLUSION: [],
      RECOMMENDATION: ['KNPE 255/3.0.\n'],
      code: 'KNPE 459',
      description:
        'An in-depth coverage of principles of health screening, exercise testing and exercise prescription for individuals with\ncardiovascular, metabolic and pulmonary diseases. An emphasis is placed on understanding disease pathophysiology and\nhow this interacts with the acute response to exercise and the adaptation to training.\n',
      NOTE: [
        'This course will normally be offered in academic years starting with an even number (e.g., 2012-2013). Students in a\nKINE Specialization Plan will have priority over students in a PHED Specialization Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Clinical Exercise Physiology',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED Specialization or KINE Specialization Plan and KNPE 125/3.0 and KNPE 225/3.0\nand KNPE 227/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 441': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 441',
      description:
        'This course provides an overview of classic and contemporary theories of attitudes and persuasion. Topics include the\nstructure of attitudes, the role of attitudes in information processing, the impact of attitudes on behaviour, and the\npsychological processes underlying attitude change. A particular emphasis is placed on reviewing and evaluating theories of\npersuasion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Attitudes and Persuasion',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 241/3.0.'],
      'LEARNING HOURS': ['120 (24L;12S;84P)\n']
    },
    'CISC 226': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 226',
      description:
        'An introduction to techniques for designing elementary computer games. Topics will include game development tools and\nprocesses, principles of game design, game prototyping and game evaluation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Game Design',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 124/3.0.'],
      'LEARNING HOURS': ['120 (36L;60G;24P)\n']
    },
    'PHYS 480': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 480',
      description:
        'A fundamental treatment of the properties of solids. Topics include: crystal structure, X ray and neutron scattering, the\nreciprocal lattice, phonons, electronic energy bands, and the thermal, magnetic, optical and transport properties of solids.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Solid State Physics',
      units: '3.0',
      PREREQUISITE: ['PHYS 345/3.0 or CHEM 313/3.0.'],
      'LEARNING HOURS': []
    },
    'PHIL 233': {
      EXCLUSION: ['No more than 1 course from PHIL 232/6.0; PHIL 233/3.0.'],
      RECOMMENDATION: [],
      code: 'PHIL 233',
      description:
        'This course will survey central works of Ancient Greek Philosophy from Thales and the other Pre-Socratics through the\nseminal works of Plato and Aristotle, and may include examples of later works by Post-Hellenic Philosophers including\nPlotinus, the Stoics, and the Skeptics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Greek Philosophy',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 365',
      description:
        'Geochemical Characterization of Earth Processes\nThe application of thermodynamics and kinetics to the understanding of natural processes in the Earth Sciences.\nDistribution of  the elements, and practical uses of isotopes and elemental tracers. Geochemical actions and transactions\nwithin, and among, the lithosphere, hydrosphere, atmosphere and biosphere, including the impact of human evolution and\nenvironmental geochemistry. Practical application of geochemistry to solving problems in natural systems will be\nemphasized. A practical involving problems, laboratory experience and field experience will be part of the course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'CHEM 112/6.0 and GEOL 232/3.0 and GEOL 235/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 497',
      description:
        'A wide range of topics of current importance in computing, including technical issues, professional questions, and moral\nand ethical decisions. Students make presentations, deliver papers, and engage in discussion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social, Ethical and Legal Issues in Computing',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a COMP Major or BMCO or COCA or COGS or COMA or CSCI or SODE\nSpecialization Plan and a GPA of 1.90 and a GPA of 2.60 in 30.0 units of CISC and C- in (CISC 365/3.0 or COGS 300/3.0).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'GPHY 314': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 314',
      description:
        'The study of historical and current climate change, projected future climates emphasizing the effects of global warming,\nimpacts of climate change, and the role of humans as agents of climatic system change.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Climate Change',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'PSYC 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 333',
      description:
        'An overview of typical sexual behaviour and its variations. Topics include the history of sex research, the sexual response\ncycle, sexual dysfunction, gender identity, and sexual orientation. Particular attention will be paid to current issues in sex\nresearch and theory.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Human Sexuality',
      units: '3.0',
      PREREQUISITE: [
        'PSYC 235/6.0 or PSYC 236/3.0 or PSYC 251/3.0 or PSYC 271/3.0 or PSYC 370/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 241': {
      EXCLUSION: ['No more than one course from FREN 241/3.0; FREN 212/6.0.'],
      RECOMMENDATION: [],
      code: 'FREN 241',
      description:
        'An introduction to French literature from the Middle Ages to the end of the Eighteenth Century stressing how tensions\ngenerated between different ideas within a period determine the aesthetic, philosophical, and literary choices made by\nmajor authors.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Histoire culturelle et litt\u00e9raire de l\u2019Ancien R\u00e9gime',
      units: '3.0',
      PREREQUISITE: [
        'FREN 150/6.0 or FREN 100/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 110/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUTH 231': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 231',
      description:
        'An examination of the major trends in musical theatre production and theory since the 19th century, exploring the work of\nimportant composers and lyricists and the structure of musical theatre works.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Musical Theatre',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 and registration in a DRAM; MUSC; or B.M.T. Plan or permission of the School.\nEQUIVALENCY    DRAM 216/3.0.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'SPAN 458': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 458',
      description:
        'Explores representative works of the Latin American film industry, with a brief introduction to film analysis. Films will be\nexamined in the context of cultural and historical issues, and their possible relation to literature. The course content may\nfocus on one specific national cinema in a given year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cine latinoamericano',
      PREREQUISITE: [
        'SPAN 351/3.0 or SPAN 352/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'MUTH 232': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 232',
      description:
        'An introduction to opera through the study of selected works from the Baroque era to the 20th century. Equal attention will\nbe paid to literary, musical, and visual aspects.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Opera',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    MUSC 287/3.0.']
    },
    'EMPR 220': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 220',
      description:
        'This course overviews the nature of conflict in the workplace. Specifically, it examines the complex role that conflict\nresolution plays at all levels of the Canadian workplace and in the determination of terms and conditions of employment,\nincluding collective bargaining.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Conflict Resolution',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (48O;72P)\n']
    },
    'LING 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 330',
      description:
        'This course provides a foundation in principles of morphological analysis. Topics covered include inflectional and\nderivational morphology as well as the morphology-syntax and morphology-phonology interfaces. Emphasis is placed on\npractical discovery method, and formal analysis and explanation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Morphology',
      units: '3.0',
      PREREQUISITE: [
        'LING 100/6.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 536': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 536',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Biology V',
      units: '3.0',
      PREREQUISITE: ['To be announced.\n'],
      'LEARNING HOURS': []
    },
    'BIOL 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 404',
      description:
        'Intensive laboratory work (8h/day) to be carried out over two and a half weeks in May. Practical work includes DNA\nisolations, DNA cloning, PCR, production of proteins, biochemical and immunological analysis of proteins.\n',
      NOTE: [
        'Priority to students registered in BIOL Major and Specialization degree Plans. See course website for details.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Techniques in Molecular Biology',
      units: '3.0',
      PREREQUISITE: [
        '(BCHM 218/3.0 or BIOL 330/3.0 or MBIO 218/3.0) and a minimum GPA of 2.0 in the Biological Foundations\nList.'
      ],
      'LEARNING HOURS': ['112.5 (100Lb;12.5P)\n']
    },
    'HIST 214': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 214',
      description:
        'ood in Global History\nThis online course will attempt to study aspects of global history using food as a central theme. We begin from the\nreflection that food has successfully transcended political and cultural boundaries in the global past, and it provides a\npromising path for interrogating socio-economic and cultural issues in transnational contexts.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (54O;72P)\n']
    },
    'GNDS 370': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 370',
      description:
        'Using feminist, trans and queer theory, critical race, disability studies, literary and cultural criticism, this course explores\nwomen\u2019s writing in a wide range of genres, with emphases on memory and self-narration and the ways in which subjects\nlocated or rejected as \u2018women\u2019 contend with binary, racialized and classed frames of gender.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing Lives: Feminism and Women\u2019s Writing',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 433': {
      EXCLUSION: [
        'No more than 3.0 units from HLTH 497/3.0 (2015-16) and KNPE 433/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 433',
      description:
        'The UN recognizes the important role of sport participation in promoting physical and mental health as well as fundamental\nhuman rights. This course will critique the use of sport and recreation on a global level as a tool for improving the lives of\npeople with disabilities with the goal of removing barriers and enabling participation for all.\n',
      NOTE: ['Only offered at the Bader International Study Centre.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Global Sport and Disability',
      units: '3.0',
      PREREQUISITE: [
        '(Level 3 or above in a PHED Specialization or KINE Specialization or HLTH Major or Medial Plan and HLTH\n332/3.0) or registration at the Bader International Study Centre.\n'
      ],
      'LEARNING HOURS': ['125 (27L;8S;4Pc;8G;16Oc;62P)\n']
    },
    'POLS 394': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 394',
      description:
        'Issues in Political Theory\nAn exploration of different aspects of political thought, political theory, and political philosophy. The focus of this course\nwill vary from year to year; consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 338': {
      EXCLUSION: [
        'No more than 1 course from MATH 338/3.0; PHYS 316/3.0; PHYS 312/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'MATH 338',
      description:
        'Methods and theory for ordinary and partial differential equations; separation of variables in rectangular and cylindrical\ncoordinate systems; sinusoidal and Bessel orthogonal functions; the wave, diffusion, and Laplace\u2019s equation; Sturm-Liouville\ntheory; Fourier transform.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fourier Methods for Boundary Value Problems',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 221/3.0 or MATH 280/3.0) and (MATH 231/3.0 or MATH 232/3.0) and (MATH 110/6.0 or MATH\n111/6.0).\n'
      ],
      'LEARNING HOURS': ['118 (36L;12T;70P)\n']
    },
    'BIOL 515': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 515',
      description: 'Aquaculture\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 310',
      description:
        'A survey of vernacular literature composed in the British Isles before 1500. Readings may be taken from Welsh, Irish, Old\nEnglish, Norman and Middle English literature and may include such works as The Mabinogion, the Lais of Marie de France,\nBeowulf, Sir Gawain and the Green Knight, and selections from Chaucer.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medieval Literature of the British Isles',
      units: '6.0',
      PREREQUISITE: [
        '[(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units)] or [(a GPA of 2.6) and (registration\nin a MDVL Plan)].'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'ARTH 438': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 438',
      description:
        'This seminar offers an in-depth study of a topic in North American Indigenous arts and visual culture, including theoretical\nand methodological readings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Indigenous Arts and Visual Culture in North America',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['126 (36S;90P)\n']
    },
    'CISC 203': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 203',
      description:
        'Discrete Mathematics for Computing II\nProof methods. Combinatorics: permutations and combinations, discrete probability, recurrence relations. Graphs and\ntrees. Boolean and abstract algebra.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'C- in [CISC 121/3.0 and (CISC 102/3.0 or MATH 110/6.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 232': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 232',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Genre II',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PACT 403': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT 403',
      description:
        'A coaching internship designed to provide an opportunity to apply theoretical and technical knowledge in a coaching\nenvironment. Coaching opportunities vary year to year, subject to availability of an appropriate placement. This course is\ndesigned as an independent project. Students must arrange for a coaching supervisor approved by SKHS.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intensive Coaching',
      units: '3.0',
      PREREQUISITE: [
        'PACT 100/3.0 and KNPE 203/3.0 and permission of the supervisor and Undergraduate Coordinator in the\nSchool of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['120 (12I;48Oc;60P)\n']
    },
    'HIST 502': {
      EXCLUSION: [
        'No more than 1 course from HIST 212/3.0, HIST 501/6.0, HIST 502/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 502',
      description:
        'Offers credit for archival work undertaken in conjunction with Queen\u2019s University Archives. One month before the\nbeginning of the term during which the work will be undertaken, students must submit an application to the Chair of\nUndergraduate Studies requesting credit hours commensurate with the project\u2019s learning hours.\n',
      NOTE: [
        "This course may be taken only once during a student's degree program.\n"
      ],
      'ONE-WAY EXCLUSION': [],
      title: "History/Queen's Archives Internship",
      units: '3.0',
      PREREQUISITE: ['Level 2 or above and permission of the Department.\n'],
      'LEARNING HOURS': ['120 (108Pc;12P)\n']
    },
    'HIST 407': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 407',
      description:
        'History of Islamic modernities and Muslim lives in South Asia from the sixteenth century to the present. Themes include\nearly modern Islamic culture; the social history of the Mughal world; local Islamic healing cultures and legal traditions; the\nlanguages of secularism and political Islam in India, Pakistan and Bangladesh.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Muslims and Islam in South Asia',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': [' 180 (36S;24Pc;120P)\n']
    },
    'POLS 318': {
      EXCLUSION: [
        'No more than 6.0 units from GNDS 421/6.0; POLS 318/3.0; POLS 382/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'POLS 318',
      description:
        'The Canadian Welfare State\nAn examination of the character and functions of the Canadian welfare state. Theoretical explanations of the welfare state.\nThe historical development of the Canadian welfare state. Proposals for social policy reform and their implications. Offered\nin alternate years.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 323',
      description:
        'The laboratory in attention course provides students with both demonstrations and hands-on experience with the\nmethodological design and data analysis techniques used in conducting classic studies of attention. Experimental\ntechniques include attentional cueing, visual search, change blindness, inattentional blindness, eye-tracking, multi-object\ntracking, and functional imaging.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Laboratory in Attention',
      units: '3.0',
      PREREQUISITE: [
        '(PSYC 203/3.0 and [PSYC 221/3.0 or PSYC 220/6.0]) or COGS 200/6.0.'
      ],
      'LEARNING HOURS': []
    },
    'CLST 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 205',
      description:
        'The techniques by which humour was created in literature and the visual arts in antiquity; social and psychological aspects\nof humour.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Ancient Humour',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['104 (2L;18G;24O;60P)\n']
    },
    'PHIL 511': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 511',
      description:
        'This course involves a directed study of a philosophical topic. Topics chosen may be from any area of philosophy, and\nshould be determined in consultation with a proposed supervising instructor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a PHIL Major or Medial Plan and (a minimum GPA of 2.60 in PHIL 250/6.0 and\nPHIL 257/6.0) and permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'CLST 208': {
      EXCLUSION: ['No more than 3.0 units from CLST 207/3.0; CLST 208/3.0.'],
      RECOMMENDATION: [],
      code: 'CLST 208',
      description:
        'Social, cultural, and political history of the eastern mediterranean littoral from the 15th to the 1st centuries BCE; particular\nemphasis on the problems of the early Jewish state.\n',
      NOTE: [
        'Offered also as a Cognate course in the Program in Jewish Studies.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Levant from the Late Bronze Age to the Coming of Rome',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'HIST 245': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 245',
      description:
        'A survey of Russian history from the reign of Peter the Great to the Russian Revolution of 1917.  Developments in cultural\nand intellectual history will be highlighted.  Particular emphasis will be placed on debates over Russia\u2019s relationship with the\nWest and Westernization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'mperial Russia',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 220': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 220',
      description:
        'Basic concepts of Unix-like systems. Shells and scripting. System-level programming in the C language. Software\ndevelopment tools and techniques.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'System-Level Programming',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LIBS 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LIBS 300',
      description:
        'A summative capstone course for the minor in Liberal Studies that will bring the humanities, social sciences, and natural\nsciences to bear on the study and interpretation of a contemporary global issue.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'The Liberal Arts in the Contemporary World',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 and registration in a LIBS Plan and LIBS 100/3.0.'
      ],
      'LEARNING HOURS': ['240 (96O;144P)\n']
    },
    'SOFT 423': {
      EXCLUSION: ['No more than 3.0 units from CISC 423/3.0; SOFT 423/3.0.'],
      RECOMMENDATION: [],
      code: 'SOFT 423',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Software Requirements',
      units: '3.0',
      PREREQUISITE: [
        'CISC 322/3.0 or CISC 326/3.0.\nCOREQUISITE      CISC 325/3.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'HIST 291': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 291',
      description:
        'A survey of Irish history from the Great Famine onwards. Economic and cultural issues will be considered along with\nfundamental economic problems. Both the nationalist and the unionist traditions will be analyzed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'reland from 1848 to the Present',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GNDS 326': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 326',
      description:
        'This course explores transnational realities and diasporic experience, with particular attention to gender and sexuality,\nthrough the arts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Diaspora and the Arts',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 305': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 226/3.0 and ARTH 228/3.0.\n'],
      code: 'ARTH 305',
      description:
        'An examination of one aspect of modern and/or contemporary art history. Possible areas of investigation include the study\nof an issue important to the art of the modern and/or contemporary period, as well as the study of the methods and\nhistoriographic positionings of art historians working today.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Modern and Contemporary Art History',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'MUSC 292': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 291/6.0; MUSC 292/3.0; MUSC 293/3.0\nEQUIVALENCY    MUSC 291/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 292',
      description:
        'Tonal and chromatic voice-leading and harmony, phrase structure, bipartite, tripartite, and composite formal structures,\nthrough part-writing and analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory and Analysis IIA',
      units: '3.0',
      PREREQUISITE: [
        'A minimum grade of C- in MUSC 191/6.0 or permission of the School.\n'
      ],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'PHIL 276': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 276',
      description:
        'An introduction to philosophical issues regarding sexism, racism, ageism, homophobia, classism, imperialism and other\nforms of oppression.\n',
      NOTE: [
        'The course is intended to prepare students for upper level courses in feminist philosophy and the philosophy of\nculture.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Perspectives on Social Diversity',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 354': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 253/3.0.\n'],
      code: 'ARTH 354',
      description:
        'A detailed study of painting and related arts in the Netherlands, ca.1580-1700. Developments in style and the growth of\nsubject types such as genre, portraiture, landscape, and still life are examined in the cultural context of life in the Dutch\nRepublic, with particular attention to the achievements of artists such as Rembrandt, Hals, and Vermeer.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Age of Rembrandt',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 235',
      description:
        'The experimental approach to the understanding, description and modification of abnormal behaviour is emphasized in the\nanalysis of disorders of cognition (e.g., learning, memory and thinking), disturbances of affect (e.g., anxiety and depression),\nand problem behaviours (e.g., addictions, sexual disorders and psychopathy).\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Abnormal Psychology',
      units: '6.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': ['240 (72L;24O;144P)\nEQUIVALENCY    PSYC 236/3.0.\n']
    },
    'POLS 483': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 483',
      description:
        'Justice and Gender\nAn examination of how contemporary theories of justice fare from the standpoint of gender (specifically inequalities in\ngender relations) and what a just, non-gendered society might look like.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 396': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 396',
      description:
        'Issues in global politics, international relations, international diplomacy, or foreign policy will be examined in this course.\nThe focus of this course will vary from year to year; consult the departmental homepage for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in International Relations',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 283': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 283',
      description:
        'Contemporary Canadian Literature\nA study of particular issues and themes in Canadian literature from the 1970s to the present (e.g., postmodernism,\nmulticulturalism, gender and sexual diversity, class relations, migration).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'ENGL 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 442',
      description:
        'Topics in Romanticism II\nFor detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ECON 371': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 371',
      description:
        'Examines regulated industries such as electrical utilities, communication, transportation and agriculture. Addresses\ntraditional questions relating to pricing rules and some recent work in political economy that attempts to explain why\nsociety has adopted the particular form of intervention that has occurred.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economics of Regulation',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'SOCY 520': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 520',
      description:
        'An intensive study of a particular topic or question, usually consisting of a number of sections or chapters which form a\nsingle coherent work. The topic is chosen by the student in consultation with an academic adviser, and the work covers\nboth terms.\n',
      NOTE: [
        'A brief giving details of the requirements is available in the Department; students should read this before the end of\ntheir third year. A meeting between staff and students is normally held in the Fall Term to discuss questions about the\nthesis.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Thesis',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 510': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 510',
      description:
        'Students will arrange their reading in consultation with members of the Department. They will be expected to write reports\non their readings and to discuss them throughout the term in seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': ['126 (36S;90P)\n']
    },
    'A contemporary and comprehensive assessment of the neurochemical anatomy and neuropharmacology of the mammalian': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code:
        'A contemporary and comprehensive assessment of the neurochemical anatomy and neuropharmacology of the mammalian',
      description:
        'and human nervous systems as they relate to development, function and disease. Topics will include dynamics of\nneurotransmitter interactions, neuronal drug receptor interactions and second messengers, neurotoxicity associated\ntransmitters and neural growth factors.\n',
      NOTE: [
        'BMCO students should contact the Department regarding prerequisites.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Progress in Neuroanatomy and Neuropharmacology',
      PREREQUISITE: [
        'A GPA of 2.5 and (a grade of B- in ANAT 312/3.0 or NSCI 323/3.0 or PHAR 340/3.0).\nCOREQUISITE    NSCI 324/3.0.'
      ],
      'LEARNING HOURS': ['130 (24L;10T;96P)\n']
    },
    'ENGL 492': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 492',
      description:
        'Studies in literary topics that cross over the historical boundaries between Groups I, II, and III. For detailed information,\nconsult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Interpretation II',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PHIL 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 452',
      description:
        'An examination of major issues in contemporary metaphysics. Possible topics include causation, properties, time, modal\ntheory, and induction.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Metaphysics I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 240': {
      EXCLUSION: [
        'No more than 3.0 units from BMED 270/3.0; GPHY 240/3.0; SOCY 210/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 240',
      description:
        'An introduction to basic issues in research with human participants, and the qualitative methods commonly employed in\nsuch research in geography. Where relevant, students may be introduced to computer software used in qualitative\nresearch.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Qualitative Methods in Geography',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 101/3.0 or GPHY 102/3.0, or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['120 (36L;18Lb;66P)\n']
    },
    'COGS 400': {
      EXCLUSION: [
        'No more than 1 course from COGS 400/3.0; CISC 452/3.0; CMPE 452/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'COGS 400',
      description:
        'Artificial Neural Networks (ANN) and Genetic Algorithms (GA) for problem solving and prediction tasks such as\nclassification, clustering, optimization and data reduction and modeling human cognition, with application to real world\nproblems. Ongoing research in this area in various application domains.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Neural and Genetic Cognitive Models',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 235/3.0 or ELEC 278/4.0).\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 283': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 283',
      description:
        'Discusses Asia, Africa and Latin America since 1945 with emphasis both on particular states (Argentina, South Africa, China\nfor example), and on institutions such as the World Bank, the International Monetary Fund and the World Trade\nOrganization. It also raises the question as to whether the role of the United States in the \u2018Third World\u2019 should be\nconsidered imperial or merely hegemonic.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Making of the Third World II',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\nEQUIVALENCY    HIST 232/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 205': {
      EXCLUSION: [
        'May not be taken with or after PSYC 355/3.0 (taken in 2015W or earlier).'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 205',
      description:
        'An overview of the evolution and function of cognitive processes. Emphasis will be placed on understanding how natural\nselection shaped cognition across animal species. Topics such as memory, decision making, cooperation, and\ncommunication will be examined from a behavioural ecology and experimental psychology perspective.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Comparative Cognition',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.\n'],
      'LEARNING HOURS': ['118.5 (18L;16.5G;36O;48P)\n']
    },
    'SPAN 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 310',
      description:
        'The Spanish Civil War (1936-39) culminated in the military overthrow of the Republican government and the beginning of\nFrancisco Franco\u2019s long dictatorship. This course examines artistic representations of the war in film (both documentary and\nfictional) and in other visual media (paintings, photography, posters), as well as in the written works of both Spanish and\nforeign authors such as Orwell, Hemingway, Neruda, Sender and Rodoreda.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Artistic Representations of the Spanish Civil War',
      units: '3.0',
      PREREQUISITE: ['SPAN 381/3.0.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'SOCY 362': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 362',
      description:
        'Cultural Studies\nThis course focuses on contemporary sociological perspectives of culture. It includes a survey of various theoretical\npositions vis \u00e0 vis culture and society such as the high and low culture distinction, the rise of mass culture; cultural\nhegemony; populism and social resistance. Canadian culture is the predominant object of analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 365': {
      EXCLUSION: ['No more than one course from FILM 353/3.0; FILM 365/6.0.'],
      RECOMMENDATION: [],
      code: 'FILM 365',
      description:
        'A course which combines study of the history and theory of narrative film and television with the production of narrative\nvideos. Requirements will include a research essay, classroom presentations, and the conceptualization and production of a\nnarrative video.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Narrative Theory and Practice',
      units: '6.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and FILM 250/6.0 and 6.0 units in\nFILM.\n'
      ],
      'LEARNING HOURS': ['240 (36L;36S;48Lb;48G;72P)\n']
    },
    'SOCY 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 235',
      description:
        'Concept and meaning of race, racism, and racialization; ethnicity; processes, policies, and practices of differentiation; the\nimpact of racism and discrimination on various populations; intersections of race, ethnicity, class and gender.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Race and Racialization',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': ['115.5 (27L;4.5T;84P)\n']
    },
    'BIOL 508': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 508',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biology of the Cell Cycle',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List and (BIOL 330/3.0 or BCHM 218/3.0\nor MBIO 218/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CISC 454': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 454',
      description:
        'Introduction to computer graphics, including a review of current hardware; modelling and transformations in two and three\ndimensions; visual realism: perspective, hidden surface elimination, and shading; colour models; applications in several\nfields.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computer Graphics',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or 4 and C- in [CISC 235/3.0 and (MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 333',
      description:
        'Supervised and unsupervised learning, neural networks, support-vector machines, decision trees, metriC based clustering,\ndistribution-based clustering, rule-based techniques, genetic algorithms. Applications to information retrieval, web mining,\ncustomer-relationship management, recommender systems, science and engineering.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Data Mining',
      units: '3.0',
      PREREQUISITE: [
        'C- in [(CISC 121/3.0 and CISC 203/3.0) and (3.0 units from STAT) and (3.0 units from MATH 111/6.0; MATH\n110/6.0; MATH 112/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 256': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 256',
      description:
        'A history of North American environmental issues, politics, and movements. The course explores the historical relationship\nbetween nature and culture, from the natural world of pre-contact native societies to the contemporary environmental\ncrisis. Topics include the fur trade, 19th-century pollution, national parks, nuclear power, and deep ecology.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'he Making of the North American Environment',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'GEOL 464': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 464',
      description:
        'An introduction to 3D visualization of natural sciences data with a focus on methods relevant to geological engineering,\nmineral exploration, and geoscience research. Perception, representation, and analytical methods. Design tools and data\nintegration methods. Temporal analysis of natural sciences data. LiDAR data analysis. Global and local models.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Visualization in the Geosciences',
      units: '1.5',
      PREREQUISITE: ['GEOL 463/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['58 (18L;18Lb;22Pc)\n']
    },
    'HIST 462': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 462',
      description:
        'odernization & Cultural Change in Latin America, 19th & 20th Centuries\nExamines the social and cultural transformation of Latin America from 1850 to 1950. Themes include nation-building,\nurbanization, emergence of new social classes, changing role of women, debates about immigration, crime, public health,\nand the \u2018social question\u2019, and the persistence of fundamental problems of poverty and inequality.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'ITLN 112': {
      EXCLUSION: [
        'No more than 6.0 units from ITLN 111/3.0; ITLN 112/3.0; ITLN P10/3.0.\nONE WAY '
      ],
      RECOMMENDATION: [],
      code: 'ITLN 112',
      description:
        'The continuation of ITLN 112/3.0. Also for students who have some knowledge of Italian but have not completed 4U Italian\nor equivalent. For these students an assessment interview with the instructor is required before registration. Contact the\nDepartment of Languages, Literatures and Cultures for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Italian II',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ITLN 111/3.0 or ITLN P10/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 303',
      description:
        'Explores a range of contemporary issues in feminist sociology. Topics may vary from year to year. See the departmental\nwebsite for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Feminist Sociology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'SPAN 206': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 206',
      description:
        'This course is an intermediate conversation course designed to advance skills in oral communication and cultural\ncompetence, supported by grammar review and written assignments. Students will engage with different media sources,\nincluding Spanish-language film, news items, cultural readings, music and literary texts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with of after SPAN 401/3.0; SPAN 402/3.0.'
      ],
      title: 'Spanish Conversation and Culture',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in SPAN 204/3.0.\nCOREQUISITE    SPAN 205/3.0 or SPAN 302/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 224': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 224',
      description: 'Continuation of MUSC 124/6.0.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Music',
      units: '6.0',
      PREREQUISITE: ['MUSC 124/6.0 and permission of the School.'],
      'LEARNING HOURS': []
    },
    'PSYC 550': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 550',
      description:
        'Reading courses to be arranged in consultation with individual members of the Department.\n',
      NOTE: [
        'Students are limited to a maximum of two of PSYC 550/3.0, PSYC 555/3.0, PSYC 560/3.0, PSYC 570/3.0, or PSYC\n575/3.0 Students are also limited to a maximum of two 500-level courses supervised by the same faculty member.\n(Students registered in PSYC 501/9.0 concurrently will not normally take one of these courses with their thesis supervisor.)\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading I',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the instructor and of the Chair of Undergraduate Studies and Level 3 or above and\nregistration in a PSYC Major, Medial or Specialization Plan.'
      ],
      'LEARNING HOURS': ['117 (20G;13I;84P)\n']
    },
    'ENGL 336': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 336',
      description:
        'A study of the origins of the English novel from early modern prose romances and satires to the gothic novel. Emphasis falls\non tracing the development of narrative forms and their relation to socio-cultural history.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Early Modern Prose Fiction',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'GEOL 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 300',
      description:
        'An intensive two-week course taken immediately after final examinations in second year (see Sessional Dates). Teams of\nstudents use geological field methods as the basis for an assessment of overburden and bedrock for a specific outcome. A\nfinal report is presented and defended.\n',
      NOTE: [
        'The cost of accommodation, transportation and food will be borne by the student. Please contact the Department\nfor more information.  Estimated $950.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Geological Field School',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 221/3.0 and GEOL 235/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (120Oc)\n']
    },
    'SOCY 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 402',
      description:
        'A critical assessment of contemporary issues and theories pertaining to intimate relationships and family relations.\nContemporary research and debates are critically discussed. An overall objective of the course is to \u2018rethink the family\u2019 and\nconsider and evaluate ideological assumptions and persistent myths about \u2018the family\u2019.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Families, Gender and the State',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'FREN 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 227',
      description:
        'A course in contemporary French civilization as seen through various media: books, newspapers, and the cinema.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le cin\u00e9ma et la civilisation fran\u00e7aise',
      units: '3.0',
      PREREQUISITE: [
        'FREN 150/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 100/6.0 or FREN 110/6.0.'
      ],
      'LEARNING HOURS': ['144 (36L;36Lb;72P)\n']
    },
    'HIST 296': {
      EXCLUSION: ['No more than 6.0 units from HIST 296/3.0; HIST 305/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 296',
      description:
        'This course examines a formative period of Islamic society: the transformations of the late antique Near East to the Muslim\nMiddle East. The course covers the period of the rise of Islam to the consequences of the Mongol conquests. It surveys the\nsocial, political, cultural and religious history of a civilization spanning Spain to Central Asia.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Making of the Muslim Middle East (550-1350 C.E.)',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 210': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 200/6.0; DRAM 201/3.0; DRAM 202/3.0; DRAM 210/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 210',
      description:
        'A survey of production methods, architecture, and performance in western and eastern theatre traditions from early\nclassical eras to the end of the 19th century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theatre History',
      units: '6.0',
      PREREQUISITE: [
        'A grade of B- in 6.0 units from (DRAM 100/6.0; DRAM 181/6.0; BISC100/3.0; BISC101/3.0) or permission of\nthe Department.\n'
      ],
      'LEARNING HOURS': []
    },
    'MUTH 380': {
      EXCLUSION: ['No more than 3.0 units from MUTH 380/3.0; MUSC 385/3.0.\n'],
      RECOMMENDATION: [],
      code: 'MUTH 380',
      description:
        'Research Methods in the Performing Arts\nFurther development of research skills from foundational courses, investigating bibliographic, archival, ethnographic, and\nembodied research methodologies. Other topics include critical theories, ethical considerations, and issues of\nrepresentation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above.\n'],
      'LEARNING HOURS': ['120 (36S;36O;48P)\n']
    },
    'MUSC 412': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 412',
      description:
        'Mid-size ensemble experience for qualified performers. Topics vary. Course includes weekly rehearsals of a wider variety of\nrepertoire, and a minimum of one concert per term for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medium Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'PHYS 117': {
      EXCLUSION: [
        'No more than 6.0 units from PHYS 104/6.0, PHYS 106/6.0; PHYS 117/6.0; PHYS 118/6.0.'
      ],
      RECOMMENDATION: ['4U Physics is recommended.\n'],
      code: 'PHYS 117',
      description:
        'An algebra-based course dealing with basic physics concepts, including dynamics, fluids, waves, electromagnetism, and\nbasic optics. Emphasis is based on the development of problem-solving skills through the use of Mastery based course\ndelivery. PHYS 117/6.0 includes a required lab component.\n',
      NOTE: ['Manual: estimated cost $15 per manual.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Physics',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;36Lb;36T:96P)\n']
    },
    'ARTH 242': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 242',
      description:
        'An introduction to the history of photography as technology, art, and social practice. Within the larger historical contexts of\nsociety and culture, it surveys key developments and applications in France, England, and the United States, and their\nspread to other parts of the world, and considers the work of major photographers and their influence.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to the History of Photography',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;12G;24O;60P)\n']
    },
    'CHEM 221': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 221',
      description:
        'Materials, Solutions and Interfaces\nA survey of the thermodynamic properties of gases and liquids, including phase and chemical equilibria and\nelectrochemistry. An introduction to the properties of materials, interfaces, surfaces and aqueous solutions. The laboratory\nuses modern software to facilitate equilibrium calculations, illustrates measurement techniques and develops laboratory\nskills. Winter Term.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'CHEM 112/6.0 and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or [MATH 123/3.0 and MATH\n124/3.0]).'
      ],
      'LEARNING HOURS': []
    },
    'CHEM 347': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 347',
      description:
        'The course covers four major topics. 1. The thermodynamic properties of interfaces (surface energy, wetting, surface area\nand porosity, capillary effects, work of adhesion/cohesion). 2. Models of adsorption/desorption phenomena. 3. The\ndynamics of phase transitions (meta-stability, nucleation, spinoidal decomposition). 4. The stability and characterization of\ncolloidal systems. Student appreciation for the importance of these phenomena is cultivated using examples drawn from\nindustrial processes/products including inks, paints, foods, polymer blends, and nanocomposites.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Surface and Colloid Science',
      units: '3.0',
      PREREQUISITE: ['CHEM 221/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'ENGL 279': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 279',
      description:
        'Students will read a range of controversial books, and discuss the contexts and content of calls that they be banned. What\nideas about literature, religion, and social order underpin such initiatives? Can limiting access to literature ever be justified?\nAuthors may include Milton, Rushdie, Hitler, Twain, Nabokov, Joyce, Lee, and Morrison.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and Censorship',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 395': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 395',
      description:
        'Students can apply to undertake a practical internship in media production, criticism or curatorship. All internships must be\napproved in advance by application to the Undergraduate Coordinator. Approval will depend on the quality of the proposal\nand the academic record of the applicant. Students are required to write a report about their experience and are evaluated\njointly by their employer and a faculty member from Film and Media. It is the responsibility of students, not the\nDepartment of Film and Media, to arrange internships.\n',
      NOTE: ['Students will be given a grade of Pass/Fail for work done.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Internship',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM and permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (120I)\n']
    },
    'DRAM 201': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 200/6.0; DRAM 201/3.0; DRAM 202/3.0; DRAM 210/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 201',
      description:
        'A survey of structure, forms and ideas of dramatic literature originating in works up to the 18th century. Plays will be read\nin English.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Drama I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GEOL 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 452',
      description:
        'The theory and practical aspects of the techniques of X-ray powder diffraction and scanning electron microscopy are\nstudied. Other techniques including Mossbauer, infra-red spectroscopy, and nuclear magnetic resonance spectroscopy will\nalso be covered. An extensive term project is required where the student employs these techniques to study a material of\ntheir choice.\n',
      NOTE: [
        'This course may not be offered every year. Consult: http://www.queensu.ca/geol/courses for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Instrumental Techniques Applied to the Study of Solids',
      units: '3.0',
      PREREQUISITE: ['GEOL 232/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (24L;36Lb;60P)\n']
    },
    'DRAM 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 323',
      description:
        'Exploration of practical preproduction needs. Topics may include casting, staging, theatre configuration, textual alteration,\nrehearsal technique, period research, design approaches.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Practical Concerns in Directing',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and (a grade of B- in\nDRAM 241/3.0 or DRAM 242/3.0).'
      ],
      'LEARNING HOURS': ['120 (36Pc;18G;66P)\n']
    },
    'GPHY 372': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 372',
      description:
        'This course provides intensive coverage of a topic in Geographic Information Science and will be offered periodically by\nvisiting professors. Consult the Departmental homepage for details on specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Geographic Information Science',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 in a GPHY Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 351',
      description:
        'Guidance in the development of the student as a composer for instruments and voice.\n',
      NOTE: [
        'Students must submit a portfolio of compositions to the Music Office by the last day of classes in the Winter Term.\nAdmission is determined through evaluation of portfolios by a Faculty jury. Submission of a portfolio does not guarantee\nadmission.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Acoustic Composition',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ARTH 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 306',
      description:
        'This survey examines key German buildings and monuments from the beginning of German Confederation to the end of the\nThird Reich. Emphasis will be placed on situating this architecture in its broader cultural and social context.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Schinkel to Speer: German Architecture from 1815 to 1945',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'ENGL 347': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 347',
      description:
        'American literature after the Revolution was arguably the first postcolonial literature in English. Through the study of\nliterature in many genres, this course will explore relationships between innovation and tradition, and between the nation\nand its others, over the course of the long nineteenth century (roughly 1780 to 1920).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Literature and the Long 19th Century',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'PHIL 383': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 383',
      description:
        'What is computation? What has computer science taught us about ourselves and the world? Topics to be addressed\ninclude: the relationship between computability, logic, and mathematics; computation and cognition; the simulation\nhypothesis; infinity and paradox; natural computation; the nature of information; artificial intelligence; and more.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Computing',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 302': {
      EXCLUSION: [
        'No more than 6.0 units from PSYC 300/6.0; PSYC 301/3.0; PSYC 302/3.0.\nEQUIVALENCY    PSYC 300/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 302',
      description:
        'The application of previous statistical and methodological courses (continuation of PSYC 202/PSYC 203/PSYC 301) toward\nthe design, execution, analysis, and communication of a research project. Lectures and laboratories cover data collection,\ndata management, some advanced statistical analyses, and communication skills.\n',
      NOTE: [
        'Enrollment is limited. Restricted to students in a PSYC Major Plan. Required for admission to PSYC 501/9.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Research Methods',
      units: '3.0',
      PREREQUISITE: [
        'A minimum grade of C in PSYC 301/3.0 and registration in a PSYC Major Plan.\n'
      ],
      'LEARNING HOURS': ['120 (36L;36Lb;12G;12O;24P)\n']
    },
    'CHEM 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 311',
      description:
        'Mechanistic Organic Chemistry\nFundamental mechanistic concepts of organic reactions, structure-activity relationships, solvent effects and catalysis.\nMechanistic aspects of substitution, addition, elimination and pericyclic reactions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['CHEM 223/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'POLS 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 430',
      description:
        'Topics vary from year to year, and may include class, ethnic, and regional politics, law and politics, interests and interest\narticulation, and democracy and democratization. Consult the departmental homepage.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Comparative Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (36S;12G;72P)\n']
    },
    'ENGL 477': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 477',
      description:
        'Topics in Postcolonial Literatures II\nFor detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'KNPE 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 365',
      description:
        'Study of strategies to enhance intrinsic motivation and self-regulation for physical activity and health behaviour change in\nclinical settings. Students will learn and practice motivational interviewing skills for behaviour change in intensive weekly\ntutorial sessions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Motivational Interviewing for Physical Activity Behaviour Change',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED, KINE or HLTH Plan and PSYC 100/6.0 and (KNPE 265/3.0 or HLTH 315/3.0).'
      ],
      'LEARNING HOURS': ['120 (12L;24T;84P)\n']
    },
    'ARTH 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 404',
      description:
        'A general survey course dealing with various aspects of conservation and museology. The course deals with professional\nethics, control of the factors causing deterioration and with preventive conservation including care in handling,\ntransporting, and storing cultural property. Open to upper-year undergraduate students with permission of the\nDepartment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Conservation Principles',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 260': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 260',
      description:
        'Review of imperative programming features. Introduction to other widely used programming paradigms. Functional\nprogramming languages, such as LISP and Haskell. Higher order functions, lazy evaluation, abstract and recursive types,\nstructural induction, symbolic expressions. Logic programming languages, such as PROLOG. Operational interpretation of\npredicates and terms, proof search, unification, backtracking. Typical applications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Programming Paradigms',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and C- in CISC 124/3.0 and C- in (CISC 102/3.0 or MATH 110/6.0).\nCOREQUISITE    CISC 204/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LLCU 333': {
      EXCLUSION: ['No more than 3.0 units from LLCU 333/3.0; SPAN 333/3.0.'],
      RECOMMENDATION: [],
      code: 'LLCU 333',
      description:
        'Baroque playwrights took full advantage of the actor Juan Rana\u2019s well-known queerness to subvert implicitly and explicitly\nthe social norms of sexual and gender identity still questioned today. Course will examine Spanish Baroque short theatre in\ngeneral and historically contextualize its subversion of social, sexual, gender, and patriarchal norms.\n',
      NOTE: ['Readings in translation.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Acting Out: Sexual and Gender Subversion in Baroque Theatre',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 351',
      description:
        'An exploration of the relationship between Victorian literature and culture. This course will examine novels, poems, and\nessays written between 1830 and 1900 with attention to their particular literary, historical, and social contexts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Victorian Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 456',
      description:
        'An investigation into different theoretical perspectives on the issue of \u2018identity\u2019 and the import of these perspectives for\nthe \u2018politics of identity\u2019. Theories of gender, race, class, nation, and sexual orientation, from a variety of perspectives,\nincluding Marxist, feminist, postmodern, and psychoanalytic theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theories of Identity Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'GEOL 543': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 543',
      description:
        'Directed, independent research on geological problems. The thesis may be based on data or material collected during\nsummer fieldwork or in the fall/winter around Kingston, on laboratory research, or using published data. Monthly tutorials\nwill cover various aspects of literature review, writing skills and oral presentations. A seminar concerning the thesis topic\nwill be presented at the end of Winter term.\n',
      NOTE: [
        'An electronic copy of the final thesis, formatted to the supervisor\u2019s satisfaction, must be uploaded to Qspace. The\nsupervisor may require one hardcopy.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Research and Thesis',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 in a GEOL Major or Specialization Plan, and a GPA of 3.3 in 36.0 units in GEOL, and permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['258 (6L;12S;48I;192P)\n']
    },
    'SOCY 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 430',
      description:
        'A critical engagement with theories of consumer culture with emphasis upon the material, symbolic and practice-orientated\naspects of consumption in sociological context; substantive focus upon shopping, taste, brands, tourism, services, digital\ncommodities.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Consumer Culture',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and SOCY 306/3.0 and (a minimum grade of C in\nSOCY 210/3.0 and SOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'HIST 225': {
      EXCLUSION: ['No more than 1 course from HIST 225/3.0; HIST 250/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 225',
      description:
        'he Early Middle Ages\nAn introduction to Medieval Europe from the fall of Rome to the 11th century including the history of the Church,\nmonasticism, the conversion of Europe and Carolingian Empire. The course will cover the disintegration of the Roman\nEmpire and the subsequent emergence of new kingdoms and social structures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 499': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 499',
      description:
        'Explores political, economic, and cultural change in the People\u2019s Republic of China, while providing an introduction to\nspecialized research methods. Attention will also be devoted to the recent history of Taiwan and Hong Kong.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'hina Since 1949',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'POLS 355': {
      EXCLUSION: [
        'No more than 3.0 units from POLS 355/3.0; POLS 394/3.0 (Fall 2015).'
      ],
      RECOMMENDATION: [],
      code: 'POLS 355',
      description:
        'This course discusses important contemporary issues that arise in political theory. Examples include: liberty and\npaternalism, toleration, punishment, multiculturalism, climate change, intergenerational justice (or injustice) and violence.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues in Contemporary Political Theory',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 435',
      description:
        'Microeconomic issues: land, labor, credit, and insurance markets; duality; alternate views of the role and evolution of non-\nmarket institutions in the development process. Macroeconomic issues: urban migration; inequality and development;\npopulation growth and technical change; internal factor accumulation versus TFP growth. Offered concurrently with ECON\n835/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Development Economics',
      units: '3.0',
      PREREQUISITE: [
        'ECON 239/3.0 and ECON 310/3.0 and permission of the Department.\nCOREQUISITE    ECON 351/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 102',
      description:
        'Introduction to mathematical discourse and proof methods. Sets, functions, sequences, and relations. Properties of the\nintegers. Induction. Equivalence relations. Linear and partial orderings.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': ['May not be taken with or after CISC 203/3.0.'],
      title: 'Discrete Mathematics for Computing I',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 435',
      description:
        'This seminar-style course involves critical assessment of HIV prevention interventions situated at varying levels of analysis\nand action. Consistent with the epidemiology of HIV/AIDS, the course focuses on interventions for disadvantaged and\nmarginalized populations. Students should be prepared to lead discussion and present in class.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar on HIV/AIDS Prevention',
      units: '3.0',
      PREREQUISITE: ['HLTH 315/3.0.'],
      'LEARNING HOURS': ['120 (24S;12G;84P)\n']
    },
    'MUSC 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 338',
      description:
        'An introduction to the methods, materials, and curriculum design suitable for teaching music to senior high school\nstudents.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Secondary Music Education',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and 6.0 units from MUSC 180/3.0-MUSC 188/3.0.'
      ],
      'LEARNING HOURS': ['106 (36L;6Pc;12G;52P)\n']
    },
    'ARTH 380': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 380',
      description:
        'Venice and Its Biennale: The Display of Contemporary Art and Culture in a Historic City\nInstruction in Venice based on daily study visits to the Venice Biennale and sites of display for modern and contemporary\nart, such as the Peggy Guggenheim and Francois Pinault collections.\n',
      NOTE: [
        'Students must pay a $3,500.00 course for this course.  The course fee covers accommodation, five group meals,\npublic transit in Venice, entrance to all museums and galleries included on the syllabus, and passes for the Venice Biennale.\nCost of travel and daily meals must also be paid by the student.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['6.0 units in ARTH.'],
      'LEARNING HOURS': ['224 (75L;12S;56Pc;36G;45P)\n']
    },
    'FREN 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 450',
      description:
        'A practical translation course. Review exercises in comparative stylistics, written and oral th\u00e9mes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Travaux pratiques: stylistique et traduction',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 250/3.0 and FREN 330/3.0) or a grade of C in FREN 344/3.0.\nEQUIVALENCY    FREN 444/3.0.'
      ],
      'LEARNING HOURS': ['132 (24L;12G;96P)\n']
    },
    'POLS 230': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 230',
      description:
        'This course provides a general introduction to the institutions and politics of the electoral process in the United States. The\ncourse integrates literature on the electoral system (including the system of primary elections), campaign financing,\npolitical parties, voting behaviour, political sociology, and political communication.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Elections',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'CHIN 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHIN 100',
      description:
        'For students with no previous knowledge of Chinese. Students familiar with Cantonese or Mandarin will not be permitted\nto enrol. Introduction to the basic structural patterns and functional usage of the language including an emphasis on oral\ncommunication (both listening and speaking), reading and writing basic Chinese characters, as well as Chinese culture.\n',
      NOTE: [
        'Students will have their level of competence assessed by the instructor during orientation week in September.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Mandarin Chinese I',
      units: '6.0',
      PREREQUISITE: ['Level 1 or (Level 2 or above and a GPA of 1.90).'],
      'LEARNING HOURS': ['240 (72L;24T;144P)\n']
    },
    'PHIL 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 310',
      description:
        'This course examines philosophical issues in the field of Global Development, such as what is meant by \u2018development\u2019,\n\u2018freedom\u2019 and \u2018quality of life\u2019.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Development Ethics',
      units: '3.0',
      PREREQUISITE: ['Level 3 and 12.0 units in PHIL, ENGL, HIST, or POLS.'],
      'LEARNING HOURS': []
    },
    'MATH 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 341',
      description:
        'Introductory geometry of curves/surfaces: directional/covariant derivative; differential forms; Frenet formulas; congruent\ncurves; surfaces in R3: mappings, topology, intrinsic geometry; manifolds; Gaussian/mean curvature; geodesics, exponential\nmap; Gauss-Bonnet Theorem; conjugate points; constant curvature surfaces.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential Geometry',
      units: '3.0',
      PREREQUISITE: ['MATH 110/6.0 and MATH 280/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'MUSC 392': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 392',
      description:
        'Introductory study of 20th-century systems of musical organization through analysis and writing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory and Analysis III',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 293/3.0 or MUSC 291/6.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'ENSC 471': {
      EXCLUSION: ['No more than 3.0 units from CHEM 321/3.0; ENSC 471/3.0.'],
      RECOMMENDATION: [],
      code: 'ENSC 471',
      description:
        'Two weeks of intensive study in Environmental Analysis. Fundamentals of sample collection and preparation, including\nstatistics and extraction methods, plus instrumental techniques including chromatography, atomic spectroscopy,\nspectrophotometry, and automated analysis techniques. Laboratory experiments in each of these areas. Enrolment limited.\nOffered in Spring Term only.\n',
      NOTE: ['Field trip: estimated cost $15.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Analysis Methods',
      units: '3.0',
      PREREQUISITE: ['CHEM 213/3.0 or permission of the School.\n'],
      'LEARNING HOURS': []
    },
    'MUSC 180': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 180-189/3.0 (BMUS excepted).'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 180',
      description:
        'An introduction to the study of the singing voice through class instruction. Fundamental techniques that can be used in a teaching\nsituation will be emphasized. Includes the study of the changing voice (male and female), breathing techniques, vowel formations,\nwarm-ups, method books and teaching techniques.\n',
      NOTE: [
        'Students with RCM Grade 8 Theory or equivalent may request permission from the School to take the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Vocal Techniques and Methods',
      units: '3.0',
      PREREQUISITE: ['(Registration in a BMUS or BMT Plan) or MUSC 104/3.0.\n'],
      'LEARNING HOURS': []
    },
    'GNDS 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 311',
      description:
        'This course examines different forms and critiques of feminism, and major issues in the development of feminist activism\nand feminist theory, including challenges to the colonial history of Western feminism. Students engage with current\ndebates in feminism, gender and queer theory, and anti-racism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Feminist Thought',
      units: '3.0',
      PREREQUISITE: ['Level 3 and GNDS 120/3.0 or GNDS 125/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 431',
      description:
        'The cellular origins of diversity in physiological processes, with consideration of the role of evolutionary, developmental and\nmolecular mechanisms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cellular Basis of Adaptation',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 330/3.0 or BCHM 218/3.0) and (one of BIOL 301/3.0; BIOL 334/3.0; BIOL 338/3.0; BIOL 339/3.0; BIOL\n341/3.0) and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['108 (6L;30S;8T;4G;60P)\n']
    },
    'ECON 360': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 360',
      description:
        'An analytical course covering topics in labour supply analysis, the economics of human capital, labour demand, the\noperation of labour markets, the economic behaviour and effect of unions, and selected aspects of wage structure.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Labour Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BISC 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BISC 100',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'BIOL 416': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 416',
      description:
        'Principles of terrestrial ecosystem ecology: soils; plant-soil interactions; energy and water balance; carbon and nutrient\ncycling; species effects; landscape-level and whole earth biogeochemistry; global change.\n',
      NOTE: ['Overnight field trip: estimated cost $75.\n'],
      'ONE-WAY EXCLUSION': ['May not be taken with or after BIOL 510/3.0.'],
      title: 'Terrestrial Ecosystems',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 302/3.0 or BIOL 303/3.0 or GPHY 317/3.0) and a minimum GPA of 2.0 in the Biological Foundations\nList.\n'
      ],
      'LEARNING HOURS': ['124 (12L,24S;18Lb;12Pc;12G;12O;16Oc;18P)\n']
    },
    'RELS 163': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 163',
      description:
        'This course will identify and describe characteristics of religion as they appear in popular culture (e.g. fashion; comics;\nmovies; art; music; novels; sitcoms; dramas; video games) and analyze how such depictions present, shape, and create\nperceptions of religion in public discourse.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Popular Culture',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;84P)']
    },
    'BIOL 369': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 206/3.0.\n'],
      code: 'BIOL 369',
      description:
        'Why sex? The evolutionary origins and consequences of sex and sexual reproduction. Topics include costs and benefits of\nsexual reproduction, the evolution and coevolution of sexes, gametes and genitalia, mating systems, gender differences and\nsex determination throughout the biotic world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sex and Evolution',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 102/3.0 and BIOL 103/3.0 and (3.0 units from BIOL 201/3.0; BIOL 202/3.0; BIOL 205/3.0; BIOL\n206/3.0).\nEQUIVALENCY    BIOL 210/3.0.'
      ],
      'LEARNING HOURS': ['122 (36L;8T;18O;60P)\n']
    },
    'CLST 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 401',
      description:
        'An introduction to the diverse research methods deployed in Classics, Archaeology and Ancient History. Weekly seminars\nwill feature the research interests of members of the Classics Department, cross-appointed faculty, and visiting researchers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Methods',
      units: '3.0',
      PREREQUISITE: [
        '(Level 4 in a CLST or CLAS or GREK or LATN Plan with a minimum GPA of 2.90) or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'BIOL 503': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 503',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Plant Biotechnology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List and [(BIOL 205/3.0 or BCHM 218/3.0)\nand BIOL 341/3.0] or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (15L;9S;24G;72P)\n']
    },
    'MATH 499': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 499',
      description:
        'Important topics in mathematics not covered in any other courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Mathematics',
      units: '3.0',
      PREREQUISITE: ['Permission of the Department.'],
      'LEARNING HOURS': []
    },
    'MUSC 281': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 281',
      description:
        'Continuation of MUSC 181/3.0. Students study woodwind instruments through class instruction on selected instruments.\nEmphasis expands to intermediate levels, with further study of playing techniques, ranges, fingerings, transpositions,\ninstrument maintenance, ensemble repertoire and teaching techniques. Rental instruments available.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Woodwind Techniques and Methods II',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 181/3.0 or permission of the instructor.\nEQUIVALENCY    MUSC 182/3.0.'
      ],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'POLS 329': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 329',
      description:
        'An introduction to European politics. The themes and geographic focus vary from year to year; they may include current\npolitical institutions and forces, the historical evolution of the European polities, and both Western and Eastern Europe.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'European Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 423': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 423',
      description:
        'An examination of aspects of modern inorganic and organometallic chemistry. Topics will include metal-ligand bonding in\norganometallic complexes, applications of organometallics in organic synthesis, metal-metal bonding in dinuclear and\npolynuclear metal complexes, and may include reaction mechanisms of transition metal complexes, bioinorganic chemistry,\nand symmetry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Inorganic and Organometallic Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 312/3.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'ENSC 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 311',
      description:
        'Applied Environmental Policy\nThis course investigates the ecological, social and economic dimensions of environmental policy using a comparative\napproach. This course will normally be offered at an international locations (e.g. BISC) thereby allowing and\ncomparisons/contrasts between Canadian and other context-specific approaches on the role of law, governance, politics,\nadministration and economics towards promotion of \u2018enlightened\u2019 environmental policy.\n',
      NOTE: [
        "Only offered in the Queen's-Blyth International Studies program or at the Bader International Studies Centre,\nHerstmonceux.\n"
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above, or permission of the School.'],
      'LEARNING HOURS': ['120 (24L;72G;24P)\n']
    },
    'DRAM 247': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 247',
      description:
        'A credit/non-credit practicum for 48 hours of extra-curricular work in drama related fields, including departmental\nproductions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Drama Practicum',
      units: '1.5',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '48 (6I;42P)\nCOREQUISITE    DRAM 240/3.0 or DRAM 242/3.0.'
      ]
    },
    'GNDS 520': {
      EXCLUSION: [
        'No more than 6.0 units from GNDS 510/6.0; GNDS 520/3.0; GNDS 530/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GNDS 520',
      description:
        'In consultation with the Head of the Department, students arrange their reading with individual Gender Studies faculty, and\nare expected to write reports on their readings and to discuss them throughout the term with that faculty supervisor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registered in a GNDS Major or Medial or SXGD Plan or permission of the Department.\n'
      ],
      'LEARNING HOURS': []
    },
    'HLTH 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 497',
      description:
        'Intensive coverage of topics that are current and/or of special interest in the area of Health Studies. Offered periodically by\nvisiting professors or members of faculty. Students should check with the School regarding availability of this course.\n',
      NOTE: [
        'Also offered at the Bader International Study Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Health Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a PHED Specialization, KINE Specialization, HLTH Major, or HTLH Medial Plan) or\nregistration at the BISC.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUSC 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 300',
      description:
        'Chamber music or small ensemble experience for qualified instrumentalists and singers. Topics vary. Course includes\nweekly or bi-weekly coachings and a minimum of one evaluation and/or concert per term for all students. Credit attained\nonly with regular attendance, active participation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Small Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': []
    },
    'MUSC 334': {
      EXCLUSION: ['No more than 3.0 units from MUSC 334/3.0; MUSC 332/3.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 334',
      description:
        'An examination of the literature, instructional methods, resources, and planning structures for teaching music to\nelementary students.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Elementary Music Education',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 274/3.0 and (3.0 units from MUSC 180/3.0; MUSC 181/3.0; MUSC 183/3.0; MUSC 185/3.0; MUSC\n187/3.0; MUSC 188/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36G;24O;60P)\n']
    },
    'MUSC 443': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 443',
      description:
        'The concepts and principles of a reductive/linear approach to the analysis of music named after its first proponent, Heinrich\nSchenker. Both theoretical and practical applications are studied.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Schenkerian Analysis',
      units: '3.0',
      PREREQUISITE: ['MUSC 291/6.0 or MUSC 293/3.0'],
      'LEARNING HOURS': ['126 (36S;90P)\n']
    },
    'MATH 436': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'MATH 328/3.0 or MATH 334/3.0 or MATH 338/3.0 or PHYS 312/6.0.\n'
      ],
      code: 'MATH 436',
      description:
        'Quasilinear equations: Cauchy problems, method of characteristics; Cauchy-Kovalevski theorem; generalized solutions;\nwave equation, Huygens\u2019 principle, conservation of energy, domain of dependence; Laplace equation, boundary value\nproblems, potential theory, Green\u2019s functions; heat equation, maximum principle.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Partial Differential Equations',
      units: '3.0',
      PREREQUISITE: ['(MATH 231/3.0 or MATH 237/3.0) and MATH 280/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'CISC 124': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 124',
      description:
        'Introduction to object-oriented design, architecture, and programming. Use of packages, class libraries, and interfaces.\nEncapsulation and representational abstraction. Inheritance. Polymorphic programming. Exception handling. Iterators.\nIntroduction to a class design notation. Applications in various areas.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Computing Science II',
      units: '3.0',
      PREREQUISITE: [
        'C- in CISC 121/3.0.\nCOREQUISITE    CISC 102/3.0 or MATH 111/6.0 or MATH 121/6.0 or MATH 110/6.0 or MATH 112/3.0 or MATH 120/6.0 or\nMATH 123/3.0 or MATH 124/3.0 or MATH 126/6.0 or MATH 122/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;60P)\n']
    },
    'FILM 440': {
      EXCLUSION: [
        'No more than one course from FILM 400/3.0-005 (2014 onward); FILM 440/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FILM 440',
      description:
        'Advanced seminar on selected areas of documentary or experimental cinemas. Subjects have included politically\ncommitted documentary in Canada; the anti-documentary.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Non-narrative Film: Special Topic',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'SOCY 401': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 401',
      description:
        'Critical treatment of contemporary theories; emphasis upon logic of social inquiry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Studies in Contemporary Social Theory',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'DEVS 392': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 392',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies I',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 451',
      description:
        'An examination of major issues in contemporary epistemology. Possible topics include justification, internalism and\nexternalism, foundationalism and coherentism, and social epistemology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Epistemology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHGY 170': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHGY 170',
      description:
        'This is an introductory level course on the structure and function of human cells for students interested in pursuing human\nhealth-related disciplines. Students will also learn the principles of energy metabolism, cell growth and proliferation, and\nhow cells interact with their environment. There is also an overall focus to relate cellular processes to human function and\ndisease, culminating in a group presentation focused on one specific cell process and how it affects health. Students taking\nthis course will be well-prepared for upper year molecular biology courses.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': ['May not be taken with or after KNPE 225/3.0.'],
      title: 'Human Cell Physiology',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36O;78P)\n']
    },
    'DRAM 251': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 251',
      description:
        'Writing of dramatic exercises and one-act plays accompanied by dramaturgical study of published and original works.\n',
      NOTE: [
        'Priority in the on-campus offering of this course is given to students in a DRAM Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Playwriting',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'EMPR 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 335',
      description:
        'There is increasing recognition of the critical role of managers in shaping key employee attitudes (job satisfaction,\nmotivation, and engagement), with important effects for organizational performance. Students will explore a range of\ntheories and practices that are demonstrated drivers of employee attitudes and organizational success.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Managing Employee Attitudes for Organizational Success',
      units: '3.0',
      PREREQUISITE: ['EMPR 200/3.0 or EMPR 230/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 386': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 386',
      description:
        'An examination of the history and political economy of the mass media, exploring the impact of a partisan press, ownership\nand use of technology on how our identity has been shaped  It will draw upon a comparative assessment of the mass media\nin advanced liberal democracies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Economy and Mass Media',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 334': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 334',
      description:
        'A lecture and laboratory course on psychometrics. Test development and evaluation will be the focus of student projects.\nThe course will introduce software packages used for analyzing psychological test data.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Laboratory in Psychological Testing',
      units: '3.0',
      PREREQUISITE: ['PSYC 301/3.0 or PSYC 300/6.0.'],
      'LEARNING HOURS': ['120 (24L;24Lb;12G;60P)\n']
    },
    'MUSC 115': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 115',
      description:
        'Large ensemble for qualified instrumentalists and singers. Topics vary. Course includes weekly rehearsals of a wide variety\nof repertoire, and a minimum of one concert per term, for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Large Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'GNDS 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 315',
      description:
        'Feminist Pedagogies\nThis course looks at teaching and learning, in formal and informal educational settings, from feminist perspectives. Explores\ndifference (race, class, gender, sexuality, ability), social justice and activism, power and empowerment, critique and\ntransformation, experience, and reflexivity. Students will develop their feminist pedagogical values and skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'EMPR 210': {
      EXCLUSION: [
        'No more than 1 course from EMPR 210/3.0; LAW 560/4.0; LAW 567/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'EMPR 210',
      description:
        'This introductory course will provide students a foundation to understand employment law in Canada. The course will\nexamine the principles of employment law with a primary focus on current provincial and federal legislation affecting\nhuman resource management in a non-unionized setting.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Employment Relations and Labour Law',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (60O;60P)\n']
    },
    'ARTH 311': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 226/3.0 and ARTH 228/3.0.\n'],
      code: 'ARTH 311',
      description:
        'A study of gender in relation to modern visual culture from the mid-nineteenth to the mid-twentieth centuries using\ntheoretical frameworks drawn from feminist art history and gender studies. Topics to be studied include fashion and\nmodernity, consumer culture, gendered and transgendered artistic identities, and the gendering of Modernism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Modernism',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'FILM 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 338',
      description:
        'An intermediate study of key concepts in cultural studies investigated through cultural practices and/or national contexts\nfrom the 1960s to the present.\n',
      NOTE: [
        'Students will be required to attend a limited number of Kingston-based cultural productions over the course of the\nterm.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Issues in Cultural Studies',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (FILM 236/3.0; FILM\n240/3.0; FILM 260/3.0) or (Level 3 and registration in an ARTH, ARTV, DRAM, or MUSC Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;12G;12Oc;60P)\n']
    },
    'RELS 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 393',
      description:
        'Encounter between Buddhism and the West, major movements and thinkers, and socio-politically engaged Buddhism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Buddhism in the Modern World',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': []
    },
    'LLCU 432': {
      EXCLUSION: [
        'No more than 1 course from DEVS 410/6.0; DEVS 420/3.0; DEVS 432/6.0; LLCU 432/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 432',
      description:
        'Provides students with an opportunity to conduct social research under the guidance of a Fudan instructor. Queen\u2019s\nstudents attend lectures on the interdisciplinary study of Shanghai and team up with Fudan counterparts to undertake\nresearch on social change in Shanghai. Assignments include in-class presentations and a final paper. Fall term.\n',
      NOTE: [
        'This course is part of the Semester in Shanghai program in Arts and Science, which will require students to pay a\n$500 program fee to cover costs over and above tuition.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Research Practicum at Fudan University',
      units: '6.0',
      PREREQUISITE: [
        'Acceptance as a participant in the Semester in Shanghai program administered by the International\nPrograms Office.\n'
      ],
      'LEARNING HOURS': ['225.26 (26L;6.5S;2.86T;9.75Pc;6.5G;0.65I;77Oc;96P)\n']
    },
    'GEOL 463': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 463',
      description:
        'An introduction to spatial information management focusing on methods to support and extend geological mapping,\nmineral and petroleum exploration, and engineering site investigation. Computers and computation, GIS software and\ntheory, spatial simulation and analysis, databases and data management, and design of effective decision support solutions.\n',
      NOTE: [
        'This course may not be offered every year. Consult: http://www.queensu.ca/geol/courses for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Spatial Information Management in the Geosciences',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 243/3.0 or GEOL 333/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['112 (33L;24Lb;55Pc)\n']
    },
    'MATH 386': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 386',
      description:
        'Integers and rationals from the natural numbers; completing the rationals to the reals; consequences of completeness for\nsequences and calculus; extensions beyond rational numbers, real numbers, and complex numbers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Our Number System \u2013 an Advanced Perspective',
      units: '3.0',
      PREREQUISITE: ['MATH 281/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 341': {
      EXCLUSION: [
        'No more than 3.0 units from PSYC 341/3.0; PSYC 399/3.0 (2017)'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 341',
      description:
        'This course aims to provide students with hands-on experience in social psychology research. Students will learn principles\nof research methods in social psychology, involving literature review, research designs, data\ncollection/management/analysis, and report.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Laboratory in Social Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 241/3.0.\n'],
      'LEARNING HOURS': ['120 (18L;18Lb;12Oc;72P)\n']
    },
    'POLS 361': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 361',
      description:
        'A survey of selected regional international organizations for political cooperation, military security and economic integration in\nEurope, Latin America, Africa and the Asia-Pacific region.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Regional International Organization',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 403': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 403',
      description:
        'This seminar aims at advanced students interested in exploring the body as a site for the production of social and cultural\nmeaning and social inequality. Theoretical approaches may include critical race theory, queer theory, feminist theory,\npostcolonial theory, and sociological theories of the body. Topics covered may include the ways that representations of the\nbody are linked to practices of racism, sexism, moral regulation, colonialism and nation-building.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of the Body',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 429': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 429',
      description:
        'A detailed study of one area or topic in the history of 19th-century visual culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in 19th-century Visual and Material Culture',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 246': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 246',
      description:
        'An introduction to the history of the Soviet Union from its origins in the Revolution of 1917 to its collapse in 1991. This\ncourse examines and assesses the Bolshevik attempt to found a new social, economic and political order and to create a\nnew man and woman in the process. Particular attention will be devoted to the policies and practices of the state as well as\nto the experiences of individual Soviet citizens.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Soviet Experiment',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'MUTH 110': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 110',
      description:
        'An introduction to the study of Western music, theatre, fine art, and literature in historical and global perspective. Using\ndrama and music as a focal point, this interdisciplinary course will place artistic creation in a social, philosophical, and\npolitical chronological framework. Key periods include European Antiquity, Renaissance, and Baroque.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Republic to Rationalism: History, Arts, and Performance I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['114 (36L;36O;42P)']
    },
    'RELS 162': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 162',
      description:
        'This course will identify and describe characteristics of religion as they appear in news reports of social, political, and\neconomic aspects of public life and analyze how the news presents, shapes, and creates perceptions of religion in public\ndiscourse.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion in the News',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;84P)']
    },
    'ENGL 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 451',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Victorian Literature I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'LLCU 213': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 213',
      description:
        'Students will analyze and understand the most important forms of organized crime present in Canada. Its history and\nevolution are defined, in an attempt to interpret the relationship between major criminal organizations and economic,\nsocial, cultural, political, and demographic changes, both domestically and internationally.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Social History of Organized Crime in Canada',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHEM 399': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 397/6.0; CHEM 398/3.0; CHEM 399/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 399',
      description:
        'Laboratory course. In consultation with the course co-ordinator, and subject to availability, students may select\nexperiments as are relevant to their degree program including synthesis, analytical instrumentation and computational\nmethods. The integration of several methods will be emphasized in the design and characterisation of molecules.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Experimental Chemistry II',
      units: '3.0',
      PREREQUISITE: [
        '6.0 units at the 200 level in CHEM.\nCOREQUISITE    3.0 units at the 300 level in CHEM or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['156 (72Lb;12T;72P)\n']
    },
    'MUSC 152': {
      EXCLUSION: ['No more than 1 course from MUSC 152/3.0; MUSC 153/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 152',
      description:
        'This course teaches students the basics of vocal composition in the Western Art Music tradition with a strong emphasis on\ncreativity and class participation.\n',
      NOTE: [
        'No prior experience with composition is required, but students must demonstrate a thorough understanding of the\nrudiments of music prior to enrollment.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Vocal Composition',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 104/3.0 or MUSC P52/3.0 or permission of the School.\n'
      ],
      'LEARNING HOURS': ['136 (12L;24S;4G;96P)\n']
    },
    'BIOL 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 421',
      description:
        "This course will explore genetic aspects of conservation, addressing questions such as: How is genetic variation lost? Can\nloss of genetic variation result in extinction? How much genetic variation is 'enough' for population viability? Can loss of\ngenetic variation be prevented? How do we define management units for conservation? And is hybridization a problem or a\nbenefit for conservation?\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Conservation Genetics',
      units: '3.0',
      PREREQUISITE: [
        '(BIOL 243/3.0 or PSYC 202/3.0 or STAT 263/3.0 or STAT 269/3.0) and a minimum GPA of 2.0 in the\nBiological Foundations List.\nCOREQUISITE    BIOL 302/3.0 or BIOL 303/3.0.'
      ],
      'LEARNING HOURS': ['120 (24L;24T;72P)\n']
    },
    'FILM 106': {
      EXCLUSION: ['No more than 3.0 units from BISC 100/3.0; FILM 106/3.0.'],
      RECOMMENDATION: [],
      code: 'FILM 106',
      description:
        'Introduction to tools and methods of visual and aural analysis and to historical and social methods, with examples primarily\nfrom cinema and other moving-image media dating from 1970 to the present.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Film Form and Modern Culture from 1970',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'HIST 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 340',
      description:
        'The growth of French Canada since the early nineteenth century and the development of its relations with the rest of the\ncountry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'rench Canada, 1830-2000',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'FREN 335': {
      EXCLUSION: ['No more than 3.0 units from FREN 335/3.0; FREN 435/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 335',
      description:
        'A detailed study of representative Qu\u00e9b\u00e9cois authors since 1965. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le roman qu\u00e9b\u00e9cois',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['132 (24L;12S;24I;72P)\n']
    },
    'ENGL 217': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 217',
      description:
        'Postcolonial Literatures\nA comparative survey of representative works of literature from around the globe (including Africa, Australia, the\nCaribbean, and the Indian subcontinent) that engage with the history and legacy of colonialism. Themes under\nconsideration may include: cultural memory; economic underdevelopment; hybrid identity; linguistic diversity; political\nresistance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a DEVS Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 348': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 348',
      description:
        'Middle East Politics\nAn examination of the politics of the Middle East, including the legacy of the Ottoman Empire and European colonialism,\nthe rise of nationalism, the role of religion, the nature of the state and political participation in different countries in the\nregion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 222': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 222',
      description:
        'The resettlement of Jews in Europe; modernization of Jewish life and culture and resistance to it in Western and Eastern\nEurope, North America, Palestine, Middle East, and State of Israel; heresy, political emancipation, developments in\nantisemitism, enlightenment, secularization, Zionism, radicalism, modern religious movements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ewish and World Civilizations (since 1492)',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 207': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 207',
      description:
        'A survey of various historical case studies that will explore the causes, conflicts, and consequences that have occurred\nwherever indigenous peoples have encountered colonizing invaders. Significant questions will include who is indigenous?,\nwho is not?, and can one speak of a global indigenous history?\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'lobal Indigenous Histories',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['130 (2T;25G;2O;101P)\n']
    },
    'GNDS 421': {
      EXCLUSION: [
        'No more than 6.0 units from GNDS 421/6.0; POLS 318/3.0; POLS 382/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GNDS 421',
      description:
        'This course is designed to provide an in-depth exploration of poverty issues in Canada. It includes discussions about working\npoor and welfare poor and addresses how race and sexuality can compound the issues of poverty. The course will also\nacknowledge how poor people are actively engaged in attempting to improve their lives through anti-poverty organizing.\nThis course contains an intensive and independent study component.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Poverty',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['204 (36S;168P)\n']
    },
    'PHIL 324': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 324',
      description:
        'This course offers an introduction to African philosophical thought. After dealing with metatheoretical questions about the\nnature of philosophy and the philosophical inquirer, the focus will shift to African views on topics such as truth, the concept\nof a person, art, morality, slavery and colonialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'African Philosophy',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'PSYC 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 335',
      description:
        'Positive Psychology is the scientific study of optimal human functioning. Lectures review the history and empirical support\nin areas such as interpersonal relationships, and applying positive thinking. Homework assignments will include experiential\nexercises designed to foster an increased understanding of the role of positive psychology in everyday life.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Positive Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and (PSYC 235/6.0 or PSYC 236/3.0).'],
      'LEARNING HOURS': []
    },
    'HIST 501': {
      EXCLUSION: [
        'No more than 1 course from HIST 212/3.0, HIST 501/6.0, HIST 502/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 501',
      description:
        'Offers credit for archival work undertaken in conjunction with Queen\u2019s University Archives. One month before the\nbeginning of the term during which the work will be undertaken, students must submit an application to the Chair of\nUndergraduate Studies requesting credit hours commensurate with the project\u2019s learning hours.\n',
      NOTE: [
        "This course may be taken only once during a student's degree program.\n"
      ],
      'ONE-WAY EXCLUSION': [],
      title: "History/Queen's Archives Internship",
      units: '6.0',
      PREREQUISITE: ['Level 2 or above and permission of the Department.\n'],
      'LEARNING HOURS': ['240 (216Pc;24P)\n']
    },
    'BIOL 322': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 322',
      description:
        'A comparative examination of interaction between animals and their environment including: physiological adaptations to\nextreme environments (e.g., arctic, desert); responses to acute and chronic environmental stress (e.g., hypoxia,\ntemperature); environmental regulation of normal physiological processes; uses of comparative models in other fields.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Physiology of Animals',
      units: '3.0',
      PREREQUISITE: ['BIOL 339/3.0.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'SOCY 122': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 122',
      description:
        'An introduction to the concepts, theories and methods of sociological enquiry, and their application to the analysis of\nCanadian society.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Sociology',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (48L;24G;24O;144P)']
    },
    'RELS 223': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 223',
      description:
        'Buddhism in India, the life and teaching of Gautama the Buddha, and the growth of the Theravadin and Mahayanist\ntraditions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Buddhism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 204': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 204',
      description:
        'An examination of whether life has \u2018meaning\u2019, and a consideration of different philosophical interpretations of the meaning\nof life, the significance of death for the meaning of life, and whether it even makes sense to speak of life as having meaning.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Life, Death, and Meaning',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 496': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 496',
      description:
        'Team-based project involving the development of a game using modern tools and software engineering techniques.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Game Development Project',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and a GPA of 1.90 and C- in [CISC 226/3.0 and (CISC 326/3.0 or COCA 201/3.0)] or permission of the\nSchool of Computing.'
      ],
      'LEARNING HOURS': ['129 (9L;120G)\n']
    },
    'ANAT 216': {
      EXCLUSION: ['No more than 3.0 units from ANAT 216/3.0; ANAT 316/3.0.'],
      RECOMMENDATION: [],
      code: 'ANAT 216',
      description:
        'The general principles of human structure and function as appreciated through a survey of the development, microscopic\nand gross anatomy of the body systems: cardiovascular, respiratory, immune/lymphatic, endocrine, digestive and\ngenitourinary.\n',
      NOTE: [
        'Priority will be given to students registered in a LISC Specialization Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of Human Morphology II',
      units: '3.0',
      PREREQUISITE: ['ANAT 215/3.0.\n'],
      'LEARNING HOURS': []
    },
    'DEVS 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 321',
      description:
        'In its capacity to imagine, construct, and disseminate modes of being and becoming, theatre has helped shape and rework\ncolonialism, national liberation, postcolonial citizenship, and neoliberal globalization. This course is a critical exploration of\nthis evolving relationship between theatre and development from a variety of perspectives throughout the world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Development Dramas',
      units: '3.0',
      PREREQUISITE: ['DEVS 100/6.0, or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'HIST 337': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 337',
      description:
        'For nearly half a millennium, the Ottoman Empire ruled large parts of Europe, West Asia and North Africa. Although\nscholars agree on dates and places, they remain divided on almost every other aspect of the Ottoman past. This course\ninvestigates Ottoman history through the debates that have driven research over the last half century, beginning in the\n13th century and concluding with World War I.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ebates in the Ottoman Empire',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MICR 461': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 461',
      description:
        'Advanced immunology course focused on current topics in immunology and immunology-related scientific research.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Immunology',
      units: '3.0',
      PREREQUISITE: [
        ' Level 4 and registration in the LISC Major or Specialization Plan and a GPA of 2.5 and a minimum grade of\nA- in MICR 360/3.0.'
      ],
      'LEARNING HOURS': ['132 (12L;24T;96P)\n']
    },
    'COGS 499': {
      EXCLUSION: [
        'No more than one course from (CISC 499/3.0; COGS 499/3.0; CISC 500/6.0).'
      ],
      RECOMMENDATION: [],
      code: 'COGS 499',
      description:
        'Topic selected under the supervision of a member of one of the faculties of CISC, LING, PHIL, PSYC. Emphasis may be on\nexperimental, theoretical, or computer implementation topics. Independent research, an oral presentation, and a written\nreport are required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Undergraduate Project',
      units: '3.0',
      PREREQUISITE: [
        '(Level 4 and registered in a COGS Specialization Plan) and (an overall GPA of 1.90) and (a GPA of 2.60 from\n30.0 units in CISC) and (a GPA of 2.60 in COGS) and COGS 300/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (24S;12I;84P)\n']
    },
    'PSYC 485': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 485',
      description:
        'Special Topics in Psychology II\nSeminar courses on advanced topics in psychology offered periodically by visiting professors.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36S;84P)']
    },
    'SPAN 333': {
      EXCLUSION: ['No more than 3.0 units from LLCU 333/3.0; SPAN 333/3.0.'],
      RECOMMENDATION: [],
      code: 'SPAN 333',
      description:
        'Baroque playwrights took full advantage of the actor Juan Rana\u2019s well-known queerness to subvert implicitly and explicitly\nthe social norms of sexual and gender identity still questioned today. Course will examine Spanish Baroque short theatre in\ngeneral and historically contextualize its subversion of social, sexual, gender, and patriarchal norms.\n',
      NOTE: [
        'Taught in English with LLCU 333/3.0. Students concentrating in Spanish submit written assignments, tests, and\nexaminations in Spanish.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Acting Out: Sexual and Gender Subversion in Baroque Theatre',
      units: '3.0',
      PREREQUISITE: ['SPAN 302/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 439': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 439',
      description:
        'Advanced theory and techniques for acquisition, processing and interpretation of geophysical data. Solve a problem from\nidea, strategy, data acquisition, processing, to interpretation and deliverables. Design projects exploit seismic, gravity,\nmagnetic, EM methods, in oil/gas/mineral exploration, near-surface prospecting and site investigation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Applied Geophysics',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 249/3.0 and GEOL 319/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['128 (21L;24G;35I;24Oc;24P)\n']
    },
    'KNPE 336': {
      EXCLUSION: [
        'No more than one course from HLTH 300/3.0; KNPE 300/3.0; KNPE 330/4.5; KNPE 336/3.0; KNPE 346/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 336',
      description:
        'Students gain experience assisting adults with a disability or age-related impairment to engage in exercise. Students\ndevelop an understanding of the nature of disability across the lifespan. The benefits of exercise, factors that promote\nexercise participation, and appropriate exercise prescription are addressed.\n',
      NOTE: ['Students must hold valid First Aid/CPR certification.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Community Field Placement in Exercise, Disability and Aging',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED or KINE Plan, or HLTH Major or Medial Plan and (a GPA of 2.70) and permission\nof the Course Coordinator and the Undergraduate Coordinator in the School of Kinesiology and Health Studies.\nCOREQUISITE    HLTH 332/3.0.\n'
      ],
      'LEARNING HOURS': ['132 (12S;84Pc;12O;24P)\n']
    },
    'PHIL 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 351',
      description:
        'A discussion of concepts and issues in the philosophy of mind. Sample topics include identity, action, emotion, intention,\nbelief and desire.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Mind',
      units: '3.0',
      PREREQUISITE: ['PHIL 250/6.0 or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'WRIT 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 250',
      description:
        'A focus on the principles of business writing. Students analyze workplace contexts and identify writing strategies best suited\nto address business problems.  Students research, organize, design, and create reader-centred documents and various\nelectronic and print texts that relate to practical situations they will encounter in the business world.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Writing in Business Contexts',
      units: '3.0',
      PREREQUISITE: [
        'WRIT 120/3.0 or WRIT 125/3.0 or permission of the instructor.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 331',
      description:
        'Survey of the political process in the United States; functioning and interaction of the principal formal and informal political\ninstitutions, the relationship between those institutions and their environment, the making of public policy, and current\nissues and trends.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Government',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 156': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 156',
      description:
        'Basics of digital audio recording, with a focus on free/open-source software tools. Through assignments oriented towards\nmastering basics necessary for podcast or music recording/mixing, you will gain experience with digital audio workstation\nsoftware for multitrack production, and tools such as EQ, compression, and limiting.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Digital Audio Recording, Editing, and Mixing',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24Lb;24O;72P)']
    },
    'GRMN 420': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 320/3.0; INTS 320/3.0; GRMN 420/3.0.\nEQUIVALENCY    INTS 320/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GRMN 420',
      description:
        'An introduction from a cultural perspective to the growth of the fascist mentality in Europe and the emergence of fascist\nregimes. The course will treat Italian Fascism and the Third Reich as part of the broader conservative and nationalist\nchallenge to liberalism.\n',
      NOTE: [
        'Taught in English together with LLCU 320/3.0.  Students in a German Plan will submit written assignments, tests and\nexaminations in German. Normally students will read German texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Fascism in Europe from Napoleon to Hitler',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GRMN 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 311',
      description:
        'An introduction to reading, discussing and writing about German literary texts in German. Major periods, authors, and texts of the\n18th and 19th centuries will be examined in their cultural and historical contexts. Students will be exposed to different genres:\nexcerpts from novels and dramas, as well as short stories, poems and film adaptations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'German Language and Culture through 18th- and 19th Century Literature',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;12T;84P)\n']
    },
    'PSYC 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 400',
      description:
        'An introduction to the scholarship and practice of teaching including what it means to be a scholarly teacher, how\npedagogy research informs educational practice, and how people learn complex information. In addition to readings,\ncritiques and facilitated discussions, a practicum component will include facilitating weekly tutorials.\n',
      NOTE: [
        'Students must complete an application and be invited for an interview in the spring to be eligible for this fall term\ncourse. During the fall term, students will be responsible for facilitating 2-3 PSYC 100 tutorials per week as part of their\nteaching practicum.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Research in Higher Education',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a PSYC Major, Medial, or Specialization Plan and a GPA of 3.30 in PSYC.'
      ],
      'LEARNING HOURS': ['221 (24S;24G;78Pc;20O;75P)\n']
    },
    'KNPE 327': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 327',
      description:
        'A laboratory experience designed to establish understanding of, and technical skills in, the measurement of human\nphysiological responses and performance capacity in exercise. Students will develop familiarity with tests of physiological\nfunction during rest and exercise in preparation for work in human performance, clinical and medical settings.\n',
      NOTE: [
        'Priority given to students in Level 3 of the KINE Specialization Plan followed by students in Level 3 of the PHED\nSpecialization Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Exercise Physiology Laboratory',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED or KINE Plan and KNPE 125/3.0, KNPE 225/3.0, and KNPE 227/3.0.'
      ],
      'LEARNING HOURS': ['126 (24L;36Lb;6I;12O;48P)\n']
    },
    'PHIL 273': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 273',
      description:
        'This lecture course provides an analysis of key figures and texts in nineteenth-century continental European philosophy.\nPossible figures include Georg Wilhelm Friedrich Hegel, Soren Kierkegaard, Friedrich Nietzsche, and Wilhelm Dilthey.\nPossible topics include post-Kantian idealism, existentialism, and hermeneutics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Continental Philosophy, 1800-1900',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 323',
      description:
        'An examination of selected themes in the cultural and intellectual history of Europe from 1750 to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'odern European Thought and Culture',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'POLS 465': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 465',
      description:
        'A consideration of the main types of war theory, including descriptive, legal, normative, causal, process, and consequential,\nwith applications to selected case studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Politics of War',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 348': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 348',
      description:
        'An exploration of the adversary tradition in the 19th and 20th century West. Socialist, feminist, labour, populist, and\nutopian thought is explored in fiction and non-fiction works.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'rophets and Populists, Ranters and Rebels',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ECON 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 310',
      description:
        'A rigorous examination of the central core of microeconomic theory. Consumer demand, the theory of production, product\nand factor markets, general equilibrium and some aspects of welfare economics are covered. The emphasis is on\ntechniques of analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Microeconomic Theory II',
      units: '3.0',
      PREREQUISITE: [
        '(A grade of C in ECON 212/3.0) and ECON 255/3.0 and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0\nor [MATH 123/3.0 and MATH 124/3.0] or MATH 126/6.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENSC 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 502',
      description:
        'This is an interdisciplinary research project related to environmental sustainability, with supervision and training in\nappropriate research methods by faculty members of the School of Environmental Studies. The course includes supervised\nresearch including a research proposal, a seminar, a poster presentation and a final thesis and oral defense.\n',
      NOTE: [
        'This course is intended for a self-motivated student with an established record of undergraduate performance, i. e.\ncumulative GPA of approximately 3.0. It is the responsibility of the student to secure a supervisor prior to registering in the\ncourse.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Sustainability',
      units: '12.0',
      PREREQUISITE: [
        'Open to students in the final year of an Honours Program in any discipline, and with permission of the\ninstructor of the course and of the department of the student\u2019s Plan.'
      ],
      'LEARNING HOURS': ['480 (24I;456P)\n']
    },
    'ECON 325': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 325',
      description:
        'An introduction to the theory of comparative advantage followed by a study of trade policies in developed and developing\ncountries including tariffs and quotas, licensing arrangements, anti-dumping and safeguard mechanisms, domestic content\nrules and other non-tariff barriers, and multilateral arrangements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Trade Policy',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'POLS 484': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 484',
      description:
        'An examination of the major theoretical debates and issues in contemporary globalization, including the historical roots of\nglobalization, and the impact of globalization on culture, economics, trade, global governance, and global social\nmovements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Politics of Globalization',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PSYC 375': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 375',
      description:
        'This course covers recent research in comparative cognition at an advanced level. Emphasis will be placed on critically\nevaluating scientific controversies in specific topics, such as episodic memory in animals, mechanisms of spatial navigation,\nand value-based decision-making. Laboratory sessions will explore the principles discussed in lectures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Cognition: Animal Learning Laboratory',
      units: '3.0',
      PREREQUISITE: [
        '[PSYC 203/3.0 and (PSYC 205/3.0 if taken in Fall 2015 or onward)] or (Level 3 and registration in a BCHM,\nBIOL, or LISC Plan).'
      ],
      'LEARNING HOURS': ['126 (18L;18Lb;12O;78P)\n']
    },
    'MICR 221': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 221',
      description:
        'A fundamental study of the structure and growth of microorganisms and viruses. The roles of microbes in aquatic,\nterrestrial and human environments will be considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Basic Microbiology',
      units: '3.0',
      PREREQUISITE: [
        '(A GPA of 1.90 in BIOL 102/3.0 and BIOL 103/3.0) and CHEM 112/6.0.\nEQUIVALENCY    MICR 229/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;18Lb;66P)\n']
    },
    'CISC 426': {
      EXCLUSION: ['No more than 3.0 units from CISC 426/3.0; SOFT 426/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 426',
      description:
        'Design and implementation of real-time embedded applications. Specifying timing properties: formal and semi-formal\nmethods; soft real-time versus hard real-time. Design notations; language constructs. Real-time operating systems. Abstract\ndevice interfaces.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Real-Time Systems',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 324/3.0 and CISC 327/3.0).\n'],
      'LEARNING HOURS': []
    },
    'GRMN 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 307',
      description:
        'Designed for students at the intermediate-advanced level. The course aims at developing communicative competence in\nthe fields of business, commerce, industry, and German in the workplace, with specific emphasis on approaches to\nintercultural communication. The course prepares students for the internationally recognized exam Zertifikat Deutsch f\u00fcr\nden Beruf. Students can write the exam on campus.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Business German II: German in the Workplace',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GNDS 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 432',
      description:
        'Examines critical theories and case studies of politics and governance in Indigenous and settler societies, based in Indigenous\nfeminist thought. Cases examine the relation between nationality, gender, and sexuality within colonial relations of rule,\nmethods of Indigenous governance, Indigenous sovereignty struggles, and theories and practices of decolonization. This course\ncontains an intensive and independent study component.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Settler Colonialism and Indigenous Politics',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['204 (36S;168P)\n']
    },
    'DEVS 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 311',
      description:
        'Explores the relationships between the production of goods, the lives and livelihoods of workers, and socio-economic\ndevelopment at local, national and global levels. Issues include: the international division of labour; global commodity\nchains; technological change; labour markets; informal sector; genders in production; unions and labour rights.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Labour and Global Development',
      units: '3.0',
      PREREQUISITE: ['DEVS 100/6.0 and DEVS 230/3.0.'],
      'LEARNING HOURS': []
    },
    'POLS 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 440',
      description:
        'An exploration of the causes of ethnic conflict, but focuses in particular on the strategies which states use to manage or\nresolve such conflicts. The review of state strategies is comprehensive in nature: using case studies, it includes approaches\nwhich are morally unacceptable as well as approaches which many consider morally desirable.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Politics of Ethnicity and Nationalism',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 410',
      description:
        'An examination of key issues in Canadian politics. Topics will vary from year to year; consult the departmental website for\nfurther details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Canadian Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (36S;12G;72P)\n']
    },
    'GPHY 101': {
      EXCLUSION: ['No more than 3.0 units from BISC 100/3.0; GPHY 101/3.0.'],
      RECOMMENDATION: [],
      code: 'GPHY 101',
      description:
        'Human Geography\nThe fundamentals of human geography including the meanings of place, the impacts of globalization, multiculturalism,\npopulation change and movement, environmental history and politics, cultural geography, issues of uneven resource\ndistribution, the role of colonialism in the modern shape of the world, agricultural geography, and urban geography.\n',
      NOTE: ['Field trip: estimated cost $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'MUSC 225': {
      EXCLUSION: ['No more than 6.0 units from MUSC 221/6.0; MUSC 225/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 225',
      description:
        'Students will perform in a public recital in accordance with guidelines established by the Dan School of Music.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\nCOREQUISITE    MUSC 220/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study II (Performance Recital)',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'LLCU 201': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 201/3.0; IDIS 201/6.0.\nEQUIVALENCY    IDIS 201/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 201',
      description:
        'This course aims at familiarizing students from diverse programs with some of the fundamental concepts of Romance\nPhilology. The analysis of the first literary and non-literary documents of the Romance languages will be a fundamental part\nof the course together with the understanding of the evolution of Latin into Vulgar Latin and its differentiation into\nRomance languages. Particular attention will be paid to Spanish, Italian, and French.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Romance Philology',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 272': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 272',
      description:
        'A survey of political, economic, and social developments in the United States from its colonial beginnings to the post-World\nWar II era.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'nited States, Colonial Era to Present',
      units: '6.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'CISC 121': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'Some programming experience (such as high-school level programming or CISC 101/3.0 or CISC 110/3.0);\nsee Introductory Courses in Departmental Notes.\nCOREQUISITE    CISC 102/3.0 or MATH 111/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 110/6.0 or MATH 112/3.0 or\nMATH 120/6.0 or MATH 123/3.0 or MATH 124/3.0 or MATH 126/6.0.'
      ],
      code: 'CISC 121',
      description:
        'Introduction to design and analysis of algorithms. Recursion, backtracking, and exits. Sequences, linked lists and references.\nBinary search trees. Elementary searching and sorting. Assertions and loop invariants. Order-of-magnitude\ncomplexity. Numerical computation. Documentation, testing and debugging.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Computing Science I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 202': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 202',
      description:
        'A survey of animals, their internal organization and their relationships to their environment. Organismal biology is discussed\nin a phylogenetic context and the evolution of organizational complexity and the relations between structure and function\nare stressed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Diversity of Life II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['117 (36L;33Lb;48P)']
    },
    'KNPE 446': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 446',
      description:
        'Building on the skills and knowledge acquired in KNPE 346/3.0, students will complete a Strength and Conditioning (SC)\ninternship with a varsity team. SC interns will be responsible for the design and implementation of training programs,\nfunctional screening, and athlete injury management. They will also assist with the Complete Athlete program and\ncontribute to the laboratory component of KNPE 345/3.0 as TAs.\n',
      NOTE: ['Valid First Aid/CPR Certification required.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Strength and Conditioning Internship',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan and KNPE 346/4.5 and (a GPA of 2.70) and\npermission of the course coordinator and the Undergraduate Chair in the School of Kinesiology and Health Studies.'
      ],
      'LEARNING HOURS': ['168 (120Pc;24G;24P)\n']
    },
    'POLS 469': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 469',
      description:
        'This course focuses on Canadian-American relations, emphasizing the interaction in both bilateral and multilateral contexts.\nPrimary concern with issues of trade, investment and resources, with some attention paid to security issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues in Canadian Foreign Policy',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 317': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 317',
      description:
        'Soils are a critical resource required by societies. Using a strong methodological approach, this course will examine the\nimportant biological, chemical, and physical properties of soils. The course will also explore critical soil-related issues facing\nsociety, including salinization, degradation from agriculture, climate change, and erosion.\n',
      NOTE: ['Field trips: estimated cost $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Soil, Environment and Society',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 208/3.0 or GPHY 209/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;36Lb;48P)\n']
    },
    'MUSC 124': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 124',
      description:
        'Private instrumental or vocal instruction for non-B.Mus. students. Auditions required.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Music',
      units: '6.0',
      PREREQUISITE: ['Permission of the School.'],
      'LEARNING HOURS': []
    },
    'MUSC 481': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 481',
      description:
        'A detailed examination of the life, times and works of a particular composer. Content varies from year to year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Composer Studies',
      units: '3.0',
      PREREQUISITE: [
        '([MUSC 293/3.0 or MUSC 291/6.0] and MUSC 103/3.0 and [MUSC 203/3.0 or MUSC 204/3.0 or MUSC\n205/3.0]) or permission of the School.'
      ],
      'LEARNING HOURS': ['127 (36L;91P)\n']
    },
    'KNPE 429': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 429',
      description:
        'The focus of this course is to develop an advanced understanding of cardiovascular and respiratory responses in meeting\noxygen demand of exercising skeletal muscle. Topics: oxygen delivery in exercising skeletal muscle metabolism/contraction;\ncompromised exercise performance in selected diseases; mechanisms of enhancement of exercise tolerance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Skeletal Muscle Oxygen Delivery: Demand Matching in Exercise',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a PHED Specialization or KINE Specialization Plan and KNPE 125/3.0 and KNPE 225/3.0\nand KNPE 227/3.0.'
      ],
      'LEARNING HOURS': ['132 (36L;12T;12O;72P)\n']
    },
    'GREK 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 430',
      description:
        'Detailed study of certain aspects of Greek Literature and history through directed readings and essay assignments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Course',
      units: '6.0',
      PREREQUISITE: [
        'A minimum GPA of 1.90 in 6.0 units from GREK at the 300-level.'
      ],
      'LEARNING HOURS': ['240 (24I;216P)\n']
    },
    'CHEM 313': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 313',
      description:
        'Elementary principles and applications of wave mechanics with special reference to molecular orbitals and chemical\nbonding.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after PHYS 344/3.0.\nEQUIVALENCY    CHEM 346/3.0.'
      ],
      title: 'Quantum Mechanics',
      units: '3.0',
      PREREQUISITE: [
        '(CHEM 211/3.0 or CHEM 222/3.0) and (MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and (MATH\n120/6.0 or MATH 121/6.0 or MATH 122/6.0 or [MATH 123/3.0 and MATH 124/3.0]) and (PHYS 104/6.0 or PHYS 106/6.0 or\nPHYS 117/6.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'ENGL 462': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 462',
      description:
        'Topics in Modern/Contemporary British Literature II\nFor detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PSYC 360': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 360',
      description:
        'The course will introduce students to: the physiology and neurobiology of sleep; methodology of sleep research; evolution\nand comparative aspects of sleep; discussion of potential functions of sleep; overview of sleep disorders.\n',
      NOTE: ['Students will spend two full nights in the Sleep Laboratory.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'The Neurobiology and Psychology of Sleep',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 271/3.0.'],
      'LEARNING HOURS': ['126 (18L;36Lb;12O:60P)\n']
    },
    'DRAM 314': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 314',
      description:
        'The development and performance of theatre conceived for audiences of young people. The course will begin with an\nexamination of examples of the genre and will culminate in a public performance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Young Peoples\u2019 Theatre Practicum',
      units: '3.0',
      PREREQUISITE: [
        'A grade of B- in DRAM 311/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ENSC 200': {
      EXCLUSION: [
        'No more than 3.0 units from ENSC 200/3.0; HIST 257/3.0.\nNSC 201/3.0\nEnvironmental Toxicology and Chemical Risks\nIntroduction to global issues and problems in environmental toxicology. Possible topics include waste disposal, pesticides,\nchemical warfare, pulp and paper mills and genetically modified foods. This course will be of interest to students with either\na science or a humanities background.\n'
      ],
      RECOMMENDATION: [],
      code: 'ENSC 200',
      description:
        'A history of the relations between humans and nature through time, with special emphasis on how science has influenced\nhow we perceive our place in nature, and how we define and understand environmental issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental History',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;84P)']
    },
    'PHYS 216': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 216',
      description:
        'Broad overview of basic laws of gravitation, radiation, and relativity: history and evolution of modern astronomy; ground\nand space based astronomy; the physics and evolution of stars; the milky way; galaxies in the universe; and cosmology. This\ncourse also uses the on campus observatory at an introductory level.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Astrophysics',
      units: '3.0',
      PREREQUISITE: [
        '(PHYS 104/6.0 or PHYS 106/6.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0), or permission of\nthe Department.'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 402',
      description:
        'Laboratory-based course emphasizing experimental approaches to understanding the principles of plant physiology covered\nin BIOL 341/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Experiments in Plant Physiology',
      units: '3.0',
      PREREQUISITE: [
        'A minimum GPA of 2.0 in the Biological Foundations List.\nCOREQUISITE    BIOL 341/3.0.'
      ],
      'LEARNING HOURS': ['114 (36Lb;24T;6O;48P)\n']
    },
    'GEOL 438': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 438',
      description:
        'Topics in Sedimentary and Petroleum Geology\nA course on a topic in the field of sedimentary geology, sedimentary geochemistry, basin analysis and/or petroleum\ngeology.\n',
      NOTE: [
        'Consult the Chair of Undergraduate Studies for details of specific course offerings each academic year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 or above in a GEOL Major, Medial or Specialization Plan.'
      ],
      'LEARNING HOURS': []
    },
    'JWST 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'JWST 502',
      description:
        'Directed reading on topics in Jewish Studies not covered in other courses available to the student.',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Reading in Jewish Studies II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ECON 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 421',
      description:
        'Topics in Macroeconomic Theory\nAn advanced discussion of selected topics in macroeconomic theory, policy, and evidence. Analysis uses: two-period\nmodels; linear, rational expectations models; overlapping generations models; and the neoclassical growth model. These\nmethods are applied to such topics as: asset-pricing; hyperinflation; exchange-rate overshooting; Ricardian equivalence;\ninternational evidence on sources of economic growth. Detailed reference is made to empirical evidence.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SPAN 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 352',
      description:
        'A survey of the major authors and works of Latin American literature from the beginning of the 20th century to the present.\nReadings will include texts from all genres and will illustrate the main cultural and historical trends and movements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Panorama literario latinoam\u00e9ricano II',
      units: '3.0',
      PREREQUISITE: ['SPAN 205/3.0 or SPAN 201/6.0.'],
      'LEARNING HOURS': []
    },
    'PHYS 491': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 491',
      description:
        'The objective of this course is the understanding of the fundamental physics associated with a nuclear reactor. Topics\ninclude a brief review of basic nuclear physics, neutron interactions and cross sections, neutron diffusion, neutron\nmoderation, theory of reactors, changes in reactivity, control of reactors. Offered in alternate years.\n',
      NOTE: ['Manual: estimated cost $15 to $25 per manual.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Physics of Nuclear Reactors',
      units: '3.0',
      PREREQUISITE: ['Level 3 or 4 in a PHYS, ASPH or MAPH Plan.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'POLS 369': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 369',
      description:
        'An analysis of Canadian foreign policy, its major objectives and orientations. Topics covered include Canada\u2019s role and\ninterests in major international organizations and its relations with key countries and regions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Foreign Policy',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BCHM 316': {
      EXCLUSION: ['No more than 3.0 units from BCHM 102/3.0; BCHM 316/3.0.\n'],
      RECOMMENDATION: [],
      code: 'BCHM 316',
      description:
        'Metabolism of carbohydrates, amino acids and lipids. Role of coenzymes. Generation and storage of metabolic energy.\nPrinciples of regulatory mechanisms, membrane structure and function, hormone action, and cellular signalling.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Metabolism',
      units: '3.0',
      PREREQUISITE: ['BCHM 315/3.0.\n'],
      'LEARNING HOURS': ['122 (36L;8O;78P)\n']
    },
    'CLST 305': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 305',
      description:
        'This survey of the material remains of early Italy will focus on the early Iron Age, Etruscan, and Roman (Regal and\nRepublican) cultures. Each culture\u2019s art, architecture, urban patterns, and burial practices will be investigated in terms of\nthe changing political and social conditions affecting those societies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology of the Etruscans and Early Romans',
      units: '3.0',
      PREREQUISITE: [
        '(CLST 102/3.0 and CLST 103/3.0) or CLST 129/6.0 or CLST 201/3.0 or CLST 101/6.0 or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'ENGL 489': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 489',
      description:
        'Studies focused on Modern and Contemporary literature that do not fit within the established Group III rubrics (British,\nCanadian, American, Postcolonial, Indigenous). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group III: Special Topics IV',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'RELS 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 502',
      description:
        'Reading courses on topics not covered in other available courses, arranged with individual members of the Department.\nRELS 502/3.0 may be taken independently or as a continuation of RELS 501/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the RELS Major Plan and permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 115': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 115',
      description:
        'Representative basic philosophical issues will be explored, such as: good and bad arguments, the source of moral\nobligation, the justification of knowledge claims, free will and determinism, the social enforcement of gender roles, taking\nresponsibility for the environment, and the meaning of life.\n',
      NOTE: [
        'Students considering a Major or Medial Plan in PHIL are strongly urged to take PHIL 111/6.0 or PHIL 115/6.0 in their\nfirst year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamental Questions',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (48L;24T;168P)']
    },
    'DRAM 219': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 219',
      description:
        'Special Studies I\nA seminar or practicum in selected areas of the curriculum.\n',
      NOTE: [
        'Not offered each year. Prerequisites vary depending on specific course content. See Department for details.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'ENGL 252': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 252',
      description: 'For detailed information, consult the department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Authors in Context: Special Topics II',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 314': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 314',
      description:
        'A study of how the human body is viewed in ancient medical theory and practice. Readings of ancient medical texts will\nexplore how the human body is constituted, how it relates to the world, what the role of the physician was seen to be in\nprevention and treatment of disease, and how illness and healing were understood in ancient Greece and Rome.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Doctor, Bloodletter, Surgeon: The Beginnings of Western Medicine',
      units: '3.0',
      PREREQUISITE: [
        'CLST 200/3.0 or CLST 201/3.0 or CLST 207/3.0 or CLST 208/3.0 or CLST 214/3.0.'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 345': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 345',
      description:
        'Advanced technical production studies involving sound, lighting, stage management, wardrobe, and carpentry. Students\nwill participate in major departmental technical projects.\n',
      NOTE: [
        'The normal classroom time of 36 hours is spread over two terms.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Technical Production',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and (a grade of B in DRAM 242/3.0)\nand DRAM 246/1.5.'
      ],
      'LEARNING HOURS': ['138 (18S;120P)\n']
    },
    'SPAN 112': {
      EXCLUSION: [
        'No more than 6.0 units from SPAN 111/3.0; SPAN 112/3.0; SPAN P10/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'SPAN 112',
      description:
        'The continuation of SPAN 111/3.0. Also for students entering the University who have some knowledge of Spanish but have\nnot completed 4U Spanish or equivalent. For these students an assessment exam or interview with an academic adviser is\nrequired before registration. Contact the Department of Languages, Literatures and Cultures for details.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after SPAN 201/6.0; SPAN 204/3.0; SPAN 205/3.0; SPAN 301/3.0; SPAN\n302/3.0; SPAN 303/3.0; SPAN 304/3.0; SPAN 401/3.0; SPAN 402/3.0.'
      ],
      title: 'Beginning Spanish II',
      units: '3.0',
      PREREQUISITE: ['A grade of C in SPAN 111/3.0 or SPAN P10/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;6O;78P)\n']
    },
    'GPHY 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 341',
      description:
        'An intensive introduction to the art and science of 3D measurement and mapping using photographs, with a particular\nfocus on applications in GIS, Cartography, Cultural Heritage, Urban Planning, Geology and Engineering.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Photogrammetry',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;36Lb;48P)\nEQUIVALENCY    CLST 351/3.0.\n']
    },
    'ECON 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 430',
      description:
        'An advanced course in economic history that explores a selection of topics debated in the literature. An emphasis is placed\non the use of economic analysis to deal with historical issues. The topics vary from year to year and usually concern mainly,\nbut not exclusively, North America. Offered concurrently with ECON 831/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues in Economic History',
      units: '3.0',
      PREREQUISITE: [
        '3.0 units from ECON 231/3.0; ECON 232/3.0; ECON 331/3.0; ECON 332/3.0.\nCOREQUISITE    ECON 310/3.0 and ECON 351/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BCHM 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 410',
      description:
        'This course presents an integrated approach to the study of protein function. Topics include proteomic techniques, mass\nspectrometry, protein purification, imaging, surface plasmon resonance, calorimetry, bioinformatics and protein evolution,\nprotein modifications and processing, interpretation and applications of 3-D structure, and structure-function relationships.\n',
      NOTE: [
        'Offered jointly with BMED 810/3.0. Students in a LISC or BMCO Plan should contact the Department regarding\nprerequisites and permission to register.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Protein Structure and Function',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Specialization or Major Plan) and [a GPA of 2.7 in BCHM 313/3.0, BCHM\n315/3.0, BCHM 316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['114 (30L;6S;6Lb;6Pc;12G;6I;6O;42P)\n']
    },
    'GPHY 250': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 250',
      description:
        'The Geography of Canada\nA regional examination of how economic, political, cultural, and environmental factors shape relationships between land and\npeople in Canada. Emphasis on geographical patterns of development and on the analytical and historical roots of public\npolicy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'DEVS 292': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 292',
      description:
        'Lectures and courses offered by regular and visiting faculty on development topics related to their research interests.\nConsult the departmental homepage for further details of specific course offerings each year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies I',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and registration in any DEVS Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ECON 361': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 361',
      description:
        'A review of theories of the principal determinants of the distribution of income and wealth including labour supply, life-\ncycle savings, ability and investment in human capital, discrimination, intergenerational transfer mechanisms. Also\nexamined are the distributional aspects of government tax transfer and social security programs.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Income Distribution and Problems of Inequality',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 445': {
      EXCLUSION: [
        'No more than 3.0 units from HLTH 493/3.0-001 (2014/15 and 2015/16); HLTH 445/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HLTH 445',
      description:
        'This course provides advanced study of the major theoretical and methodological approaches in critical health promotion.\nStudents will be primarily exposed to academic literature across several disciplines that engage with critical health\npromotion. Case studies of health promotion practice that illustrate critical perspectives will be discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Health Promotion',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a KINE Specialization Plan, PHED Specialization Plan, or HLTH Major or Medial\nPlan) and (HLTH 205/3.0 or HLTH 315/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36S; 84P)\n']
    },
    'PORT 104': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 102/3.0 (if taken between 2012-13 and 2014-15); PORT 104/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PORT 104',
      description:
        'Continuation of PORT 103/3.0. Basic communicative skills, vocabulary, and structures of the Portuguese language and the\nknowledge and understanding of the social, cultural, and historical contexts of Portugal and Brazil, and other Portuguese\nspeaking countries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Portuguese and Culture II',
      units: '3.0',
      PREREQUISITE: [
        'PORT 103/3.0 or LLCU 101/3.0 if taken between 2012-13 and 2014-15).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 216': {
      EXCLUSION: ['No more than 1 course from HIST 216/3.0; HIST 304/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 216',
      description:
        'The Civil War has been the defining moment in American history. This course examines the political, cultural and social\norigins of the conflict, experiences of the war itself for both soldiers and civilians, studies the unfinished revolution of\nReconstruction, and considers the legacy of the Civil War and Reconstruction in the contemporary US.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '.S. Civil War and Reconstruction',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MICR 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MICR 435',
      description:
        'An in-depth analysis of the genetics, biochemistry, assembly and function of the major structures of the procaryotic cell.\nEmphasis on the experimental approaches in the current literature.\n',
      NOTE: ['Offered in alternate years to MICR 436/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Procaryotic Structure and Function',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 205/3.0 and (MICR 221/3.0 or MICR 229/3.0 with a minimum grade of B-) and (Registration in the LISC\nMajor or Specialization Plan) and (a GPA of 2.5).\nCOREQUISITE    BCHM 310/9.0 or BCHM 315/3.0 or BIOL 334/3.0.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 286': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 286',
      description:
        'A study, from feminist perspectives, of women\u2019s roles in music and relation to music in popular and classical genres of\nvarious historic and contemporary traditions. Critical examination of the construct of gender and identity in several musics\nis included.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Women, Gender and Music',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36S;24O;60P)']
    },
    'DEVS 411': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 411',
      description:
        'Required for students who have successfully completed the course requirements for DEVS 410. The course will provide a\nforum for students to debrief and to critically examine their placement experience. Evaluation based on presentation,\nparticipation, journal synthesis and a final report.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after DEVS 420/3.0; DEVS 421/3.0.'
      ],
      title: 'Post-Placement Seminar in Development Studies',
      units: '3.0',
      PREREQUISITE: [
        'DEVS 410/6.0 and Level 3 or above and registration in the DEVS Major Plan and departmental approval in\nadvance from the Placement Coordinator, Global Development Studies.\n'
      ],
      'LEARNING HOURS': []
    },
    'PPEC 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PPEC 200',
      description:
        'This course will emphasize the analysis of conceptual complementarities, the assessment of arguments, and the application\nof principles in factual contexts that are the focus of study within the disciplines of Politics, Philosophy and Economics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to the Study of Politics, Philosophy and Economics',
      units: '3.0',
      PREREQUISITE: [
        '12.0 units from ECON 110/6.0; POLS 110/6.0; PHIL at the 100-level.'
      ],
      'LEARNING HOURS': ['120 (24L;12G;84P)\n']
    },
    'SPAN 381': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 381',
      description:
        'An introduction to the major authors and works of the literature of Spain from the Enlightenment to the present. Through\nstudy and analysis students will obtain a general understanding of the main cultural and historical and societal trends and\nmovements during these eras.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introducci\u00f3n: Literatura de Espa\u00f1a II',
      units: '3.0',
      PREREQUISITE: ['SPAN 201/6.0 or SPAN 205/3.0.'],
      'LEARNING HOURS': []
    },
    'HIST 242': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 242',
      description:
        'Lecture course on a selected historical issue. Subject changes from year to year; course is either being offered for the first\ntime or is being taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ssues in Canadian History',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 251': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 251',
      description: 'For detailed information, consult the department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Authors in Context: Special Topics I',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DEVS 493': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 493',
      description:
        'Topics in Development Studies II\nSeminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 803/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 293': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 293',
      description:
        'Introduces cultural studies from a primarily literary perspective, surveying critical approaches associated with this\ninterdisciplinary field of study, and paying special attention to the study of popular culture and questions of aesthetic value\nthrough readings drawn from a range of pop cultural genres (such as horror, romance, crime fiction).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Approaches to Cultural Studies',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 310',
      description:
        'An examination of the evolution of constitutional principles in Canada. Topics include developments in federal-provincial\nrelations, the role of the courts in federal-provincial disputes, and the nexus between the community values of federalism\nand the individual rights in the Canadian Charter of Rights and Freedoms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles of the Canadian Constitution',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 200',
      description:
        'An overview of principles of physical fitness and wellness with an emphasis on the planning and implementation of a\npersonalized physical fitness program.\n',
      NOTE: ['Not available to students in a KINE or PHED Plan.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after: KNPE 227/3.0 (formerly PHED 155/3.0); KNPE 255/3.0 (formerly\nPHED 255/3.0).'
      ],
      title: 'Physical Fitness and Wellness',
      units: '3.0',
      PREREQUISITE: ['Level 2.\n'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'PSYC 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 450',
      description:
        'Advanced Topics in Developmental Psychology\nTopics vary from year to year and may include prenatal factors in development, infancy, aging, adolescence, cultural\ndeprivation and intervention programs in early childhood, and developmental psychopathology.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['128 (18L;18S;25G;15O;52P)']
    },
    'DRAM 332': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 331/3.0; DRAM 332/3.0; DRAM 339/3.0; STSC 300/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 332',
      description:
        'Performing with Masks\nAn extension of core acting skills and an opportunity to develop an appreciation for performance through the medium of\nmask.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and a grade of B- in DRAM 237/3.0\nand (3.0 units from DRAM 238/3.0; DRAM 239/3.0; DRAM 273/3.0).\n'
      ],
      'LEARNING HOURS': ['108 (36G;36Pc;36P)\n']
    },
    'FREN 230': {
      EXCLUSION: [
        'No more than one course from FREN 230/3.0; FREN 220/6.0; FREN 221/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 230',
      description:
        'The methodology of literary analysis. Assignments may include textual analysis and dissertation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Analyse textuelle et \u00e9tude de la langue',
      units: '3.0',
      PREREQUISITE: [
        'FREN 150/6.0 or FREN 100/6.0 or (FREN 101/3.0 and FREN 102/3.0) or FREN 110/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (30L;6O;84P)\n']
    },
    'BCHM 313': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 313',
      description:
        'The application of physical chemistry to biological problems, with an emphasis on arithmetical and algebraic manipulation.\nTopics include enzyme kinetics, bioenergetics, centrifugation, radioactivity and spectroscopy.\n',
      NOTE: [
        'If you have taken or are currently registered in BCHM 310/9.0 you may contact the department for permission to\nenroll.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Physical Biochemistry',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and BCHM 315/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 541': {
      EXCLUSION: [
        'No more than 1 course from BIOL 537/12.0 and BIOL 541/12.0.'
      ],
      RECOMMENDATION: [],
      code: 'BIOL 541',
      description:
        'Individual research projects under the supervision of a staff member; reported in the form of a thesis, poster, and seminar.\n',
      NOTE: [
        'Students must select projects in consultation with potential supervisors a minimum of one full term in advance of\nstarting the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Research in Biotechnology',
      units: '12.0',
      PREREQUISITE: [
        'Admission to the final year of the BTEC program in Biology and a minimum GPA of 2.0 in the Biological\nFoundations List and permission of the project supervisor and course coordinator.\n'
      ],
      'LEARNING HOURS': ['446 (8L;18S;360Pc;60P)\n']
    },
    'DRAM 236': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 236',
      description:
        'An introduction to the principles and skills of preparing and delivering effective oral presentations. Using acting techniques\nand the principles of theatre, students will explore confidence building, vocal and physical dynamics as well as creative\nexpression.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Public Presentation',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['108 (36G;36Pc;36P)\n']
    },
    'SOCY 388': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 388',
      description:
        'Comparative examination of criminal justice system and its major institutions; Canadian research emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Criminal Justice',
      units: '3.0',
      PREREQUISITE: ['SOCY 275/3.0 or SOCY 274/6.0.'],
      'LEARNING HOURS': []
    },
    'LLCU 209': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 209',
      description:
        "This course goes beyond the typical representations of Rio de Janeiro to provide an understanding of the complex social,\npolitical, economic, and cultural history that have shaped the city's development and character. Focus is on the twentieth\ncentury, but provides the necessary historical background to understand the dynamics of life in Rio.\n",
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Rio de Janeiro: the Marvelous City',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['132 (48O;84P)\n']
    },
    'ARTH 419': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 419',
      description:
        'This seminar/practicum course for studio artists focuses on the distinctive intermedia methods found in performance art as\ndeveloped from the mid-1950s to the present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Performance Art Studies',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 222': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 222',
      description:
        'Impressionism and Post-Impressionism\nThis course offers a unique opportunity to study the art of Manet, Degas, Monet and Van Gogh, where many of the\npaintings studied will be viewed on gallery visits to London and Paris. Some of the classes will take place in the Mus\u00e9e\nD\u2019Orsay in Paris and the National Gallery and Courtauld Institute in London. Further classes at Herstmonceux Castle explore\ngender debates, the French nude and Paris as the fashionable centre of modernity.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 2 or above or permission of the Department.\nEQUIVALENCY    ARTH 322/3.0.'
      ],
      'LEARNING HOURS': ['129 (30L;6S;24T;18G;6I;12O;9Oc;24P)\n']
    },
    'BIOL 327': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 327',
      description:
        'Two weeks of field work plus written assignments in one or two areas of study to be done when specialized modules are\navailable in May, July, August or February. Studies may include ecology of birds, fish, insects, small mammals, plants, tundra\nand taiga, lakes and caves.\n',
      NOTE: [
        'Field trip: estimated cost of each module and the schedule of offerings for each year are available in January.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Biology III',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 307/3.0 and BIOL 317/3.0. Prior to registering in the course students must complete the application\nprocess, be placed in a module and complete the field work.'
      ],
      'LEARNING HOURS': []
    },
    'DEVS 340': {
      EXCLUSION: ['No more than 3.0 units from DEVS 340/3.0; POLS 346/3.0.'],
      RECOMMENDATION: [],
      code: 'DEVS 340',
      description:
        'Theories of Development\nProvides students with an overview of theories that underpin the development enterprise, and critiques of development,\nthrough the use of primary texts and critical appraisals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'DEVS 100/6.0 and DEVS 230/3.0 and DEVS 240/3.0. (DEVS 100/6.0 can be taken concurrently with DEVS\n230/3.0 or DEVS 240/3.0 in exceptional circumstances).\n'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 419': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 419',
      description:
        'A seminar or workshop in selected areas of the curriculum. Not offered every year. See Department for details.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Studies III',
      units: '3.0',
      PREREQUISITE: ['Level 4.'],
      'LEARNING HOURS': []
    },
    'ENGL 496': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 496',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Criticism and Theory I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUSC 183': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 183',
      description:
        'An introduction to the study of brass instruments through class instruction on trumpet, trombone, and euphonium.\nFundamental playing techniques and diagnostics will be emphasized. Includes the study of ranges, fingerings,\ntranspositions, basic instrument maintenance, method books and teaching techniques. Rental instruments available.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Brass Techniques and Methods I',
      units: '3.0',
      PREREQUISITE: ['(Registration in a BMUS or BMT Plan) or MUSC 104/3.0.'],
      'LEARNING HOURS': []
    },
    'CLST 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 430',
      description:
        'Detailed study of certain aspects of Greek and Roman literature, history or philosophy through directed readings and essay\nassignments. A short thesis may be required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Research Course',
      units: '6.0',
      PREREQUISITE: ['Permission of the Department.'],
      'LEARNING HOURS': ['240 (24I;216Oc)\n']
    },
    'GEOL 362': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 362',
      description:
        'Characterization of major ore deposit types using petrological, geochemical and geophysical engineering sciences. Tectonic\nsetting, age, rock composition, geometry, mineralogy and textures, geochemical and geophysical signatures. Metallogenic\nepochs and provinces. Design and evaluation of ore deposit models and exploration programs, including ore processing and\nenvironmental issues. Laboratory work integrates techniques of ore microscopy to determine paragenetic sequences,\nestimation of ore grade and evaluation of issues related to ore processing and site contamination.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Petrology Applied to Ore Deposits',
      units: '3.0',
      PREREQUISITE: ['GEOL 235/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['121 (33L;33Lb;55P)\n']
    },
    'BIOL 339': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 339',
      description:
        'Focus is placed on adaptive physiology and integrative function (nervous and hormonal, movement, excretion, circulation\nand digestion) with examples selected from various phylogenetic levels as appropriate.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Animal Physiology',
      units: '3.0',
      PREREQUISITE: ['BIOL 205/3.0 or BCHM 218/3.0.'],
      'LEARNING HOURS': ['120 (36L;18O;66P)\n']
    },
    'PHIL 406': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 406',
      description:
        'An examination of major issues in contemporary social and political philosophy. Possible topics to be studied include\ncommunitarianism, liberalism, multi-culturalism, the nation-state, and utopias.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Current Issues in Social and Political Philosophy II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 306',
      description:
        'A study of plays and performance in Canada, concentrating on works since the 1960s. Attention will be paid to experiments\nby companies and individual playwrights. Texts will be read in English.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Drama',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 261': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 261',
      description:
        'An analysis of the Canadian labour relations system in an economic setting. The socio-economic institutional framework of the\nindustrial and collective bargaining system in Canada provides the background for an analysis of some major emerging issues,\nsuch as white collar unionism, unions in the public sector, the public interest in emergency disputes, and the impact of\ntechnological change.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Labour Relations',
      units: '3.0',
      PREREQUISITE: [' ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;9G;75P)\n']
    },
    'STAT 263': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0; NURS\n323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM 162/3.0.\n'
      ],
      RECOMMENDATION: ['An Ontario 4U mathematics course or equivalent.\n'],
      code: 'STAT 263',
      description:
        'A basic course in statistical methods with the necessary probability included. Topics include probability models, random\nvariables, distributions, estimation, hypothesis testing, elementary nonparametric methods.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': ['May not be taken with or after STAT 269/3.0.'],
      title: 'Introduction to Statistics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 382': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 382',
      description:
        'Elementary mathematical material will be used to explore different ways of discovering results and mastering concepts.\nTopics will come from number theory, geometry, analysis, probability theory, and linear algebra. Much class time will be\nused for problem solving and presentations by students.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematical Explorations',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 221/3.0 or MATH 225/3.0 or MATH 231/3.0 or MATH 280/3.0 or MATH 232/3.0) and (MATH\n210/3.0 or MATH 211/6.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHYS 495': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 495',
      description:
        'Topics include: the production and measurement of X rays and charged particles for radiation therapy and nuclear\nmedicine; interactions of radiation with matter and biological materials; interaction coefficients and radiation dosimetry;\nradiation safety; physics of medical imaging with examples from nuclear medicine, ultrasound and magnetic resonance\nimaging.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Medical Physics',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or 4 and registration in an ASPH, MAPH, or PHYS Plan.'
      ],
      'LEARNING HOURS': []
    },
    'FILM 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 400',
      description:
        'An advanced course in developing expertise in research and critical writing concerning contemporary world cinema, media\narts, and other cultural phenomena.\n',
      NOTE: [
        'Students will be asked to view material and visit exhibitions outside of class time.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Film, Media, and Cultural Studies',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;12G;12Oc;36P)\n']
    },
    'DEVS 494': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 494',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 804/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies III',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 445',
      description:
        'An examination of the key ideas from a major figure in the history of philosophy. Philosophers studies will vary from\noffering to offering, including Aristotle, Aquinas, Kant, Mill and Rawls.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Major Figures I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300-level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'HIST 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 430',
      description:
        'An exploration of key topics in the history and interpretation of the Crusades, the society and culture of the Latin Kingdoms,\nand their impact on the peoples of the eastern Mediterranean, Muslim and Christian.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Crusades and the Latin Kingdoms',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'LATN 327': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 327',
      description:
        'Representative works of prose and poetry to illustrate various aspects of the history and culture of the period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medieval Latin',
      units: '6.0',
      PREREQUISITE: [
        'A grade of C- in LATN 209/6.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['264 (72L;192P)\n']
    },
    'CRSS 453': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CRSS 453',
      description:
        'An advanced organ systems approach to the physiological principles underlying cardiac function and oxygen delivery using\nlectures, seminars, and selected readings. Topics include mechanics and regulation of heart function as well as\nperturbations in cardiac function. Oxygen delivery and utilization will be examined at the levels of the lung, blood, and\ntissue. The responses to alterations in oxygen demand and/or supply will also be addressed. Obstructive sleep apnea will be\nused as a model of a pathological cardiorespiratory system interactions.\n',
      NOTE: ['Priority given to students in the CRSS Sub-Plan.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Principles in Cardiorespiratory Science I',
      units: '3.0',
      PREREQUISITE: [
        '(PHGY 214/6.0 or PHGY 212/6.0) and Level 4 and registration in a LISC Major or Specialization Plan and (a\nGPA of 2.5).'
      ],
      'LEARNING HOURS': []
    },
    'GEOL 478': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 478',
      description:
        'Principles of sequence stratigraphy. Depositional processes, facies models, and sequence stratigraphy of fluvial, coastal,\nshelf, and deep-marine environments. Introduction to analysis of sedimentary basins.\n',
      NOTE: [
        'This course may not be offered every year. Consult : http://www.queensu.ca/geol/courses for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Terrigenous Clastic Sedimentology',
      units: '3.0',
      PREREQUISITE: ['GEOL 238/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['130 (48L;10S;36Lb;36P)\n']
    },
    'KNPE 493': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 493',
      description:
        'Intensive coverage of topics which are of current and/or of special interest in the area of health enhancement, disease\nprevention and human performance. Offered periodically by visiting professors or members of faculty. Students should\ncheck with the School regarding availability of this course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Applied Exercise Science',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan.'
      ],
      'LEARNING HOURS': []
    },
    'CHEM 282': {
      EXCLUSION: [
        'No more than 3.0 units from CHEM 223/3.0; CHEM 282/3.0; CHEM 285/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 282',
      description:
        'A continuation from CHEM 281/3.0 intended for students in biological sciences, life sciences, and other programs taking no\nfurther courses in organic chemistry. Students in chemistry or biochemistry programs should not enrol in this course.\nOrganic molecules and their reactions; relevance to biological systems. Illustrations using biomolecules such as\ncarbohydrates, amino acids and proteins, lipids, and nucleic acids. The laboratory affords experience in elementary organic\nsyntheses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'General Organic Chemistry II',
      units: '3.0',
      PREREQUISITE: ['CHEM 112/6.0 and CHEM 281/3.0.\n'],
      'LEARNING HOURS': ['141 (36L;33Lb;12O;60P)\n']
    },
    'RELS 354': {
      EXCLUSION: [
        'No more than 6.0 units from RELS 255/3.0; RELS 354/3.0; RELS 353/6.0; RELS 355/3.0.\nRELS 368/3.0\nReligion and Business Ethics\nStudents will develop background knowledge and analytic skills necessary to identify and negotiate religious commitments\nin business relationships and resolve ethical issues around the role of religion in business contexts. We will analyze case\nstudies to explore various ways in which business practitioners can and do address questions arising in everyday\ninteractions in the business world.\n'
      ],
      RECOMMENDATION: [],
      code: 'RELS 354',
      description:
        'An introduction to major theoretical approaches to the study of religion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory in Religious Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and 6.0 units at the 200 level in RELS.\n',
        'Level 3 or above or 6.0 units at the 100 level in RELS.'
      ],
      'LEARNING HOURS': ['132 (36L;96P)\n', '132 (36L;96P)\n']
    },
    'FREN 112': {
      EXCLUSION: [
        'No more than 6.0 units from FREN P10/6.0; FREN P11/3.0; FREN P12/3.0; FREN 111/3.0; FREN 112/3.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'FREN 112',
      description:
        'Review of the French language in the North American context: written and oral exercises, compositions, short readings.\nEmphasis on grammar and vocabulary.\n',
      NOTE: ['Not available for credit towards any plan in FREN\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after FREN 118/3.0; FREN 150/6.0; FREN 219/3.0; FREN 320/3.0; FREN\n100/6.0; FREN 101/3.0; FREN 102/3.0; FREN 110/6.0.\nEQUIVALENCY    FREN P12/3.0.'
      ],
      title: 'R\u00e9vision de la grammaire II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 416': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 416',
      description:
        'Introduction to the basics of material history analysis focussing on the \u2018stuff\u2019 of everyday life in Canada, and how it has\nshaped Canadian identities and cultures since 1900. The main goal is to show students how artifacts can inform and enrich\nhistorical inquiry by integrating methodological frameworks from archaeology, anthropology, etc.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'aterial History in Canada',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (6L;30S;24O;120P)\n']
    },
    'MUSC 470': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 470',
      description:
        'Topics in Music Education I\nSeminars offered by faculty related to their music education research/interests. Content varies year to year. See\ndepartmental brochure for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['MUTH 387/3.0.'],
      'LEARNING HOURS': []
    },
    'GPHY 501': {
      EXCLUSION: [
        'No more than 1 course from GPHY 501/3.0; GPHY 502/3.0; GPHY 503/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 501',
      description:
        'Open to Level 4 students who have an average of A- or greater in those courses which form their concentration.  Special\nconsideration will be given to requests from students with an average of B or more in those courses which form their\nconcentration.  The student will arrange a program of study with a specific member of the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Studies in Geography',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and a (GPA of 3.50 in 24.0 units in GPHY) and (registration in a GPHY Major or Medial Plan or EGPY\nSpecialization Plan) and (consent of a supervising member of the Department) or by permission of the Departmental\nUndergraduate Committee.\n'
      ],
      'LEARNING HOURS': ['120 (24I;96P)\n']
    },
    'POLS 434': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 434',
      description:
        'This course explores the political implications of multiculturalism from a variety of perspectives, including theory, policy,\nand historical meaning. Issues include: history and policy of multiculturalism in the Canadian, US and global contexts; the\nconstruction of \u2018race\u2019 and anti-racism; and the role of multiculturalism in citizenship inclusion and exclusion.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Multiculturalism',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'FREN 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 502',
      description:
        'Recherches dirig\u00e9es II\nResearch in a particular area of French literature or language under the supervision of a professor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Permission of the Department and approval of the supervisor.\n'
      ],
      'LEARNING HOURS': ['120 (24I;96P)']
    },
    'PHYS 317': {
      EXCLUSION: [
        'No more than 1 course from MATH 228/3.0; MATH 326/3.0; PHYS 317/3.0; PHYS 312/6.0.\n'
      ],
      RECOMMENDATION: [],
      code: 'PHYS 317',
      description:
        'A continuation of PHYS 316/3.0. Partial differential equations, functions of a complex variable and contour integration, and\nspecial topics such as probability and statistics, group theory and non-linear dynamics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Methods in Mathematical Physics II',
      units: '3.0',
      PREREQUISITE: ['PHYS 316/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'POLS 382': {
      EXCLUSION: [
        ' No more than 6.0 units from GNDS 421/6.0; POLS 318/3.0; POLS 382/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'POLS 382',
      description:
        'This course explores feminist questions about the role of social policy in alleviating gender inequalities. Through an\nintersectional analysis of gender, race and class, this course examines how social policies address poverty, un/employment,\nimmigration and colonialism. Each student will explore one Canadian social policy in detail.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and Social Policy',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 110': {
      EXCLUSION: [
        'No more than 1 course from MATH 110/6.0; MATH 111/6.0; MATH 112/3.0.\n'
      ],
      RECOMMENDATION: ['At least one 4U mathematics course.\n'],
      code: 'MATH 110',
      description:
        'For students intending a medial or major concentration in Mathematics or Statistics. Provides a thorough introduction to\nlinear algebra up to and including eigenvalues and eigenvectors.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Linear Algebra',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['264 (72L;24T;168P)\n']
    },
    'FREN 343': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 343',
      description:
        'An introduction to the history of ideas and cultural evolution in French Canada, African and Caribbean culture and\nliterature, from the colonial period to the present day.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'Histoire culturelle et litt\u00e9raire de la francophonie et du Qu\u00e9bec',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GEOL 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 352',
      description:
        'Through lectures, seminars and assigned readings selected topics in mineralogy are explored. Emphasis on the current\nliterature and the details of mineralogical phenomena will lead to better understanding of petrologic systems.\n',
      NOTE: [
        'This course may not be offered every year. Consult: http://www.queensu.ca/geol/courses for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Mineralogy',
      units: '3.0',
      PREREQUISITE: ['GEOL 232/3.0 or GEOL 212/3.0.'],
      'LEARNING HOURS': ['120 (24L;36Lb;60P)\n']
    },
    'PHIL 367': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 367',
      description:
        'Jewish Philosophy\nAn examination of key Jewish thought from Philo to Fackenheim, exploring such themes as the relationship between\nphilosophy, literature, law, and religion; developments within Jewish philosophy; non-Jewish influences on Jewish thought\nand vice-versa. Contributions to contemporary philosophical work such as those in bioethics and postmodernism may also\nbe considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(6.0 units in PHIL or JWST) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 460': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 460',
      description:
        "Seminar that draws on students' previous work to enhance advanced research, production and writing for final project in\ncreative writing, criticism, journalism, production and/or curating and programming film, media, and digital culture.  Topics\nfrom theory, criticism, and history of film, media, digital culture, film festivals, media arts exhibitions and museums will be\naddressed to suit individuals. Examples from narrative, documentary, experimental film or digital media art will be\nanalyzed. Student projects will be published online and/or exhibited at the new Isabel Bader Centre for the Performing Arts.\n",
      NOTE: ['Open to FILM Major or Medial, STSC, and COCA students only.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Major Project',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['228 (36L;36G;36O;120Oc)\n']
    },
    'PSYC 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 442',
      description:
        'This course will examine a wide range of social cognitive topics (e.g., reasoning, decision making, attribution, language, self-\nconcept, cognitive styles, emotion, relationship and subjective well-being) from a cultural perspective by drawing on a wide\nrange of cross-cultural studies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Culture and Cognition',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 241/3.0.'],
      'LEARNING HOURS': ['114 (12L;24S;78P)\n']
    },
    'ENGL 369': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 369',
      description:
        'A study of prose fiction from the twentieth and twenty-first centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern and Contemporary Prose Fiction',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 328': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 328',
      description: 'A study of selected topics in ancient philosophy.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ancient Philosophy',
      units: '3.0',
      PREREQUISITE: [
        '(PHIL 250/6.0 or PHIL 257/6.0) or (6.0 units in PHIL and registration in a CLST Major or Medial Plan) or\npermission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 408': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 408',
      description:
        'An examination of major issues in the philosophy of law. Possible topics to be studied include definitional questions,\ninterpretivism, positivism, punishment and the relationship between law and morality.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in the Philosophy of Law Seminar',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 537': {
      EXCLUSION: [
        'No more than 1 course from BIOL 537/12.0 and BIOL 541/12.0.'
      ],
      RECOMMENDATION: [],
      code: 'BIOL 537',
      description:
        'Individual research projects under the supervision of a staff member; reported in the form of a thesis, poster and seminar.\n',
      NOTE: [
        'In the spring preceding fourth year, students must select projects in consultation with potential supervisors.\nRegistration is subject to availability of a supervisor. Work on the project during summer is advantageous if field studies are\nrequired. See also the statement on BIOL 501/3.0-BIOL 536/3.0 in the BIOL Department Information, preliminary\ninformation section.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Research in Biology',
      units: '12.0',
      PREREQUISITE: [
        'Admission to the final year of a BSCH program in Biology and a minimum GPA of 2.0 in the Biological\nFoundations List and permission of the project supervisor and course coordinator.\n'
      ],
      'LEARNING HOURS': []
    },
    'ECON 239': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 239',
      description:
        'A survey of the various economic theories and models elaborating the process of development. The course considers the\nmeaning of economic development; the fundamental analytics of economic growth; the barriers to growth; balanced and\nunbalanced strategies of growth; population, employment and technology problems; foreign-trade and foreign aid issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economic Development',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'HIST 280': {
      EXCLUSION: ['No more than 1 course from HIST 280/6.0; HIST 281/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 280',
      description:
        'A survey of the history of gender in North America. Examines topics such as patriarchy and the unequal status of women,\nmasculinity, racial and ethnic relations, and sexuality. Also considers the impact of gender on historical events and\nphenomena such as industrialization, class conflict, World War II and the Cold War.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'ender in North American History',
      units: '6.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['240 (72O;168P)\n']
    },
    'HLTH 434': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 434',
      description:
        'This course explores the proliferation of health social movements since the 1970s. Bringing together the interdisciplinary\nstudy of health and illness with social movement theory, the course analyses the strategies, goals, and outcomes of political\norganizing around conditions ranging from HIV/AIDS to sick building syndrome. Students will lead seminar discussions and\nundertake original research on a movement of their choice.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Social Movements in Health',
      units: '3.0',
      PREREQUISITE: ['HLTH 333/3.0 or HLTH 334/3.0 or DEVS 320/3.0.'],
      'LEARNING HOURS': ['120 (24S;12G;84P)\n']
    },
    'ECON 225': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 225',
      description:
        'The Economics of the European Union\nThis course will focus on two major topics: a) the process of economic integration towards a common market in Europe;\nand b) the coordination of macroeconomic policy within Europe, the operation of the European Monetary System and the\nmovement towards European Union.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['ECON 110/6.0 or ECON 112/3.0.'],
      'LEARNING HOURS': ['120 (36L;24Oc;60P)\n']
    },
    'GEOL 262': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 262',
      description:
        'The basic mineralogy and petrology of mineral deposits are examined. The formation and classification of mineral deposits,\nconsidering such aspects as tectonic setting, age, rock composition, geometry, and mineralogy are investigated. Emphasis is\nplaced on the processes by which mineral deposits are formed and transformed, and their influence on mining and\nproduction. Laboratory work integrates geological information from the scale of hand samples to regional maps as tools to\nassist with mine design, estimation of ore grade and evaluation of issues related to ore processing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after GEOL 232/3.0; GEOL 362/3.0.'
      ],
      title: 'Geological Aspects of Mineral Deposits',
      units: '3.0',
      PREREQUISITE: ['GEOL 104/3.0.\n'],
      'LEARNING HOURS': ['114 (36L;18Lb;60P)\n']
    },
    'ECON 243': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 243',
      description:
        'An economic analysis of modern health care institutions, organizations, and markets, both generically and in the Canadian\ncontext. A discussion of current Canadian health policy debates and various policy options and reform proposals.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Economics of Health Care',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;12G;12O;60P)\n']
    },
    'FILM 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 501',
      description:
        'Open to students completing an honours concentration in Film and Media, or Stage and Screen Studies. May be an essay or\na film or video project. Apply for FILM 500/6.0 or FILM 501/3.0, but not both, to the Undergraduate Coordinator by end of\nLevel 3.\n',
      NOTE: [
        'To use Film and Media video equipment the student must have completed FILM 250/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and 30.0 units in FILM or\npermission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'LLCU 249': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 249',
      description:
        'This course explores the emergence, development, and criticism of the Latin Lover figure in the West, from the creation of\nthe archetypical Don Juan in the 17th century to contemporary Hollywood representation of Italian and Latin-American\nlovers.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Latin Lovers: Love, Sex, and Popular Culture',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['114 (36O;78P)\n']
    },
    'PHYS 414': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 414',
      description:
        'Einstein\u2019s theory of gravity is developed from fundamental principles to a level which enables the student to read some of\nthe current literature. Includes an introduction to computer algebra, an essential element of a modern introduction to\nEinstein\u2019s theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to General Relativity',
      units: '3.0',
      PREREQUISITE: [
        'PHYS 321/3.0 and (MATH 334/3.0 or PHYS 317/3.0 or PHYS 312/6.0).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 205',
      description:
        'This course explores the interconnected nature of the Atlantic World between 1492 and 1860, and breaks away from\ntraditional emphases on the nation-state and other constructed boundaries. Topics will include migration, imperial rivalries,\nplantation economies, systems of labor, resistance, race, class, gender, religion and ideologies of revolution.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Atlantic World',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['136 (36L;4G;96P)\n']
    },
    'LLCU 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 303',
      description:
        'This course examines the main concepts of intercultural communication, identifies the obstacles for successful intercultural\ncommunication, and explores strategies for overcoming these barriers. Students apply their conceptual understanding as\nwell as their language skills to real-world situations as part of the applied portion of the course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Intercultural Communication',
      units: '3.0',
      PREREQUISITE: ['Level 3 and LLCU 111/3.0.'],
      'LEARNING HOURS': ['120 (24L;24Oc;72P)\n']
    },
    'HIST 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 456',
      description:
        'Thematic approach to the history of the Muslim world in a cross-cultural, trans-regional, and global perspective. Topics\nvary, and may include but are not limited to religion and state, gender, nomadism, migration and refugees, commodities\nand resources, war, diaspora.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'slam and Muslims in World History',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'KNPE 439': {
      EXCLUSION: [
        'No more than 3.0 units from KNPE 439/3.0 and KNPE 493/3.0 (Fall Term 2016-17).'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 439',
      description:
        'In this course students will read, evaluate and discuss recent scientific literature in the areas of exercise metabolism,\nexercise nutrition, and performance. Students will develop a systematic approach to scientific writing and write\ntranslational literature that accurately communicates recent scientific findings to the general population.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Appraisal and Translation of Muscle Physiology Research',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED Specialization or KINE Specialization Plan and KNPE 339/3.0.\n'
      ],
      'LEARNING HOURS': ['132 (36S;96P)\n']
    },
    'ENSC 290': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 290',
      description:
        'This course includes a combination of lectures, assignments and case studies that are designed to introduce students to the\necological critique of the standard neo-classical economic analysis of environmental degradation and depletion. Students\nwill also be asked to consider the more holistic approach to calculating the costs and benefits of economic activity proposed\nby ecological economists.\n',
      NOTE: [
        'This course may not be used towards the requirements of an ECON Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Ecological Economics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'ENGL 357': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 357',
      description:
        'A study of the relationship between literary texts and the burgeoning visual culture of the period. Representative visual\nforms might include book illustration and design, painting, photography, and commercial advertisement.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '19th-Century British Literature and Visual Culture',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'HIST 304': {
      EXCLUSION: ['No more than 1 course from HIST 304/6.0 or HIST 216/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 304',
      description:
        'Focus on the causes and consequences of the Civil War, slavery, antebellum social and political divisions, secession, the\nexperiences of soldiers and civilians during the war itself, reconstruction, and the place of the Civil War in US culture since\n1877.\n',
      NOTE: [
        'In Fall Term, HIST 304/6.0 meets in the same classroom as HIST 216/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'he Civil War and the Making of America',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (34.5L;36S;1.5T;168P)\n']
    },
    'FILM 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 304',
      description:
        'Creative Industries in the 21st Century\nStudents will study the creative industries in global context. Course includes theoretical readings, field trips, guest lectures,\nand creative assignments to understand contemporary creative economies.\n',
      NOTE: [
        'Students may be required to participate in a field trip in certain years. Estimated cost for bus and event admission is\n$70 plus accommodation and food. See departmental webpage for more information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Oc;48P)\n']
    },
    'ECON 255': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 255',
      description:
        'An introduction to the use of mathematics in economic analysis. The first part of the course will concentrate on techniques\nfor constrained and unconstrained optimization, as applied to problems of firm and consumer behaviour. This will lead to\nthe interpretation of Lagrange multipliers as shadow prices. The second part of the course will show how matrix algebra\nmay be used to study problems of production and allocation in interdependent economies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Mathematical Economics',
      units: '3.0',
      PREREQUISITE: [
        '(ECON 110/6.0 or [ECON 111/3.0 and ECON 112/3.0]) and (MATH 120/6.0 or MATH 121/6.0 or MATH\n122/6.0 or [MATH 123/3.0 and MATH 124/3.0] or MATH 126/6.0).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 498': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 498',
      description:
        'The goal of this seminar is to enable students pursuing the final year of a Major in French Studies to apply the methods and\ntheory acquired over the course of their program to a corpus of works not previously covered by their program. In a seminar\nframework, under the guidance of a professor, they will, as a group, present and discuss the fruits of their readings and the\nquestions raised by these readings. In addition, at the end of each of the two terms, they will write an exam designed to\nmeasure their ability to consider, both broadly and deeply, the texts they have read, to synthesize their reflections in a\ntheoretically coherent fashion, and to express their findings clearly and coherently.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'S\u00e9minaire de lecture',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and registration in a FREN Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['240 (36S;204P)\n']
    },
    'PSYC 241': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 241',
      description:
        'The study of the individual in the social context: Self and identity, social cognition, interpersonal behaviour (affiliation,\nattraction, sex, aggression, altruism); social attitudes, prejudice and discrimination; social influence and group processes\n(conformity, leadership and intergroup relations); applied social psychology.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Social Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': []
    },
    'DRAM 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 400',
      description:
        'A practicum course amalgamating a variety of aspects of theatre and drama.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Theatre',
      units: '9.0',
      PREREQUISITE: [
        'Level 4 and registration in a DRAM Major Plan and a GPA of 2.60.'
      ],
      'LEARNING HOURS': ['384 (144G;240P)\n']
    },
    'CISC 221': {
      EXCLUSION: [],
      RECOMMENDATION: ['CISC 220/3.0.\n'],
      code: 'CISC 221',
      description:
        'The descriptive levels of computer architecture. Instruction-set architectures. Assembly Language. Data representation.\nSupport for operating-system management and high-level languages. Input/output and interrupts. Designing for\nperformance. Digital Logic.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computer Architecture',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 124/3.0.'],
      'LEARNING HOURS': ['120 (12L;24G;84P)\n']
    },
    'DRAM 350': {
      EXCLUSION: ['No more than 1 course from DRAM 350/6.0; DRAM 351/3.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 350',
      description:
        'Continuation of DRAM 251/3.0. An intermediate study of playwriting and dramaturgy, including exercises in dramatic\ntechniques and composition of original works.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Playwriting III',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and a grade of B- in\nDRAM 251/3.0.\n'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'SOCY 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 421',
      description:
        'Instruction and practice in building and testing multiple regression and logistic regression models with sociological data.\nPotential utility of alternative models considered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Multivariate Statistical Applications',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 122': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 122',
      description:
        'A thematic introduction to world history from prehistoric times to the present, with particular emphasis on the changing\nbalance of power between regions of the globe and the contributions of the peoples of Africa, Asia, Oceania and the\nAmericas to modernity.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Making of the Modern World',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (48L;24S;24O;144P)']
    },
    'HIST 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 422',
      description:
        'An examination of the French Revolution and the historiographical debates it has engendered. Themes to be explored\ninclude revolutionary political culture, art and festivals, democracy and political representation, how the Revolution\naffected women, the Revolution in the countryside, Counterrevolution, the nature of the Terror, and revolution in the\ncolonies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he French Revolution',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'HIST 412': {
      EXCLUSION: [
        'No more than 4.5 units from HIST 400/4.5-001 (Fall 2016-17); HIST 400/4.5-002 (Fall 2015-16); HIST 400/4.5-\n003 (Fall 2013-14 and Winter 2014-15); HIST 396/4.5 (Fall 2011-12); HIST 412/4.5.'
      ],
      RECOMMENDATION: [],
      code: 'HIST 412',
      description:
        'A dialogue seminar on the geographical, historical, and cultural setting of the Land of Israel/Palestine; impact of foreign\npowers and ideas; its role in religious and political thought; nationalism; construction of narratives, competition for hegemony\nand territory; attempts to divide the land; the role of dialogue between Palestinians and Jews.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ne Land, Many Narratives, Israel/Palestine',
      units: '4.5',
      PREREQUISITE: [
        'A grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['180 (36S;36O;108P)\n']
    },
    'LLCU 248': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 248/3.0; SPAN 248/3.0.\nEQUIVALENCY    SPAN 248/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 248',
      description:
        'This survey course covers a vast area, several cultures, and many centuries. Students are expected to develop a general\nunderstanding of Spanish American culture through an examination of important historical, social, political, economic, and\nartistic developments in the area.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Spanish American Cultural Contexts',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 278': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 278',
      description:
        'A study of English-language literature emphasizing or relating to its sense of place. Course content may vary from year to\nyear.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and Place',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 446': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 446',
      description:
        'An examination of the key ideas from a major figure in the history of philosophy. Philosophers studied will vary from\noffering-to-offering, including Aristotle, Aquinas, Kant, Mill and Rawls.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Major Figures II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'LLCU 320': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 320/3.0; INTS 320/3.0; GRMN 420/3.0.\nEQUIVALENCY    INTS 320/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 320',
      description:
        'An introduction from a cultural perspective to the growth of the fascist mentality in Europe and the emergence of fascist\nregimes. The course will treat Italian Fascism and the Third Reich as part of the broader conservative and nationalist\nchallenge to liberalism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fascism in Europe from Napoleon to Hitler',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 414': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 414',
      description:
        'Politics in Quebec\nAn introduction to the political history of Quebec: the development of ideologies (including nationalism), constitutional\ndevelopments, and the building of the Quebec state during the Quiet Revolution. Some contemporary issues in Quebec\npolitics, and the relationship between Quebec and the rest of Canada.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 466': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 466',
      description:
        'An examination of the political dimensions of violent conflict in Africa, including the causes of inter-state and intra-state\nconflict, and responses such as peacebuilding and global governance initiatives.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Politics of War in Africa',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 426': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 426',
      description:
        'Consult the Department for possible offerings in any given year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Sociology II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'EPID 499': {
      EXCLUSION: [
        'No more than 12.0 units from ANAT 499/12.0; CANC 499/12.0; EPID 499/12.0; LISC 499/12.0; MICR 499/12.0;\nNSCI 499/12.0; PATH 499/12.0; PHAR 499/12.0; PHGY 499/12.0, MICR 455/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'EPID 499',
      description:
        'An examination of an epidemiological research question chosen by the student with guidance from the supervisor. Project\nwill involve review of the literature, development of a proposal, data collection and/or processing, data analysis, a written\nreport and oral presentation. Students will be required to attend and report on seminars of their choosing from a number\nof venues across campus. Limited enrolment.\n',
      NOTE: ['Acceptance by a supervisor required prior to registration.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Project in Epidemiology',
      units: '12.0',
      PREREQUISITE: [
        'Level 4 and registration in the LISC Specialization Plan and a GPA of 2.50 and (BMED 270/3.0 or EPID\n301/3.0 or HLTH 323/3.0).\n'
      ],
      'LEARNING HOURS': ['480 (288Lb;24G;24I;144P)\n']
    },
    'ENGL 274': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 274',
      description:
        'A study of texts that have war as their subject, examining the cultural functions war literature performs (such as recruiting,\ncelebrating, healing, mourning, witnessing, commemorating, protesting), as well as its role in the construction of collective\nmemory and national identity. The particular focus may vary from year to year; for detailed information, consult the\ndepartment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and War',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MOHK 101': {
      EXCLUSION: ['LLCU 101/3.0 (Topic: Mohawk I).'],
      RECOMMENDATION: [],
      code: 'MOHK 101',
      description:
        'An introduction to the language and culture of the Kanyen\u2019keh\u00e1:ka, the people of the Mohawk Nation. This course is\ndesigned for those who have neither been exposed to Kanyen\u2019k\u00e9ha, the Mohawk language, nor its traditional societal\npractices. Learn basic Mohawk language and gain a rich understanding of the Mohawk culture and tradition.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Mohawk Language and Culture I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 253': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 253',
      description:
        'An introduction to the skills required to improvise in the jazz style. Students will develop their ability to improvise by\nanalyzing, listening and performing repertoire from the Swing and Bebop eras.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Jazz Improvisation',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and registration in a BMUS or BMT Plan or permission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'HLTH 415': {
      EXCLUSION: ['No more than one course from BMED 471/3.0; HLTH 415/6.0.'],
      RECOMMENDATION: [],
      code: 'HLTH 415',
      description:
        'An examination and application of the principles of program planning in a variety of settings. Topics will include needs\nassessment, intervention design and implementation, and evaluation. Students will develop a program plan. The application of\nselected program design models will serve as a basis for the course.\n',
      NOTE: [
        'In special circumstances, HLTH 315/3.0 may be taken concurrently with HLTH 415/6.0 in one\u2019s final year of the HLTH\nMajor Plan. Permission of the Undergraduate Chair in the School of Kinesiology and Health Studies is required.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Program Design and Evaluation',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and registration in a PHED, KINE, HLTH Major or Medial Plan and (HLTH 252/3.0 and HLTH 315/3.0).\n'
      ],
      'LEARNING HOURS': ['264 (36L;92Pc;36G;100P)\n']
    },
    'FILM 435': {
      EXCLUSION: [
        'No more than one course from FILM 400/3.0-003 (2014 onward); FILM 435/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FILM 435',
      description:
        'Advanced seminar on relations between societies and their expression in culture, with particular reference to film, television,\nand comparable media. Subjects have included interdisciplinary approaches and cultural studies; cinema in the Third World.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Culture and Representation: Special Topic',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'SOCY 428': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 428',
      description:
        'Selected Topics in Sociology IV\nConsult the Department for possible offerings in any given year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'PPEC 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PPEC 400',
      description:
        'Politics, Philosophy and Economics approach problems from discipline specific perspectives, but the questions asked have\nfundamental similarities. In this course students will be exposed to research methods from all three different disciplines,\nwhile completing a research intensive project. Peer review and presentation skills will be emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Research Seminar in Politics, Philosophy and Economics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the PPEC Specialization Plan and a minimum Plan GPA of 2.60 and permission of\nthe Department.'
      ],
      'LEARNING HOURS': ['120 (12L;12S;12G;84P)\n']
    },
    'POLS 336': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 336',
      description:
        'Contemporary problems facing Britain as a result of its historical evolution: economic stagnation, centrifugal forces of\nnationalism and communal violence, and the decline of the two-party system.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'British Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 276': {
      EXCLUSION: [
        'No more than 6.0 units from SOCY 275/3.0; SOCY 276/3.0; SOCY 274/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 276',
      description:
        'This course examines a variety of substantive topics in the sociology of deviance. The choice of topics will illustrate the\nrange of theoretical approaches discussed in SOCY 275/3.0. The selection of topics will vary from semester to semester but\nwill typically include violence, corporate crime, sexual deviance, and physical stigma.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Substantive Issues in Social Deviance',
      units: '3.0',
      PREREQUISITE: ['SOCY 275/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 446': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 446',
      description:
        'Advanced study of an aspect of organization in 20th-century music through analysis of the repertoire and analytical\nreadings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Analysis of 20th-Century Music',
      units: '3.0',
      PREREQUISITE: ['MUSC 392/3.0 or permission of the School.'],
      'LEARNING HOURS': ['126 (36S;12O;78P)\n']
    },
    'PHIL 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 335',
      description: 'An examination of the Critique of Pure Reason.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Kant',
      units: '3.0',
      PREREQUISITE: ['PHIL 250/6.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 250': {
      EXCLUSION: ['No more than 6.0 units from PHIL 253/6.0; POLS 250/6.0.'],
      RECOMMENDATION: [],
      code: 'POLS 250',
      description:
        'A survey of the principal ideas of Western political theorists from ancient to modern times, focusing in particular on the role\nand scope of government; the proper organization of governmental power; the nature of political obligation; and the ethics\nof political power and authority. Offered annually.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Theory',
      units: '6.0',
      PREREQUISITE: ['POLS 110/6.0.\n'],
      'LEARNING HOURS': []
    },
    'BIOL 532': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 532',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Biology I',
      units: '3.0',
      PREREQUISITE: ['To be announced.\n'],
      'LEARNING HOURS': ['120 (9L;9S;18G;84P)\n']
    },
    'FILM 360': {
      EXCLUSION: ['No more than one course from FILM 355/6.0; FILM 360/3.0.'],
      RECOMMENDATION: [],
      code: 'FILM 360',
      description:
        'Intermediate critical and historical study in non-fiction film and television, based on selected examples from Canada,\nincluding productions of the National Film Board and the CBC, and international documentary cinemas.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Documentary Tradition',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.\n'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'HIST 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 352',
      description:
        'This course examines Northeast African social, political and economic history since the mid-19th century. Topics include:\nbirth of modern nation states in the region, onset of European colonialism, regional and international rivalry due to the\nregion\u2019s global geostrategic significance, independence, post-independence challenges and opportunities.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ortheast Africa from 1850s',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'PHIL 471': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 471',
      description:
        'Current Issues in Medical Epistemology\nAn examination of epistemic issues arising from or pertaining to medicine. Possible topics to be considered include the\nnature of disease, concepts of scientific discovery as found in medicine, and the relationship between medical research and\nclinical practice.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'PSYC 433': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 433',
      description:
        'Human Sexual Function and Dysfunction\nThis course will provide students with an overview of common sexual dysfunctions, including prevalence, clinical\npresentation, and comorbid diagnoses. Particular attention will be paid to assessment and treatment (both therapy and\nmedical management) in sexual dysfunction; in addition, past and current research strategies will be presented and\ncritiqued, with an emphasis on classification difficulties.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['PSYC 203/3.0 and (PSYC 235/6.0 or PSYC 236/3.0).'],
      'LEARNING HOURS': []
    },
    'PHIL 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 240',
      description:
        'An examination of key issues and texts in the philosophy of education. Possible topics include the nature and aims of the\nlearning process, progressive and conservative education, the politics of education, and contemporary debates regarding\nthe canon.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Education',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 433': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 433',
      description:
        'An advanced survey of how power and authority were understood, exercised, and challenged in Canada before 1896.\nTopics include political cultures and ideologies, tools of governance such as the law and schools, popular political\nparticipation and protest, nationalism, citizenship, and the emergence of the modern, liberal state.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ower, Authority and the State in Early Canada',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;24O;264P)\n']
    },
    'A course providing 1) the essentials in cellular and molecular neuroscience to pursue a graduate program and': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code:
        'A course providing 1) the essentials in cellular and molecular neuroscience to pursue a graduate program and',
      description:
        'neuroscience or related field, and 2) independent learning and communication skills applicable broadly. The course is\ndivided into three segments: 1) neuronal integration, 2) synaptic plasticity, and 3) neuromodulation.\n',
      NOTE: [
        'BMCO students should contact the Department regarding prerequisites.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Cellular and Molecular Neuroscience',
      PREREQUISITE: [
        'Level 4 and registration in the LISC Major or Specialization Plan and a GPA of 2.5 and a minimum grade of B\nin NSCI 323/3.0.'
      ],
      'LEARNING HOURS': ['119 (12L;24S;8G;6I;69P)\n']
    },
    'ARTH 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 451',
      description:
        'Explores Caravaggio, Artemisia Gentileschi and contemporaries in Baroque Italy. Considers issues such as\nnaturalism/idealism, patronage, populist piety, gender. One of the goals is to look at the ways in which these artists\u2019\npersonalities have been projected onto their work by scholars, essayists, novelists, and filmmakers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Caravaggio and Artemisia',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ECON 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 452',
      description:
        'Emphasizes problems in specifying and estimating econometric models, methods available for detecting and handling these\nproblems, and economic applications. Extensive use of matrix algebra.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Econometrics',
      units: '3.0',
      PREREQUISITE: ['ECON 255/3.0 and (ECON 351/3.0 or STAT 361/3.0).'],
      'LEARNING HOURS': ['120 (36L;12G;72P)\n']
    },
    'MUSC 129': {
      EXCLUSION: ['No more than 3.0 units from; MUSC 129/3.0; MUSC 128/3.0.'],
      RECOMMENDATION: ['MUSC 191/6.0.\n'],
      code: 'MUSC 129',
      description:
        'A fundamental keyboard skills course designed for non-keyboard majors.\n',
      NOTE: [
        'Course content will support and coordinate with the traditional diatonic harmonic material covered in MUSC 191\nbut will also include other styles. Successful completion of the course will require a working fluency at the keyboard in\nsight-reading, melodic and harmonic analysis as well as transcription. Activities will include harmonization, transposition\nand improvisation.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Keyboard Skills',
      units: '3.0',
      PREREQUISITE: [
        'Registration in the B.Mus. or B.M.T. Plan or permission of the School.\n'
      ],
      'LEARNING HOURS': ['120 (24Lb;96P)\n']
    },
    'PSYC 251': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 251',
      description:
        'Introduction to the scientific study of human development, as well as the fundamental theories, methods and applications\nin the field of developmental psychology. A major focus of this course is the social, cognitive, and neurobiological processes\nthat underlie perceptual, cognitive, and emotional development from conception to adolescence.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Developmental Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': ['120 (12L;18T;36O;48P)\n']
    },
    'ASTR 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ASTR 101',
      description:
        'A non-mathematical introduction to the science of astronomy for non-specialist students. Topics to be covered include the\nfundamentals of astronomy; and introduction to the tools and techniques of modern observational astronomy; the\nhistorical development of our understanding of the Earth, Moon, and Solar System; space exploration of Mars, Jupiter, and\nother planets; the nature of the Sun; and the origin and uniqueness of our Solar System.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Astronomy I: The Solar System',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;24O;60P)\nEQUIVALENCY    PHYS P15/3.0.']
    },
    'ARTH 336': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 336',
      description:
        'An examination of selected visual representations of the British landscape, from 18th-century paintings to recent\ndevelopments in a variety of media such as sculpture and earthworks. Issues of national identity, collecting and exhibiting\nwill be addressed.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'British Landscape Art',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'PHYS 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 315',
      description:
        'Physical Processes in Astrophysics\nThis course relates observable quantities to the physical properties of astronomical sources thereby deciphering the varied\nnature of the cosmos. Basic physical processes in astrophysics are discussed and applied to diverse systems including\nplanets, stars, the interstellar medium and distant galaxies. Topics include radiative transfer and the perturbation of the\nsignal by instruments, the atmosphere, and the interstellar medium. The main astrophysical emission processes, both\ncontinuum and line, are also presented. An evening project using the on campus observatory will be carried out during the\nterm.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'PHYS 216/3.0 and PHYS 242/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 330',
      description:
        'Course on a selected historical topic, with a significant field component. Topics change from year to year. Consult\ndepartment website for details.\n',
      NOTE: [
        'Also offered in the Queen\u2019s-Blyth International Studies program\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in History',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a HIST Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['114 (18L;18Lb;18T;60P)\n']
    },
    'HIST 324': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 324',
      description:
        'Race relations and immigration in North American history, with emphasis on Canada from the 1840s to the 1980s. Covers\nnative-non-native contact, European immigrants, migration of blacks from the U.S. south, ethnic radicalism, Asian\nimmigration, Japanese internment, immigration policy, \u2018multiculturalism,\u2019 and changing definitions of \u2018race\u2019.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ace and Immigration in North America',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'CRSS 454': {
      EXCLUSION: [
        'No more than 3.0 units from CRSS 454/3.0 and LISC 454/3.0.\nEQUIVALENCY    LISC 454/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CRSS 454',
      description:
        'A study of the physiology, pharmacology and anatomy of the cardiovascular system. Topics include integrative mechanisms\nof control and pharmacotherapy involved in short-term and long-term control of the circulation in health and disease.\n',
      NOTE: [
        'Assessment involves essay-style exams, student seminar presentations and a group research project (final oral\npresentation).\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Cardiovascular Sciences',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in the LISC Major or Specialization Plan) and (a GPA of 2.5) or permission of the\ncourse coordinator.\n'
      ],
      'LEARNING HOURS': ['138 (18L;10S;10G;100P)\n']
    },
    'FREN 325': {
      EXCLUSION: ['No more than 3.0 units from FREN 325/3.0; FREN 425/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 325',
      description:
        'A seminar on avant-garde and post-modern works in which students will be asked to examine traditional literary\nconventions of representation, particularly those established over the course of the 19th century. Class discussion will then\nshift to avant-garde and post-modern works that question such conventions and also address issues pertaining to the limits\nof representation. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Litt\u00e9rature contemporaine',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (33L;3Pc;84P)\n']
    },
    'ENGL 238': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 238',
      description:
        'Comics and Graphic Novels\nA study of the art of graphic narrative from newspaper strips of the Golden Age to current graphic novels, comprising\nhistory, aesthetics, and close reading of graphic narrative as a form of literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 442',
      description:
        'This seminar focuses on historical and contemporary critical writing to explore historical and contemporary perspectives on\nthe nature, theory, and practice of photography. It is a course about ideas rather than images - ideas about photographs,\nabout looking at photographs, and about reading photographs - ideas that have governed the way we look at, respond to,\nand draw meaning from photographs.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Critical Writing on Photography: Meaning and Practice',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': []
    },
    'CISC 271': {
      EXCLUSION: [
        'No more than 3.0 units from CISC 271/3.0; MATH 272/3.0; PHYS 313/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CISC 271',
      description:
        'Scientific Computing\nIntroduction to scientific computing: algorithm design, error analysis, ill-conditioning. Linear equations. Least-squares\nfitting. Non-linear equations. Effective use of library programs, with discussion of their limitations and some aspects of their\ndesign and implementation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'C- in {[CISC 101/3.0 or CISC 121/3.0] and [MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0] and [MATH\n120/6.0 or MATH 121/6.0 or MATH 122/6.0 or (MATH 123/3.0 and MATH 124/3.0) or MATH 126/6.0]}.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 208': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 208',
      description:
        'Explores the structure of, and physical processes responsible for the development of landforms and soils. Understanding\nthese systems is directly relevant to environmental planning, hazard and risk assessment, geology, and surface processes on\nother planets. Topics include weathering, volcanic, tectonic, mass wasting, glacial, and fluvial processes.\n',
      NOTE: ['Field trip: estimated cost $25.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Surface Processes, Landforms, and Soils',
      units: '3.0',
      PREREQUISITE: ['GPHY 102/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;36Lb;48P)\n']
    },
    'PSYC 353': {
      EXCLUSION: [
        'No more than 3.0 units from PSYC 353/3.0; PSYC 350/3.0 (2015-16; 2016-17).'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 353',
      description:
        'This course will begin by defining atypical development and discuss how gaining better understanding of atypical\ndevelopment allows us to understand typical development, and vice versa. We will cover six disorders in greater detail:\nLanguage Disorders, Dyslexia, Down Syndrome, Williams Syndrome, Attention-Deficit/Hyperactivity Disorder and Autism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Atypical Development',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '127 (36L;91P)\nEQUIVALENCY    PSYC 457/3.0.\nPREREQUISTE    PSYC 203/3.0 and PSYC 251/3.0.\n'
      ]
    },
    'HIST 273': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 273',
      description:
        'A survey of the \u2018New Imperialism\u2019 of the late 19th and 20th centuries. The course examines the origins and course of\nEuropean expansion in Africa and Asia, justifications for and theories of empire, and the 20th century decolonization\nprocess. It will conclude with reflection on the New Imperialism from the vantage point of \u2018globalization\u2019.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ew Imperialism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HLTH 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 333',
      description:
        'An investigation of current influences on sexual health. Issues will be considered from social, political, and historical\nperspectives. Topics which may be covered include sex education; lesbian, gay, bisexual, and transgender issues; sexual\nhuman rights; sexuality and war; HIV/AIDS; the history of marriage; and sexual violence.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Issues in Human Sexuality',
      units: '3.0',
      PREREQUISITE: ['Level 3 and registration in a PHED, KINE, or HLTH Plan.'],
      'LEARNING HOURS': ['120 (24L;12T;12G;72P)\n']
    },
    'HIST 258': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 258',
      description:
        'Examines the history of slavery in the United States and Canada from the colonial era to the mid nineteenth-century.\nVarious approaches will be emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'lavery in North America from the Colonial Era to 1865',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 209': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 209',
      description:
        'An interdisciplinary course in which the Canadian nation state will be examined from a geographic, historical, political,\ncultural and economic perspective, with particular attention being paid to ethnic and racial relations, national identity and\ncultural icons.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ntroduction to Themes in Canadian History II',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 211': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 211',
      description:
        'Introduction to the literature of Britain and Western Europe from the tenth to the fifteenth centuries. Non-English works\nare read in translation; some training in Middle English is provided. Readings may include romance, troubadour poetry,\nhistory and pseudo history, drama, women\u2019s writing, and authors such as Dante, Boccaccio, and Chaucer.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medieval European Literature',
      units: '6.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a MDVL Minor Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'BCHM 218': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 218',
      description:
        'Molecules and macromolecules that participate in the replication and expression of genes. Current methods for exploring\nthe structure, function, and manipulation of genetic material.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Molecular Biology',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and [(BIOL 102/3.0 and CHEM 112/6.0) or (CHEM 114/3.0 and PHGY 170/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\nEQUIVALENCY    MBIO 218/3.0.\n']
    },
    'MUSC 394': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 394',
      description:
        'Study, through analysis, of contrapuntal procedures and styles, from the earliest use of counterpoint through to\ncontemporary contrapuntal compositions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contrapuntal Analysis',
      units: '3.0',
      PREREQUISITE: [
        'MUSC 293/3.0 or MUSC 291/6.0 or permission of the School.'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'GRMN 433': {
      EXCLUSION: [
        'No more than 3.0 units from INTS 322/3.0; GRMN 433/3.0; LLCU 322/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GRMN 433',
      description:
        'An examination of international discourses on conflict and resolution, including theories of reconciliation, human rights,\nand international law, as portrayed in various media (fiction, theatre and film) and diverse cultural contexts (e.g. ancient\nGreece, Germany, South Africa and Canada).\n',
      NOTE: [
        'Taught in English together with LLCU 322/3.0. Students in a GRMN Plan will submit written assignments, tests, and\nexaminations in German.  Normally, they will read German texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Conflict and Culture: Literature, Law and Human Rights',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 484': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 484',
      description:
        'An exploration of topics in the social, cultural, political and economic history of Ireland from the Rising of 1798 onwards.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Irish History, 1798 to the Present',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 3.0 units from HIST 300-329; a GPA of 3.30 in all history courses; and registration in a HIST\nMajor or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MUSC 355': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 355',
      description:
        'Guidance in the development of the student as a composer of electroacoustic music.\n',
      NOTE: [
        'Students must submit in writing to the Music Office their request to apply for this course by the last day of classes\nin the Winter Term.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Electroacoustic Composition',
      units: '6.0',
      PREREQUISITE: ['MUSC 255/6.0 and permission of the School.'],
      'LEARNING HOURS': []
    },
    'KNPE 354': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 354',
      description:
        'An introduction to occupational biomechanics and physical ergonomics. The course will apply principles of biomechanics to\ndescribe relationships between job demands, functional/tissue capacities and work-related injury. Demand, capacity and\ninjury risk evaluation tools will also be presented.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Occupational Biomechanics and Physical Ergonomics',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a KINE or PHED Plan and KNPE 254/3.0.\nEQUIVALENCY    KNPE 253/3.0'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FRST 290': {
      EXCLUSION: [
        'No more than 3.0 units from FREN 392/3.0; FRST 290/3.0; FREN 290/3.0; IDIS 290/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FRST 290',
      description:
        'Students will explore Paris through the different perspectives offered by writers, filmmakers, painters, photographers, and\nother artists who have played an important role in significant literary and artistic trends and movements. The course covers\nliterature, painting, and film starting at the end of the 19th century and extends to the present.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Paris Through Literature, Painting, Cinema, and Photography',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': [
        '120 (48O;72P)\nEQUIVALENCY    FREN 290/3.0; IDIS 290/3.0.\n'
      ]
    },
    'ENGL 491': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 491',
      description:
        'Studies in literary topics that cross over the historical boundaries between Groups I, II and III. For detailed information,\nconsult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Interpretation I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'GPHY 318': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 318',
      description:
        'An examination of the distributions of plants and animals on global, regional and local scales, their causes and significance.\n',
      NOTE: ['Field trip: estimated cost $25.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Biogeography',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (GPHY 207/3.0 or [BIOL 201/3.0 and BIOL 202/3.0]), or permission of the Department.'
      ],
      'LEARNING HOURS': ['116 (36L;8Oc;72P)\n']
    },
    'SPAN 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 303',
      description:
        'Intensive practice in advanced grammar with a focus on Spanish for business, technical, administrative and related cultural\npurposes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Espa\u00f1ol para contextos profesionales I',
      units: '3.0',
      PREREQUISITE: ['SPAN 201/6.0 or SPAN 205/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DEVS 496': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 496',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 806/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies V',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'ECON 280': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 280',
      description:
        'An examination of the interrelationships between changes in the size, composition and distribution of population and\nchanges in the economy. Application is made of some elementary concepts of economic theory and some basic techniques\nof demographic analysis are introduced. Illustrations are drawn from both the Canadian and the international settings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Population and Economic Change',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (12L;24G;36O;48P)\n']
    },
    'HIST 479': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 479',
      description:
        'An exploration of the history of the theory and practice of development with particular reference to Tropical Africa.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Theory and Practice of Development',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'PSYC 380': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 380',
      description:
        'Advanced Perception\nThis advanced course in visual and auditory perception will integrate findings from neuroanatomy and physiology with\npsychophysics, perception, and behavior. Information processing will be traced from sensory structures through to motor\noutput and communicative behaviour. The course will introduce you to psychophysical and neurophysical methodology and\nwill contain many demonstrations and hands-on experiments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 215/3.0.'],
      'LEARNING HOURS': []
    },
    'DEVS 497': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 497',
      description:
        'Seminars offered by regular and visiting faculty on development topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each year.\n',
      NOTE: ['Taught concurrently with DEVS 807/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Development Studies VI',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in the DEVS Major or Medial Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'POLS 510': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 510',
      description:
        'Students arrange their course of reading in consultation with members of the Department. They are expected to write\nreports on their readings and to discuss them in seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['240 (15I;225P)\n']
    },
    'MUSC 293': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 291/6.0; MUSC 292/3.0; MUSC 293/3.0\nEQUIVALENCY    MUSC 291/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 293',
      description:
        'Chromatic voice-leading and harmony, large-scale and expanded formal structures, including sonata, rondo, and expanded\n19th-century forms, through part-writing and analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theory and Analysis IIB',
      units: '3.0',
      PREREQUISITE: ['MUSC 292/3.0.\n'],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'ARTH 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 341',
      description:
        'An introduction to the processes, practices and histories of photography; the changing topics address its interpretation and\napplication since the 1840s.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Photography and Society',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['126 (24L;12G;90P)\n']
    },
    'MATH 434': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 434',
      description:
        'Theory of convex sets and functions; separation theorems; primal-duel properties; geometric treatment of optimization\nproblems; algorithmic procedures for solving constrained optimization programs; engineering and economic applications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Optimization Theory and Applications',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 212/3.0) and MATH 281/3.0.'
      ],
      'LEARNING HOURS': []
    },
    'CHEM 499': {
      EXCLUSION: [
        'No more than 6.0 units from CHEM 497/6.0; CHEM 498/3.0; CHEM 499/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CHEM 499',
      description:
        'Research Project II\nA Winter Term research project on a topic in chemistry, supervised by a member of staff. Normally limited to students in\nthe final year of a major or subject of specialization in Chemistry. Additional restrictions may apply.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (108Lb;12P)\n']
    },
    'SOCY 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 422',
      description:
        'Examination of social implications of communication and information technology in the context of sociological theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Studies in Communication and Information Technology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUSC 455': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 455',
      description: 'A continuation of MUSC 352/3.0, MUSC 355/6.0.\n',
      NOTE: [
        'Students must submit in writing to the Music Office their request to apply for this course by the last day of classes\nin the Winter Term.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Electroacoustic Composition',
      units: '6.0',
      PREREQUISITE: [
        '(MUSC 352/3.0 or MUSC 355/6.0 or MUSC 356/6.0) and permission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 491': {
      EXCLUSION: [
        'No more than 3.0 units from MUSC 470/3.0 (2011-12 to 2014-15); MUSC 491/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 491',
      description:
        'In this course we explore both how we consume sound and music within a range of media (film, television, radio), and\nwhere we consume it (homes, elevators, gyms, grocery stores) in order to help educators think critically about the functions\nand effects of sound and music in everyday environments.\n',
      NOTE: [
        'Not open to students who previously have taken Music and Mass Media as a special topics course (MUSC 470/3.0,\nTopics in Music Education I).\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Music and Mass Media',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.\n'],
      'LEARNING HOURS': ['120 (36S;12O;72P)\n']
    },
    'MUSC 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 335',
      description:
        'This course examines formal, informal and non-formal structures that support music teaching and learning in the\ncommunity across the lifespan.\n',
      NOTE: [
        'Non-Music students should note that a significant music background is required to be successful in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Education in the Community',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a BMT or MUSC Plan or permission of the School.'
      ],
      'LEARNING HOURS': ['120 (36G;24O;60P)\n']
    },
    'GEOL 249': {
      EXCLUSION: ['No more than 3.0 units from GEOL 249/3.0; GEOL 269/3.0.'],
      RECOMMENDATION: [],
      code: 'GEOL 249',
      description:
        'The application of physical principles to examine and characterize the Earth at all scales. The Earth\u2019s physical properties and\ndynamic processes will be assessed and evaluated by integrating such topics as gravity, seismology, magnetism,\ngeochronology, and heat flow, as related to scientific and engineering problems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Geophysical Characterization of the Earth',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 104/3.0 or permission of the Department.\nCOREQUISITE    [MATH 120/6.0 or MATH 121/6.0 or (MATH 123/3.0 and MATH 124/3.0) or MATH 122/6.0] and (PHYS\n104/6.0 or PHYS 106/6.0 or PHYS 117/6.0 or PHYS 118/6.0 or PHYS 107/6.0) or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['117 (36L;48Pc;7G;24P)\n']
    },
    'ENGL 481': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 481',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Indigenous Literatures I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ARTF 337': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTF 337',
      description:
        'In this advanced course students select one media choice from these areas: paint media, sculpture/new media or print\nmedia.\n',
      NOTE: ['Open only to students in a BFA Program.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Programs I',
      units: '9.0',
      PREREQUISITE: [
        'A minimum grade of C- in ARTF 228/6.0 and a GPA of 1.60.'
      ],
      'LEARNING HOURS': ['324 (144Lb;180P)\n']
    },
    'DRAM 448': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 448',
      description:
        'This course examines a range of administrative and collaborative skills necessary for producing theatre works. Among the\nareas that will be defined and discussed are marketing, budgeting, fundraising, staffing, and production management, as\napplied to a variety of types of organizational contexts (commercial, non-profit, university, and community).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theatre Administration',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a COCA. DRAM, MUSC, MUTH, or STSC Plan.\nEQUIVALENCY    DRAM 348/3.0.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'POLS 406': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 406',
      description:
        'A comparative examination of the politics and government of different countries, theories or themes in comparative\npolitics. The focus of this course will vary from year to year. Consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Politics: Questions & Challenges',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ITLN 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ITLN 205',
      description:
        'Emphasizing the application of morphology and syntax, with written and oral practice. Readings will be discussed from\nlexical, syntactical and thematic points of view.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Italiano avanzato',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ITLN 204/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 322': {
      EXCLUSION: ['No more than 1 course from HIST 263/3.0; HIST 322/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 322',
      description:
        'A study of the conduct of war and its implication for society and culture, principally in the 19th and 20th centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ar and Modern Society',
      units: '6.0',
      PREREQUISITE: ['Registration in a HIST Major or Medial Plan.\n'],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'BIOL 206': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 201/3.0 and BIOL 202/3.0.\n'],
      code: 'BIOL 206',
      description:
        'An introduction to the genetic mechanisms of population differentiation and evolutionary change - from molecules to\nspecies. The genetical theory of evolution is also applied to problems involving conservation, biotechnology and the\nevolution of disease.\n',
      NOTE: [
        'Priority to BIOL concentrators will be given during course selection.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Evolutionary Genetics',
      units: '3.0',
      PREREQUISITE: ['BIOL 205/3.0.'],
      'LEARNING HOURS': ['120 (36L;36Lb;12O;36P)\n']
    },
    'GEOL 402': {
      EXCLUSION: [
        'No more than one course from GEOL 401/1.5; GEOL 402/1.5; GEOL 368/3.0 (prior to 2013); GEOL 488/3.0\n(prior to 2013).'
      ],
      RECOMMENDATION: [],
      code: 'GEOL 402',
      description:
        'The self-directed detailed study of some aspect of the geological evolution of eastern North America. The topic will\ncomplement the knowledge gained in GEOL 488/3.0.\n',
      NOTE: [
        'This course is intended to provide an option for students in lieu of GEOL 401/1.5.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Problems in North American Geology',
      units: '1.5',
      PREREQUISITE: [
        '(A GPA of 2.90 in GEOL 221/3.0, GEOL 238/3.0, and GEOL 321/3.0) or permission of the Department.\nCOREQUISITE    GEOL 488/3.0 and permission of the Department.\n'
      ],
      'LEARNING HOURS': ['60 (10I;50P)\n']
    },
    'HIST 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 306',
      description:
        'This course examines competing explanations of the genocide of European jewry in the 1930s-40s and how it was allowed\nto occur. Students develop skills of analyzing historical documents, writing, class participation, and critical debate of\nhistoriography.\n',
      NOTE: [
        'In Fall Term, HIST 306/6.0 meets in the same classroom as HIST 295/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Holocaust: Problems and Interpretations',
      units: '6.0',
      PREREQUISITE: [
        'Registration in a HIST Major or Medial Plan.\n',
        'Registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['240 (34.5L;36S;1.5T;168P)\n', '240 (72S;168P)\n']
    },
    'FILM 355': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 355',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'POLS 347': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 347',
      description:
        'Major issues in the contemporary politics and political economy of sub-Saharan Africa. The development of the colonial and\npost-colonial state, capitalist development and the role of indigenous and international capital, and political and socio-\neconomic aspects of class, ethnicity and gender.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Politics of Africa',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 120': {
      EXCLUSION: [
        'No more than 6.0 units from MATH 120/6.0; MATH 121/6.0; MATH 122/6.0; MATH 123/3.0; MATH 124/3.0;\nMATH 126/6.0.'
      ],
      RECOMMENDATION: [
        'MHF4U and MCV4U or 4U AFIC, or permission of the Department.\n'
      ],
      code: 'MATH 120',
      description:
        'A thorough discussion of calculus, including limits, continuity, differentiation, integration, multivariable differential calculus,\nand sequences and series.\n',
      NOTE: [
        'For students intending to pursue a medial or major plan in Mathematics or Statistics or Physics.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential and Integral Calculus',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['288 (72L;24T;192P)\n']
    },
    'CLST 203': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 203',
      description:
        'Greek concepts of the supernatural and humanity\u2019s relationship to it. The basic myths, official and secret creeds, meaning\nand social function of myth and ritual.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Myth and Religion',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PHYS 242': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'A minimum grade of C in PHYS 104/6.0 or PHYS 106/6.0.\n'
      ],
      code: 'PHYS 242',
      description:
        'Evidence for relativistic effects. Kinematics and dynamics in special relativity, space time diagrams, applications. Evidence\nfor quanta, spectra, Bohr atom. Introduction to the Schroedinger equation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Relativity and Quanta',
      units: '3.0',
      PREREQUISITE: ['PHYS 104/6.0 or PHYS 106/6.0.'],
      'LEARNING HOURS': []
    },
    'GPHY 368': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 368',
      description:
        'A critical evaluation of the changing relationships between nature and society.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environments and Society',
      units: '3.0',
      PREREQUISITE: [
        '(6.0 units from GPHY 227/3.0; GPHY 228/3.0; GPHY 229/3.0) or (3.0 units at the 200 level or above in\nDEVS).'
      ],
      'LEARNING HOURS': ['127 (36L;4G;12O;3Oc;72P)\n']
    },
    'JAPN 301': {
      EXCLUSION: [
        ' No more than 6.0 units from JAPN 300/6.0; JAPN 301/3.0; JAPN 302/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'JAPN 301',
      description:
        'Intermediate study of the structural patterns of the language, with intensive training in listening, speaking, reading, and\nwriting. Extensive use of audio-visual materials.\n',
      NOTE: [
        'Students with previous study background must take a placement test during orientation week.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Japanese I',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in JAPN 200/6.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': []
    },
    'POLS 242': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 242',
      description:
        'The nature of political regimes in advanced industrial countries and the developing world. Offered annually.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Comparative Politics: Contemporary Regimes',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'GEOL 419': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 419',
      description:
        'This 12-day, intensive field course focuses on field and laboratory techniques using a wide array of geophysical site\ninvestigation and exploration methods. Review lectures on instrument theory and principles of exploration program design.\nThe course culminates in an exercise to design and implement an integrated geophysical site investigation.\n',
      NOTE: [
        'Please contact the Department for more information.  Estimated $750.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Geophysics Field School',
      units: '3.0',
      PREREQUISITE: ['GEOL 319/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['120 (8L;12G;60Pc;40P)\n']
    },
    'ECON 222': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 222',
      description:
        'A study of the basic models of national income determination and financial markets. The course includes application to\npolicy problems such as inflation, unemployment and balance of payments disequilibria.\n',
      NOTE: [
        'A grade of C in this course is required as a prerequisite for ECON 320/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Macroeconomic Theory I',
      units: '3.0',
      PREREQUISITE: [
        'ECON 110/6.0 or (ECON 111/3.0 and ECON 112/3.0).\nCOREQUISITE    MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or (MATH 123/3.0 and MATH 124/3.0) or MATH 126/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'RELS 396': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 396',
      description:
        'Exploration of Islamic developments since the 19th century: major thinkers, trends of thought, and contemporary\nmovements as responses to modernity.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Islam in the Modern World',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'PHIL 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 420',
      description:
        'Ethical Issues I\nAn examination of major issues in ethics. Possible topics to be considered include political violence, coercion, punishment,\nimmigration, suicide, drug policy, leisure and akrasia.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'FREN 390': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 390',
      description:
        'A study of discourse on and by women in representative works (primarily the novel). Travaux pratiques may include essays\nand tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Genre et litt\u00e9rature',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 486': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 486',
      description:
        'An intensive study of the music culture of a specific country or geographical area.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Area Studies in Ethnomusicology',
      units: '3.0',
      PREREQUISITE: [
        '(Level 3 or above and [MUSC 103/3.0 or MUSC 289/3.0]) or permission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'MATH 437': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 437',
      description:
        'Subject matter to vary from year to year. Given jointly with MATH 837/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Applied Mathematics',
      units: '3.0',
      PREREQUISITE: ['Permission of the Department.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'BISC 101': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BISC 101',
      description:
        'This is an introductory course, complementing and extending BISC 100, focused on skills and approaches from a number of\ndisciplines (Film and Media, Geography, History, Sociology). Academic skills will be honed by centring on centrifugal forces\nof mobility, exchange and action. Processes such as warring, colonising, trading, connecting and leading are highlighted.\n',
      NOTE: [
        'This is a mandatory course for students in the First-Year Program at the Bader International Study Centre.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Acting Globally',
      units: '3.0',
      PREREQUISITE: ['BISC 100/3.0.'],
      'LEARNING HOURS': ['152.4 (14.4L;12S;6Pc;6G;42Oc;72P)\n']
    },
    'FILM 425': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 425',
      description:
        'Research seminar that draws on students\u2019 previous work to enhance advanced writing and research in film criticism. Topics\nfrom theory, criticism, and history will be addressed to suit individual students\u2019 projects.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Film Criticism',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'CHEM 322': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 322',
      description:
        'The application of quantum mechanics to the structures and internal motions of molecules. The foundations of electronic,\nvibrational, rotational and NMR spectroscopy will be discussed together with their applications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Chemical Bond: Computation and Spectroscopy',
      units: '3.0',
      PREREQUISITE: ['CHEM 313/3.0 or CHEM 346/3.0 or PHYS 344/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'HIST 390': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 390',
      description:
        'Seminar on a selected topic in history. Topics change from year to year; course is either being offered for the first time or is\nbeing taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in History',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'GEOL 472': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 472',
      description:
        'Cost, risk, and return characteristics of mineral exploration; introduction to economic evaluation; cash flow and time value\nconcepts; discounted cash flow methods; mining taxation considerations; sensitivity and risk analysis techniques;\nexploration economics and strategies; evaluation of exploration projects; exploration planning issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economic Analysis Methods in Geological Engineering',
      units: '3.0',
      PREREQUISITE: ['GEOL 235/3.0 and permission of the Department.'],
      'LEARNING HOURS': []
    },
    'GNDS 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 330',
      description:
        'This course examines gender in an international context with emphasis on current global issues of women and development.\nTopics include gendering international political economy, women\u2019s health and sexualities, and forms of struggle, resistance\nand change in non-western contexts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender and the Global South',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 319': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 319',
      description:
        'An introduction to Canadian political thinkers who have addressed important themes in contemporary Canadian public,\nlegal and theoretical discourse, including multiculturalism, critical race theory, antipornography campaigns, sexual violence,\nglobalization and modern alienation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Public Discourse in Canada: Issues and Debates',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 348': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 348',
      description:
        'Costs and benefits of legal rules. Among the topics covered are: the justification, acquisition, scope and taking by the state of\nproperty rights, the enforcement of and remedies for breach of contract, the assignment of liability in traffic accidents and\nharm from dangerous products, the costs of litigation and the optimal severity of punishment for crime with special reference\nto the death penalty.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Law and Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'BIOL 535': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 535',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Biology IV',
      units: '3.0',
      PREREQUISITE: ['To be announced.\n'],
      'LEARNING HOURS': ['120 (9L;9S;18G;84P)\n']
    },
    'LING 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 435',
      description:
        'Course content will vary from year to year and will explore a special theme in the interface between morphology and\nsyntax. The course is comparative in perspective, drawing on evidence from different languages. The format is largely\ndiscussion-oriented and includes a substantial component of student presentations. Readings are selected from the current\nresearch literature (journal articles, working papers, unpublished manuscripts and dissertations).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Morpho-Syntax',
      units: '3.0',
      PREREQUISITE: ['LING 330/3.0 and LING 340/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ECON 391': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 391',
      description:
        'This course provides a solid understanding of the economic causes and consequences of environmental problems and\nsuggests practical solutions. Microeconomic analysis is used to help address a range of issues related to the environment.\nLikely topics include global environmental problems, sustainable development, environmental law, strategic models of\nregulation, environmental ethics, and bioeconomic models.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Environmental Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'DRAM 220': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 201/3.0; DRAM 202/3.0; DRAM 220/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 220',
      description:
        'A study of applied dramatic literature, including structure, genre, and staging techniques. Students will analyze several\nplays from various points of view, embracing both theatrical and literary concerns.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Dramaturgy',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['126 (36L;30O;60P)\n']
    },
    'HEBR 295': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 295',
      description:
        'An extensive grammar review with practice in speaking, writing, and translation, based on the reading of texts by modern\nHebrew writers. HEBR 295/3.0, when offered, is a direct continuation of HEBR 294/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Modern Hebrew II',
      units: '3.0',
      PREREQUISITE: ['HEBR 294/3.0 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'LANG 201': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LANG 201',
      description:
        'For students studying abroad or at a Canadian University who wish to learn a modern language other than English and who\nhave acquired a basic knowledge of that language. An increased emphasis on the study of the grammatical structures of the\nlanguage and on the acquisition of vocabulary. Practice in speaking, reading, and writing.\n',
      NOTE: [
        'A language placement test will be administered by the host university.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Language Acquisition - Advanced Level I',
      units: '3.0',
      PREREQUISITE: [
        '(LANG 101/3.0 and LANG 102/3.0) or (LANG P10/3.0 and LANG P11/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    LANG 120/3.0.\n']
    },
    'EMPR 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'EMPR 200',
      description:
        'This is an introductory course which focuses on the key factors which shape work and employment relations in Canada.\nTopics covered include aspects of labour and employment law, labour relations, human resources management, human\nbehaviour in organizations, and labour markets and labour policies that govern workplace relations.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Work and Employment Relations in Canada',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTF 125': {
      EXCLUSION: [],
      RECOMMENDATION: ['Some drawing experience.\n'],
      code: 'ARTF 125',
      description:
        'Designed to appeal to studio novice and seasoned artist alike, this course seeks to foster a broad understanding of historical\nand contemporary printmaking processes, through hands on studio assisted projects. These will cover lithography, etching\nrelief, book binding, hand transfer and photo-digital etching. Overall emphasis is on experimentation and exploration of\nimagery.\n',
      NOTE: [
        'Offered during Summer Term only. Not available for credit towards a B.F.A. program.\n'
      ],
      'ONE-WAY EXCLUSION': ['May not be taken with or after: ARTF 227/6.0.'],
      title: 'Introduction to Studio Art in Printmaking',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'CISC 324': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 324',
      description:
        'Layered operating systems for conventional shared memory computers: concurrent processes. Synchronization and\ncommunication. Concurrent algorithms. Scheduling. Deadlock. Memory management. Protection. File systems. Device\nmanagement. Typical layers.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Operating Systems',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 221/3.0 and CISC 235/3.0).'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 421',
      description:
        'Intensive study of a special topic, period, or author(s) in the world of Rome. For information contact the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Latin/Roman Scholarship II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a CLST or CLAS or GREK or LATN Plan, and permission of Department.'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 352',
      description:
        'A course emphasizing romance and gothic traditions, beginning with the scholarly revival of romance in the mid-eighteenth\ncentury and culminating with modern gothic of the late-nineteenth century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Romance and Gothic',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'CLST 102': {
      EXCLUSION: [
        'No more than 6.0 units from CLST 101/6.0; CLST 102/3.0; CLST 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'CLST 102',
      description:
        'An introduction to major themes in the development of Greek civilization using the evidence of literature, history and\narchaeology. Some attention will be given to those aspects of ancient cultural and intellectual growth that are of\nsignificance in the western tradition.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Greek Civilization',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'SOCY 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 227',
      description:
        'A discussion of theoretical frameworks for understanding contemporary societies. The course will normally cover capitalism\nand economy; globalization and post-colonialism; identity, politics, and social movements; science, technology, and\nenvironmentalism; consumerism and urban life.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theorizing Contemporary Society',
      units: '3.0',
      PREREQUISITE: ['SOCY 226/3.0.'],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'ENSC 391': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 391',
      description:
        'Application of approaches and practices of sustainability will be developed with an emphasis on individual or group\nprojects. This course will involve sustainability efforts at a local, regional or national scale.\n',
      NOTE: [
        "Only offered in the Queen's-Blyth International Studies program or at the Bader International Studies Centre,\nHerstmonceux.\n"
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Practical Applications in Sustainability',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (24L;72G;24P)\n']
    },
    'ENGL 498': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 498',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Criticism and Theory III',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ENGL 447': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 447',
      description:
        'Studies of 19th-century literature produced in the Americas (Canada, United States, and elsewhere in the western\nhemisphere). Geographical focus will vary from year to year. For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literature of the Americas II',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MATH 228': {
      EXCLUSION: [
        'No more than 1 course from MATH 228/3.0; MATH 326/3.0; PHYS 317/3.0; PHYS 312/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 228',
      description:
        'Complex arithmetic, complex plane. Differentiation, analytic functions. Elementary functions. Contour integration, Cauchy\u2019s\nTheorem, and Integral Formula. Taylor and Laurent series, residues with applications to evaluation of integrals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Complex Analysis',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH\n122/6.0 or MATH 124/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'HIST 298': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 298',
      description:
        'A survey of Chinese history, thought, and material culture from the time of the first establishment of the unified Empire in\n221 B.C.E. to the last Emperor\u2019s abdication in 1912. A variety of recent reconstructions of parts of China\u2019s imperial past will\nalso be discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'mperial China',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'MUSC 221': {
      EXCLUSION: ['No more than 6.0 units from MUSC 220/6.0; MUSC 221/6.0.\n'],
      RECOMMENDATION: [],
      code: 'MUSC 221',
      description: 'Continuation of MUSC 121/6.0.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study II',
      units: '6.0',
      PREREQUISITE: ['MUSC 121/6.0.\n'],
      'LEARNING HOURS': []
    },
    'GNDS 280': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 280',
      description:
        'Offered when faculty resources permit, these courses are analyses of particular areas of gender studies interdisciplinary\nresearch. Details regarding specific topics will be available from the Head of the Department on an annual basis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Gender Studies',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 495': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 495',
      description:
        'Studies in representative critical theories from antiquity onwards, with special emphasis on modern criticism both in its\ntheoretical and practical aspects.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Literary Criticism and Theory',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72S;168P)\n']
    },
    'HIST 218': {
      EXCLUSION: ['No more than one course from HIST 218/3.0; HIST 301/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 218',
      description:
        'An introduction to the fabled world of Byzantium. The course surveys key aspects of Byzantine political history, society and\nculture. It traces the transformation of the empire from its origins in third century Rome into the \u2018other\u2019 middle ages of the\nEastern Mediterranean and the Balkans ending with the fall of Constantinople in 1453.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'yzantium',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['127 (36L;91P)\n']
    },
    'RELS 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 240',
      description:
        'Studies the differences between the categories of religion, magic, witchcraft, the supernatural, etc., as constructed in\nscholarship, popular culture, and practice. Focuses on examples such as New Religious Movements, depictions of magic in\nfilm and TV, and moral panics over alleged occult practices, and the histories that let us make sense of them.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Magic, Witchcraft, and the Supernatural',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (24L;6G;12O;78P)\n']
    },
    'POLS 486': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 486',
      description:
        'A difficult challenge facing a liberal-democratic polity is how to distinguish allowable state action from the protected sphere\nof human activity. The course examines contemporary debates about whether rights provide an appropriate critical\nstandard for evaluating state action and looks at different institutional methods to assess the justification of state actions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Politics of Rights',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 215': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 215',
      description:
        'Sports and spectacles of violence, from Ancient Greek athletic contests and Roman gladiatorial combat to jousts, hunts,\nexecutions, and mock battles of Medieval and Renaissance Europe. Exploring ruins of buildings, texts, and images illuminate\nsuch issues as gender roles, social and political functions of violence, eroticism, and animal cruelty.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title:
        'port and the Spectacle of Violence from Antiquity to the Renaissance',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['114 (36L;36O;42P)\n']
    },
    'LLCU 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 301',
      description:
        'An examination of traditional and innovative forms of oral cultural transmission in a selection of American, African and\nEuropean contexts with particular focus on the interaction of narrative and technology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Oral Tradition and Innovation in Cultural Transmission',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'LIBS 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LIBS 100',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ENGL 375': {
      EXCLUSION: ['No more than 6.0 units from ENGL 375/6.0; ENGL 470/6.0.'],
      RECOMMENDATION: [],
      code: 'ENGL 375',
      description:
        'Studies in modern and/or contemporary American fiction, poetry, and drama.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).\n'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'DRAM 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 502',
      description:
        'An independent advanced project in any area of the basic curriculum, supervised and evaluated by faculty.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a DRAM Major or Media Plan) and (a GPA of 2.90 in DRAM) and permission of\nthe School.'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 359': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 359',
      description:
        'Central issues include: the distinction between language and speech; the syntax/semantics/pragmatics trio; reference,\ndenoting, names and descriptions; meaning, truth and verifiability; realism and anti-realism; linguistic forms of pragmatism,\nbehaviourism, idealism, etc.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Language',
      units: '3.0',
      PREREQUISITE: ['PHIL 250/6.0 or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'ENSC 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 320',
      description:
        'A lecture/seminar course focusing on the notion of wildlife; laws governing wildlife protection and use; the effects of\noverexploitation, habitat destruction, and introduced species, and management plans and strategies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Wildlife Issues in a Changing World',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'GNDS 211': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 211',
      description:
        'A study of feminist narratives and gender politics in relationship to women\u2019s lives from the 17th century forward with an\nemphasis upon global histories.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Feminist Histories',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GNDS 120': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 120',
      description:
        'This course explores women, gender, and difference from feminist and anti-racist perspectives. It identifies the ways in\nwhich women\u2019s activism, politics, and experiences intersect with other gendered identifications such as race, location, class,\n(dis)ability, and sexuality. Lessons and texts will introduce feminism, the body, colonialism, gender performance, and\nstrategies of resistance.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Women, Gender, Difference',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (12L;12T;12O;84P)']
    },
    'POLS 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 400',
      description:
        'This seminar will examine key texts in the discipline of political science. The focus of this course will vary from year to year.\nSee the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Political Science',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'RELS 131': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 131',
      description:
        'Introduces religion in India, China and Japan; also the movements of Judaism, Christianity, Islam and Humanism.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'World Religions/Religious Worlds',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['228 (48L;24T;156P)']
    },
    'ENIN 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 200',
      description:
        'This course delivers an introduction to the economic and organizational dimensions of innovation and entrepreneurship.\nUsing case studies of real companies and initiatives, we\u2019ll evaluate how disruptive and incremental innovations bring about\nchanges in the market by prompting new products and services, business models, technologies, and paradigms.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Foundations of Entrepreneurship',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (84O;36P)\n']
    },
    'HIST 459': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 459',
      description:
        'An exploration of approaches to \u2018community\u2019 and \u2018society\u2019 in British thought and culture from the late 18th to the early\n20th century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ritish Culture and Society, 1780-1914',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'RELS 234': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 234',
      description:
        'An introduction to the self-definition of Judaism through an analysis of the concepts of God, Torah and Israel past and\npresent. Also, a preliminary study of the struggles facing Jews in Europe, the State of Israel and North America.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Judaism',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 312': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 312',
      description:
        'Issues raised by the feminist critique of traditional Christian theology and feminist attempts at theological reconstruction.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Christian Feminist Theology',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'MUSC 188': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 188',
      description:
        'An introduction to the guitar through class instruction. Fundamental note-playing and chording techniques to accompany\nsinging will be emphasized. Includes the study of ranges, fingerings, transpositions, basic instrument maintenance, method\nbooks and teaching techniques. Students must provide their own instruments.\n',
      NOTE: [
        'Students with RCM Grade 8 Theory or equivalent may request permission from the School to take the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Guitar Techniques and Methods',
      units: '3.0',
      PREREQUISITE: ['(Registration in a BMUS or BMT Plan) or MUSC 104/3.0.'],
      'LEARNING HOURS': []
    },
    'HIST 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 432',
      description:
        'This course examines cultural histories of economic life in nineteenth-century America and explores the ways in which\nculture and the economy shaped each other throughout the century. Topics may include the market revolution, slavery,\nfinancial markets, fiction and the market, industrialization, incorporation, and consumer culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'conomy and Culture in Nineteenth Century America',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'FILM 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 307',
      description:
        'Intermediate study of some of the most significant films made in Europe from the early 20th century to today. Considers\nhistorical, technological, and aesthetic determinants and influence.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Classics of European Cinema',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'MUSC 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 212',
      description:
        'Medium Ensemble\nMid-size ensemble experience for qualified performers. Topics vary. Course includes weekly rehearsals of a wider variety of\nrepertoire, and a minimum of one concert per term for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'IDIS 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 410',
      description:
        'Students in film, visual art, drama, and music explore new modes of interdisciplinary performance practice through the\ncreation of a collective work performed in public. Enrolment is limited.\n',
      NOTE: [' Administered by the Department of Film and Media.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Cultural Performance in Practice',
      units: '6.0',
      PREREQUISITE: ['Level 4 in a FILM, ARTF, DRAM or MUSC Plan.'],
      'LEARNING HOURS': ['228 (36Pc;96G;96P)\n']
    },
    'GPHY 403': {
      EXCLUSION: [
        'No more than 3.0 units from GPHY 401/3.0; GPHY 402/3.0; GPHY 403/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 403',
      description:
        'Seminars offered by regular and visiting faculty on Geography topics related to their research interests. Consult the\ndepartmental homepage for further details of specific course offerings each academic year.\n',
      NOTE: [
        'Field trip fees may apply in certain years. See departmental webpage for more information. Cost will vary\ndepending on location, but not likely to exceed $300 per year.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Seminar in Human Geography III',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (a GPA of 2.60 in 24.0 units in GPHY and registration in a GPHY Major or Medial [Arts] Plan).\n'
      ],
      'LEARNING HOURS': ['132 (36S;24Oc;72P)\n']
    },
    'ARTF 260': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 120/6.0.'],
      code: 'ARTF 260',
      description:
        'Non-B.F.A. students work with media, techniques and strategies of contemporary and earlier artists. Coursework includes\ndrawing, painting, and studio visits. Discussion on artists\u2019 writings on studio practice/theory, and art practice as\nresearch. Emphasis on understanding process rather than skill development.\n',
      NOTE: ['Not available for credit towards a B.F.A. program.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Studies in Studio Practice',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ARTH 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 310',
      description:
        'A study of women as subjects in art, producers of art and writers of art history. Specific female artists (Western and non-\nWestern) will be considered within theoretical frameworks that have become important to feminist art historians during\nthe past 15 to 20 years (for example, marxist theory, discourse theory, reception theory, psychoanalytic theory).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Feminism, Art, Art History',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'CHEM 412': {
      EXCLUSION: ['No more than 3.0 units from CHEM 412/3.0; PHYS 472/3.0.'],
      RECOMMENDATION: [],
      code: 'CHEM 412',
      description:
        'The fundamentals of statistical mechanics with applications to thermodynamic properties of gases, liquids and solids and to\nchemical equilibrium in dilute gases.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Statistical Mechanics',
      units: '3.0',
      PREREQUISITE: [
        '(CHEM 221/3.0 and CHEM 313/3.0) or (PHYS 345/3.0 and PHYS 372/3.0).\n'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'CISC 434': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 434',
      description:
        'Distributed systems goals, characteristics, and architectures. Processes: models, inter-process communication and\ncoordination. Name services. Consistency and replication. Fault tolerance: design for reliable communication and recovery.\nSecurity. Development paradigms based on data types: object, file, and web-based systems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Distributed Systems',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 324/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SPAN 302': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 302',
      description:
        'Gram\u00e1tica avanzada y composici\u00f3n II\nThis course provides a comprehensive review of the most difficult aspects of Spanish grammar through advanced exercises\nin reading, composition, and conversation. The goal of the course is to consolidate and perfect the student\u2019s written and\noral skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after SPAN 401/3.0; SPAN 402/3.0.'
      ],
      title: '',
      PREREQUISITE: ['SPAN 301/3.0.\n'],
      'LEARNING HOURS': []
    },
    'MUSC 476': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 476',
      description:
        'An intensive analysis of a particular topic within a specific area of music: ethnomusicology, musicology or theory/analysis.\nDetails regarding specific topics will be available from Dan School of Drama and Music on an annual basis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Music II',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and permission of the School.'],
      'LEARNING HOURS': []
    },
    'HLTH 230': {
      EXCLUSION: ['No more than 3.0 units from HLTH 230/3.0; NURS 100/3.0.'],
      RECOMMENDATION: ['4U Biology.\n'],
      code: 'HLTH 230',
      description:
        'Study of macronutrients, selected micronutrients, energy needs for human performance, relationship of nutrient metabolism\nto health, consequences of nutrient deficiencies and excesses. Examine how student\u2019s own food intake may influence present\nand future nutritional well-being.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Basic Human Nutrition',
      units: '3.0',
      PREREQUISITE: ['Level 2.\n'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'SOCY 310': {
      EXCLUSION: [
        'No more than 3.0 units from SOCY 302/3.0-001; SOCY 310/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'SOCY 310',
      description:
        'A lecture-format course devoted to the sociological understanding of visual culture in contemporary society. The course\nintegrates the critical development of key social theories of visuality from Descartes to Baudrillard and beyond. It addresses\nthe sociological significance of visual culture in terms of ideology, hegemony and visual discourse.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Visual Culture',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PSYC 452': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 452',
      description:
        'This seminar focuses on the human ability to produce and comprehend language and its development. Using original\nempirical articles the participants in the seminar will examine topics like syntactic and lexical disambiguation, structural\npriming, the development of reading, and cultural variability in language ability.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Developmental Psycholinguistics',
      units: '3.0',
      PREREQUISITE: [
        '(PSYC 203/3.0 and 12.0 units in PSYC at the 200 level or above) or (level 3 and [registration in a LING or\nCOGS Plan] and a grade of B- in PSYC 100/6.0).'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 507': {
      EXCLUSION: ['No more than 3.0 units from BIOL 360/3.0; BIOL 507/3.0.\n'],
      RECOMMENDATION: [],
      code: 'BIOL 507',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': ['May not be taken with or after BIOL 441/3.0.'],
      title: 'Biotechnology',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'PSYC 100': {
      EXCLUSION: [
        'No more than 1 course from PSYC 100/6.0; PSYC 101/3.0; PSYC 102/3.0; PSYC 103/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'PSYC 100',
      description:
        'Principles of Psychology\nAn introductory survey of basic areas of psychology including perception, cognition, learning and motivation and their\nbiological substrata. Also reviewed are child development, individual differences, social psychology and abnormal\npsychology. Research participation experience is provided for students on an individual voluntary basis. Students are\nencouraged to participate in up to five hours of research experimentation. The course is based on a blended model where\non-line learning is supplemented with a weekly lecture and small-group learning lab.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': ['221 (24L;22Lb;100O;75P)\n']
    },
    'ARTH 260': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 260',
      description:
        'An investigation of the impact of war on art and architecture, as well as human attempts to preserve cultural heritage. A\nchronological or thematic approach may be taken, with focus placed on one or more case studies, such as: the Sacks of\nRome, the Napoleonic wars, Nazi looting, the Cultural Revolution in China, Afghanistan under Taliban rule.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Culture and Conflict',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'IDIS 305': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 305',
      description:
        'British Studies II\nAn interdisciplinary introduction to the broad development of British life and culture, focusing on cultural and political\nconflicts in British society. The course usually combines British art history, history, literature and geography.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'MUSC 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 400',
      description:
        'Chamber music or small ensemble experience for qualified instrumentalists and singers. Topics vary. Course includes\nweekly or bi-weekly coachings and a minimum of one evaluation and/or concert per term for all students. Credit attained\nonly with regular attendance, active participation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Small Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': []
    },
    'ARTH 232': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 232',
      description:
        'A study of Canadian art from the end of the nineteenth century. The nature and development of Canadian art within the\ncontext of the social, political and economic history of the country will be examined.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Art II',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARTH 347': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 214/3.0 and 215/3.0 (or ARTH 213/6.0).\n'],
      code: 'ARTH 347',
      description:
        'Painting and sculpture in the period following the High Renaissance will be examined, with emphasis placed on the\nemergence and meaning of mannerism in Florence and Rome.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mannerism',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'GPHY 229': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 229',
      description:
        'The role of place and space in understanding how social identities (gender, sexuality, race, nationality, class) are constructed\nand contested. Topics include the spaces and meanings of the body, home, work, leisure and consumption, cultural\nlandscapes, constructions of nature, globalization and issues of knowledge, power and imperialism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Place, Space, Culture and Social Life',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;24O;60P)\n']
    },
    'RELS 326': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 326',
      description:
        'Explores the role of religion in the politics of Muslim societies with particular attention to the modern period.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Politics in Muslim Societies',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'ARTH 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 422',
      description:
        'A detailed study of one area or topic in the history of later 20th-century art.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Later 20th-century Visual and Material Culture',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 402': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 402',
      description:
        'Science and Justice\nThe word \u2018science\u2019 comes from the Latin scientia, which means \u2018having knowledge\u2019. What is the relation between science\nand normative political ideals such as democracy, justice and equality? The topics covered in any given year will vary, but\nmay include the ethical, legal and social consequences of advances in the biomedical or environmental sciences.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 393',
      description:
        'As documents of personal and collective identity, portraits reflect the ideals and concerns of the people they depict and the\ncontexts in which they circulate. This course explores the impact of portraiture as an art form and a social phenomenon.\nCourse content may focus on one or more artists, media, historical periods or cultural traditions.\n',
      NOTE: [
        'There will be at least one field trip to study portraits first-hand.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Portrait',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['114 (36L;12O;6Oc;60P)\n']
    },
    'GPHY 346': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 346',
      description:
        'Study of the techniques of Geographic Information Systems and their applications in solving physical and environmental\nproblems. Topics include data representation and models, spatial interpolation, raster-based analysis and modeling, surface\nmodels and terrain analysis, data visualization, temporal analysis, error and accuracy, and other algorithms and analytical\nprocedures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Modeling',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 243/3.0 and (3.0 units from GPHY 247/3.0; ECON 250/3.0; KNPE 251/3.0; PHED 251/3.0; POLS\n385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0), or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (24L;24Pc;24G;24O;24P)\n']
    },
    'FREN 388': {
      EXCLUSION: ['No more than 3.0 units from FREN 388/3.0; FREN 488/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 388',
      description:
        'A study of significant trends in the novel of 18th century France with special emphasis on historical and aesthetic changes in\nthe relationship between fiction and its social context. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Le Roman du 18e si\u00e8cle',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 355': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 355',
      description:
        'A lecture/laboratory experience designed to help prepare students to participate in a variety of multidisciplinary clinical\nand/or professional environments. Concept and skill development pertaining to exercise/lifestyle for general as well as\nselected special populations will prepare students for experiences in clinical and medical settings.\n',
      NOTE: [
        'Priority given to students in Level 3 of the KINE Specialization Plan followed by students in Level 3 of the PHED\nSpecialization Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Lifestyle and Cardiometabolic Assessment Laboratory',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a KINE or PHED Plan and KNPE 125/3.0, KNPE 225/3.0, KNPE 227/3.0 and KNPE 255/3.0.'
      ],
      'LEARNING HOURS': ['120 (12L;36Lb;72P)\n']
    },
    'GEOL 359': {
      EXCLUSION: ['GEOL 349/3.0.'],
      RECOMMENDATION: [],
      code: 'GEOL 359',
      description:
        'The theory and use of numerical computational procedures to solve geo-engineering and geoscience problems. The utility,\nsignificance and widespread applicability of analytical and numerical techniques will be illustrated in the evaluation and\nsolution of practical problems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applications of Quantitative Analysis in Geological Sciences',
      units: '3.0',
      PREREQUISITE: [
        'GEOL 249/3.0 and (MATH 225/3.0 or MATH 232/3.0).\nCOREQUISITE    STAT 263/3.0.\n'
      ],
      'LEARNING HOURS': ['128 (36L;22T;6I;16Oc;48P)\n']
    },
    'ARTH 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 321',
      description:
        'European Art, 1789-1859: Revolution to Evolution\nA study of European art and sculpture of the early nineteenth-century in its political, social and scientific contexts. Topics\nmay include revolutionary painting and caricature, national romanticism, orientalism and empire, realism and popular\nculture, universal exhibitions, and the interplay of art and modern science.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HEBR 292': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 292',
      description: 'Readings in biblical Hebrew prose and poetry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Biblical Hebrew',
      units: '3.0',
      PREREQUISITE: ['HEBR 191/6.0 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'RELS 236': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 236',
      description:
        'Views of and attitudes toward sexuality in selected world religions; the place of sexuality in religious traditions; relationship\nbetween sex and the sacred; specific topics such as marriage, gay and lesbian issues, contraception will be chosen.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Religion and Sex',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': []
    },
    'CLST 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 311',
      description:
        'Intensive study (in translation) of the major epics of classical antiquity: Homer, Hesiod, Apollonios, Vergil and Lucan in the\ncontext of the oral and literate heroic traditions. Comparative study of English heroic poetry encouraged.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Greek and Roman Epic',
      units: '3.0',
      PREREQUISITE: [
        'CLST 100/6.0 or (CLST 102/3.0 and CLST 103/3.0) or CLST 101/6.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'FREN 106': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 106',
      description:
        'For students with no (or a minimal) background in French.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after FREN 107/3.0; FREN 111/3.0; FREN 112/3.0; FREN 118/3.0; FREN\n150/6.0; FREN 219/3.0; FREN 320/3.0; FREN P10/6.0; FREN P11/3.0; FREN P12/3.0; FREN P17/3.0; FREN 100/6.0; FREN\n101/3.0; FREN 102/3.0; FREN 110/6.0.'
      ],
      title: 'Communication et culture I',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['144 (132O;12P)\nEQUIVALENCY    FREN P16/3.0.\n']
    },
    'DRAM 271': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 271',
      description:
        'A seminar course devoted to the exploration of a range of dramatic works from the Medieval period in England. Students\nwill read works from both religious and secular traditions, including liturgical drama, morality plays, cycle dramas and\ninterludes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Medieval Dramatic Literature',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36S;24Oc;60P)\n']
    },
    'HIST 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 200',
      description:
        'This course examines the history of India as a series of contacts with the rest of the world. Topics include Roman trade in\nancient India, the Portuguese, Turkish, and Mughal empires, Gandhi in South Africa, and South Asian diasporas in Europe and\nNorth America. Course materials include histories, travel accounts, court chronicles, medical treatises, literature, and film.\n',
      NOTE: ['Also offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'ndia and the World',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'GPHY 247': {
      EXCLUSION: [
        'No more than 3.0 units from BIOL 243/3.0; CHEE 209/3.0; ECON 250/3.0; GPHY 247/3.0; KNPE 251/3.0 (formerly\nPHED 251/3.0); NURS 323/3.0; POLS 385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0; COMM\n162/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GPHY 247',
      description:
        'An introduction to the analysis of data from real life situations. Covers study design, descriptive and inferential statistics.\nTopics include probability, t-tests, regression, Chi-square tests, analysis of variance. Emphasis is in the foundation of\nstatistical inference and practical application of statistical methods using statistical software.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Statistics',
      units: '3.0',
      PREREQUISITE: ['GPHY 101/3.0 or GPHY 102/3.0.\n'],
      'LEARNING HOURS': []
    },
    'GPHY 371': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 371',
      description:
        'Special Topics in Earth System Science\nCourse offered by visiting faculty on Geography topics related to their research interests. Consult the departmental\nhomepage for further details of specific course offerings each academic year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 in a GPHY Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 408': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 408',
      description:
        'An intensive six-week introduction to archaeological methods and interpretation during participation in a fieldwork project\nrun by a member of the Classics Department.\n',
      NOTE: ['Offered in Summer Term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology Fieldwork Practicum I',
      units: '6.0',
      PREREQUISITE: ['Level 2 and permission of the Department.'],
      'LEARNING HOURS': ['282 (201Lb;18T;27G;36I)\n']
    },
    'POLS 393': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 393',
      description:
        'A comparative examination of the politics and government of different countries, or theories or themes in comparative\npolitics. The focus of this course will vary from year to year; consult the departmental website for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Comparative Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DRAM 422': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 422',
      description:
        'Students\u2019 directing of short scenes will be the basis of practical exploration of directorial methods.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directing Practicum I',
      units: '3.0',
      PREREQUISITE: [
        'A grade of B- in DRAM 323/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'PHYS 432': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 432',
      description:
        'Electromagnetic theory and applications. Topics include: Maxwell\u2019s equations, gauge theory, relativistic transformations of\nMaxwell\u2019s equations, properties of waves in free space, dielectrics, conductors and ionized media, reflection and refraction\nat the surfaces of various media, propagation in metallic and dielectric waveguides, radiation of electromagnetic waves\nfrom charged particles and antennae.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Electromagnetic Theory',
      units: '3.0',
      PREREQUISITE: [
        'PHYS 239/3.0 and (MATH 221/3.0 or MATH 280/3.0) and (MATH 225/3.0 or MATH 231/3.0 or MATH\n232/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'HIST 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 400',
      description:
        'Seminar on a selected topic in history. Topics change from year to year; course is either being offered for the first time or is\nbeing taught by visiting faculty. Consult department office or website for details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in History',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'ECON 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 331',
      description:
        'Uses the methods of economic analysis to examine the main features of the development of Canada before Confederation\nand the United States through the Civil War.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Economic History of North America to 1865',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'FREN 363': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 363',
      description:
        'A study of the major steps in the evolution of French from Latin to the modern day. Subjects treated include: the languages\nupon which French is based; the major steps in the development of French; French as a social institution, as an official\nlanguage and as a living language; the Francophone world.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Histoire de la langue fran\u00e7aise',
      units: '3.0',
      PREREQUISITE: [
        'FREN 215/6.0 or (FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 306',
      description:
        'An overview of the causes and record of global and regional environmental change during the last 100,000 years. Topics\ninclude glaciation, ocean-atmosphere interactions, sea level change, climatic variability, vegetation dynamics and discerning\nbetween the impact of human activities and that of natural environmental forcing mechanisms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Natural Environmental Change',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 207/3.0 or GPHY 208/3.0 or GPHY 209/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': ['126 (36L;6O;84P)\n']
    },
    'Teams of students will identify the critical questions that must be answered to resolve major controversies or gaps of': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code:
        'Teams of students will identify the critical questions that must be answered to resolve major controversies or gaps of',
      description:
        'knowledge that impede the application of fundamental principles in the Life Sciences to health care. The end product will\nbe a written report and public presentation that is accessible to a wide audience.\n',
      NOTE: [
        'Restricted to students registered in Level 3 of LISC Specialization or Major Plan or Level 3 of BCHM Specialization or\nMajor Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Process of Discovery in the Biomedical Sciences',
      PREREQUISITE: [
        'Level 3 and registration in a LISC or BCHM Honours Plan (LISC-M-BSH; LISC-P-BSH; BCHM-M-BSH; BCHM-P-\nBSH).'
      ],
      'LEARNING HOURS': ['126 (6L;6S;33G;33O;48P)\n']
    },
    'FREN 391': {
      EXCLUSION: [
        'No more than 3.0 units from FREN 391/3.0; FREN 491/3.0 (formerly FREN 407/3.0).'
      ],
      RECOMMENDATION: [],
      code: 'FREN 391',
      description:
        'Focuses on a specific author or on a specific theme of Quebec literature. Topics will depend on the professor\u2019s interest and\nfield of research. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Auteurs et th\u00e8mes en litt\u00e9rature qu\u00e9b\u00e9coise',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['132 (24L;12S;24I;72P)\n']
    },
    'DRAM 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 431',
      description:
        'Advanced Acting - Performance I\nResearch, rehearsal and presentation of a role for performance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A GPA of 1.70 in 6.0 units from: DRAM 331/3.0; DRAM 339/3.0; DRAM 373/3.0 or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': []
    },
    'SPAN 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 301',
      description:
        'This course provides a comprehensive review of the most difficult aspects of Spanish grammar through advanced exercises\nin reading, composition, and conversation. The goal of the course is to consolidate and perfect the student\u2019s written and\noral skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after SPAN 302/3.0; SPAN 401/3.0; SPAN 402/3.0.'
      ],
      title: 'Gram\u00e1tica avanzada y composici\u00f3n I',
      units: '3.0',
      PREREQUISITE: ['SPAN 201/6.0 or SPAN 205/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 431',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Restoration and 18th-Century Literature I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MUTH 360': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 360',
      description:
        'Performance experience for qualified musicians in a staged vocal ensemble. Topics include musical theatre, opera, or other\nensemble formats combining voice and drama.\n',
      NOTE: [
        'Placement is made at the discretion of the School based on an audition or other criteria.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Theatre Ensemble',
      units: '1.5',
      PREREQUISITE: ['MUTH 260/1.5 and permission of the School.'],
      'LEARNING HOURS': ['168 (72Pc;24G;72P)\n']
    },
    'DEVS 230': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 230',
      description:
        'Applying global political economy perspectives to key aspects of development finance. Topics include the introduction of\nbasic economic terms, the role of the International Monetary Fund, World Bank, World Trade Organization, and the\ngrowing roles of Transnational Corporations and financial markets in development\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Global Political Economy of Development',
      units: '3.0',
      PREREQUISITE: [
        'DEVS 100/6.0 (DEVS 100/6.0 can be taken concurrently in exceptional circumstances).'
      ],
      'LEARNING HOURS': ['96 (24L;12T;12O;48P)\n']
    },
    'PSYC 271': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 271',
      description:
        'Brain and Behaviour I\nAn introduction to behavioural neuroscience. The course primarily focuses on the basics of neuronal operation, functional\nneuroanatomy, neuropharmacology, and behavioral neuroscience methods. This will be followed by an examination of\ninput (sensory) and output (motor) systems of the brain. Finally, topics relevant to lateralization of function and language\nwill be covered.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after NSCI 323/3.0; NSCI 324/3.0; PSYC 370/3.0.'
      ],
      title: '',
      PREREQUISITE: ['PSYC 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 500': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 500',
      description:
        'This course involves a directed study of a philosophical topic. Topics chosen may be from any area of philosophy, and\nshould be determined in consultation with a proposed supervising instructor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '6.0',
      PREREQUISITE: [
        'Level 4 and registration in a PHIL Major or Medial Plan and (a minimum GPA of 2.60 in PHIL 250/6.0 and\nPHIL 257/6.0) and permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'HLTH 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 331',
      description:
        'Advanced Human Nutrition\nCurrent issues relating to nutrition and health promotion/disease prevention. Such topics as cardiovascular disease, weight\ncontrol, eating disorders, nutrient needs during the life cycle, fads and quackery, sociocultural, economic and media\ninfluences. Topics may vary.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['HLTH 230/3.0 or NURS 100/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 410': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 410',
      description:
        'Creative investigation of media, culture, and technology, focused through the medium of video from its invention to its\ncurrent digital forms. Practical experiments will be guided by critical texts and case studies that contextualize video-based\npractices in a variety of fields.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Video Production for Digital Media',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and FILM 250/6.0 and 24.0 units in FILM.'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;60P)\n']
    },
    'POLS 450': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 450',
      description:
        'An analysis of texts that take the nature of humans as the basis for political argument. Emphasis is on the search for\nfoundations for political claims and the nature of 20th-century relativism, cultural and moral.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Political Theory: Appeals to Human Nature',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ENGL 272': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 272',
      description: 'For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Issues and Themes: Special Topics II',
      units: '3.0',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 153': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 153',
      description:
        'This course will present the fundamentals of biomechanics which includes an understanding of joint structure and function,\nforces and moments, tools used to record motion and use of these tools for description of motion and skill evaluation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Biomechanics',
      units: '3.0',
      PREREQUISITE: ['Level 1 or above in a PHED or KINE Plan.'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'FILM 214': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 214',
      description:
        'This course involves both media studies and production. Students will use their own mobile devices to complete a series of\ncreative projects, while learning theoretical and practical aspects of mobile media communications.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mobile Communications',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['108 (36L;36O;36P)']
    },
    'The course introduces sensory information processing and perception as well as methods used to study the relationship between': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code:
        'The course introduces sensory information processing and perception as well as methods used to study the relationship between',
      description:
        'the physical energy that is sensed (e.g. light and sound) and the subjective experience of objects and events. Mechanisms\nunderlying perception of touch, body position, taste, smell, hearing, and vision are covered.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sensation and Perception',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;9T;75P)\n']
    },
    'FILM 305': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 305',
      description:
        'Intermediate critical and historical study, through a selection of narrative films from one or more European nations. Examines\ncinema industries and art within national and continental culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'European Narrative',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'CISC 500': {
      EXCLUSION: [
        'No more than one course from (CISC 499/3.0; COGS 499/3.0; CISC 500/6.0).'
      ],
      RECOMMENDATION: [],
      code: 'CISC 500',
      description:
        'Individual research project under the supervision of a School of Computing faculty member. Evaluation is based on an oral\npresentation and a written thesis. It is the responsibility of the student to make a research proposal and secure a supervisor\nprior to enrolling in the course.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Undergraduate Thesis',
      units: '6.0',
      PREREQUISITE: [
        'Permission of the Department. Minimum cumulative GPA of 3.5 and Level 4 and registration in a COMP\nMajor or BMCO, COGS, COMA, CSCI, or SODE specialization plan.\n'
      ],
      'LEARNING HOURS': ['240 (24I;216P)\n']
    },
    'HIST 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 442',
      description:
        'An exploration of how New World societies were born out of the contact between Europe, Africa, and the Americas that\nfollowed Columbus\u2019 landing in 1492. Topics will include contact, colonisation, slavery, trade, race, culture and creolization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ew World Societies',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'BIOL 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 330',
      description:
        'An introduction to the cellular basis of biological variation. The course explores the control of cell function exerted by the\nnucleus, the pathways for building and fuelling cells, and the control of integrative cellular events.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Cell Biology',
      units: '3.0',
      PREREQUISITE: ['BIOL 205/3.0 or BCHM 218/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;24O;48P)\n']
    },
    'LLCU 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 340',
      description:
        "The course will focus on the major trends of European Romanticism, mainly English, French, German and Italian. A\ncomparison of both the 'poetics' together with a comparative analyses poems will serve as the backbone of the course.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'European Romanticism',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 454': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 454',
      description:
        'This course will introduce students to the major theoretical approaches and ongoing debates within organization theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Organizations',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'SPAN 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 351',
      description:
        'A survey of the major authors and works of Latin American literature from 1492 to the end of the 19th century. Readings will\ninclude texts from all genres and will illustrate the main cultural and historical trends and movements.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Panorama literario latinoam\u00e9ricano I',
      units: '3.0',
      PREREQUISITE: ['SPAN 205/3.0 or SPAN 201/6.0.'],
      'LEARNING HOURS': []
    },
    'ENIN 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 340',
      description:
        'Topics in Innovation and Entrepreneurship\nExamines current innovation and entrepreneurship trends, practices, styles, theories, texts, and discourses. Through online\nresearch, assigned readings, and creative assignment, students will engage in creative exploration of innovative products,\nservices, business models, and learn about innovative individuals.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (84O;36P)\n']
    },
    'ENIN 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENIN 240',
      description:
        'Students will examine four aspects of creativity \u2013 the creative person, process, product, and press \u2013 to increase the degree\nto which they recognize and nurture their own creative potential. Supported by interdisciplinary research and theory,\nstudents will assess the increasing importance and global context of creativity skills in the 21st century.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Explorations in Creativity',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (84O;36P)']
    },
    'ARTH 308': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 308',
      description:
        'This course examines the changes in European art later known as \u2019Gothic\u2019. With a focus on England, France, Spain, Italy and\nGermany, this class will consider major monuments across the media, from manuscript painting, to architecture, stained\nglass, sculpture and ars sacra. Throughout, monuments will be placed in their appropriate social, historical and patronal\ncontexts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gothic Art in Europe c.1150-1400',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'PHIL 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 330',
      description:
        'Investigations in the History of Philosophy\nAn examination of perennial topics and/or important authors and schools of thought within the History of Philosophy.\nWhile the course will target material that has proven important to contemporary thinking, the emphasis will be\non understanding the topics/authors/movements within their historical milieu.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'PHIL 250/6.0 or PHIL 257/6.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 468': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 468',
      description:
        'This course analyzes Middle Eastern politics from the perspective of international relations. Themes covered include the\nevolution of various identities in the region, the role of outside actors in the Middle East, contemporary Middle Eastern\nstate and social relations, and the role that Middle Eastern states play in contemporary world politics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The International Relations of the Middle East',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'ENSC 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 307',
      description:
        'Marine issues such as fisheries and aquaculture, climate change, oil and gas development, shipping, coastal development\nand marine protected areas will be explored in the context of factors that create environmental problems and the steps\nthat are being taken to solve them. Assignments are modeled on real-world examples to develop skills for creating positive\nchange to promote sustainable practices. This course will be highly complementary to other courses in Oceanography or\nLimnology (GEOL 200/3.0, BIOL 335/3.0, GPHY 303/3.0).\n',
      NOTE: ['Field trip: estimated cost $35.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Marine Environmental Issues',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above, or permission of the School.'],
      'LEARNING HOURS': []
    },
    'CHEM 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 415',
      description:
        'Electrochemistry and Electrocatalysis\nThe course covers concepts of equilibrium electrochemistry and examines the structure of the electrode-solution interface.\nIt discusses the basics of electron transfer and derives electrochemical kinetics equations. It shows examples of several\nelectrochemical reactions and overviews experimental methods used to study electrochemical phenomena.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['CHEM 212/3.0 and CHEM 221/3.0.'],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'HIST 434': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 434',
      description:
        'Throughout the twentieth century, leftists in Canada, socialists, communists, anarchists, feminists, gay and lesbian activists,\nGreens, and others have struggled to reshape Canadian society and politics. This course traces their attempts to transform\nCanada by examining distinct periods and frameworks of analysis, concluding with the challenge of globalization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Canadian Left in the Twentieth Century',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'HEBR 294': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 294',
      description:
        'An extensive grammar review with practice in speaking, writing, and translation, based on the reading of texts by modern\nHebrew writers. HEBR 295/3.0, when offered, is a direct continuation of HEBR 294/3.0.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Modern Hebrew I',
      units: '3.0',
      PREREQUISITE: ['HEBR 190/6.0 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'HIST 455': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 455',
      description:
        'An exploration of the Spanish and Latin American Inquisitions and the Extirpation of Idolatries campaigns against indigenous\npeoples between 1492 and 1700. Themes include understanding Catholic orthodoxy, and how the practices of healing, prayer,\nwitchcraft, and mysticism served as cultural unifiers and as markers of gender and ethnic differences.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Heresy, Holiness and Idolatry in the Iberian Atlantic',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ENSC 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 321',
      description:
        'Examines the socially uneven effects across race, class, gender and nation of environmental problems such as toxic waste\ndisposal, air pollution, climate change, deforestation and environmental disasters and the responses to them from local to\nglobal movements, protests and politics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Justice in Global Context',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['150 (18L;18S;6O;108P)\n']
    },
    'FILM 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 352',
      description:
        'Advanced practical course in film and video aesthetics. Starting with the screening and analysis of selected works, each\nstudent will script, produce and edit a short video or 16mm work that explores particular formal questions. Emphasis will be\nplaced on unconventional approaches and techniques.\n',
      NOTE: [
        'Students may enroll in no more than one production course per academic year: FILM 250/6.0; FILM 351/3.0; FILM\n352/3.0; FILM 353/3.0; FILM 355/6.0; FILM 356/3.0; FILM 365/6.0; FILM 375/6.0; FILM 385/6.0; FILM 410/3.0; FILM\n451/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Production: Issues of Form and Structure',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Major or Medial Plan, STSC or COCA Specialization and FILM 250/6.0 and 6.0 units in\nFILM.'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;60P)\n']
    },
    'FREN 107': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 107',
      description:
        'For students with three years of high school French or equivalent.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [
        'May not be taken with or after FREN 111/3.0; FREN 112/3.0; FREN 118/3.0; FREN 150/6.0; FREN\n219/3.0; FREN 320/3.0; FREN P10/6.0, FREN P11/3.0; FREN P12/3.0; FREN 100/6.0; FREN 101/3.0; FREN 102/3.0; FREN\n110/6.0.'
      ],
      title: 'Communication et culture II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['144 (132O;12P)\nEQUIVALENCY    FREN P17/3.0.\n']
    },
    'PSYC 236': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 236',
      description:
        'The experimental approach to understanding the causes, symptoms, course, and treatment of mental illness is emphasized\nin the analysis of disorders of cognition (e.g., schizophrenia), and problem behaviours (e.g., addictions, sexual disorders).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Clinical Psychology',
      units: '3.0',
      PREREQUISITE: ['PSYC 100/6.0.'],
      'LEARNING HOURS': ['120 (36L;12O;72P)\nEQUIVALENCY    PSYC 235/6.0.\n']
    },
    'GEOL 368': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 368',
      description:
        'The origin, composition and diagenesis of carbonate rocks. Study of modern carbonate sediments and depositional\nenvironments; development of facies models; petrographic and geochemical analysis of limestones and dolostones.\n',
      NOTE: [
        'Required extended field trip during term. Please contact the Department for more information.  Estimated $35.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Carbonate Sedimentology',
      PREREQUISITE: [
        'GEOL 238/3.0 or permission of the Department.\nCOREQUSITE    GEOL 301/1.5.'
      ],
      'LEARNING HOURS': ['121 (33L;18Lb;70P)\n']
    },
    'BIOL 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 323',
      description:
        'Vertebrate biodiversity including characteristics and adaptations of the major classes of the living vertebrates; major\nenvironmental and geological changes associated with vertebrate evolution.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Vertebrate Diversity and Evolution',
      units: '3.0',
      PREREQUISITE: ['BIOL 201/3.0 and BIOL 202/3.0 and BIOL 206/3.0.'],
      'LEARNING HOURS': ['120 (36L;12Lb;72P)\n']
    },
    'MUSC 285': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 285',
      description:
        'Continuation of MUSC 185/3.0. Students study orchestral stringed instruments through class instruction on selected\ninstruments. Emphasis includes further study of playing techniques, ranges, fingerings, bowings, transpositions, tunings,\ninstrument maintenance, ensemble repertoire and teaching techniques. Rental instruments available.\n',
      NOTE: ['Optional Instrumental rental fee of $75 plus HST per term.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'String Techniques and Methods II',
      units: '3.0',
      PREREQUISITE: ['MUSC 185/3.0 or permission of the instructor.'],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'MUSC 274': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 274',
      description:
        'A laboratory course emphasizing weekly field-based observations and supervised practice teaching experiences in music\nwithin schools and/or community organizations in conjunction with music education theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Education: Partnership Placement',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above and [registration in a MUSC or BMT Plan or (MUSC 114/3.0 and 3.0 units from MUSC or\nMUTH)] or permission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'PHYS 490': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 490',
      description:
        'A systematic introduction to nuclear and particle physics for advanced physics students. Topics include basic nuclear\nproperties: size, mass, decay and reactions; shell model of nuclear structure; magnetic moments; gamma and beta decay;\nquark model of elementary particles; and strong, electromagnetic and weak interactions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Nuclear and Particle Physics',
      units: '3.0',
      PREREQUISITE: ['PHYS 345/3.0.'],
      'LEARNING HOURS': []
    },
    'HIST 364': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 364',
      description:
        'This course examines the multi-ethnic, multi-confessional nature of the lands of the former Russian Empire and Soviet Union,\nfocusing on the borderlands. Topics include nationality policies, the status of Muslims and Jews, definitions of Empire, and the\ntreatment of linguistic minorities.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'mperial Borderlands: Russia and the Soviet Union',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MUSC 215': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 215',
      description:
        'Large ensemble for qualified instrumentalists and singers. Topics vary. Course includes weekly rehearsals of a wide variety\nof repertoire, and a minimum of one concert per term, for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Large Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'HIST 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 341',
      description:
        'This course offers a balanced introduction to the Reformation. The seminar takes a critical approach to a broad range of\nsubjects including late medieval religion, Christian humanism, Luther, Zwingli, Calvin, Radical Reformation, Reformation\nbeyond German lands, social and cultural impact of the Reformation, and Catholic Reformation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Reformation',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'ARTH 312': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 214/3.0 and 215/3.0 (or ARTH 213/6.0).\n'],
      code: 'ARTH 312',
      description:
        'An examination of selected topics in 15th-century Italian Renaissance painting.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Quattrocento Painting',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['126 (24L;12G;90P)\n']
    },
    'STAT 462': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 462',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'LLCU 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 102',
      description:
        'Continuation of LLCU 101/3.0: offering a basic level of understanding, speaking, reading and writing in the language. The\nspecific language will be announced on the Department of Languages, Literatures and Cultures web page.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Language and Culture II',
      units: '3.0',
      PREREQUISITE: ['LLCU 101/3.0 in same language.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ECON 390': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 390',
      description:
        'The study of the exploitation and conservation of natural resources such as fisheries, forestry, minerals and energy, and the\nimplications for public policy using tools of economic analysis. Issues relating to the quality of the environment and role of\nnatural resources in the growth and development of the economy are also emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Natural Resource Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 212/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 470': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 470',
      description:
        'An examination and discussion of the economic and social history of Sub-Saharan Africa with a primary focus on the 19th\nand 20th centuries.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Development of Capitalism in Africa',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'KNPE 455': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 455',
      description:
        'Provides advanced understanding of concepts related to the use of physical activity/lifestyle as a strategy for reducing\nmorbidity and mortality in general and selected special populations in preparation to participate in a variety of\nmultidisciplinary clinical and/or professional health care environments.\n',
      NOTE: [
        'This course will normally be offered in academic years starting with an odd number (eg., 2013-2014). Students in a\nKINE Plan will have priority over students in a PHED Plan.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Physical Activity and Health',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above in a KINE Specialization Plan or PHED Specialization Plan and KNPE 125/3.0, KNPE 225/3.0,\nKNPE 227/3.0 and KNPE 255/3.0.'
      ],
      'LEARNING HOURS': ['117 (36L;9Lb;72P)\n']
    },
    'MATH 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 310',
      description:
        'Permutation groups, matrix groups, abstract groups, subgroups, homomorphisms, cosets, quotient groups, group actions,\nSylow theorems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group Theory',
      units: '3.0',
      PREREQUISITE: ['MATH 210/3.0 or MATH 217/3.0.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'INTS 221': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 221',
      description:
        'A variety of intellectual approaches will be integrated in an interdisciplinary exploration of some of the major challenges\nfacing the world community. Examination of such issues as the environment, poverty, disease, human rights, cultural\nidentity or armed conflict will be used to stimulate discovery of what constitutes \u2018global engagement\u2019. Topics will vary and\nthe course may not be offered in every term.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Global Issues of the 21st Century',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the instructor.'],
      'LEARNING HOURS': []
    },
    'HLTH 403': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 403',
      description:
        'Explores global perspectives of Community Based Rehabilitation as a strategy for equalization of health, education and\nsocial inclusion of persons with disabilities. Design, implement and evaluate CBR programs and examine basic CBR\nframeworks, health and disability policy, global partnerships, education and training strategies.\n',
      NOTE: [
        'This course falls under a selection of courses with a focus on Interdisciplinary Studies in Global Health and Disability that\nwill be offered only at the Bader International Study Centre.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Community Based Rehabilitation',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and a minimum GPA of 1.9.'],
      'LEARNING HOURS': ['123 (42L;18G;23Oc;40P)\n']
    },
    'ARTF 102': {
      EXCLUSION: [
        'No more than 6.0 units from ARTF 102/3.0; ARTF 110/6.0; ARTF 127/6.0.\n'
      ],
      RECOMMENDATION: [
        'ARTH 120/6.0. A survey course in Art History provides increased visual literacy at the studio level.\nPrevious experience in studio art is highly recommended.\n'
      ],
      code: 'ARTF 102',
      description:
        'A foundation course in drawing and sculpture aimed at examining the visual, tactile and structural characteristics of various\nmaterials in relation to 3 dimensional space.\n',
      NOTE: ['Materials: estimated cost $250.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Drawing and Sculpture',
      units: '3.0',
      PREREQUISITE: ['ARTF 101/3.0 or permission of the instructor.\n'],
      'LEARNING HOURS': ['144 (48Lb;96P)\n']
    },
    'PHIL 263': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 263',
      description:
        'A consideration of traditional and/or contemporary religious conceptions and arguments. Possible topics include: the\nnature and existence of God, and bases of religious claims.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Religion',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': []
    },
    'PACT 335': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT 335',
      description:
        'This activity-based course will afford students the opportunity to work with community physical activity programs for the\nelderly and relate class theory from KNPE 335/3.0 Physical Activity for Seniors to practical implementation. Students will\nwork in a variety of programs; including: aqua fitness, tai chi, cardiac health maintenance, seniors fitness classes, and so on.\n',
      NOTE: [
        'Transportation and other costs (e.g. required Criminal Checks) are the responsibility of the student.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Practicum in Physical Activity for Seniors',
      units: '3.0',
      PREREQUISITE: ['PACT 237/3.0 and KNPE 335/3.0.'],
      'LEARNING HOURS': ['114 (18S;36Oc;60P)\n']
    },
    'STAT 353': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'STAT 353',
      description:
        'Intermediate probability theory as a basis for further study in mathematical statistics and stochastic processes; probability\nmeasures, expectations; modes of convergence of sequences of random variables; conditional expectations; independent\nsystems of random variables; Gaussian systems; characteristic functions; Law of large numbers, Central limit theory; some\nnotions of dependence.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Probability II',
      units: '3.0',
      PREREQUISITE: [
        '(STAT 268/3.0 or STAT 351/3.0) and (MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and MATH\n281/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FILM 216': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 216',
      description:
        'Introduction to historical research and analysis of narrative and other films. Examines works, from a range of periods and\nsettings, and the conditions that shaped their production, circulation and reception.\n',
      NOTE: ['Priority will be given to FILM, STSC, and COCA students.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Historical Inquiry',
      units: '3.0',
      PREREQUISITE: [
        '(A grade of B- in FILM 110/6.0) or (a GPA of 2.60 in FILM 104/3.0 and FILM 106/3.0) or (a GPA of 2.60 in\nBISC 100/3.0 and FILM 104/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'GPHY 243': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 243',
      description:
        'An introduction to the basic principles, techniques and applications of Geographic Information Science. Students will learn\nconcepts of Global Positioning Systems (GPS), georeferencing, vector and raster based models and the nature of geospatial\ndata.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Geographic Information Science',
      units: '3.0',
      PREREQUISITE: [
        '(GPHY 101/3.0 and GPHY 102/3.0) or (BIOL 102/3.0 and BIOL 103/3.0) or (GEOL 104/3.0 and GEOL 107/3.0)\nor permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24Pc;60P)\n']
    },
    'PHIL 431': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 431',
      description:
        'An examination of major issues in ancient philosophy. Possible topics to be considered include the appearance/reality\ndistinction, causation, the emotions, happiness (eudaimonia) and substance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ancient Philosophy I',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'FILM 375': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 375',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'LING 505': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 505',
      description:
        'Upon agreement with a qualified instructor, students with fourth year standing in Linguistics may take this course to\ndevelop and demonstrate research skills in Linguistics. Working under supervision, students will choose a specific topic in a\nparticular language, prepare a research proposal which involves the collection and analysis of data, carry out the research,\nand write a thesis based on the results. Fall and Winter Terms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis in Linguistics',
      units: '9.0',
      PREREQUISITE: [
        'Level 4 in a LING Plan and (12.0 units at the 300 level or above in LING) and (a GPA of 3.50) and permission\nof the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['348 (36I;312P)\n']
    },
    'MATH 210': {
      EXCLUSION: [
        'No more than 1 course from MATH 210/3.0; MATH 211/6.0; MATH 213/3.0; MATH 217/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 210',
      description:
        'Integers, polynomials, modular arithmetic, rings, ideals, homomorphisms, quotient rings, division algorithm, greatest\ncommon divisors, Euclidean domains, unique factorization, fields, finite fields.\n',
      NOTE: [
        'Students with MATH 112/3.0 may ask for admission with the permissions of the Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Rings and Fields',
      PREREQUISITE: [
        'MATH 110/6.0 or MATH 111/6.0 or (MATH 112/3.0 with permission of the Department).\n'
      ],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'POLS 451': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 451',
      description:
        'An examination of key issues in political theory. Topics will vary from year to year; consult the departmental homepage.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Political Theory',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (36S;12G;72P)\n']
    },
    'BIOL 509': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 335/3.0.\n'],
      code: 'BIOL 509',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Limnological Environmental Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (9L;9S;18G;84P)\n']
    },
    'Intensive coverage of topics that are current and': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'Intensive coverage of topics that are current and',
      description:
        'professors or members of faculty. Students should check with the School regarding availability of this course.\n',
      NOTE: [
        'Restricted to students in a concentration in health studies, kinesiology or physical and health education.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Health Studies I',
      PREREQUISITE: ['Level 3.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 382': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 382',
      description:
        'Studies in literature from a specific nation or region of the postcolonial world (such as South Africa, West Africa, Australia,\nthe Caribbean, South Asia). Content will vary, but the aim will be to explore the cultural and historical contexts that inform\nliterary production in the particular nation or region under study.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Postcolonial Literatures in Context',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'FREN 393': {
      EXCLUSION: [
        'No more than 6.0 units from FREN 215/6.0; FREN 353/3.0; FREN 393/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 393',
      description:
        'Introduction to basic notions in French lexicology and morphology. The structure of words. Derivational and inflectional\nmorphology. The structure of the lexicon.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Morphologie et lexicologie du fran\u00e7ais',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['132 (24L;12G;96P)\n']
    },
    'LLCU 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 205',
      description:
        "This course will introduce major themes and concepts in the cultures of a specific nation with an emphasis on\nunderstanding and examining the important social, historical and cultural contexts of the country and its people. Topics\nmay include art, film, economy, religion, and politics. The specific 'Nation' details to be announced on the Languages,\nLiteratures and Cultures website.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Cultures of a Nation',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;36T;48P)\n']
    },
    'BIOL 409': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 322/3.0 or BIOL 339/3.0 or BIOL 341/3.0.\n'],
      code: 'BIOL 409',
      description:
        'Bioremediation\nThe use of living organisms to address environmental problems. Topics include mechanisms of contaminant extraction,\nabsorption, concentration, and degradation using bacteria and plants to detoxify organic compounds, sequester heavy\nmetals or clean up excess nutrients.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'BIOL 330/3.0 and a minimum GPA of 2.0 in the Biological Foundations List.'
      ],
      'LEARNING HOURS': ['109.2 (36L;12T;6Oc;55.2P)\n']
    },
    'ARTH 211': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 211',
      description:
        'This course will explore the scientific aspects of art conservation, including the materials found in cultural heritage, their\ndegradation, and the scientific techniques used in their analysis. Topics to be discussed include conservation treatments\nand preventative conservation, as well as forgeries and conservation controversies in history.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Science and Art Conservation: Complexities and Controversies',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'POLS 435': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 435',
      description:
        'The course introduces students to some of the important questions about the Palestinian-Israeli conflict. What is the\nhistory of the conflict? How did distinct national identities emerge? What issues are at stake for the actors involved? How\ndo domestic factors shape Palestinian-Israeli relations? Why have peacemaking efforts been unsuccessful?\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Palestinian-Israeli Conflict',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (36S;12G;72P)\n']
    },
    'PHIL 316': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 316',
      description:
        'A study of what is involved in enjoying, understanding and interpreting works of art, and of the place of the arts in human\nculture. Writings of artists and critics, as well as those of philosophers, will be used.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of Art',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 380': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 380',
      description:
        'Studies in Canadian fiction, poetry, and literary criticism in relation to recurring concerns within Canadian cultural history.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literature and Culture in Canada',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'MATH 339': {
      EXCLUSION: [],
      RECOMMENDATION: ['MATH 110/6.0 or MATH 111/6.0.\n'],
      code: 'MATH 339',
      description:
        'This course highlights the usefulness of game theoretical approaches in solving problems in the natural sciences and\neconomics. Basic ideas of game theory, including Nash equilibrium and mixed strategies; stability using approaches\ndeveloped for the study of dynamical systems, including evolutionary stability and replicator dynamics; the emergence of\nco-operative behaviour; limitations of applying the theory to human behaviour.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Evolutionary Game Theory',
      units: '3.0',
      PREREQUISITE: [
        'MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 127': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 127',
      description: 'Training in sight reading and dictation.\n',
      NOTE: [
        'Students with RCM Grade 8 Theory or equivalent may request permission from the School to take the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Ear Training and Sight Singing I',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in a BMUS or BMT Plan) or MUSC 104/3.0 or permission of the School.'
      ],
      'LEARNING HOURS': []
    },
    'IDIS 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'IDIS 311',
      description:
        'A production class exploring the formal concepts, historical underpinnings, and technical tools used in the production of\nindependent sound works, or in the production of more elaborate sound components for video, film or theatrical projects.\n',
      NOTE: [' Administered by the School of Music.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Sound Production',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'FILM 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 303',
      description:
        'This course offers an overview of recent filmmaking practices from various continents. Transnational cinemas explore how\nintimate, personal styles of filmmaking converge with theories of globalization, hybridity and remediation.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Transnational Cinemas',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization) or (FILM 236/3.0; FILM 240/3.0; FILM 260/3.0) or\n(LLCU 209/3.0; DEVS 240/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'RELS 161': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 161',
      description:
        'Explores religious issues in culture, literature, politics and social ethics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Problems in Religion and Culture',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['228 (48L;24T;156P)']
    },
    'MUSC 203': {
      EXCLUSION: ['No more than 3.0 units from MUSC 102/3.0; MUSC 203/3.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 203',
      description:
        'Examination of musical styles and movements in the nineteenth and twentieth centuries, in their sociocultural contexts.\nDiscussion of foundation topics introduced in MUSC 103/3.0 is continued.\n',
      NOTE: [
        'Non-Music students holding Royal Conservatory Grade 9 Theory or equivalent may enroll in this course with\npermission of the School.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Romantic and Twentieth-Century Music',
      units: '3.0',
      PREREQUISITE: ['MUSC 103/3.0.\nCOREQUISITE    MUSC 191/6.0.\n'],
      'LEARNING HOURS': ['118 (36L;12O;70P)\n']
    },
    'HIST 498': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 498',
      description:
        'A course on China\u2019s nationalist and communist revolutions. Readings explore rival revolutionaries\u2019 goals and programs.\nSeminars examine the internal and international struggles affecting the outcome of the civil war of 1946-1949.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'hina\u2019s Revolutions, 1911 to 1949',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'PHGY 355': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHGY 355',
      description:
        'An intermediate course focussing on biomedical applications of lung biology. Topics include lung mechanics, gas exchange,\nacid-base balance and control of breathing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biomedical Respiratory Physiology',
      units: '3.0',
      PREREQUISITE: [' PHGY 210/6.0 or PHGY 214/6.0 or PHGY 212/6.0.'],
      'LEARNING HOURS': []
    },
    'POLS 471': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 471',
      description:
        'An examination of connections between politics, science and technology. Topics include: ideologies and the autonomy of\nscience; science in the Warfare State; controlling the social uses of science.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Politics and Science in Technological Societies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'FILM 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 320',
      description:
        'Media and the Arts\nIntermediate study in relations between moving-image media and other visual or performing arts.\n',
      NOTE: [
        'Priority will be given to FILM, STSC, COCA, and MDIA students.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (FILM 236/3.0; FILM\n240/3.0; FILM 260/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'PHIL 381': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 381',
      description:
        'Topics may include the nature of scientific method; the meaning of laws of nature; theoretical entities; scientific\nexplanation; causality, induction, and probability.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Philosophy of the Natural Sciences',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'CWRI 296': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CWRI 296',
      description:
        'This course is structured entirely around the creative writing workshop. The concentration is on short fiction and poetry,\nthough memoir and creative non-fiction are options. There is intensive focus on publication and editing in a class-produced\nanthology, launched at the end of term with a public reading.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Creative Writing II',
      units: '3.0',
      PREREQUISITE: [
        'CWRI 293/3.0 or CWRI 294/3.0 or CWRI 295/3.0, and permission of the instructor.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CISC 457': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 457',
      description:
        'Introduction to fundamental concepts and applications in image processing and computer vision. Topics include image\nacquisition, convolution, Discrete Fourier Transform, image enhancement, edge detection, segmentation, image\nregistration, human contrast perception, colour perception and reproduction, stereo vision.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Image Processing and Computer Vision',
      units: '3.0',
      PREREQUISITE: [
        'C- in [(MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH\n122/6.0 or MATH 123/3.0 or MATH 124/3.0 or MATH 126/6.0) and CISC 124/3.0].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HEBR 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HEBR 502',
      description:
        'Directed Hebrew reading of material not covered in other courses, appropriate to the student\u2019s level.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Reading in Hebrew',
      units: '3.0',
      PREREQUISITE: ['Permission of the instructor or the Program Director.'],
      'LEARNING HOURS': []
    },
    'INTS 321': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'INTS 321',
      description:
        'A comparative discussion of the representation of a number of global cities in contemporary fiction, film, and scholarly\ncriticism with a focus on race, gender, and sexuality. The course explores recent shifts in understanding of cities and of\nurban life and the widely varying narratives these shifts have engendered.\n',
      NOTE: [
        'Administered by the Department of Languages, Literatures and Cultures.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Urban Images: Race, Gender, Sexuality and the Imagined City',
      units: '3.0',
      PREREQUISITE: ['Level 2 or permission of the Department.'],
      'LEARNING HOURS': []
    },
    'LLCU 226': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 226/3.0; ITLN 226/3.0; ITLN 326/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 226',
      description:
        'Addresses the various issues relating to the film adaptation of an Italian literary text. The reading of narrative texts, the\nviewing of films and critical readings are required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Italian Literature and Cinema',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    ITLN 226/3.0.\n']
    },
    'DRAM 202': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 200/6.0; DRAM 201/3.0; DRAM 202/3.0; DRAM 210/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 202',
      description:
        'A survey of structure, forms and ideas of dramatic literature originating in works from 17th century to present. Plays will be\nread in English.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Drama II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'BCHM 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BCHM 442',
      description:
        'Tutorials, assignments and demonstrations in important subjects in biochemistry emphasizing topics of broad interest.\nParticular emphasis will be paid to the applications of biochemical knowledge and new technologies.\n',
      NOTE: [
        'Students in the BCHM Major Plan registered in BCHM 441/3.0 will not be allowed to register in BCHM 442/3.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminars in Biochemistry',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a BCHM Specialization Plan) and [a GPA of 2.7 in BCHM 313/3.0, BCHM 315/3.0,\nBCHM 316/3.0, BCHM 317/6.0, (BCHM 218/3.0 or MBIO 218/3.0)].'
      ],
      'LEARNING HOURS': ['120 (12S;12T;12G;84P)\n']
    },
    'BIOL 527': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 335/3.0.\n'],
      code: 'BIOL 527',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Paleolimnology and Global Environmental Change',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'SOCY 420': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 420',
      description:
        'This course focuses on program evaluation as applied sociology, including program theory, and will provide a practical\nunderstanding of how social research methods are used to assess social intervention programs.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Program Evaluation',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a SOCY Major or Medial Plan and (a minimum grade of C in SOCY 210/3.0 and\nSOCY 211/3.0 and SOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in SOCY 210/3.0 and SOCY 211/3.0 and\nSOCY 226/3.0 and SOCY 227/3.0) and (a minimum GPA of 2.60 in all SOCY).'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 293': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 293',
      description:
        'An introduction to environmental philosophy through a study of readings that have exercised a formative influence on\nWestern thinking about the relationship between humans and the rest of nature, and hence also about human nature itself.\nThe course will offer an environmental perspective on the history of philosophy from ancient to recent times.\n',
      NOTE: ['Bus fare and entrance fee: estimate cost $20.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Humans and the Natural World',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 304': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 304',
      description:
        'Advanced study of the physical geography of northern regions, emphasizing the Canadian Arctic.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Arctic and Periglacial Environments',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['126 (36L;6O;84P)\n']
    },
    'DRAM 339': {
      EXCLUSION: [
        'No more than 6.0 units from DRAM 331/3.0; DRAM 332/3.0; DRAM 339/3.0; STSC 300/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'DRAM 339',
      description:
        'Practical work in selected areas of performance. Not offered every year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Performance II',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan) and a grade of B- in DRAM 237/3.0\nand (3.0 units from DRAM 238/3.0; DRAM 239/3.0; DRAM 273/3.0).\n'
      ],
      'LEARNING HOURS': ['120 (36Pc;48G;36P)\n']
    },
    'POLS 391': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 391',
      description:
        'This course introduces students to the various families of electoral systems in use around the world. It examines their\nvariations and assesses the consequences of electoral systems on political parties, legislatures and governments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Electoral Systems',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 213': {
      EXCLUSION: [
        'No more than 1 course from HIST 213/6.0; HIST 253/3.0; HIST 240/6.0 (2013-14).'
      ],
      RECOMMENDATION: [],
      code: 'HIST 213',
      description:
        'Examines the rise of the welfare state since 1945 in North America and Western Europe. Topics include broad trends like\ndeindustrialization, globalization, the rise of inequality, and social mobility. Specific policies discussed concern health care,\npensions, unemployment, families, taxation, immigration, higher education, and public housing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'omparative Public Policy',
      units: '6.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'RELS 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 212',
      description:
        'Similarities and differences in the myths of ancient Egypt and Mesopotamia will be explored on the basis of material\nremains (e.g., the pyramids and temple architecture) and texts.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mythology of the Ancient Near East',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 317': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 317',
      description:
        'How courts are responding to their responsibility to review legislative and executive decisions in terms of their impact on\ncitizens; the impact of the Charter on the way government is viewed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Charter Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PACT 237': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PACT 237',
      description:
        'This activity-based course will allow students to lead the daily physical activity (DPA) program at local elementary schools.\nStudents will learn how to design appropriate lesson plans, and then will have the opportunity to apply this knowledge and\nimplement their program within the school system.\n',
      NOTE: [
        'Transportation and other costs (e.g. required Criminal Checks) are the responsibility of the student.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Practicum in Physical Activity for Children',
      units: '3.0',
      PREREQUISITE: ['PACT 100/3.0 and KNPE 237/3.0.'],
      'LEARNING HOURS': ['114 (24S;30Oc;60P)\n']
    },
    'HIST 351': {
      EXCLUSION: [
        'HIST 400/4.5-002 (Fall Term 2016-17) and HIST 400/4.5-003 (Fall Term 2015-16).'
      ],
      RECOMMENDATION: [],
      code: 'HIST 351',
      description:
        'Our seminar will examine political, economic, social, and cultural aspects of the history of Russia from 1700 to the present.\nWe will focus on the most pivotal moments of Russian history \u2013 major wars, reforms, and revolutions and study the ways\nthey changed Russia as well as resistance to these changes.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ar, Reform and Revolution in Russian History',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['180 (36S;36O;108P)\n']
    },
    'JAPN 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'JAPN 200',
      description:
        'Continued study of the structural patterns of the language, with intensive training in listening, speaking, reading, and writing.\nExtensive use of audio-visual materials. Students are expected to study individually on a regular basis with the aid of an audio\ntape in addition to the four hours of classroom work per week.\n',
      NOTE: [
        'Students with previous study background must take a placement test during orientation week.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Japanese II',
      units: '6.0',
      PREREQUISITE: [
        'A grade of C in JAPN 100/6.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'MATH 280': {
      EXCLUSION: [
        'No more than 3.0 units from MATH 221/3.0; MATH 227/3.0; MATH 280/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 280',
      description:
        'Limits, continuity, C1, and linear approximations of functions of several variables. Multiple integrals and Jacobians. Line and\nsurface integrals. The theorems of Green, Stokes, and Gauss.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Calculus',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 112/3.0) and (MATH 120/6.0 or MATH 121/6.0 or MATH\n122/6.0 or MATH 124/3.0).\n'
      ],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'GPHY 370': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 370',
      description:
        'Course offered by visiting faculty on Geography topics related to their research interests. Consult the departmental\nhomepage for further details of specific course offerings each academic year.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Special Topics in Human Geography',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 in a GPHY Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LATN 322': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 322',
      description:
        'Selected passages of Latin verse, usually drawn from epic, lyric, elegy, and drama, read in the original Latin and commented\nupon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with LATN 422/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Latin Verse',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in LATN 209/6.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'ENGL 456': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 456',
      description:
        'Studies in literary topics focused on \u201cthe long nineteenth century\u201d that do not fit within the established Group II rubrics\n(Romantic Literature, Victorian Literature, Literature of the Americas). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group II: Special Topics I',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'DRAM 541': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 541',
      description:
        'An independent advanced project in the area of design, supervised and evaluated by faculty. ',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies in Design',
      units: '3.0',
      PREREQUISITE: [
        'A grade of B in DRAM 342/3.0 or DRAM 345/3.0, or permission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'MUTH 260': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 260',
      description:
        'Performance experience for qualified musicians in a staged vocal ensemble. Topics include musical theatre, opera, or other\nensemble formats combining voice and drama.\n',
      NOTE: [
        'Placement is made at the discretion of the School based on an audition or other criteria.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Theatre Ensemble',
      units: '1.5',
      PREREQUISITE: ['MUTH 160/1.5 and permission of the School.'],
      'LEARNING HOURS': ['168 (72Pc;24G;72P)\n']
    },
    'ITLN 415': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 215/3.0; ITLN 415/3.0; LLCU 215/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 415',
      description:
        'A study of Dante Alighieri\u2019s life and poetry, especially the Vita Nuova and the Divina Commedia.\n',
      NOTE: [
        'Taught in English together with LLCU 215/3.0. Students concentrating in Italian submit written assignments, tests\nand examinations in Italian. Normally they will read Italian texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Dante',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ITLN 408': {
      EXCLUSION: [
        'No more than 3.0 units from ITLN 308/3.0; ITLN 408/3.0; LLCU 308/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ITLN 408',
      description:
        'This course will examine social, historic and political realities of the twentieth century through the lens of the unique Italian\nhumorist tradition of film making. The course will focus on films by F.Fellini, L.Comencini, E.Scola, G.Tornatore,\nG.Salvatores, N.Moretti, R.Benigni and other film makers.\n',
      NOTE: [
        'Taught in English together with LLCU 308/3.0. Students concentrating in Italian submit written assignments, tests,\nand examination in Italian.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'From Fellini to Benigni',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;36T;48P)\n']
    },
    'HLTH 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 430',
      description:
        'Sociocultural Studies of Food\nWhat we eat tells us about who we are and how we see ourselves, as individuals and groups. This seminar style course will\ndraw on scholarly literature from a range of disciplines including health studies, history, politics, sociology, anthropology,\nphilosophy, cultural studies, and women\u2019s studies to explore contemporary issues related to food and eating.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        '[Level 3 or above in a HLTH Major or Medial Plan] or [Level 3 or above in a PHED Specialization or KINE\nSpecialization Plan and (HLTH 333/3.0 or HLTH 334/3.0)].'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'CLST 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 303',
      description:
        'Study of the remains from the Bronze Age to the end of the Archaic period. Emphasis on the revival of architecture, painting\nand sculpture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Archaeology of Early Greece',
      units: '3.0',
      PREREQUISITE: [
        '(CLST 102/3.0 and CLST 103/3.0) or CLST 129/6.0 or CLST 200/3.0 or CLST 207/3.0 or CLST 101/6.0 or\npermission of the Department.'
      ],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'HIST 221': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 221',
      description:
        'A thematic-chronological history of Jews; political, social, religious and cultural interactions with the ancient near east,\nHellenism, Rome, Christians, and Muslims; the biblical background; the rise of rabbinic Judaism and its opponents; communal\nlife; gender; Diaspora cultures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ewish and World Civilizations (until 1492)',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 247': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 247',
      description:
        'This course will subject a range of issues in practical ethics to philosophical scrutiny.  Topics may include obligations to\nfuture generations, the ethics of war and self-defence, whether torture is ever permissible, the ethics of deception, the\nmorality of genetic enhancement, the nature of exploitation, and moral objections to organ sales.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Practical Ethics',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CISC 235': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 235',
      description:
        'Design and implementation of advanced data structures and related algorithms, including correctness and complexity\nanalysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Data Structures',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 124/3.0 and CISC 203/3.0).'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LING 415': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 415',
      description:
        'The aim of this course is to provide students with an understanding of the fundamental concepts and tools of analysis in\nsemantics. Students will learn to recognize and identify different features of word meaning and a variety of semantic\nrelations between words and sentences. The characteristics of logical relations and truth-functional semantics and the role\nthese play in the interpretation of words and sentences will be discussed.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Semantics',
      units: '3.0',
      PREREQUISITE: [
        'LING 340/3.0 or permission of the Department of Languages, Literatures, and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ARAB 200': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARAB 200',
      description:
        'This intensive intermediate-level course is designed to provide a review of the basic elements of Modern Standard Arabic\nand continues the development of students\u2019 communicative skills in reading, writing, listening and speaking Arabic. It will\noffer an introduction to more complex syntactic and grammatical forms and structures, preparing students for carrying on a\nsimple conversation, reading an intermediate level text, and understanding basic conversations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Modern Standard Arabic',
      units: '6.0',
      PREREQUISITE: ['ARAB 100/6.0 or permission of the Instructor.'],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'HIST 285': {
      EXCLUSION: ['No more than 6.0 units from HIST 285/3.0; HIST 302/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 285',
      description:
        'A survey of Latin American history from the pre-conquest era to the mid-19th century. Examines the complexities\nof Spanish and Portuguese colonialism, the Independence movements, and the ensuing struggle to build a viable post-\ncolonial order.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'atin America to 1850: The Colonial Experience',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['129 (33L;24O;72P)\n']
    },
    'FREN 392': {
      EXCLUSION: [
        'No more than 3.0 units from FREN 392/3.0; FRST 290/3.0; FREN 290/3.0; IDIS 290/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'FREN 392',
      description:
        'Students will explore Paris through the diverse, creative, and anecdotal perspectives offered by writers, filmmakers,\npainters, photographers, and other artists. Such figures have played important roles in significant literary and artistic trends\nand movements, and have portrayed Paris in a variety of perspectives.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Paris Through Literature, Painting, Cinema, and Photography',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': [
        '120 (48O;72P)\nEQUIVALENCY    FREN 290/3.0; IDIS 290/3.0.\n'
      ]
    },
    'PSYC 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 501',
      description:
        'Each student will, under supervision, formulate and present an original research proposal involving the collection and\nanalysis of data, carry it out, and submit a thesis based on the results. Proposals must be approved by relevant Ethics\nReview committees. This course is optional for students completing a major in psychology but all students are advised that\nadmission to a graduate research program in psychology normally requires the completion of an honours thesis.\n',
      NOTE: [
        'Students whose research involves the care and/or handling of animals must also complete the Introductory Animal\nCare Course and if required the appropriate Animal Use workshops through the Office of the University Veterinarian.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Honours Thesis',
      units: '9.0',
      PREREQUISITE: [
        '(A grade of C+ in PSYC 302/3.0 or PSYC 300/6.0) and (a GPA of 2.60 in PSYC 202/3.0; PSYC 203/3.0; PSYC\n301/3.0; PSYC 302/3.0 or PSYC 300/6.0) and a GPA of 3.30 in PSYC and permission of Department.'
      ],
      'LEARNING HOURS': ['365 (9S;6T;350P)\n']
    },
    'GEOL 107': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 107',
      description:
        'The history of life, from its inception four billion years ago to the present day, focusing on the inter-relationship between\norganic evolution and global change. Coevolution of early life and the atmosphere; development of marine animals and\ntheir ecosystems; invasion of the land; dinosaurs and their world; mass extinctions; the Age of Mammals; and hominid\nevolution. Lectures plus three three-hour laboratories.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History of Life',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12Lb;12O;60P)']
    },
    'SPAN 380': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 380',
      description:
        'An introduction to the major authors and works of the literature of Spain from its beginnings to the end of the 17th Century.\nThrough study and analysis students will obtain a general understanding of the main cultural, historical, and societal trends\nand movements during these periods.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introducci\u00f3n: Literatura de Espa\u00f1a I',
      units: '3.0',
      PREREQUISITE: ['SPAN 201/6.0 or SPAN 205/3.0.'],
      'LEARNING HOURS': []
    },
    'HIST 226': {
      EXCLUSION: ['No more than 1 course from HIST 226/3.0; HIST 250/6.0.'],
      RECOMMENDATION: [],
      code: 'HIST 226',
      description:
        'An introduction to the main themes of the history of the Latin West between the 11th and 15th centuries including changes\nin the economy, society, religion, culture, and politics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he Later Middle Ages',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'KNPE 265': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 265',
      description:
        'This course will introduce both theoretical and applied/professional aspects of human social behaviour in sport and exercise\nsettings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Psychology of Sport and Exercise',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above in a PHED, KINE, or HLTH Plan.\nCOREQUISITE    PSYC 100/6.0.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'ECON 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 442',
      description:
        'Selected topics in the theory of public economics and related policy questions. Content varies from year to year. Topics may\ninclude: the role of asymmetric information in public economics, tax policy, design of redistributive programs, fiscal federalism,\nand selected aspects of Canadian public policy. Students are directed to the undergraduate website for a detailed description.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Public Economics',
      units: '3.0',
      PREREQUISITE: ['ECON 310/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GRMN 306': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 306',
      description:
        'Designed for students at the intermediate-advanced level. The course aims at developing communicative competence in\nthe fields of business, commerce, industry, and German in the workplace, with specific emphasis on oral communication.\nThe course prepares students for the internationally recognized exam Zertifikat Deutsch f\u00fcr den Beruf. Students can write\nthe exam on campus.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Business German I: German in the Workplace',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SPAN 504': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 504',
      description:
        'Reading courses in selected fields of Spanish American literature to meet the needs of advanced students for whom a\nseminar course is not available. Course details to be announced on website.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Literatura de Hispanoam\u00e9rica: Estudios independientes',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department of Languages Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 501': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 501',
      description:
        'An independent advanced project in any area of the basic curriculum, supervised and evaluated by faculty. Completed\napplications must be submitted for Department approval by 15 March of students\u2019 third year. Consult faculty advisors or\nsupervisors for detailed information well in advance of the deadline.\n',
      NOTE: [
        'In addition to the prerequisites indicated below, the department may require a grade of A- in any DRAM course\nrelevant to the subject of study.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a DRAM Major or Media Plan) and (a GPA of 2.90 in DRAM) and permission of\nthe School.'
      ],
      'LEARNING HOURS': []
    },
    'PHYS 212': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 212',
      description:
        'Waves and Vibrations\nFundamentals of free, damped and forced vibrations with applications to various mechanical systems. Coupled oscillations\nand normal modes. Classical wave equation, standing and travelling waves. Continuum mechanics of solid bodies; elasticity\ntheory with applications. Introduction to optics: image formation and optical instruments.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['PHYS 206/3.0.'],
      'LEARNING HOURS': []
    },
    'HIST 353': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 353',
      description:
        'Research seminar on revolutions, civil wars, and political violence in twentieth-century Latin America. Includes case studies\nof Mexican and Cuban revolutions, Central American civil wars, and other insurgencies. Explores theories of revolution,\npatterns of unrest, and attempts to bring about revolutionary change.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'evolutions and Civil Wars in Twenthieth-Century Latin America',
      units: '4.5',
      PREREQUISITE: [
        'A grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['170 (36S;2I;6O;126P)\n']
    },
    'PHYS 472': {
      EXCLUSION: ['No more than 3.0 units from: CHEM 412/3.0; PHYS 472/3.0.'],
      RECOMMENDATION: [],
      code: 'PHYS 472',
      description:
        'Phase space, the ergodic hypothesis and ensemble theory. Canonical and grand canonical ensembles. Partition functions. Ideal\nquantum gases. Classical gases and the liquid vapour transition. Introduction to techniques for interacting systems, including\nMonte Carlo simulations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Statistical Mechanics',
      units: '3.0',
      PREREQUISITE: ['PHYS 313/3.0 and PHYS 344/3.0 and PHYS 372/3.0.\n'],
      'LEARNING HOURS': []
    },
    'LANG 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LANG 102',
      description:
        'For students studying abroad or at a Canadian University who wish to learn a modern language other than English and who\nhave no previous knowledge of that language. A basic level of understanding, speaking, reading, and writing in the\nlanguage. An introduction to elements of culture of the countries in which the language is spoken.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Language Acquisition - Beginning Level II',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    LANG P11/3.0.']
    },
    'MUSC 321': {
      EXCLUSION: [
        'No more than 6.0 units from MUSC 320/6.0; MUSC 321/6.0.\n',
        'No more than 6.0 units from MUSC 321/6.0; MUSC 325/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MUSC 321',
      description: 'Continuation of MUSC 221/6.0 at an advanced level.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study III',
      units: '6.0',
      PREREQUISITE: ['A grade of B- in (MUSC 220/6.0 or MUSC 221/6.0).\n'],
      'LEARNING HOURS': []
    },
    'FREN 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FREN 331',
      description:
        'Acquisition of a deeper knowledge of the principles of textual production, with particular emphasis on the use of computer-\nbased grammatical and lexicographic tools, and an examination of the stylistic constraints on textual production.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'R\u00e9daction et style II',
      units: '3.0',
      PREREQUISITE: ['FREN 330/3.0 or FREN 201/3.0 or FREN 202/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 421',
      description:
        'An examination of major issues in ethics. Possible topics to be considered include political violence, coercion, punishment,\nimmigration, suicide, drug policy, leisure and akrasia.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ethical Issues II',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'IDIS 222': {
      EXCLUSION: ['No more than 3.0 units from IDIS 220/3.0 and IDIS 222/3.0.'],
      RECOMMENDATION: [],
      code: 'IDIS 222',
      description:
        'Students will investigate the process of translating a text from print to digital form and how understandings of textuality,\ntextual materiality, and readership aid in theorising this process. Students will be introduced to basic elements of the\nstandard humanities mark-up language, TEIP5, in order to better enable them to understand this process.\n',
      NOTE: ['This course will only be offered at the BISC.\n'],
      'ONE-WAY EXCLUSION': [],
      title:
        'Digital Humanities II: The Theory and Practice of Digital Representation',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;9Lb;12Oc;60P)\n']
    },
    'POLS 211': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 211',
      description:
        'An examination of the institutions and constitutional foundations of government and politics in Canada. Offered annually.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Government',
      units: '3.0',
      PREREQUISITE: ['POLS 110/6.0.'],
      'LEARNING HOURS': []
    },
    'CLST 340': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 340',
      description:
        'Emergence of Early Rome and the social and political growth of the Republic.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Roman Republic',
      units: '3.0',
      PREREQUISITE: ['CLST 201/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'PSYC 430': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 430',
      description:
        'This course reviews theory and research on the self, primarily from a social psychological perspective. Topics include: the\nnature of the self, search for self-knowledge, self-development, self-cognition, self-regulation of behaviour, self-\npresentation, self-esteem, and the role of the self in psychological health.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Self',
      units: '3.0',
      PREREQUISITE: ['PSYC 203/3.0 and PSYC 241/3.0.'],
      'LEARNING HOURS': []
    },
    'PHIL 153': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 153',
      description:
        'An introduction to political philosophy which explores the relationship between state and citizen. Issues include: civil\ndisobedience, nationalism, the welfare state, anarchism and the capitalist state.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The State and the Citizen',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'DRAM 310': {
      EXCLUSION: ['No more than 6.0 units from DRAM 300/6.0; DRAM 310/3.0.'],
      RECOMMENDATION: [],
      code: 'DRAM 310',
      description:
        'Study of changing approaches to performance internationally from late 19th century to mid-20th century. Emphasis on\ninterdisciplinarity with other arts and experimentation in methods and forms of stage production.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modernist Staging',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and (registration in a DRAM Major or Medial Plan, or COCA-CODR Sub-Plan, or STSC Specialization\nPlan) and (a GPA of 2.60 in DRAM) or permission of the Department.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CLST 207': {
      EXCLUSION: ['No more than 3.0 units from CLST 207/3.0; CLST 208/3.0.'],
      RECOMMENDATION: [],
      code: 'CLST 207',
      description:
        'Introduction to the civilizations of Mesopotamia, Syro-Palestine, Egypt and Anatolia from the Bronze Age to the Greek\nconquest. Artistic, intellectual, social and political history.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'The Ancient Near East',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['126 (36L;90P)\n']
    },
    'HIST 476': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 476',
      description:
        'An exploration of war in a Canadian context, with an emphasis on how war has shaped Canadian society and the\nrelationship between Canada and its armed forces. Topics to be studied, from a Canadian perspective, include the military\nas a profession, military culture, combat stress, leadership, gender and sexuality in the military, and mutinies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'anada at War',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'BIOL 442': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 442',
      description:
        'An exploration of human disease, illness, and injury, and the symptoms and treatments of medical conditions, with an\nevolutionary framework.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Evolutionary Medicine',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 206/3.0 and a minimum GPA of 2.0 in the Biological Foundations List.\nEQUIVALENCY    BIOL 522/3.0.'
      ],
      'LEARNING HOURS': ['120 (24L;20T;10O;66P)\n']
    },
    'GEOL 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 333',
      description:
        'Terrain Evaluation\nAn introduction to the principles of geomorphology relevant to Geological Sciences and Geological Engineering.\nIdentification and evaluation of terrain features using analog and digital imagery via traditional and digital (GIS) methods.\nDigital terrain model acquisition and analysis. Introduction to digital terrain analysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['GEOL 104/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['124 (36L;33Lb;55Pc)\n']
    },
    'GNDS 530': {
      EXCLUSION: [
        'No more than 6.0 units from GNDS 510/6.0; GNDS 520/3.0; GNDS 530/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GNDS 530',
      description:
        'In consultation with the Head of the Department, students arrange their reading with individual Gender Studies faculty, and\nare expected to write reports on their readings and to discuss them throughout the term with that faculty supervisor.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registered in a GNDS Major or Medial Plan or SXGD Plan or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 250': {
      EXCLUSION: ['No more than 3.0 units from ARTH 223/3.0; ARTH 250/3.0.'],
      RECOMMENDATION: [],
      code: 'ARTH 250',
      description:
        'An introduction to the social conditions and cultural movements that shaped European visual art of the nineteenth century\nin its global context.  The course will stress the tension between modernity and anti-modernism as well as competing views\non the very nature of visual art.\n',
      NOTE: ['Only offered online. Consult Arts and Science Online.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Art, Society, and Culture',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.\n'],
      'LEARNING HOURS': ['120 (48O;72P)\n']
    },
    'PHIL 151': {
      EXCLUSION: ['No more than 1 course from PHIL 111/6.0; PHIL 151/3.0.'],
      RECOMMENDATION: [],
      code: 'PHIL 151',
      description:
        'An examination of some major milestones in the development of philosophical thought. The course will involve both the\nexposition of texts and discussion of the philosophical issues which they raise.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Great Works of Philosophy',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'WRIT 265': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'WRIT 265',
      description:
        'Editing in Academic and Professional Contexts\nThis course introduces the levels of editing \u2013 substantive, stylistic, and copyediting \u2013 and how to apply these skills to\nacademic and professional documents such as reports, essays, articles, and newsletters. The course will give students the\ntools both to revise their own work and to edit the work of others for greater clarity.\n',
      NOTE: [
        'A student with a 100-level course with a writing component, such as DRAM, ENGL, FILM, HIST, PHIL, POLS, SOCY\nmay alternatively use this as a prerequisite and should contact the instructor for permission to register in the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['WRIT 125/3.0 or permission of the instructor.'],
      'LEARNING HOURS': ['114 (36O;78P)\n']
    },
    'ANAT 416': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ANAT 416',
      description:
        'Comprehensive overview of cellular and molecular biology of mammalian reproduction including gametogenesis,\nfertilization, early embryo development and placentation; selected topics of clinical aspects of reproduction. Participation in\nseminars and group discussion is required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biology of Reproduction',
      units: '3.0',
      PREREQUISITE: [
        '(ANAT 215/3.0 and ANAT 216/3.0) or ANAT 309/3.0, and Level 4 and (a GPA of 2.5 and registration in a LISC\nMajor or Specialization Plan) or permission of the Department of Biomedical and Molecular Sciences.'
      ],
      'LEARNING HOURS': []
    },
    'GPHY 310': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 310',
      description:
        'Landscape Ecology\nStudy of the relationship between spacial pattern and ecological processes. Topics include spatial arrangement of\necosystems and its influence on the flow of energy, materials and biota; agents of pattern and change; methods and\ntechniques for characterizing landscapes and detecting change; applications in resource conservation and management.\n',
      NOTE: ['Field trips may apply in certain years; estimated cost $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 and [GPHY 207/3.0 or (BIOL 201/3.0 and BIOL 202/3.0)] or permission of the Department.\nEQUIVALENCY    GPHY 418/3.0.'
      ],
      'LEARNING HOURS': ['120 (24L;24Lb;6O;66P)\n']
    },
    'GRMN 426': {
      EXCLUSION: [
        'No more than 3.0 units from INTS 326/3.0; GRMN 426/3.0; LLCU 326/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GRMN 426',
      description:
        'Film in the New Europe\nThis course will investigate how the new Europe and film shaped each other. European film is our starting point for\ninvestigating the connections between work and art. Topics will include: urban space; (post- and para-); socialist societies;\nborder crossings, especially gendered labour and cultural flows.\n',
      NOTE: [
        'Taught in English together with LLCU 326/3.0. Students in a German Plan will submit written assignments, tests and\nexaminations in German. Normally, they will read German texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'EMPR 230': {
      EXCLUSION: ['No more than 3.0 units from COMM 181/3.0; EMPR 230/3.0.'],
      RECOMMENDATION: [],
      code: 'EMPR 230',
      description:
        'This course will provide an overview of the key components of an effective organizational human resource management\nsystem, running the spectrum from recruitment and selection practices that ensure that an organization is staffed\nappropriately, to management approaches aimed at bringing out the best in employees once hired.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Managing Human Resources and Employment Relations',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 424': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 424',
      description:
        'An examination of how the Enlightenment changed French culture, focusing on key ideas of cultural development and\nstagnation, changing sensibility and sociability, and cultural institutions and venues, from the academy and salon to the\ncoffeehouse and Revolutionary festival.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ultural History of Enlightenment France',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'POLS 338': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 338',
      description:
        'An examination of the European union and the forces towards integration: origin, politics and future.\n',
      NOTE: [
        'Also offered at the Bader International Studies Centre, Herstmonceux. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'European Integration',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHIL 466': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 466',
      description:
        'An examination of major issues in the philosophy of art. Possible topics include: the definition of art, art and the emotions,\nart and interpretation, art and the aesthetic, and the philosophy of particular artforms (i.e., literature, film).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in the Philosophy of Art',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 360': {
      EXCLUSION: ['No more than 3.0 units from BIOL 360; BIOL 507/3.0.'],
      RECOMMENDATION: [],
      code: 'BIOL 360',
      description:
        'Biotechnology and Society\nThe contributions and effects of biotechnology on humanity will be explored from the perspective of their impacts on\nsociety including moral and ethical issues. Biotechnological contributions to society to be explored will include those in\nmedicine, industry, and agriculture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['BIOL 205/3.0 or BCHM 218/3.0.\n'],
      'LEARNING HOURS': ['120 (36L;12T;72P)\n']
    },
    'POLS 332': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 332',
      description:
        'The politics of the Russian Federation and selected countries of Central and Eastern Europe.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Post-Communist Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'FREN 323': {
      EXCLUSION: ['No more than 3.0 units from FREN 323/3.0; FREN 423/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 323',
      description:
        'A detailed study of major 19th century writers. Travaux pratiques include essays and tests.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'La litt\u00e9rature fran\u00e7aise du 19e si\u00e8cle',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (33L;3Pc;84P)\n']
    },
    'GNDS 412': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 412',
      description:
        'This course provides an advanced study in specific topics and theories relating to the fields of sexual and gender diversity.\nTopics may change from year to year. This course contains an intensive and independent study component.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Seminar in Sexual and Gender Diversity',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['204(36S;168P)\n']
    },
    'PSYC 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 352',
      description:
        'Cognitive and Language Development\nAn overview of the development of cognitive and language processes in children. Topics include a discussion of the\nbiological and social foundations of cognitive and language development, perceptual development, early communication,\ndevelopment of concepts and scripts, and improvements in reasoning and problem-solving ability over the course of\ndevelopment.\nPREREQUISTE    (PSYC 203/3.0 and PSYC 251/3.0) or (level 3 and [registration in a COGS or LING Plan] and PSYC 100/6.0 with\na grade of B-).',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'KNPE 261': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 261',
      description:
        'Evaluation of human performance from perception to movement execution. Mechanisms underlying skill acquisition and\nthe roles of practice and feedback on performance will be evaluated.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Motor Learning and Control',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above in a PHED or KINE Plan and PSYC 100/6.0.'
      ],
      'LEARNING HOURS': ['132 (30L;12Lb;6G;84P)\n']
    },
    'ENSC 390': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 390',
      description:
        'The concept of sustainability provides a focus for discussing global and regional environmental issues in the broadest\npossible perspective. This course will examine the meaning of sustainability and ways in which it is assessed at various\nlevels including individual lifestyles, ecological, agricultural and industrial systems, urban areas, regions within countries,\nnations, and the world as a whole. Case studies will be used to illustrate the general principles.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sustainability',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': []
    },
    'GNDS 465': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 465',
      description:
        'This course analyzes exchanges among Jewish, Muslim, and Christian traditions, using tools from gender studies, critical race\nstudies, religious and cultural studies. The course explores boundary-crossing in social, cultural, personal and political contexts.\nThe course contains an intensive and independent study component.\n',
      NOTE: ['Also offered at the Bader International Study Centre.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender Dialogues: Religion and Cultural Politics',
      units: '6.0',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['216 (36S;180P)\n']
    },
    'POLS 463': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 463',
      description:
        'Critical examination of selected themes, issues and works in classical and contemporary international relations theory.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'International Relations Theory',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 270': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 270',
      description:
        'Minds and Machines\nA survey of the contribution of philosophy to the cognitive sciences. The focus will be on providing a synthesis of the\ndifferent perspectives brought by each of the disciplines, in particular, cognitive psychology, computer science,\nneurophysics, and linguistics, through an investigation of how the various approaches ultimately frame and answer our\nquestions about the mind.\n',
      NOTE: [
        'Each week, students will be assigned a number of articles or chapters for reading and will be expected to be able to\ndiscuss the readings in class.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 2 or above or completed 6.0 units in PHIL.'],
      'LEARNING HOURS': ['120 (36L;84P)\nEQUIVALENCY    PHIL 170/3.0.\n']
    },
    'CISC 498': {
      EXCLUSION: ['No more than 6.0 units from CISC 498/6.0; CISC 499/3.0.'],
      RECOMMENDATION: [],
      code: 'CISC 498',
      description:
        'Information Technology Project\nTopic selected under the supervision of a faculty member. Emphasis is on the application of software engineering\ntechniques to the development of a substantial software system. Group work, oral presentation, participation in design and\ncode review meetings, and delivery of complete software specification and design are required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 4 and registration in a SODE Specialization Plan and a GPA of 1.90 and a GPA of 2.60 in 30.0 units of\nCISC and C- in [(CISC 322/3.0 or CISC 326/3.0) and (CISC 325/3.0 or CISC 327/3.0 or SOFT 325/3.0 or SOFT 327/3.0)].\n'
      ],
      'LEARNING HOURS': ['258 (18S;240G)\n']
    },
    'HIST 363': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 363',
      description:
        'The economic, social and political changes which characterized the United Kingdom\u2019s transformation in the 20th century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he British Isles in the 20th Century',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'HIST 210': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 210',
      description:
        'An overview of Canada\u2019s sexual past. Introduces historiographical debates and theoretical approaches to the history of\nsexuality. Attentive to race, class, and gender, the course employs sexuality as a prism through which to view the\noperations of power in Canadian history.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he History of Sexuality in Canada',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'ECON 111': {
      EXCLUSION: [
        'No more than 6.0 units from ECON 110/6.0; ECON 111/3.0; ECON 112/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'ECON 111',
      description:
        'An introduction to microeconomic analysis of a modern mixed economy. The course analyzes the behaviour of individual\nconsumers and producers, the determination of market prices for commodities and resources, and the role of government\npolicy in the functioning of the market system. ECON 111/3.0 and ECON 112/3.0 are together equivalent to ECON 110/6.0.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Microeconomics',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'POLS 328': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 328',
      description:
        'An examination of key issues in European politics. Topics will vary from year to year; consult the department homepage.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in European Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 257': {
      EXCLUSION: ['No more than 3.0 units from ENSC 200/3.0; HIST 257/3.0.'],
      RECOMMENDATION: [],
      code: 'HIST 257',
      description:
        'A global survey of the effects of human activity on our physical surroundings and vice versa, in pre-agricultural, agricultural\nand industrial/agricultural societies. The course will be organized topically and themes will include the relevant problems of\nhistorical method, and the history of human attitudes to nature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'nvironmental History',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.\n'],
      'LEARNING HOURS': []
    },
    'MUSC 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 315',
      description:
        'Large ensemble for qualified instrumentalists and singers. Topics vary. Course includes weekly rehearsals of a wide variety\nof repertoire, and a minimum of one concert per term, for all students. Credit attained only with regular attendance, active\nparticipation, and ample preparation.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Large Ensemble',
      units: '1.5',
      PREREQUISITE: ['Permission of the School upon audition.'],
      'LEARNING HOURS': ['168 (72Pc;96P)\n']
    },
    'DRAM 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 205',
      description:
        'An exploration of theatricality and theatrical communication via an examination of how some major trends in theatre since\nthe 19th century have been represented by film and electronic media. The course will study examples of theatrical works\non film and other theatrical responses to social, cultural, and political issues presented in mass media.\n',
      NOTE: [
        'Also offered online. Consult Arts and Science Online. Learning Hours may vary.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Theatre in the Age of Film and Television',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': ['114 (18G;60O;36P)\n']
    },
    'BCHM 310': {
      EXCLUSION: [
        'No more than 1 course from BCHM 310/9.0;BCHM 102/3.0.\n',
        'No more than 1 course from BCHM 310/9.0; BCHM 316/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'BCHM 310',
      description:
        'Principles of protein biochemistry, enzymology, and protein engineering. Metabolism of carbohydrates, amino acids and\nlipids. Role of coenzymes. Generation and storage of metabolic energy. Principles of regulatory mechanisms, membrane\nstructure and function, hormone action, and cellular signalling.\n',
      NOTE: [
        'Students lacking the prerequisites CHEM 222/3.0 or CHEM 282/3.0 may take these courses as a corequisite with\npermission of the Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'General Biochemistry',
      units: '9.0',
      PREREQUISITE: [
        'Level 3 or above and (BCHM 218/3.0 or MBIO 218/3.0) and [(CHEM 222/3.0 and CHEM 223/3.0) or CHEM\n282/3.0].\n'
      ],
      'LEARNING HOURS': ['348 (72L;36Lb;240P)\n']
    },
    'ARTH 494': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 494',
      description:
        'A study of selected topics in the art of the 17th century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Baroque Art',
      units: '3.0',
      PREREQUISITE: [
        'A GPA of 2.60 in a minimum of 24.0 units in ARTH courses and Level 4 and registration in an ARTH Major or\nMedial Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'LATN 591': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LATN 591',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'General Examination',
      units: '0.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'RELS 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 311',
      description:
        'Jesus: The Continuing Historical Quest\nThis course provides an introduction to the methods and premises used in the modern quest to understand the historical\nfacts of Jesus\u2019 life. Particular attention will be given to understanding the historical Jesus in his first-century socio-cultural\ncontext.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'HLTH 397': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 397',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GPHY 311': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 311',
      description:
        'Knowledge of biogeochemical cycles is key to understanding earth system science. This course examines the processes\nbehind the transfers and transformations of biogeochemical elements (e.g. carbon, nitrogen, phosphorus, sulfur, and\nmetals) between various Earth systems, and explores methods used to investigate and quantify biogeochemical cycles.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biogeochemical Processes',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and 6.0 units in CHEM at the 100 level or above.\nEQUIVALENCY    GPHY 411/3.0.'
      ],
      'LEARNING HOURS': ['120 (24L;12Pc;84P)\n']
    },
    'MATH 385': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 385',
      description:
        'Measurement of mortality, life annuities, life insurance, premiums, reserves, cash values, population theory, multi-life\nfunctions, multiple-decrement functions. The classroom meetings will be primarily problem-solving sessions, based on\nassigned readings and problems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Life Contingencies',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or MATH 124/3.0 or MATH 126/6.0) and MATH 384/3.0\nand (STAT 268/3.0 or STAT 351/3.0), or permission of the Department.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'GPHY 102': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 102',
      description:
        'This course introduces the major concepts studied in Earth System Science. The fundamental processes and\ninterrelationships between the atmosphere, oceans, biosphere and the lithosphere are investigated to serve as a basis for\nunderstanding natural systems, particularly at or near the Earth\u2019s surface.\n',
      NOTE: ['Field trip: estimated cost $30.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Earth System Science',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;12T;48P)']
    },
    'ENGL 244': {
      EXCLUSION: [
        'No more than 6.0 units from ENGL 244/3.0; ENGL 245/3.0; ENGL 360/6.0'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 244',
      description:
        'A study of modern fiction, including works by such writers as James, Conrad, Ford, Joyce, Woolf.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern British Fiction',
      PREREQUISITE: ['A grade of C in ENGL 100/6.0.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 447': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 447',
      description:
        'An introduction to discussions of sex and gender in the history of medicine. Main themes include: the impact of cultural and social\nrelations on the production of scientific and medical knowledge on sex and gender, and the impact of science and medicine in the\ncreation of social categories.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ex and the History of Medicine',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'HLTH 334': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HLTH 334',
      description:
        'Explores cultural meanings of health and illness, the power dynamics through which these meanings are constructed, and\nrelated injustices in bodily experiences.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Politics of Health and Illness',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 and registration in a PHED, KINE, or HLTH Plan and (HLTH 101/3.0 or KNPE 167/3.0 or SOCY\n122/6.0).'
      ],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'FILM 323': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 323',
      description:
        'Intermediate examination of film and television in Canada since 1980, taking into account regional difference and other\ncultural, political, and economic distinctions.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Contemporary Canadian Film and Television',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'DRAM 241': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 241',
      description:
        'An examination of design elements in theatrical production, exploring the work of design practitioners and theorists, and\nstudying the design process.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Design and Theatre',
      units: '3.0',
      PREREQUISITE: ['A grade of B- in DRAM 240/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 326': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 326',
      description:
        'The development of English drama from 1580 to 1642 with emphasis on Shakespeare, but including plays by such writers as\nLyly, Greene, Marlowe, Dekker, Jonson, Marston, Beaumont and Fletcher, Webster, and Massinger.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Shakespeare and Renaissance Drama',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': []
    },
    'CISC 499': {
      EXCLUSION: ['No more than 6.0 units from CISC 498/6.0; CISC 499/3.0.\n'],
      RECOMMENDATION: [],
      code: 'CISC 499',
      description:
        'Topic selected under the supervision of a faculty member. Emphasis may be on the development of a large program, or on\nmore theoretical issues. Independent research, an oral presentation, and a written report are required.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Undergraduate Project',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a COMP Major or BMCO or COMA or CSCI Specialization Plan and a GPA of 1.90\nand a GPA of 2.60 in 30.0 units of CISC and C- in CISC 365/3.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'HIST 460': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 460',
      description:
        'An introduction to the study of British rule in India. This course examines the impact of the colonial governance of India on\nBritain from the mid-eighteenth century to Independence.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'he British and India, 1765-1947',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'MUSC 329': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 329',
      description:
        'The practical study of teaching techniques of standard musical repertoire (solo, chamber, orchestral, operatic, etc.) of a particular\ninstrument. The course requires student performances of representative musical works. The focus of study will rotate from year\nto year as resources permit.\n',
      NOTE: [
        'Students must have previous experience on the instrument/vocal area listed in the topic ID. Contact the School for\nmore information.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Pedagogy II',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above and permission of the School.'],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'GPHY 342': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 342',
      description:
        'This course represents an extension of GPHY 242/3.0, with an in-depth examination of image processing techniques for\ninformation extraction. Topics include remote sensor technology, image enhancement, classification, change detection,\nradiometric and geometric correction and sources and applications of remote sensing data.\n',
      NOTE: ['Enrolment limited to 40 students.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Remote Sensing II: Digital Image Processing',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 242/3.0 and GPHY 247/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (24L;24Pc;72P)\n']
    },
    'LING 205': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 205',
      description:
        'This course examines how language reflects and creates power relations in society. Students will learn fundamentals in the\nlinguistic study of language usage and style, and examine language and power in areas such as language socialization,\nlanguage and age, language and gender, language and education, and language and culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Language and Power',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (36L;84P)']
    },
    'GRMN 429': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 329/3.0; GRMN 429/3.0; ENGL 273/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'GRMN 429',
      description:
        'The course offers an overview of the related genres of the Fantastic, the Fairy Tale, Dystopia, Science Fiction, and Horror.\nExamples will include popular works such as the Twilight Saga, Harry Potter, and/or The Hunger Games, but also traditional\ntexts by Hoffman and Kafka. Parallel to the fictional works, the course offers theoretical analysis.\n',
      NOTE: [
        'Taught in English together with LLCU 329/3.0. Students in a GMST Plan will submit written assignments, tests and\nexaminations in German. Normally, students will read German texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Uncanny Encounters: Narrative Analysis of the Fantastic Genre',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures\n'
      ],
      'LEARNING HOURS': ['120 (12L;24S;12G;24O;48P)\n']
    },
    'JAPN 100': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'JAPN 100',
      description:
        'For students without any previous knowledge of Japanese. Introduction to the basic structural patterns of the language and\nintensive training in listening, speaking, reading, and writing. Extensive use of audio-visual materials. Students are expected\nto study individually on a regular basis with the aid of an audio tape in addition to the four hours of classroom work per\nweek.\n',
      NOTE: [
        'Students will have their level of competence assessed by the Department of Languages, Literatures and Cultures in\nSeptember.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Introductory Japanese I',
      units: '6.0',
      PREREQUISITE: ['Level 1 or (Level 2 and a GPA of 1.90).'],
      'LEARNING HOURS': []
    },
    'ENGL 360': {
      EXCLUSION: [
        'No more than 6.0 units from ENGL 244/3.0; ENGL 245/3.0; ENGL 360/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'ENGL 360',
      description:
        'A study of poetry, prose, and drama from the late nineteenth century to the mid-twentieth century.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Modern Literature',
      units: '6.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).\n'
      ],
      'LEARNING HOURS': ['240 (72L;168P)\n']
    },
    'PHYS 334': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 334',
      description:
        'The design of electronic circuits and systems, using commonly available devices and integrated circuits. The properties of\nlinear circuits are discussed with particular reference to the applications of feedback; operational amplifiers are introduced\nas fundamental building blocks. Digital circuits are examined and the properties of the commonly available I.C. types are\nstudied; their use in measurement, control and signal analysis is outlined. Laboratory work is closely linked with lectures\nand provides practical experience in the subjects covered in lectures.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Electronics for Physicists',
      units: '3.0',
      PREREQUISITE: ['PHYS 239/3.0.'],
      'LEARNING HOURS': ['132 (36L;36Lb;12T;48P)\n']
    },
    'KNPE 450': {
      EXCLUSION: [
        'No more than 3.0 units from KNPE 450/3.0; MECH 495/3.0; PT 419/3.0; RHBS 428/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'KNPE 450',
      description:
        'This is an interdisciplinary lecture/seminar course designed to provide a comprehensive overview of ergonomics\nemphasizing applications to product design and prevention of musculoskeletal injuries. The focus includes anthropometry,\nworkplace design, and biomechanical and other human factors. Ergonomic assessment methodologies will be used to\nassess design features and possible musculoskeletal problems.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ergonomics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a KINE, PHED, or HLTH Plan and (ANAT 101/3.0 or ANAT 315/3.0) and [(KNPE 254/3.0 or KNPE\n353/3.0) or 6.0 units in PHYS at the 100-level].\n'
      ],
      'LEARNING HOURS': []
    },
    'DRAM 301': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DRAM 301',
      description:
        'An exploration of theoretical questions underlying drama and performance throughout their histories. Selected readings,\nlectures, student presentations, class discussions and contemplation of theatre issues.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Theories of the Theatre I',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and registration in a COCA, DRAM, MUSC, MUTH, or STSC Plan.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'SOCY 302': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 302',
      description:
        'Explores a range of contemporary issues in socio-legal studies. Topics may vary from year to year. See the departmental\nwebsite for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Selected Topics in Socio-legal Studies',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'CHEM 414': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 414',
      description:
        'An advanced treatment of the concepts and applications of catalysis, including the kinetics of catalysis and topics selected\nfrom the areas of homogeneous, heterogeneous, and biocatalysis.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Catalysis',
      units: '3.0',
      PREREQUISITE: ['CHEM 312/3.0 and CHEM 223/3.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'CHEM 413': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 413',
      description:
        'The application of quantum mechanics to chemical structures, energetics, internal motions of molecules, and chemical\nreactions. An introduction to the use of modern electronic structure software in chemistry.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Computational Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 313/3.0 or CHEM 346/3.0 or PHYS 345/3.0.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'MUSC 325': {
      EXCLUSION: ['No more than 6.0 units from MUSC 321/6.0; MUSC 325/6.0.'],
      RECOMMENDATION: [],
      code: 'MUSC 325',
      description:
        'Students will perform in a public recital in accordance with guidelines established by Dan School of Drama and Music.\n',
      NOTE: [
        'Accompanist fee - wind, brass, string, and voice students. Estimated cost $180.\nCOREQUISITE    MUSC 320/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Applied Study III (Performance Recital)',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GRMN 531': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GRMN 531',
      description:
        'Reading courses enabling individual study of a particular author or problem in greater depth, the specific topic to be\nselected in consultation with the Head of Department. An essay of appropriate length may, after consultation, be submitted\nin either course in lieu of a final examination.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Studies I',
      units: '3.0',
      PREREQUISITE: [
        'Permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (120P)\n']
    },
    'GEOL 401': {
      EXCLUSION: ['No more than 1.5 units from GEOL 401/1.5; GEOL 402/1.5.'],
      RECOMMENDATION: [],
      code: 'GEOL 401',
      description:
        'A multi-day field trip that uses stratigraphic, sedimentological, paleontological, and structural data to interpret shall-and-\ndeep-marine rock successions in paleoenvironmental and tectonic context. Enrollment is limited. Course runs during the\nweek of Canadian Thanksgiving.\n',
      NOTE: [
        'For more information on costs see the departmental webpage for more information.  Estimated $450.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Studies in Geology II',
      units: '1.5',
      PREREQUISITE: [
        '(A GPA of 2.90 in GEOL 221/3.0, GEOL 238/3.0 and GEOL 321/3.0) or permission of the Department.\nCOREQUISITE    GEOL 488/3.0.\n'
      ],
      'LEARNING HOURS': ['61 (1L;30Pc;15G;15P)\n']
    },
    'MUTH 331': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUTH 331',
      description:
        'Preparation and production of the school or community musical. Practical examination of planning and rehearsal\ntechniques. Analysis of relevant factors.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Music Theatre Practicum',
      units: '3.0',
      PREREQUISITE: [
        '(Level 3 or above and registration in a MUSC Plan) or (registration in a BMT Plan) or MUTH 231/3.0.'
      ],
      'LEARNING HOURS': [
        '120 (12L;24Pc;12O;72P)\nEQUIVALENCY    MUSC 373/3.0.\n'
      ]
    },
    'POLS 439': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 439',
      description:
        'Focus varies from year to year depending on the research interests of the faculty members involved. See the departmental\nhomepage for further details.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'American Politics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'PHIL 303': {
      EXCLUSION: ['No more than 3.0 units from PHIL 303/3.0; COMM 338/3.0.'],
      RECOMMENDATION: [],
      code: 'PHIL 303',
      description:
        'An examination of the moral principles involved in the evaluation of business institutions, practices and decisions. Sample\ntopics include: liberty, efficiency and the free market ideal; the market and justice in distribution.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Ethics and Business',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MUSC 380': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 380',
      description:
        'An intensive study of a topic within historical musicology, ethnomusicology, or popular music(s).\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Music History and Culture I',
      units: '3.0',
      PREREQUISITE: [
        '(MUSC 191/6.0 and MUSC 103/3.0 and [MUSC 203/3.0 or MUSC 204/3.0 or MUSC 205/3.0]) or permission\nof the School.'
      ],
      'LEARNING HOURS': ['112 (36L;24O;52P)\n']
    },
    'CISC 453': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 453',
      description:
        'Investigation of selected areas of artificial intelligence research. Possible topics include natural language understanding,\ncomputational perception, planning, learning, and neurocomputing.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Artificial Intelligence',
      units: '3.0',
      PREREQUISITE: ['C- in CISC 352/3.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 421',
      description:
        'An examination of the importance of elections to the maintenance of democratic systems. Six themes are discussed: the\nhistory and theory of democratic participation; the legal framework; campaign organization; why people vote the way they\ndo; the manifestation of social cleavages during campaigns; and the future of electoral participation. Canadian examples\nare placed in a comparative context.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Elections',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': []
    },
    'LLCU 214': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LLCU 214',
      description:
        "The course will analyze the cinematic representation of the Mafia and other criminal organizations, such as Yakuza, Triads,\nVory V Zakone. The course will focus on how North American cinema (Hollywood) often glorifies the mafiosi's lifestyle. The\ngoal is the deconstruction of the romantic portrayal of the gangster life style created on screen.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mafia Culture and the Power of Symbols, Rituals and Myth',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36L;36T;48P)\n']
    },
    'MUSC 189': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 189',
      description:
        'Group instruction in the basic techniques and methods of a selected World Music and their application to teaching.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Techniques and Methods of World Music',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a BMUS, BMT, MUSC, or DRAM Plan or permission of the School.'
      ],
      'LEARNING HOURS': ['114 (36L;78P)\n']
    },
    'GNDS 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 440',
      description:
        'Social Justice Practicum: Learning through Community Organizing and Activism\nA seminar in which students work in and outside the classroom on community organizing projects. Students reflect on how\nfeminist, anti-racist, and queer theory can be integrated with real world practices.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '',
      PREREQUISITE: [
        'Level 3 or above in a GNDS Major or Medial or SXGD Plan, or permission of the Department.'
      ],
      'LEARNING HOURS': ['240 (36S;72Pc;132P)\n']
    },
    'LLCU 200': {
      EXCLUSION: [
        'No more than 1 course from LLCU 200/3.0; IDIS 200/6.0.\nEQUIVALENCY    IDIS 200/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 200',
      description:
        'Semiotics is the discipline that studies signs and how these participate in creating meaning and communication. This course\nfocuses on the theoretical system on which semiotic analyses is based (F. de Saussure, C. Peirce, R. Barthes, and others) and\nwill be devoted to various subject areas such as literature, art, film, theatre, and other fields.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Semiotics: Interpreting the World',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'LING 400': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'LING 400',
      description:
        'This course explores the forms of reasoning and evidence used in constructing and evaluating scientific arguments in\nlinguistics, through discussion of articles that represent significant innovations and controversies in linguistic theory.\nEmphasis is on the structure of arguments, rather than on the analysis of individual languages or phenomena.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Linguistic Analysis and Argumentation',
      units: '3.0',
      PREREQUISITE: [
        '(LING 320/3.0 and LING 340/3.0) or permission of the Department of Languages, Literatures, and Cultures.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'MATH 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MATH 421',
      description:
        'An exploration of the modern theory of Fourier series: Abel and Cesaro summability; Dirichlet\u2019s and Fej\u00e9r\u2019s kernels; term by\nterm differentiation and integration; infinite products; Bernoulli numbers; Gibbs\u2019s phenomenon.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fourier Series',
      units: '3.0',
      PREREQUISITE: ['MATH 281/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['132 (36L;96P)\n']
    },
    'LLCU 247': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 247/3.0; SPAN 247/3.0.\nEQUIVALENCY    SPAN 247/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 247',
      description:
        'This course covers the most significant political, historical, and artistic events and people that have shaped Spanish\ncivilization from prehistoric times to the present. Students will acquire essential knowledge about one of Europe\u2019s most\ndynamic countries and at the same time improve their analytical, writing, and professional skills.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Dynamic History of Spain',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 126': {
      EXCLUSION: [
        'No more than 6.0 units from MATH 120/6.0; MATH 121/6.0; MATH 122/6.0; MATH 123/3.0; MATH 124/3.0;\nMATH 126/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 126',
      description:
        'Differentiation and integration of the elementary functions, with applications to the social sciences and economics; Taylor\npolynomials; multivariable differential calculus.\n',
      NOTE: [
        'Primarily intended for students in the BAH program. Students in the BSCH, BCMPH and BCOM programs should not\nenrol in this course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential and Integral Calculus',
      units: '6.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;24T;144P)\n']
    },
    'RELS 202': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 202',
      description:
        'A topic of current interest in Religious Studies not covered in other available courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Traditions in Religious Studies',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or 6.0 units at the 100-level in RELS.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 449': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 449',
      description:
        'Thematic topics in the history of the societies and cultures of the Mediterranean region during the medieval era. These can\ninclude comparative and cross-cultural studies of society, economy, religion and political formations across the Latin West,\nByzantium, and the Islamic World.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'opics in Medieval Mediterranean History',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'GNDS 351': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GNDS 351',
      description:
        'An investigation of gender as it is constructed in historical and contemporary dress and fashion. The focus will be upon\nvisual culture and material culture.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Dress and Fashion',
      units: '3.0',
      PREREQUISITE: ['Level 3 or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 493': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 493',
      description:
        'Studies in literary topics that cross over the historical boundaries between Groups I, II, and III. For detailed information,\nconsult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Topics in Literary Interpretation III',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'SPAN 354': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SPAN 354',
      description:
        'A survey of women\u2019s literary and cultural production in Latin America from the earliest writers to the present day. Texts will\ninclude poetry, essays, short stories, novels, art and film.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Cultura femenina latinoamericana',
      units: '3.0',
      PREREQUISITE: [
        'SPAN 351/3.0 or SPAN 352/3.0.\nCOREQUISITE    (SPAN 301/3.0 and SPAN 302/3.0) or (SPAN 303/3.0 and SPAN 304/3.0).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'GRMN 419': {
      EXCLUSION: ['No more than 3.0 units from GRMN 419/3.0; LLCU 319/3.0.'],
      RECOMMENDATION: [],
      code: 'GRMN 419',
      description:
        'A survey of various currents of thought from 19th-century Europe that illustrate conservative discomfort with industrial society\nand help to make the outbreak of fascism understandable after 1918. The course will distinguish between conservative,\nnationalist, aesthetic, and religious trends, illustrated by relevant readings from different countries.\n',
      NOTE: [
        'Taught in English together with LLCU 319/3.0. Students in a GMST Plan will submit written assignments, tests, and\nexaminations in German. Normally, students will read German texts in the original.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Roots of Fascism: Resistance to Liberalism in the 19th Century',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GRMN 202/3.0 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'CHIN 300': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHIN 300',
      description:
        'Continuing study of the functional usage of Mandarin Chinese with intensive training in listening, speaking, reading and\nwriting using the simplified forms of Chinese characters.\n',
      NOTE: [
        'Students will have their level of competence assessed by the instructor during orientation week in September.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Intermediate Mandarin Chinese',
      units: '6.0',
      PREREQUISITE: [
        'CHIN 200/6.0 and permission of the Department of Languages, Literatures and Cultures.'
      ],
      'LEARNING HOURS': []
    },
    'HIST 334': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 334',
      description:
        'An examination of southern African societies from the consolidation of modern colonial rule up to the present, largely\nexclusive of apartheid South Africa. Topics include social and political tensions under colonialism, economic development,\nthe \u2018invention of tribalism\u2019, independence struggles, and post-colonial issues such as structural adjustment and HIV/AIDS.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'outhern Africa from c.1890',
      units: '4.5',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'CISC 320': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CISC 320',
      description:
        'Introduction to management of small and medium-scale software projects. Advanced programming methodology using the\nprogramming language C++. Includes a significant programming project.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Fundamentals of Software Development',
      units: '3.0',
      PREREQUISITE: ['C- in (CISC 220/3.0 and CISC 235/3.0).'],
      'LEARNING HOURS': ['120 (36L;24T;24G;36P)\n']
    },
    'GREK 421': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GREK 421',
      description:
        'Selected works of Greek prose, usually drawn from oratory, history, and philosophy, read in the original Greek and\ncommented upon for their linguistic, literary, and historical significance.\n',
      NOTE: ['This course is normally co-taught with GREK 321/3.0.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Greek Prose',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in GREK 321/3.0 or permission of the Department of Classics.'
      ],
      'LEARNING HOURS': ['141 (36L;105P)\n']
    },
    'GEOL 488': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 488',
      description:
        'An advanced course discussing the principles of earth evolution as exemplified by North America. The holistic approach\nillustrates the way in which geodynamics, geochemistry, sedimentation, paleo-biology and oceanography are used to\nunravel the history of the continent.\n',
      NOTE: [
        'GEOL 321/3.0 may be taken concurrently with permission of the Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Geology of North America',
      units: '3.0',
      PREREQUISITE: [
        '(GEOL 107/3.0 and GEOL 235/3.0 and GEOL 238/3.0 and GEOL 249/3.0 and GEOL 300/3.0 and GEOL\n321/3.0 and GEOL 365/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;36S;48P)\n']
    },
    'ENSC 103': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 103',
      description:
        'An interdisciplinary approach to complex environmental issues, and diverse perspectives on environmental management\nand sustainability. The course considers the social and scientific aspects of environmental problems and the production of\nenvironmental knowledge alongside global linkages, human health implications and barriers to sustainability.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environment and Sustainability',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': ['120 (24L;12T;24O;60P)\nEQUIVALENCY    ENSC 203/3.0.']
    },
    'FILM 445': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 445',
      description:
        'Advanced seminar on an area of narrative cinema, generally concerning a selection of feature-length films. Subjects have\nincluded international films of the 1990s.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Narrative Film: Special Topic',
      units: '3.0',
      PREREQUISITE: [
        'Registration in a FILM Plan, STSC or COCA Specialization and 30.0 units in FILM or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['108 (36L;24Lb;48P)\n']
    },
    'SOCY 284': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 284',
      description:
        'Social context and consequences of information and communication technologies as they relate to work, culture, privacy\nand education.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Sociology of Information and Communication Technology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'BIOL 343': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 343',
      description:
        'Advanced topics in using R for data management, exploratory data analysis, data visualization, and statistical analysis using\nthe general linear model, with particular focus on statistical literacy and biological examples from both laboratory and field\nresearch.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Data Analysis for Biologists',
      units: '3.0',
      PREREQUISITE: ['BIOL 243/3.0 or PSYC 202/3.0 or STAT 269/3.0.'],
      'LEARNING HOURS': ['120 (36L;12T;12O;60P)\n']
    },
    'PHIL 441': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 441',
      description:
        'An examination of major issues in 20th century philosophy. Possible topics to be studied include debates about modality,\nthe development of logic, the natural language movement, pragmatism and verificationism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '20th Century Philosophy I',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'POLS 341': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 341',
      description:
        'The course begins with an historical overview of the late Qing dynasty, the origins of the Chinese revolution, and 50 years of\nthe People\u2019s Republic of China. It then focuses primarily on political science concepts and approaches to the study of\nChinese politics as well as issues of reform in various sectors of China\u2019s economy and polity.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Chinese Politics',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 274': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 274',
      description:
        'A cultural history of France from 1750 to the present. In addition to examining developments in French art, literature, and\nmusic, the course considers the changing venues and institutions of culture and deals with such overarching themes as\nFrench notions of language, sociability, private and public space, gender, and individualism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ultural History of Modern France',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above.'],
      'LEARNING HOURS': []
    },
    'GPHY 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 315',
      description:
        'Methods of measurement and management of environmental data including energy and radiation fluxes, temperature,\nhumidity, wind precipitation, and soil moisture. Practical work involves the design and implementation of a field\nexperiment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Environmental Measurements: Data Collection and Management',
      units: '3.0',
      PREREQUISITE: [
        '6.0 units at the 200 level or above in GPHY_Physical, or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;24Lb;60P)\n']
    },
    'KNPE 227': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 227',
      description:
        'An introduction to the basic components of physiology as they apply to health, fitness and exercise physiology.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Exercise Physiology',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or above in a PHED or KINE Plan and KNPE 125/3.0 and KNPE 225/3.0.'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'MOHK 102': {
      EXCLUSION: ['LLCU 102/3.0 (Topic: Mohawk II).'],
      RECOMMENDATION: [],
      code: 'MOHK 102',
      description:
        'A continuation of MOHK 101/3.0. Students will participate and begin to develop the ability to read, write and speak some\nbasic Mohawk language and further their understanding of the richness of Mohawk culture, traditions, and worldviews.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Beginning Mohawk Language and Culture II',
      units: '3.0',
      PREREQUISITE: ['MOHK 101/3.0 or LLCU 101/3.0 (Topic: Mohawk I)\n'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'GPHY 365': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 365',
      description:
        'The geographical implications of the incorporation of the Third World into the global economy. Emphasis will be upon\nissues relating to both the physical and human environments in reference to development, ecological alteration, cultural\nchange, and spatial readjustment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Geography, Development, and Environment in the Third World',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or above and (6.0 units from GPHY 227/3.0; GPHY 228/3.0; GPHY 229/3.0) or (3.0 units at the 200\nlevel or above in DEVS or GNDS) or (ENSC 103/3.0 or ENSC 203/3.0) or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36L;12O;72P)\n']
    },
    'HLTH 205': {
      EXCLUSION: ['No more than 3.0 units from BMED 271/3.0; HLTH 205/3.0.'],
      RECOMMENDATION: [],
      code: 'HLTH 205',
      description:
        'A survey of the practice of health promotion. Topics include the field\u2019s history, philosophies of health promotion, the social\necological framework, program planning and evaluation, practitioner skills and competencies, cultural competence, ethics,\nthe use of theory, community organizing, social marketing, harm reduction, information literacy, and health promotion\npractice in selected settings.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Introduction to Health Promotion',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 and registration in a HLTH Plan and HLTH 101/3.0.\n'
      ],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'BIOL 307': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 307',
      description:
        'Two weeks of field work plus written assignments in one or two areas of study to be done when specialized modules are\navailable in May, July, August or February. Studies may include ecology of birds, fish, insects, small mammals, plants, tundra\nand taiga, lakes and caves.\n',
      NOTE: [
        'Field trip: estimated cost of each module and the schedule of offerings for each year are available in January.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Field Biology I',
      PREREQUISITE: [
        'BIOL 102/3.0 and BIOL 103/3.0 and (registration in a BIOL Major, BIOL Science Minor/General, BIMA\nSpecialization, BIPS Specialization, BTEC Specialization, or EBIO Specialization Plan).'
      ],
      'LEARNING HOURS': []
    },
    'GEOL 238': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GEOL 238',
      description:
        'An examination of the genetic link between surficial geological processes and the sedimentary record produced by these\nprocesses. Students obtain an integrated overview of the nature and operation of the Earth-surface environment. Topics\ninclude origin of sedimentary rocks and their sedimentary structures, depositional environments and stratigraphic\nsuccessions; stratigraphic principles and their application to sedimentary basins, with implications for hydrocarbon genesis;\ninteraction of natural processes with human society.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Surficial Processes, Sedimentation and Stratigraphy',
      units: '3.0',
      PREREQUISITE: ['GEOL 104/3.0 or permission of the Department.'],
      'LEARNING HOURS': ['130 (36L;22Lb;72P)\n']
    },
    'FREN 387': {
      EXCLUSION: ['No more than 3.0 units from FREN 387/3.0; FREN 487/3.0.'],
      RECOMMENDATION: [],
      code: 'FREN 387',
      description:
        "Seventeenth-century texts are studied in detail from the works of Cyrano de Bergerac, d'Urf\u00e9, Scarron, Fureti\u00e8re,\nGuilleragues and Mme de la Fayette. Travaux pratiques include oral expos\u00e9s and dissertations.\n",
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: '\u00c9crits du 17e si\u00e8cle',
      units: '3.0',
      PREREQUISITE: [
        '(FREN 230/3.0 and FREN 241/3.0) or (FREN 212/6.0 and FREN 220/6.0) or FREN 221/6.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'HIST 418': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 418',
      description:
        'Explores the two watershed crises of England\u2019s early modern era: the Tudor Reformation and the Revolution of 1640-1660.\nTopics will include: religious warfare; early modern state-building; social and economic upheaval; and the evolution of\npolitical thought.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'eformation and Revolution in Early Modern England',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'LLCU 234': {
      EXCLUSION: [
        'No more than 3.0 units from LLCU 234/3.0; ITLN 234/3.0; ITLN 332/3.0.\nEQUIVALENCY    ITLN 234/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'LLCU 234',
      description:
        'A survey of Italian literature, through selected texts of representative authors, from the eighteenth century to present.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Survey of Italian Literature II',
      units: '3.0',
      PREREQUISITE: [
        'Level 2 or permission of the Department of Languages, Literatures and Cultures.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'POLS 346': {
      EXCLUSION: ['No more than 3.0 units from: DEVS 340/3.0; POLS 346/3.0.'],
      RECOMMENDATION: [],
      code: 'POLS 346',
      description:
        'A critical examination of the current theories of development influenced by various post-Marxist, postmodernist and\npostcolonial tendencies. Growth strategies practised by the state and alternative visions offered by the social movements\nwill also be discussed.\n',
      NOTE: [
        'Students with third-year standing in the Development Studies Medial should contact the Department.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Development Theory',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.\n'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'MATH 124': {
      EXCLUSION: [
        'No more than 6.0 units from MATH 120/6.0; MATH 121/6.0; MATH 122/6.0; MATH 123/3.0; MATH 124/3.0;\nMATH 126/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 124',
      description:
        'Topics include techniques of integration, differential equations, and multivariable differential calculus.\n',
      NOTE: [
        'For students who have credit for a one-term course in calculus. Topics covered are the same as those in the Winter\nterm of MATH 121/6.0.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Differential and Integral Calculus II',
      units: '3.0',
      PREREQUISITE: ['MATH 123/3.0 or permission of the Department.\n'],
      'LEARNING HOURS': ['126 (36L;12T;78P)\n']
    },
    'FILM 308': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'FILM 308',
      description:
        'Students will examine recent popular culture trends, practices, styles, theories, and artifacts. Through creative assignments,\nonline discussion, online research and readings, students will engage in creative critique of the power of the popular to\nshape our identities, ideologies, and cultural arrangements.\n',
      NOTE: [
        'Priority will be given to FILM, STSC, COCA, and MDIA students.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Popular Cultures',
      units: '3.0',
      PREREQUISITE: [
        '(Registration in a FILM Plan, STSC or COCA Specialization and 12.0 units in FILM) or (FILM 236/3.0; FILM\n240/3.0; FILM 260/3.0).'
      ],
      'LEARNING HOURS': ['108 (36L;24S;48P)\n']
    },
    'MATH 334': {
      EXCLUSION: [
        'No more than 1 course from MATH 334/3.0; PHYS 316/3.0; PHYS 312/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 334',
      description:
        'Banach and Hilbert spaces of continuous- and discrete-time signals; spaces of continuous and not necessarily continuous signals;\ncontinuous-discrete Fourier transform; continuous-continuous Fourier transform; discrete-continuous Fourier transform; discrete-\ndiscrete Fourier transform; transform inversion using Fourier series and Fourier integrals.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Mathematical Methods for Engineering and Physics',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 212/3.0) and MATH 281/3.0.\n'
      ],
      'LEARNING HOURS': ['132 (36L;12T;84P)\n']
    },
    'SOCY 389': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 389',
      description:
        'Investigation of gender differences in offending, victimization and criminal justice processing; Canadian research\nemphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Gender, Law and Crime',
      units: '3.0',
      PREREQUISITE: ['SOCY 275/3.0 or SOCY 274/6.0.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'PHYS 106': {
      EXCLUSION: [
        'No more than 6.0 units from PHYS 104/6.0; PHYS 106/6.0; PHYS 117/6.0; PHYS 118/6.0.'
      ],
      RECOMMENDATION: [
        '4U Physics is required.\nCOREQUISITE    MATH 120/6.0 or MATH 121/6.0 or MATH 122/6.0 or (MATH 123/3.0 and MATH 124/3.0).\n'
      ],
      code: 'PHYS 106',
      description:
        'Mechanics, including systems of particles and rigid body motion; fluids; electricity and magnetism; oscillatory motion and\nwaves; heat, light and sound; topics in modern physics. Aspects of physics useful for further work in other sciences will be\nemphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'General Physics',
      PREREQUISITE: [],
      'LEARNING HOURS': ['240 (72L;36Lb;36T;96P)\n']
    },
    'PHYS 239': {
      EXCLUSION: [],
      RECOMMENDATION: [
        'A minimum grade of C in PHYS 104/6.0 or PHYS 106/6.0.\n'
      ],
      code: 'PHYS 239',
      description:
        'The experimental basis and mathematical description of electrostatics, magnetostatics and electromagnetic induction,\ntogether with a discussion of the properties of dielectrics and ferromagnetics, are presented.  Both the integral and vector\nforms of Maxwell\u2019s equations are deduced.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Electromagnetism',
      units: '3.0',
      PREREQUISITE: [
        '(PHYS 104/6.0 or PHYS 106/6.0) and (MATH 221/3.0 or MATH 227/3.0 or MATH 280/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'ECON 240': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ECON 240',
      description:
        'The incentive effects of taxes on the allocation of resources in the economy and their impact on the distribution of wealth\nin Canada. Reviews Canadian tax policy and evaluates the effects of various federal and provincial taxes on the behaviour of\nhouseholds and firms.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Tax Policy',
      units: '3.0',
      PREREQUISITE: ['ECON 110/6.0 or ECON 111/3.0.'],
      'LEARNING HOURS': ['120 (36L;6G;78P)\n']
    },
    'KNPE 436': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'KNPE 436',
      description:
        'Leadership experience in the context of an exercise program for adults with a disability or age-related impairment. Students\ndevelop an understanding of a) the operational considerations to run an adapted exercise program including the necessary\nhuman and financial resources, and b) the influence of disability/impairment on social participation.\n',
      NOTE: ['Students must hold valid First Aid/CPR certification.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Internship in Exercise, Disability and Aging',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a PHED or KINE Plan, or HLTH Major or Medial Plan and KNPE 336/3.0 and (a plan GPA of 2.70)\nand permission of the course coordinator and the Undergraduate Coordinator in the School of Kinesiology and Health\nStudies.'
      ],
      'LEARNING HOURS': ['132 (12S;84Pc;12O;24P)\n']
    },
    'HIST 359': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 359',
      description:
        'Major themes in the history of Ontario from the 18th century to World War II. Selected aspects of local history will be\nstudied. Research involving the use of original sources will be emphasized.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'ntario',
      units: '9.0',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['360 (72S;288P)\n']
    },
    'HLTH 455': {
      EXCLUSION: [
        'No more than 3.0 units from HLTH 497/3.0 (if taken between 2012-2015; HLTH 455/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'HLTH 455',
      description:
        'This course will examine how characteristics and configurations of urban environments, such as urban sprawl,\ntransportation, community design, housing, and food networks, may promote or impede health and well-being. This\nseminar-style course will be especially useful for students considering careers in public health and/or urban planning.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Health and Built Environments',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 in a KINE Specialization Plan, PHED Specialization Plan, or HLTH Major or Medial Plan.\n'
      ],
      'LEARNING HOURS': ['118 (36S;10Oc;72P)\n']
    },
    'POLS 512': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 512',
      description:
        'Students arrange their course of reading in consultation with members of the Department. They are expected to write\nreports on their readings and to discuss them in seminars.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Special Reading',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (registration in a POLS Major or Medial Plan) and POLS 250/6.0 and (a GPA of 2.5 on all units in\nPOLS).'
      ],
      'LEARNING HOURS': ['120 (9I;111P)\n']
    },
    'ARTH 116': {
      EXCLUSION: [
        'No more than 9.0 units from ARTH 116/3.0; ARTH 117/3.0; ARTH 120/6.0.'
      ],
      RECOMMENDATION: [],
      code: 'ARTH 116',
      description:
        'A chronological survey of painting, sculpture and architecture in western culture from Greece and Rome through to the\nearly modern period. The art works will be studied at British galleries, museums and architectural monuments.\n',
      NOTE: [
        'Offered only at the Bader International Study Centre, Herstmonceux. Students must participate in field trips.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title:
        'Art and Architecture in Britain from the Classical Period to c.1700',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'GPHY 345': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 345',
      description:
        'An in-depth exploration of the spatial analysis techniques used in vector GIS. The analysis of geographic primitives of points,\nlines, areas and surfaces in the context of applications drawn from geography, biology, planning and related disciplines.\nEmphasis is placed on the use of current GIS software in a hands-on environment.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Spatial Analysis',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 243/3.0 and (3.0 units from GPHY 247/3.0; ECON 250/3.0; KNPE 251/3.0; PHED 251/3.0; POLS\n385/3.0; PSYC 202/3.0; SOCY 211/3.0; STAT 263/3.0; STAT 267/3.0; STAT 367/3.0), or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (24L;24Pc;24G;24O;24P)\n']
    },
    'ENGL 206': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 206',
      description:
        'A survey history of the English language from its origins in proto-Indo-European to the variety of contemporary world\nEnglishes, with special emphasis on English as a language of literature.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'History of the English Language',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C in ENGL 100/6.0 or (registration in a LING Plan).'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'ENGL 488': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENGL 488',
      description:
        'Studies focused on Modern and Contemporary literature that do not fit within the established Group III rubrics (British,\nCanadian, American, Postcolonial, Indigenous). For detailed information, consult the Department.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Group III: Special Topics III',
      units: '3.0',
      PREREQUISITE: [
        '(ENGL 200/6.0 and ENGL 290/3.0) and (a GPA of 2.4 on all ENGL units) and (registration in an ENGL Major\nor Medial Plan).'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'HIST 339': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'HIST 339',
      description:
        'This course explores the North American Jewish engagement with modern ideologies such as secularism, antisemitism,\nliberalism, nationalism, socialism, feminism, and neo-conservativism. Other specific topics include the secularization of\nuniversities; the recent retrenchment of Orthodox Judaism; and the resurgence of \u2018popular atheism\u2019.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Jews Without Judaism',
      PREREQUISITE: [
        'A Grade of C+ in 6.0 units from HIST 300-329 and registration in a HIST Major or Medial Plan.'
      ],
      'LEARNING HOURS': ['180 (36S;144P)\n']
    },
    'MATH 272': {
      EXCLUSION: [
        'No more than 3.0 units from CISC 271/3.0; MATH 272/3.0; PHYS 313/3.0.'
      ],
      RECOMMENDATION: [],
      code: 'MATH 272',
      description:
        'An introductory course on the use of computers in science. Topics include: solving linear and nonlinear equations,\ninterpolation, integration, and numerical solutions of ordinary differential equations. Extensive use is made of MATLAB, a\nhigh level interactive numerical package.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Applications of Numerical Methods',
      units: '3.0',
      PREREQUISITE: [
        '(MATH 110/6.0 or MATH 111/6.0 or MATH 212/3.0) and (CISC 101/3.0 or CISC 121/3.0).\nCOREQUISITE    MATH 225/3.0 or MATH 232/3.0.\n'
      ],
      'LEARNING HOURS': ['120 (36L;12Lb;12T;60P)\n']
    },
    'BIOL 506': {
      EXCLUSION: [],
      RECOMMENDATION: ['BIOL 341/3.0 and BIOL 322/3.0.\n'],
      code: 'BIOL 506',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Biochemical Adaptations to Life Under Extreme Conditions',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and registration in a Biology Honours Plan (BIOL-M-BSH, BIOL-P-BSH, BIMA-P-BSH, BIPS-P-BSH,\nBTEC-P-BSH, EBIO-P-BSH) and a minimum GPA of 2.0 in the Biological Foundations List and [BIOL 334/3.0 or (BCHM 315/3.0\nand BCHM 316/3.0) or BCHM 310/6.0] or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (36S;84P)\n']
    },
    'ARTH 353': {
      EXCLUSION: [],
      RECOMMENDATION: ['ARTH 253/3.0.\n'],
      code: 'ARTH 353',
      description:
        'A detailed study of painting and related arts in Flanders (present-day Belgium) in the 17th century, with emphasis on the\nachievements of artists such as Rubens, Van Dyck, and Jordaens.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Flemish Baroque Art',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'DEVS 333': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 333',
      description:
        'Over the past several decades, business \u2013 particularly large multinational corporations \u2013 have come to play an increasingly\ndominant role in global development. This course will interrogate the structures, processes and practices employed by\ncorporations as the forge new partnerships with states, global development organizations and corporations.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Business and Global Development',
      units: '3.0',
      PREREQUISITE: [
        'One of COMM 200/3.0; COMM 372/3.0; COMM 375/3.0; COMM 407/3.0; DEVS 230/3.0; DEVS 250/3.0;\nGPHY 228/3.0; POLS 262/3.0; SOCY 225/3.0.'
      ],
      'LEARNING HOURS': ['120 (24L;12T;84P)\n']
    },
    'SOFT 327': {
      EXCLUSION: ['No more than 3.0 units from CISC 327/3.0; SOFT 327/3.0.'],
      RECOMMENDATION: [],
      code: 'SOFT 327',
      description: '',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Software Quality Assurance',
      units: '3.0',
      PREREQUISITE: ['CISC 203/3.0 and CISC 204/3.0 and CISC 223/3.0.\n'],
      'LEARNING HOURS': []
    },
    'PSYC 440': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PSYC 440',
      description:
        'A discussion of some areas and issues in social psychology emphasizing techniques and methods of social psychological\nresearch. Substantive topics may include attitudes and attitude change, psychology of women, conformity and deviance,\netc.\n',
      NOTE: [
        'Prerequisites vary depending on specific course content; consult instructor or Undergraduate Office in the\nPsychology Department.'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Topics in Social Psychology',
      units: '3.0',
      PREREQUISITE: [],
      'LEARNING HOURS': []
    },
    'ENSC 315': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ENSC 315',
      description:
        'National and global review of current and projected adequacy of food supplies, as affected by soil and water resources,\nclimate and climate change, and human population growth. Reviews different scenarios for meeting food needs over the\nnext 50 years, including technological, social, economic, and political factors.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Global Food Security, Agriculture, and Environment',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above.'],
      'LEARNING HOURS': ['124 (36L;4Pc;6O;18Oc;60P)\n']
    },
    'CLST 404': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CLST 404',
      description:
        'The growth of Athens from the Neolithic period to Late Antiquity. Emphasis on social and political developments and personal\naspirations which determine the cityscape.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Topography of Athens',
      units: '3.0',
      PREREQUISITE: [
        'CLST 303/3.0 or CLST 304/3.0 or CLST 332/3.0 or CLST 333/3.0 or CLST 334/3.0 or CLST 335/3.0 or CLST\n330/3.0 or CLST 331/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['126 (36S;90P)\n']
    },
    'PHYS 444': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHYS 444',
      description:
        'This course covers perturbation theory, scattering theory and the addition of angular momentum. Special topics may\ninclude: many electron systems, path integral formulation of quantum mechanics, entanglement and quantum computing,\nquantum optics.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Advanced Quantum Physics',
      units: '3.0',
      PREREQUISITE: ['PHYS 345/3.0.'],
      'LEARNING HOURS': []
    },
    'PHIL 467': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'PHIL 467',
      description:
        'An examination of major issues in hermeneutics or the theory of interpretation. Possible topics to be studied include the\nhistory of hermeneutics, objectivity and relativism, critiques of ideology, semiotics, and pragmatism.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Hermeneutics',
      units: '3.0',
      PREREQUISITE: [
        'Level 4 and (PHIL 250/6.0 and PHIL 257/6.0) and (a minimum GPA of 2.4 in all 300-level PHIL) and\n[(registration in a PHIL Major Plan and 9.0 units of PHIL at the 300 level) or (registration in a PHIL Medial Plan and 6.0 units\nof PHIL at the 300-level)].'
      ],
      'LEARNING HOURS': []
    },
    'ARTH 231': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'ARTH 231',
      description:
        'A study of Canadian art from its beginnings through the nineteenth century. The nature and development of Canadian art\nwithin the context of the social, political and economic history of the country will be examined.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Canadian Art I',
      units: '3.0',
      PREREQUISITE: ['Level 2 or above or permission of the Department.'],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'SOCY 336': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'SOCY 336',
      description:
        'The course examines the meaning of work and the changes taking place in the workworld, with special attention devoted to\nnew technology, gender, unionism and globalization.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Sociology of Work and Technology',
      units: '3.0',
      PREREQUISITE: [
        'A grade of C- in SOCY 122/6.0 or (BISC 100/3.0 and BISC 101/3.0).'
      ],
      'LEARNING HOURS': []
    },
    'POLS 352': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'POLS 352',
      description:
        'Drawing on historical texts, this course explores the representations of women and the constructions of femininity and\nmasculinity, the body, and gender relations in the history of political thought, and explores contemporary feminist\nresponses to these texts and ideas.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Women and the History of Political Thought',
      units: '3.0',
      PREREQUISITE: [
        '(12 units in POLS at the 200 level or above) and (a GPA of 2.0 on all units in POLS), or permission of the\nDepartment.'
      ],
      'LEARNING HOURS': ['120 (36L;84P)\n']
    },
    'RELS 302': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'RELS 302',
      description:
        'A topic of current interest in Religious Studies not covered in other available courses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Traditions in Religious Studies',
      units: '3.0',
      PREREQUISITE: ['Level 3 or above or 6.0 units at the 100 level in RELS.'],
      'LEARNING HOURS': []
    },
    'BIOL 303': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'BIOL 303',
      description:
        'An introduction to the major ecological concepts at the community and ecosystem scales. Patterns and mechanisms\nunderlying: community structure; biogeographic patterns; element cycles in terrestrial and aquatic ecosystems.\nEnvironmental problems are assessed in terms of ecological principles. Laboratory work includes field studies as well as\nindividual and group projects.\n',
      NOTE: ['Field trip: estimated cost $20.\n'],
      'ONE-WAY EXCLUSION': [],
      title: 'Community and Ecosystem Ecology',
      units: '3.0',
      PREREQUISITE: [
        'BIOL 201/3.0 and BIOL 202/3.0 and BIOL 206/3.0 and (BIOL 243/3.0 or PSYC 202/3.0 or STAT 269/3.0).'
      ],
      'LEARNING HOURS': ['127 (36L;36Lb;55P)\n']
    },
    'DEVS 330': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 330',
      description:
        'An introduction to the socio-economic, cultural and political factors surrounding technology and its relationship to the\ndevelopment process in both advanced industrial societies and developing nations. Student project groups will focus on\nparticular realms of technology in development and the interaction of politics and policy with technological choice and\ndesign, including appropriate, intermediate and sustainable technologies.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Technology and Development',
      PREREQUISITE: [
        'Level 3 or above and (registration in any DEVS Plan or registration in any Applied Science Program), or\npermission of the Department.'
      ],
      'LEARNING HOURS': []
    },
    'MUSC 187': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'MUSC 187',
      description:
        'An introduction to playing techniques, management of the percussion section, notation, and performance practice on band,\norchestral, and keyboard percussion instruments. Includes the study of ranges, transpositions, basic instrument\nmaintenance, method books and teaching techniques.\n',
      NOTE: [
        'Students with RCM Grade 8 Theory or equivalent may request permission from the School to take the course.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Percussion Techniques and Methods I',
      units: '3.0',
      PREREQUISITE: ['(Registration in a BMUS or BMT Plan) or MUSC 104/3.0.'],
      'LEARNING HOURS': []
    },
    'GPHY 349': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'GPHY 349',
      description:
        'This course examines contemporary applications of geographic information science (GIScience) and geographic information\nsystem (GIS) in public health, including disease mapping, environmental hazards, spatial epidemiology, and problems of\naccessibility to and siting of health services.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'GIScience and Public Health',
      units: '3.0',
      PREREQUISITE: [
        'GPHY 243/3.0 and GPHY 247/3.0 or permission of the Department.'
      ],
      'LEARNING HOURS': ['120 (24L;24P; 72P)\n']
    },
    'RELS 452': {
      EXCLUSION: ['No more than 1 course from RELS 451/6.0; RELS 452/3.0.'],
      RECOMMENDATION: [],
      code: 'RELS 452',
      description:
        'Religion in modernity; traditional groups, newer religious movements, contemporary ideologies and social trends of\nreligious significance.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'The Contemporary Religious Situation',
      units: '3.0',
      PREREQUISITE: [
        'Level 3 or 4 and registration in a RELS Major or Medial Plan.\nCOREQUISITE    [RELS 354/3.0 and (RELS 255/3.0 or RELS 355/3.0)] or RELS 353/6.0.\n'
      ],
      'LEARNING HOURS': []
    },
    'CHEM 424': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'CHEM 424',
      description:
        'Specific properties of polymers (glass transition, crystallinity, polydispersity, etc.) and their dependence on macromolecular\nstructure and isomerism. Polymer synthesis overview: step and chain polymerization (free-radical, ionic and insertion\nmechanisms) and reactions on polymers. Examples of polymers and their uses.\n',
      NOTE: [],
      'ONE-WAY EXCLUSION': [],
      title: 'Polymer Chemistry',
      units: '3.0',
      PREREQUISITE: ['CHEM 223/3.'],
      'LEARNING HOURS': ['108 (36L;72P)\n']
    },
    'DEVS 502': {
      EXCLUSION: [],
      RECOMMENDATION: [],
      code: 'DEVS 502',
      description:
        'This course enables a student or a group of students to explore a body of literature on a selected topic in development. The\nfocus may be by theme, by region or by academic approach and can span the humanities, social sciences and\nenvironmental sciences.\n',
      NOTE: [
        'The students are responsible for approaching a professor with whom they wish to work and who is willing to\nundertake this project.\n'
      ],
      'ONE-WAY EXCLUSION': [],
      title: 'Directed Readings in Development Studies',
      units: '3.0',
      PREREQUISITE: [
        'Minimum Cumulative GPA of 3.50 and Level 4 and registration in the DEVS Major or Medial Plan.'
      ],
      'LEARNING HOURS': []
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/courses.js